export const rawData = {
  name: 'P&L Comparison (Weekly) - Jul 21 - Jun 29, 2025',
  timeFrame: 'Weekly',
  type: 'P&L Comparison',
  reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
  capabilities: {
    money: true,
    budget: true,
    percentage: true,
    transactions: true,
    charts: true,
    sparklines: 'bar',
    smoothing: true,
    anomalies: false,
    totalRow: false,
    variance: false,
    synthetic: false,
    flaggedTransactions: true,
    liveReport: true,
  },
  range: {
    start: '2025-07-21',
    end: '2025-06-29',
    range: 'Jul 21 - Jun 29, 2025',
  },
  currency: 'USD',
  locationId: '5e433b2d-17d4-4d7f-b0b3-31513cbc4a75',
  locationName: 'Ainsworth Hoboken',
  columns: [
    {
      name: 'Accounts',
      type: [
        {
          type: 'Account',
        },
      ],
      data: [
        {
          id: '5bc89b03_@_2',
          cellID: '5bc89b03_@_2_-x-_0',
          amountTitle: 'SALES',
          refTitle: 'SALES',
          percentTitle: '',
          level: 0,
          glCode: 4000,
          parent: null,
          path: ['SALES'],
          display: 'header_1',
          children: [
            'c5601bf4_@_2',
            'e1ca5621_@_2',
            'ba0b0910_@_2',
            '2f14959f_@_2',
            '7bb557b1_@_2',
            'cbede411_@_2',
            '4e12e939_@_2',
            'a1f04b4c_@_2',
          ],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'SALES',
              path: ['SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: '5bc89b03_@_2_-x-_1',
              baseAmount: 0,
              transactions: 0,
              id: '5bc89b03_@_2',
              index: 0,
            },
            {
              date: '2025-07-14',
              title: 'SALES',
              path: ['SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: '5bc89b03_@_2_-x-_2',
              baseAmount: 0,
              transactions: 0,
              id: '5bc89b03_@_2',
              index: 1,
            },
            {
              date: '2025-07-07',
              title: 'SALES',
              path: ['SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              cellID: '5bc89b03_@_2_-x-_3',
              baseAmount: 0,
              transactions: 0,
              id: '5bc89b03_@_2',
              index: 2,
            },
            {
              date: '2025-06-30',
              title: 'SALES',
              path: ['SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              cellID: '5bc89b03_@_2_-x-_4',
              baseAmount: 0,
              transactions: 0,
              id: '5bc89b03_@_2',
              index: 3,
            },
            {
              date: '2025-06-23',
              title: 'SALES',
              path: ['SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              cellID: '5bc89b03_@_2_-x-_5',
              baseAmount: 0,
              transactions: 0,
              id: '5bc89b03_@_2',
              index: 4,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'c5601bf4_@_2',
          cellID: 'c5601bf4_@_2_-x-_0',
          amountTitle: 'Sales, Food',
          refTitle: 'Sales, Food',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4105,
          parent: '5bc89b03',
          path: ['SALES', 'Sales, Food'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales, Food',
              path: ['SALES', 'Sales, Food'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [49465.17],
                anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
                stats: {
                  mean: 40779.536,
                  variance: 20231770.394503992,
                  stdDev: 4497.974032217615,
                },
              },
              trxAnomaly: {
                anomalies: [8],
                anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
                stats: {
                  mean: 7.2,
                  variance: 0.15999999999999998,
                  stdDev: 0.39999999999999997,
                },
              },
              trxFlagged: [],
              amount: 40123,
              perc: 0.5278,
              percAvg: 0.5278,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: 4814.5,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: 4276,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 4525,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: 3727,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 3850,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 12032.5,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 6898,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.5278,
              percentAVG: 0.5278,
              cellID: 'c5601bf4_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 7,
              id: 'c5601bf4_@_2',
              index: 0,
              cPercent: 0.5277632430125925,
            },
            {
              date: '2025-07-14',
              title: 'Sales, Food',
              path: ['SALES', 'Sales, Food'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [49465.17],
                anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
                stats: {
                  mean: 40779.536,
                  variance: 20231770.394503992,
                  stdDev: 4497.974032217615,
                },
              },
              trxAnomaly: {
                anomalies: [8],
                anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
                stats: {
                  mean: 7.2,
                  variance: 0.15999999999999998,
                  stdDev: 0.39999999999999997,
                },
              },
              trxFlagged: [],
              amount: 37673.51,
              perc: 0.5454,
              percAvg: 0.5454,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: 2311,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: 3859,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 2662,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: 2951,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 7307.5,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 11975.51,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: 6607.5,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.5454,
              percentAVG: 0.5454,
              cellID: 'c5601bf4_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 7,
              id: 'c5601bf4_@_2',
              index: 1,
              cPercent: 0.5453882289924938,
            },
            {
              date: '2025-07-07',
              title: 'Sales, Food',
              path: ['SALES', 'Sales, Food'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [49465.17],
                anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
                stats: {
                  mean: 40779.536,
                  variance: 20231770.394503992,
                  stdDev: 4497.974032217615,
                },
              },
              trxAnomaly: {
                anomalies: [8],
                anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
                stats: {
                  mean: 7.2,
                  variance: 0.15999999999999998,
                  stdDev: 0.39999999999999997,
                },
              },
              trxFlagged: [],
              amount: 39645,
              perc: 0.5565,
              percAvg: 0.5565,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 3404.5,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 2043.5,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: 2980,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 3034,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: 5745,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 11703,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 10735,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.5565,
              percentAVG: 0.5565,
              cellID: 'c5601bf4_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 7,
              id: 'c5601bf4_@_2',
              index: 2,
              cPercent: 0.5565361091493021,
            },
            {
              date: '2025-06-30',
              title: 'Sales, Food',
              path: ['SALES', 'Sales, Food'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [49465.17],
                anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
                stats: {
                  mean: 40779.536,
                  variance: 20231770.394503992,
                  stdDev: 4497.974032217615,
                },
              },
              trxAnomaly: {
                anomalies: [8],
                anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
                stats: {
                  mean: 7.2,
                  variance: 0.15999999999999998,
                  stdDev: 0.39999999999999997,
                },
              },
              trxFlagged: [],
              amount: 49465.17,
              perc: 0.5367,
              percAvg: 0.5367,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: 3223,
                },
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '15308',
                  num: 'Strip sale P6.25',
                  name: '',
                  description: '',
                  amount: 5883.17,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 3494,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 2415.5,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 5198,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: 9323.5,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 10915,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 9013,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.5367,
              percentAVG: 0.5367,
              cellID: 'c5601bf4_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 8,
              id: 'c5601bf4_@_2',
              index: 3,
              cPercent: 0.5367395406679853,
            },
            {
              date: '2025-06-23',
              title: 'Sales, Food',
              path: ['SALES', 'Sales, Food'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [49465.17],
                anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
                stats: {
                  mean: 40779.536,
                  variance: 20231770.394503992,
                  stdDev: 4497.974032217615,
                },
              },
              trxAnomaly: {
                anomalies: [8],
                anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
                stats: {
                  mean: 7.2,
                  variance: 0.15999999999999998,
                  stdDev: 0.39999999999999997,
                },
              },
              trxFlagged: [],
              amount: 36991,
              perc: 0.5462,
              percAvg: 0.5462,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: 2749,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: 5498,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: 3139.5,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: 1993.5,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 4984.5,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 10957,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: 7669.5,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.5462,
              percentAVG: 0.5462,
              cellID: 'c5601bf4_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 7,
              id: 'c5601bf4_@_2',
              index: 4,
              cPercent: 0.546184893132121,
            },
          ],
          anomalies: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
        },
        {
          id: 'e1ca5621_@_2',
          cellID: 'e1ca5621_@_2_-x-_0',
          amountTitle: 'Sales, Liquor',
          refTitle: 'Sales, Liquor',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4110,
          parent: '5bc89b03',
          path: ['SALES', 'Sales, Liquor'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales, Liquor',
              path: ['SALES', 'Sales, Liquor'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [26219.51],
                anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
                stats: {
                  mean: 20895.703999999998,
                  variance: 8728515.724423997,
                  stdDev: 2954.406154276016,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [
                {
                  id: 'f5f466b6-1069-4f73-b141-8e3c89f3fe16',
                  index: 6,
                  account: '4110 Revenue / Sales:Sales, Liquor',
                  type: 'trx',
                  status: 'inProgress',
                  period: '2025-07-23',
                  createdAt: '2025-07-29 16:09:56',
                  amount: 1629,
                  transaction: {
                    id: 'e252f492-4b2a-4e34-a610-4f77c5f721e1',
                    memo: '',
                    name: '',
                    trxType: 'Journal Entry',
                  },
                },
              ],
              amount: 22039.5,
              amtAvg: 22039.5,
              perc: 0.2899,
              percAvg: 0.2899,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: 1294,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: 1490,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 1629,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: 1811,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 2589,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 8862.5,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 4364,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 22039.5,
              percent: 0.2899,
              percentAVG: 0.2899,
              cellID: 'e1ca5621_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 7,
              id: 'e1ca5621_@_2',
              index: 0,
              cPercent: 0.2898995088696267,
            },
            {
              date: '2025-07-14',
              title: 'Sales, Liquor',
              path: ['SALES', 'Sales, Liquor'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [26219.51],
                anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
                stats: {
                  mean: 20895.703999999998,
                  variance: 8728515.724423997,
                  stdDev: 2954.406154276016,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 18733.5,
              amtAvg: 18733.5,
              perc: 0.2712,
              percAvg: 0.2712,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: 362,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: 1232,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 822,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: 1973,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 3302,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 7901.5,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: 3141,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 18733.5,
              percent: 0.2712,
              percentAVG: 0.2712,
              cellID: 'e1ca5621_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 7,
              id: 'e1ca5621_@_2',
              index: 1,
              cPercent: 0.2711993224902825,
            },
            {
              date: '2025-07-07',
              title: 'Sales, Liquor',
              path: ['SALES', 'Sales, Liquor'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [26219.51],
                anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
                stats: {
                  mean: 20895.703999999998,
                  variance: 8728515.724423997,
                  stdDev: 2954.406154276016,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 18588.01,
              amtAvg: 18588.01,
              perc: 0.2609,
              percAvg: 0.2609,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 1151.01,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 449,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: 1435,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 1164,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: 2608,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 6630,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 5151,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 18588.01,
              percent: 0.2609,
              percentAVG: 0.2609,
              cellID: 'e1ca5621_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 7,
              id: 'e1ca5621_@_2',
              index: 2,
              cPercent: 0.2609382964365826,
            },
            {
              date: '2025-06-30',
              title: 'Sales, Liquor',
              path: ['SALES', 'Sales, Liquor'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [26219.51],
                anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
                stats: {
                  mean: 20895.703999999998,
                  variance: 8728515.724423997,
                  stdDev: 2954.406154276016,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 26219.51,
              amtAvg: 26219.51,
              perc: 0.2845,
              percAvg: 0.2845,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: 1367,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 1397.01,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 1793,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 6275,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: 5281,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 5572.5,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 4534,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 26219.51,
              percent: 0.2845,
              percentAVG: 0.2845,
              cellID: 'e1ca5621_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 7,
              id: 'e1ca5621_@_2',
              index: 3,
              cPercent: 0.28450418251750975,
            },
            {
              date: '2025-06-23',
              title: 'Sales, Liquor',
              path: ['SALES', 'Sales, Liquor'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [26219.51],
                anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
                stats: {
                  mean: 20895.703999999998,
                  variance: 8728515.724423997,
                  stdDev: 2954.406154276016,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 18898,
              amtAvg: 18898,
              perc: 0.279,
              percAvg: 0.279,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: 1230,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: 1562,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: 1105,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: 1473,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 2132,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 7591.5,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: 3804.5,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 18898,
              percent: 0.279,
              percentAVG: 0.279,
              cellID: 'e1ca5621_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 7,
              id: 'e1ca5621_@_2',
              index: 4,
              cPercent: 0.2790354981052371,
            },
          ],
          anomalies: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
        },
        {
          id: 'ba0b0910_@_2',
          cellID: 'ba0b0910_@_2_-x-_0',
          amountTitle: 'Sales, Beer',
          refTitle: 'Sales, Beer',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4115,
          parent: '5bc89b03',
          path: ['SALES', 'Sales, Beer'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales, Beer',
              path: ['SALES', 'Sales, Beer'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 5524.8,
                  variance: 481194.9600000001,
                  stdDev: 693.6821750629031,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 14,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 5225,
              amtAvg: 5225,
              perc: 0.0687,
              percAvg: 0.0687,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: 97,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: 376,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: 110,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: 542,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 61,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 474,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: 20,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: 347,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 107,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 503,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 600,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 1413,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 151,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 424,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 5225,
              percent: 0.0687,
              percentAVG: 0.0687,
              cellID: 'ba0b0910_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 14,
              id: 'ba0b0910_@_2',
              index: 0,
              cPercent: 0.06872773583084005,
            },
            {
              date: '2025-07-14',
              title: 'Sales, Beer',
              path: ['SALES', 'Sales, Beer'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 5524.8,
                  variance: 481194.9600000001,
                  stdDev: 693.6821750629031,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 14,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [
                {
                  id: 'eb89fd19-e2a6-4df6-8e97-6a0462be5e2f',
                  index: 0,
                  account: 'Sales, Beer',
                  type: 'Flagged Cell',
                  status: 'inProgress',
                  period: '2025-07-14',
                  createdAt: '2025-07-29 19:37:44',
                  amount: 5015,
                },
                {
                  id: 'f53bb8ca-cc34-4ea6-bd43-eda4d5af03d8',
                  index: 5,
                  account: '4115 Revenue / Sales:Sales, Beer',
                  type: 'trx',
                  status: 'inProgress',
                  period: '2025-07-15',
                  createdAt: '2025-07-29 16:49:23',
                  amount: 102,
                  transaction: {
                    id: 'b1888fa0-4e9b-4d9b-a1f2-2b02e6f3be52',
                    memo: '',
                    name: '',
                    trxType: 'Journal Entry',
                  },
                },
              ],
              amount: 5015,
              amtAvg: 5015,
              perc: 0.0726,
              percAvg: 0.0726,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: 56,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: 173,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: 102,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: 583,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 85,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 178,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: 77,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: 467,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 96,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 623,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 417,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 1256,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: 261,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: 641,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 5015,
              percent: 0.0726,
              percentAVG: 0.0726,
              cellID: 'ba0b0910_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 14,
              id: 'ba0b0910_@_2',
              index: 1,
              cPercent: 0.07260066737602514,
            },
            {
              date: '2025-07-07',
              title: 'Sales, Beer',
              path: ['SALES', 'Sales, Beer'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 5524.8,
                  variance: 481194.9600000001,
                  stdDev: 693.6821750629031,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 14,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 4710,
              amtAvg: 4710,
              perc: 0.0661,
              percAvg: 0.0661,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 47,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 517,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 93,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 151,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: 69,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: 441,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 59,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 187,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: 83,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: 681,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 378,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 979,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 295,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 730,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 4710,
              percent: 0.0661,
              percentAVG: 0.0661,
              cellID: 'ba0b0910_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 14,
              id: 'ba0b0910_@_2',
              index: 2,
              cPercent: 0.06611893237717778,
            },
            {
              date: '2025-06-30',
              title: 'Sales, Beer',
              path: ['SALES', 'Sales, Beer'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 5524.8,
                  variance: 481194.9600000001,
                  stdDev: 693.6821750629031,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 14,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 6528,
              amtAvg: 6528,
              perc: 0.0708,
              percAvg: 0.0708,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: 106,
                },
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: 252,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 135,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 413,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 69,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 539,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 452,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 794,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: 338,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: 1243,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 272,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 1042,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 166,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 707,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 6528,
              percent: 0.0708,
              percentAVG: 0.0708,
              cellID: 'ba0b0910_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 14,
              id: 'ba0b0910_@_2',
              index: 3,
              cPercent: 0.0708344016907373,
            },
            {
              date: '2025-06-23',
              title: 'Sales, Beer',
              path: ['SALES', 'Sales, Beer'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 5524.8,
                  variance: 481194.9600000001,
                  stdDev: 693.6821750629031,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 14,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 6146,
              amtAvg: 6146,
              perc: 0.0907,
              percAvg: 0.0907,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: 36,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: 190,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: 170,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: 424,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: 289,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: 713,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: 46,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: 374,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 172,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 760,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 584,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 1482,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: 173,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: 733,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 6146,
              percent: 0.0907,
              percentAVG: 0.0907,
              cellID: 'ba0b0910_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 14,
              id: 'ba0b0910_@_2',
              index: 4,
              cPercent: 0.09074781306777369,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
        },
        {
          id: '2f14959f_@_2',
          cellID: '2f14959f_@_2_-x-_0',
          amountTitle: 'Sales, Wine',
          refTitle: 'Sales, Wine',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4120,
          parent: '5bc89b03',
          path: ['SALES', 'Sales, Wine'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales, Wine',
              path: ['SALES', 'Sales, Wine'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1252],
                anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
                stats: {
                  mean: 1578,
                  variance: 39290.8,
                  stdDev: 198.21907072731423,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [
                {
                  id: '1e4fc649-e738-40ac-af2f-98fa638ac3fe',
                  index: 4,
                  account: '4120 Revenue / Sales:Sales, Wine',
                  type: 'trx',
                  status: 'inProgress',
                  period: '2025-07-24',
                  createdAt: '2025-07-29 16:58:53',
                  amount: 248,
                  transaction: {
                    id: '88c5af13-7511-4e18-a7a0-e4757e221dce',
                    memo: '',
                    name: '',
                    trxType: 'Journal Entry',
                  },
                },
              ],
              amount: 1861,
              amtAvg: 1861,
              perc: 0.0245,
              percAvg: 0.0245,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: 156,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: 205,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 342,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: 248,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 267,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 489,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 154,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 1861,
              percent: 0.0245,
              percentAVG: 0.0245,
              cellID: '2f14959f_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 7,
              id: '2f14959f_@_2',
              index: 0,
              cPercent: 0.02447891222606571,
            },
            {
              date: '2025-07-14',
              title: 'Sales, Wine',
              path: ['SALES', 'Sales, Wine'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1252],
                anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
                stats: {
                  mean: 1578,
                  variance: 39290.8,
                  stdDev: 198.21907072731423,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1636,
              amtAvg: 1636,
              perc: 0.0237,
              percAvg: 0.0237,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: 52,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: 373,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 144,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: 195,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 419,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 324,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: 129,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 1636,
              percent: 0.0237,
              percentAVG: 0.0237,
              cellID: '2f14959f_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 7,
              id: '2f14959f_@_2',
              index: 1,
              cPercent: 0.023683886705319464,
            },
            {
              date: '2025-07-07',
              title: 'Sales, Wine',
              path: ['SALES', 'Sales, Wine'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1252],
                anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
                stats: {
                  mean: 1578,
                  variance: 39290.8,
                  stdDev: 198.21907072731423,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1252,
              amtAvg: 1252,
              perc: 0.0176,
              percAvg: 0.0176,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 99,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 42,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: 171,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 98,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: 276,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 484,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 82,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 1252,
              percent: 0.0176,
              percentAVG: 0.0176,
              cellID: '2f14959f_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 7,
              id: '2f14959f_@_2',
              index: 2,
              cPercent: 0.01757556334102475,
            },
            {
              date: '2025-06-30',
              title: 'Sales, Wine',
              path: ['SALES', 'Sales, Wine'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1252],
                anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
                stats: {
                  mean: 1578,
                  variance: 39290.8,
                  stdDev: 198.21907072731423,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1628,
              amtAvg: 1628,
              perc: 0.0177,
              percAvg: 0.0177,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: 38,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 183,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 243,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 227,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: 236,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 437,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 264,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 1628,
              percent: 0.0177,
              percentAVG: 0.0177,
              cellID: '2f14959f_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 7,
              id: '2f14959f_@_2',
              index: 3,
              cPercent: 0.017665196990275786,
            },
            {
              date: '2025-06-23',
              title: 'Sales, Wine',
              path: ['SALES', 'Sales, Wine'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1252],
                anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
                stats: {
                  mean: 1578,
                  variance: 39290.8,
                  stdDev: 198.21907072731423,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1513,
              amtAvg: 1513,
              perc: 0.0223,
              percAvg: 0.0223,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: 211,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: 197,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: 135,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: 56,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 227,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 587,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: 100,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 1513,
              percent: 0.0223,
              percentAVG: 0.0223,
              cellID: '2f14959f_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 7,
              id: '2f14959f_@_2',
              index: 4,
              cPercent: 0.022339967649128146,
            },
          ],
          anomalies: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
        },
        {
          id: '7bb557b1_@_2',
          cellID: '7bb557b1_@_2_-x-_0',
          amountTitle: 'Sales, Non-Alcoholic Beverage',
          refTitle: 'Sales, Non-Alcoholic Beverage',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4125,
          parent: '5bc89b03',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales, Non-Alcoholic Beverage',
              path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2616.6,
                  variance: 59473.44,
                  stdDev: 243.87176958393525,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2599,
              amtAvg: 2599,
              perc: 0.0342,
              percAvg: 0.0342,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: 333,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: 316,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 243,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: 266,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 205,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 701,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 535,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 2599,
              percent: 0.0342,
              percentAVG: 0.0342,
              cellID: '7bb557b1_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 7,
              id: '7bb557b1_@_2',
              index: 0,
              cPercent: 0.03418629386112025,
            },
            {
              date: '2025-07-14',
              title: 'Sales, Non-Alcoholic Beverage',
              path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2616.6,
                  variance: 59473.44,
                  stdDev: 243.87176958393525,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2370,
              amtAvg: 2370,
              perc: 0.0343,
              percAvg: 0.0343,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: 170,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: 307,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 141,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: 239,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 451,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 583,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: 479,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 2370,
              percent: 0.0343,
              percentAVG: 0.0343,
              cellID: '7bb557b1_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 7,
              id: '7bb557b1_@_2',
              index: 1,
              cPercent: 0.03430978697530998,
            },
            {
              date: '2025-07-07',
              title: 'Sales, Non-Alcoholic Beverage',
              path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2616.6,
                  variance: 59473.44,
                  stdDev: 243.87176958393525,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2328,
              amtAvg: 2328,
              perc: 0.0327,
              percAvg: 0.0327,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 258,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 110,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: 198,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 116,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: 297,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 757,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 592,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 2328,
              percent: 0.0327,
              percentAVG: 0.0327,
              cellID: '7bb557b1_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 7,
              id: '7bb557b1_@_2',
              index: 2,
              cPercent: 0.032680440461585955,
            },
            {
              date: '2025-06-30',
              title: 'Sales, Non-Alcoholic Beverage',
              path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2616.6,
                  variance: 59473.44,
                  stdDev: 243.87176958393525,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2902,
              amtAvg: 2902,
              perc: 0.0315,
              percAvg: 0.0315,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: 239,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 188,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 144,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 480,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: 641,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 616,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 594,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 2902,
              percent: 0.0315,
              percentAVG: 0.0315,
              cellID: '7bb557b1_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 7,
              id: '7bb557b1_@_2',
              index: 3,
              cPercent: 0.03148919021239578,
            },
            {
              date: '2025-06-23',
              title: 'Sales, Non-Alcoholic Beverage',
              path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2616.6,
                  variance: 59473.44,
                  stdDev: 243.87176958393525,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2884,
              amtAvg: 2884,
              perc: 0.0426,
              percAvg: 0.0426,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: 260,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: 554,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: 349,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: 104,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 302,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 743,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: 572,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 2884,
              percent: 0.0426,
              percentAVG: 0.0426,
              cellID: '7bb557b1_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 7,
              id: '7bb557b1_@_2',
              index: 4,
              cPercent: 0.04258325624592569,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
        },
        {
          id: 'cbede411_@_2',
          cellID: 'cbede411_@_2_-x-_0',
          amountTitle: 'Sales, Miscellaneous',
          refTitle: 'Sales, Miscellaneous',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4140,
          parent: '5bc89b03',
          path: ['SALES', 'Sales, Miscellaneous'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales, Miscellaneous',
              path: ['SALES', 'Sales, Miscellaneous'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [95],
                anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
                stats: {
                  mean: 2534.4740000000006,
                  variance: 1812238.9630240002,
                  stdDev: 1346.194251593729,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
                stats: {
                  mean: 3.8,
                  variance: 1.3599999999999999,
                  stdDev: 1.16619037896906,
                },
              },
              trxFlagged: [],
              amount: 2760.8,
              perc: 0.0363,
              percAvg: 0.0363,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 2542.8,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 86,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 80,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 52,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0363,
              percentAVG: 0.0363,
              cellID: 'cbede411_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 4,
              id: 'cbede411_@_2',
              index: 0,
              cPercent: 0.03631455178598722,
            },
            {
              date: '2025-07-14',
              title: 'Sales, Miscellaneous',
              path: ['SALES', 'Sales, Miscellaneous'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [95],
                anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
                stats: {
                  mean: 2534.4740000000006,
                  variance: 1812238.9630240002,
                  stdDev: 1346.194251593729,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
                stats: {
                  mean: 3.8,
                  variance: 1.3599999999999999,
                  stdDev: 1.16619037896906,
                },
              },
              trxFlagged: [],
              amount: 2387.65,
              perc: 0.0346,
              percAvg: 0.0346,
              dataRows: [
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 29.48,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 1140.57,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 1217.6,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0346,
              percentAVG: 0.0346,
              cellID: 'cbede411_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 3,
              id: 'cbede411_@_2',
              index: 1,
              cPercent: 0.03456530078970417,
            },
            {
              date: '2025-07-07',
              title: 'Sales, Miscellaneous',
              path: ['SALES', 'Sales, Miscellaneous'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [95],
                anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
                stats: {
                  mean: 2534.4740000000006,
                  variance: 1812238.9630240002,
                  stdDev: 1346.194251593729,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
                stats: {
                  mean: 3.8,
                  variance: 1.3599999999999999,
                  stdDev: 1.16619037896906,
                },
              },
              trxFlagged: [],
              amount: 3359.04,
              perc: 0.0472,
              percAvg: 0.0472,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 214,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 388,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 387,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 79.04,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 2291,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0472,
              percentAVG: 0.0472,
              cellID: 'cbede411_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 5,
              id: 'cbede411_@_2',
              index: 2,
              cPercent: 0.04715416955673784,
            },
            {
              date: '2025-06-30',
              title: 'Sales, Miscellaneous',
              path: ['SALES', 'Sales, Miscellaneous'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [95],
                anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
                stats: {
                  mean: 2534.4740000000006,
                  variance: 1812238.9630240002,
                  stdDev: 1346.194251593729,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
                stats: {
                  mean: 3.8,
                  variance: 1.3599999999999999,
                  stdDev: 1.16619037896906,
                },
              },
              trxFlagged: [],
              amount: 4069.88,
              perc: 0.0442,
              percAvg: 0.0442,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 1084,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 1460.88,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 1247,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 20,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 258,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0442,
              percentAVG: 0.0442,
              cellID: 'cbede411_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 5,
              id: 'cbede411_@_2',
              index: 3,
              cPercent: 0.04416169037271721,
            },
            {
              date: '2025-06-23',
              title: 'Sales, Miscellaneous',
              path: ['SALES', 'Sales, Miscellaneous'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [95],
                anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
                stats: {
                  mean: 2534.4740000000006,
                  variance: 1812238.9630240002,
                  stdDev: 1346.194251593729,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
                stats: {
                  mean: 3.8,
                  variance: 1.3599999999999999,
                  stdDev: 1.16619037896906,
                },
              },
              trxFlagged: [],
              amount: 95,
              perc: 0.0014,
              percAvg: 0.0014,
              dataRows: [
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 30,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 65,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0014,
              percentAVG: 0.0014,
              cellID: 'cbede411_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 2,
              id: 'cbede411_@_2',
              index: 4,
              cPercent: 0.0014027078167000487,
            },
          ],
          anomalies: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
        },
        {
          id: '4e12e939_@_2',
          cellID: '4e12e939_@_2_-x-_0',
          amountTitle: 'Sales, Service Charges',
          refTitle: 'Sales, Service Charges',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4145,
          parent: '5bc89b03',
          path: ['SALES', 'Sales, Service Charges'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales, Service Charges',
              path: ['SALES', 'Sales, Service Charges'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1199.15],
                anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
                stats: {
                  mean: 1315.116,
                  variance: 5809.014823999995,
                  stdDev: 76.21689329800839,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1416.32,
              perc: 0.0186,
              percAvg: 0.0186,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: 106.75,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: 177.13,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: 227.71,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: 127.6,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: 117.39,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: 470.49,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: 189.25,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0186,
              percentAVG: 0.0186,
              cellID: '4e12e939_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 7,
              id: '4e12e939_@_2',
              index: 0,
              cPercent: 0.018629754413767536,
            },
            {
              date: '2025-07-14',
              title: 'Sales, Service Charges',
              path: ['SALES', 'Sales, Service Charges'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1199.15],
                anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
                stats: {
                  mean: 1315.116,
                  variance: 5809.014823999995,
                  stdDev: 76.21689329800839,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1260.84,
              perc: 0.0183,
              percAvg: 0.0183,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: 64.36,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: 139.39,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: 85.01,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: 109.8,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: 281.63,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: 382.51,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: 198.14,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0183,
              percentAVG: 0.0183,
              cellID: '4e12e939_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 7,
              id: '4e12e939_@_2',
              index: 1,
              cPercent: 0.01825280667086491,
            },
            {
              date: '2025-07-07',
              title: 'Sales, Service Charges',
              path: ['SALES', 'Sales, Service Charges'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1199.15],
                anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
                stats: {
                  mean: 1315.116,
                  variance: 5809.014823999995,
                  stdDev: 76.21689329800839,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1353.22,
              perc: 0.019,
              percAvg: 0.019,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: 120.99,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: 51.45,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: 86.37,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: 64.5,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: 196.33,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: 441.93,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: 391.65,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.019,
              percentAVG: 0.019,
              cellID: '4e12e939_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 7,
              id: '4e12e939_@_2',
              index: 2,
              cPercent: 0.018996488677589067,
            },
            {
              date: '2025-06-30',
              title: 'Sales, Service Charges',
              path: ['SALES', 'Sales, Service Charges'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1199.15],
                anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
                stats: {
                  mean: 1315.116,
                  variance: 5809.014823999995,
                  stdDev: 76.21689329800839,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1346.05,
              perc: 0.0146,
              percAvg: 0.0146,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: 82.19,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: 91.61,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: 175.96,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: 178.33,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: 283.66,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: 327.27,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: 207.03,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0146,
              percentAVG: 0.0146,
              cellID: '4e12e939_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 7,
              id: '4e12e939_@_2',
              index: 3,
              cPercent: 0.014605797548378822,
            },
            {
              date: '2025-06-23',
              title: 'Sales, Service Charges',
              path: ['SALES', 'Sales, Service Charges'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1199.15],
                anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
                stats: {
                  mean: 1315.116,
                  variance: 5809.014823999995,
                  stdDev: 76.21689329800839,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1199.15,
              perc: 0.0177,
              percAvg: 0.0177,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: 70.38,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: 158.55,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: 128.45,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: 82.3,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: 152.85,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: 417.11,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: 189.51,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0177,
              percentAVG: 0.0177,
              cellID: '4e12e939_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 7,
              id: '4e12e939_@_2',
              index: 4,
              cPercent: 0.017705863983114353,
            },
          ],
          anomalies: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
        },
        {
          id: 'a1f04b4c_@_2',
          cellID: 'a1f04b4c_@_2_-x-_0',
          amountTitle: 'Sales - No category',
          refTitle: 'Sales - No category',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4199,
          parent: '5bc89b03',
          path: ['SALES', 'Sales - No category'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Sales - No category',
              path: ['SALES', 'Sales - No category'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: 'a1f04b4c_@_2_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 0,
              id: 'a1f04b4c_@_2',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Sales - No category',
              path: ['SALES', 'Sales - No category'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: 'a1f04b4c_@_2_-x-_2',
              baseAmount: 69076.5,
              transactions: 0,
              id: 'a1f04b4c_@_2',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Sales - No category',
              path: ['SALES', 'Sales - No category'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              cellID: 'a1f04b4c_@_2_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 0,
              id: 'a1f04b4c_@_2',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Sales - No category',
              path: ['SALES', 'Sales - No category'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'a1f04b4c_@_2_-x-_4',
              baseAmount: 92158.61,
              transactions: 0,
              id: 'a1f04b4c_@_2',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Sales - No category',
              path: ['SALES', 'Sales - No category'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'a1f04b4c_@_2_-x-_5',
              baseAmount: 67726.15,
              transactions: 0,
              id: 'a1f04b4c_@_2',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '74405d1a_@_3',
          cellID: '74405d1a_@_3_-x-_0',
          amountTitle: 'GROSS SALES',
          refTitle: 'GROSS SALES',
          percentTitle: '',
          level: 0,
          glCode: null,
          parent: null,
          path: ['GROSS SALES'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'GROSS SALES',
              path: ['GROSS SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [92158.61],
                anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
                stats: {
                  mean: 75244.23000000001,
                  variance: 79467887.97148004,
                  stdDev: 8914.476315043978,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 76024.62000000001,
              amtAvg: 76024.62000000001,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 76024.62000000001,
              cellID: '74405d1a_@_3_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 0,
              id: '74405d1a_@_3',
              index: 0,
            },
            {
              date: '2025-07-14',
              title: 'GROSS SALES',
              path: ['GROSS SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [92158.61],
                anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
                stats: {
                  mean: 75244.23000000001,
                  variance: 79467887.97148004,
                  stdDev: 8914.476315043978,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 69076.5,
              amtAvg: 69076.5,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 69076.5,
              cellID: '74405d1a_@_3_-x-_2',
              baseAmount: 69076.5,
              transactions: 0,
              id: '74405d1a_@_3',
              index: 1,
            },
            {
              date: '2025-07-07',
              title: 'GROSS SALES',
              path: ['GROSS SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [92158.61],
                anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
                stats: {
                  mean: 75244.23000000001,
                  variance: 79467887.97148004,
                  stdDev: 8914.476315043978,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 71235.26999999999,
              amtAvg: 71235.26999999999,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 71235.26999999999,
              cellID: '74405d1a_@_3_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 0,
              id: '74405d1a_@_3',
              index: 2,
            },
            {
              date: '2025-06-30',
              title: 'GROSS SALES',
              path: ['GROSS SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [92158.61],
                anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
                stats: {
                  mean: 75244.23000000001,
                  variance: 79467887.97148004,
                  stdDev: 8914.476315043978,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 92158.61,
              amtAvg: 92158.61,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 92158.61,
              cellID: '74405d1a_@_3_-x-_4',
              baseAmount: 92158.61,
              transactions: 0,
              id: '74405d1a_@_3',
              index: 3,
            },
            {
              date: '2025-06-23',
              title: 'GROSS SALES',
              path: ['GROSS SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [92158.61],
                anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
                stats: {
                  mean: 75244.23000000001,
                  variance: 79467887.97148004,
                  stdDev: 8914.476315043978,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 67726.15,
              amtAvg: 67726.15,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 67726.15,
              cellID: '74405d1a_@_3_-x-_5',
              baseAmount: 67726.15,
              transactions: 0,
              id: '74405d1a_@_3',
              index: 4,
            },
          ],
          anomalies: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
        },
        {
          id: 'ba9fcd64_@_6',
          cellID: 'ba9fcd64_@_6_-x-_0',
          amountTitle: 'Comps & Discounts',
          refTitle: 'Comps & Discounts',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Comps & Discounts'],
          display: 'header_2',
          children: ['4936addc_@_6'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Comps & Discounts',
              path: ['Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: 'ba9fcd64_@_6_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 0,
              id: 'ba9fcd64_@_6',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Comps & Discounts',
              path: ['Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: 'ba9fcd64_@_6_-x-_2',
              baseAmount: 69076.5,
              transactions: 0,
              id: 'ba9fcd64_@_6',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Comps & Discounts',
              path: ['Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'ba9fcd64_@_6_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 0,
              id: 'ba9fcd64_@_6',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Comps & Discounts',
              path: ['Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'ba9fcd64_@_6_-x-_4',
              baseAmount: 92158.61,
              transactions: 0,
              id: 'ba9fcd64_@_6',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Comps & Discounts',
              path: ['Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'ba9fcd64_@_6_-x-_5',
              baseAmount: 67726.15,
              transactions: 0,
              id: 'ba9fcd64_@_6',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '4936addc_@_6',
          cellID: '4936addc_@_6_-x-_0',
          amountTitle: 'Discounts and Comps',
          refTitle: 'Discounts and Comps',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 1,
          glCode: 4500,
          parent: 'ba9fcd64',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Discounts and Comps',
              path: ['Comps & Discounts', 'Discounts and Comps'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1217.5,
              perc: -0.016,
              percAvg: -0.016,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Journal Entry',
                  eventId: '15356',
                  num: 'MJ1878ME',
                  name: '',
                  description: '',
                  amount: -177.25,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Journal Entry',
                  eventId: '15357',
                  num: 'MJ1879ME',
                  name: '',
                  description: '',
                  amount: -84.5,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Journal Entry',
                  eventId: '15530',
                  num: 'MJ1883ME',
                  name: '',
                  description: '',
                  amount: -59.5,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Journal Entry',
                  eventId: '15531',
                  num: 'MJ1887ME',
                  name: '',
                  description: '',
                  amount: -117.75,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Journal Entry',
                  eventId: '15561',
                  num: 'MJ1888ME',
                  name: '',
                  description: '',
                  amount: -144,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15572',
                  num: 'MJ1890ME',
                  name: '',
                  description: '',
                  amount: -320.5,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15573',
                  num: 'MJ1934ME',
                  name: '',
                  description: '',
                  amount: -314,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: -0.016,
              percentAVG: -0.016,
              cellID: '4936addc_@_6_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 7,
              id: '4936addc_@_6',
              index: 0,
              cPercent: -0.01601454897110962,
            },
            {
              date: '2025-07-14',
              title: 'Discounts and Comps',
              path: ['Comps & Discounts', 'Discounts and Comps'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -982.3,
              perc: -0.0142,
              percAvg: -0.0142,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Journal Entry',
                  eventId: '15217',
                  num: 'MJ1863ME',
                  name: '',
                  description: '',
                  amount: -56,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Journal Entry',
                  eventId: '15309',
                  num: 'MJ1864ME',
                  name: '',
                  description: '',
                  amount: -169.8,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Journal Entry',
                  eventId: '15310',
                  num: 'MJ1867ME',
                  name: '',
                  description: '',
                  amount: -54,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Journal Entry',
                  eventId: '15311',
                  num: 'MJ1869ME',
                  name: '',
                  description: '',
                  amount: -64.5,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Journal Entry',
                  eventId: '15312',
                  num: 'MJ1871ME',
                  name: '',
                  description: '',
                  amount: -142.75,
                },
                {
                  txnDate: '2025-07-19',
                  type: 'Journal Entry',
                  eventId: '15353',
                  num: 'MJ1873ME',
                  name: '',
                  description: '',
                  amount: -453.25,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15354',
                  num: 'MJ1876ME',
                  name: '',
                  description: '',
                  amount: -42,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: -0.0142,
              percentAVG: -0.0142,
              cellID: '4936addc_@_6_-x-_2',
              baseAmount: 69076.5,
              transactions: 7,
              id: '4936addc_@_6',
              index: 1,
              cPercent: -0.014220465715547255,
            },
            {
              date: '2025-07-07',
              title: 'Discounts and Comps',
              path: ['Comps & Discounts', 'Discounts and Comps'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1208.5,
              perc: -0.017,
              percAvg: -0.017,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Journal Entry',
                  eventId: '14888',
                  num: 'MJ1832ME',
                  name: '',
                  description: '',
                  amount: -97.5,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Journal Entry',
                  eventId: '14905',
                  num: 'MJ1834ME',
                  name: '',
                  description: '',
                  amount: -146,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15025',
                  num: 'MJ1835ME',
                  name: '',
                  description: '',
                  amount: -72,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Journal Entry',
                  eventId: '15026',
                  num: 'MJ1851ME',
                  name: '',
                  description: '',
                  amount: -93,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Journal Entry',
                  eventId: '15028',
                  num: 'MJ1853ME',
                  name: '',
                  description: '',
                  amount: -117.5,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Journal Entry',
                  eventId: '15209',
                  num: 'MJ1855ME',
                  name: '',
                  description: '',
                  amount: -275.75,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15208',
                  num: 'MJ1858ME',
                  name: '',
                  description: '',
                  amount: -406.75,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: -0.017,
              percentAVG: -0.017,
              cellID: '4936addc_@_6_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 7,
              id: '4936addc_@_6',
              index: 2,
              cPercent: -0.016964910780853364,
            },
            {
              date: '2025-06-30',
              title: 'Discounts and Comps',
              path: ['Comps & Discounts', 'Discounts and Comps'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -2053.88,
              perc: -0.0223,
              percAvg: -0.0223,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14704',
                  num: 'MJ1780ME',
                  name: '',
                  description: '',
                  amount: -24,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Journal Entry',
                  eventId: '14710',
                  num: 'MJ1788ME',
                  name: '',
                  description: '',
                  amount: -569.25,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14711',
                  num: 'MJ1795ME',
                  name: '',
                  description: '',
                  amount: -81,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14712',
                  num: 'MJ1797ME',
                  name: '',
                  description: '',
                  amount: -461,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Journal Entry',
                  eventId: '14713',
                  num: 'MJ1799ME',
                  name: '',
                  description: '',
                  amount: -193,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Journal Entry',
                  eventId: '14715',
                  num: 'MJ1801ME',
                  name: '',
                  description: '',
                  amount: -213.25,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '14716',
                  num: 'MJ1803ME',
                  name: '',
                  description: '',
                  amount: -512.38,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: -0.0223,
              percentAVG: -0.0223,
              cellID: '4936addc_@_6_-x-_4',
              baseAmount: 92158.61,
              transactions: 7,
              id: '4936addc_@_6',
              index: 3,
              cPercent: -0.022286360438813043,
            },
            {
              date: '2025-06-23',
              title: 'Discounts and Comps',
              path: ['Comps & Discounts', 'Discounts and Comps'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1294,
              perc: -0.0191,
              percAvg: -0.0191,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Journal Entry',
                  eventId: '14564',
                  num: 'MJ1758ME',
                  name: '',
                  description: '',
                  amount: -177,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Journal Entry',
                  eventId: '14681',
                  num: 'MJ1759ME',
                  name: '',
                  description: '',
                  amount: -241.75,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Journal Entry',
                  eventId: '14682',
                  num: 'MJ1766ME',
                  name: '',
                  description: '',
                  amount: -145,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Journal Entry',
                  eventId: '14683',
                  num: 'MJ1769ME',
                  name: '',
                  description: '',
                  amount: -96.25,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Journal Entry',
                  eventId: '14684',
                  num: 'MJ1771ME',
                  name: '',
                  description: '',
                  amount: -183,
                },
                {
                  txnDate: '2025-06-28',
                  type: 'Journal Entry',
                  eventId: '14686',
                  num: 'MJ1774ME',
                  name: '',
                  description: '',
                  amount: -381,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14687',
                  num: 'MJ1777ME',
                  name: '',
                  description: '',
                  amount: -70,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: -0.0191,
              percentAVG: -0.0191,
              cellID: '4936addc_@_6_-x-_5',
              baseAmount: 67726.15,
              transactions: 7,
              id: '4936addc_@_6',
              index: 4,
              cPercent: -0.01910635699799856,
            },
          ],
          anomalies: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
        },
        {
          id: '8a448d4b_@_7',
          cellID: '8a448d4b_@_7_-x-_0',
          amountTitle: 'Total Comps & Discounts',
          refTitle: 'Total Comps & Discounts',
          percentTitle: 'GROSS SALES',
          baseRef: 'GROSS SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Total Comps & Discounts'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Comps & Discounts',
              path: ['Total Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1217.5,
              amtAvg: -1217.5,
              perc: -0.016,
              percAvg: -0.016,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: -1217.5,
              percent: -0.016,
              percentAVG: -0.016,
              cellID: '8a448d4b_@_7_-x-_1',
              baseAmount: 76024.62000000001,
              transactions: 0,
              id: '8a448d4b_@_7',
              index: 0,
              cPercent: -0.01601454897110962,
            },
            {
              date: '2025-07-14',
              title: 'Total Comps & Discounts',
              path: ['Total Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -982.3,
              amtAvg: -982.3,
              perc: -0.0142,
              percAvg: -0.0142,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: -982.3,
              percent: -0.0142,
              percentAVG: -0.0142,
              cellID: '8a448d4b_@_7_-x-_2',
              baseAmount: 69076.5,
              transactions: 0,
              id: '8a448d4b_@_7',
              index: 1,
              cPercent: -0.014220465715547255,
            },
            {
              date: '2025-07-07',
              title: 'Total Comps & Discounts',
              path: ['Total Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1208.5,
              amtAvg: -1208.5,
              perc: -0.017,
              percAvg: -0.017,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -1208.5,
              percent: -0.017,
              percentAVG: -0.017,
              cellID: '8a448d4b_@_7_-x-_3',
              baseAmount: 71235.26999999999,
              transactions: 0,
              id: '8a448d4b_@_7',
              index: 2,
              cPercent: -0.016964910780853364,
            },
            {
              date: '2025-06-30',
              title: 'Total Comps & Discounts',
              path: ['Total Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -2053.88,
              amtAvg: -2053.88,
              perc: -0.0223,
              percAvg: -0.0223,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: -2053.88,
              percent: -0.0223,
              percentAVG: -0.0223,
              cellID: '8a448d4b_@_7_-x-_4',
              baseAmount: 92158.61,
              transactions: 0,
              id: '8a448d4b_@_7',
              index: 3,
              cPercent: -0.022286360438813043,
            },
            {
              date: '2025-06-23',
              title: 'Total Comps & Discounts',
              path: ['Total Comps & Discounts'],
              baseRef: 'GROSS SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-2053.88],
                anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
                stats: {
                  mean: -1351.236,
                  variance: 134271.44118400002,
                  stdDev: 366.43067718737746,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1294,
              amtAvg: -1294,
              perc: -0.0191,
              percAvg: -0.0191,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: -1294,
              percent: -0.0191,
              percentAVG: -0.0191,
              cellID: '8a448d4b_@_7_-x-_5',
              baseAmount: 67726.15,
              transactions: 0,
              id: '8a448d4b_@_7',
              index: 4,
              cPercent: -0.01910635699799856,
            },
          ],
          anomalies: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
        },
        {
          id: '3b5cefb1_@_8',
          cellID: '3b5cefb1_@_8_-x-_0',
          amountTitle: 'NET SALES',
          refTitle: 'NET SALES',
          percentTitle: '',
          level: 0,
          glCode: null,
          parent: null,
          path: ['NET SALES'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'NET SALES',
              path: ['NET SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [90104.73],
                anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
                stats: {
                  mean: 73892.99399999999,
                  variance: 73578780.70850402,
                  stdDev: 8577.807453452428,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 74807.12000000001,
              amtAvg: 74807.12000000001,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 74807.12000000001,
              cellID: '3b5cefb1_@_8_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '3b5cefb1_@_8',
              index: 0,
            },
            {
              date: '2025-07-14',
              title: 'NET SALES',
              path: ['NET SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [90104.73],
                anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
                stats: {
                  mean: 73892.99399999999,
                  variance: 73578780.70850402,
                  stdDev: 8577.807453452428,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 68094.2,
              amtAvg: 68094.2,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 68094.2,
              cellID: '3b5cefb1_@_8_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '3b5cefb1_@_8',
              index: 1,
            },
            {
              date: '2025-07-07',
              title: 'NET SALES',
              path: ['NET SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [90104.73],
                anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
                stats: {
                  mean: 73892.99399999999,
                  variance: 73578780.70850402,
                  stdDev: 8577.807453452428,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 70026.76999999999,
              amtAvg: 70026.76999999999,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 70026.76999999999,
              cellID: '3b5cefb1_@_8_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '3b5cefb1_@_8',
              index: 2,
            },
            {
              date: '2025-06-30',
              title: 'NET SALES',
              path: ['NET SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [90104.73],
                anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
                stats: {
                  mean: 73892.99399999999,
                  variance: 73578780.70850402,
                  stdDev: 8577.807453452428,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 90104.73,
              amtAvg: 90104.73,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 90104.73,
              cellID: '3b5cefb1_@_8_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '3b5cefb1_@_8',
              index: 3,
            },
            {
              date: '2025-06-23',
              title: 'NET SALES',
              path: ['NET SALES'],
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [90104.73],
                anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
                stats: {
                  mean: 73892.99399999999,
                  variance: 73578780.70850402,
                  stdDev: 8577.807453452428,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 66432.15,
              amtAvg: 66432.15,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 66432.15,
              cellID: '3b5cefb1_@_8_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '3b5cefb1_@_8',
              index: 4,
            },
          ],
          anomalies: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
        },
        {
          id: '753db221_@_9',
          cellID: '753db221_@_9_-x-_0',
          amountTitle: 'COST OF GOODS SOLD (COGS)',
          refTitle: 'COST OF GOODS SOLD (COGS)',
          percentTitle: '',
          level: 0,
          glCode: 5000,
          parent: null,
          path: ['COST OF GOODS SOLD (COGS)'],
          display: 'header_1',
          children: [
            '7a94d93b_@_9',
            '3f46fcce_@_9',
            '2bdeb0ad_@_9',
            '593c4b13_@_9',
            'e0037727_@_9',
            '47294ea3_@_9',
            '841fc412_@_9',
            '6eb26171_@_9',
            '15101cdc_@_9',
            '90be8534_@_9',
            '3395a498_@_9',
            'e2c4f57e_@_9',
            'b29ce542_@_9',
            '9f08e50d_@_9',
            '027a424d_@_9',
            'dfae81d5_@_9',
          ],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COST OF GOODS SOLD (COGS)',
              path: ['COST OF GOODS SOLD (COGS)'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: '753db221_@_9_-x-_1',
              baseAmount: 0,
              transactions: 0,
              id: '753db221_@_9',
              index: 0,
            },
            {
              date: '2025-07-14',
              title: 'COST OF GOODS SOLD (COGS)',
              path: ['COST OF GOODS SOLD (COGS)'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: '753db221_@_9_-x-_2',
              baseAmount: 0,
              transactions: 0,
              id: '753db221_@_9',
              index: 1,
            },
            {
              date: '2025-07-07',
              title: 'COST OF GOODS SOLD (COGS)',
              path: ['COST OF GOODS SOLD (COGS)'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              cellID: '753db221_@_9_-x-_3',
              baseAmount: 0,
              transactions: 0,
              id: '753db221_@_9',
              index: 2,
            },
            {
              date: '2025-06-30',
              title: 'COST OF GOODS SOLD (COGS)',
              path: ['COST OF GOODS SOLD (COGS)'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              cellID: '753db221_@_9_-x-_4',
              baseAmount: 0,
              transactions: 0,
              id: '753db221_@_9',
              index: 3,
            },
            {
              date: '2025-06-23',
              title: 'COST OF GOODS SOLD (COGS)',
              path: ['COST OF GOODS SOLD (COGS)'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              cellID: '753db221_@_9_-x-_5',
              baseAmount: 0,
              transactions: 0,
              id: '753db221_@_9',
              index: 4,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '7a94d93b_@_9',
          cellID: '7a94d93b_@_9_-x-_0',
          amountTitle: 'COGS, Food',
          refTitle: 'COGS, Food',
          percentTitle: 'Sales, Food',
          baseRef: 'Sales, Food',
          level: 1,
          glCode: 5100,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Food',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
              baseRef: 'Sales, Food',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2621.67],
                anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
                stats: {
                  mean: 1421.26,
                  variance: 614405.2425200001,
                  stdDev: 783.8400618238392,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.4,
                  variance: 1.4400000000000002,
                  stdDev: 1.2000000000000002,
                },
              },
              trxFlagged: [],
              amount: 2046.02,
              perc: 0.051,
              percAvg: 0.051,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15521',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 374.85,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Expense',
                  eventId: '15622',
                  num: '',
                  name: 'Ferro & Sons, Inc.',
                  description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
                  amount: 1089.11,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Expense',
                  eventId: '15594',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 117.28,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Expense',
                  eventId: '15595',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 464.78,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.051,
              percentAVG: 0.051,
              cellID: '7a94d93b_@_9_-x-_1',
              baseAmount: 40123,
              transactions: 4,
              id: '7a94d93b_@_9',
              index: 0,
              cPercent: 0.050993694389751515,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Food',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
              baseRef: 'Sales, Food',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2621.67],
                anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
                stats: {
                  mean: 1421.26,
                  variance: 614405.2425200001,
                  stdDev: 783.8400618238392,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.4,
                  variance: 1.4400000000000002,
                  stdDev: 1.2000000000000002,
                },
              },
              trxFlagged: [],
              amount: 1092.35,
              perc: 0.029,
              percAvg: 0.029,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15227',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 210.91,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15229',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 200.5,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15235',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 184.53,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15236',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 89.76,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15324',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 406.65,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.029,
              percentAVG: 0.029,
              cellID: '7a94d93b_@_9_-x-_2',
              baseAmount: 37673.51,
              transactions: 5,
              id: '7a94d93b_@_9',
              index: 1,
              cPercent: 0.02899517459350084,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Food',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
              baseRef: 'Sales, Food',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2621.67],
                anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
                stats: {
                  mean: 1421.26,
                  variance: 614405.2425200001,
                  stdDev: 783.8400618238392,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.4,
                  variance: 1.4400000000000002,
                  stdDev: 1.2000000000000002,
                },
              },
              trxFlagged: [],
              amount: 2621.67,
              perc: 0.0661,
              percAvg: 0.0661,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '14756',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 319.92,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '15383',
                  num: '',
                  name: 'Ferro & Sons, Inc.',
                  description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
                  amount: 2301.75,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0661,
              percentAVG: 0.0661,
              cellID: '7a94d93b_@_9_-x-_3',
              baseAmount: 39645,
              transactions: 2,
              id: '7a94d93b_@_9',
              index: 2,
              cPercent: 0.06612864169504351,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Food',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
              baseRef: 'Sales, Food',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2621.67],
                anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
                stats: {
                  mean: 1421.26,
                  variance: 614405.2425200001,
                  stdDev: 783.8400618238392,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.4,
                  variance: 1.4400000000000002,
                  stdDev: 1.2000000000000002,
                },
              },
              trxFlagged: [],
              amount: 592.08,
              perc: 0.012,
              percAvg: 0.012,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Expense',
                  eventId: '14754',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 244.6,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Expense',
                  eventId: '14755',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 347.48,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.012,
              percentAVG: 0.012,
              cellID: '7a94d93b_@_9_-x-_4',
              baseAmount: 49465.17,
              transactions: 2,
              id: '7a94d93b_@_9',
              index: 3,
              cPercent: 0.011969634391229224,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Food',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
              baseRef: 'Sales, Food',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2621.67],
                anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
                stats: {
                  mean: 1421.26,
                  variance: 614405.2425200001,
                  stdDev: 783.8400618238392,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.4,
                  variance: 1.4400000000000002,
                  stdDev: 1.2000000000000002,
                },
              },
              trxFlagged: [],
              amount: 754.18,
              perc: 0.0204,
              percAvg: 0.0204,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14556',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 271.63,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14557',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 135.12,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14753',
                  num: '',
                  name: 'Restaurant Depot',
                  description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
                  amount: 331.44,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14879',
                  num: 'Uber eats ADJ P6.25',
                  name: '',
                  description: 'Refund',
                  amount: 15.99,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0204,
              percentAVG: 0.0204,
              cellID: '7a94d93b_@_9_-x-_5',
              baseAmount: 36991,
              transactions: 4,
              id: '7a94d93b_@_9',
              index: 4,
              cPercent: 0.020388202535751937,
            },
          ],
          anomalies: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
        },
        {
          id: '3f46fcce_@_9',
          cellID: '3f46fcce_@_9_-x-_0',
          amountTitle: 'COGS, Meat & Poultry',
          refTitle: 'COGS, Meat & Poultry',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5101,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Meat & Poultry',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3127.43],
                anomalyScores: [0, 0, -0.763586046627646, 0, 0],
                stats: {
                  mean: 3579.3360000000002,
                  variance: 87562.92414400002,
                  stdDev: 295.9103312559398,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
                stats: {
                  mean: 3.8,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 3783.57,
              perc: 0.0506,
              percAvg: 0.0506,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15568',
                  num: 'IV101-0027056103',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 48.99,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Bill',
                  eventId: '15548',
                  num: 'IV101-0027063549',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 195.86,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1591.81,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1555.39,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15547',
                  num: 'MI1900ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 391.52,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0506,
              percentAVG: 0.0506,
              cellID: '3f46fcce_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 5,
              id: '3f46fcce_@_9',
              index: 0,
              cPercent: 0.050577672285739644,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Meat & Poultry',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3127.43],
                anomalyScores: [0, 0, -0.763586046627646, 0, 0],
                stats: {
                  mean: 3579.3360000000002,
                  variance: 87562.92414400002,
                  stdDev: 295.9103312559398,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
                stats: {
                  mean: 3.8,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 3997.89,
              perc: 0.0587,
              percAvg: 0.0587,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Bill',
                  eventId: '15207',
                  num: '9255396',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 797.83,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Bill',
                  eventId: '15540',
                  num: 'IV101-0027025179',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 97.98,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15537',
                  num: '9257563',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1822.14,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15566',
                  num: '9259520',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1279.94,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0587,
              percentAVG: 0.0587,
              cellID: '3f46fcce_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 4,
              id: '3f46fcce_@_9',
              index: 1,
              cPercent: 0.05871116776465543,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Meat & Poultry',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3127.43],
                anomalyScores: [0, 0, -0.763586046627646, 0, 0],
                stats: {
                  mean: 3579.3360000000002,
                  variance: 87562.92414400002,
                  stdDev: 295.9103312559398,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
                stats: {
                  mean: 3.8,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 3127.43,
              perc: 0.0447,
              percAvg: 0.0447,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1139.64,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14896',
                  num: 'IV101-0026997147',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 195.76,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1703.27,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Bill',
                  eventId: '14897',
                  num: '9253030',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 88.76,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0447,
              percentAVG: 0.0447,
              cellID: '3f46fcce_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 4,
              id: '3f46fcce_@_9',
              index: 2,
              cPercent: 0.044660491980424065,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Meat & Poultry',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3127.43],
                anomalyScores: [0, 0, -0.763586046627646, 0, 0],
                stats: {
                  mean: 3579.3360000000002,
                  variance: 87562.92414400002,
                  stdDev: 295.9103312559398,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
                stats: {
                  mean: 3.8,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 3461.52,
              perc: 0.0384,
              percAvg: 0.0384,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14714',
                  num: '9247031',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1435.21,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14824',
                  num: 'MI1811ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 441.11,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Bill',
                  eventId: '14724',
                  num: '9249000',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1585.2,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0384,
              percentAVG: 0.0384,
              cellID: '3f46fcce_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 3,
              id: '3f46fcce_@_9',
              index: 3,
              cPercent: 0.038416629182507954,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Meat & Poultry',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3127.43],
                anomalyScores: [0, 0, -0.763586046627646, 0, 0],
                stats: {
                  mean: 3579.3360000000002,
                  variance: 87562.92414400002,
                  stdDev: 295.9103312559398,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
                stats: {
                  mean: 3.8,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 3526.27,
              perc: 0.0531,
              percAvg: 0.0531,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Bill',
                  eventId: '14561',
                  num: '9239104',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1083.72,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1700.37,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '14703',
                  num: '9243481',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 742.18,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0531,
              percentAVG: 0.0531,
              cellID: '3f46fcce_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: '3f46fcce_@_9',
              index: 4,
              cPercent: 0.05308077489589002,
            },
          ],
          anomalies: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
        },
        {
          id: '2bdeb0ad_@_9',
          cellID: '2bdeb0ad_@_9_-x-_0',
          amountTitle: 'COGS, Seafood',
          refTitle: 'COGS, Seafood',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5102,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Seafood',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 409.418,
                  variance: 6520.799336000002,
                  stdDev: 80.75146646346431,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 0.96,
                  stdDev: 0.9797958971132712,
                },
              },
              trxFlagged: [],
              amount: 336.7,
              perc: 0.0045,
              percAvg: 0.0045,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15568',
                  num: 'IV101-0027056103',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 19.99,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 181.2,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 113.12,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15567',
                  num: 'IV101-0027082856',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 22.39,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0045,
              percentAVG: 0.0045,
              cellID: '2bdeb0ad_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 4,
              id: '2bdeb0ad_@_9',
              index: 0,
              cPercent: 0.004500908469675078,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Seafood',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 409.418,
                  variance: 6520.799336000002,
                  stdDev: 80.75146646346431,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 0.96,
                  stdDev: 0.9797958971132712,
                },
              },
              trxFlagged: [],
              amount: 487.73,
              perc: 0.0072,
              percAvg: 0.0072,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Bill',
                  eventId: '15207',
                  num: '9255396',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 113.07,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15536',
                  num: 'IV101-0027029234',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 23.49,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15537',
                  num: '9257563',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 113.18,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15566',
                  num: '9259520',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 237.99,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0072,
              percentAVG: 0.0072,
              cellID: '2bdeb0ad_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 4,
              id: '2bdeb0ad_@_9',
              index: 1,
              cPercent: 0.007162577723212844,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Seafood',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 409.418,
                  variance: 6520.799336000002,
                  stdDev: 80.75146646346431,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 0.96,
                  stdDev: 0.9797958971132712,
                },
              },
              trxFlagged: [],
              amount: 348.57,
              perc: 0.005,
              percAvg: 0.005,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 106.47,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14896',
                  num: 'IV101-0026997147',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 44.78,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 173.83,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '15027',
                  num: 'IV101-0026997137',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 23.49,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.005,
              percentAVG: 0.005,
              cellID: '2bdeb0ad_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 4,
              id: '2bdeb0ad_@_9',
              index: 2,
              cPercent: 0.004977667826175619,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Seafood',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 409.418,
                  variance: 6520.799336000002,
                  stdDev: 80.75146646346431,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 0.96,
                  stdDev: 0.9797958971132712,
                },
              },
              trxFlagged: [],
              amount: 347.73,
              perc: 0.0039,
              percAvg: 0.0039,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14714',
                  num: '9247031',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 173.84,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Bill',
                  eventId: '14724',
                  num: '9249000',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 173.89,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0039,
              percentAVG: 0.0039,
              cellID: '2bdeb0ad_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 2,
              id: '2bdeb0ad_@_9',
              index: 3,
              cPercent: 0.003859175872343217,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Seafood',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 409.418,
                  variance: 6520.799336000002,
                  stdDev: 80.75146646346431,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 0.96,
                  stdDev: 0.9797958971132712,
                },
              },
              trxFlagged: [],
              amount: 526.36,
              perc: 0.0079,
              percAvg: 0.0079,
              dataRows: [
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 174.66,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '14703',
                  num: '9243481',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 351.7,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0079,
              percentAVG: 0.0079,
              cellID: '2bdeb0ad_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 2,
              id: '2bdeb0ad_@_9',
              index: 4,
              cPercent: 0.007923272090395991,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
        },
        {
          id: '593c4b13_@_9',
          cellID: '593c4b13_@_9_-x-_0',
          amountTitle: 'COGS, Produce',
          refTitle: 'COGS, Produce',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5103,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Produce',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [530.45],
                anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
                stats: {
                  mean: 3267.802,
                  variance: 2018082.4716559995,
                  stdDev: 1420.5922960709029,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
                stats: {
                  mean: 7.4,
                  variance: 12.24,
                  stdDev: 3.4985711369071804,
                },
              },
              trxFlagged: [],
              amount: 3875.6,
              perc: 0.0518,
              percAvg: 0.0518,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15525',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 674.46,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15526',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 35.75,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15527',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 576.26,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15568',
                  num: 'IV101-0027056103',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 433.25,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Bill',
                  eventId: '15548',
                  num: 'IV101-0027063549',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 180.25,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15544',
                  num: '712755',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 150.68,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15615',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'BALDOR SPECIALTY BALDOR SPE',
                  amount: 986.9,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15567',
                  num: 'IV101-0027082856',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 187.5,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Bill',
                  eventId: '15543',
                  num: '713076',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 451.8,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15547',
                  num: 'MI1900ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 198.75,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0518,
              percentAVG: 0.0518,
              cellID: '593c4b13_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 10,
              id: '593c4b13_@_9',
              index: 0,
              cPercent: 0.0518079027771688,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Produce',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [530.45],
                anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
                stats: {
                  mean: 3267.802,
                  variance: 2018082.4716559995,
                  stdDev: 1420.5922960709029,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
                stats: {
                  mean: 7.4,
                  variance: 12.24,
                  stdDev: 3.4985711369071804,
                },
              },
              trxFlagged: [],
              amount: 3361.74,
              perc: 0.0494,
              percAvg: 0.0494,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15440',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 487.94,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15442',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 26.75,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Expense',
                  eventId: '15444',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 438.75,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Expense',
                  eventId: '15446',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 81.58,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Expense',
                  eventId: '15447',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 16.5,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Bill',
                  eventId: '15538',
                  num: 'IV101-0027025164',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 16.5,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Bill',
                  eventId: '15540',
                  num: 'IV101-0027025179',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 200.25,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Expense',
                  eventId: '15448',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 286.21,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Expense',
                  eventId: '15449',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'BALDOR SPECIALTY BALDOR SPE',
                  amount: 936.51,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15467',
                  num: '6502274',
                  name: 'Avanti Produce',
                  description: 'CHECK 6502274',
                  amount: 732.25,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15536',
                  num: 'IV101-0027029234',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 138.5,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0494,
              percentAVG: 0.0494,
              cellID: '593c4b13_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 11,
              id: '593c4b13_@_9',
              index: 1,
              cPercent: 0.049368962407958385,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Produce',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [530.45],
                anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
                stats: {
                  mean: 3267.802,
                  variance: 2018082.4716559995,
                  stdDev: 1420.5922960709029,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
                stats: {
                  mean: 7.4,
                  variance: 12.24,
                  stdDev: 3.4985711369071804,
                },
              },
              trxFlagged: [],
              amount: 4014.31,
              perc: 0.0573,
              percAvg: 0.0573,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14721',
                  num: '711317',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 588.95,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Expense',
                  eventId: '14836',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'BALDOR SPECIALTY BALDOR SPE',
                  amount: 979.61,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Bill',
                  eventId: '15542',
                  num: '711503',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 461.8,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14896',
                  num: 'IV101-0026997147',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 237.5,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '15027',
                  num: 'IV101-0026997137',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 169.75,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15426',
                  num: '6502217',
                  name: 'Avanti Produce',
                  description: 'CHECK 6502217 INV 0710262',
                  amount: 1061.45,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Bill',
                  eventId: '15535',
                  num: 'IV101-0027013901',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 26.75,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Bill',
                  eventId: '15570',
                  num: 'IV101-0027013935',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 488.5,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0573,
              percentAVG: 0.0573,
              cellID: '593c4b13_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 8,
              id: '593c4b13_@_9',
              index: 2,
              cPercent: 0.05732536285766144,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Produce',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [530.45],
                anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
                stats: {
                  mean: 3267.802,
                  variance: 2018082.4716559995,
                  stdDev: 1420.5922960709029,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
                stats: {
                  mean: 7.4,
                  variance: 12.24,
                  stdDev: 3.4985711369071804,
                },
              },
              trxFlagged: [],
              amount: 4556.91,
              perc: 0.0506,
              percAvg: 0.0506,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Bill',
                  eventId: '14821',
                  num: '710926',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 914.6,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Expense',
                  eventId: '14835',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'BALDOR SPECIALTY BALDOR SPE',
                  amount: 1115.12,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14824',
                  num: 'MI1811ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 68.25,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14837',
                  num: '',
                  name: 'Baldor Specialty Foods Inc.',
                  description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
                  amount: 694.09,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Bill',
                  eventId: '14722',
                  num: '711119',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 488.45,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15335',
                  num: '6502145',
                  name: 'Avanti Produce',
                  description: 'CHECK 6502145 INV#0710602',
                  amount: 676.65,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Bill',
                  eventId: '14723',
                  num: '711235',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 599.75,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0506,
              percentAVG: 0.0506,
              cellID: '593c4b13_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 7,
              id: '593c4b13_@_9',
              index: 3,
              cPercent: 0.050573482657347735,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Produce',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [530.45],
                anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
                stats: {
                  mean: 3267.802,
                  variance: 2018082.4716559995,
                  stdDev: 1420.5922960709029,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
                stats: {
                  mean: 7.4,
                  variance: 12.24,
                  stdDev: 3.4985711369071804,
                },
              },
              trxFlagged: [],
              amount: 530.45,
              perc: 0.008,
              percAvg: 0.008,
              dataRows: [
                {
                  txnDate: '2025-06-24',
                  type: 'Check',
                  eventId: '14852',
                  num: '6502071',
                  name: 'Avanti Produce',
                  description: 'CHECK 6502071',
                  amount: 530.45,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.008,
              percentAVG: 0.008,
              cellID: '593c4b13_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '593c4b13_@_9',
              index: 4,
              cPercent: 0.00798483866621809,
            },
          ],
          anomalies: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
        },
        {
          id: 'e0037727_@_9',
          cellID: 'e0037727_@_9_-x-_0',
          amountTitle: 'COGS, Grocery',
          refTitle: 'COGS, Grocery',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5104,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Grocery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7462.322,
                  variance: 18904853.627936,
                  stdDev: 4347.971208268978,
                },
              },
              trxAnomaly: {
                anomalies: [11],
                anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
                stats: {
                  mean: 7.6,
                  variance: 4.24,
                  stdDev: 2.0591260281974,
                },
              },
              trxFlagged: [],
              amount: 2697.45,
              perc: 0.0361,
              percAvg: 0.0361,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15568',
                  num: 'IV101-0027056103',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 26.37,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Bill',
                  eventId: '15565',
                  num: '862670',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 99,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1225.26,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1141.98,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15567',
                  num: 'IV101-0027082856',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 32.31,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Bill',
                  eventId: '15543',
                  num: '713076',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 98.85,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15545',
                  num: 'MI1904ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 31.92,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15546',
                  num: 'MI1903ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 41.76,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0361,
              percentAVG: 0.0361,
              cellID: 'e0037727_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 8,
              id: 'e0037727_@_9',
              index: 0,
              cPercent: 0.03605873344676282,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Grocery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7462.322,
                  variance: 18904853.627936,
                  stdDev: 4347.971208268978,
                },
              },
              trxAnomaly: {
                anomalies: [11],
                anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
                stats: {
                  mean: 7.6,
                  variance: 4.24,
                  stdDev: 2.0591260281974,
                },
              },
              trxFlagged: [],
              amount: 12455.23,
              perc: 0.1829,
              percAvg: 0.1829,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Bill',
                  eventId: '15207',
                  num: '9255396',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 575.78,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Check',
                  eventId: '15456',
                  num: '6502279',
                  name: 'Performance Food Service',
                  description: 'CHECK 6502279',
                  amount: 6401.55,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15536',
                  num: 'IV101-0027029234',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 33.7,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15537',
                  num: '9257563',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 581.93,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15319',
                  num: '',
                  name: 'The Webstaurant Store',
                  description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
                  amount: 594.29,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15514',
                  num: '',
                  name: 'ShopRite',
                  description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
                  amount: 41.27,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15516',
                  num: '6502334',
                  name: 'Performance Food Service',
                  description: 'CHECK 6502334',
                  amount: 3560.65,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15566',
                  num: '9259520',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 666.06,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.1829,
              percentAVG: 0.1829,
              cellID: 'e0037727_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 8,
              id: 'e0037727_@_9',
              index: 1,
              cPercent: 0.18291176047299182,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Grocery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7462.322,
                  variance: 18904853.627936,
                  stdDev: 4347.971208268978,
                },
              },
              trxAnomaly: {
                anomalies: [11],
                anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
                stats: {
                  mean: 7.6,
                  variance: 4.24,
                  stdDev: 2.0591260281974,
                },
              },
              trxFlagged: [],
              amount: 11950.63,
              perc: 0.1707,
              percAvg: 0.1707,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 506.56,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14721',
                  num: '711317',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 65.9,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '15258',
                  num: '',
                  name: 'ShopRite',
                  description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
                  amount: 53.12,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15347',
                  num: '6502206',
                  name: 'Performance Food Service',
                  description: 'CHECK 6502206',
                  amount: 3633.57,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Check',
                  eventId: '15388',
                  num: '6502219',
                  name: 'Performance Food Service',
                  description: 'CHECK 6502219',
                  amount: 5884.26,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Bill',
                  eventId: '15542',
                  num: '711503',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 210.65,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14896',
                  num: 'IV101-0026997147',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 26.37,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1381.53,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '15027',
                  num: 'IV101-0026997137',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 28.05,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Bill',
                  eventId: '14897',
                  num: '9253030',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 103.21,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Expense',
                  eventId: '15241',
                  num: '',
                  name: 'Instacart',
                  description: 'VISA DDA PUR AP - 401134     IC  INSTACART               INSTACART COM * CA',
                  amount: 57.41,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.1707,
              percentAVG: 0.1707,
              cellID: 'e0037727_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 11,
              id: 'e0037727_@_9',
              index: 2,
              cPercent: 0.17065802121103116,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Grocery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7462.322,
                  variance: 18904853.627936,
                  stdDev: 4347.971208268978,
                },
              },
              trxAnomaly: {
                anomalies: [11],
                anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
                stats: {
                  mean: 7.6,
                  variance: 4.24,
                  stdDev: 2.0591260281974,
                },
              },
              trxFlagged: [],
              amount: 2309.13,
              perc: 0.0256,
              percAvg: 0.0256,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14714',
                  num: '9247031',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 973.13,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14824',
                  num: 'MI1811ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 109.71,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Bill',
                  eventId: '14722',
                  num: '711119',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 49.8,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Bill',
                  eventId: '14724',
                  num: '9249000',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 1077.64,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Bill',
                  eventId: '14723',
                  num: '711235',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 98.85,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0256,
              percentAVG: 0.0256,
              cellID: 'e0037727_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 5,
              id: 'e0037727_@_9',
              index: 3,
              cPercent: 0.025627178506611142,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Grocery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 7462.322,
                  variance: 18904853.627936,
                  stdDev: 4347.971208268978,
                },
              },
              trxAnomaly: {
                anomalies: [11],
                anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
                stats: {
                  mean: 7.6,
                  variance: 4.24,
                  stdDev: 2.0591260281974,
                },
              },
              trxFlagged: [],
              amount: 7899.17,
              perc: 0.1189,
              percAvg: 0.1189,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Bill',
                  eventId: '14561',
                  num: '9239104',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 639.73,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14604',
                  num: '',
                  name: 'The Webstaurant Store',
                  description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
                  amount: 875.95,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 481.65,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Check',
                  eventId: '14860',
                  num: '6502089',
                  name: 'Performance Food Service',
                  description: 'CHECK 6502089',
                  amount: 5204.19,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '14703',
                  num: '9243481',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 659.19,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14887',
                  num: '',
                  name: 'ShopRite',
                  description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
                  amount: 38.46,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.1189,
              percentAVG: 0.1189,
              cellID: 'e0037727_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 6,
              id: 'e0037727_@_9',
              index: 4,
              cPercent: 0.11890583098695437,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
        },
        {
          id: '47294ea3_@_9',
          cellID: '47294ea3_@_9_-x-_0',
          amountTitle: 'COGS, Bakery',
          refTitle: 'COGS, Bakery',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5105,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Bakery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1630.48],
                anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
                stats: {
                  mean: 763.7439999999999,
                  variance: 256303.46354400003,
                  stdDev: 506.2642230535356,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 44.8,
              perc: 0.0006,
              percAvg: 0.0006,
              dataRows: [
                {
                  txnDate: '2025-07-22',
                  type: 'Bill',
                  eventId: '15548',
                  num: 'IV101-0027063549',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 44.8,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0006,
              percentAVG: 0.0006,
              cellID: '47294ea3_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '47294ea3_@_9',
              index: 0,
              cPercent: 0.0005988734762145634,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Bakery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1630.48],
                anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
                stats: {
                  mean: 763.7439999999999,
                  variance: 256303.46354400003,
                  stdDev: 506.2642230535356,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 715.21,
              perc: 0.0105,
              percAvg: 0.0105,
              dataRows: [
                {
                  txnDate: '2025-07-15',
                  type: 'Expense',
                  eventId: '15262',
                  num: '',
                  name: 'RM Bakery LLC',
                  description: 'RM BAKERY LLC    SALE',
                  amount: 670.41,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Bill',
                  eventId: '15540',
                  num: 'IV101-0027025179',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 44.8,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0105,
              percentAVG: 0.0105,
              cellID: '47294ea3_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: '47294ea3_@_9',
              index: 1,
              cPercent: 0.010503244035468514,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Bakery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1630.48],
                anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
                stats: {
                  mean: 763.7439999999999,
                  variance: 256303.46354400003,
                  stdDev: 506.2642230535356,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 769.45,
              perc: 0.011,
              percAvg: 0.011,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 37,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Expense',
                  eventId: '14843',
                  num: '',
                  name: 'RM Bakery LLC',
                  description: 'RM BAKERY LLC    SALE',
                  amount: 732.45,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.011,
              percentAVG: 0.011,
              cellID: '47294ea3_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 2,
              id: '47294ea3_@_9',
              index: 2,
              cPercent: 0.010987940754657114,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Bakery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1630.48],
                anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
                stats: {
                  mean: 763.7439999999999,
                  variance: 256303.46354400003,
                  stdDev: 506.2642230535356,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 658.78,
              perc: 0.0073,
              percAvg: 0.0073,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Expense',
                  eventId: '14842',
                  num: '',
                  name: 'RM Bakery LLC',
                  description: 'RM BAKERY LLC    SALE',
                  amount: 613.98,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14824',
                  num: 'MI1811ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 44.8,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0073,
              percentAVG: 0.0073,
              cellID: '47294ea3_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 2,
              id: '47294ea3_@_9',
              index: 3,
              cPercent: 0.007311269896707976,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Bakery',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1630.48],
                anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
                stats: {
                  mean: 763.7439999999999,
                  variance: 256303.46354400003,
                  stdDev: 506.2642230535356,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 1630.48,
              perc: 0.0245,
              percAvg: 0.0245,
              dataRows: [
                {
                  txnDate: '2025-06-24',
                  type: 'Expense',
                  eventId: '14598',
                  num: '',
                  name: 'RM Bakery LLC',
                  description: 'RM BAKERY LLC    SALE',
                  amount: 260.58,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14830',
                  num: '',
                  name: 'David Rosen Bakery Supply Co',
                  description: 'VISA DDA PUR AP - 445351     DAVID ROSEN                 718 381 0600  * NY',
                  amount: 1369.9,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0245,
              percentAVG: 0.0245,
              cellID: '47294ea3_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 2,
              id: '47294ea3_@_9',
              index: 4,
              cPercent: 0.02454353803090823,
            },
          ],
          anomalies: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
        },
        {
          id: '841fc412_@_9',
          cellID: '841fc412_@_9_-x-_0',
          amountTitle: 'COGS, Dairy',
          refTitle: 'COGS, Dairy',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5106,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Dairy',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1228.65],
                anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
                stats: {
                  mean: 1052.1200000000001,
                  variance: 11228.125000000011,
                  stdDev: 105.96284726261375,
                },
              },
              trxAnomaly: {
                anomalies: [7],
                anomalyScores: [0.82915619758885, 0, 0, 0, 0],
                stats: {
                  mean: 4.8,
                  variance: 1.7600000000000002,
                  stdDev: 1.32664991614216,
                },
              },
              trxFlagged: [],
              amount: 1049.11,
              perc: 0.014,
              percAvg: 0.014,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15568',
                  num: 'IV101-0027056103',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 68.24,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Bill',
                  eventId: '15548',
                  num: 'IV101-0027063549',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 68.74,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 335.06,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15544',
                  num: '712755',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 115,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 293.08,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15567',
                  num: 'IV101-0027082856',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 59.09,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Journal Entry',
                  eventId: '15547',
                  num: 'MI1900ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 109.9,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.014,
              percentAVG: 0.014,
              cellID: '841fc412_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 7,
              id: '841fc412_@_9',
              index: 0,
              cPercent: 0.014024199835523674,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Dairy',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1228.65],
                anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
                stats: {
                  mean: 1052.1200000000001,
                  variance: 11228.125000000011,
                  stdDev: 105.96284726261375,
                },
              },
              trxAnomaly: {
                anomalies: [7],
                anomalyScores: [0.82915619758885, 0, 0, 0, 0],
                stats: {
                  mean: 4.8,
                  variance: 1.7600000000000002,
                  stdDev: 1.32664991614216,
                },
              },
              trxFlagged: [],
              amount: 1228.65,
              perc: 0.018,
              percAvg: 0.018,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Bill',
                  eventId: '15207',
                  num: '9255396',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 245.74,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Bill',
                  eventId: '15539',
                  num: 'IV101-0027025183',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 81.58,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Bill',
                  eventId: '15540',
                  num: 'IV101-0027025179',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 30.22,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15537',
                  num: '9257563',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 475.14,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15566',
                  num: '9259520',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 395.97,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.018,
              percentAVG: 0.018,
              cellID: '841fc412_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 5,
              id: '841fc412_@_9',
              index: 1,
              cPercent: 0.018043386955129807,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Dairy',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1228.65],
                anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
                stats: {
                  mean: 1052.1200000000001,
                  variance: 11228.125000000011,
                  stdDev: 105.96284726261375,
                },
              },
              trxAnomaly: {
                anomalies: [7],
                anomalyScores: [0.82915619758885, 0, 0, 0, 0],
                stats: {
                  mean: 4.8,
                  variance: 1.7600000000000002,
                  stdDev: 1.32664991614216,
                },
              },
              trxFlagged: [],
              amount: 963.42,
              perc: 0.0138,
              percAvg: 0.0138,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 311.38,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Bill',
                  eventId: '15542',
                  num: '711503',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 71.8,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14896',
                  num: 'IV101-0026997147',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 64.51,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 493.79,
                },
                {
                  txnDate: '2025-07-12',
                  type: 'Bill',
                  eventId: '15570',
                  num: 'IV101-0027013935',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 21.94,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0138,
              percentAVG: 0.0138,
              cellID: '841fc412_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 5,
              id: '841fc412_@_9',
              index: 2,
              cPercent: 0.013757881450193977,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Dairy',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1228.65],
                anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
                stats: {
                  mean: 1052.1200000000001,
                  variance: 11228.125000000011,
                  stdDev: 105.96284726261375,
                },
              },
              trxAnomaly: {
                anomalies: [7],
                anomalyScores: [0.82915619758885, 0, 0, 0, 0],
                stats: {
                  mean: 4.8,
                  variance: 1.7600000000000002,
                  stdDev: 1.32664991614216,
                },
              },
              trxFlagged: [],
              amount: 1091.88,
              perc: 0.0121,
              percAvg: 0.0121,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14714',
                  num: '9247031',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 518.45,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Journal Entry',
                  eventId: '14824',
                  num: 'MI1811ME',
                  name: '',
                  description: 'Vendor: Baldor Specialty Foods Inc.',
                  amount: 30.22,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Bill',
                  eventId: '14724',
                  num: '9249000',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 354.61,
                },
                {
                  txnDate: '2025-07-05',
                  type: 'Bill',
                  eventId: '14723',
                  num: '711235',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 188.6,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0121,
              percentAVG: 0.0121,
              cellID: '841fc412_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 4,
              id: '841fc412_@_9',
              index: 3,
              cPercent: 0.012117898805090479,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Dairy',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1228.65],
                anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
                stats: {
                  mean: 1052.1200000000001,
                  variance: 11228.125000000011,
                  stdDev: 105.96284726261375,
                },
              },
              trxAnomaly: {
                anomalies: [7],
                anomalyScores: [0.82915619758885, 0, 0, 0, 0],
                stats: {
                  mean: 4.8,
                  variance: 1.7600000000000002,
                  stdDev: 1.32664991614216,
                },
              },
              trxFlagged: [],
              amount: 927.54,
              perc: 0.014,
              percAvg: 0.014,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Bill',
                  eventId: '14561',
                  num: '9239104',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 185.11,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 197.79,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '14703',
                  num: '9243481',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 544.64,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.014,
              percentAVG: 0.014,
              cellID: '841fc412_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: '841fc412_@_9',
              index: 4,
              cPercent: 0.01396221558387016,
            },
          ],
          anomalies: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
        },
        {
          id: '6eb26171_@_9',
          cellID: '6eb26171_@_9_-x-_0',
          amountTitle: 'COGS, Liquor',
          refTitle: 'COGS, Liquor',
          percentTitle: 'Sales, Liquor',
          baseRef: 'Sales, Liquor',
          level: 1,
          glCode: 5110,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Liquor',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
              baseRef: 'Sales, Liquor',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3551.5199999999995,
                  variance: 2218108.5819999995,
                  stdDev: 1489.331589002261,
                },
              },
              trxAnomaly: {
                anomalies: [10],
                anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
                stats: {
                  mean: 4.8,
                  variance: 7.76,
                  stdDev: 2.7856776554368237,
                },
              },
              trxFlagged: [],
              amount: 5695.15,
              amtAvg: 5695.15,
              perc: 0.2584,
              percAvg: 0.2584,
              dataRows: [
                {
                  txnDate: '2025-07-22',
                  type: 'Bill',
                  eventId: '15565',
                  num: '862670',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 1216.77,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15569',
                  num: '866618',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 68.38,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Check',
                  eventId: '15653',
                  num: '6502348',
                  name: 'Allied Beverages',
                  description: 'CHECK 6502348',
                  amount: 1483.07,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Bill',
                  eventId: '15571',
                  num: '870345',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 1992.45,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Expense',
                  eventId: '15620',
                  num: '',
                  name: 'Fedway',
                  description: 'FEDWAY ASSOCIATE FEDWAY ASS',
                  amount: 934.48,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 5695.15,
              percent: 0.2584,
              percentAVG: 0.2584,
              cellID: '6eb26171_@_9_-x-_1',
              baseAmount: 22039.5,
              transactions: 5,
              id: '6eb26171_@_9',
              index: 0,
              cPercent: 0.2584064974250777,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Liquor',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
              baseRef: 'Sales, Liquor',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3551.5199999999995,
                  variance: 2218108.5819999995,
                  stdDev: 1489.331589002261,
                },
              },
              trxAnomaly: {
                anomalies: [10],
                anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
                stats: {
                  mean: 4.8,
                  variance: 7.76,
                  stdDev: 2.7856776554368237,
                },
              },
              trxFlagged: [],
              amount: 1597.33,
              amtAvg: 1597.33,
              perc: 0.0853,
              percAvg: 0.0853,
              dataRows: [
                {
                  txnDate: '2025-07-16',
                  type: 'Deposit',
                  eventId: '15469',
                  num: '',
                  name: 'Allied Beverages',
                  description: '653030 Dt.06.19.2025',
                  amount: -215,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15512',
                  num: '6502221',
                  name: 'Fedway',
                  description: 'POD CHECK',
                  amount: 1000,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15549',
                  num: '59469',
                  name: 'Federal Wine & Spirits Co.',
                  description: '',
                  amount: 812.33,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 1597.33,
              percent: 0.0853,
              percentAVG: 0.0853,
              cellID: '6eb26171_@_9_-x-_2',
              baseAmount: 18733.5,
              transactions: 3,
              id: '6eb26171_@_9',
              index: 1,
              cPercent: 0.08526596738463181,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Liquor',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
              baseRef: 'Sales, Liquor',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3551.5199999999995,
                  variance: 2218108.5819999995,
                  stdDev: 1489.331589002261,
                },
              },
              trxAnomaly: {
                anomalies: [10],
                anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
                stats: {
                  mean: 4.8,
                  variance: 7.76,
                  stdDev: 2.7856776554368237,
                },
              },
              trxFlagged: [],
              amount: 3807.32,
              amtAvg: 3807.32,
              perc: 0.2048,
              percAvg: 0.2048,
              dataRows: [
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14900',
                  num: '837929',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 1325.12,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14901',
                  num: '3733648',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 112,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14902',
                  num: '42235',
                  name: 'Federal Wine & Spirits Co.',
                  description: '',
                  amount: 1370.2,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15406',
                  num: '6502220',
                  name: 'Fedway',
                  description: 'CHECK 6502220',
                  amount: 1000,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 3807.32,
              percent: 0.2048,
              percentAVG: 0.2048,
              cellID: '6eb26171_@_9_-x-_3',
              baseAmount: 18588.01,
              transactions: 4,
              id: '6eb26171_@_9',
              index: 2,
              cPercent: 0.20482665976616113,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Liquor',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
              baseRef: 'Sales, Liquor',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3551.5199999999995,
                  variance: 2218108.5819999995,
                  stdDev: 1489.331589002261,
                },
              },
              trxAnomaly: {
                anomalies: [10],
                anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
                stats: {
                  mean: 4.8,
                  variance: 7.76,
                  stdDev: 2.7856776554368237,
                },
              },
              trxFlagged: [],
              amount: 4449.61,
              amtAvg: 4449.61,
              perc: 0.1697,
              percAvg: 0.1697,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Journal Entry',
                  eventId: '14820',
                  num: 'MI1826ME',
                  name: '',
                  description: 'Vendor: Allied Beverage Group LLC',
                  amount: 178.64,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Deposit',
                  eventId: '15279',
                  num: '650411',
                  name: '',
                  description: '',
                  amount: -237,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Deposit',
                  eventId: '15279',
                  num: '773964',
                  name: '',
                  description: '',
                  amount: -69,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Deposit',
                  eventId: '15279',
                  num: '752749',
                  name: '',
                  description: '',
                  amount: -48,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Deposit',
                  eventId: '15279',
                  num: '644657',
                  name: '',
                  description: '',
                  amount: -36,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Deposit',
                  eventId: '15279',
                  num: '641925',
                  name: '',
                  description: '',
                  amount: -12,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Check',
                  eventId: '15287',
                  num: '6502148',
                  name: 'Allied Beverages',
                  description: 'CHECK 6502148',
                  amount: 178.64,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14822',
                  num: 'MI1819ME',
                  name: '',
                  description: 'Vendor: Federal Wine & Spirits Co.',
                  amount: 1184.38,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Bill',
                  eventId: '14823',
                  num: '824312',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 2309.95,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15333',
                  num: '6502200',
                  name: 'Fedway',
                  description: 'POD CHECK #110620',
                  amount: 1000,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 4449.61,
              percent: 0.1697,
              percentAVG: 0.1697,
              cellID: '6eb26171_@_9_-x-_4',
              baseAmount: 26219.51,
              transactions: 10,
              id: '6eb26171_@_9',
              index: 3,
              cPercent: 0.16970607002190352,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Liquor',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
              baseRef: 'Sales, Liquor',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3551.5199999999995,
                  variance: 2218108.5819999995,
                  stdDev: 1489.331589002261,
                },
              },
              trxAnomaly: {
                anomalies: [10],
                anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
                stats: {
                  mean: 4.8,
                  variance: 7.76,
                  stdDev: 2.7856776554368237,
                },
              },
              trxFlagged: [],
              amount: 2208.19,
              amtAvg: 2208.19,
              perc: 0.1168,
              percAvg: 0.1168,
              dataRows: [
                {
                  txnDate: '2025-06-25',
                  type: 'Check',
                  eventId: '14859',
                  num: '6502093',
                  name: 'Fedway',
                  description: 'CHECK 6502093',
                  amount: 1000,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Check',
                  eventId: '14880',
                  num: '6502094',
                  name: 'Allied Beverages',
                  description: 'CHECK 6502094',
                  amount: 1208.19,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 2208.19,
              percent: 0.1168,
              percentAVG: 0.1168,
              cellID: '6eb26171_@_9_-x-_5',
              baseAmount: 18898,
              transactions: 2,
              id: '6eb26171_@_9',
              index: 4,
              cPercent: 0.11684781458355382,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
        },
        {
          id: '15101cdc_@_9',
          cellID: '15101cdc_@_9_-x-_0',
          amountTitle: 'COGS, Bar Groceries',
          refTitle: 'COGS, Bar Groceries',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5111,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Bar Groceries',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [182.06],
                anomalyScores: [0.858758349427589, 0, 0, 0, 0],
                stats: {
                  mean: 80.854,
                  variance: 3472.246784,
                  stdDev: 58.92577351210589,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.9600000000000002,
                  stdDev: 0.9797958971132713,
                },
              },
              trxFlagged: [],
              amount: 182.06,
              perc: 0.0024,
              percAvg: 0.0024,
              dataRows: [
                {
                  txnDate: '2025-07-22',
                  type: 'Bill',
                  eventId: '15565',
                  num: '862670',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 59,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15563',
                  num: '9262982',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 61.53,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15562',
                  num: '9265170',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 61.53,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0024,
              percentAVG: 0.0024,
              cellID: '15101cdc_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 3,
              id: '15101cdc_@_9',
              index: 0,
              cPercent: 0.002433725559813023,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Bar Groceries',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [182.06],
                anomalyScores: [0.858758349427589, 0, 0, 0, 0],
                stats: {
                  mean: 80.854,
                  variance: 3472.246784,
                  stdDev: 58.92577351210589,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.9600000000000002,
                  stdDev: 0.9797958971132713,
                },
              },
              trxFlagged: [],
              amount: 90.52,
              perc: 0.0013,
              percAvg: 0.0013,
              dataRows: [
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15536',
                  num: 'IV101-0027029234',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 90.52,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0013,
              percentAVG: 0.0013,
              cellID: '15101cdc_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '15101cdc_@_9',
              index: 1,
              cPercent: 0.001329334950700647,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Bar Groceries',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [182.06],
                anomalyScores: [0.858758349427589, 0, 0, 0, 0],
                stats: {
                  mean: 80.854,
                  variance: 3472.246784,
                  stdDev: 58.92577351210589,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.9600000000000002,
                  stdDev: 0.9797958971132713,
                },
              },
              trxFlagged: [],
              amount: 70.16,
              perc: 0.001,
              percAvg: 0.001,
              dataRows: [
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 70.16,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.001,
              percentAVG: 0.001,
              cellID: '15101cdc_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '15101cdc_@_9',
              index: 2,
              cPercent: 0.0010019025581217012,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Bar Groceries',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [182.06],
                anomalyScores: [0.858758349427589, 0, 0, 0, 0],
                stats: {
                  mean: 80.854,
                  variance: 3472.246784,
                  stdDev: 58.92577351210589,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.9600000000000002,
                  stdDev: 0.9797958971132713,
                },
              },
              trxFlagged: [],
              amount: 61.53,
              perc: 0.0007,
              percAvg: 0.0007,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14719',
                  num: '9247032',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 61.53,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0007,
              percentAVG: 0.0007,
              cellID: '15101cdc_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '15101cdc_@_9',
              index: 3,
              cPercent: 0.0006828720312463064,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Bar Groceries',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [182.06],
                anomalyScores: [0.858758349427589, 0, 0, 0, 0],
                stats: {
                  mean: 80.854,
                  variance: 3472.246784,
                  stdDev: 58.92577351210589,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.9600000000000002,
                  stdDev: 0.9797958971132713,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '15101cdc_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '15101cdc_@_9',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
        },
        {
          id: '90be8534_@_9',
          cellID: '90be8534_@_9_-x-_0',
          amountTitle: 'COGS, Beer',
          refTitle: 'COGS, Beer',
          percentTitle: 'Sales, Beer',
          baseRef: 'Sales, Beer',
          level: 1,
          glCode: 5115,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
              baseRef: 'Sales, Beer',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '90be8534_@_9_-x-_1',
              baseAmount: 5225,
              transactions: 0,
              id: '90be8534_@_9',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
              baseRef: 'Sales, Beer',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '90be8534_@_9_-x-_2',
              baseAmount: 5015,
              transactions: 0,
              id: '90be8534_@_9',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
              baseRef: 'Sales, Beer',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 435.87,
              amtAvg: 435.87,
              perc: 0.0925,
              percAvg: 0.0925,
              dataRows: [
                {
                  txnDate: '2025-07-09',
                  type: 'Check',
                  eventId: '15390',
                  num: '6502207',
                  name: 'Eileen Kim',
                  description: 'CHECK 6502207 Beer',
                  amount: 435.87,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 435.87,
              percent: 0.0925,
              percentAVG: 0.0925,
              cellID: '90be8534_@_9_-x-_3',
              baseAmount: 4710,
              transactions: 1,
              id: '90be8534_@_9',
              index: 2,
              cPercent: 0.09254140127388535,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
              baseRef: 'Sales, Beer',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              cellID: '90be8534_@_9_-x-_4',
              baseAmount: 6528,
              transactions: 0,
              id: '90be8534_@_9',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
              baseRef: 'Sales, Beer',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              cellID: '90be8534_@_9_-x-_5',
              baseAmount: 6146,
              transactions: 0,
              id: '90be8534_@_9',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '3395a498_@_9',
          cellID: '3395a498_@_9_-x-_0',
          amountTitle: 'COGS, Draught Beer',
          refTitle: 'COGS, Draught Beer',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5116,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Draught Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3631.5],
                anomalyScores: [0, 0.990370616654923, 0, 0, 0],
                stats: {
                  mean: 887,
                  variance: 1919866.3,
                  stdDev: 1385.5924003833163,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 4.960000000000001,
                  stdDev: 2.227105745132009,
                },
              },
              trxFlagged: [],
              amount: 508,
              perc: 0.0068,
              percAvg: 0.0068,
              dataRows: [
                {
                  txnDate: '2025-07-24',
                  type: 'Bill',
                  eventId: '15553',
                  num: '627286',
                  name: 'Northern Eagle Beverage',
                  description: '',
                  amount: 413,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Bill',
                  eventId: '15558',
                  num: '3733797',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 95,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0068,
              percentAVG: 0.0068,
              cellID: '3395a498_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 2,
              id: '3395a498_@_9',
              index: 0,
              cPercent: 0.006790797453504425,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Draught Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3631.5],
                anomalyScores: [0, 0.990370616654923, 0, 0, 0],
                stats: {
                  mean: 887,
                  variance: 1919866.3,
                  stdDev: 1385.5924003833163,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 4.960000000000001,
                  stdDev: 2.227105745132009,
                },
              },
              trxFlagged: [],
              amount: 3631.5,
              perc: 0.0533,
              percAvg: 0.0533,
              dataRows: [
                {
                  txnDate: '2025-07-17',
                  type: 'Expense',
                  eventId: '15493',
                  num: '',
                  name: 'Northern Eagle Beverage',
                  description: 'NORTHERN EAGLE B INVOICES',
                  amount: 870.5,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Bill',
                  eventId: '15554',
                  num: '625995',
                  name: 'Northern Eagle Beverage',
                  description: '',
                  amount: 640,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Bill',
                  eventId: '15555',
                  num: '3733721',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 447,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Bill',
                  eventId: '15556',
                  num: '3733723',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 485,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15498',
                  num: '',
                  name: 'Northern Eagle Beverage',
                  description: 'NORTHERN EAGLE B INVOICES',
                  amount: 640,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15508',
                  num: '6502332',
                  name: 'Hoboken Brewing',
                  description: 'CHECK 6502332',
                  amount: 549,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0533,
              percentAVG: 0.0533,
              cellID: '3395a498_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 6,
              id: '3395a498_@_9',
              index: 1,
              cPercent: 0.053330533290647374,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Draught Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3631.5],
                anomalyScores: [0, 0.990370616654923, 0, 0, 0],
                stats: {
                  mean: 887,
                  variance: 1919866.3,
                  stdDev: 1385.5924003833163,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 4.960000000000001,
                  stdDev: 2.227105745132009,
                },
              },
              trxFlagged: [],
              amount: 295.5,
              perc: 0.0042,
              percAvg: 0.0042,
              dataRows: [
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14901',
                  num: '3733648',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 295.5,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0042,
              percentAVG: 0.0042,
              cellID: '3395a498_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '3395a498_@_9',
              index: 2,
              cPercent: 0.00421981479368533,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Draught Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3631.5],
                anomalyScores: [0, 0.990370616654923, 0, 0, 0],
                stats: {
                  mean: 887,
                  variance: 1919866.3,
                  stdDev: 1385.5924003833163,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 4.960000000000001,
                  stdDev: 2.227105745132009,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '3395a498_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '3395a498_@_9',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Draught Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3631.5],
                anomalyScores: [0, 0.990370616654923, 0, 0, 0],
                stats: {
                  mean: 887,
                  variance: 1919866.3,
                  stdDev: 1385.5924003833163,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
                stats: {
                  mean: 1.8,
                  variance: 4.960000000000001,
                  stdDev: 2.227105745132009,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '3395a498_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '3395a498_@_9',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
        },
        {
          id: 'e2c4f57e_@_9',
          cellID: 'e2c4f57e_@_9_-x-_0',
          amountTitle: 'COGS, Bottled Beer',
          refTitle: 'COGS, Bottled Beer',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5117,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Bottled Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 321.71999999999997,
                  variance: 34843.0336,
                  stdDev: 186.66288758079364,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 438.6,
              perc: 0.0059,
              percAvg: 0.0059,
              dataRows: [
                {
                  txnDate: '2025-07-24',
                  type: 'Bill',
                  eventId: '15553',
                  num: '627286',
                  name: 'Northern Eagle Beverage',
                  description: '',
                  amount: 52.6,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Bill',
                  eventId: '15558',
                  num: '3733797',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 349,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Bill',
                  eventId: '15559',
                  num: '3733798',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 37,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0059,
              percentAVG: 0.0059,
              cellID: 'e2c4f57e_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 3,
              id: 'e2c4f57e_@_9',
              index: 0,
              cPercent: 0.0058630782738327576,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Bottled Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 321.71999999999997,
                  variance: 34843.0336,
                  stdDev: 186.66288758079364,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 522,
              perc: 0.0077,
              percAvg: 0.0077,
              dataRows: [
                {
                  txnDate: '2025-07-17',
                  type: 'Bill',
                  eventId: '15555',
                  num: '3733721',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 298,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15549',
                  num: '59469',
                  name: 'Federal Wine & Spirits Co.',
                  description: '',
                  amount: 224,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0077,
              percentAVG: 0.0077,
              cellID: 'e2c4f57e_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: 'e2c4f57e_@_9',
              index: 1,
              cPercent: 0.007665851129758482,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Bottled Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 321.71999999999997,
                  variance: 34843.0336,
                  stdDev: 186.66288758079364,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 416,
              perc: 0.0059,
              percAvg: 0.0059,
              dataRows: [
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14899',
                  num: '3733647',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 37,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14901',
                  num: '3733648',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 379,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0059,
              percentAVG: 0.0059,
              cellID: 'e2c4f57e_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 2,
              id: 'e2c4f57e_@_9',
              index: 2,
              cPercent: 0.0059405852933099735,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Bottled Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 321.71999999999997,
                  variance: 34843.0336,
                  stdDev: 186.66288758079364,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 232,
              perc: 0.0026,
              percAvg: 0.0026,
              dataRows: [
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14822',
                  num: 'MI1819ME',
                  name: '',
                  description: 'Vendor: Federal Wine & Spirits Co.',
                  amount: 232,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0026,
              percentAVG: 0.0026,
              cellID: 'e2c4f57e_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: 'e2c4f57e_@_9',
              index: 3,
              cPercent: 0.002574781590267237,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Bottled Beer',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 321.71999999999997,
                  variance: 34843.0336,
                  stdDev: 186.66288758079364,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'e2c4f57e_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'e2c4f57e_@_9',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
        },
        {
          id: 'b29ce542_@_9',
          cellID: 'b29ce542_@_9_-x-_0',
          amountTitle: 'COGS, Wine',
          refTitle: 'COGS, Wine',
          percentTitle: 'Sales, Wine',
          baseRef: 'Sales, Wine',
          level: 1,
          glCode: 5120,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Wine',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
              baseRef: 'Sales, Wine',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1132.352,
                  variance: 466697.673056,
                  stdDev: 683.152745040229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2.4,
                  variance: 1.8399999999999999,
                  stdDev: 1.3564659966250536,
                },
              },
              trxFlagged: [],
              amount: 1280.88,
              amtAvg: 1280.88,
              perc: 0.6883,
              percAvg: 0.6883,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15569',
                  num: '866618',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 145.08,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Bill',
                  eventId: '15571',
                  num: '870345',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 325.8,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15550',
                  num: '723293',
                  name: 'Gallo Wine Sales',
                  description: '',
                  amount: 810,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 1280.88,
              percent: 0.6883,
              percentAVG: 0.6883,
              cellID: 'b29ce542_@_9_-x-_1',
              baseAmount: 1861,
              transactions: 3,
              id: 'b29ce542_@_9',
              index: 0,
              cPercent: 0.6882751209027406,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Wine',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
              baseRef: 'Sales, Wine',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1132.352,
                  variance: 466697.673056,
                  stdDev: 683.152745040229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2.4,
                  variance: 1.8399999999999999,
                  stdDev: 1.3564659966250536,
                },
              },
              trxFlagged: [],
              amount: 1032.5,
              amtAvg: 1032.5,
              perc: 0.6311,
              percAvg: 0.6311,
              dataRows: [
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15549',
                  num: '59469',
                  name: 'Federal Wine & Spirits Co.',
                  description: '',
                  amount: 507.3,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15551',
                  num: '714240',
                  name: 'Gallo Wine Sales',
                  description: '',
                  amount: 525.2,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 1032.5,
              percent: 0.6311,
              percentAVG: 0.6311,
              cellID: 'b29ce542_@_9_-x-_2',
              baseAmount: 1636,
              transactions: 2,
              id: 'b29ce542_@_9',
              index: 1,
              cPercent: 0.6311124694376528,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Wine',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
              baseRef: 'Sales, Wine',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1132.352,
                  variance: 466697.673056,
                  stdDev: 683.152745040229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2.4,
                  variance: 1.8399999999999999,
                  stdDev: 1.3564659966250536,
                },
              },
              trxFlagged: [],
              amount: 1209.4,
              amtAvg: 1209.4,
              perc: 0.966,
              percAvg: 0.966,
              dataRows: [
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14900',
                  num: '837929',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 218.16,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14902',
                  num: '42235',
                  name: 'Federal Wine & Spirits Co.',
                  description: '',
                  amount: 181.24,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '15206',
                  num: '710320',
                  name: 'Gallo Wine Sales',
                  description: '',
                  amount: 810,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 1209.4,
              percent: 0.966,
              percentAVG: 0.966,
              cellID: 'b29ce542_@_9_-x-_3',
              baseAmount: 1252,
              transactions: 3,
              id: 'b29ce542_@_9',
              index: 2,
              cPercent: 0.9659744408945687,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Wine',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
              baseRef: 'Sales, Wine',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1132.352,
                  variance: 466697.673056,
                  stdDev: 683.152745040229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2.4,
                  variance: 1.8399999999999999,
                  stdDev: 1.3564659966250536,
                },
              },
              trxFlagged: [],
              amount: 2138.98,
              amtAvg: 2138.98,
              perc: 1.3139,
              percAvg: 1.3139,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Check',
                  eventId: '15277',
                  num: '6502116',
                  name: 'Gallo Wine Sales',
                  description: 'CHECK 6502116 703442',
                  amount: 720.12,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Bill',
                  eventId: '14717',
                  num: '707058',
                  name: 'Gallo Wine Sales',
                  description: '',
                  amount: 462,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14822',
                  num: 'MI1819ME',
                  name: '',
                  description: 'Vendor: Federal Wine & Spirits Co.',
                  amount: 631.06,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Bill',
                  eventId: '14823',
                  num: '824312',
                  name: 'Allied Beverages',
                  description: '',
                  amount: 325.8,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 2138.98,
              percent: 1.3139,
              percentAVG: 1.3139,
              cellID: 'b29ce542_@_9_-x-_4',
              baseAmount: 1628,
              transactions: 4,
              id: 'b29ce542_@_9',
              index: 3,
              cPercent: 1.3138697788697788,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Wine',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
              baseRef: 'Sales, Wine',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1132.352,
                  variance: 466697.673056,
                  stdDev: 683.152745040229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 2.4,
                  variance: 1.8399999999999999,
                  stdDev: 1.3564659966250536,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'b29ce542_@_9_-x-_5',
              baseAmount: 1513,
              transactions: 0,
              id: 'b29ce542_@_9',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
        },
        {
          id: '9f08e50d_@_9',
          cellID: '9f08e50d_@_9_-x-_0',
          amountTitle: 'COGS, Non-Alcoholic',
          refTitle: 'COGS, Non-Alcoholic',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5125,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Non-Alcoholic',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [78.71],
                anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
                stats: {
                  mean: 1208.614,
                  variance: 528906.312224,
                  stdDev: 727.2594531692249,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0, 0.784464540552736, 0, 0],
                stats: {
                  mean: 4.4,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 1532.25,
              amtAvg: 1532.25,
              perc: 0.0205,
              percAvg: 0.0205,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15568',
                  num: 'IV101-0027056103',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 77.62,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15637',
                  num: '6502336',
                  name: 'Peerless Beverage',
                  description: 'CHECK 6502336',
                  amount: 1311.5,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 19.26,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 75.37,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15567',
                  num: 'IV101-0027082856',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 48.5,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 1532.25,
              percent: 0.0205,
              percentAVG: 0.0205,
              cellID: '9f08e50d_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 5,
              id: '9f08e50d_@_9',
              index: 0,
              cPercent: 0.02048267598057511,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Non-Alcoholic',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [78.71],
                anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
                stats: {
                  mean: 1208.614,
                  variance: 528906.312224,
                  stdDev: 727.2594531692249,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0, 0.784464540552736, 0, 0],
                stats: {
                  mean: 4.4,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 1730.15,
              amtAvg: 1730.15,
              perc: 0.0254,
              percAvg: 0.0254,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15437',
                  num: '6502262',
                  name: 'Peerless Beverage',
                  description: 'CHECK 6502262',
                  amount: 986,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Bill',
                  eventId: '15540',
                  num: 'IV101-0027025179',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 65.5,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Bill',
                  eventId: '15557',
                  num: '3733722',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 81.5,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Bill',
                  eventId: '15560',
                  num: '13859010',
                  name: 'Pepsi',
                  description: '',
                  amount: 597.15,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 1730.15,
              percent: 0.0254,
              percentAVG: 0.0254,
              cellID: '9f08e50d_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 4,
              id: '9f08e50d_@_9',
              index: 1,
              cPercent: 0.025408184544351797,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Non-Alcoholic',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [78.71],
                anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
                stats: {
                  mean: 1208.614,
                  variance: 528906.312224,
                  stdDev: 727.2594531692249,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0, 0.784464540552736, 0, 0],
                stats: {
                  mean: 4.4,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 661.57,
              amtAvg: 661.57,
              perc: 0.0094,
              percAvg: 0.0094,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 121.22,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14896',
                  num: 'IV101-0026997147',
                  name: 'Baldor Specialty Foods Inc.',
                  description: '',
                  amount: 65.5,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14898',
                  num: '3685855',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 40.75,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14899',
                  num: '3733647',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 122.25,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 153.95,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14904',
                  num: '116699',
                  name: 'W.b. Law Coffee',
                  description: '',
                  amount: 157.9,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 661.57,
              percent: 0.0094,
              percentAVG: 0.0094,
              cellID: '9f08e50d_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 6,
              id: '9f08e50d_@_9',
              index: 2,
              cPercent: 0.009447387049267017,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Non-Alcoholic',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [78.71],
                anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
                stats: {
                  mean: 1208.614,
                  variance: 528906.312224,
                  stdDev: 727.2594531692249,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0, 0.784464540552736, 0, 0],
                stats: {
                  mean: 4.4,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 2040.39,
              amtAvg: 2040.39,
              perc: 0.0226,
              percAvg: 0.0226,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Expense',
                  eventId: '14846',
                  num: '',
                  name: 'Peerless Beverage',
                  description: 'PEERLESS BEVERAG PEERLESS B',
                  amount: 1115,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14714',
                  num: '9247031',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 49.75,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Bill',
                  eventId: '14718',
                  num: '27165007',
                  name: 'Pepsi',
                  description: '',
                  amount: 812.37,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Journal Entry',
                  eventId: '14822',
                  num: 'MI1819ME',
                  name: '',
                  description: 'Vendor: Federal Wine & Spirits Co.',
                  amount: 63.27,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 2040.39,
              percent: 0.0226,
              percentAVG: 0.0226,
              cellID: '9f08e50d_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 4,
              id: '9f08e50d_@_9',
              index: 3,
              cPercent: 0.02264464917657486,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Non-Alcoholic',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [78.71],
                anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
                stats: {
                  mean: 1208.614,
                  variance: 528906.312224,
                  stdDev: 727.2594531692249,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0, 0, 0.784464540552736, 0, 0],
                stats: {
                  mean: 4.4,
                  variance: 1.04,
                  stdDev: 1.019803902718557,
                },
              },
              trxFlagged: [],
              amount: 78.71,
              amtAvg: 78.71,
              perc: 0.0012,
              percAvg: 0.0012,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Bill',
                  eventId: '14561',
                  num: '9239104',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 49.91,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Check',
                  eventId: '15211',
                  num: '6502076',
                  name: 'Peerless Beverage',
                  description: '',
                  amount: 3.75,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 25.05,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 78.71,
              percent: 0.0012,
              percentAVG: 0.0012,
              cellID: '9f08e50d_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: '9f08e50d_@_9',
              index: 4,
              cPercent: 0.0011848178931436058,
            },
          ],
          anomalies: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
        },
        {
          id: '027a424d_@_9',
          cellID: '027a424d_@_9_-x-_0',
          amountTitle: 'COGS, Packaging',
          refTitle: 'COGS, Packaging',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5135,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'COGS, Packaging',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 259.672,
                  variance: 11114.769296000002,
                  stdDev: 105.42660620545462,
                },
              },
              trxAnomaly: {
                anomalies: [1, 3],
                anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
                stats: {
                  mean: 2,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 189.45,
              perc: 0.0025,
              percAvg: 0.0025,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 129.66,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 59.79,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0025,
              percentAVG: 0.0025,
              cellID: '027a424d_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 2,
              id: '027a424d_@_9',
              index: 0,
              cPercent: 0.0025325129479653805,
            },
            {
              date: '2025-07-14',
              title: 'COGS, Packaging',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 259.672,
                  variance: 11114.769296000002,
                  stdDev: 105.42660620545462,
                },
              },
              trxAnomaly: {
                anomalies: [1, 3],
                anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
                stats: {
                  mean: 2,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 410.12,
              perc: 0.006,
              percAvg: 0.006,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Bill',
                  eventId: '15207',
                  num: '9255396',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 102.98,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15537',
                  num: '9257563',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 307.14,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.006,
              percentAVG: 0.006,
              cellID: '027a424d_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: '027a424d_@_9',
              index: 1,
              cPercent: 0.006022833075357373,
            },
            {
              date: '2025-07-07',
              title: 'COGS, Packaging',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 259.672,
                  variance: 11114.769296000002,
                  stdDev: 105.42660620545462,
                },
              },
              trxAnomaly: {
                anomalies: [1, 3],
                anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
                stats: {
                  mean: 2,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 147.95,
              perc: 0.0021,
              percAvg: 0.0021,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 103.38,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 44.57,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0021,
              percentAVG: 0.0021,
              cellID: '027a424d_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 2,
              id: '027a424d_@_9',
              index: 2,
              cPercent: 0.0021127634474644484,
            },
            {
              date: '2025-06-30',
              title: 'COGS, Packaging',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 259.672,
                  variance: 11114.769296000002,
                  stdDev: 105.42660620545462,
                },
              },
              trxAnomaly: {
                anomalies: [1, 3],
                anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
                stats: {
                  mean: 2,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 188.73,
              perc: 0.0021,
              percAvg: 0.0021,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14714',
                  num: '9247031',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 188.73,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0021,
              percentAVG: 0.0021,
              cellID: '027a424d_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '027a424d_@_9',
              index: 3,
              cPercent: 0.0020945626272893775,
            },
            {
              date: '2025-06-23',
              title: 'COGS, Packaging',
              path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 259.672,
                  variance: 11114.769296000002,
                  stdDev: 105.42660620545462,
                },
              },
              trxAnomaly: {
                anomalies: [1, 3],
                anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
                stats: {
                  mean: 2,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 362.11,
              perc: 0.0055,
              percAvg: 0.0055,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Bill',
                  eventId: '14561',
                  num: '9239104',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 94.73,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 128.73,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '14703',
                  num: '9243481',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 138.65,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0055,
              percentAVG: 0.0055,
              cellID: '027a424d_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: '027a424d_@_9',
              index: 4,
              cPercent: 0.005450824638371632,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
        },
        {
          id: 'dfae81d5_@_9',
          cellID: 'dfae81d5_@_9_-x-_0',
          amountTitle: 'Shipping, Freight and Delivery',
          refTitle: 'Shipping, Freight and Delivery',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5195,
          parent: '753db221',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Shipping, Freight and Delivery',
              path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 387.04,
              perc: 0.0052,
              percAvg: 0.0052,
              dataRows: [
                {
                  txnDate: '2025-07-22',
                  type: 'Check',
                  eventId: '15649',
                  num: '6502338',
                  name: 'Campos Delivery LLC',
                  description: 'CHECK 6502338',
                  amount: 387.04,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0052,
              percentAVG: 0.0052,
              cellID: 'dfae81d5_@_9_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: 'dfae81d5_@_9',
              index: 0,
              cPercent: 0.005173839067725104,
            },
            {
              date: '2025-07-14',
              title: 'Shipping, Freight and Delivery',
              path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: 'dfae81d5_@_9_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'dfae81d5_@_9',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Shipping, Freight and Delivery',
              path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              cellID: 'dfae81d5_@_9_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'dfae81d5_@_9',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Shipping, Freight and Delivery',
              path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              cellID: 'dfae81d5_@_9_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'dfae81d5_@_9',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Shipping, Freight and Delivery',
              path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              cellID: 'dfae81d5_@_9_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'dfae81d5_@_9',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '528a97f9_@_10',
          cellID: '528a97f9_@_10_-x-_0',
          amountTitle: 'TOTAL COGS',
          refTitle: 'TOTAL COGS',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['TOTAL COGS'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'TOTAL COGS',
              path: ['TOTAL COGS'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 25562.316,
                  variance: 27743880.639304,
                  stdDev: 5267.246020389023,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 24046.680000000004,
              amtAvg: 24046.680000000004,
              perc: 0.3214,
              percAvg: 0.3214,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 24046.680000000004,
              percent: 0.3214,
              percentAVG: 0.3214,
              cellID: '528a97f9_@_10_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '528a97f9_@_10',
              index: 0,
              cPercent: 0.3214490813173933,
            },
            {
              date: '2025-07-14',
              title: 'TOTAL COGS',
              path: ['TOTAL COGS'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 25562.316,
                  variance: 27743880.639304,
                  stdDev: 5267.246020389023,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 32352.92,
              amtAvg: 32352.92,
              perc: 0.4751,
              percAvg: 0.4751,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 32352.92,
              percent: 0.4751,
              percentAVG: 0.4751,
              cellID: '528a97f9_@_10_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '528a97f9_@_10',
              index: 1,
              cPercent: 0.4751200542777505,
            },
            {
              date: '2025-07-07',
              title: 'TOTAL COGS',
              path: ['TOTAL COGS'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 25562.316,
                  variance: 27743880.639304,
                  stdDev: 5267.246020389023,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 30839.25,
              amtAvg: 30839.25,
              perc: 0.4404,
              percAvg: 0.4404,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 30839.25,
              percent: 0.4404,
              percentAVG: 0.4404,
              cellID: '528a97f9_@_10_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '528a97f9_@_10',
              index: 2,
              cPercent: 0.4403922956892058,
            },
            {
              date: '2025-06-30',
              title: 'TOTAL COGS',
              path: ['TOTAL COGS'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 25562.316,
                  variance: 27743880.639304,
                  stdDev: 5267.246020389023,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 22129.269999999997,
              amtAvg: 22129.269999999997,
              perc: 0.2456,
              percAvg: 0.2456,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 22129.269999999997,
              percent: 0.2456,
              percentAVG: 0.2456,
              cellID: '528a97f9_@_10_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '528a97f9_@_10',
              index: 3,
              cPercent: 0.24559498707781488,
            },
            {
              date: '2025-06-23',
              title: 'TOTAL COGS',
              path: ['TOTAL COGS'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 25562.316,
                  variance: 27743880.639304,
                  stdDev: 5267.246020389023,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 18443.46,
              amtAvg: 18443.46,
              perc: 0.2776,
              percAvg: 0.2776,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 18443.46,
              percent: 0.2776,
              percentAVG: 0.2776,
              cellID: '528a97f9_@_10_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '528a97f9_@_10',
              index: 4,
              cPercent: 0.2776285277535049,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
        },
        {
          id: '7b400e74_@_12',
          cellID: '7b400e74_@_12_-x-_0',
          amountTitle: 'GROSS PROFIT',
          refTitle: 'GROSS PROFIT',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['GROSS PROFIT'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'GROSS PROFIT',
              path: ['GROSS PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [67975.45999999999],
                anomalyScores: [0, 0, 0, 0.872263803844029, 0],
                stats: {
                  mean: 48330.678,
                  variance: 126805687.84233598,
                  stdDev: 11260.80316151277,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 50760.44,
              amtAvg: 50760.44,
              perc: 0.6786,
              percAvg: 0.6786,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 50760.44,
              percent: 0.6786,
              percentAVG: 0.6786,
              cellID: '7b400e74_@_12_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '7b400e74_@_12',
              index: 0,
              cPercent: 0.6785509186826066,
            },
            {
              date: '2025-07-14',
              title: 'GROSS PROFIT',
              path: ['GROSS PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [67975.45999999999],
                anomalyScores: [0, 0, 0, 0.872263803844029, 0],
                stats: {
                  mean: 48330.678,
                  variance: 126805687.84233598,
                  stdDev: 11260.80316151277,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 35741.28,
              amtAvg: 35741.28,
              perc: 0.5249,
              percAvg: 0.5249,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 35741.28,
              percent: 0.5249,
              percentAVG: 0.5249,
              cellID: '7b400e74_@_12_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '7b400e74_@_12',
              index: 1,
              cPercent: 0.5248799457222495,
            },
            {
              date: '2025-07-07',
              title: 'GROSS PROFIT',
              path: ['GROSS PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [67975.45999999999],
                anomalyScores: [0, 0, 0, 0.872263803844029, 0],
                stats: {
                  mean: 48330.678,
                  variance: 126805687.84233598,
                  stdDev: 11260.80316151277,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 39187.51999999999,
              amtAvg: 39187.51999999999,
              perc: 0.5596,
              percAvg: 0.5596,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 39187.51999999999,
              percent: 0.5596,
              percentAVG: 0.5596,
              cellID: '7b400e74_@_12_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '7b400e74_@_12',
              index: 2,
              cPercent: 0.5596077043107942,
            },
            {
              date: '2025-06-30',
              title: 'GROSS PROFIT',
              path: ['GROSS PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [67975.45999999999],
                anomalyScores: [0, 0, 0, 0.872263803844029, 0],
                stats: {
                  mean: 48330.678,
                  variance: 126805687.84233598,
                  stdDev: 11260.80316151277,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 67975.45999999999,
              amtAvg: 67975.45999999999,
              perc: 0.7544,
              percAvg: 0.7544,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 67975.45999999999,
              percent: 0.7544,
              percentAVG: 0.7544,
              cellID: '7b400e74_@_12_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '7b400e74_@_12',
              index: 3,
              cPercent: 0.7544050129221851,
            },
            {
              date: '2025-06-23',
              title: 'GROSS PROFIT',
              path: ['GROSS PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [67975.45999999999],
                anomalyScores: [0, 0, 0, 0.872263803844029, 0],
                stats: {
                  mean: 48330.678,
                  variance: 126805687.84233598,
                  stdDev: 11260.80316151277,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 47988.689999999995,
              amtAvg: 47988.689999999995,
              perc: 0.7224,
              percAvg: 0.7224,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 47988.689999999995,
              percent: 0.7224,
              percentAVG: 0.7224,
              cellID: '7b400e74_@_12_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '7b400e74_@_12',
              index: 4,
              cPercent: 0.7223714722464951,
            },
          ],
          anomalies: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
        },
        {
          id: '39d9c4d4_@_13',
          cellID: '39d9c4d4_@_13_-x-_0',
          amountTitle: 'OPERATING EXPENSES',
          refTitle: 'OPERATING EXPENSES',
          percentTitle: '',
          level: 0,
          glCode: null,
          parent: null,
          path: ['OPERATING EXPENSES'],
          display: 'header_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'OPERATING EXPENSES',
              path: ['OPERATING EXPENSES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [74613.1],
                anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
                stats: {
                  mean: 43090.988,
                  variance: 320300857.26885605,
                  stdDev: 17896.951060693442,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 28899.82,
              amtAvg: 30351.52,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 30351.52,
              cellID: '39d9c4d4_@_13_-x-_1',
              baseAmount: 28899.82,
              transactions: 0,
              id: '39d9c4d4_@_13',
              index: 0,
            },
            {
              date: '2025-07-14',
              title: 'OPERATING EXPENSES',
              path: ['OPERATING EXPENSES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [74613.1],
                anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
                stats: {
                  mean: 43090.988,
                  variance: 320300857.26885605,
                  stdDev: 17896.951060693442,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 74613.1,
              amtAvg: 56783.54,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 56783.54,
              cellID: '39d9c4d4_@_13_-x-_2',
              baseAmount: 74613.1,
              transactions: 0,
              id: '39d9c4d4_@_13',
              index: 1,
            },
            {
              date: '2025-07-07',
              title: 'OPERATING EXPENSES',
              path: ['OPERATING EXPENSES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [74613.1],
                anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
                stats: {
                  mean: 43090.988,
                  variance: 320300857.26885605,
                  stdDev: 17896.951060693442,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 51508.119999999995,
              amtAvg: 51508.119999999995,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 51508.119999999995,
              cellID: '39d9c4d4_@_13_-x-_3',
              baseAmount: 51508.119999999995,
              transactions: 0,
              id: '39d9c4d4_@_13',
              index: 2,
            },
            {
              date: '2025-06-30',
              title: 'OPERATING EXPENSES',
              path: ['OPERATING EXPENSES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [74613.1],
                anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
                stats: {
                  mean: 43090.988,
                  variance: 320300857.26885605,
                  stdDev: 17896.951060693442,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 31655.99,
              amtAvg: 37173.28,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 37173.28,
              cellID: '39d9c4d4_@_13_-x-_4',
              baseAmount: 31655.99,
              transactions: 0,
              id: '39d9c4d4_@_13',
              index: 3,
            },
            {
              date: '2025-06-23',
              title: 'OPERATING EXPENSES',
              path: ['OPERATING EXPENSES'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [74613.1],
                anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
                stats: {
                  mean: 43090.988,
                  variance: 320300857.26885605,
                  stdDev: 17896.951060693442,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 28777.91,
              amtAvg: 28777.91,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 28777.91,
              cellID: '39d9c4d4_@_13_-x-_5',
              baseAmount: 28777.91,
              transactions: 0,
              id: '39d9c4d4_@_13',
              index: 4,
            },
          ],
          anomalies: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
        },
        {
          id: '5b0fe671_@_14',
          cellID: '5b0fe671_@_14_-x-_0',
          amountTitle: 'LABOR',
          refTitle: 'LABOR',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: 6000,
          parent: null,
          path: ['LABOR'],
          display: 'header_1',
          children: ['bb2363da_@_14', '143a84db_@_14', 'dacf6533_@_14', '1e9ad256_@_14'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'LABOR',
              path: ['LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '5b0fe671_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '5b0fe671_@_14',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'LABOR',
              path: ['LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '5b0fe671_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '5b0fe671_@_14',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'LABOR',
              path: ['LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '5b0fe671_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '5b0fe671_@_14',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'LABOR',
              path: ['LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '5b0fe671_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '5b0fe671_@_14',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'LABOR',
              path: ['LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '5b0fe671_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '5b0fe671_@_14',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'bb2363da_@_14',
          cellID: 'bb2363da_@_14_-x-_0',
          amountTitle: 'Direct Labor',
          refTitle: 'Direct Labor',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5200,
          parent: '5b0fe671',
          path: ['LABOR', 'Direct Labor'],
          display: 'default',
          children: ['687f4cd2_@_14', '529343c4_@_14', '3c61733f_@_14'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Direct Labor',
              path: ['LABOR', 'Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: 'bb2363da_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'bb2363da_@_14',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Direct Labor',
              path: ['LABOR', 'Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: 'bb2363da_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'bb2363da_@_14',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Direct Labor',
              path: ['LABOR', 'Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'bb2363da_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'bb2363da_@_14',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Direct Labor',
              path: ['LABOR', 'Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'bb2363da_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'bb2363da_@_14',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Direct Labor',
              path: ['LABOR', 'Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'bb2363da_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'bb2363da_@_14',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '687f4cd2_@_14',
          cellID: '687f4cd2_@_14_-x-_0',
          amountTitle: 'Labor Other',
          refTitle: 'Labor Other',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 5205,
          parent: 'bb2363da',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Labor Other',
              path: ['LABOR', 'Direct Labor', 'Labor Other'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 20617.188000000002,
                  variance: 128448599.96581598,
                  stdDev: 11333.516663675753,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 30,
                  variance: 456.4,
                  stdDev: 21.36352030916253,
                },
              },
              trxFlagged: [],
              amount: 13892.95,
              perc: 0.1857,
              percAvg: 0.1857,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15639',
                  num: '6502305',
                  name: 'Samantha Lada',
                  description: 'POD CHECK  Payroll W.E. 07.06.2025',
                  amount: 769.89,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15640',
                  num: '6502320',
                  name: 'Ramirez, Jesus Sarmiento',
                  description: 'CHECK 6502320 Payroll W.E. 07.06.2025',
                  amount: 684.47,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15641',
                  num: '6502308',
                  name: 'Olivia Mandez',
                  description: 'CHECK 6502308 Payroll W.E. 07.06.2025',
                  amount: 678.27,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15642',
                  num: '6502266',
                  name: 'Ramirez, Jesus Sarmiento',
                  description: 'CHECK 6502266 Payroll W.E. 06.29.2025',
                  amount: 606.87,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15643',
                  num: '6502323',
                  name: 'Anthony Sanchez',
                  description: 'CHECK 6502323 Payroll W.E. 07.06.2025',
                  amount: 606.26,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15644',
                  num: '6502285',
                  name: 'Cantillano Cardenas, Lila',
                  description: 'CHECK 6502285 Payroll W.E. 07.06.2025',
                  amount: 329.53,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15645',
                  num: '6502304',
                  name: 'Christopher Intriago',
                  description: 'CHECK 6502304 Payroll W.E. 07.06.2025',
                  amount: 193,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Check',
                  eventId: '15650',
                  num: '6502321',
                  name: 'Manuel Ramirez',
                  description: 'CHECK 6502321 Payroll W.E. 07.06.2025',
                  amount: 362.39,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Check',
                  eventId: '15652',
                  num: '6502358',
                  name: 'Domingo Roman',
                  description: 'POD CHECK Payroll W.E. 07.13.2025',
                  amount: 1511,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Check',
                  eventId: '15654',
                  num: '6502349',
                  name: 'Omar Lopez',
                  description: 'CHECK 6502349 Payroll W.E. 07.13.2025',
                  amount: 588.1,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Check',
                  eventId: '15655',
                  num: '6502355',
                  name: 'Hernandez-Canel, Esteban',
                  description: 'CHECK 6502355 Payroll W.E. 07.13.2025',
                  amount: 569.02,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Check',
                  eventId: '15656',
                  num: '6502354',
                  name: 'Cruz Hernandez, Pedro',
                  description: 'CHECK 6502354 Payroll W.E. 07.13.2025',
                  amount: 494.15,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15635',
                  num: 'Payroll Accrual 07.27',
                  name: '',
                  description: 'Other',
                  amount: 6500,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.1857,
              percentAVG: 0.1857,
              cellID: '687f4cd2_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 13,
              id: '687f4cd2_@_14',
              index: 0,
              cPercent: 0.18571694779855177,
            },
            {
              date: '2025-07-14',
              title: 'Labor Other',
              path: ['LABOR', 'Direct Labor', 'Labor Other'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 20617.188000000002,
                  variance: 128448599.96581598,
                  stdDev: 11333.516663675753,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 30,
                  variance: 456.4,
                  stdDev: 21.36352030916253,
                },
              },
              trxFlagged: [],
              amount: 28890.19,
              perc: 0.4243,
              percAvg: 0.4243,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15430',
                  num: '6502230',
                  name: 'Cantillano Cardenas, Lila',
                  description: 'CHECK 6502230 W.E. 06.29.2025',
                  amount: 85.04,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15431',
                  num: '6502244',
                  name: 'Christopher Intriago',
                  description: 'CHECK 6502244 W.E. 06.29.2025',
                  amount: 141.3,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15432',
                  num: '6502226',
                  name: 'Reynaldo Cortes Sanchoz',
                  description: 'CHECK 6502226 W.E. 06.29.2025',
                  amount: 276.43,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15433',
                  num: '6502278',
                  name: 'Ivonne Olarte',
                  description: 'CHECK 6502278',
                  amount: 370,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15434',
                  num: '6502228',
                  name: 'ASSADOURIAN, BERDJ G',
                  description: 'CHECK 6502228 W.E. 06.29.2025',
                  amount: 542.77,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15435',
                  num: '6502260',
                  name: 'Sanchez, Anthony',
                  description: 'CHECK 6502260 W.E. 06.29.2025',
                  amount: 666.9,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Check',
                  eventId: '15451',
                  num: '6502193',
                  name: 'Dunn, Kaitlyn',
                  description: 'CHECK 6502193 W.E. 06.22.2025',
                  amount: 207.62,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Check',
                  eventId: '15452',
                  num: '6502253',
                  name: 'Perdikos, Eleni',
                  description: 'CHECK 6502253 W.E. 06.29.2025',
                  amount: 391.66,
                },
                {
                  txnDate: '2025-07-15',
                  type: 'Check',
                  eventId: '15453',
                  num: '6502267',
                  name: 'Manuel Ramirez',
                  description: 'CHECK 6502267',
                  amount: 400.63,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15458',
                  num: '6502255',
                  name: 'Arielle Pizarro',
                  description: 'CHECK 6502255 W.E. 06.29.2025',
                  amount: 142.25,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15459',
                  num: '6502270',
                  name: 'Ana Garzon',
                  description: 'CHECK 6502270  W.E. 06.23.2025',
                  amount: 208,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15460',
                  num: '6502316',
                  name: 'Jessica Polak',
                  description: 'CHECK 6502316 W.E. 07.06.2025',
                  amount: 267.75,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15461',
                  num: '6502294',
                  name: 'Carlos Dominguez',
                  description: "CHECK 6502294 Brandon's Donuts",
                  amount: 309.6,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15462',
                  num: '6502303',
                  name: 'Hernandez-Canel, Esteban',
                  description: 'CHECK 6502303 W.E. 07.06.2025',
                  amount: 497.4,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15463',
                  num: '6502281',
                  name: 'Omar Lopez',
                  description: 'CHECK 6502281 W.E. 07.06.2025',
                  amount: 508.73,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15464',
                  num: '6502293',
                  name: 'Carlos Dominguez',
                  description: 'CHECK 6502293 W.E. 07.06.2025',
                  amount: 607.32,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15465',
                  num: '6502291',
                  name: 'Cruz Hernandez, Pedro',
                  description: 'CHECK 6502291 W.E. 07.06.2025',
                  amount: 621.17,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15466',
                  num: '6502306',
                  name: 'Luna, Nelson',
                  description: 'CHECK 6502306 W.E. 07.06.2025',
                  amount: 629.47,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15471',
                  num: '6502254',
                  name: 'Allanah Pizarro.',
                  description: 'CHECK 6502254 W.E. 06.29.2025',
                  amount: 78.51,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15472',
                  num: '6502312',
                  name: 'Marina Pasek',
                  description: 'CHECK 6502312 W.E. 07.06.2025',
                  amount: 157.94,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15473',
                  num: '6502277',
                  name: 'Junior Santiago',
                  description: 'CHECK 6502277',
                  amount: 170.39,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15474',
                  num: '6502301',
                  name: 'Lina Granados',
                  description: 'CHECK 6502301 W.E. 07.06.2025',
                  amount: 317.08,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15475',
                  num: '6502302',
                  name: 'Javier Hernandez',
                  description: 'CHECK 6502302 W.E. 07.06.2025',
                  amount: 345.45,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15476',
                  num: '6502327',
                  name: 'Carac, Israel',
                  description: 'CHECK 6502327 W.E. 07.06.2025',
                  amount: 371.36,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15477',
                  num: '6502314',
                  name: 'Allanah Pizarro.',
                  description: 'CHECK 6502314 W.E. 07.06.2025',
                  amount: 410.26,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15478',
                  num: '6502233',
                  name: 'Isabella Devine',
                  description: 'CHECK 6502233 W.E. 07.06.2025',
                  amount: 445.8,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15479',
                  num: '6502307',
                  name: 'Alexis Martinez',
                  description: 'CHECK 6502307 W.E. 07.06.2025',
                  amount: 478.68,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15480',
                  num: '6502290',
                  name: 'Reynaldo Cortes Sanchoz',
                  description: 'CHECK 6502290 W.E. 07.06.2025',
                  amount: 514.73,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15481',
                  num: '6502284',
                  name: 'Jason Canas',
                  description: 'CHECK 6502284 W.E. 07.06.2025',
                  amount: 518.12,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15482',
                  num: '6502232',
                  name: 'Conserve, Mercidieu',
                  description: 'POD CHECK W.E. 06.29.2025',
                  amount: 535.96,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15483',
                  num: '6502283',
                  name: 'ASSADOURIAN, BERDJ G',
                  description: 'CHECK 6502283 W.E. 07.06.2025',
                  amount: 576.38,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15484',
                  num: '6502184',
                  name: 'Conserve, Mercidieu',
                  description: 'POD CHECK W.E..06.22.2025',
                  amount: 616.17,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15485',
                  num: '6502298',
                  name: 'Franco Ramos, Luis David',
                  description: 'CHECK 6502298 W.E. 07.06.2025',
                  amount: 624.92,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15486',
                  num: '6502259',
                  name: 'Rosemarie Rosado',
                  description: 'CHECK 6502259 W.E. 06.29.2025',
                  amount: 684.15,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15487',
                  num: '6502299',
                  name: 'Juliana Garcia Escobar',
                  description: 'CHECK 6502299 W.E. 07.06.2025',
                  amount: 685.44,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15488',
                  num: '6502300',
                  name: 'Ana Maria Garzon',
                  description: 'CHECK 6502300 W.E. 07.06.2025',
                  amount: 748.35,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15489',
                  num: '6502289',
                  name: 'Efren Cortes Sanchez',
                  description: 'CHECK 6502289 W.E. 07.06.2025',
                  amount: 757.68,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15490',
                  num: '6502297',
                  name: 'Fonto, Laurynn',
                  description: 'CHECK 6502297 W.E. 07.06.2025',
                  amount: 823.27,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Check',
                  eventId: '15491',
                  num: '6502295',
                  name: 'Hakim Eatman',
                  description: 'CHECK 6502295 W.E. 07.06.2025',
                  amount: 966.36,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15500',
                  num: '6502310',
                  name: 'Frida Monroy',
                  description: 'CHECK 6502310 W.E. 07.06.2025',
                  amount: 202.73,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15501',
                  num: '6502318',
                  name: 'Carlos Ramirez',
                  description: 'CHECK 6502318',
                  amount: 304.03,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15502',
                  num: '6502309',
                  name: 'Jephthah Michel',
                  description: 'POD CHECK W.E. 07.06.2025',
                  amount: 403.1,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15503',
                  num: '6502292',
                  name: 'Isabella Devine',
                  description: 'CHECK 6502292 W.E. 07.06.2025',
                  amount: 405.95,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15504',
                  num: '6502313',
                  name: 'Perdikos, Eleni',
                  description: 'CHECK 6502313 W.E. 07.06.2025',
                  amount: 406.59,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15505',
                  num: '6502287',
                  name: 'Geoconda Castro',
                  description: 'CHECK 6502287 W.E. 07.06.2025',
                  amount: 408.55,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15507',
                  num: '6502276',
                  name: 'Janetydy Huesca.',
                  description: 'CHECK 6502276',
                  amount: 545,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15509',
                  num: '6502324',
                  name: 'Junior Santiago',
                  description: 'CHECK 6502324 W.E. 07.06.2025',
                  amount: 571.25,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15510',
                  num: '6502296',
                  name: 'Smicker Figueroa',
                  description: 'CHECK 6502296 W.E. 07.06.2025',
                  amount: 844.04,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15511',
                  num: '6502311',
                  name: 'Ivonne Olarte',
                  description: 'CHECK 6502311 W.E. 07.06.2025',
                  amount: 932.87,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15513',
                  num: '6502317',
                  name: 'Mikhailson Pollas',
                  description: 'CHECK 6502317 W.E. 07.06.2025',
                  amount: 1044.91,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15515',
                  num: '6502325',
                  name: 'Roberto Santiago.',
                  description: 'CHECK 6502325 W.E. 07.06.2025',
                  amount: 1120.13,
                },
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15355',
                  num: 'Payroll Accrual 07.20',
                  name: '',
                  description: 'Other',
                  amount: 4000,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.4243,
              percentAVG: 0.4243,
              cellID: '687f4cd2_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 52,
              id: '687f4cd2_@_14',
              index: 1,
              cPercent: 0.42426799933033943,
            },
            {
              date: '2025-07-07',
              title: 'Labor Other',
              path: ['LABOR', 'Direct Labor', 'Labor Other'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 20617.188000000002,
                  variance: 128448599.96581598,
                  stdDev: 11333.516663675753,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 30,
                  variance: 456.4,
                  stdDev: 21.36352030916253,
                },
              },
              trxFlagged: [],
              amount: 37586.56,
              perc: 0.5367,
              percAvg: 0.5367,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15350',
                  num: '6502189',
                  name: 'Rony Normil',
                  description: 'CHECK 6502189 W.E. 6.22.25',
                  amount: 1337.83,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15351',
                  num: '6502160',
                  name: 'Ivonne Olarte',
                  description: 'CHECK 6502160 W.E. 6.22.25',
                  amount: 1054.65,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15352',
                  num: '6502178',
                  name: 'Mikhailson Pollas',
                  description: 'CHECK 6502178 W.E. 6.22.25',
                  amount: 1044.91,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15358',
                  num: '6502152',
                  name: 'Omar Lopez',
                  description: 'CHECK 6502152 Brandons Donuts',
                  amount: 590.89,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15359',
                  num: '6502158',
                  name: 'Isabella Devine',
                  description: 'CHECK 6502158 W.E. 06.22.2025',
                  amount: 146.5,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15360',
                  num: '6502198',
                  name: 'Jessica Polak',
                  description: 'CHECK 6502198 W.E. 06.22.2025',
                  amount: 252.85,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15361',
                  num: '6502174',
                  name: 'Lina Granados',
                  description: 'CHECK 6502174 W.E. 06.22.2025',
                  amount: 262.86,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15362',
                  num: '6502153',
                  name: 'Omar Lopez',
                  description: 'CHECK 6502153',
                  amount: 300,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15363',
                  num: '6502196',
                  name: 'Javier Hernandez',
                  description: 'CHECK 6502196 W.E. 06.22.2025',
                  amount: 313.15,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15364',
                  num: '6502170',
                  name: 'Christopher Intriago',
                  description: 'CHECK 6502170 W.E. 06.22.2025',
                  amount: 340.34,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15365',
                  num: '6502191',
                  name: 'Joseph, Fiona',
                  description: 'CHECK 6502191 W.E. 06.22.2025',
                  amount: 344.05,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15366',
                  num: '6502154',
                  name: 'Juliana Garcia Escobar',
                  description: 'CHECK 6502154 W.E. 06.22.2025',
                  amount: 352.55,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15367',
                  num: '6502159',
                  name: 'Geoconda Castro',
                  description: 'CHECK 6502159 W.E. 06.22.2025',
                  amount: 367.8,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15368',
                  num: '6502186',
                  name: 'Tocto, Domenica',
                  description: 'CHECK 6502186 W.E. 06.22.2025',
                  amount: 388.33,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15369',
                  num: '6502194',
                  name: 'Rosemarie Rosado',
                  description: 'CHECK 6502194 W.E. 06.22.2025',
                  amount: 401.65,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15370',
                  num: '6502179',
                  name: 'Marina Pasek',
                  description: 'CHECK 6502179 W.E. 06.22.2025',
                  amount: 423.02,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15371',
                  num: '6502171',
                  name: 'Fonto, Laurynn',
                  description: 'CHECK 6502171',
                  amount: 495.61,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15372',
                  num: '6502211',
                  name: 'Smicker Figueroa',
                  description: 'CHECK 6502211 W.E. 06.22.2025',
                  amount: 552.98,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15373',
                  num: '6502156',
                  name: 'Luis David Franco Ramos',
                  description: 'CHECK 6502156 W.E. 06.22.2025',
                  amount: 557.66,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15374',
                  num: '6502187',
                  name: 'ASSADOURIAN, BERDJ G',
                  description: 'CHECK 6502187 W.E. 06.22.2025',
                  amount: 564.07,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15375',
                  num: '6502188',
                  name: 'Samantha Lada',
                  description: 'POD CHECK W.E. 06.22.2025',
                  amount: 619.92,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15376',
                  num: '6502197',
                  name: 'Jephthah Michel',
                  description: 'POD CHECK W.E. 06.22.2025',
                  amount: 736.22,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15377',
                  num: '6502199',
                  name: 'Hakim Eatman',
                  description: 'CHECK 6502199 W.E. 06.22.2025',
                  amount: 778.89,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Check',
                  eventId: '15391',
                  num: '6502214',
                  name: 'Manuel Ramirez',
                  description: 'CHECK 6502214',
                  amount: 423.19,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15392',
                  num: '6502256',
                  name: 'Polak, Jessica',
                  description: 'CHECK 6502256 W.E. 06.29.2025',
                  amount: 303.02,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15393',
                  num: '6502252',
                  name: 'Marina Pasek',
                  description: 'CHECK 6502252',
                  amount: 332.68,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15394',
                  num: '6502243',
                  name: 'Javier Hernandez',
                  description: 'CHECK 6502243 W.E. 06.29.2025',
                  amount: 349.53,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15395',
                  num: '6502248',
                  name: 'Olivia Mandez',
                  description: 'CHECK 6502248 W.E. 06.29.2025',
                  amount: 366.02,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15396',
                  num: '6502218',
                  name: 'Omar Lopez',
                  description: 'CHECK 6502218 Brandons Donuts',
                  amount: 369.33,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15397',
                  num: '6502231',
                  name: 'Carac, Israel',
                  description: 'CHECK 6502231 W.E. 06.29.2025',
                  amount: 390.55,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15398',
                  num: '6502239',
                  name: 'Franco Ramos, Luis David',
                  description: 'CHECK 6502239 W.E. 06.29.2025',
                  amount: 460.45,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15399',
                  num: '6502247',
                  name: 'Luna, Nelson',
                  description: 'CHECK 6502247 W.E. 06.29.2025',
                  amount: 479.84,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15400',
                  num: '6502269',
                  name: 'Alexis Martinez',
                  description: 'CHECK 6502269 W.E. 06.29.2025',
                  amount: 491.13,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15401',
                  num: '6502229',
                  name: 'Jason Canas',
                  description: 'CHECK 6502229 W.E. 06.29.2025',
                  amount: 499.29,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15402',
                  num: '6502225',
                  name: 'Cruz Hernandez, Pedro',
                  description: 'CHECK 6502225 W.E. 06.29.2025',
                  amount: 604.74,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15403',
                  num: '6502223',
                  name: 'Hernandez-Canel, Esteban',
                  description: 'CHECK 6502223 W.E. 06.29.2025',
                  amount: 611.68,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15404',
                  num: '6502236',
                  name: 'Hakim Eatman',
                  description: 'CHECK 6502236 W.E. 06.29.2025',
                  amount: 611.8,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15405',
                  num: '6502222',
                  name: 'Efren Cortes Sanchez',
                  description: 'CHECK 6502222 W.E. 06.29.2025',
                  amount: 750.35,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15407',
                  num: '6502257',
                  name: 'Mikhailson Pollas',
                  description: 'CHECK 6502257 W.E. 06.29.2025',
                  amount: 1044.91,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15408',
                  num: '6502250',
                  name: 'Rony Normil',
                  description: 'CHECK 6502250 W.E. 06.29.2025',
                  amount: 1337.83,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15411',
                  num: '6502168',
                  name: 'Manon, Carolina',
                  description: 'CHECK 6502168 W.E. 06.22.2025',
                  amount: 166.98,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15412',
                  num: '6502265',
                  name: 'Carlos Dominguez',
                  description: 'CHECK 6502265 W.E. 06.29.2025',
                  amount: 314,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15413',
                  num: '6502240',
                  name: 'Juliana Garcia Escobar',
                  description: 'CHECK 6502240 W.E. 06.29.2025',
                  amount: 359.89,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15414',
                  num: '6502234',
                  name: 'Geoconda Castro',
                  description: 'CHECK 6502234 W.E. 06.29.2025',
                  amount: 399.03,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15415',
                  num: '6502237',
                  name: 'Smicker Figueroa',
                  description: 'CHECK 6502237 W.E. 06.29.2025',
                  amount: 527.82,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15416',
                  num: '6502264',
                  name: 'Carlos Dominguez',
                  description: 'CHECK 6502264 W.E. 06.29.2025',
                  amount: 530,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15417',
                  num: '6502275',
                  name: 'Janetydy Huesca.',
                  description: 'CHECK 6502275',
                  amount: 540,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15418',
                  num: '6502245',
                  name: 'Joseph, Fiona',
                  description: 'CHECK 6502245 W.E. 06.29.2025',
                  amount: 559.92,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15419',
                  num: '6502242',
                  name: 'Lina Granados',
                  description: 'CHECK 6502242 W.E. 06.29.2025',
                  amount: 564.42,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15420',
                  num: '6502140',
                  name: 'Janetydy Huesca.',
                  description: 'CHECK 6502140 W.E. 06.29.2025',
                  amount: 580,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15421',
                  num: '6502246',
                  name: 'Samantha Lada',
                  description: 'POD CHECK W.E. 06.29.2025',
                  amount: 654.53,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15422',
                  num: '6502238',
                  name: 'Fonto, Laurynn',
                  description: 'CHECK 6502238 W.E. 06.29.2025',
                  amount: 707.24,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15423',
                  num: '6502251',
                  name: 'Ivonne Olarte',
                  description: 'CHECK 6502251 W.E. 06.29.2025',
                  amount: 761.38,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15424',
                  num: '6502227',
                  name: 'Carlos Ramirez',
                  description: 'CHECK 6502227 W.E. 06.29.2025',
                  amount: 767.84,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15425',
                  num: '6502249',
                  name: 'Jephthah Michel',
                  description: 'POD CHECK W.E. 06.29.2025',
                  amount: 825.33,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15427',
                  num: '6502268',
                  name: 'Roberto Santiago.',
                  description: 'CHECK 6502268 W.E. 06.29.2025',
                  amount: 1120.13,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Check',
                  eventId: '15429',
                  num: '6502261',
                  name: 'Ibrahim Sidibay',
                  description: 'CHECK 6502261 W.E. 06.29.2025',
                  amount: 54.98,
                },
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15628',
                  num: 'PR 07.07. to 07.13',
                  name: '',
                  description: 'Other',
                  amount: 6500,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.5367,
              percentAVG: 0.5367,
              cellID: '687f4cd2_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 58,
              id: '687f4cd2_@_14',
              index: 2,
              cPercent: 0.5367455902935406,
            },
            {
              date: '2025-06-30',
              title: 'Labor Other',
              path: ['LABOR', 'Direct Labor', 'Labor Other'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 20617.188000000002,
                  variance: 128448599.96581598,
                  stdDev: 11333.516663675753,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 30,
                  variance: 456.4,
                  stdDev: 21.36352030916253,
                },
              },
              trxFlagged: [],
              amount: 17238.8,
              perc: 0.1913,
              percAvg: 0.1913,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Check',
                  eventId: '14883',
                  num: '6502139',
                  name: 'Janetydy Huesca.',
                  description: 'CHECK 6502139 Payroll 06.15.2025',
                  amount: 580,
                },
                {
                  txnDate: '2025-06-30',
                  type: 'Check',
                  eventId: '14884',
                  num: '6502137',
                  name: 'Ivonne Olarte',
                  description: 'CHECK 6502137',
                  amount: 356.2,
                },
                {
                  txnDate: '2025-06-30',
                  type: 'Check',
                  eventId: '14885',
                  num: '6502136',
                  name: 'Javier Hernandez',
                  description: 'CHECK 6502136',
                  amount: 301.48,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Check',
                  eventId: '15275',
                  num: '6502143',
                  name: '',
                  description: '',
                  amount: 59.76,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Check',
                  eventId: '15282',
                  num: '6502162',
                  name: 'Carlos Ramirez',
                  description: 'CHECK 6502162',
                  amount: 677.74,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Check',
                  eventId: '15283',
                  num: '6502155',
                  name: 'Luna, Nelson',
                  description: 'CHECK 6502155',
                  amount: 583.78,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Check',
                  eventId: '15284',
                  num: '6502183',
                  name: 'Carlos Dominguez',
                  description: 'CHECK 6502183 WE 6.22.25 not found in Report',
                  amount: 542.58,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Check',
                  eventId: '15285',
                  num: '6502166',
                  name: 'Hernandez-Canel, Esteban',
                  description: 'CHECK 6502166 WE 6.22.25 not found in Report',
                  amount: 511.02,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15330',
                  num: '6502192',
                  name: 'Alexandre, Wood Loudie',
                  description: 'POD CHECK W.E. 6.22.25',
                  amount: 703.44,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15331',
                  num: '6502157',
                  name: 'Efren Cortes Sanchez',
                  description: 'CHECK 6502157 W.E. 6.22.25',
                  amount: 755.76,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15332',
                  num: '6502182',
                  name: 'Roberto Santiago.',
                  description: 'CHECK 6502182 W.E. 6.22.25',
                  amount: 1120.13,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15336',
                  num: '6502167',
                  name: 'Olivia Mandez',
                  description: 'CHECK 6502167 W.E. 6.22.25',
                  amount: 658.11,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15337',
                  num: '6502190',
                  name: 'Ramirez, Jesus Sarmiento',
                  description: 'CHECK 6502190 W.E. 6.22.25',
                  amount: 626.79,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15338',
                  num: '6502164',
                  name: 'Cruz Hernandez, Pedro',
                  description: 'CHECK 6502164 W.E. 6.22.25',
                  amount: 588.3,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15339',
                  num: '6502180',
                  name: 'Alexis Martinez',
                  description: 'CHECK 6502180 W.E. 6.22.25',
                  amount: 506.92,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15340',
                  num: '6502169',
                  name: 'Perdikos, Eleni',
                  description: 'CHECK 6502169 W.E. 6.22.25',
                  amount: 486.53,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15341',
                  num: '6502175',
                  name: 'Sanchez, Anthony',
                  description: 'CHECK 6502175 W.E. 6.22.25',
                  amount: 377.91,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15342',
                  num: '6502173',
                  name: 'Jason Canas',
                  description: 'CHECK 6502173 W.E. 6.22.25',
                  amount: 362.53,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15343',
                  num: '6502185',
                  name: 'Reynaldo Cortes Sanchoz',
                  description: 'CHECK 6502185 W.E. 6.22.25',
                  amount: 305.7,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15344',
                  num: '6502177',
                  name: 'Ibrahim Sidibay',
                  description: 'CHECK 6502177 W.E. 6.22.25',
                  amount: 262.54,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15345',
                  num: '6502163',
                  name: 'Frida Monroy',
                  description: 'CHECK 6502163 W.E. 6.22.25',
                  amount: 196.84,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15346',
                  num: '6502161',
                  name: 'Carac, Israel',
                  description: 'CHECK 6502161 W.E. 6.22.25',
                  amount: 174.74,
                },
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '15268',
                  num: 'PR 06.30 to 07.06',
                  name: '',
                  description: 'Other',
                  amount: 6500,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.1913,
              percentAVG: 0.1913,
              cellID: '687f4cd2_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 23,
              id: '687f4cd2_@_14',
              index: 3,
              cPercent: 0.19131958999266743,
            },
            {
              date: '2025-06-23',
              title: 'Labor Other',
              path: ['LABOR', 'Direct Labor', 'Labor Other'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 20617.188000000002,
                  variance: 128448599.96581598,
                  stdDev: 11333.516663675753,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 30,
                  variance: 456.4,
                  stdDev: 21.36352030916253,
                },
              },
              trxFlagged: [],
              amount: 5477.44,
              perc: 0.0825,
              percAvg: 0.0825,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Check',
                  eventId: '14674',
                  num: '6502081',
                  name: 'Anthony Sanchez',
                  description: 'CHECK 6502081',
                  amount: 489.65,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Check',
                  eventId: '14680',
                  num: '6502083',
                  name: 'Isabella Devine',
                  description: 'CHECK 6502083 06/02 - 06/08',
                  amount: 128.64,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Check',
                  eventId: '14858',
                  num: '6502091',
                  name: 'Omar Lopez',
                  description: 'CHECK 6502091',
                  amount: 559.15,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '15265',
                  num: 'PR 06.23 to 06.29',
                  name: '',
                  description: 'Other',
                  amount: 4300,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0825,
              percentAVG: 0.0825,
              cellID: '687f4cd2_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 4,
              id: '687f4cd2_@_14',
              index: 4,
              cPercent: 0.08245164427163655,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
        },
        {
          id: '529343c4_@_14',
          cellID: '529343c4_@_14_-x-_0',
          amountTitle: 'Labor, Management',
          refTitle: 'Labor, Management',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 5210,
          parent: 'bb2363da',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Labor, Management',
              path: ['LABOR', 'Direct Labor', 'Labor, Management'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [6486.95],
                anomalyScores: [0, 0.939954670660601, 0, 0, 0],
                stats: {
                  mean: 3210.0299999999997,
                  variance: 3038490.3835999994,
                  stdDev: 1743.1266114657303,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2244.1,
              perc: 0.03,
              percAvg: 0.03,
              dataRows: [
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15635',
                  num: 'Payroll Accrual 07.27',
                  name: '',
                  description: 'Management',
                  amount: 2244.1,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.03,
              percentAVG: 0.03,
              cellID: '529343c4_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '529343c4_@_14',
              index: 0,
              cPercent: 0.029998481427971024,
            },
            {
              date: '2025-07-14',
              title: 'Labor, Management',
              path: ['LABOR', 'Direct Labor', 'Labor, Management'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [6486.95],
                anomalyScores: [0, 0.939954670660601, 0, 0, 0],
                stats: {
                  mean: 3210.0299999999997,
                  variance: 3038490.3835999994,
                  stdDev: 1743.1266114657303,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 6486.95,
              perc: 0.0953,
              percAvg: 0.0953,
              dataRows: [
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15355',
                  num: 'Payroll Accrual 07.20',
                  name: '',
                  description: 'Management',
                  amount: 6486.95,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0953,
              percentAVG: 0.0953,
              cellID: '529343c4_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '529343c4_@_14',
              index: 1,
              cPercent: 0.09526435437966817,
            },
            {
              date: '2025-07-07',
              title: 'Labor, Management',
              path: ['LABOR', 'Direct Labor', 'Labor, Management'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [6486.95],
                anomalyScores: [0, 0.939954670660601, 0, 0, 0],
                stats: {
                  mean: 3210.0299999999997,
                  variance: 3038490.3835999994,
                  stdDev: 1743.1266114657303,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2244.1,
              perc: 0.032,
              percAvg: 0.032,
              dataRows: [
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15628',
                  num: 'PR 07.07. to 07.13',
                  name: '',
                  description: 'Management',
                  amount: 2244.1,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.032,
              percentAVG: 0.032,
              cellID: '529343c4_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '529343c4_@_14',
              index: 2,
              cPercent: 0.03204631600172334,
            },
            {
              date: '2025-06-30',
              title: 'Labor, Management',
              path: ['LABOR', 'Direct Labor', 'Labor, Management'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [6486.95],
                anomalyScores: [0, 0.939954670660601, 0, 0, 0],
                stats: {
                  mean: 3210.0299999999997,
                  variance: 3038490.3835999994,
                  stdDev: 1743.1266114657303,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 3455,
              perc: 0.0383,
              percAvg: 0.0383,
              dataRows: [
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '15268',
                  num: 'PR 06.30 to 07.06',
                  name: '',
                  description: 'Management',
                  amount: 3455,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0383,
              percentAVG: 0.0383,
              cellID: '529343c4_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '529343c4_@_14',
              index: 3,
              cPercent: 0.03834426894126424,
            },
            {
              date: '2025-06-23',
              title: 'Labor, Management',
              path: ['LABOR', 'Direct Labor', 'Labor, Management'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [6486.95],
                anomalyScores: [0, 0.939954670660601, 0, 0, 0],
                stats: {
                  mean: 3210.0299999999997,
                  variance: 3038490.3835999994,
                  stdDev: 1743.1266114657303,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1620,
              perc: 0.0244,
              percAvg: 0.0244,
              dataRows: [
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '15265',
                  num: 'PR 06.23 to 06.29',
                  name: '',
                  description: 'Management',
                  amount: 1620,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0244,
              percentAVG: 0.0244,
              cellID: '529343c4_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '529343c4_@_14',
              index: 4,
              cPercent: 0.024385783088459432,
            },
          ],
          anomalies: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
        },
        {
          id: '3c61733f_@_14',
          cellID: '3c61733f_@_14_-x-_0',
          amountTitle: 'Labor, BOH',
          refTitle: 'Labor, BOH',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 5215,
          parent: 'bb2363da',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Labor, BOH',
              path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [5121.55],
                anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
                stats: {
                  mean: 2393.5420000000004,
                  variance: 1860506.9120160001,
                  stdDev: 1364.0040000000001,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1711.54,
              perc: 0.0229,
              percAvg: 0.0229,
              dataRows: [
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15635',
                  num: 'Payroll Accrual 07.27',
                  name: '',
                  description: 'BOH',
                  amount: 1711.54,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0.0229,
              percentAVG: 0.0229,
              cellID: '3c61733f_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '3c61733f_@_14',
              index: 0,
              cPercent: 0.0228793729794704,
            },
            {
              date: '2025-07-14',
              title: 'Labor, BOH',
              path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [5121.55],
                anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
                stats: {
                  mean: 2393.5420000000004,
                  variance: 1860506.9120160001,
                  stdDev: 1364.0040000000001,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 5121.55,
              perc: 0.0752,
              percAvg: 0.0752,
              dataRows: [
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15355',
                  num: 'Payroll Accrual 07.20',
                  name: '',
                  description: 'BOH',
                  amount: 5121.55,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.0752,
              percentAVG: 0.0752,
              cellID: '3c61733f_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '3c61733f_@_14',
              index: 1,
              cPercent: 0.07521272002608152,
            },
            {
              date: '2025-07-07',
              title: 'Labor, BOH',
              path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [5121.55],
                anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
                stats: {
                  mean: 2393.5420000000004,
                  variance: 1860506.9120160001,
                  stdDev: 1364.0040000000001,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1711.54,
              perc: 0.0244,
              percAvg: 0.0244,
              dataRows: [
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15628',
                  num: 'PR 07.07. to 07.13',
                  name: '',
                  description: 'BOH',
                  amount: 1711.54,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0244,
              percentAVG: 0.0244,
              cellID: '3c61733f_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '3c61733f_@_14',
              index: 2,
              cPercent: 0.024441224406037864,
            },
            {
              date: '2025-06-30',
              title: 'Labor, BOH',
              path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [5121.55],
                anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
                stats: {
                  mean: 2393.5420000000004,
                  variance: 1860506.9120160001,
                  stdDev: 1364.0040000000001,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1711.54,
              perc: 0.019,
              percAvg: 0.019,
              dataRows: [
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '15268',
                  num: 'PR 06.30 to 07.06',
                  name: '',
                  description: 'BOH',
                  amount: 1711.54,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.019,
              percentAVG: 0.019,
              cellID: '3c61733f_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '3c61733f_@_14',
              index: 3,
              cPercent: 0.01899500725433615,
            },
            {
              date: '2025-06-23',
              title: 'Labor, BOH',
              path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [5121.55],
                anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
                stats: {
                  mean: 2393.5420000000004,
                  variance: 1860506.9120160001,
                  stdDev: 1364.0040000000001,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1711.54,
              perc: 0.0258,
              percAvg: 0.0258,
              dataRows: [
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '15265',
                  num: 'PR 06.23 to 06.29',
                  name: '',
                  description: 'BOH',
                  amount: 1711.54,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0258,
              percentAVG: 0.0258,
              cellID: '3c61733f_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '3c61733f_@_14',
              index: 4,
              cPercent: 0.025763730362482626,
            },
          ],
          anomalies: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
        },
        {
          id: '143a84db_@_14',
          cellID: '143a84db_@_14_-x-_0',
          amountTitle: 'Total Direct Labor',
          refTitle: 'Total Direct Labor',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '5b0fe671',
          path: ['LABOR', 'Total Direct Labor'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Direct Labor',
              path: ['LABOR', 'Total Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 26220.76,
                  variance: 165285310.36244,
                  stdDev: 12856.33347274564,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 17848.59,
              amtAvg: 17848.59,
              perc: 0.2386,
              percAvg: 0.2386,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 17848.59,
              percent: 0.2386,
              percentAVG: 0.2386,
              cellID: '143a84db_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '143a84db_@_14',
              index: 0,
              cPercent: 0.2385948022059932,
            },
            {
              date: '2025-07-14',
              title: 'Total Direct Labor',
              path: ['LABOR', 'Total Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 26220.76,
                  variance: 165285310.36244,
                  stdDev: 12856.33347274564,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 40498.69,
              amtAvg: 40498.69,
              perc: 0.5947,
              percAvg: 0.5947,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 40498.69,
              percent: 0.5947,
              percentAVG: 0.5947,
              cellID: '143a84db_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '143a84db_@_14',
              index: 1,
              cPercent: 0.5947450737360892,
            },
            {
              date: '2025-07-07',
              title: 'Total Direct Labor',
              path: ['LABOR', 'Total Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 26220.76,
                  variance: 165285310.36244,
                  stdDev: 12856.33347274564,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 41542.2,
              amtAvg: 41542.2,
              perc: 0.5932,
              percAvg: 0.5932,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 41542.2,
              percent: 0.5932,
              percentAVG: 0.5932,
              cellID: '143a84db_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '143a84db_@_14',
              index: 2,
              cPercent: 0.5932331307013019,
            },
            {
              date: '2025-06-30',
              title: 'Total Direct Labor',
              path: ['LABOR', 'Total Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 26220.76,
                  variance: 165285310.36244,
                  stdDev: 12856.33347274564,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 22405.34,
              amtAvg: 22405.34,
              perc: 0.2487,
              percAvg: 0.2487,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 22405.34,
              percent: 0.2487,
              percentAVG: 0.2487,
              cellID: '143a84db_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '143a84db_@_14',
              index: 3,
              cPercent: 0.24865886618826782,
            },
            {
              date: '2025-06-23',
              title: 'Total Direct Labor',
              path: ['LABOR', 'Total Direct Labor'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 26220.76,
                  variance: 165285310.36244,
                  stdDev: 12856.33347274564,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 8808.98,
              amtAvg: 8808.98,
              perc: 0.1326,
              percAvg: 0.1326,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 8808.98,
              percent: 0.1326,
              percentAVG: 0.1326,
              cellID: '143a84db_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '143a84db_@_14',
              index: 4,
              cPercent: 0.1326011577225786,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
        },
        {
          id: 'dacf6533_@_14',
          cellID: 'dacf6533_@_14_-x-_0',
          amountTitle: 'Labor Related Expenses',
          refTitle: 'Labor Related Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 5300,
          parent: '5b0fe671',
          path: ['LABOR', 'Labor Related Expenses'],
          display: 'default',
          children: ['7a82e4de_@_14', 'bbc14e9c_@_14', '416bc276_@_14', 'c12aec10_@_14'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Labor Related Expenses',
              path: ['LABOR', 'Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: 'dacf6533_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'dacf6533_@_14',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Labor Related Expenses',
              path: ['LABOR', 'Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: 'dacf6533_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'dacf6533_@_14',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Labor Related Expenses',
              path: ['LABOR', 'Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'dacf6533_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'dacf6533_@_14',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Labor Related Expenses',
              path: ['LABOR', 'Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'dacf6533_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'dacf6533_@_14',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Labor Related Expenses',
              path: ['LABOR', 'Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'dacf6533_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'dacf6533_@_14',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '7a82e4de_@_14',
          cellID: '7a82e4de_@_14_-x-_0',
          amountTitle: 'Commission/Bonus/Incentives',
          refTitle: 'Commission/Bonus/Incentives',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 5310,
          parent: 'dacf6533',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Commission/Bonus/Incentives',
              path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '7a82e4de_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '7a82e4de_@_14',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Commission/Bonus/Incentives',
              path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '7a82e4de_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '7a82e4de_@_14',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Commission/Bonus/Incentives',
              path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 271,
              perc: 0.0039,
              percAvg: 0.0039,
              dataRows: [
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15628',
                  num: 'PR 07.07. to 07.13',
                  name: '',
                  description: 'Commission',
                  amount: 271,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0039,
              percentAVG: 0.0039,
              cellID: '7a82e4de_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '7a82e4de_@_14',
              index: 2,
              cPercent: 0.003869948592516834,
            },
            {
              date: '2025-06-30',
              title: 'Commission/Bonus/Incentives',
              path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '7a82e4de_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '7a82e4de_@_14',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Commission/Bonus/Incentives',
              path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 268,
              perc: 0.004,
              percAvg: 0.004,
              dataRows: [
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '15265',
                  num: 'PR 06.23 to 06.29',
                  name: '',
                  description: 'comission',
                  amount: 268,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.004,
              percentAVG: 0.004,
              cellID: '7a82e4de_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '7a82e4de_@_14',
              index: 4,
              cPercent: 0.004034191276362425,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'bbc14e9c_@_14',
          cellID: 'bbc14e9c_@_14_-x-_0',
          amountTitle: 'Payroll Taxes',
          refTitle: 'Payroll Taxes',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 5315,
          parent: 'dacf6533',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Payroll Taxes',
              path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
                stats: {
                  mean: 679.762,
                  variance: 1556854.7699359995,
                  stdDev: 1247.7398646897516,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: -788.82,
              perc: -0.0105,
              percAvg: -0.0105,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Deposit',
                  eventId: '15624',
                  num: '',
                  name: 'Payroll Tax',
                  description: 'STRATEGY EXECUTI TAX COL',
                  amount: -1269.59,
                },
                {
                  txnDate: '2025-07-27',
                  type: 'Journal Entry',
                  eventId: '15635',
                  num: 'Payroll Accrual 07.27',
                  name: '',
                  description: 'PR Tax',
                  amount: 480.77,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: -0.0105,
              percentAVG: -0.0105,
              cellID: 'bbc14e9c_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 2,
              id: 'bbc14e9c_@_14',
              index: 0,
              cPercent: -0.010544718203294017,
            },
            {
              date: '2025-07-14',
              title: 'Payroll Taxes',
              path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
                stats: {
                  mean: 679.762,
                  variance: 1556854.7699359995,
                  stdDev: 1247.7398646897516,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 2993.1,
              perc: 0.044,
              percAvg: 0.044,
              dataRows: [
                {
                  txnDate: '2025-07-20',
                  type: 'Journal Entry',
                  eventId: '15355',
                  num: 'Payroll Accrual 07.20',
                  name: '',
                  description: 'PR Tax',
                  amount: 2993.1,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0.044,
              percentAVG: 0.044,
              cellID: 'bbc14e9c_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: 'bbc14e9c_@_14',
              index: 1,
              cPercent: 0.04395528547218412,
            },
            {
              date: '2025-07-07',
              title: 'Payroll Taxes',
              path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
                stats: {
                  mean: 679.762,
                  variance: 1556854.7699359995,
                  stdDev: 1247.7398646897516,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 480.77,
              perc: 0.0069,
              percAvg: 0.0069,
              dataRows: [
                {
                  txnDate: '2025-07-13',
                  type: 'Journal Entry',
                  eventId: '15628',
                  num: 'PR 07.07. to 07.13',
                  name: '',
                  description: 'PR Tax',
                  amount: 480.77,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0069,
              percentAVG: 0.0069,
              cellID: 'bbc14e9c_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: 'bbc14e9c_@_14',
              index: 2,
              cPercent: 0.006865517287174606,
            },
            {
              date: '2025-06-30',
              title: 'Payroll Taxes',
              path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
                stats: {
                  mean: 679.762,
                  variance: 1556854.7699359995,
                  stdDev: 1247.7398646897516,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 475,
              perc: 0.0053,
              percAvg: 0.0053,
              dataRows: [
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '15268',
                  num: 'PR 06.30 to 07.06',
                  name: '',
                  description: 'PR Tax',
                  amount: 475,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0.0053,
              percentAVG: 0.0053,
              cellID: 'bbc14e9c_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: 'bbc14e9c_@_14',
              index: 3,
              cPercent: 0.005271643342141972,
            },
            {
              date: '2025-06-23',
              title: 'Payroll Taxes',
              path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
                stats: {
                  mean: 679.762,
                  variance: 1556854.7699359995,
                  stdDev: 1247.7398646897516,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
                stats: {
                  mean: 1.2,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 238.76,
              perc: 0.0036,
              percAvg: 0.0036,
              dataRows: [
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '15265',
                  num: 'PR 06.23 to 06.29',
                  name: '',
                  description: 'PR Tax',
                  amount: 238.76,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0036,
              percentAVG: 0.0036,
              cellID: 'bbc14e9c_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'bbc14e9c_@_14',
              index: 4,
              cPercent: 0.003594042944568255,
            },
          ],
          anomalies: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
        },
        {
          id: '416bc276_@_14',
          cellID: '416bc276_@_14_-x-_0',
          amountTitle: 'Employee Meals',
          refTitle: 'Employee Meals',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 5340,
          parent: 'dacf6533',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Employee Meals',
              path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: '416bc276_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '416bc276_@_14',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Employee Meals',
              path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '416bc276_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '416bc276_@_14',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Employee Meals',
              path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '416bc276_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '416bc276_@_14',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Employee Meals',
              path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '416bc276_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '416bc276_@_14',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Employee Meals',
              path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 774,
              perc: 0.0117,
              percAvg: 0.0117,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Check',
                  eventId: '14675',
                  num: '650204',
                  name: 'Eileen Kim',
                  description: 'CHECK 650204 Reimbursement',
                  amount: 774,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0117,
              percentAVG: 0.0117,
              cellID: '416bc276_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '416bc276_@_14',
              index: 4,
              cPercent: 0.011650985253375061,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'c12aec10_@_14',
          cellID: 'c12aec10_@_14_-x-_0',
          amountTitle: 'Recruiting',
          refTitle: 'Recruiting',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 5345,
          parent: 'dacf6533',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Recruiting',
              path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: 'c12aec10_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'c12aec10_@_14',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Recruiting',
              path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: 'c12aec10_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'c12aec10_@_14',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Recruiting',
              path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'c12aec10_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'c12aec10_@_14',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Recruiting',
              path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'c12aec10_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'c12aec10_@_14',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Recruiting',
              path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'c12aec10_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'c12aec10_@_14',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '1e9ad256_@_14',
          cellID: '1e9ad256_@_14_-x-_0',
          amountTitle: 'Total Labor Related Expenses',
          refTitle: 'Total Labor Related Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '5b0fe671',
          path: ['LABOR', 'Total Labor Related Expenses'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Labor Related Expenses',
              path: ['LABOR', 'Total Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
                stats: {
                  mean: 942.3619999999999,
                  variance: 1514356.643536,
                  stdDev: 1230.5919890589244,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -788.82,
              amtAvg: -788.82,
              perc: -0.0105,
              percAvg: -0.0105,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: -788.82,
              percent: -0.0105,
              percentAVG: -0.0105,
              cellID: '1e9ad256_@_14_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '1e9ad256_@_14',
              index: 0,
              cPercent: -0.010544718203294017,
            },
            {
              date: '2025-07-14',
              title: 'Total Labor Related Expenses',
              path: ['LABOR', 'Total Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
                stats: {
                  mean: 942.3619999999999,
                  variance: 1514356.643536,
                  stdDev: 1230.5919890589244,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2993.1,
              amtAvg: 2993.1,
              perc: 0.044,
              percAvg: 0.044,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 2993.1,
              percent: 0.044,
              percentAVG: 0.044,
              cellID: '1e9ad256_@_14_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '1e9ad256_@_14',
              index: 1,
              cPercent: 0.04395528547218412,
            },
            {
              date: '2025-07-07',
              title: 'Total Labor Related Expenses',
              path: ['LABOR', 'Total Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
                stats: {
                  mean: 942.3619999999999,
                  variance: 1514356.643536,
                  stdDev: 1230.5919890589244,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 751.77,
              amtAvg: 751.77,
              perc: 0.0107,
              percAvg: 0.0107,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 751.77,
              percent: 0.0107,
              percentAVG: 0.0107,
              cellID: '1e9ad256_@_14_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '1e9ad256_@_14',
              index: 2,
              cPercent: 0.010735465879691439,
            },
            {
              date: '2025-06-30',
              title: 'Total Labor Related Expenses',
              path: ['LABOR', 'Total Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
                stats: {
                  mean: 942.3619999999999,
                  variance: 1514356.643536,
                  stdDev: 1230.5919890589244,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 475,
              amtAvg: 475,
              perc: 0.0053,
              percAvg: 0.0053,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 475,
              percent: 0.0053,
              percentAVG: 0.0053,
              cellID: '1e9ad256_@_14_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '1e9ad256_@_14',
              index: 3,
              cPercent: 0.005271643342141972,
            },
            {
              date: '2025-06-23',
              title: 'Total Labor Related Expenses',
              path: ['LABOR', 'Total Labor Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [2993.1],
                anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
                stats: {
                  mean: 942.3619999999999,
                  variance: 1514356.643536,
                  stdDev: 1230.5919890589244,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1280.76,
              amtAvg: 1280.76,
              perc: 0.0193,
              percAvg: 0.0193,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 1280.76,
              percent: 0.0193,
              percentAVG: 0.0193,
              cellID: '1e9ad256_@_14_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '1e9ad256_@_14',
              index: 4,
              cPercent: 0.01927921947430574,
            },
          ],
          anomalies: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
        },
        {
          id: 'd0736ae7_@_15',
          cellID: 'd0736ae7_@_15_-x-_0',
          amountTitle: 'TOTAL LABOR',
          refTitle: 'TOTAL LABOR',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['TOTAL LABOR'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'TOTAL LABOR',
              path: ['TOTAL LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 27163.121999999996,
                  variance: 181497655.213336,
                  stdDev: 13472.106561831226,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 17059.77,
              amtAvg: 17059.77,
              perc: 0.2281,
              percAvg: 0.2281,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 17059.77,
              percent: 0.2281,
              percentAVG: 0.2281,
              cellID: 'd0736ae7_@_15_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'd0736ae7_@_15',
              index: 0,
              cPercent: 0.2280500840026992,
            },
            {
              date: '2025-07-14',
              title: 'TOTAL LABOR',
              path: ['TOTAL LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 27163.121999999996,
                  variance: 181497655.213336,
                  stdDev: 13472.106561831226,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 43491.79,
              amtAvg: 43491.79,
              perc: 0.6387,
              percAvg: 0.6387,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 43491.79,
              percent: 0.6387,
              percentAVG: 0.6387,
              cellID: 'd0736ae7_@_15_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'd0736ae7_@_15',
              index: 1,
              cPercent: 0.6387003592082733,
            },
            {
              date: '2025-07-07',
              title: 'TOTAL LABOR',
              path: ['TOTAL LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 27163.121999999996,
                  variance: 181497655.213336,
                  stdDev: 13472.106561831226,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 42293.969999999994,
              amtAvg: 42293.969999999994,
              perc: 0.604,
              percAvg: 0.604,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 42293.969999999994,
              percent: 0.604,
              percentAVG: 0.604,
              cellID: 'd0736ae7_@_15_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'd0736ae7_@_15',
              index: 2,
              cPercent: 0.6039685965809932,
            },
            {
              date: '2025-06-30',
              title: 'TOTAL LABOR',
              path: ['TOTAL LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 27163.121999999996,
                  variance: 181497655.213336,
                  stdDev: 13472.106561831226,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 22880.34,
              amtAvg: 22880.34,
              perc: 0.2539,
              percAvg: 0.2539,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 22880.34,
              percent: 0.2539,
              percentAVG: 0.2539,
              cellID: 'd0736ae7_@_15_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'd0736ae7_@_15',
              index: 3,
              cPercent: 0.2539305095304098,
            },
            {
              date: '2025-06-23',
              title: 'TOTAL LABOR',
              path: ['TOTAL LABOR'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 27163.121999999996,
                  variance: 181497655.213336,
                  stdDev: 13472.106561831226,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 10089.74,
              amtAvg: 10089.74,
              perc: 0.1519,
              percAvg: 0.1519,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 10089.74,
              percent: 0.1519,
              percentAVG: 0.1519,
              cellID: 'd0736ae7_@_15_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'd0736ae7_@_15',
              index: 4,
              cPercent: 0.15188037719688435,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
        },
        {
          id: 'b7d061ce_@_16',
          cellID: 'b7d061ce_@_16_-x-_0',
          amountTitle: 'PRIME COST',
          refTitle: 'PRIME COST',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['PRIME COST'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'PRIME COST',
              path: ['PRIME COST'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 52725.438,
                  variance: 346155513.457576,
                  stdDev: 18605.254995768693,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 41106.450000000004,
              amtAvg: 41106.450000000004,
              perc: 0.5495,
              percAvg: 0.5495,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 41106.450000000004,
              percent: 0.5495,
              percentAVG: 0.5495,
              cellID: 'b7d061ce_@_16_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'b7d061ce_@_16',
              index: 0,
              cPercent: 0.5494991653200925,
            },
            {
              date: '2025-07-14',
              title: 'PRIME COST',
              path: ['PRIME COST'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 52725.438,
                  variance: 346155513.457576,
                  stdDev: 18605.254995768693,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 75844.70999999999,
              amtAvg: 75844.70999999999,
              perc: 1.1138,
              percAvg: 1.1138,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 75844.70999999999,
              percent: 1.1138,
              percentAVG: 1.1138,
              cellID: 'b7d061ce_@_16_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'b7d061ce_@_16',
              index: 1,
              cPercent: 1.1138204134860237,
            },
            {
              date: '2025-07-07',
              title: 'PRIME COST',
              path: ['PRIME COST'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 52725.438,
                  variance: 346155513.457576,
                  stdDev: 18605.254995768693,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 73133.22,
              amtAvg: 73133.22,
              perc: 1.0444,
              percAvg: 1.0444,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 73133.22,
              percent: 1.0444,
              percentAVG: 1.0444,
              cellID: 'b7d061ce_@_16_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'b7d061ce_@_16',
              index: 2,
              cPercent: 1.0443608922701992,
            },
            {
              date: '2025-06-30',
              title: 'PRIME COST',
              path: ['PRIME COST'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 52725.438,
                  variance: 346155513.457576,
                  stdDev: 18605.254995768693,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 45009.61,
              amtAvg: 45009.61,
              perc: 0.4995,
              percAvg: 0.4995,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 45009.61,
              percent: 0.4995,
              percentAVG: 0.4995,
              cellID: 'b7d061ce_@_16_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'b7d061ce_@_16',
              index: 3,
              cPercent: 0.4995254966082247,
            },
            {
              date: '2025-06-23',
              title: 'PRIME COST',
              path: ['PRIME COST'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 52725.438,
                  variance: 346155513.457576,
                  stdDev: 18605.254995768693,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 28533.199999999997,
              amtAvg: 28533.199999999997,
              perc: 0.4295,
              percAvg: 0.4295,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 28533.199999999997,
              percent: 0.4295,
              percentAVG: 0.4295,
              cellID: 'b7d061ce_@_16_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'b7d061ce_@_16',
              index: 4,
              cPercent: 0.42950890495038924,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
        },
        {
          id: '2f5a4d68_@_17',
          cellID: '2f5a4d68_@_17_-x-_0',
          amountTitle: 'Contribution Margin',
          refTitle: 'Contribution Margin',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Contribution Margin'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Contribution Margin',
              path: ['Contribution Margin'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 21167.555999999997,
                  variance: 487005743.832544,
                  stdDev: 22068.206629278782,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 33700.670000000006,
              amtAvg: 33700.670000000006,
              perc: 0.4505,
              percAvg: 0.4505,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 33700.670000000006,
              percent: 0.4505,
              percentAVG: 0.4505,
              cellID: '2f5a4d68_@_17_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '2f5a4d68_@_17',
              index: 0,
              cPercent: 0.4505008346799075,
            },
            {
              date: '2025-07-14',
              title: 'Contribution Margin',
              path: ['Contribution Margin'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 21167.555999999997,
                  variance: 487005743.832544,
                  stdDev: 22068.206629278782,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -7750.509999999995,
              amtAvg: -7750.509999999995,
              perc: -0.1138,
              percAvg: -0.1138,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: -7750.509999999995,
              percent: -0.1138,
              percentAVG: -0.1138,
              cellID: '2f5a4d68_@_17_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '2f5a4d68_@_17',
              index: 1,
              cPercent: -0.1138204134860237,
            },
            {
              date: '2025-07-07',
              title: 'Contribution Margin',
              path: ['Contribution Margin'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 21167.555999999997,
                  variance: 487005743.832544,
                  stdDev: 22068.206629278782,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -3106.4500000000116,
              amtAvg: -3106.4500000000116,
              perc: -0.0444,
              percAvg: -0.0444,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -3106.4500000000116,
              percent: -0.0444,
              percentAVG: -0.0444,
              cellID: '2f5a4d68_@_17_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '2f5a4d68_@_17',
              index: 2,
              cPercent: -0.044360892270199126,
            },
            {
              date: '2025-06-30',
              title: 'Contribution Margin',
              path: ['Contribution Margin'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 21167.555999999997,
                  variance: 487005743.832544,
                  stdDev: 22068.206629278782,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 45095.119999999995,
              amtAvg: 45095.119999999995,
              perc: 0.5005,
              percAvg: 0.5005,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 45095.119999999995,
              percent: 0.5005,
              percentAVG: 0.5005,
              cellID: '2f5a4d68_@_17_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '2f5a4d68_@_17',
              index: 3,
              cPercent: 0.5004745033917753,
            },
            {
              date: '2025-06-23',
              title: 'Contribution Margin',
              path: ['Contribution Margin'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 21167.555999999997,
                  variance: 487005743.832544,
                  stdDev: 22068.206629278782,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 37898.95,
              amtAvg: 37898.95,
              perc: 0.5705,
              percAvg: 0.5705,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 37898.95,
              percent: 0.5705,
              percentAVG: 0.5705,
              cellID: '2f5a4d68_@_17_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '2f5a4d68_@_17',
              index: 4,
              cPercent: 0.5704910950496108,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
        },
        {
          id: '2cd659af_@_18',
          cellID: '2cd659af_@_18_-x-_0',
          amountTitle: 'CONTROLLABLE EXPENSES',
          refTitle: 'CONTROLLABLE EXPENSES',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: 7000,
          parent: null,
          path: ['CONTROLLABLE EXPENSES'],
          display: 'header_1',
          children: [
            '3be3d09b_@_18',
            'b7f8c8b8_@_18',
            '9d0fd7d1_@_18',
            'd484c66b_@_18',
            'edd65db2_@_18',
            '024ba9eb_@_18',
            '0c83dbac_@_18',
            '6f7c6ca5_@_18',
            'f12db2ec_@_18',
            '084f517c_@_18',
            'ea7ffa49_@_18',
            '1675dbe8_@_18',
            '4da1092f_@_18',
          ],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'CONTROLLABLE EXPENSES',
              path: ['CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '2cd659af_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '2cd659af_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'CONTROLLABLE EXPENSES',
              path: ['CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '2cd659af_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '2cd659af_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'CONTROLLABLE EXPENSES',
              path: ['CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '2cd659af_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '2cd659af_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'CONTROLLABLE EXPENSES',
              path: ['CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '2cd659af_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '2cd659af_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'CONTROLLABLE EXPENSES',
              path: ['CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '2cd659af_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '2cd659af_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '3be3d09b_@_18',
          cellID: '3be3d09b_@_18_-x-_0',
          amountTitle: 'Direct Operating Expenses',
          refTitle: 'Direct Operating Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 6100,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          display: 'default',
          children: [
            '1a6a3f76_@_18',
            '514ec7ed_@_18',
            '758ae475_@_18',
            '28a2ce1f_@_18',
            'ad6ac922_@_18',
            '9f991141_@_18',
          ],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '3be3d09b_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '3be3d09b_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '3be3d09b_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '3be3d09b_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '3be3d09b_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '3be3d09b_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '3be3d09b_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '3be3d09b_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '3be3d09b_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '3be3d09b_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '1a6a3f76_@_18',
          cellID: '1a6a3f76_@_18_-x-_0',
          amountTitle: 'Equipment Lease Rental',
          refTitle: 'Equipment Lease Rental',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6110,
          parent: '3be3d09b',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Equipment Lease Rental',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 35,
              perc: 0,
              percAvg: 0.0005,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 35,
              percent: 0,
              percentAVG: 0.0005,
              cellID: '1a6a3f76_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '1a6a3f76_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Equipment Lease Rental',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 35,
              perc: 0,
              percAvg: 0.0005,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 35,
              percent: 0,
              percentAVG: 0.0005,
              cellID: '1a6a3f76_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '1a6a3f76_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Equipment Lease Rental',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 155,
              perc: 0.0022,
              percAvg: 0.0022,
              dataRows: [
                {
                  txnDate: '2025-07-09',
                  type: 'Journal Entry',
                  eventId: '15533',
                  num: 'MI1905ME',
                  name: '',
                  description: 'Vendor: Alpine Soda Systems Of New York LLC',
                  amount: 155,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0022,
              percentAVG: 0.0022,
              cellID: '1a6a3f76_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '1a6a3f76_@_18',
              index: 2,
              cPercent: 0.0022134392318823217,
            },
            {
              date: '2025-06-30',
              title: 'Equipment Lease Rental',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 45.65,
              perc: 0,
              percAvg: 0.0005,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 45.65,
              percent: 0,
              percentAVG: 0.0005,
              cellID: '1a6a3f76_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '1a6a3f76_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Equipment Lease Rental',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '1a6a3f76_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '1a6a3f76_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '514ec7ed_@_18',
          cellID: '514ec7ed_@_18_-x-_0',
          amountTitle: 'Cleaning Supplies',
          refTitle: 'Cleaning Supplies',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6115,
          parent: '3be3d09b',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Cleaning Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [66.69],
                anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
                stats: {
                  mean: 135.994,
                  variance: 1760.6405040000002,
                  stdDev: 41.95998693994077,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
                stats: {
                  mean: 2.2,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 184.53,
              amtAvg: 114.23,
              perc: 0.0025,
              percAvg: 0.0015,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15534',
                  num: '3590454',
                  name: 'White Plains Linen',
                  description: '',
                  amount: 83.48,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 65.35,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 35.7,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 114.23,
              percent: 0.0025,
              percentAVG: 0.0015,
              cellID: '514ec7ed_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 3,
              id: '514ec7ed_@_18',
              index: 0,
              cPercent: 0.00246674380727396,
            },
            {
              date: '2025-07-14',
              title: 'Cleaning Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [66.69],
                anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
                stats: {
                  mean: 135.994,
                  variance: 1760.6405040000002,
                  stdDev: 41.95998693994077,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
                stats: {
                  mean: 2.2,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 131.91,
              amtAvg: 114.23,
              perc: 0.0019,
              percAvg: 0.0017,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Bill',
                  eventId: '15207',
                  num: '9255396',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 20.12,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15537',
                  num: '9257563',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 111.79,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 114.23,
              percent: 0.0019,
              percentAVG: 0.0017,
              cellID: '514ec7ed_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: '514ec7ed_@_18',
              index: 1,
              cPercent: 0.001937169391813106,
            },
            {
              date: '2025-07-07',
              title: 'Cleaning Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [66.69],
                anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
                stats: {
                  mean: 135.994,
                  variance: 1760.6405040000002,
                  stdDev: 41.95998693994077,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
                stats: {
                  mean: 2.2,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 122.74,
              perc: 0.0018,
              percAvg: 0.0018,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 101.13,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 21.61,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0018,
              percentAVG: 0.0018,
              cellID: '514ec7ed_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 2,
              id: '514ec7ed_@_18',
              index: 2,
              cPercent: 0.0017527582665886204,
            },
            {
              date: '2025-06-30',
              title: 'Cleaning Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [66.69],
                anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
                stats: {
                  mean: 135.994,
                  variance: 1760.6405040000002,
                  stdDev: 41.95998693994077,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
                stats: {
                  mean: 2.2,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 66.69,
              amtAvg: 123.8,
              perc: 0.0007,
              percAvg: 0.0014,
              dataRows: [
                {
                  txnDate: '2025-07-04',
                  type: 'Bill',
                  eventId: '14724',
                  num: '9249000',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 66.69,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 123.8,
              percent: 0.0007,
              percentAVG: 0.0014,
              cellID: '514ec7ed_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '514ec7ed_@_18',
              index: 3,
              cPercent: 0.0007401387252367329,
            },
            {
              date: '2025-06-23',
              title: 'Cleaning Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [66.69],
                anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
                stats: {
                  mean: 135.994,
                  variance: 1760.6405040000002,
                  stdDev: 41.95998693994077,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
                stats: {
                  mean: 2.2,
                  variance: 0.5599999999999999,
                  stdDev: 0.7483314773547882,
                },
              },
              trxFlagged: [],
              amount: 174.1,
              perc: 0.0026,
              percAvg: 0.0026,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Bill',
                  eventId: '14561',
                  num: '9239104',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 65.4,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 74,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '14703',
                  num: '9243481',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 34.7,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0026,
              percentAVG: 0.0026,
              cellID: '514ec7ed_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: '514ec7ed_@_18',
              index: 4,
              cPercent: 0.0026207190343832017,
            },
          ],
          anomalies: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
        },
        {
          id: '758ae475_@_18',
          cellID: '758ae475_@_18_-x-_0',
          amountTitle: 'Cleaning Services',
          refTitle: 'Cleaning Services',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6120,
          parent: '3be3d09b',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Cleaning Services',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 235.95,
              perc: 0,
              percAvg: 0.0032,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 235.95,
              percent: 0,
              percentAVG: 0.0032,
              cellID: '758ae475_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '758ae475_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Cleaning Services',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 235.95,
              perc: 0,
              percAvg: 0.0035,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 235.95,
              percent: 0,
              percentAVG: 0.0035,
              cellID: '758ae475_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '758ae475_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Cleaning Services',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1044.92,
              perc: 0.0149,
              percAvg: 0.0149,
              dataRows: [
                {
                  txnDate: '2025-07-09',
                  type: 'Check',
                  eventId: '15389',
                  num: '6502115',
                  name: 'Golden Cleaning',
                  description: 'CHECK 6502115',
                  amount: 1044.92,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0149,
              percentAVG: 0.0149,
              cellID: '758ae475_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '758ae475_@_18',
              index: 2,
              cPercent: 0.014921722078570813,
            },
            {
              date: '2025-06-30',
              title: 'Cleaning Services',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 213.91,
              perc: 0,
              percAvg: 0.0024,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 213.91,
              percent: 0,
              percentAVG: 0.0024,
              cellID: '758ae475_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '758ae475_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Cleaning Services',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '758ae475_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '758ae475_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '28a2ce1f_@_18',
          cellID: '28a2ce1f_@_18_-x-_0',
          amountTitle: 'Restaurant Supplies',
          refTitle: 'Restaurant Supplies',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6125,
          parent: '3be3d09b',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Restaurant Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [529.68],
                anomalyScores: [0.829937455486837, 0, 0, 0, 0],
                stats: {
                  mean: 430.96000000000004,
                  variance: 3537.1996399999975,
                  stdDev: 59.4743611987552,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 529.68,
              amtAvg: 402.65,
              perc: 0.0071,
              percAvg: 0.0054,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Bill',
                  eventId: '15541',
                  num: '9262981',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 270.35,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Bill',
                  eventId: '15564',
                  num: '9265169',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 139.53,
                },
                {
                  txnDate: '2025-07-26',
                  type: 'Bill',
                  eventId: '15543',
                  num: '713076',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 119.8,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 402.65,
              percent: 0.0071,
              percentAVG: 0.0054,
              cellID: '28a2ce1f_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 3,
              id: '28a2ce1f_@_18',
              index: 0,
              cPercent: 0.007080609439315401,
            },
            {
              date: '2025-07-14',
              title: 'Restaurant Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [529.68],
                anomalyScores: [0.829937455486837, 0, 0, 0, 0],
                stats: {
                  mean: 430.96000000000004,
                  variance: 3537.1996399999975,
                  stdDev: 59.4743611987552,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 376.87,
              amtAvg: 402.65,
              perc: 0.0055,
              percAvg: 0.0059,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Bill',
                  eventId: '15207',
                  num: '9255396',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 46.81,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Bill',
                  eventId: '15537',
                  num: '9257563',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 149.33,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Bill',
                  eventId: '15566',
                  num: '9259520',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 180.73,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 402.65,
              percent: 0.0055,
              percentAVG: 0.0059,
              cellID: '28a2ce1f_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 3,
              id: '28a2ce1f_@_18',
              index: 1,
              cPercent: 0.0055345389181457455,
            },
            {
              date: '2025-07-07',
              title: 'Restaurant Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [529.68],
                anomalyScores: [0.829937455486837, 0, 0, 0, 0],
                stats: {
                  mean: 430.96000000000004,
                  variance: 3537.1996399999975,
                  stdDev: 59.4743611987552,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 411.98,
              perc: 0.0059,
              percAvg: 0.0059,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Bill',
                  eventId: '14720',
                  num: '9249995',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 87.54,
                },
                {
                  txnDate: '2025-07-09',
                  type: 'Bill',
                  eventId: '15542',
                  num: '711503',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 59.9,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Bill',
                  eventId: '14903',
                  num: '9253029',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 264.54,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0059,
              percentAVG: 0.0059,
              cellID: '28a2ce1f_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 3,
              id: '28a2ce1f_@_18',
              index: 2,
              cPercent: 0.005883178675812123,
            },
            {
              date: '2025-06-30',
              title: 'Restaurant Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [529.68],
                anomalyScores: [0.829937455486837, 0, 0, 0, 0],
                stats: {
                  mean: 430.96000000000004,
                  variance: 3537.1996399999975,
                  stdDev: 59.4743611987552,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 464.64,
              amtAvg: 406.84,
              perc: 0.0052,
              percAvg: 0.0045,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Bill',
                  eventId: '14714',
                  num: '9247031',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 232.93,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Bill',
                  eventId: '14722',
                  num: '711119',
                  name: 'Avanti Enterprises,INC.',
                  description: '',
                  amount: 119.8,
                },
                {
                  txnDate: '2025-07-04',
                  type: 'Bill',
                  eventId: '14724',
                  num: '9249000',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 111.91,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 406.84,
              percent: 0.0052,
              percentAVG: 0.0045,
              cellID: '28a2ce1f_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 3,
              id: '28a2ce1f_@_18',
              index: 3,
              cPercent: 0.005156666026300728,
            },
            {
              date: '2025-06-23',
              title: 'Restaurant Supplies',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [529.68],
                anomalyScores: [0.829937455486837, 0, 0, 0, 0],
                stats: {
                  mean: 430.96000000000004,
                  variance: 3537.1996399999975,
                  stdDev: 59.4743611987552,
                },
              },
              trxAnomaly: {
                anomalies: [0, 0, 0, 0, 0],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 3,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 371.63,
              perc: 0.0056,
              percAvg: 0.0056,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Bill',
                  eventId: '14561',
                  num: '9239104',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 80.19,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Bill',
                  eventId: '14685',
                  num: '9240751',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 166.11,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '14703',
                  num: '9243481',
                  name: 'Performance Food Service',
                  description: '',
                  amount: 125.33,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0056,
              percentAVG: 0.0056,
              cellID: '28a2ce1f_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: '28a2ce1f_@_18',
              index: 4,
              cPercent: 0.005594128746397641,
            },
          ],
          anomalies: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
        },
        {
          id: 'ad6ac922_@_18',
          cellID: 'ad6ac922_@_18_-x-_0',
          amountTitle: 'Laundry, Linens, & Uniforms',
          refTitle: 'Laundry, Linens, & Uniforms',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6135,
          parent: '3be3d09b',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Laundry, Linens, & Uniforms',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1954.31],
                anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
                stats: {
                  mean: 884.5779999999999,
                  variance: 480407.64341599995,
                  stdDev: 693.114451887998,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16,
                  stdDev: 0.4,
                },
              },
              trxFlagged: [],
              amount: 268.89,
              amtAvg: 557.42,
              perc: 0.0036,
              percAvg: 0.0075,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Bill',
                  eventId: '15534',
                  num: '3590454',
                  name: 'White Plains Linen',
                  description: '',
                  amount: 268.89,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 557.42,
              percent: 0.0036,
              percentAVG: 0.0075,
              cellID: 'ad6ac922_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: 'ad6ac922_@_18',
              index: 0,
              cPercent: 0.0035944439513244187,
            },
            {
              date: '2025-07-14',
              title: 'Laundry, Linens, & Uniforms',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1954.31],
                anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
                stats: {
                  mean: 884.5779999999999,
                  variance: 480407.64341599995,
                  stdDev: 693.114451887998,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16,
                  stdDev: 0.4,
                },
              },
              trxFlagged: [],
              amount: 1058.12,
              amtAvg: 557.42,
              perc: 0.0155,
              percAvg: 0.0082,
              dataRows: [
                {
                  txnDate: '2025-07-17',
                  type: 'Expense',
                  eventId: '15492',
                  num: '',
                  name: 'White Plains Linen',
                  description: 'WHITE PLAINS COA COLLECTION',
                  amount: 1058.12,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 557.42,
              percent: 0.0155,
              percentAVG: 0.0082,
              cellID: 'ad6ac922_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: 'ad6ac922_@_18',
              index: 1,
              cPercent: 0.015539062064023073,
            },
            {
              date: '2025-07-07',
              title: 'Laundry, Linens, & Uniforms',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1954.31],
                anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
                stats: {
                  mean: 884.5779999999999,
                  variance: 480407.64341599995,
                  stdDev: 693.114451887998,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16,
                  stdDev: 0.4,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'ad6ac922_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'ad6ac922_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Laundry, Linens, & Uniforms',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1954.31],
                anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
                stats: {
                  mean: 884.5779999999999,
                  variance: 480407.64341599995,
                  stdDev: 693.114451887998,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16,
                  stdDev: 0.4,
                },
              },
              trxFlagged: [],
              amount: 1141.57,
              amtAvg: 547.55,
              perc: 0.0127,
              percAvg: 0.0061,
              dataRows: [
                {
                  txnDate: '2025-07-03',
                  type: 'Expense',
                  eventId: '14839',
                  num: '',
                  name: 'White Plains Linen',
                  description: 'WHITE PLAINS COA COLLECTION',
                  amount: 1141.57,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 547.55,
              percent: 0.0127,
              percentAVG: 0.0061,
              cellID: 'ad6ac922_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: 'ad6ac922_@_18',
              index: 3,
              cPercent: 0.012669368189661075,
            },
            {
              date: '2025-06-23',
              title: 'Laundry, Linens, & Uniforms',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1954.31],
                anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
                stats: {
                  mean: 884.5779999999999,
                  variance: 480407.64341599995,
                  stdDev: 693.114451887998,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16,
                  stdDev: 0.4,
                },
              },
              trxFlagged: [],
              amount: 1954.31,
              perc: 0.0294,
              percAvg: 0.0294,
              dataRows: [
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14886',
                  num: '',
                  name: 'Sartor NYC',
                  description: 'VISA DDA PUR AP - 469216     SQ  SARTOR INC              NEW YORK      * NY',
                  amount: 1954.31,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0294,
              percentAVG: 0.0294,
              cellID: 'ad6ac922_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'ad6ac922_@_18',
              index: 4,
              cPercent: 0.02941813564667108,
            },
          ],
          anomalies: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
        },
        {
          id: '9f991141_@_18',
          cellID: '9f991141_@_18_-x-_0',
          amountTitle: 'Kitchen/ Bar Smallwares',
          refTitle: 'Kitchen/ Bar Smallwares',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6155,
          parent: '3be3d09b',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Kitchen/ Bar Smallwares',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '9f991141_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '9f991141_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Kitchen/ Bar Smallwares',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '9f991141_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '9f991141_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Kitchen/ Bar Smallwares',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '9f991141_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '9f991141_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Kitchen/ Bar Smallwares',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 243.44,
              perc: 0,
              percAvg: 0.0027,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 243.44,
              percent: 0,
              percentAVG: 0.0027,
              cellID: '9f991141_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '9f991141_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Kitchen/ Bar Smallwares',
              path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1598.17,
              perc: 0.0241,
              percAvg: 0.0241,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14590',
                  num: '',
                  name: 'Crate & Barrel',
                  description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
                  amount: 631.25,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14591',
                  num: '',
                  name: 'Crate & Barrel',
                  description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
                  amount: 546.8,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14592',
                  num: '',
                  name: 'Crate & Barrel',
                  description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
                  amount: 420.12,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0241,
              percentAVG: 0.0241,
              cellID: '9f991141_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: '9f991141_@_18',
              index: 4,
              cPercent: 0.02405717713486618,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'b7f8c8b8_@_18',
          cellID: 'b7f8c8b8_@_18_-x-_0',
          amountTitle: 'Total Direct Operating Expenses',
          refTitle: 'Total Direct Operating Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [4098.21],
                anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
                stats: {
                  mean: 2011.15,
                  variance: 1160187.0302400002,
                  stdDev: 1077.1197845365205,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 983.0999999999999,
              amtAvg: 1345.25,
              perc: 0.0131,
              percAvg: 0.018,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 1345.25,
              percent: 0.0131,
              percentAVG: 0.018,
              cellID: 'b7f8c8b8_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'b7f8c8b8_@_18',
              index: 0,
              cPercent: 0.01314179719791378,
            },
            {
              date: '2025-07-14',
              title: 'Total Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [4098.21],
                anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
                stats: {
                  mean: 2011.15,
                  variance: 1160187.0302400002,
                  stdDev: 1077.1197845365205,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1566.8999999999999,
              amtAvg: 1345.25,
              perc: 0.023,
              percAvg: 0.0198,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 1345.25,
              percent: 0.023,
              percentAVG: 0.0198,
              cellID: 'b7f8c8b8_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'b7f8c8b8_@_18',
              index: 1,
              cPercent: 0.023010770373981925,
            },
            {
              date: '2025-07-07',
              title: 'Total Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [4098.21],
                anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
                stats: {
                  mean: 2011.15,
                  variance: 1160187.0302400002,
                  stdDev: 1077.1197845365205,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1734.64,
              amtAvg: 1734.64,
              perc: 0.0248,
              percAvg: 0.0248,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 1734.64,
              percent: 0.0248,
              percentAVG: 0.0248,
              cellID: 'b7f8c8b8_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'b7f8c8b8_@_18',
              index: 2,
              cPercent: 0.02477109825285388,
            },
            {
              date: '2025-06-30',
              title: 'Total Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [4098.21],
                anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
                stats: {
                  mean: 2011.15,
                  variance: 1160187.0302400002,
                  stdDev: 1077.1197845365205,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1672.8999999999999,
              amtAvg: 1581.19,
              perc: 0.0186,
              percAvg: 0.0175,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 1581.19,
              percent: 0.0186,
              percentAVG: 0.0175,
              cellID: 'b7f8c8b8_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'b7f8c8b8_@_18',
              index: 3,
              cPercent: 0.018566172941198535,
            },
            {
              date: '2025-06-23',
              title: 'Total Direct Operating Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [4098.21],
                anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
                stats: {
                  mean: 2011.15,
                  variance: 1160187.0302400002,
                  stdDev: 1077.1197845365205,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 4098.21,
              amtAvg: 4098.21,
              perc: 0.0617,
              percAvg: 0.0617,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 4098.21,
              percent: 0.0617,
              percentAVG: 0.0617,
              cellID: 'b7f8c8b8_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'b7f8c8b8_@_18',
              index: 4,
              cPercent: 0.0616901605623181,
            },
          ],
          anomalies: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
        },
        {
          id: '9d0fd7d1_@_18',
          cellID: '9d0fd7d1_@_18_-x-_0',
          amountTitle: 'Transaction Related Expenses',
          refTitle: 'Transaction Related Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 6200,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          display: 'default',
          children: ['47bbbb15_@_18'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '9d0fd7d1_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '9d0fd7d1_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '9d0fd7d1_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '9d0fd7d1_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '9d0fd7d1_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '9d0fd7d1_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '9d0fd7d1_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '9d0fd7d1_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '9d0fd7d1_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '9d0fd7d1_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '47bbbb15_@_18',
          cellID: '47bbbb15_@_18_-x-_0',
          amountTitle: '3rd Party Commissions',
          refTitle: '3rd Party Commissions',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6215,
          parent: '9d0fd7d1',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: '3rd Party Commissions',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '47bbbb15_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '47bbbb15_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: '3rd Party Commissions',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '47bbbb15_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '47bbbb15_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: '3rd Party Commissions',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '47bbbb15_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '47bbbb15_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: '3rd Party Commissions',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 50,
              perc: 0,
              percAvg: 0.0006,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 50,
              percent: 0,
              percentAVG: 0.0006,
              cellID: '47bbbb15_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '47bbbb15_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: '3rd Party Commissions',
              path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '47bbbb15_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '47bbbb15_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'd484c66b_@_18',
          cellID: 'd484c66b_@_18_-x-_0',
          amountTitle: 'Total Transaction Related Expenses',
          refTitle: 'Total Transaction Related Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'd484c66b_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'd484c66b_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Total Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'd484c66b_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'd484c66b_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Total Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'd484c66b_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'd484c66b_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Total Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 50,
              perc: 0,
              percAvg: 0.0006,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 50,
              percent: 0,
              percentAVG: 0.0006,
              cellID: 'd484c66b_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'd484c66b_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Total Transaction Related Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'd484c66b_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'd484c66b_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'edd65db2_@_18',
          cellID: 'edd65db2_@_18_-x-_0',
          amountTitle: 'Marketing & Advertising',
          refTitle: 'Marketing & Advertising',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 6250,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          display: 'default',
          children: ['c61b398a_@_18', '1dc3b3a3_@_18'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: 'edd65db2_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'edd65db2_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: 'edd65db2_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'edd65db2_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'edd65db2_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'edd65db2_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'edd65db2_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'edd65db2_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'edd65db2_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'edd65db2_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'c61b398a_@_18',
          cellID: 'c61b398a_@_18_-x-_0',
          amountTitle: 'Marketing & Public Relations',
          refTitle: 'Marketing & Public Relations',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6255,
          parent: 'edd65db2',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Marketing & Public Relations',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
                stats: {
                  mean: 386.598,
                  variance: 437527.793616,
                  stdDev: 661.4588374313249,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 388.88,
              perc: 0,
              percAvg: 0.0052,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 388.88,
              percent: 0,
              percentAVG: 0.0052,
              cellID: 'c61b398a_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'c61b398a_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Marketing & Public Relations',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
                stats: {
                  mean: 386.598,
                  variance: 437527.793616,
                  stdDev: 661.4588374313249,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 22.19,
              amtAvg: 388.88,
              perc: 0.0003,
              percAvg: 0.0057,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15441',
                  num: '',
                  name: 'GO DADDY.COM',
                  description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0586      480 5058855   * AZ',
                  amount: 22.19,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 388.88,
              percent: 0.0003,
              percentAVG: 0.0057,
              cellID: 'c61b398a_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: 'c61b398a_@_18',
              index: 1,
              cPercent: 0.0003258721007075493,
            },
            {
              date: '2025-07-07',
              title: 'Marketing & Public Relations',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
                stats: {
                  mean: 386.598,
                  variance: 437527.793616,
                  stdDev: 661.4588374313249,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 1700,
              perc: 0.0243,
              percAvg: 0.0243,
              dataRows: [
                {
                  txnDate: '2025-07-10',
                  type: 'Expense',
                  eventId: '15410',
                  num: '',
                  name: 'The Scene',
                  description: 'VISA DDA PUR AP - 406466     WWW THESCENENY COM          WWW THESCENEN * NY',
                  amount: 1700,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0243,
              percentAVG: 0.0243,
              cellID: 'c61b398a_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: 'c61b398a_@_18',
              index: 2,
              cPercent: 0.02427643028516095,
            },
            {
              date: '2025-06-30',
              title: 'Marketing & Public Relations',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
                stats: {
                  mean: 386.598,
                  variance: 437527.793616,
                  stdDev: 661.4588374313249,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 556.85,
              perc: 0,
              percAvg: 0.0062,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Expense',
                  eventId: '15201',
                  num: '',
                  name: 'Adentro Inc',
                  description: 'ADENTRO INC      ZENREACH',
                  amount: 89,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Deposit',
                  eventId: '15202',
                  num: '',
                  name: 'Adentro Inc',
                  description: 'ADENTRO INC      ZENREACH',
                  amount: -89,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 556.85,
              percent: 0,
              percentAVG: 0.0062,
              cellID: 'c61b398a_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 2,
              id: 'c61b398a_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Marketing & Public Relations',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
                stats: {
                  mean: 386.598,
                  variance: 437527.793616,
                  stdDev: 661.4588374313249,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 210.8,
              perc: 0.0032,
              percAvg: 0.0032,
              dataRows: [
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14850',
                  num: '',
                  name: 'GO DADDY.COM',
                  description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0986      480 5058855   * AZ',
                  amount: 210.8,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0032,
              percentAVG: 0.0032,
              cellID: 'c61b398a_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'c61b398a_@_18',
              index: 4,
              cPercent: 0.0031731623920044742,
            },
          ],
          anomalies: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
        },
        {
          id: '1dc3b3a3_@_18',
          cellID: '1dc3b3a3_@_18_-x-_0',
          amountTitle: 'Advertising & Promotions',
          refTitle: 'Advertising & Promotions',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6260,
          parent: 'edd65db2',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Advertising & Promotions',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1227.09],
                anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
                stats: {
                  mean: 486.81800000000004,
                  variance: 168303.20849599998,
                  stdDev: 410.2477403910959,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
                stats: {
                  mean: 1.8,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 548,
              amtAvg: 466.08,
              perc: 0.0073,
              percAvg: 0.0062,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15524',
                  num: '',
                  name: 'Popmenu Inc.',
                  description: 'VISA DDA PUR AP - 401134     POPMENU INC                 POPMENU COM   * GA',
                  amount: 548,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 466.08,
              percent: 0.0073,
              percentAVG: 0.0062,
              cellID: '1dc3b3a3_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '1dc3b3a3_@_18',
              index: 0,
              cPercent: 0.007325505914410285,
            },
            {
              date: '2025-07-14',
              title: 'Advertising & Promotions',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1227.09],
                anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
                stats: {
                  mean: 486.81800000000004,
                  variance: 168303.20849599998,
                  stdDev: 410.2477403910959,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
                stats: {
                  mean: 1.8,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 289,
              amtAvg: 466.08,
              perc: 0.0042,
              percAvg: 0.0068,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15226',
                  num: '',
                  name: 'Facebook',
                  description: 'VISA DDA PUR AP - 420429     FACEBK  8V9TBVCVK2          650 5434800   * CA',
                  amount: 289,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 466.08,
              percent: 0.0042,
              percentAVG: 0.0068,
              cellID: '1dc3b3a3_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '1dc3b3a3_@_18',
              index: 1,
              cPercent: 0.004244120644636401,
            },
            {
              date: '2025-07-07',
              title: 'Advertising & Promotions',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1227.09],
                anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
                stats: {
                  mean: 486.81800000000004,
                  variance: 168303.20849599998,
                  stdDev: 410.2477403910959,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
                stats: {
                  mean: 1.8,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '1dc3b3a3_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '1dc3b3a3_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Advertising & Promotions',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1227.09],
                anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
                stats: {
                  mean: 486.81800000000004,
                  variance: 168303.20849599998,
                  stdDev: 410.2477403910959,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
                stats: {
                  mean: 1.8,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 1227.09,
              amtAvg: 453.17,
              perc: 0.0136,
              percAvg: 0.005,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Expense',
                  eventId: '14749',
                  num: '',
                  name: 'Facebook',
                  description: 'VISA DDA PUR AP - 420429     FACEBK  4GXXCVYUK2          650 5434800   * CA',
                  amount: 18.14,
                },
                {
                  txnDate: '2025-07-01',
                  type: 'Expense',
                  eventId: '14750',
                  num: '',
                  name: 'Facebook',
                  description: 'VISA DDA PUR AP - 420429     FACEBK  UDDR8UQUK2          650 5434800   * CA',
                  amount: 98.26,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14847',
                  num: '',
                  name: 'Google',
                  description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE THE AINSWO    650 2530000   * CA',
                  amount: 237.79,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14848',
                  num: '',
                  name: 'Google',
                  description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE PAIGECONCE    650 2530000   * CA',
                  amount: 522.99,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14849',
                  num: '',
                  name: 'Google',
                  description: 'VISA DDA PUR AP - 420429     GOOGLE ADSXXXXXX3399        650 2530000   * CA',
                  amount: 349.91,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 453.17,
              percent: 0.0136,
              percentAVG: 0.005,
              cellID: '1dc3b3a3_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 5,
              id: '1dc3b3a3_@_18',
              index: 3,
              cPercent: 0.013618485955176826,
            },
            {
              date: '2025-06-23',
              title: 'Advertising & Promotions',
              path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1227.09],
                anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
                stats: {
                  mean: 486.81800000000004,
                  variance: 168303.20849599998,
                  stdDev: 410.2477403910959,
                },
              },
              trxAnomaly: {
                anomalies: [5],
                anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
                stats: {
                  mean: 1.8,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 370,
              perc: 0.0056,
              percAvg: 0.0056,
              dataRows: [
                {
                  txnDate: '2025-06-24',
                  type: 'Expense',
                  eventId: '14558',
                  num: '',
                  name: 'Facebook',
                  description: 'VISA DDA PUR AP - 420429     FACEBK  KR7KAXUUK2          650 5434800   * CA',
                  amount: 262,
                },
                {
                  txnDate: '2025-06-29',
                  type: 'Journal Entry',
                  eventId: '14879',
                  num: 'Uber eats ADJ P6.25',
                  name: '',
                  description: 'Sum of Merchant promotions applied to the order',
                  amount: 108,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0056,
              percentAVG: 0.0056,
              cellID: '1dc3b3a3_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 2,
              id: '1dc3b3a3_@_18',
              index: 4,
              cPercent: 0.005569592433783944,
            },
          ],
          anomalies: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
        },
        {
          id: '024ba9eb_@_18',
          cellID: '024ba9eb_@_18_-x-_0',
          amountTitle: 'Total Marketing & Advertising',
          refTitle: 'Total Marketing & Advertising',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
                stats: {
                  mean: 873.4159999999999,
                  variance: 263188.835784,
                  stdDev: 513.0193327585229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 548,
              amtAvg: 854.96,
              perc: 0.0073,
              percAvg: 0.0114,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 854.96,
              percent: 0.0073,
              percentAVG: 0.0114,
              cellID: '024ba9eb_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '024ba9eb_@_18',
              index: 0,
              cPercent: 0.007325505914410285,
            },
            {
              date: '2025-07-14',
              title: 'Total Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
                stats: {
                  mean: 873.4159999999999,
                  variance: 263188.835784,
                  stdDev: 513.0193327585229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 311.19,
              amtAvg: 854.96,
              perc: 0.0046,
              percAvg: 0.0126,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 854.96,
              percent: 0.0046,
              percentAVG: 0.0126,
              cellID: '024ba9eb_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '024ba9eb_@_18',
              index: 1,
              cPercent: 0.00456999274534395,
            },
            {
              date: '2025-07-07',
              title: 'Total Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
                stats: {
                  mean: 873.4159999999999,
                  variance: 263188.835784,
                  stdDev: 513.0193327585229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1700,
              amtAvg: 1700,
              perc: 0.0243,
              percAvg: 0.0243,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 1700,
              percent: 0.0243,
              percentAVG: 0.0243,
              cellID: '024ba9eb_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '024ba9eb_@_18',
              index: 2,
              cPercent: 0.02427643028516095,
            },
            {
              date: '2025-06-30',
              title: 'Total Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
                stats: {
                  mean: 873.4159999999999,
                  variance: 263188.835784,
                  stdDev: 513.0193327585229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1227.09,
              amtAvg: 1010.02,
              perc: 0.0136,
              percAvg: 0.0112,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 1010.02,
              percent: 0.0136,
              percentAVG: 0.0112,
              cellID: '024ba9eb_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '024ba9eb_@_18',
              index: 3,
              cPercent: 0.013618485955176826,
            },
            {
              date: '2025-06-23',
              title: 'Total Marketing & Advertising',
              path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1700],
                anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
                stats: {
                  mean: 873.4159999999999,
                  variance: 263188.835784,
                  stdDev: 513.0193327585229,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 580.8,
              amtAvg: 580.8,
              perc: 0.0087,
              percAvg: 0.0087,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 580.8,
              percent: 0.0087,
              percentAVG: 0.0087,
              cellID: '024ba9eb_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '024ba9eb_@_18',
              index: 4,
              cPercent: 0.008742754825788417,
            },
          ],
          anomalies: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
        },
        {
          id: '0c83dbac_@_18',
          cellID: '0c83dbac_@_18_-x-_0',
          amountTitle: 'Music & DJ',
          refTitle: 'Music & DJ',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 6305,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Music & DJ',
              path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '0c83dbac_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '0c83dbac_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Music & DJ',
              path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '0c83dbac_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '0c83dbac_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Music & DJ',
              path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '0c83dbac_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '0c83dbac_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Music & DJ',
              path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 113.42,
              perc: 0,
              percAvg: 0.0013,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 113.42,
              percent: 0,
              percentAVG: 0.0013,
              cellID: '0c83dbac_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '0c83dbac_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Music & DJ',
              path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 500,
              perc: 0.0075,
              percAvg: 0.0075,
              dataRows: [
                {
                  txnDate: '2025-06-25',
                  type: 'Check',
                  eventId: '14857',
                  num: '6502092',
                  name: 'YNVS Media LLC',
                  description: 'POD CHECK',
                  amount: 500,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0075,
              percentAVG: 0.0075,
              cellID: '0c83dbac_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '0c83dbac_@_18',
              index: 4,
              cPercent: 0.007526476261870195,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '6f7c6ca5_@_18',
          cellID: '6f7c6ca5_@_18_-x-_0',
          amountTitle: 'General & Administrative Expenses',
          refTitle: 'General & Administrative Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 6500,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          display: 'default',
          children: [
            '5a0fedcf_@_18',
            'b08821c2_@_18',
            'a630ac37_@_18',
            '975961bc_@_18',
            '9450bb96_@_18',
            '236c5723_@_18',
            'c3c23383_@_18',
            '058d9b25_@_18',
            '0c2b505e_@_18',
            '9dc533d9_@_18',
          ],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '6f7c6ca5_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '6f7c6ca5_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '6f7c6ca5_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '6f7c6ca5_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '6f7c6ca5_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '6f7c6ca5_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '6f7c6ca5_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '6f7c6ca5_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '6f7c6ca5_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '6f7c6ca5_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '5a0fedcf_@_18',
          cellID: '5a0fedcf_@_18_-x-_0',
          amountTitle: 'Accounting & Bookkeeping',
          refTitle: 'Accounting & Bookkeeping',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6505,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Accounting & Bookkeeping',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 338.48,
              perc: 0,
              percAvg: 0.0045,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 338.48,
              percent: 0,
              percentAVG: 0.0045,
              cellID: '5a0fedcf_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '5a0fedcf_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Accounting & Bookkeeping',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 338.48,
              perc: 0,
              percAvg: 0.005,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 338.48,
              percent: 0,
              percentAVG: 0.005,
              cellID: '5a0fedcf_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '5a0fedcf_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Accounting & Bookkeeping',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '5a0fedcf_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '5a0fedcf_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Accounting & Bookkeeping',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1499,
              amtAvg: 340.1,
              perc: 0.0166,
              percAvg: 0.0038,
              dataRows: [
                {
                  txnDate: '2025-07-01',
                  type: 'Bill',
                  eventId: '14560',
                  num: 'INV-12776-7690',
                  name: 'KitchenSync LLC',
                  description: '',
                  amount: 1499,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 340.1,
              percent: 0.0166,
              percentAVG: 0.0038,
              cellID: '5a0fedcf_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '5a0fedcf_@_18',
              index: 3,
              cPercent: 0.016636196568149086,
            },
            {
              date: '2025-06-23',
              title: 'Accounting & Bookkeeping',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              cellID: '5a0fedcf_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '5a0fedcf_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'b08821c2_@_18',
          cellID: 'b08821c2_@_18_-x-_0',
          amountTitle: 'Consulting',
          refTitle: 'Consulting',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6510,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Consulting',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'b08821c2_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'b08821c2_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Consulting',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'b08821c2_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'b08821c2_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Consulting',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'b08821c2_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'b08821c2_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Consulting',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 41.67,
              perc: 0,
              percAvg: 0.0005,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 41.67,
              percent: 0,
              percentAVG: 0.0005,
              cellID: 'b08821c2_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'b08821c2_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Consulting',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1250,
              perc: 0.0188,
              percAvg: 0.0188,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Check',
                  eventId: '14676',
                  num: '6502084',
                  name: 'Shaun Rose',
                  description: 'CHECK 6502084',
                  amount: 1250,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0188,
              percentAVG: 0.0188,
              cellID: 'b08821c2_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'b08821c2_@_18',
              index: 4,
              cPercent: 0.018816190654675487,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'a630ac37_@_18',
          cellID: 'a630ac37_@_18_-x-_0',
          amountTitle: 'Legal',
          refTitle: 'Legal',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6520,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Legal',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1444.206,
                  variance: 686438.0999040001,
                  stdDev: 828.5156002779912,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 1233.49,
              amtAvg: 658.11,
              perc: 0.0165,
              percAvg: 0.0088,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15623',
                  num: '',
                  name: 'At Law',
                  description: 'WIRE TRANSFER OUTGOING - Collection At Law',
                  amount: 1233.49,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 658.11,
              percent: 0.0165,
              percentAVG: 0.0088,
              cellID: 'a630ac37_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: 'a630ac37_@_18',
              index: 0,
              cPercent: 0.01648893848606924,
            },
            {
              date: '2025-07-14',
              title: 'Legal',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1444.206,
                  variance: 686438.0999040001,
                  stdDev: 828.5156002779912,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 658.11,
              perc: 0,
              percAvg: 0.0097,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 658.11,
              percent: 0,
              percentAVG: 0.0097,
              cellID: 'a630ac37_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'a630ac37_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Legal',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1444.206,
                  variance: 686438.0999040001,
                  stdDev: 828.5156002779912,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 1681,
              perc: 0.024,
              percAvg: 0.024,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '15384',
                  num: '',
                  name: 'At Law',
                  description: 'WIRE TRANSFER OUTGOING - Collection At Law',
                  amount: 1681,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.024,
              percentAVG: 0.024,
              cellID: 'a630ac37_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: 'a630ac37_@_18',
              index: 2,
              cPercent: 0.024005105476091505,
            },
            {
              date: '2025-06-30',
              title: 'Legal',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1444.206,
                  variance: 686438.0999040001,
                  stdDev: 828.5156002779912,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 2500,
              amtAvg: 791.01,
              perc: 0.0277,
              percAvg: 0.0088,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Check',
                  eventId: '14882',
                  num: '2095',
                  name: 'Matthew J Keating Attorney',
                  description: 'CHECK 2095',
                  amount: 2500,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 791.01,
              percent: 0.0277,
              percentAVG: 0.0088,
              cellID: 'a630ac37_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: 'a630ac37_@_18',
              index: 3,
              cPercent: 0.027745491274431433,
            },
            {
              date: '2025-06-23',
              title: 'Legal',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1444.206,
                  variance: 686438.0999040001,
                  stdDev: 828.5156002779912,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.16000000000000006,
                  stdDev: 0.4000000000000001,
                },
              },
              trxFlagged: [],
              amount: 1806.54,
              perc: 0.0272,
              percAvg: 0.0272,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Check',
                  eventId: '14679',
                  num: '6502064',
                  name: 'Matthew J Keating Attorney',
                  description: 'CHECK 6502064',
                  amount: 1806.54,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0272,
              percentAVG: 0.0272,
              cellID: 'a630ac37_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'a630ac37_@_18',
              index: 4,
              cPercent: 0.02719376085223796,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
        },
        {
          id: '975961bc_@_18',
          cellID: '975961bc_@_18_-x-_0',
          amountTitle: 'Payroll Processing Fees',
          refTitle: 'Payroll Processing Fees',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6525,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Payroll Processing Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 38.96,
              perc: 0,
              percAvg: 0.0005,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 38.96,
              percent: 0,
              percentAVG: 0.0005,
              cellID: '975961bc_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '975961bc_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Payroll Processing Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 92.53,
              amtAvg: 38.96,
              perc: 0.0014,
              percAvg: 0.0006,
              dataRows: [
                {
                  txnDate: '2025-07-15',
                  type: 'Expense',
                  eventId: '15445',
                  num: '',
                  name: '7Shifts',
                  description: 'VISA DDA PUR AP - 401134     7SHIFTS                     7SHIFTS COM   * DE',
                  amount: 92.53,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 38.96,
              percent: 0.0014,
              percentAVG: 0.0006,
              cellID: '975961bc_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '975961bc_@_18',
              index: 1,
              cPercent: 0.001358852883211786,
            },
            {
              date: '2025-07-07',
              title: 'Payroll Processing Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '975961bc_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '975961bc_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Payroll Processing Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 80,
              amtAvg: 95.64,
              perc: 0.0009,
              percAvg: 0.0011,
              dataRows: [
                {
                  txnDate: '2025-07-06',
                  type: 'Journal Entry',
                  eventId: '15268',
                  num: 'PR 06.30 to 07.06',
                  name: '',
                  description: 'Invoices: Ains hoboken - 7/16/2025 - Shipping Fee',
                  amount: 80,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 95.64,
              percent: 0.0009,
              percentAVG: 0.0011,
              cellID: '975961bc_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '975961bc_@_18',
              index: 3,
              cPercent: 0.0008878557207818059,
            },
            {
              date: '2025-06-23',
              title: 'Payroll Processing Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '975961bc_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '975961bc_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '9450bb96_@_18',
          cellID: '9450bb96_@_18_-x-_0',
          amountTitle: 'Computer Supplies, Software & IT',
          refTitle: 'Computer Supplies, Software & IT',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6535,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Computer Supplies, Software & IT',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 350.15,
              perc: 0,
              percAvg: 0.0047,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 350.15,
              percent: 0,
              percentAVG: 0.0047,
              cellID: '9450bb96_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '9450bb96_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Computer Supplies, Software & IT',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1440.67,
              amtAvg: 350.15,
              perc: 0.0212,
              percAvg: 0.0051,
              dataRows: [
                {
                  txnDate: '2025-07-15',
                  type: 'Expense',
                  eventId: '15443',
                  num: '',
                  name: 'Tripleseat',
                  description: 'VISA DDA PUR AP - 490641     PST TRIPLESEAT              978 2916436   * MA',
                  amount: 406.67,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Expense',
                  eventId: '15494',
                  num: '',
                  name: 'Toast Inc',
                  description: 'TOAST, INC       TOAST, INC',
                  amount: 1034,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 350.15,
              percent: 0.0212,
              percentAVG: 0.0051,
              cellID: '9450bb96_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: '9450bb96_@_18',
              index: 1,
              cPercent: 0.021157014841205274,
            },
            {
              date: '2025-07-07',
              title: 'Computer Supplies, Software & IT',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 110,
              perc: 0.0016,
              percAvg: 0.0016,
              dataRows: [
                {
                  txnDate: '2025-07-09',
                  type: 'Expense',
                  eventId: '15261',
                  num: '',
                  name: 'MarginEdge',
                  description: 'MARGINEDGE       XXXXXX9612',
                  amount: 110,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0016,
              percentAVG: 0.0016,
              cellID: '9450bb96_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '9450bb96_@_18',
              index: 2,
              cPercent: 0.0015708278419810026,
            },
            {
              date: '2025-06-30',
              title: 'Computer Supplies, Software & IT',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 353.18,
              perc: 0,
              percAvg: 0.0039,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 353.18,
              percent: 0,
              percentAVG: 0.0039,
              cellID: '9450bb96_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '9450bb96_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Computer Supplies, Software & IT',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '9450bb96_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '9450bb96_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '236c5723_@_18',
          cellID: '236c5723_@_18_-x-_0',
          amountTitle: 'Dues and Subscriptions',
          refTitle: 'Dues and Subscriptions',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6550,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Dues and Subscriptions',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 12.78,
              amtAvg: 28.71,
              perc: 0.0002,
              percAvg: 0.0004,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15529',
                  num: '',
                  name: 'Spotify',
                  description: 'VISA DDA PUR AP - 420429     SPOTIFY USA                 877 7781161   * NY',
                  amount: 12.78,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 28.71,
              percent: 0.0002,
              percentAVG: 0.0004,
              cellID: '236c5723_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '236c5723_@_18',
              index: 0,
              cPercent: 0.00017083935325942233,
            },
            {
              date: '2025-07-14',
              title: 'Dues and Subscriptions',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 28.71,
              perc: 0,
              percAvg: 0.0004,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 28.71,
              percent: 0,
              percentAVG: 0.0004,
              cellID: '236c5723_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '236c5723_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Dues and Subscriptions',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '236c5723_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '236c5723_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Dues and Subscriptions',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 114.36,
              amtAvg: 73.06,
              perc: 0.0013,
              percAvg: 0.0008,
              dataRows: [
                {
                  txnDate: '2025-07-03',
                  type: 'Expense',
                  eventId: '14844',
                  num: '',
                  name: 'Resy',
                  description: 'RESYNETWORKINC   RESYNETWOR',
                  amount: 114.36,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 73.06,
              percent: 0.0013,
              percentAVG: 0.0008,
              cellID: '236c5723_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '236c5723_@_18',
              index: 3,
              cPercent: 0.0012691897528575914,
            },
            {
              date: '2025-06-23',
              title: 'Dues and Subscriptions',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '236c5723_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '236c5723_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'c3c23383_@_18',
          cellID: 'c3c23383_@_18_-x-_0',
          amountTitle: 'Bank Charges & Fees',
          refTitle: 'Bank Charges & Fees',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6560,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Bank Charges & Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 46,
                  variance: 1624,
                  stdDev: 40.29888335921977,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.8400000000000003,
                  stdDev: 1.3564659966250538,
                },
              },
              trxFlagged: [],
              amount: 90,
              amtAvg: 47.42,
              perc: 0.0012,
              percAvg: 0.0006,
              dataRows: [
                {
                  txnDate: '2025-07-22',
                  type: 'Expense',
                  eventId: '15609',
                  num: '',
                  name: 'Bank Charges',
                  description: 'WIRE TRANSFER FEE',
                  amount: 30,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15610',
                  num: '',
                  name: 'Bank Charges',
                  description: 'WIRE TRANSFER FEE',
                  amount: 30,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15611',
                  num: '',
                  name: 'Bank Charges',
                  description: 'WIRE TRANSFER FEE',
                  amount: 30,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 47.42,
              percent: 0.0012,
              percentAVG: 0.0006,
              cellID: 'c3c23383_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 3,
              id: 'c3c23383_@_18',
              index: 0,
              cPercent: 0.0012030940370381855,
            },
            {
              date: '2025-07-14',
              title: 'Bank Charges & Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 46,
                  variance: 1624,
                  stdDev: 40.29888335921977,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.8400000000000003,
                  stdDev: 1.3564659966250538,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 47.42,
              perc: 0,
              percAvg: 0.0007,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 47.42,
              percent: 0,
              percentAVG: 0.0007,
              cellID: 'c3c23383_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'c3c23383_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Bank Charges & Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 46,
                  variance: 1624,
                  stdDev: 40.29888335921977,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.8400000000000003,
                  stdDev: 1.3564659966250538,
                },
              },
              trxFlagged: [],
              amount: 90,
              perc: 0.0013,
              percAvg: 0.0013,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '14767',
                  num: '',
                  name: 'Bank Charges',
                  description: 'WIRE TRANSFER FEE',
                  amount: 30,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '14768',
                  num: '',
                  name: 'Bank Charges',
                  description: 'WIRE TRANSFER FEE',
                  amount: 30,
                },
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '14769',
                  num: '',
                  name: 'Bank Charges',
                  description: 'WIRE TRANSFER FEE',
                  amount: 30,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0013,
              percentAVG: 0.0013,
              cellID: 'c3c23383_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 3,
              id: 'c3c23383_@_18',
              index: 2,
              cPercent: 0.0012852227798026386,
            },
            {
              date: '2025-06-30',
              title: 'Bank Charges & Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 46,
                  variance: 1624,
                  stdDev: 40.29888335921977,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.8400000000000003,
                  stdDev: 1.3564659966250538,
                },
              },
              trxFlagged: [],
              amount: 50,
              amtAvg: 47.31,
              perc: 0.0006,
              percAvg: 0.0005,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Expense',
                  eventId: '15203',
                  num: '',
                  name: 'Bank Charges',
                  description: 'MAINTENANCE FEE',
                  amount: 20,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14766',
                  num: '',
                  name: 'Bank Charges',
                  description: 'WIRE TRANSFER FEE',
                  amount: 30,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 47.31,
              percent: 0.0006,
              percentAVG: 0.0005,
              cellID: 'c3c23383_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 2,
              id: 'c3c23383_@_18',
              index: 3,
              cPercent: 0.0005549098254886286,
            },
            {
              date: '2025-06-23',
              title: 'Bank Charges & Fees',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 46,
                  variance: 1624,
                  stdDev: 40.29888335921977,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1.6,
                  variance: 1.8400000000000003,
                  stdDev: 1.3564659966250538,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'c3c23383_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'c3c23383_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
        },
        {
          id: '058d9b25_@_18',
          cellID: '058d9b25_@_18_-x-_0',
          amountTitle: 'Office Supplies & Expenses',
          refTitle: 'Office Supplies & Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6575,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Office Supplies & Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3521.12],
                anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
                stats: {
                  mean: 1367.336,
                  variance: 1349481.5646639995,
                  stdDev: 1161.671883392208,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
                stats: {
                  mean: 8.2,
                  variance: 15.36,
                  stdDev: 3.919183588453085,
                },
              },
              trxFlagged: [],
              amount: 3521.12,
              amtAvg: 1390.72,
              perc: 0.0471,
              percAvg: 0.0186,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15517',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 1086.51,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15518',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 318.9,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15519',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 51.17,
                },
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15638',
                  num: '6502345',
                  name: 'Meow Hospitality LLC',
                  description: 'POD CHECK',
                  amount: 1063,
                },
                {
                  txnDate: '2025-07-22',
                  type: 'Expense',
                  eventId: '15625',
                  num: '',
                  name: 'CVS Pharmacy',
                  description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
                  amount: 802.22,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15575',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 62.37,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15576',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 44.77,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15577',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 56.5,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15579',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 14.49,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Expense',
                  eventId: '15578',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 14.8,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Expense',
                  eventId: '15581',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 6.39,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 1390.72,
              percent: 0.0471,
              percentAVG: 0.0186,
              cellID: '058d9b25_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 11,
              id: '058d9b25_@_18',
              index: 0,
              cPercent: 0.04706931639662106,
            },
            {
              date: '2025-07-14',
              title: 'Office Supplies & Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3521.12],
                anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
                stats: {
                  mean: 1367.336,
                  variance: 1349481.5646639995,
                  stdDev: 1161.671883392208,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
                stats: {
                  mean: 8.2,
                  variance: 15.36,
                  stdDev: 3.919183588453085,
                },
              },
              trxFlagged: [],
              amount: 1286.21,
              amtAvg: 1390.72,
              perc: 0.0189,
              percAvg: 0.0204,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15225',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 122.46,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15230',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 26.02,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15231',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 271.88,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15234',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 400.34,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15237',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 41.56,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Expense',
                  eventId: '15220',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 7.45,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Expense',
                  eventId: '15318',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 55.98,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15315',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 63.96,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15316',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 181.16,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15317',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 49.38,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Expense',
                  eventId: '15323',
                  num: '',
                  name: 'The Home Depot',
                  description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
                  amount: 66.02,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 1390.72,
              percent: 0.0189,
              percentAVG: 0.0204,
              cellID: '058d9b25_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 11,
              id: '058d9b25_@_18',
              index: 1,
              cPercent: 0.018888686554802026,
            },
            {
              date: '2025-07-07',
              title: 'Office Supplies & Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3521.12],
                anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
                stats: {
                  mean: 1367.336,
                  variance: 1349481.5646639995,
                  stdDev: 1161.671883392208,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
                stats: {
                  mean: 8.2,
                  variance: 15.36,
                  stdDev: 3.919183588453085,
                },
              },
              trxFlagged: [],
              amount: 19.18,
              perc: 0.0003,
              percAvg: 0.0003,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Expense',
                  eventId: '14730',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 19.18,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0003,
              percentAVG: 0.0003,
              cellID: '058d9b25_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '058d9b25_@_18',
              index: 2,
              cPercent: 0.0002738952546290512,
            },
            {
              date: '2025-06-30',
              title: 'Office Supplies & Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3521.12],
                anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
                stats: {
                  mean: 1367.336,
                  variance: 1349481.5646639995,
                  stdDev: 1161.671883392208,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
                stats: {
                  mean: 8.2,
                  variance: 15.36,
                  stdDev: 3.919183588453085,
                },
              },
              trxFlagged: [],
              amount: 900.05,
              amtAvg: 1318.4,
              perc: 0.01,
              percAvg: 0.0146,
              dataRows: [
                {
                  txnDate: '2025-06-30',
                  type: 'Expense',
                  eventId: '14727',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 13.53,
                },
                {
                  txnDate: '2025-06-30',
                  type: 'Expense',
                  eventId: '14731',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 1.75,
                },
                {
                  txnDate: '2025-06-30',
                  type: 'Expense',
                  eventId: '14736',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 4.99,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14728',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 38.65,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14729',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 85.3,
                },
                {
                  txnDate: '2025-07-02',
                  type: 'Deposit',
                  eventId: '14845',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA REF - 469216     AMAZON MKTPLACE PMTS        AMZN COM BILL * WA',
                  amount: -244.17,
                },
                {
                  txnDate: '2025-07-03',
                  type: 'Check',
                  eventId: '15334',
                  num: '6502210',
                  name: 'Meow Hospitality LLC',
                  description: 'POD CHECK',
                  amount: 1000,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 1318.4,
              percent: 0.01,
              percentAVG: 0.0146,
              cellID: '058d9b25_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 7,
              id: '058d9b25_@_18',
              index: 3,
              cPercent: 0.009988931768620804,
            },
            {
              date: '2025-06-23',
              title: 'Office Supplies & Expenses',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3521.12],
                anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
                stats: {
                  mean: 1367.336,
                  variance: 1349481.5646639995,
                  stdDev: 1161.671883392208,
                },
              },
              trxAnomaly: {
                anomalies: [1],
                anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
                stats: {
                  mean: 8.2,
                  variance: 15.36,
                  stdDev: 3.919183588453085,
                },
              },
              trxFlagged: [],
              amount: 1110.12,
              perc: 0.0167,
              percAvg: 0.0167,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14548',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 21.3,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14594',
                  num: '',
                  name: 'The Home Depot',
                  description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
                  amount: 127.91,
                },
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14596',
                  num: '',
                  name: 'CVS Pharmacy',
                  description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
                  amount: 771.5,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Expense',
                  eventId: '14565',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 46.04,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Expense',
                  eventId: '14566',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 15.98,
                },
                {
                  txnDate: '2025-06-25',
                  type: 'Expense',
                  eventId: '14567',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 6.39,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Expense',
                  eventId: '14732',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 23.35,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Expense',
                  eventId: '14733',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 42.64,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14726',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 7.85,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14734',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 19.18,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14735',
                  num: '',
                  name: 'Amazon',
                  description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
                  amount: 27.98,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0167,
              percentAVG: 0.0167,
              cellID: '058d9b25_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 11,
              id: '058d9b25_@_18',
              index: 4,
              cPercent: 0.016710583655654677,
            },
          ],
          anomalies: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
        },
        {
          id: '0c2b505e_@_18',
          cellID: '0c2b505e_@_18_-x-_0',
          amountTitle: 'Phone and Internet',
          refTitle: 'Phone and Internet',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6605,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Phone and Internet',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 88.8,
              perc: 0,
              percAvg: 0.0012,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 88.8,
              percent: 0,
              percentAVG: 0.0012,
              cellID: '0c2b505e_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '0c2b505e_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Phone and Internet',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 393.24,
              amtAvg: 88.8,
              perc: 0.0058,
              percAvg: 0.0013,
              dataRows: [
                {
                  txnDate: '2025-07-17',
                  type: 'Expense',
                  eventId: '15495',
                  num: '',
                  name: 'Optimum',
                  description: 'OPTIMUM 7862     CABLE PMNT',
                  amount: 393.24,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 88.8,
              percent: 0.0058,
              percentAVG: 0.0013,
              cellID: '0c2b505e_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '0c2b505e_@_18',
              index: 1,
              cPercent: 0.005774941184418057,
            },
            {
              date: '2025-07-07',
              title: 'Phone and Internet',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '0c2b505e_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '0c2b505e_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Phone and Internet',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 100.39,
              perc: 0,
              percAvg: 0.0011,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 100.39,
              percent: 0,
              percentAVG: 0.0011,
              cellID: '0c2b505e_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '0c2b505e_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Phone and Internet',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 334.99,
              perc: 0.005,
              percAvg: 0.005,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14595',
                  num: '',
                  name: 'DirecTV',
                  description: 'VISA DDA PUR AP - 469216     SPI DIRECTV SERVICE         800 531 5000  * CA',
                  amount: 334.99,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.005,
              percentAVG: 0.005,
              cellID: '0c2b505e_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '0c2b505e_@_18',
              index: 4,
              cPercent: 0.005042588565927793,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '9dc533d9_@_18',
          cellID: '9dc533d9_@_18_-x-_0',
          amountTitle: 'Security',
          refTitle: 'Security',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6610,
          parent: '6f7c6ca5',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Security',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '9dc533d9_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '9dc533d9_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Security',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '9dc533d9_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '9dc533d9_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Security',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '9dc533d9_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '9dc533d9_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Security',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 31.67,
              perc: 0,
              percAvg: 0.0004,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 31.67,
              percent: 0,
              percentAVG: 0.0004,
              cellID: '9dc533d9_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '9dc533d9_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Security',
              path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 950,
              perc: 0.0143,
              percAvg: 0.0143,
              dataRows: [
                {
                  txnDate: '2025-06-27',
                  type: 'Check',
                  eventId: '14881',
                  num: '6502082',
                  name: 'Herve Bertrand',
                  description: 'CHECK 6502082 Security',
                  amount: 950,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0143,
              percentAVG: 0.0143,
              cellID: '9dc533d9_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '9dc533d9_@_18',
              index: 4,
              cPercent: 0.01430030489755337,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'f12db2ec_@_18',
          cellID: 'f12db2ec_@_18_-x-_0',
          amountTitle: 'Total General & Administrative Expenses',
          refTitle: 'Total General & Administrative Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1900.18],
                anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
                stats: {
                  mean: 4113.056,
                  variance: 1823009.5043839994,
                  stdDev: 1350.1886921404723,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 4857.389999999999,
              amtAvg: 2941.35,
              perc: 0.0649,
              percAvg: 0.0393,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 2941.35,
              percent: 0.0649,
              percentAVG: 0.0393,
              cellID: 'f12db2ec_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'f12db2ec_@_18',
              index: 0,
              cPercent: 0.0649321882729879,
            },
            {
              date: '2025-07-14',
              title: 'Total General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1900.18],
                anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
                stats: {
                  mean: 4113.056,
                  variance: 1823009.5043839994,
                  stdDev: 1350.1886921404723,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 3212.6499999999996,
              amtAvg: 2941.35,
              perc: 0.0472,
              percAvg: 0.0432,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 2941.35,
              percent: 0.0472,
              percentAVG: 0.0432,
              cellID: 'f12db2ec_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'f12db2ec_@_18',
              index: 1,
              cPercent: 0.04717949546363714,
            },
            {
              date: '2025-07-07',
              title: 'Total General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1900.18],
                anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
                stats: {
                  mean: 4113.056,
                  variance: 1823009.5043839994,
                  stdDev: 1350.1886921404723,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1900.18,
              amtAvg: 1900.18,
              perc: 0.0271,
              percAvg: 0.0271,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 1900.18,
              percent: 0.0271,
              percentAVG: 0.0271,
              cellID: 'f12db2ec_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'f12db2ec_@_18',
              index: 2,
              cPercent: 0.027135051352504196,
            },
            {
              date: '2025-06-30',
              title: 'Total General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1900.18],
                anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
                stats: {
                  mean: 4113.056,
                  variance: 1823009.5043839994,
                  stdDev: 1350.1886921404723,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 5143.41,
              amtAvg: 3192.43,
              perc: 0.0571,
              percAvg: 0.0354,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 3192.43,
              percent: 0.0571,
              percentAVG: 0.0354,
              cellID: 'f12db2ec_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'f12db2ec_@_18',
              index: 3,
              cPercent: 0.05708257491032935,
            },
            {
              date: '2025-06-23',
              title: 'Total General & Administrative Expenses',
              path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [1900.18],
                anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
                stats: {
                  mean: 4113.056,
                  variance: 1823009.5043839994,
                  stdDev: 1350.1886921404723,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 5451.65,
              amtAvg: 5451.65,
              perc: 0.0821,
              percAvg: 0.0821,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 5451.65,
              percent: 0.0821,
              percentAVG: 0.0821,
              cellID: 'f12db2ec_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'f12db2ec_@_18',
              index: 4,
              cPercent: 0.08206342862604929,
            },
          ],
          anomalies: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
        },
        {
          id: '084f517c_@_18',
          cellID: '084f517c_@_18_-x-_0',
          amountTitle: 'Travel, Meals, & Entertainment',
          refTitle: 'Travel, Meals, & Entertainment',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 6700,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          display: 'default',
          children: ['e4e1ab18_@_18', 'f245aeff_@_18', '3ae4b332_@_18', '4dbd49a9_@_18'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '084f517c_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '084f517c_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '084f517c_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '084f517c_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '084f517c_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '084f517c_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '084f517c_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '084f517c_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '084f517c_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '084f517c_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'e4e1ab18_@_18',
          cellID: 'e4e1ab18_@_18_-x-_0',
          amountTitle: 'Travel, Ground Transport & Airfare',
          refTitle: 'Travel, Ground Transport & Airfare',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6705,
          parent: '084f517c',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Travel, Ground Transport & Airfare',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [355.12],
                anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
                stats: {
                  mean: 190.34,
                  variance: 9766.42676,
                  stdDev: 98.82523341738182,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 355.12,
              amtAvg: 175.05,
              perc: 0.0047,
              percAvg: 0.0023,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15606',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 60.9,
                },
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15607',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 81.87,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Expense',
                  eventId: '15603',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 52.21,
                },
                {
                  txnDate: '2025-07-24',
                  type: 'Expense',
                  eventId: '15605',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
                  amount: 54.38,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Expense',
                  eventId: '15604',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 50.67,
                },
                {
                  txnDate: '2025-07-25',
                  type: 'Expense',
                  eventId: '15608',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 55.09,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 175.05,
              percent: 0.0047,
              percentAVG: 0.0023,
              cellID: 'e4e1ab18_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 6,
              id: 'e4e1ab18_@_18',
              index: 0,
              cPercent: 0.004747141715922227,
            },
            {
              date: '2025-07-14',
              title: 'Travel, Ground Transport & Airfare',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [355.12],
                anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
                stats: {
                  mean: 190.34,
                  variance: 9766.42676,
                  stdDev: 98.82523341738182,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 105.95,
              amtAvg: 175.05,
              perc: 0.0016,
              percAvg: 0.0026,
              dataRows: [
                {
                  txnDate: '2025-07-16',
                  type: 'Expense',
                  eventId: '15219',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 50.7,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Expense',
                  eventId: '15264',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
                  amount: 55.25,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 175.05,
              percent: 0.0016,
              percentAVG: 0.0026,
              cellID: 'e4e1ab18_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: 'e4e1ab18_@_18',
              index: 1,
              cPercent: 0.0015559328107239679,
            },
            {
              date: '2025-07-07',
              title: 'Travel, Ground Transport & Airfare',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [355.12],
                anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
                stats: {
                  mean: 190.34,
                  variance: 9766.42676,
                  stdDev: 98.82523341738182,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 235.02,
              perc: 0.0034,
              percAvg: 0.0034,
              dataRows: [
                {
                  txnDate: '2025-07-10',
                  type: 'Expense',
                  eventId: '15243',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 74.9,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Expense',
                  eventId: '15246',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 54.38,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Expense',
                  eventId: '15239',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 56.72,
                },
                {
                  txnDate: '2025-07-11',
                  type: 'Expense',
                  eventId: '15263',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
                  amount: 49.02,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0034,
              percentAVG: 0.0034,
              cellID: 'e4e1ab18_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 4,
              id: 'e4e1ab18_@_18',
              index: 2,
              cPercent: 0.003356145085657957,
            },
            {
              date: '2025-06-30',
              title: 'Travel, Ground Transport & Airfare',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [355.12],
                anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
                stats: {
                  mean: 190.34,
                  variance: 9766.42676,
                  stdDev: 98.82523341738182,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 79.12,
              amtAvg: 188.2,
              perc: 0.0009,
              percAvg: 0.0021,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '14764',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 79.12,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 188.2,
              percent: 0.0009,
              percentAVG: 0.0021,
              cellID: 'e4e1ab18_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: 'e4e1ab18_@_18',
              index: 3,
              cPercent: 0.000878089307853206,
            },
            {
              date: '2025-06-23',
              title: 'Travel, Ground Transport & Airfare',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [355.12],
                anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
                stats: {
                  mean: 190.34,
                  variance: 9766.42676,
                  stdDev: 98.82523341738182,
                },
              },
              trxAnomaly: {
                anomalies: [6],
                anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
                stats: {
                  mean: 3.2,
                  variance: 2.96,
                  stdDev: 1.7204650534085253,
                },
              },
              trxFlagged: [],
              amount: 176.49,
              perc: 0.0027,
              percAvg: 0.0027,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Expense',
                  eventId: '14581',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
                  amount: 68.96,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Expense',
                  eventId: '14765',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
                  amount: 50.66,
                },
                {
                  txnDate: '2025-06-26',
                  type: 'Expense',
                  eventId: '14841',
                  num: '',
                  name: 'Uber Trips',
                  description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
                  amount: 56.87,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0027,
              percentAVG: 0.0027,
              cellID: 'e4e1ab18_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 3,
              id: 'e4e1ab18_@_18',
              index: 4,
              cPercent: 0.0026566955909149413,
            },
          ],
          anomalies: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
        },
        {
          id: 'f245aeff_@_18',
          cellID: 'f245aeff_@_18_-x-_0',
          amountTitle: 'Meals & Entertainment',
          refTitle: 'Meals & Entertainment',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6710,
          parent: '084f517c',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Meals & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [871.17],
                anomalyScores: [0, 0.994177836334134, 0, 0, 0],
                stats: {
                  mean: 228.144,
                  variance: 104584.884624,
                  stdDev: 323.395863647017,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 86.91,
              amtAvg: 237.27,
              perc: 0.0012,
              percAvg: 0.0032,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Expense',
                  eventId: '15528',
                  num: '',
                  name: 'Plaza Mexico',
                  description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
                  amount: 86.91,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 237.27,
              percent: 0.0012,
              percentAVG: 0.0032,
              cellID: 'f245aeff_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: 'f245aeff_@_18',
              index: 0,
              cPercent: 0.0011617878084332078,
            },
            {
              date: '2025-07-14',
              title: 'Meals & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [871.17],
                anomalyScores: [0, 0.994177836334134, 0, 0, 0],
                stats: {
                  mean: 228.144,
                  variance: 104584.884624,
                  stdDev: 323.395863647017,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 871.17,
              amtAvg: 237.27,
              perc: 0.0128,
              percAvg: 0.0035,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Expense',
                  eventId: '15329',
                  num: '',
                  name: 'Plaza Mexico',
                  description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
                  amount: 71.17,
                },
                {
                  txnDate: '2025-07-16',
                  type: 'Check',
                  eventId: '15468',
                  num: '6502282',
                  name: 'Mamma Mia',
                  description: 'POD CHECK',
                  amount: 800,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 237.27,
              percent: 0.0128,
              percentAVG: 0.0035,
              cellID: 'f245aeff_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: 'f245aeff_@_18',
              index: 1,
              cPercent: 0.012793600629715893,
            },
            {
              date: '2025-07-07',
              title: 'Meals & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [871.17],
                anomalyScores: [0, 0.994177836334134, 0, 0, 0],
                stats: {
                  mean: 228.144,
                  variance: 104584.884624,
                  stdDev: 323.395863647017,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'f245aeff_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'f245aeff_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Meals & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [871.17],
                anomalyScores: [0, 0.994177836334134, 0, 0, 0],
                stats: {
                  mean: 228.144,
                  variance: 104584.884624,
                  stdDev: 323.395863647017,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 92.67,
              amtAvg: 240.66,
              perc: 0.001,
              percAvg: 0.0027,
              dataRows: [
                {
                  txnDate: '2025-07-03',
                  type: 'Expense',
                  eventId: '14834',
                  num: '',
                  name: 'Plaza Mexico',
                  description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
                  amount: 92.67,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 240.66,
              percent: 0.001,
              percentAVG: 0.0027,
              cellID: 'f245aeff_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: 'f245aeff_@_18',
              index: 3,
              cPercent: 0.0010284698705606244,
            },
            {
              date: '2025-06-23',
              title: 'Meals & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [871.17],
                anomalyScores: [0, 0.994177836334134, 0, 0, 0],
                stats: {
                  mean: 228.144,
                  variance: 104584.884624,
                  stdDev: 323.395863647017,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 89.97,
              perc: 0.0014,
              percAvg: 0.0014,
              dataRows: [
                {
                  txnDate: '2025-06-25',
                  type: 'Expense',
                  eventId: '14603',
                  num: '',
                  name: 'Plaza Mexico',
                  description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
                  amount: 89.97,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0014,
              percentAVG: 0.0014,
              cellID: 'f245aeff_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'f245aeff_@_18',
              index: 4,
              cPercent: 0.0013543141385609228,
            },
          ],
          anomalies: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
        },
        {
          id: '3ae4b332_@_18',
          cellID: '3ae4b332_@_18_-x-_0',
          amountTitle: 'Parking',
          refTitle: 'Parking',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6720,
          parent: '084f517c',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Parking',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1238,
              amtAvg: 279.55,
              perc: 0.0165,
              percAvg: 0.0037,
              dataRows: [
                {
                  txnDate: '2025-07-24',
                  type: 'Expense',
                  eventId: '15621',
                  num: '',
                  name: 'Hoboken Parking',
                  description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
                  amount: 1238,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 279.55,
              percent: 0.0165,
              percentAVG: 0.0037,
              cellID: '3ae4b332_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '3ae4b332_@_18',
              index: 0,
              cPercent: 0.016549226865036373,
            },
            {
              date: '2025-07-14',
              title: 'Parking',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 279.55,
              perc: 0,
              percAvg: 0.0041,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 279.55,
              percent: 0,
              percentAVG: 0.0041,
              cellID: '3ae4b332_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '3ae4b332_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Parking',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '3ae4b332_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '3ae4b332_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Parking',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 280.88,
              perc: 0,
              percAvg: 0.0031,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 280.88,
              percent: 0,
              percentAVG: 0.0031,
              cellID: '3ae4b332_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '3ae4b332_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Parking',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1238,
              perc: 0.0186,
              percAvg: 0.0186,
              dataRows: [
                {
                  txnDate: '2025-06-24',
                  type: 'Expense',
                  eventId: '14579',
                  num: '',
                  name: 'Hoboken Parking',
                  description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
                  amount: 1238,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0186,
              percentAVG: 0.0186,
              cellID: '3ae4b332_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '3ae4b332_@_18',
              index: 4,
              cPercent: 0.0186355552243906,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '4dbd49a9_@_18',
          cellID: '4dbd49a9_@_18_-x-_0',
          amountTitle: 'Fuel',
          refTitle: 'Fuel',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6725,
          parent: '084f517c',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Fuel',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 32.426,
                  variance: 336.544984,
                  stdDev: 18.345162414107975,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 34.01,
              amtAvg: 23.71,
              perc: 0.0005,
              percAvg: 0.0003,
              dataRows: [
                {
                  txnDate: '2025-07-23',
                  type: 'Expense',
                  eventId: '15583',
                  num: '',
                  name: 'FUEL 4',
                  description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
                  amount: 34.01,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 23.71,
              percent: 0.0005,
              percentAVG: 0.0003,
              cellID: '4dbd49a9_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '4dbd49a9_@_18',
              index: 0,
              cPercent: 0.00045463586888520765,
            },
            {
              date: '2025-07-14',
              title: 'Fuel',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 32.426,
                  variance: 336.544984,
                  stdDev: 18.345162414107975,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 36.01,
              amtAvg: 23.71,
              perc: 0.0005,
              percAvg: 0.0003,
              dataRows: [
                {
                  txnDate: '2025-07-16',
                  type: 'Expense',
                  eventId: '15260',
                  num: '',
                  name: 'FUEL 4',
                  description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
                  amount: 36.01,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 23.71,
              percent: 0.0005,
              percentAVG: 0.0003,
              cellID: '4dbd49a9_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '4dbd49a9_@_18',
              index: 1,
              cPercent: 0.0005288262436448332,
            },
            {
              date: '2025-07-07',
              title: 'Fuel',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 32.426,
                  variance: 336.544984,
                  stdDev: 18.345162414107975,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '4dbd49a9_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '4dbd49a9_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Fuel',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 32.426,
                  variance: 336.544984,
                  stdDev: 18.345162414107975,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 35,
              amtAvg: 22.23,
              perc: 0.0004,
              percAvg: 0.0002,
              dataRows: [
                {
                  txnDate: '2025-07-03',
                  type: 'Expense',
                  eventId: '14832',
                  num: '',
                  name: 'FUEL 4',
                  description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
                  amount: 35,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 22.23,
              percent: 0.0004,
              percentAVG: 0.0002,
              cellID: '4dbd49a9_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: '4dbd49a9_@_18',
              index: 3,
              cPercent: 0.00038843687784204003,
            },
            {
              date: '2025-06-23',
              title: 'Fuel',
              path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 32.426,
                  variance: 336.544984,
                  stdDev: 18.345162414107975,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
                stats: {
                  mean: 1,
                  variance: 0.4,
                  stdDev: 0.6324555320336759,
                },
              },
              trxFlagged: [],
              amount: 57.11,
              perc: 0.0009,
              percAvg: 0.0009,
              dataRows: [
                {
                  txnDate: '2025-06-26',
                  type: 'Expense',
                  eventId: '14833',
                  num: '',
                  name: 'FUEL 4',
                  description: 'VISA DDA PUR AP - 475542     FUEL 4 GAS AND DIESEL       SECAUCUS      * NJ',
                  amount: 30.1,
                },
                {
                  txnDate: '2025-06-27',
                  type: 'Expense',
                  eventId: '14831',
                  num: '',
                  name: 'FUEL 4',
                  description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
                  amount: 27.01,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0009,
              percentAVG: 0.0009,
              cellID: '4dbd49a9_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 2,
              id: '4dbd49a9_@_18',
              index: 4,
              cPercent: 0.0008596741186308137,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
        },
        {
          id: 'ea7ffa49_@_18',
          cellID: 'ea7ffa49_@_18_-x-_0',
          amountTitle: 'Total Travel, Meals, & Entertainment',
          refTitle: 'Total Travel, Meals, & Entertainment',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 946.11,
                  variance: 405048.44547999994,
                  stdDev: 636.4341642935268,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1714.04,
              amtAvg: 715.58,
              perc: 0.0229,
              percAvg: 0.0096,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 715.58,
              percent: 0.0229,
              percentAVG: 0.0096,
              cellID: 'ea7ffa49_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'ea7ffa49_@_18',
              index: 0,
              cPercent: 0.022912792258277016,
            },
            {
              date: '2025-07-14',
              title: 'Total Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 946.11,
                  variance: 405048.44547999994,
                  stdDev: 636.4341642935268,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1013.13,
              amtAvg: 715.58,
              perc: 0.0149,
              percAvg: 0.0105,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 715.58,
              percent: 0.0149,
              percentAVG: 0.0105,
              cellID: 'ea7ffa49_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'ea7ffa49_@_18',
              index: 1,
              cPercent: 0.014878359684084696,
            },
            {
              date: '2025-07-07',
              title: 'Total Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 946.11,
                  variance: 405048.44547999994,
                  stdDev: 636.4341642935268,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 235.02,
              amtAvg: 235.02,
              perc: 0.0034,
              percAvg: 0.0034,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 235.02,
              percent: 0.0034,
              percentAVG: 0.0034,
              cellID: 'ea7ffa49_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'ea7ffa49_@_18',
              index: 2,
              cPercent: 0.003356145085657957,
            },
            {
              date: '2025-06-30',
              title: 'Total Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 946.11,
                  variance: 405048.44547999994,
                  stdDev: 636.4341642935268,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 206.79000000000002,
              amtAvg: 731.97,
              perc: 0.0023,
              percAvg: 0.0081,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 731.97,
              percent: 0.0023,
              percentAVG: 0.0081,
              cellID: 'ea7ffa49_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'ea7ffa49_@_18',
              index: 3,
              cPercent: 0.0022949960562558707,
            },
            {
              date: '2025-06-23',
              title: 'Total Travel, Meals, & Entertainment',
              path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 946.11,
                  variance: 405048.44547999994,
                  stdDev: 636.4341642935268,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1561.57,
              amtAvg: 1561.57,
              perc: 0.0235,
              percAvg: 0.0235,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 1561.57,
              percent: 0.0235,
              percentAVG: 0.0235,
              cellID: 'ea7ffa49_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'ea7ffa49_@_18',
              index: 4,
              cPercent: 0.023506239072497277,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
        },
        {
          id: '1675dbe8_@_18',
          cellID: '1675dbe8_@_18_-x-_0',
          amountTitle: 'Repairs & Maintenance',
          refTitle: 'Repairs & Maintenance',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 6800,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          display: 'default',
          children: ['aa06968c_@_18', '4d40af10_@_18', 'a044faba_@_18', 'd6450b86_@_18'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '1675dbe8_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '1675dbe8_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '1675dbe8_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '1675dbe8_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '1675dbe8_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '1675dbe8_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '1675dbe8_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '1675dbe8_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '1675dbe8_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '1675dbe8_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'aa06968c_@_18',
          cellID: 'aa06968c_@_18_-x-_0',
          amountTitle: 'Repair & Maintenance, Equipment',
          refTitle: 'Repair & Maintenance, Equipment',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6810,
          parent: '1675dbe8',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Repair & Maintenance, Equipment',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 551.33,
              perc: 0,
              percAvg: 0.0074,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 551.33,
              percent: 0,
              percentAVG: 0.0074,
              cellID: 'aa06968c_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'aa06968c_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Repair & Maintenance, Equipment',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2441.6,
              amtAvg: 551.33,
              perc: 0.0359,
              percAvg: 0.0081,
              dataRows: [
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15436',
                  num: '6502273',
                  name: 'AZ Mechanical',
                  description: 'CHECK 6502273',
                  amount: 880,
                },
                {
                  txnDate: '2025-07-14',
                  type: 'Check',
                  eventId: '15438',
                  num: '6502272',
                  name: 'AZ Mechanical',
                  description: 'CHECK 6502272 HVAC',
                  amount: 1150,
                },
                {
                  txnDate: '2025-07-18',
                  type: 'Check',
                  eventId: '15506',
                  num: '6502328',
                  name: 'AIs Technical Incorporated',
                  description: 'CHECK 6502328',
                  amount: 411.6,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 551.33,
              percent: 0.0359,
              percentAVG: 0.0081,
              cellID: 'aa06968c_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 3,
              id: 'aa06968c_@_18',
              index: 1,
              cPercent: 0.035856210954824344,
            },
            {
              date: '2025-07-07',
              title: 'Repair & Maintenance, Equipment',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'aa06968c_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'aa06968c_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Repair & Maintenance, Equipment',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 704.51,
              perc: 0,
              percAvg: 0.0078,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 704.51,
              percent: 0,
              percentAVG: 0.0078,
              cellID: 'aa06968c_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'aa06968c_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Repair & Maintenance, Equipment',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 3479,
              perc: 0.0524,
              percAvg: 0.0524,
              dataRows: [
                {
                  txnDate: '2025-06-24',
                  type: 'Check',
                  eventId: '14854',
                  num: '6502073',
                  name: 'AZ Mechanical',
                  description: 'CHECK 6502073 MS HVAC',
                  amount: 3479,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0524,
              percentAVG: 0.0524,
              cellID: 'aa06968c_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'aa06968c_@_18',
              index: 4,
              cPercent: 0.052369221830092814,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '4d40af10_@_18',
          cellID: '4d40af10_@_18_-x-_0',
          amountTitle: 'Repair & Maintenance, Facility',
          refTitle: 'Repair & Maintenance, Facility',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6815,
          parent: '1675dbe8',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Repair & Maintenance, Facility',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3645.32],
                anomalyScores: [0, 0, 0.81921212447709, 0, 0],
                stats: {
                  mean: 1424.1,
                  variance: 1837936.13568,
                  stdDev: 1355.7050326970098,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
                stats: {
                  mean: 1,
                  variance: 1.2,
                  stdDev: 1.0954451150103321,
                },
              },
              trxFlagged: [],
              amount: 1777.52,
              amtAvg: 1607.85,
              perc: 0.0238,
              percAvg: 0.0215,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15636',
                  num: '6502326',
                  name: 'Eileen Kim',
                  description: 'CHECK 6502326 Electrical & plumbing work',
                  amount: 1777.52,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 1607.85,
              percent: 0.0238,
              percentAVG: 0.0215,
              cellID: '4d40af10_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '4d40af10_@_18',
              index: 0,
              cPercent: 0.023761374585734615,
            },
            {
              date: '2025-07-14',
              title: 'Repair & Maintenance, Facility',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3645.32],
                anomalyScores: [0, 0, 0.81921212447709, 0, 0],
                stats: {
                  mean: 1424.1,
                  variance: 1837936.13568,
                  stdDev: 1355.7050326970098,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
                stats: {
                  mean: 1,
                  variance: 1.2,
                  stdDev: 1.0954451150103321,
                },
              },
              trxFlagged: [],
              amount: 1697.66,
              amtAvg: 1607.85,
              perc: 0.0249,
              percAvg: 0.0236,
              dataRows: [
                {
                  txnDate: '2025-07-15',
                  type: 'Check',
                  eventId: '15455',
                  num: '6502087',
                  name: 'American Garage Door',
                  description: 'CHECK 6502087 Garage Door',
                  amount: 1697.66,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 1607.85,
              percent: 0.0249,
              percentAVG: 0.0236,
              cellID: '4d40af10_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '4d40af10_@_18',
              index: 1,
              cPercent: 0.024931051396447863,
            },
            {
              date: '2025-07-07',
              title: 'Repair & Maintenance, Facility',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3645.32],
                anomalyScores: [0, 0, 0.81921212447709, 0, 0],
                stats: {
                  mean: 1424.1,
                  variance: 1837936.13568,
                  stdDev: 1355.7050326970098,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
                stats: {
                  mean: 1,
                  variance: 1.2,
                  stdDev: 1.0954451150103321,
                },
              },
              trxFlagged: [],
              amount: 3645.32,
              perc: 0.0521,
              percAvg: 0.0521,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Check',
                  eventId: '15349',
                  num: '6502085',
                  name: 'American Garage Door',
                  description: 'CHECK 6502085',
                  amount: 1697.66,
                },
                {
                  txnDate: '2025-07-08',
                  type: 'Check',
                  eventId: '15387',
                  num: '6502144',
                  name: 'Tekno Electric',
                  description: 'CHECK 6502144',
                  amount: 250,
                },
                {
                  txnDate: '2025-07-10',
                  type: 'Check',
                  eventId: '15409',
                  num: '6502086',
                  name: 'American Garage Door',
                  description: 'CHECK 6502086 Garage door',
                  amount: 1697.66,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0.0521,
              percentAVG: 0.0521,
              cellID: '4d40af10_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 3,
              id: '4d40af10_@_18',
              index: 2,
              cPercent: 0.052056092263001716,
            },
            {
              date: '2025-06-30',
              title: 'Repair & Maintenance, Facility',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3645.32],
                anomalyScores: [0, 0, 0.81921212447709, 0, 0],
                stats: {
                  mean: 1424.1,
                  variance: 1837936.13568,
                  stdDev: 1355.7050326970098,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
                stats: {
                  mean: 1,
                  variance: 1.2,
                  stdDev: 1.0954451150103321,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 1378.16,
              perc: 0,
              percAvg: 0.0153,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 1378.16,
              percent: 0,
              percentAVG: 0.0153,
              cellID: '4d40af10_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '4d40af10_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Repair & Maintenance, Facility',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [3645.32],
                anomalyScores: [0, 0, 0.81921212447709, 0, 0],
                stats: {
                  mean: 1424.1,
                  variance: 1837936.13568,
                  stdDev: 1355.7050326970098,
                },
              },
              trxAnomaly: {
                anomalies: [3],
                anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
                stats: {
                  mean: 1,
                  variance: 1.2,
                  stdDev: 1.0954451150103321,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              cellID: '4d40af10_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '4d40af10_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
        },
        {
          id: 'a044faba_@_18',
          cellID: 'a044faba_@_18_-x-_0',
          amountTitle: 'Pest Control',
          refTitle: 'Pest Control',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6820,
          parent: '1675dbe8',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Pest Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 118.65,
              perc: 0,
              percAvg: 0.0016,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 118.65,
              percent: 0,
              percentAVG: 0.0016,
              cellID: 'a044faba_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'a044faba_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Pest Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 118.65,
              perc: 0,
              percAvg: 0.0017,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 118.65,
              percent: 0,
              percentAVG: 0.0017,
              cellID: 'a044faba_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'a044faba_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Pest Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'a044faba_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'a044faba_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Pest Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 525.46,
              amtAvg: 194.38,
              perc: 0.0058,
              percAvg: 0.0022,
              dataRows: [
                {
                  txnDate: '2025-07-02',
                  type: 'Expense',
                  eventId: '15290',
                  num: '',
                  name: 'Liberty Pest',
                  description: 'VISA DDA PUR AP - 403982     LIBERTY PEST CONTROL        718 8379030   * NY',
                  amount: 525.46,
                },
              ],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 194.38,
              percent: 0.0058,
              percentAVG: 0.0022,
              cellID: 'a044faba_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 1,
              id: 'a044faba_@_18',
              index: 3,
              cPercent: 0.005831658338025097,
            },
            {
              date: '2025-06-23',
              title: 'Pest Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1137.35,
              perc: 0.0171,
              percAvg: 0.0171,
              dataRows: [
                {
                  txnDate: '2025-06-24',
                  type: 'Check',
                  eventId: '14851',
                  num: '650103',
                  name: 'Liberty Pest',
                  description: 'CHECK 650103 1170053',
                  amount: 505.49,
                },
                {
                  txnDate: '2025-06-24',
                  type: 'Check',
                  eventId: '14855',
                  num: '65014',
                  name: 'Liberty Pest',
                  description: 'CHECK 65014 1185730',
                  amount: 631.86,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0171,
              percentAVG: 0.0171,
              cellID: 'a044faba_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 2,
              id: 'a044faba_@_18',
              index: 4,
              cPercent: 0.01712047555287613,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'd6450b86_@_18',
          cellID: 'd6450b86_@_18_-x-_0',
          amountTitle: 'Fire Control',
          refTitle: 'Fire Control',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 6825,
          parent: '1675dbe8',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Fire Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'd6450b86_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'd6450b86_@_18',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Fire Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'd6450b86_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'd6450b86_@_18',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Fire Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'd6450b86_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'd6450b86_@_18',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Fire Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 21.04,
              perc: 0,
              percAvg: 0.0002,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 21.04,
              percent: 0,
              percentAVG: 0.0002,
              cellID: 'd6450b86_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'd6450b86_@_18',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Fire Control',
              path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'd6450b86_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'd6450b86_@_18',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '4da1092f_@_18',
          cellID: '4da1092f_@_18_-x-_0',
          amountTitle: 'Total Repairs & Maintenance',
          refTitle: 'Total Repairs & Maintenance',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '2cd659af',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [525.46],
                anomalyScores: [0, 0, 0, -0.781916910471579, 0],
                stats: {
                  mean: 2940.782,
                  variance: 2385442.0553760002,
                  stdDev: 1544.487635229237,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1777.52,
              amtAvg: 2277.83,
              perc: 0.0238,
              percAvg: 0.0304,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 2277.83,
              percent: 0.0238,
              percentAVG: 0.0304,
              cellID: '4da1092f_@_18_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '4da1092f_@_18',
              index: 0,
              cPercent: 0.023761374585734615,
            },
            {
              date: '2025-07-14',
              title: 'Total Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [525.46],
                anomalyScores: [0, 0, 0, -0.781916910471579, 0],
                stats: {
                  mean: 2940.782,
                  variance: 2385442.0553760002,
                  stdDev: 1544.487635229237,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 4139.26,
              amtAvg: 2277.83,
              perc: 0.0608,
              percAvg: 0.0335,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 2277.83,
              percent: 0.0608,
              percentAVG: 0.0335,
              cellID: '4da1092f_@_18_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '4da1092f_@_18',
              index: 1,
              cPercent: 0.060787262351272214,
            },
            {
              date: '2025-07-07',
              title: 'Total Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [525.46],
                anomalyScores: [0, 0, 0, -0.781916910471579, 0],
                stats: {
                  mean: 2940.782,
                  variance: 2385442.0553760002,
                  stdDev: 1544.487635229237,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 3645.32,
              amtAvg: 3645.32,
              perc: 0.0521,
              percAvg: 0.0521,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 3645.32,
              percent: 0.0521,
              percentAVG: 0.0521,
              cellID: '4da1092f_@_18_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '4da1092f_@_18',
              index: 2,
              cPercent: 0.052056092263001716,
            },
            {
              date: '2025-06-30',
              title: 'Total Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [525.46],
                anomalyScores: [0, 0, 0, -0.781916910471579, 0],
                stats: {
                  mean: 2940.782,
                  variance: 2385442.0553760002,
                  stdDev: 1544.487635229237,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 525.46,
              amtAvg: 2298.09,
              perc: 0.0058,
              percAvg: 0.0255,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 2298.09,
              percent: 0.0058,
              percentAVG: 0.0255,
              cellID: '4da1092f_@_18_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '4da1092f_@_18',
              index: 3,
              cPercent: 0.005831658338025097,
            },
            {
              date: '2025-06-23',
              title: 'Total Repairs & Maintenance',
              path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [525.46],
                anomalyScores: [0, 0, 0, -0.781916910471579, 0],
                stats: {
                  mean: 2940.782,
                  variance: 2385442.0553760002,
                  stdDev: 1544.487635229237,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 4616.35,
              amtAvg: 4616.35,
              perc: 0.0695,
              percAvg: 0.0695,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 4616.35,
              percent: 0.0695,
              percentAVG: 0.0695,
              cellID: '4da1092f_@_18_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '4da1092f_@_18',
              index: 4,
              cPercent: 0.06948969738296895,
            },
          ],
          anomalies: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
        },
        {
          id: 'a624f257_@_19',
          cellID: 'a624f257_@_19_-x-_0',
          amountTitle: 'TOTAL CONTROLLABLE EXPENSES',
          refTitle: 'TOTAL CONTROLLABLE EXPENSES',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'TOTAL CONTROLLABLE EXPENSES',
              path: ['TOTAL CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [16808.58],
                anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
                stats: {
                  mean: 10984.514000000001,
                  variance: 8739785.896584,
                  stdDev: 2956.312888816744,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 9880.05,
              amtAvg: 8134.97,
              perc: 0.1321,
              percAvg: 0.1087,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 8134.97,
              percent: 0.1321,
              percentAVG: 0.1087,
              cellID: 'a624f257_@_19_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'a624f257_@_19',
              index: 0,
              cPercent: 0.1320736582293236,
            },
            {
              date: '2025-07-14',
              title: 'TOTAL CONTROLLABLE EXPENSES',
              path: ['TOTAL CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [16808.58],
                anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
                stats: {
                  mean: 10984.514000000001,
                  variance: 8739785.896584,
                  stdDev: 2956.312888816744,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 10243.130000000001,
              amtAvg: 8134.97,
              perc: 0.1504,
              percAvg: 0.1195,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 8134.97,
              percent: 0.1504,
              percentAVG: 0.1195,
              cellID: 'a624f257_@_19_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'a624f257_@_19',
              index: 1,
              cPercent: 0.15042588061831993,
            },
            {
              date: '2025-07-07',
              title: 'TOTAL CONTROLLABLE EXPENSES',
              path: ['TOTAL CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [16808.58],
                anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
                stats: {
                  mean: 10984.514000000001,
                  variance: 8739785.896584,
                  stdDev: 2956.312888816744,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 9215.160000000002,
              amtAvg: 9215.160000000002,
              perc: 0.1316,
              percAvg: 0.1316,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 9215.160000000002,
              percent: 0.1316,
              percentAVG: 0.1316,
              cellID: 'a624f257_@_19_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'a624f257_@_19',
              index: 2,
              cPercent: 0.1315948172391787,
            },
            {
              date: '2025-06-30',
              title: 'TOTAL CONTROLLABLE EXPENSES',
              path: ['TOTAL CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [16808.58],
                anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
                stats: {
                  mean: 10984.514000000001,
                  variance: 8739785.896584,
                  stdDev: 2956.312888816744,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 8775.650000000001,
              amtAvg: 8977.12,
              perc: 0.0974,
              percAvg: 0.0996,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 8977.12,
              percent: 0.0974,
              percentAVG: 0.0996,
              cellID: 'a624f257_@_19_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'a624f257_@_19',
              index: 3,
              cPercent: 0.0973938882009857,
            },
            {
              date: '2025-06-23',
              title: 'TOTAL CONTROLLABLE EXPENSES',
              path: ['TOTAL CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [16808.58],
                anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
                stats: {
                  mean: 10984.514000000001,
                  variance: 8739785.896584,
                  stdDev: 2956.312888816744,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 16808.58,
              amtAvg: 16808.58,
              perc: 0.253,
              percAvg: 0.253,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 16808.58,
              percent: 0.253,
              percentAVG: 0.253,
              cellID: 'a624f257_@_19_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'a624f257_@_19',
              index: 4,
              cPercent: 0.25301875673149227,
            },
          ],
          anomalies: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
        },
        {
          id: 'a973b710_@_20',
          cellID: 'a973b710_@_20_-x-_0',
          amountTitle: 'Controllable Profit',
          refTitle: 'Controllable Profit',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Controllable Profit'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Controllable Profit',
              path: ['Controllable Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 10183.041999999998,
                  variance: 457690195.3150161,
                  stdDev: 21393.695223476847,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 23820.620000000006,
              amtAvg: 25565.700000000004,
              perc: 0.3184,
              percAvg: 0.3418,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 25565.700000000004,
              percent: 0.3184,
              percentAVG: 0.3418,
              cellID: 'a973b710_@_20_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'a973b710_@_20',
              index: 0,
              cPercent: 0.3184271764505839,
            },
            {
              date: '2025-07-14',
              title: 'Controllable Profit',
              path: ['Controllable Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 10183.041999999998,
                  variance: 457690195.3150161,
                  stdDev: 21393.695223476847,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -17993.639999999996,
              amtAvg: -15885.479999999996,
              perc: -0.2642,
              percAvg: -0.2333,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: -15885.479999999996,
              percent: -0.2642,
              percentAVG: -0.2333,
              cellID: 'a973b710_@_20_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'a973b710_@_20',
              index: 1,
              cPercent: -0.26424629410434364,
            },
            {
              date: '2025-07-07',
              title: 'Controllable Profit',
              path: ['Controllable Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 10183.041999999998,
                  variance: 457690195.3150161,
                  stdDev: 21393.695223476847,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -12321.610000000013,
              amtAvg: -12321.610000000013,
              perc: -0.176,
              percAvg: -0.176,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -12321.610000000013,
              percent: -0.176,
              percentAVG: -0.176,
              cellID: 'a973b710_@_20_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'a973b710_@_20',
              index: 2,
              cPercent: -0.17595570950937783,
            },
            {
              date: '2025-06-30',
              title: 'Controllable Profit',
              path: ['Controllable Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 10183.041999999998,
                  variance: 457690195.3150161,
                  stdDev: 21393.695223476847,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 36319.469999999994,
              amtAvg: 36117.99999999999,
              perc: 0.4031,
              percAvg: 0.4008,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 36117.99999999999,
              percent: 0.4031,
              percentAVG: 0.4008,
              cellID: 'a973b710_@_20_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'a973b710_@_20',
              index: 3,
              cPercent: 0.4030806151907896,
            },
            {
              date: '2025-06-23',
              title: 'Controllable Profit',
              path: ['Controllable Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 10183.041999999998,
                  variance: 457690195.3150161,
                  stdDev: 21393.695223476847,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 21090.369999999995,
              amtAvg: 21090.369999999995,
              perc: 0.3175,
              percAvg: 0.3175,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 21090.369999999995,
              percent: 0.3175,
              percentAVG: 0.3175,
              cellID: 'a973b710_@_20_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'a973b710_@_20',
              index: 4,
              cPercent: 0.3174723383181185,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
        },
        {
          id: '79208dfc_@_21',
          cellID: '79208dfc_@_21_-x-_0',
          amountTitle: 'NON-CONTROLLABLE EXPENSES',
          refTitle: 'NON-CONTROLLABLE EXPENSES',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: 8000,
          parent: null,
          path: ['NON-CONTROLLABLE EXPENSES'],
          display: 'header_1',
          children: ['52e26b6b_@_21', '20d5762f_@_21', '763b7c77_@_21', 'd4b5a9af_@_21'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'NON-CONTROLLABLE EXPENSES',
              path: ['NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '79208dfc_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '79208dfc_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'NON-CONTROLLABLE EXPENSES',
              path: ['NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '79208dfc_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '79208dfc_@_21',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'NON-CONTROLLABLE EXPENSES',
              path: ['NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '79208dfc_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '79208dfc_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'NON-CONTROLLABLE EXPENSES',
              path: ['NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '79208dfc_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '79208dfc_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'NON-CONTROLLABLE EXPENSES',
              path: ['NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '79208dfc_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '79208dfc_@_21',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '52e26b6b_@_21',
          cellID: '52e26b6b_@_21_-x-_0',
          amountTitle: 'Property Expenses',
          refTitle: 'Property Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 7100,
          parent: '79208dfc',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          display: 'default',
          children: ['68876c4f_@_21', '208dfabc_@_21', 'c9446d9c_@_21'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '52e26b6b_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '52e26b6b_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '52e26b6b_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '52e26b6b_@_21',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '52e26b6b_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '52e26b6b_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '52e26b6b_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '52e26b6b_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '52e26b6b_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '52e26b6b_@_21',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '68876c4f_@_21',
          cellID: '68876c4f_@_21_-x-_0',
          amountTitle: 'Rent/Lease',
          refTitle: 'Rent/Lease',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 7105,
          parent: '52e26b6b',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Rent/Lease',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 4163.27,
              perc: 0,
              percAvg: 0.0557,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 4163.27,
              percent: 0,
              percentAVG: 0.0557,
              cellID: '68876c4f_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '68876c4f_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Rent/Lease',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 18437.33,
              amtAvg: 4163.27,
              perc: 0.2708,
              percAvg: 0.0611,
              dataRows: [
                {
                  txnDate: '2025-07-16',
                  type: 'Expense',
                  eventId: '15470',
                  num: '',
                  name: 'Ironstate Proper',
                  description: 'IRONSTATE PROPER SIGONFILE',
                  amount: 18437.33,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 4163.27,
              percent: 0.2708,
              percentAVG: 0.0611,
              cellID: '68876c4f_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 1,
              id: '68876c4f_@_21',
              index: 1,
              cPercent: 0.2707621207092528,
            },
            {
              date: '2025-07-07',
              title: 'Rent/Lease',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '68876c4f_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '68876c4f_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Rent/Lease',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 4358.03,
              perc: 0,
              percAvg: 0.0484,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 4358.03,
              percent: 0,
              percentAVG: 0.0484,
              cellID: '68876c4f_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '68876c4f_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Rent/Lease',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '68876c4f_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '68876c4f_@_21',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '208dfabc_@_21',
          cellID: '208dfabc_@_21_-x-_0',
          amountTitle: 'Utility, Electricity',
          refTitle: 'Utility, Electricity',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 7125,
          parent: '52e26b6b',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Utility, Electricity',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: '208dfabc_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '208dfabc_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Utility, Electricity',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: '208dfabc_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '208dfabc_@_21',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Utility, Electricity',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '208dfabc_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '208dfabc_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Utility, Electricity',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '208dfabc_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '208dfabc_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Utility, Electricity',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '208dfabc_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '208dfabc_@_21',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'c9446d9c_@_21',
          cellID: 'c9446d9c_@_21_-x-_0',
          amountTitle: 'Utility, Gas',
          refTitle: 'Utility, Gas',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 7130,
          parent: '52e26b6b',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Utility, Gas',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'c9446d9c_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'c9446d9c_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Utility, Gas',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: 'c9446d9c_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'c9446d9c_@_21',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Utility, Gas',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'c9446d9c_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'c9446d9c_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Utility, Gas',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 14.37,
              perc: 0,
              percAvg: 0.0002,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 14.37,
              percent: 0,
              percentAVG: 0.0002,
              cellID: 'c9446d9c_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'c9446d9c_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Utility, Gas',
              path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 430.96,
              perc: 0.0065,
              percAvg: 0.0065,
              dataRows: [
                {
                  txnDate: '2025-06-27',
                  type: 'Bill',
                  eventId: '15215',
                  num: '80547688',
                  name: 'NuCO2',
                  description: '',
                  amount: 430.96,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0065,
              percentAVG: 0.0065,
              cellID: 'c9446d9c_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: 'c9446d9c_@_21',
              index: 4,
              cPercent: 0.006487220419631158,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '20d5762f_@_21',
          cellID: '20d5762f_@_21_-x-_0',
          amountTitle: 'Total Property Expenses',
          refTitle: 'Total Property Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '79208dfc',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 4163.27,
              perc: 0,
              percAvg: 0.0557,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 4163.27,
              percent: 0,
              percentAVG: 0.0557,
              cellID: '20d5762f_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '20d5762f_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Total Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 18437.33,
              amtAvg: 4163.27,
              perc: 0.2708,
              percAvg: 0.0611,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 4163.27,
              percent: 0.2708,
              percentAVG: 0.0611,
              cellID: '20d5762f_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '20d5762f_@_21',
              index: 1,
              cPercent: 0.2707621207092528,
            },
            {
              date: '2025-07-07',
              title: 'Total Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '20d5762f_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '20d5762f_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Total Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 4372.4,
              perc: 0,
              percAvg: 0.0485,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 4372.4,
              percent: 0,
              percentAVG: 0.0485,
              cellID: '20d5762f_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '20d5762f_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Total Property Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 430.96,
              amtAvg: 430.96,
              perc: 0.0065,
              percAvg: 0.0065,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 430.96,
              percent: 0.0065,
              percentAVG: 0.0065,
              cellID: '20d5762f_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '20d5762f_@_21',
              index: 4,
              cPercent: 0.006487220419631158,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '763b7c77_@_21',
          cellID: '763b7c77_@_21_-x-_0',
          amountTitle: 'Other Income and Expenses',
          refTitle: 'Other Income and Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 8100,
          parent: '79208dfc',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          display: 'default',
          children: ['91f38f9a_@_21', '5ccef3e9_@_21'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              percent: 0,
              percentAVG: 0,
              cellID: '763b7c77_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '763b7c77_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              percent: 0,
              percentAVG: 0,
              cellID: '763b7c77_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '763b7c77_@_21',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '763b7c77_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '763b7c77_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '763b7c77_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '763b7c77_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '763b7c77_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '763b7c77_@_21',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '91f38f9a_@_21',
          cellID: '91f38f9a_@_21_-x-_0',
          amountTitle: 'Other Income/Expenses',
          refTitle: 'Other Income/Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 8130,
          parent: '763b7c77',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Other Income/Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: -0.23,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: -0.23,
              percent: 0,
              percentAVG: 0,
              cellID: '91f38f9a_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '91f38f9a_@_21',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Other Income/Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: -0.23,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: -0.23,
              percent: 0,
              percentAVG: 0,
              cellID: '91f38f9a_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '91f38f9a_@_21',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Other Income/Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1.01,
              perc: 0,
              percAvg: 0,
              dataRows: [
                {
                  txnDate: '2025-07-07',
                  type: 'Deposit',
                  eventId: '15382',
                  num: '',
                  name: 'Toast Inc',
                  description: 'TOAST            EOM JUN 30',
                  amount: -1.01,
                },
              ],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '91f38f9a_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 1,
              id: '91f38f9a_@_21',
              index: 2,
              cPercent: -0.000014423055640007388,
            },
            {
              date: '2025-06-30',
              title: 'Other Income/Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: -0.2,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: -0.2,
              percent: 0,
              percentAVG: 0,
              cellID: '91f38f9a_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '91f38f9a_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Other Income/Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '91f38f9a_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '91f38f9a_@_21',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '5ccef3e9_@_21',
          cellID: '5ccef3e9_@_21_-x-_0',
          amountTitle: 'To Be Classified P&L',
          refTitle: 'To Be Classified P&L',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 2,
          glCode: 9999,
          parent: '763b7c77',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'To Be Classified P&L',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.8960000000002,
                  variance: 1010918.8690640001,
                  stdDev: 1005.444612628662,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.56,
                  stdDev: 0.7483314773547883,
                },
              },
              trxFlagged: [],
              amount: 1960,
              amtAvg: 993.74,
              perc: 0.0262,
              percAvg: 0.0133,
              dataRows: [
                {
                  txnDate: '2025-07-21',
                  type: 'Check',
                  eventId: '15657',
                  num: '6502339',
                  name: 'Roberto Averos',
                  description: 'CHECK 6502339',
                  amount: 1960,
                },
              ],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 993.74,
              percent: 0.0262,
              percentAVG: 0.0133,
              cellID: '5ccef3e9_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 1,
              id: '5ccef3e9_@_21',
              index: 0,
              cPercent: 0.02620071458438715,
            },
            {
              date: '2025-07-14',
              title: 'To Be Classified P&L',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.8960000000002,
                  variance: 1010918.8690640001,
                  stdDev: 1005.444612628662,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.56,
                  stdDev: 0.7483314773547883,
                },
              },
              trxFlagged: [],
              amount: 2440.85,
              amtAvg: 993.74,
              perc: 0.0358,
              percAvg: 0.0146,
              dataRows: [
                {
                  txnDate: '2025-07-17',
                  type: 'Expense',
                  eventId: '15496',
                  num: '',
                  name: 'Unknown',
                  description: 'BENEFITHEALTHPLA WEBPAYMENT',
                  amount: 987.26,
                },
                {
                  txnDate: '2025-07-17',
                  type: 'Expense',
                  eventId: '15497',
                  num: '',
                  name: 'Unknown',
                  description: 'BENEFITHEALTHPLA WEBPAYMENT',
                  amount: 1453.59,
                },
              ],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 993.74,
              percent: 0.0358,
              percentAVG: 0.0146,
              cellID: '5ccef3e9_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 2,
              id: '5ccef3e9_@_21',
              index: 1,
              cPercent: 0.03584519680090228,
            },
            {
              date: '2025-07-07',
              title: 'To Be Classified P&L',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.8960000000002,
                  variance: 1010918.8690640001,
                  stdDev: 1005.444612628662,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.56,
                  stdDev: 0.7483314773547883,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '5ccef3e9_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '5ccef3e9_@_21',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'To Be Classified P&L',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.8960000000002,
                  variance: 1010918.8690640001,
                  stdDev: 1005.444612628662,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.56,
                  stdDev: 0.7483314773547883,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 943.62,
              perc: 0,
              percAvg: 0.0105,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 943.62,
              percent: 0,
              percentAVG: 0.0105,
              cellID: '5ccef3e9_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '5ccef3e9_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'To Be Classified P&L',
              path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.8960000000002,
                  variance: 1010918.8690640001,
                  stdDev: 1005.444612628662,
                },
              },
              trxAnomaly: {
                anomalies: [2],
                anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
                stats: {
                  mean: 0.8,
                  variance: 0.56,
                  stdDev: 0.7483314773547883,
                },
              },
              trxFlagged: [],
              amount: 1448.63,
              perc: 0.0218,
              percAvg: 0.0218,
              dataRows: [
                {
                  txnDate: '2025-06-23',
                  type: 'Check',
                  eventId: '14677',
                  num: '6502078',
                  name: 'David Conte',
                  description: 'CHECK 6502078',
                  amount: 1448.63,
                },
              ],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0.0218,
              percentAVG: 0.0218,
              cellID: '5ccef3e9_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 1,
              id: '5ccef3e9_@_21',
              index: 4,
              cPercent: 0.021806158614466043,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
        },
        {
          id: 'd4b5a9af_@_21',
          cellID: 'd4b5a9af_@_21_-x-_0',
          amountTitle: 'Total Other Income and Expenses',
          refTitle: 'Total Other Income and Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: null,
          parent: '79208dfc',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          display: 'total_2',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.694,
                  variance: 1011391.6702639998,
                  stdDev: 1005.6797056041252,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1960,
              amtAvg: 993.51,
              perc: 0.0262,
              percAvg: 0.0133,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 993.51,
              percent: 0.0262,
              percentAVG: 0.0133,
              cellID: 'd4b5a9af_@_21_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'd4b5a9af_@_21',
              index: 0,
              cPercent: 0.02620071458438715,
            },
            {
              date: '2025-07-14',
              title: 'Total Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.694,
                  variance: 1011391.6702639998,
                  stdDev: 1005.6797056041252,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 2440.85,
              amtAvg: 993.51,
              perc: 0.0358,
              percAvg: 0.0146,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 993.51,
              percent: 0.0358,
              percentAVG: 0.0146,
              cellID: 'd4b5a9af_@_21_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'd4b5a9af_@_21',
              index: 1,
              cPercent: 0.03584519680090228,
            },
            {
              date: '2025-07-07',
              title: 'Total Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.694,
                  variance: 1011391.6702639998,
                  stdDev: 1005.6797056041252,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1.01,
              amtAvg: -1.01,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -1.01,
              percent: 0,
              percentAVG: 0,
              cellID: 'd4b5a9af_@_21_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'd4b5a9af_@_21',
              index: 2,
              cPercent: -0.000014423055640007388,
            },
            {
              date: '2025-06-30',
              title: 'Total Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.694,
                  variance: 1011391.6702639998,
                  stdDev: 1005.6797056041252,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 943.42,
              perc: 0,
              percAvg: 0.0105,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 943.42,
              percent: 0,
              percentAVG: 0.0105,
              cellID: 'd4b5a9af_@_21_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'd4b5a9af_@_21',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Total Other Income and Expenses',
              path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: true,
                isHeader: true,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [0, 0, 0, 0, 0],
                stats: {
                  mean: 1169.694,
                  variance: 1011391.6702639998,
                  stdDev: 1005.6797056041252,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1448.63,
              amtAvg: 1448.63,
              perc: 0.0218,
              percAvg: 0.0218,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 1448.63,
              percent: 0.0218,
              percentAVG: 0.0218,
              cellID: 'd4b5a9af_@_21_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'd4b5a9af_@_21',
              index: 4,
              cPercent: 0.021806158614466043,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
        },
        {
          id: '1851dc59_@_22',
          cellID: '1851dc59_@_22_-x-_0',
          amountTitle: 'TOTAL NON-CONTROLLABLE EXPENSES',
          refTitle: 'TOTAL NON-CONTROLLABLE EXPENSES',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'TOTAL NON-CONTROLLABLE EXPENSES',
              path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [20878.18],
                anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
                stats: {
                  mean: 4943.352000000001,
                  variance: 64217842.944216,
                  stdDev: 8013.603617862316,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1960,
              amtAvg: 5156.78,
              perc: 0.0262,
              percAvg: 0.0689,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 5156.78,
              percent: 0.0262,
              percentAVG: 0.0689,
              cellID: '1851dc59_@_22_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '1851dc59_@_22',
              index: 0,
              cPercent: 0.02620071458438715,
            },
            {
              date: '2025-07-14',
              title: 'TOTAL NON-CONTROLLABLE EXPENSES',
              path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [20878.18],
                anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
                stats: {
                  mean: 4943.352000000001,
                  variance: 64217842.944216,
                  stdDev: 8013.603617862316,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 20878.18,
              amtAvg: 5156.78,
              perc: 0.3066,
              percAvg: 0.0757,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: 5156.78,
              percent: 0.3066,
              percentAVG: 0.0757,
              cellID: '1851dc59_@_22_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '1851dc59_@_22',
              index: 1,
              cPercent: 0.3066073175101551,
            },
            {
              date: '2025-07-07',
              title: 'TOTAL NON-CONTROLLABLE EXPENSES',
              path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [20878.18],
                anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
                stats: {
                  mean: 4943.352000000001,
                  variance: 64217842.944216,
                  stdDev: 8013.603617862316,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -1.01,
              amtAvg: -1.01,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -1.01,
              percent: 0,
              percentAVG: 0,
              cellID: '1851dc59_@_22_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '1851dc59_@_22',
              index: 2,
              cPercent: -0.000014423055640007388,
            },
            {
              date: '2025-06-30',
              title: 'TOTAL NON-CONTROLLABLE EXPENSES',
              path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [20878.18],
                anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
                stats: {
                  mean: 4943.352000000001,
                  variance: 64217842.944216,
                  stdDev: 8013.603617862316,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 5315.82,
              perc: 0,
              percAvg: 0.059,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 5315.82,
              percent: 0,
              percentAVG: 0.059,
              cellID: '1851dc59_@_22_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '1851dc59_@_22',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'TOTAL NON-CONTROLLABLE EXPENSES',
              path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [20878.18],
                anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
                stats: {
                  mean: 4943.352000000001,
                  variance: 64217842.944216,
                  stdDev: 8013.603617862316,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 1879.5900000000001,
              amtAvg: 1879.5900000000001,
              perc: 0.0283,
              percAvg: 0.0283,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 1879.5900000000001,
              percent: 0.0283,
              percentAVG: 0.0283,
              cellID: '1851dc59_@_22_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '1851dc59_@_22',
              index: 4,
              cPercent: 0.0282933790340972,
            },
          ],
          anomalies: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
        },
        {
          id: '251b8ac6_@_23',
          cellID: '251b8ac6_@_23_-x-_0',
          amountTitle: 'Operating Profit',
          refTitle: 'Operating Profit',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Operating Profit'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Operating Profit',
              path: ['Operating Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 21860.620000000006,
              amtAvg: 20408.920000000006,
              perc: 0.2922,
              percAvg: 0.2728,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 20408.920000000006,
              percent: 0.2922,
              percentAVG: 0.2728,
              cellID: '251b8ac6_@_23_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '251b8ac6_@_23',
              index: 0,
              cPercent: 0.2922264618661967,
            },
            {
              date: '2025-07-14',
              title: 'Operating Profit',
              path: ['Operating Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -38871.81999999999,
              amtAvg: -21042.259999999995,
              perc: -0.5709,
              percAvg: -0.309,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: -21042.259999999995,
              percent: -0.5709,
              percentAVG: -0.309,
              cellID: '251b8ac6_@_23_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '251b8ac6_@_23',
              index: 1,
              cPercent: -0.5708536116144987,
            },
            {
              date: '2025-07-07',
              title: 'Operating Profit',
              path: ['Operating Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -12320.600000000013,
              amtAvg: -12320.600000000013,
              perc: -0.1759,
              percAvg: -0.1759,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -12320.600000000013,
              percent: -0.1759,
              percentAVG: -0.1759,
              cellID: '251b8ac6_@_23_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '251b8ac6_@_23',
              index: 2,
              cPercent: -0.17594128645373783,
            },
            {
              date: '2025-06-30',
              title: 'Operating Profit',
              path: ['Operating Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 36319.469999999994,
              amtAvg: 30802.179999999993,
              perc: 0.4031,
              percAvg: 0.3418,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 30802.179999999993,
              percent: 0.4031,
              percentAVG: 0.3418,
              cellID: '251b8ac6_@_23_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '251b8ac6_@_23',
              index: 3,
              cPercent: 0.4030806151907896,
            },
            {
              date: '2025-06-23',
              title: 'Operating Profit',
              path: ['Operating Profit'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 19210.779999999995,
              amtAvg: 19210.779999999995,
              perc: 0.2892,
              percAvg: 0.2892,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 19210.779999999995,
              percent: 0.2892,
              percentAVG: 0.2892,
              cellID: '251b8ac6_@_23_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '251b8ac6_@_23',
              index: 4,
              cPercent: 0.2891789592840213,
            },
          ],
          anomalies: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
        },
        {
          id: '5e10c38d_@_24',
          cellID: '5e10c38d_@_24_-x-_0',
          amountTitle: 'Other Expenses',
          refTitle: 'Other Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Other Expenses'],
          display: 'header_1',
          children: ['13e3a076_@_24'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Other Expenses',
              path: ['Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: '5e10c38d_@_24_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '5e10c38d_@_24',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Other Expenses',
              path: ['Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: '5e10c38d_@_24_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '5e10c38d_@_24',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Other Expenses',
              path: ['Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: '5e10c38d_@_24_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '5e10c38d_@_24',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Other Expenses',
              path: ['Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: '5e10c38d_@_24_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '5e10c38d_@_24',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Other Expenses',
              path: ['Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: '5e10c38d_@_24_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '5e10c38d_@_24',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '13e3a076_@_24',
          cellID: '13e3a076_@_24_-x-_0',
          amountTitle: 'Loan Interest',
          refTitle: 'Loan Interest',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 8205,
          parent: '5e10c38d',
          path: ['Other Expenses', 'Loan Interest'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Loan Interest',
              path: ['Other Expenses', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: '13e3a076_@_24_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '13e3a076_@_24',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Loan Interest',
              path: ['Other Expenses', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: '13e3a076_@_24_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '13e3a076_@_24',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Loan Interest',
              path: ['Other Expenses', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '13e3a076_@_24_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '13e3a076_@_24',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Loan Interest',
              path: ['Other Expenses', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '13e3a076_@_24_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '13e3a076_@_24',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Loan Interest',
              path: ['Other Expenses', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              amtAvg: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 0,
              percent: 0,
              percentAVG: 0,
              cellID: '13e3a076_@_24_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '13e3a076_@_24',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'caeb87a7_@_25',
          cellID: 'caeb87a7_@_25_-x-_0',
          amountTitle: 'Total Other Expenses',
          refTitle: 'Total Other Expenses',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Total Other Expenses'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Other Expenses',
              path: ['Total Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: 'caeb87a7_@_25_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'caeb87a7_@_25',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Total Other Expenses',
              path: ['Total Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: 'caeb87a7_@_25_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'caeb87a7_@_25',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Total Other Expenses',
              path: ['Total Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'caeb87a7_@_25_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'caeb87a7_@_25',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Total Other Expenses',
              path: ['Total Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'caeb87a7_@_25_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'caeb87a7_@_25',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Total Other Expenses',
              path: ['Total Other Expenses'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'caeb87a7_@_25_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'caeb87a7_@_25',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'e815a21e_@_26',
          cellID: 'e815a21e_@_26_-x-_0',
          amountTitle: 'EBITDA',
          refTitle: 'EBITDA',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['EBITDA'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'EBITDA',
              path: ['EBITDA'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 21860.620000000006,
              amtAvg: 20408.920000000006,
              perc: 0.2922,
              percAvg: 0.2728,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 20408.920000000006,
              percent: 0.2922,
              percentAVG: 0.2728,
              cellID: 'e815a21e_@_26_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'e815a21e_@_26',
              index: 0,
              cPercent: 0.2922264618661967,
            },
            {
              date: '2025-07-14',
              title: 'EBITDA',
              path: ['EBITDA'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -38871.81999999999,
              amtAvg: -21042.259999999995,
              perc: -0.5709,
              percAvg: -0.309,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: -21042.259999999995,
              percent: -0.5709,
              percentAVG: -0.309,
              cellID: 'e815a21e_@_26_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'e815a21e_@_26',
              index: 1,
              cPercent: -0.5708536116144987,
            },
            {
              date: '2025-07-07',
              title: 'EBITDA',
              path: ['EBITDA'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -12320.600000000013,
              amtAvg: -12320.600000000013,
              perc: -0.1759,
              percAvg: -0.1759,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -12320.600000000013,
              percent: -0.1759,
              percentAVG: -0.1759,
              cellID: 'e815a21e_@_26_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'e815a21e_@_26',
              index: 2,
              cPercent: -0.17594128645373783,
            },
            {
              date: '2025-06-30',
              title: 'EBITDA',
              path: ['EBITDA'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 36319.469999999994,
              amtAvg: 30802.179999999993,
              perc: 0.4031,
              percAvg: 0.3418,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 30802.179999999993,
              percent: 0.4031,
              percentAVG: 0.3418,
              cellID: 'e815a21e_@_26_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'e815a21e_@_26',
              index: 3,
              cPercent: 0.4030806151907896,
            },
            {
              date: '2025-06-23',
              title: 'EBITDA',
              path: ['EBITDA'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 19210.779999999995,
              amtAvg: 19210.779999999995,
              perc: 0.2892,
              percAvg: 0.2892,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 19210.779999999995,
              percent: 0.2892,
              percentAVG: 0.2892,
              cellID: 'e815a21e_@_26_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'e815a21e_@_26',
              index: 4,
              cPercent: 0.2891789592840213,
            },
          ],
          anomalies: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
        },
        {
          id: '644555ee_@_27',
          cellID: '644555ee_@_27_-x-_0',
          amountTitle: 'Interest, Taxes, Depreciation and Amortization',
          refTitle: 'Interest, Taxes, Depreciation and Amortization',
          percentTitle: '',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Interest, Taxes, Depreciation and Amortization'],
          display: 'header_1',
          children: ['dce93088_@_27'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Interest, Taxes, Depreciation and Amortization',
              path: ['Interest, Taxes, Depreciation and Amortization'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: '644555ee_@_27_-x-_1',
              baseAmount: 0,
              transactions: 0,
              id: '644555ee_@_27',
              index: 0,
            },
            {
              date: '2025-07-14',
              title: 'Interest, Taxes, Depreciation and Amortization',
              path: ['Interest, Taxes, Depreciation and Amortization'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: '644555ee_@_27_-x-_2',
              baseAmount: 0,
              transactions: 0,
              id: '644555ee_@_27',
              index: 1,
            },
            {
              date: '2025-07-07',
              title: 'Interest, Taxes, Depreciation and Amortization',
              path: ['Interest, Taxes, Depreciation and Amortization'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              cellID: '644555ee_@_27_-x-_3',
              baseAmount: 0,
              transactions: 0,
              id: '644555ee_@_27',
              index: 2,
            },
            {
              date: '2025-06-30',
              title: 'Interest, Taxes, Depreciation and Amortization',
              path: ['Interest, Taxes, Depreciation and Amortization'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              cellID: '644555ee_@_27_-x-_4',
              baseAmount: 0,
              transactions: 0,
              id: '644555ee_@_27',
              index: 3,
            },
            {
              date: '2025-06-23',
              title: 'Interest, Taxes, Depreciation and Amortization',
              path: ['Interest, Taxes, Depreciation and Amortization'],
              vizHelpers: {
                lastItem: false,
                isTotal: false,
                isHeader: false,
                isBigHeader: true,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: true,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              cellID: '644555ee_@_27_-x-_5',
              baseAmount: 0,
              transactions: 0,
              id: '644555ee_@_27',
              index: 4,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'dce93088_@_27',
          cellID: 'dce93088_@_27_-x-_0',
          amountTitle: 'Loan Interest',
          refTitle: 'Loan Interest',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 1,
          glCode: 8205,
          parent: '644555ee',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          display: 'default',
          children: [],
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Loan Interest',
              path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: 'dce93088_@_27_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'dce93088_@_27',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Loan Interest',
              path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: 'dce93088_@_27_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'dce93088_@_27',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Loan Interest',
              path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'dce93088_@_27_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'dce93088_@_27',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Loan Interest',
              path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'dce93088_@_27_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'dce93088_@_27',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Loan Interest',
              path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: true,
                isTotal: false,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'dce93088_@_27_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'dce93088_@_27',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: 'b4184eff_@_28',
          cellID: 'b4184eff_@_28_-x-_0',
          amountTitle: 'Total Interest, Taxes, Depreciation and Amortization',
          refTitle: 'Total Interest, Taxes, Depreciation and Amortization',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'Total Interest, Taxes, Depreciation and Amortization',
              path: ['Total Interest, Taxes, Depreciation and Amortization'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              cellID: 'b4184eff_@_28_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: 'b4184eff_@_28',
              index: 0,
              cPercent: 0,
            },
            {
              date: '2025-07-14',
              title: 'Total Interest, Taxes, Depreciation and Amortization',
              path: ['Total Interest, Taxes, Depreciation and Amortization'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              cellID: 'b4184eff_@_28_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: 'b4184eff_@_28',
              index: 1,
              cPercent: 0,
            },
            {
              date: '2025-07-07',
              title: 'Total Interest, Taxes, Depreciation and Amortization',
              path: ['Total Interest, Taxes, Depreciation and Amortization'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              percent: 0,
              percentAVG: 0,
              cellID: 'b4184eff_@_28_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: 'b4184eff_@_28',
              index: 2,
              cPercent: 0,
            },
            {
              date: '2025-06-30',
              title: 'Total Interest, Taxes, Depreciation and Amortization',
              path: ['Total Interest, Taxes, Depreciation and Amortization'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              percent: 0,
              percentAVG: 0,
              cellID: 'b4184eff_@_28_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: 'b4184eff_@_28',
              index: 3,
              cPercent: 0,
            },
            {
              date: '2025-06-23',
              title: 'Total Interest, Taxes, Depreciation and Amortization',
              path: ['Total Interest, Taxes, Depreciation and Amortization'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 0,
              perc: 0,
              percAvg: 0,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              percent: 0,
              percentAVG: 0,
              cellID: 'b4184eff_@_28_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: 'b4184eff_@_28',
              index: 4,
              cPercent: 0,
            },
          ],
          anomalies: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
        },
        {
          id: '9b50fa7c_@_29',
          cellID: '9b50fa7c_@_29_-x-_0',
          amountTitle: 'NET PROFIT',
          refTitle: 'NET PROFIT',
          percentTitle: 'NET SALES',
          baseRef: 'NET SALES',
          level: 0,
          glCode: null,
          parent: null,
          path: ['NET PROFIT'],
          display: 'total_1',
          children: [],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          amounts: [
            {
              date: '2025-07-21',
              title: 'NET PROFIT',
              path: ['NET PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 21860.620000000006,
              amtAvg: 20408.920000000006,
              perc: 0.2922,
              percAvg: 0.2728,
              dataRows: [],
              reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
              amountAVG: 20408.920000000006,
              percent: 0.2922,
              percentAVG: 0.2728,
              cellID: '9b50fa7c_@_29_-x-_1',
              baseAmount: 74807.12000000001,
              transactions: 0,
              id: '9b50fa7c_@_29',
              index: 0,
              cPercent: 0.2922264618661967,
            },
            {
              date: '2025-07-14',
              title: 'NET PROFIT',
              path: ['NET PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -38871.81999999999,
              amtAvg: -21042.259999999995,
              perc: -0.5709,
              percAvg: -0.309,
              dataRows: [],
              reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
              amountAVG: -21042.259999999995,
              percent: -0.5709,
              percentAVG: -0.309,
              cellID: '9b50fa7c_@_29_-x-_2',
              baseAmount: 68094.2,
              transactions: 0,
              id: '9b50fa7c_@_29',
              index: 1,
              cPercent: -0.5708536116144987,
            },
            {
              date: '2025-07-07',
              title: 'NET PROFIT',
              path: ['NET PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: -12320.600000000013,
              amtAvg: -12320.600000000013,
              perc: -0.1759,
              percAvg: -0.1759,
              dataRows: [],
              reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
              amountAVG: -12320.600000000013,
              percent: -0.1759,
              percentAVG: -0.1759,
              cellID: '9b50fa7c_@_29_-x-_3',
              baseAmount: 70026.76999999999,
              transactions: 0,
              id: '9b50fa7c_@_29',
              index: 2,
              cPercent: -0.17594128645373783,
            },
            {
              date: '2025-06-30',
              title: 'NET PROFIT',
              path: ['NET PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 36319.469999999994,
              amtAvg: 30802.179999999993,
              perc: 0.4031,
              percAvg: 0.3418,
              dataRows: [],
              reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
              amountAVG: 30802.179999999993,
              percent: 0.4031,
              percentAVG: 0.3418,
              cellID: '9b50fa7c_@_29_-x-_4',
              baseAmount: 90104.73,
              transactions: 0,
              id: '9b50fa7c_@_29',
              index: 3,
              cPercent: 0.4030806151907896,
            },
            {
              date: '2025-06-23',
              title: 'NET PROFIT',
              path: ['NET PROFIT'],
              baseRef: 'NET SALES',
              vizHelpers: {
                lastItem: false,
                isTotal: true,
                isHeader: false,
                isBigHeader: false,
                isExpanded: true,
                isSelected: false,
                noValuesToShow: false,
              },
              anomaly: {
                anomalies: [-38871.81999999999],
                anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
                stats: {
                  mean: 5239.689999999998,
                  variance: 738317698.8131198,
                  stdDev: 27172.002112710055,
                },
              },
              trxAnomaly: {
                anomalies: [],
                anomalyScores: [],
                stats: {
                  mean: 0,
                  variance: 0,
                  stdDev: 0,
                },
              },
              trxFlagged: [],
              amount: 19210.779999999995,
              amtAvg: 19210.779999999995,
              perc: 0.2892,
              percAvg: 0.2892,
              dataRows: [],
              reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
              amountAVG: 19210.779999999995,
              percent: 0.2892,
              percentAVG: 0.2892,
              cellID: '9b50fa7c_@_29_-x-_5',
              baseAmount: 66432.15,
              transactions: 0,
              id: '9b50fa7c_@_29',
              index: 4,
              cPercent: 0.2891789592840213,
            },
          ],
          anomalies: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
        },
      ],
      isLocation: false,
      periodReporting: false,
      liveReport: false,
      periodID: '',
      date: {
        start: '2025-07-21',
        end: '2025-07-27',
      },
      compoundColumn: false,
      originType: 'Accounts',
    },
    {
      name: '2025-07-21',
      reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
      date: {
        start: '2025-07-21',
        end: '2025-07-27',
      },
      type: [
        {
          type: 'Data',
          index: 0,
        },
      ],
      data: [
        {
          date: '2025-07-21',
          title: 'SALES',
          path: ['SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: '5bc89b03_@_2_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '5bc89b03_@_2',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Food',
          path: ['SALES', 'Sales, Food'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
          trxAnomaly: {
            anomalies: [8],
            anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
            stats: {
              mean: 7.2,
              variance: 0.15999999999999998,
              stdDev: 0.39999999999999997,
            },
          },
          trxFlagged: [],
          amount: 40123,
          perc: 0.5278,
          percAvg: 0.5278,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 4814.5,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 4276,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 4525,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 3727,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 3850,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 12032.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 6898,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.5278,
          percentAVG: 0.5278,
          cellID: 'c5601bf4_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: 'c5601bf4_@_2',
          index: 0,
          cPercent: 0.5277632430125925,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Liquor',
          path: ['SALES', 'Sales, Liquor'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [
            {
              id: 'f5f466b6-1069-4f73-b141-8e3c89f3fe16',
              index: 6,
              account: '4110 Revenue / Sales:Sales, Liquor',
              type: 'trx',
              status: 'inProgress',
              period: '2025-07-23',
              createdAt: '2025-07-29 16:09:56',
              amount: 1629,
              transaction: {
                id: 'e252f492-4b2a-4e34-a610-4f77c5f721e1',
                memo: '',
                name: '',
                trxType: 'Journal Entry',
              },
            },
          ],
          amount: 22039.5,
          amtAvg: 22039.5,
          perc: 0.2899,
          percAvg: 0.2899,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 1294,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 1490,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 1629,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 1811,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 2589,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 8862.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 4364,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 22039.5,
          percent: 0.2899,
          percentAVG: 0.2899,
          cellID: 'e1ca5621_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: 'e1ca5621_@_2',
          index: 0,
          cPercent: 0.2898995088696267,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Beer',
          path: ['SALES', 'Sales, Beer'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 14,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 5225,
          amtAvg: 5225,
          perc: 0.0687,
          percAvg: 0.0687,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 97,
            },
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 376,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 110,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 542,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 61,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 474,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 20,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 347,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 107,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 503,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 600,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 1413,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 151,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 424,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5225,
          percent: 0.0687,
          percentAVG: 0.0687,
          cellID: 'ba0b0910_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 14,
          id: 'ba0b0910_@_2',
          index: 0,
          cPercent: 0.06872773583084005,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Wine',
          path: ['SALES', 'Sales, Wine'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [
            {
              id: '1e4fc649-e738-40ac-af2f-98fa638ac3fe',
              index: 4,
              account: '4120 Revenue / Sales:Sales, Wine',
              type: 'trx',
              status: 'inProgress',
              period: '2025-07-24',
              createdAt: '2025-07-29 16:58:53',
              amount: 248,
              transaction: {
                id: '88c5af13-7511-4e18-a7a0-e4757e221dce',
                memo: '',
                name: '',
                trxType: 'Journal Entry',
              },
            },
          ],
          amount: 1861,
          amtAvg: 1861,
          perc: 0.0245,
          percAvg: 0.0245,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 156,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 205,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 342,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 248,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 267,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 489,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 154,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1861,
          percent: 0.0245,
          percentAVG: 0.0245,
          cellID: '2f14959f_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '2f14959f_@_2',
          index: 0,
          cPercent: 0.02447891222606571,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Non-Alcoholic Beverage',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2599,
          amtAvg: 2599,
          perc: 0.0342,
          percAvg: 0.0342,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 333,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 316,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 243,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 266,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 205,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 701,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 535,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2599,
          percent: 0.0342,
          percentAVG: 0.0342,
          cellID: '7bb557b1_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '7bb557b1_@_2',
          index: 0,
          cPercent: 0.03418629386112025,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Miscellaneous',
          path: ['SALES', 'Sales, Miscellaneous'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
            stats: {
              mean: 3.8,
              variance: 1.3599999999999999,
              stdDev: 1.16619037896906,
            },
          },
          trxFlagged: [],
          amount: 2760.8,
          perc: 0.0363,
          percAvg: 0.0363,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 2542.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 86,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 80,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 52,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0363,
          percentAVG: 0.0363,
          cellID: 'cbede411_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 4,
          id: 'cbede411_@_2',
          index: 0,
          cPercent: 0.03631455178598722,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Service Charges',
          path: ['SALES', 'Sales, Service Charges'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1416.32,
          perc: 0.0186,
          percAvg: 0.0186,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 106.75,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 177.13,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 227.71,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 127.6,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 117.39,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 470.49,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 189.25,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0186,
          percentAVG: 0.0186,
          cellID: '4e12e939_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '4e12e939_@_2',
          index: 0,
          cPercent: 0.018629754413767536,
        },
        {
          date: '2025-07-21',
          title: 'Sales - No category',
          path: ['SALES', 'Sales - No category'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: 'a1f04b4c_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: 'a1f04b4c_@_2',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'GROSS SALES',
          path: ['GROSS SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 76024.62000000001,
          amtAvg: 76024.62000000001,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 76024.62000000001,
          cellID: '74405d1a_@_3_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: '74405d1a_@_3',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Comps & Discounts',
          path: ['Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'ba9fcd64_@_6_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: 'ba9fcd64_@_6',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Discounts and Comps',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1217.5,
          perc: -0.016,
          percAvg: -0.016,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: -177.25,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: -84.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: -59.5,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: -117.75,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: -144,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: -320.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: -314,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.016,
          percentAVG: -0.016,
          cellID: '4936addc_@_6_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '4936addc_@_6',
          index: 0,
          cPercent: -0.01601454897110962,
        },
        {
          date: '2025-07-21',
          title: 'Total Comps & Discounts',
          path: ['Total Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1217.5,
          amtAvg: -1217.5,
          perc: -0.016,
          percAvg: -0.016,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -1217.5,
          percent: -0.016,
          percentAVG: -0.016,
          cellID: '8a448d4b_@_7_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: '8a448d4b_@_7',
          index: 0,
          cPercent: -0.01601454897110962,
        },
        {
          date: '2025-07-21',
          title: 'NET SALES',
          path: ['NET SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 74807.12000000001,
          amtAvg: 74807.12000000001,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 74807.12000000001,
          cellID: '3b5cefb1_@_8_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '3b5cefb1_@_8',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'COST OF GOODS SOLD (COGS)',
          path: ['COST OF GOODS SOLD (COGS)'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: '753db221_@_9_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '753db221_@_9',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Food',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          baseRef: 'Sales, Food',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.4,
              variance: 1.4400000000000002,
              stdDev: 1.2000000000000002,
            },
          },
          trxFlagged: [],
          amount: 2046.02,
          perc: 0.051,
          percAvg: 0.051,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15521',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 374.85,
            },
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15622',
              num: '',
              name: 'Ferro & Sons, Inc.',
              description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
              amount: 1089.11,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15594',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 117.28,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15595',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 464.78,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.051,
          percentAVG: 0.051,
          cellID: '7a94d93b_@_9_-x-_1',
          baseAmount: 40123,
          transactions: 4,
          id: '7a94d93b_@_9',
          index: 0,
          cPercent: 0.050993694389751515,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Meat & Poultry',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
            stats: {
              mean: 3.8,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 3783.57,
          perc: 0.0506,
          percAvg: 0.0506,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 48.99,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 195.86,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 1591.81,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 1555.39,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 391.52,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0506,
          percentAVG: 0.0506,
          cellID: '3f46fcce_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 5,
          id: '3f46fcce_@_9',
          index: 0,
          cPercent: 0.050577672285739644,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Seafood',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 0.96,
              stdDev: 0.9797958971132712,
            },
          },
          trxFlagged: [],
          amount: 336.7,
          perc: 0.0045,
          percAvg: 0.0045,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 19.99,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 181.2,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 113.12,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 22.39,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0045,
          percentAVG: 0.0045,
          cellID: '2bdeb0ad_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 4,
          id: '2bdeb0ad_@_9',
          index: 0,
          cPercent: 0.004500908469675078,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Produce',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
            stats: {
              mean: 7.4,
              variance: 12.24,
              stdDev: 3.4985711369071804,
            },
          },
          trxFlagged: [],
          amount: 3875.6,
          perc: 0.0518,
          percAvg: 0.0518,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15525',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 674.46,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15526',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 35.75,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15527',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 576.26,
            },
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 433.25,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 180.25,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15544',
              num: '712755',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 150.68,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15615',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 986.9,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 187.5,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 451.8,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 198.75,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0518,
          percentAVG: 0.0518,
          cellID: '593c4b13_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 10,
          id: '593c4b13_@_9',
          index: 0,
          cPercent: 0.0518079027771688,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Grocery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
          trxAnomaly: {
            anomalies: [11],
            anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
            stats: {
              mean: 7.6,
              variance: 4.24,
              stdDev: 2.0591260281974,
            },
          },
          trxFlagged: [],
          amount: 2697.45,
          perc: 0.0361,
          percAvg: 0.0361,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 26.37,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 99,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 1225.26,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 1141.98,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 32.31,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 98.85,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15545',
              num: 'MI1904ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 31.92,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15546',
              num: 'MI1903ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 41.76,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0361,
          percentAVG: 0.0361,
          cellID: 'e0037727_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 8,
          id: 'e0037727_@_9',
          index: 0,
          cPercent: 0.03605873344676282,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bakery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 44.8,
          perc: 0.0006,
          percAvg: 0.0006,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 44.8,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0006,
          percentAVG: 0.0006,
          cellID: '47294ea3_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '47294ea3_@_9',
          index: 0,
          cPercent: 0.0005988734762145634,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Dairy',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
          trxAnomaly: {
            anomalies: [7],
            anomalyScores: [0.82915619758885, 0, 0, 0, 0],
            stats: {
              mean: 4.8,
              variance: 1.7600000000000002,
              stdDev: 1.32664991614216,
            },
          },
          trxFlagged: [],
          amount: 1049.11,
          perc: 0.014,
          percAvg: 0.014,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 68.24,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 68.74,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 335.06,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15544',
              num: '712755',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 115,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 293.08,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 59.09,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 109.9,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.014,
          percentAVG: 0.014,
          cellID: '841fc412_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 7,
          id: '841fc412_@_9',
          index: 0,
          cPercent: 0.014024199835523674,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Liquor',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          baseRef: 'Sales, Liquor',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
          trxAnomaly: {
            anomalies: [10],
            anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
            stats: {
              mean: 4.8,
              variance: 7.76,
              stdDev: 2.7856776554368237,
            },
          },
          trxFlagged: [],
          amount: 5695.15,
          amtAvg: 5695.15,
          perc: 0.2584,
          percAvg: 0.2584,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 1216.77,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15569',
              num: '866618',
              name: 'Allied Beverages',
              description: '',
              amount: 68.38,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15653',
              num: '6502348',
              name: 'Allied Beverages',
              description: 'CHECK 6502348',
              amount: 1483.07,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15571',
              num: '870345',
              name: 'Allied Beverages',
              description: '',
              amount: 1992.45,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15620',
              num: '',
              name: 'Fedway',
              description: 'FEDWAY ASSOCIATE FEDWAY ASS',
              amount: 934.48,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5695.15,
          percent: 0.2584,
          percentAVG: 0.2584,
          cellID: '6eb26171_@_9_-x-_1',
          baseAmount: 22039.5,
          transactions: 5,
          id: '6eb26171_@_9',
          index: 0,
          cPercent: 0.2584064974250777,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bar Groceries',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.9600000000000002,
              stdDev: 0.9797958971132713,
            },
          },
          trxFlagged: [],
          amount: 182.06,
          perc: 0.0024,
          percAvg: 0.0024,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 59,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15563',
              num: '9262982',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15562',
              num: '9265170',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0024,
          percentAVG: 0.0024,
          cellID: '15101cdc_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: '15101cdc_@_9',
          index: 0,
          cPercent: 0.002433725559813023,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          baseRef: 'Sales, Beer',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '90be8534_@_9_-x-_1',
          baseAmount: 5225,
          transactions: 0,
          id: '90be8534_@_9',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Draught Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 4.960000000000001,
              stdDev: 2.227105745132009,
            },
          },
          trxFlagged: [],
          amount: 508,
          perc: 0.0068,
          percAvg: 0.0068,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15553',
              num: '627286',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 413,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15558',
              num: '3733797',
              name: 'Peerless Beverage',
              description: '',
              amount: 95,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0068,
          percentAVG: 0.0068,
          cellID: '3395a498_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 2,
          id: '3395a498_@_9',
          index: 0,
          cPercent: 0.006790797453504425,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bottled Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 438.6,
          perc: 0.0059,
          percAvg: 0.0059,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15553',
              num: '627286',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 52.6,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15558',
              num: '3733797',
              name: 'Peerless Beverage',
              description: '',
              amount: 349,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15559',
              num: '3733798',
              name: 'Peerless Beverage',
              description: '',
              amount: 37,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0059,
          percentAVG: 0.0059,
          cellID: 'e2c4f57e_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: 'e2c4f57e_@_9',
          index: 0,
          cPercent: 0.0058630782738327576,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Wine',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          baseRef: 'Sales, Wine',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2.4,
              variance: 1.8399999999999999,
              stdDev: 1.3564659966250536,
            },
          },
          trxFlagged: [],
          amount: 1280.88,
          amtAvg: 1280.88,
          perc: 0.6883,
          percAvg: 0.6883,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15569',
              num: '866618',
              name: 'Allied Beverages',
              description: '',
              amount: 145.08,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15571',
              num: '870345',
              name: 'Allied Beverages',
              description: '',
              amount: 325.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15550',
              num: '723293',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 810,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1280.88,
          percent: 0.6883,
          percentAVG: 0.6883,
          cellID: 'b29ce542_@_9_-x-_1',
          baseAmount: 1861,
          transactions: 3,
          id: 'b29ce542_@_9',
          index: 0,
          cPercent: 0.6882751209027406,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Non-Alcoholic',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0, 0.784464540552736, 0, 0],
            stats: {
              mean: 4.4,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 1532.25,
          amtAvg: 1532.25,
          perc: 0.0205,
          percAvg: 0.0205,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 77.62,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15637',
              num: '6502336',
              name: 'Peerless Beverage',
              description: 'CHECK 6502336',
              amount: 1311.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 19.26,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 75.37,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 48.5,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1532.25,
          percent: 0.0205,
          percentAVG: 0.0205,
          cellID: '9f08e50d_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 5,
          id: '9f08e50d_@_9',
          index: 0,
          cPercent: 0.02048267598057511,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Packaging',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
          trxAnomaly: {
            anomalies: [1, 3],
            anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
            stats: {
              mean: 2,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 189.45,
          perc: 0.0025,
          percAvg: 0.0025,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 129.66,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 59.79,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0025,
          percentAVG: 0.0025,
          cellID: '027a424d_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 2,
          id: '027a424d_@_9',
          index: 0,
          cPercent: 0.0025325129479653805,
        },
        {
          date: '2025-07-21',
          title: 'Shipping, Freight and Delivery',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 387.04,
          perc: 0.0052,
          percAvg: 0.0052,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Check',
              eventId: '15649',
              num: '6502338',
              name: 'Campos Delivery LLC',
              description: 'CHECK 6502338',
              amount: 387.04,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0052,
          percentAVG: 0.0052,
          cellID: 'dfae81d5_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'dfae81d5_@_9',
          index: 0,
          cPercent: 0.005173839067725104,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL COGS',
          path: ['TOTAL COGS'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 24046.680000000004,
          amtAvg: 24046.680000000004,
          perc: 0.3214,
          percAvg: 0.3214,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 24046.680000000004,
          percent: 0.3214,
          percentAVG: 0.3214,
          cellID: '528a97f9_@_10_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '528a97f9_@_10',
          index: 0,
          cPercent: 0.3214490813173933,
        },
        {
          date: '2025-07-21',
          title: 'GROSS PROFIT',
          path: ['GROSS PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 50760.44,
          amtAvg: 50760.44,
          perc: 0.6786,
          percAvg: 0.6786,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 50760.44,
          percent: 0.6786,
          percentAVG: 0.6786,
          cellID: '7b400e74_@_12_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '7b400e74_@_12',
          index: 0,
          cPercent: 0.6785509186826066,
        },
        {
          date: '2025-07-21',
          title: 'OPERATING EXPENSES',
          path: ['OPERATING EXPENSES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 28899.82,
          amtAvg: 30351.52,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 30351.52,
          cellID: '39d9c4d4_@_13_-x-_1',
          baseAmount: 28899.82,
          transactions: 0,
          id: '39d9c4d4_@_13',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'LABOR',
          path: ['LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '5b0fe671_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '5b0fe671_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Direct Labor',
          path: ['LABOR', 'Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'bb2363da_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'bb2363da_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Labor Other',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 30,
              variance: 456.4,
              stdDev: 21.36352030916253,
            },
          },
          trxFlagged: [],
          amount: 13892.95,
          perc: 0.1857,
          percAvg: 0.1857,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15639',
              num: '6502305',
              name: 'Samantha Lada',
              description: 'POD CHECK  Payroll W.E. 07.06.2025',
              amount: 769.89,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15640',
              num: '6502320',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502320 Payroll W.E. 07.06.2025',
              amount: 684.47,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15641',
              num: '6502308',
              name: 'Olivia Mandez',
              description: 'CHECK 6502308 Payroll W.E. 07.06.2025',
              amount: 678.27,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15642',
              num: '6502266',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502266 Payroll W.E. 06.29.2025',
              amount: 606.87,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15643',
              num: '6502323',
              name: 'Anthony Sanchez',
              description: 'CHECK 6502323 Payroll W.E. 07.06.2025',
              amount: 606.26,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15644',
              num: '6502285',
              name: 'Cantillano Cardenas, Lila',
              description: 'CHECK 6502285 Payroll W.E. 07.06.2025',
              amount: 329.53,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15645',
              num: '6502304',
              name: 'Christopher Intriago',
              description: 'CHECK 6502304 Payroll W.E. 07.06.2025',
              amount: 193,
            },
            {
              txnDate: '2025-07-22',
              type: 'Check',
              eventId: '15650',
              num: '6502321',
              name: 'Manuel Ramirez',
              description: 'CHECK 6502321 Payroll W.E. 07.06.2025',
              amount: 362.39,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15652',
              num: '6502358',
              name: 'Domingo Roman',
              description: 'POD CHECK Payroll W.E. 07.13.2025',
              amount: 1511,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15654',
              num: '6502349',
              name: 'Omar Lopez',
              description: 'CHECK 6502349 Payroll W.E. 07.13.2025',
              amount: 588.1,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15655',
              num: '6502355',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502355 Payroll W.E. 07.13.2025',
              amount: 569.02,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15656',
              num: '6502354',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502354 Payroll W.E. 07.13.2025',
              amount: 494.15,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'Other',
              amount: 6500,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.1857,
          percentAVG: 0.1857,
          cellID: '687f4cd2_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 13,
          id: '687f4cd2_@_14',
          index: 0,
          cPercent: 0.18571694779855177,
        },
        {
          date: '2025-07-21',
          title: 'Labor, Management',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2244.1,
          perc: 0.03,
          percAvg: 0.03,
          dataRows: [
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'Management',
              amount: 2244.1,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.03,
          percentAVG: 0.03,
          cellID: '529343c4_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '529343c4_@_14',
          index: 0,
          cPercent: 0.029998481427971024,
        },
        {
          date: '2025-07-21',
          title: 'Labor, BOH',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1711.54,
          perc: 0.0229,
          percAvg: 0.0229,
          dataRows: [
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0229,
          percentAVG: 0.0229,
          cellID: '3c61733f_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '3c61733f_@_14',
          index: 0,
          cPercent: 0.0228793729794704,
        },
        {
          date: '2025-07-21',
          title: 'Total Direct Labor',
          path: ['LABOR', 'Total Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 17848.59,
          amtAvg: 17848.59,
          perc: 0.2386,
          percAvg: 0.2386,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 17848.59,
          percent: 0.2386,
          percentAVG: 0.2386,
          cellID: '143a84db_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '143a84db_@_14',
          index: 0,
          cPercent: 0.2385948022059932,
        },
        {
          date: '2025-07-21',
          title: 'Labor Related Expenses',
          path: ['LABOR', 'Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'dacf6533_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'dacf6533_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Commission/Bonus/Incentives',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '7a82e4de_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '7a82e4de_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Payroll Taxes',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: -788.82,
          perc: -0.0105,
          percAvg: -0.0105,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Deposit',
              eventId: '15624',
              num: '',
              name: 'Payroll Tax',
              description: 'STRATEGY EXECUTI TAX COL',
              amount: -1269.59,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'PR Tax',
              amount: 480.77,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0105,
          percentAVG: -0.0105,
          cellID: 'bbc14e9c_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 2,
          id: 'bbc14e9c_@_14',
          index: 0,
          cPercent: -0.010544718203294017,
        },
        {
          date: '2025-07-21',
          title: 'Employee Meals',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: '416bc276_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '416bc276_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Recruiting',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: 'c12aec10_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'c12aec10_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Labor Related Expenses',
          path: ['LABOR', 'Total Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -788.82,
          amtAvg: -788.82,
          perc: -0.0105,
          percAvg: -0.0105,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -788.82,
          percent: -0.0105,
          percentAVG: -0.0105,
          cellID: '1e9ad256_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1e9ad256_@_14',
          index: 0,
          cPercent: -0.010544718203294017,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL LABOR',
          path: ['TOTAL LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 17059.77,
          amtAvg: 17059.77,
          perc: 0.2281,
          percAvg: 0.2281,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 17059.77,
          percent: 0.2281,
          percentAVG: 0.2281,
          cellID: 'd0736ae7_@_15_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd0736ae7_@_15',
          index: 0,
          cPercent: 0.2280500840026992,
        },
        {
          date: '2025-07-21',
          title: 'PRIME COST',
          path: ['PRIME COST'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 41106.450000000004,
          amtAvg: 41106.450000000004,
          perc: 0.5495,
          percAvg: 0.5495,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 41106.450000000004,
          percent: 0.5495,
          percentAVG: 0.5495,
          cellID: 'b7d061ce_@_16_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b7d061ce_@_16',
          index: 0,
          cPercent: 0.5494991653200925,
        },
        {
          date: '2025-07-21',
          title: 'Contribution Margin',
          path: ['Contribution Margin'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 33700.670000000006,
          amtAvg: 33700.670000000006,
          perc: 0.4505,
          percAvg: 0.4505,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 33700.670000000006,
          percent: 0.4505,
          percentAVG: 0.4505,
          cellID: '2f5a4d68_@_17_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '2f5a4d68_@_17',
          index: 0,
          cPercent: 0.4505008346799075,
        },
        {
          date: '2025-07-21',
          title: 'CONTROLLABLE EXPENSES',
          path: ['CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '2cd659af_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '2cd659af_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '3be3d09b_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '3be3d09b_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Equipment Lease Rental',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 35,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 35,
          percent: 0,
          percentAVG: 0.0005,
          cellID: '1a6a3f76_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1a6a3f76_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Cleaning Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
            stats: {
              mean: 2.2,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 184.53,
          amtAvg: 114.23,
          perc: 0.0025,
          percAvg: 0.0015,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15534',
              num: '3590454',
              name: 'White Plains Linen',
              description: '',
              amount: 83.48,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 65.35,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 35.7,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 114.23,
          percent: 0.0025,
          percentAVG: 0.0015,
          cellID: '514ec7ed_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: '514ec7ed_@_18',
          index: 0,
          cPercent: 0.00246674380727396,
        },
        {
          date: '2025-07-21',
          title: 'Cleaning Services',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 235.95,
          perc: 0,
          percAvg: 0.0032,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 235.95,
          percent: 0,
          percentAVG: 0.0032,
          cellID: '758ae475_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '758ae475_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Restaurant Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 529.68,
          amtAvg: 402.65,
          perc: 0.0071,
          percAvg: 0.0054,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 270.35,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 139.53,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 119.8,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 402.65,
          percent: 0.0071,
          percentAVG: 0.0054,
          cellID: '28a2ce1f_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: '28a2ce1f_@_18',
          index: 0,
          cPercent: 0.007080609439315401,
        },
        {
          date: '2025-07-21',
          title: 'Laundry, Linens, & Uniforms',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16,
              stdDev: 0.4,
            },
          },
          trxFlagged: [],
          amount: 268.89,
          amtAvg: 557.42,
          perc: 0.0036,
          percAvg: 0.0075,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15534',
              num: '3590454',
              name: 'White Plains Linen',
              description: '',
              amount: 268.89,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 557.42,
          percent: 0.0036,
          percentAVG: 0.0075,
          cellID: 'ad6ac922_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'ad6ac922_@_18',
          index: 0,
          cPercent: 0.0035944439513244187,
        },
        {
          date: '2025-07-21',
          title: 'Kitchen/ Bar Smallwares',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '9f991141_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9f991141_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 983.0999999999999,
          amtAvg: 1345.25,
          perc: 0.0131,
          percAvg: 0.018,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1345.25,
          percent: 0.0131,
          percentAVG: 0.018,
          cellID: 'b7f8c8b8_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b7f8c8b8_@_18',
          index: 0,
          cPercent: 0.01314179719791378,
        },
        {
          date: '2025-07-21',
          title: 'Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '9d0fd7d1_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9d0fd7d1_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: '3rd Party Commissions',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '47bbbb15_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '47bbbb15_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd484c66b_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd484c66b_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'edd65db2_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'edd65db2_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Marketing & Public Relations',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 388.88,
          perc: 0,
          percAvg: 0.0052,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 388.88,
          percent: 0,
          percentAVG: 0.0052,
          cellID: 'c61b398a_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'c61b398a_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Advertising & Promotions',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
            stats: {
              mean: 1.8,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 548,
          amtAvg: 466.08,
          perc: 0.0073,
          percAvg: 0.0062,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15524',
              num: '',
              name: 'Popmenu Inc.',
              description: 'VISA DDA PUR AP - 401134     POPMENU INC                 POPMENU COM   * GA',
              amount: 548,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 466.08,
          percent: 0.0073,
          percentAVG: 0.0062,
          cellID: '1dc3b3a3_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '1dc3b3a3_@_18',
          index: 0,
          cPercent: 0.007325505914410285,
        },
        {
          date: '2025-07-21',
          title: 'Total Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 548,
          amtAvg: 854.96,
          perc: 0.0073,
          percAvg: 0.0114,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 854.96,
          percent: 0.0073,
          percentAVG: 0.0114,
          cellID: '024ba9eb_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '024ba9eb_@_18',
          index: 0,
          cPercent: 0.007325505914410285,
        },
        {
          date: '2025-07-21',
          title: 'Music & DJ',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '0c83dbac_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '0c83dbac_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '6f7c6ca5_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '6f7c6ca5_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Accounting & Bookkeeping',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 338.48,
          perc: 0,
          percAvg: 0.0045,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 338.48,
          percent: 0,
          percentAVG: 0.0045,
          cellID: '5a0fedcf_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '5a0fedcf_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Consulting',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'b08821c2_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b08821c2_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Legal',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 1233.49,
          amtAvg: 658.11,
          perc: 0.0165,
          percAvg: 0.0088,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15623',
              num: '',
              name: 'At Law',
              description: 'WIRE TRANSFER OUTGOING - Collection At Law',
              amount: 1233.49,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 658.11,
          percent: 0.0165,
          percentAVG: 0.0088,
          cellID: 'a630ac37_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'a630ac37_@_18',
          index: 0,
          cPercent: 0.01648893848606924,
        },
        {
          date: '2025-07-21',
          title: 'Payroll Processing Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 38.96,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 38.96,
          percent: 0,
          percentAVG: 0.0005,
          cellID: '975961bc_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '975961bc_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Computer Supplies, Software & IT',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 350.15,
          perc: 0,
          percAvg: 0.0047,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 350.15,
          percent: 0,
          percentAVG: 0.0047,
          cellID: '9450bb96_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9450bb96_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Dues and Subscriptions',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 12.78,
          amtAvg: 28.71,
          perc: 0.0002,
          percAvg: 0.0004,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15529',
              num: '',
              name: 'Spotify',
              description: 'VISA DDA PUR AP - 420429     SPOTIFY USA                 877 7781161   * NY',
              amount: 12.78,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 28.71,
          percent: 0.0002,
          percentAVG: 0.0004,
          cellID: '236c5723_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '236c5723_@_18',
          index: 0,
          cPercent: 0.00017083935325942233,
        },
        {
          date: '2025-07-21',
          title: 'Bank Charges & Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.8400000000000003,
              stdDev: 1.3564659966250538,
            },
          },
          trxFlagged: [],
          amount: 90,
          amtAvg: 47.42,
          perc: 0.0012,
          percAvg: 0.0006,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15609',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15610',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15611',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 47.42,
          percent: 0.0012,
          percentAVG: 0.0006,
          cellID: 'c3c23383_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: 'c3c23383_@_18',
          index: 0,
          cPercent: 0.0012030940370381855,
        },
        {
          date: '2025-07-21',
          title: 'Office Supplies & Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
            stats: {
              mean: 8.2,
              variance: 15.36,
              stdDev: 3.919183588453085,
            },
          },
          trxFlagged: [],
          amount: 3521.12,
          amtAvg: 1390.72,
          perc: 0.0471,
          percAvg: 0.0186,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15517',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 1086.51,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15518',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 318.9,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15519',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 51.17,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15638',
              num: '6502345',
              name: 'Meow Hospitality LLC',
              description: 'POD CHECK',
              amount: 1063,
            },
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15625',
              num: '',
              name: 'CVS Pharmacy',
              description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
              amount: 802.22,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15575',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 62.37,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15576',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 44.77,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15577',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 56.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15579',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 14.49,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15578',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 14.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15581',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 6.39,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1390.72,
          percent: 0.0471,
          percentAVG: 0.0186,
          cellID: '058d9b25_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 11,
          id: '058d9b25_@_18',
          index: 0,
          cPercent: 0.04706931639662106,
        },
        {
          date: '2025-07-21',
          title: 'Phone and Internet',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 88.8,
          perc: 0,
          percAvg: 0.0012,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 88.8,
          percent: 0,
          percentAVG: 0.0012,
          cellID: '0c2b505e_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '0c2b505e_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Security',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '9dc533d9_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9dc533d9_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4857.389999999999,
          amtAvg: 2941.35,
          perc: 0.0649,
          percAvg: 0.0393,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2941.35,
          percent: 0.0649,
          percentAVG: 0.0393,
          cellID: 'f12db2ec_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'f12db2ec_@_18',
          index: 0,
          cPercent: 0.0649321882729879,
        },
        {
          date: '2025-07-21',
          title: 'Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '084f517c_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '084f517c_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Travel, Ground Transport & Airfare',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 355.12,
          amtAvg: 175.05,
          perc: 0.0047,
          percAvg: 0.0023,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15606',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 60.9,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15607',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 81.87,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15603',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 52.21,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15605',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 54.38,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15604',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 50.67,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15608',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 55.09,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 175.05,
          percent: 0.0047,
          percentAVG: 0.0023,
          cellID: 'e4e1ab18_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 6,
          id: 'e4e1ab18_@_18',
          index: 0,
          cPercent: 0.004747141715922227,
        },
        {
          date: '2025-07-21',
          title: 'Meals & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 86.91,
          amtAvg: 237.27,
          perc: 0.0012,
          percAvg: 0.0032,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15528',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 86.91,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 237.27,
          percent: 0.0012,
          percentAVG: 0.0032,
          cellID: 'f245aeff_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'f245aeff_@_18',
          index: 0,
          cPercent: 0.0011617878084332078,
        },
        {
          date: '2025-07-21',
          title: 'Parking',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1238,
          amtAvg: 279.55,
          perc: 0.0165,
          percAvg: 0.0037,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15621',
              num: '',
              name: 'Hoboken Parking',
              description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
              amount: 1238,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 279.55,
          percent: 0.0165,
          percentAVG: 0.0037,
          cellID: '3ae4b332_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '3ae4b332_@_18',
          index: 0,
          cPercent: 0.016549226865036373,
        },
        {
          date: '2025-07-21',
          title: 'Fuel',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 34.01,
          amtAvg: 23.71,
          perc: 0.0005,
          percAvg: 0.0003,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15583',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 34.01,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 23.71,
          percent: 0.0005,
          percentAVG: 0.0003,
          cellID: '4dbd49a9_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '4dbd49a9_@_18',
          index: 0,
          cPercent: 0.00045463586888520765,
        },
        {
          date: '2025-07-21',
          title: 'Total Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1714.04,
          amtAvg: 715.58,
          perc: 0.0229,
          percAvg: 0.0096,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 715.58,
          percent: 0.0229,
          percentAVG: 0.0096,
          cellID: 'ea7ffa49_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'ea7ffa49_@_18',
          index: 0,
          cPercent: 0.022912792258277016,
        },
        {
          date: '2025-07-21',
          title: 'Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '1675dbe8_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1675dbe8_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Repair & Maintenance, Equipment',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 551.33,
          perc: 0,
          percAvg: 0.0074,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 551.33,
          percent: 0,
          percentAVG: 0.0074,
          cellID: 'aa06968c_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'aa06968c_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Repair & Maintenance, Facility',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
            stats: {
              mean: 1,
              variance: 1.2,
              stdDev: 1.0954451150103321,
            },
          },
          trxFlagged: [],
          amount: 1777.52,
          amtAvg: 1607.85,
          perc: 0.0238,
          percAvg: 0.0215,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15636',
              num: '6502326',
              name: 'Eileen Kim',
              description: 'CHECK 6502326 Electrical & plumbing work',
              amount: 1777.52,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1607.85,
          percent: 0.0238,
          percentAVG: 0.0215,
          cellID: '4d40af10_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '4d40af10_@_18',
          index: 0,
          cPercent: 0.023761374585734615,
        },
        {
          date: '2025-07-21',
          title: 'Pest Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 118.65,
          perc: 0,
          percAvg: 0.0016,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 118.65,
          percent: 0,
          percentAVG: 0.0016,
          cellID: 'a044faba_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'a044faba_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Fire Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd6450b86_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd6450b86_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1777.52,
          amtAvg: 2277.83,
          perc: 0.0238,
          percAvg: 0.0304,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2277.83,
          percent: 0.0238,
          percentAVG: 0.0304,
          cellID: '4da1092f_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '4da1092f_@_18',
          index: 0,
          cPercent: 0.023761374585734615,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL CONTROLLABLE EXPENSES',
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 9880.05,
          amtAvg: 8134.97,
          perc: 0.1321,
          percAvg: 0.1087,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 8134.97,
          percent: 0.1321,
          percentAVG: 0.1087,
          cellID: 'a624f257_@_19_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'a624f257_@_19',
          index: 0,
          cPercent: 0.1320736582293236,
        },
        {
          date: '2025-07-21',
          title: 'Controllable Profit',
          path: ['Controllable Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 23820.620000000006,
          amtAvg: 25565.700000000004,
          perc: 0.3184,
          percAvg: 0.3418,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 25565.700000000004,
          percent: 0.3184,
          percentAVG: 0.3418,
          cellID: 'a973b710_@_20_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'a973b710_@_20',
          index: 0,
          cPercent: 0.3184271764505839,
        },
        {
          date: '2025-07-21',
          title: 'NON-CONTROLLABLE EXPENSES',
          path: ['NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '79208dfc_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '79208dfc_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '52e26b6b_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '52e26b6b_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Rent/Lease',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 4163.27,
          perc: 0,
          percAvg: 0.0557,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 4163.27,
          percent: 0,
          percentAVG: 0.0557,
          cellID: '68876c4f_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '68876c4f_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Utility, Electricity',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: '208dfabc_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '208dfabc_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Utility, Gas',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'c9446d9c_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'c9446d9c_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 4163.27,
          perc: 0,
          percAvg: 0.0557,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 4163.27,
          percent: 0,
          percentAVG: 0.0557,
          cellID: '20d5762f_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '20d5762f_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '763b7c77_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '763b7c77_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Other Income/Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: -0.23,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -0.23,
          percent: 0,
          percentAVG: 0,
          cellID: '91f38f9a_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '91f38f9a_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'To Be Classified P&L',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.56,
              stdDev: 0.7483314773547883,
            },
          },
          trxFlagged: [],
          amount: 1960,
          amtAvg: 993.74,
          perc: 0.0262,
          percAvg: 0.0133,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15657',
              num: '6502339',
              name: 'Roberto Averos',
              description: 'CHECK 6502339',
              amount: 1960,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 993.74,
          percent: 0.0262,
          percentAVG: 0.0133,
          cellID: '5ccef3e9_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '5ccef3e9_@_21',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'Total Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1960,
          amtAvg: 993.51,
          perc: 0.0262,
          percAvg: 0.0133,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 993.51,
          percent: 0.0262,
          percentAVG: 0.0133,
          cellID: 'd4b5a9af_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd4b5a9af_@_21',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL NON-CONTROLLABLE EXPENSES',
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1960,
          amtAvg: 5156.78,
          perc: 0.0262,
          percAvg: 0.0689,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5156.78,
          percent: 0.0262,
          percentAVG: 0.0689,
          cellID: '1851dc59_@_22_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1851dc59_@_22',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'Operating Profit',
          path: ['Operating Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 21860.620000000006,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.2922,
          percentAVG: 0.2728,
          cellID: '251b8ac6_@_23_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '251b8ac6_@_23',
          index: 0,
          cPercent: 0.2922264618661967,
        },
        {
          date: '2025-07-21',
          title: 'Other Expenses',
          path: ['Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: '5e10c38d_@_24_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '5e10c38d_@_24',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Loan Interest',
          path: ['Other Expenses', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: '13e3a076_@_24_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '13e3a076_@_24',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Other Expenses',
          path: ['Total Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: 'caeb87a7_@_25_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'caeb87a7_@_25',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'EBITDA',
          path: ['EBITDA'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 21860.620000000006,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.2922,
          percentAVG: 0.2728,
          cellID: 'e815a21e_@_26_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'e815a21e_@_26',
          index: 0,
          cPercent: 0.2922264618661967,
        },
        {
          date: '2025-07-21',
          title: 'Interest, Taxes, Depreciation and Amortization',
          path: ['Interest, Taxes, Depreciation and Amortization'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: '644555ee_@_27_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '644555ee_@_27',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Loan Interest',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: 'dce93088_@_27_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'dce93088_@_27',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Interest, Taxes, Depreciation and Amortization',
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          cellID: 'b4184eff_@_28_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b4184eff_@_28',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'NET PROFIT',
          path: ['NET PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 21860.620000000006,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.2922,
          percentAVG: 0.2728,
          cellID: '9b50fa7c_@_29_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9b50fa7c_@_29',
          index: 0,
          cPercent: 0.2922264618661967,
        },
      ],
      total: false,
      compoundColumn: false,
      isLocation: false,
      liveReport: false,
      periodReporting: false,
      periodID: '',
      consolidated: false,
      originType: 'Data',
    },
    {
      name: '2025-07-14',
      reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
      date: {
        start: '2025-07-14',
        end: '2025-07-20',
      },
      type: [
        {
          type: 'Data',
          index: 1,
        },
      ],
      data: [
        {
          date: '2025-07-14',
          title: 'SALES',
          path: ['SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: '5bc89b03_@_2_-x-_2',
          baseAmount: 0,
          transactions: 0,
          id: '5bc89b03_@_2',
          index: 1,
        },
        {
          date: '2025-07-14',
          title: 'Sales, Food',
          path: ['SALES', 'Sales, Food'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
          trxAnomaly: {
            anomalies: [8],
            anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
            stats: {
              mean: 7.2,
              variance: 0.15999999999999998,
              stdDev: 0.39999999999999997,
            },
          },
          trxFlagged: [],
          amount: 37673.51,
          perc: 0.5454,
          percAvg: 0.5454,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 2311,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 3859,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 2662,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 2951,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 7307.5,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 11975.51,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 6607.5,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.5454,
          percentAVG: 0.5454,
          cellID: 'c5601bf4_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 7,
          id: 'c5601bf4_@_2',
          index: 1,
          cPercent: 0.5453882289924938,
        },
        {
          date: '2025-07-14',
          title: 'Sales, Liquor',
          path: ['SALES', 'Sales, Liquor'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18733.5,
          amtAvg: 18733.5,
          perc: 0.2712,
          percAvg: 0.2712,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 362,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 1232,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 822,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 1973,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 3302,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 7901.5,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 3141,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 18733.5,
          percent: 0.2712,
          percentAVG: 0.2712,
          cellID: 'e1ca5621_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 7,
          id: 'e1ca5621_@_2',
          index: 1,
          cPercent: 0.2711993224902825,
        },
        {
          date: '2025-07-14',
          title: 'Sales, Beer',
          path: ['SALES', 'Sales, Beer'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 14,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [
            {
              id: 'eb89fd19-e2a6-4df6-8e97-6a0462be5e2f',
              index: 0,
              account: 'Sales, Beer',
              type: 'Flagged Cell',
              status: 'inProgress',
              period: '2025-07-14',
              createdAt: '2025-07-29 19:37:44',
              amount: 5015,
            },
            {
              id: 'f53bb8ca-cc34-4ea6-bd43-eda4d5af03d8',
              index: 5,
              account: '4115 Revenue / Sales:Sales, Beer',
              type: 'trx',
              status: 'inProgress',
              period: '2025-07-15',
              createdAt: '2025-07-29 16:49:23',
              amount: 102,
              transaction: {
                id: 'b1888fa0-4e9b-4d9b-a1f2-2b02e6f3be52',
                memo: '',
                name: '',
                trxType: 'Journal Entry',
              },
            },
          ],
          amount: 5015,
          amtAvg: 5015,
          perc: 0.0726,
          percAvg: 0.0726,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 56,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 173,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 102,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 583,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 85,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 178,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 77,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 467,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 96,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 623,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 417,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 1256,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 261,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 641,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 5015,
          percent: 0.0726,
          percentAVG: 0.0726,
          cellID: 'ba0b0910_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 14,
          id: 'ba0b0910_@_2',
          index: 1,
          cPercent: 0.07260066737602514,
        },
        {
          date: '2025-07-14',
          title: 'Sales, Wine',
          path: ['SALES', 'Sales, Wine'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1636,
          amtAvg: 1636,
          perc: 0.0237,
          percAvg: 0.0237,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 52,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 373,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 144,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 195,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 419,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 324,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 129,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 1636,
          percent: 0.0237,
          percentAVG: 0.0237,
          cellID: '2f14959f_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 7,
          id: '2f14959f_@_2',
          index: 1,
          cPercent: 0.023683886705319464,
        },
        {
          date: '2025-07-14',
          title: 'Sales, Non-Alcoholic Beverage',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2370,
          amtAvg: 2370,
          perc: 0.0343,
          percAvg: 0.0343,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 170,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 307,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 141,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 239,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 451,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 583,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 479,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 2370,
          percent: 0.0343,
          percentAVG: 0.0343,
          cellID: '7bb557b1_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 7,
          id: '7bb557b1_@_2',
          index: 1,
          cPercent: 0.03430978697530998,
        },
        {
          date: '2025-07-14',
          title: 'Sales, Miscellaneous',
          path: ['SALES', 'Sales, Miscellaneous'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
            stats: {
              mean: 3.8,
              variance: 1.3599999999999999,
              stdDev: 1.16619037896906,
            },
          },
          trxFlagged: [],
          amount: 2387.65,
          perc: 0.0346,
          percAvg: 0.0346,
          dataRows: [
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 29.48,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 1140.57,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 1217.6,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0346,
          percentAVG: 0.0346,
          cellID: 'cbede411_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 3,
          id: 'cbede411_@_2',
          index: 1,
          cPercent: 0.03456530078970417,
        },
        {
          date: '2025-07-14',
          title: 'Sales, Service Charges',
          path: ['SALES', 'Sales, Service Charges'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1260.84,
          perc: 0.0183,
          percAvg: 0.0183,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 64.36,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 139.39,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 85.01,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 109.8,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 281.63,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 382.51,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 198.14,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0183,
          percentAVG: 0.0183,
          cellID: '4e12e939_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 7,
          id: '4e12e939_@_2',
          index: 1,
          cPercent: 0.01825280667086491,
        },
        {
          date: '2025-07-14',
          title: 'Sales - No category',
          path: ['SALES', 'Sales - No category'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: 'a1f04b4c_@_2_-x-_2',
          baseAmount: 69076.5,
          transactions: 0,
          id: 'a1f04b4c_@_2',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'GROSS SALES',
          path: ['GROSS SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 69076.5,
          amtAvg: 69076.5,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 69076.5,
          cellID: '74405d1a_@_3_-x-_2',
          baseAmount: 69076.5,
          transactions: 0,
          id: '74405d1a_@_3',
          index: 1,
        },
        {
          date: '2025-07-14',
          title: 'Comps & Discounts',
          path: ['Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: 'ba9fcd64_@_6_-x-_2',
          baseAmount: 69076.5,
          transactions: 0,
          id: 'ba9fcd64_@_6',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Discounts and Comps',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -982.3,
          perc: -0.0142,
          percAvg: -0.0142,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: -56,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: -169.8,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: -54,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: -64.5,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: -142.75,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: -453.25,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: -42,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: -0.0142,
          percentAVG: -0.0142,
          cellID: '4936addc_@_6_-x-_2',
          baseAmount: 69076.5,
          transactions: 7,
          id: '4936addc_@_6',
          index: 1,
          cPercent: -0.014220465715547255,
        },
        {
          date: '2025-07-14',
          title: 'Total Comps & Discounts',
          path: ['Total Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -982.3,
          amtAvg: -982.3,
          perc: -0.0142,
          percAvg: -0.0142,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: -982.3,
          percent: -0.0142,
          percentAVG: -0.0142,
          cellID: '8a448d4b_@_7_-x-_2',
          baseAmount: 69076.5,
          transactions: 0,
          id: '8a448d4b_@_7',
          index: 1,
          cPercent: -0.014220465715547255,
        },
        {
          date: '2025-07-14',
          title: 'NET SALES',
          path: ['NET SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 68094.2,
          amtAvg: 68094.2,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 68094.2,
          cellID: '3b5cefb1_@_8_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '3b5cefb1_@_8',
          index: 1,
        },
        {
          date: '2025-07-14',
          title: 'COST OF GOODS SOLD (COGS)',
          path: ['COST OF GOODS SOLD (COGS)'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: '753db221_@_9_-x-_2',
          baseAmount: 0,
          transactions: 0,
          id: '753db221_@_9',
          index: 1,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Food',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          baseRef: 'Sales, Food',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.4,
              variance: 1.4400000000000002,
              stdDev: 1.2000000000000002,
            },
          },
          trxFlagged: [],
          amount: 1092.35,
          perc: 0.029,
          percAvg: 0.029,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15227',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 210.91,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15229',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 200.5,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15235',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 184.53,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15236',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 89.76,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15324',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 406.65,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.029,
          percentAVG: 0.029,
          cellID: '7a94d93b_@_9_-x-_2',
          baseAmount: 37673.51,
          transactions: 5,
          id: '7a94d93b_@_9',
          index: 1,
          cPercent: 0.02899517459350084,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Meat & Poultry',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
            stats: {
              mean: 3.8,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 3997.89,
          perc: 0.0587,
          percAvg: 0.0587,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 797.83,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 97.98,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 1822.14,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 1279.94,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0587,
          percentAVG: 0.0587,
          cellID: '3f46fcce_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 4,
          id: '3f46fcce_@_9',
          index: 1,
          cPercent: 0.05871116776465543,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Seafood',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 0.96,
              stdDev: 0.9797958971132712,
            },
          },
          trxFlagged: [],
          amount: 487.73,
          perc: 0.0072,
          percAvg: 0.0072,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 113.07,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 23.49,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 113.18,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 237.99,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0072,
          percentAVG: 0.0072,
          cellID: '2bdeb0ad_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 4,
          id: '2bdeb0ad_@_9',
          index: 1,
          cPercent: 0.007162577723212844,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Produce',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
            stats: {
              mean: 7.4,
              variance: 12.24,
              stdDev: 3.4985711369071804,
            },
          },
          trxFlagged: [],
          amount: 3361.74,
          perc: 0.0494,
          percAvg: 0.0494,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15440',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 487.94,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15442',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 26.75,
            },
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15444',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 438.75,
            },
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15446',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 81.58,
            },
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15447',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 16.5,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15538',
              num: 'IV101-0027025164',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 16.5,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 200.25,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15448',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 286.21,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15449',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 936.51,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15467',
              num: '6502274',
              name: 'Avanti Produce',
              description: 'CHECK 6502274',
              amount: 732.25,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 138.5,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0494,
          percentAVG: 0.0494,
          cellID: '593c4b13_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 11,
          id: '593c4b13_@_9',
          index: 1,
          cPercent: 0.049368962407958385,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Grocery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
          trxAnomaly: {
            anomalies: [11],
            anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
            stats: {
              mean: 7.6,
              variance: 4.24,
              stdDev: 2.0591260281974,
            },
          },
          trxFlagged: [],
          amount: 12455.23,
          perc: 0.1829,
          percAvg: 0.1829,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 575.78,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15456',
              num: '6502279',
              name: 'Performance Food Service',
              description: 'CHECK 6502279',
              amount: 6401.55,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 33.7,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 581.93,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15319',
              num: '',
              name: 'The Webstaurant Store',
              description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
              amount: 594.29,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15514',
              num: '',
              name: 'ShopRite',
              description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
              amount: 41.27,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15516',
              num: '6502334',
              name: 'Performance Food Service',
              description: 'CHECK 6502334',
              amount: 3560.65,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 666.06,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.1829,
          percentAVG: 0.1829,
          cellID: 'e0037727_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 8,
          id: 'e0037727_@_9',
          index: 1,
          cPercent: 0.18291176047299182,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Bakery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 715.21,
          perc: 0.0105,
          percAvg: 0.0105,
          dataRows: [
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15262',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 670.41,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 44.8,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0105,
          percentAVG: 0.0105,
          cellID: '47294ea3_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: '47294ea3_@_9',
          index: 1,
          cPercent: 0.010503244035468514,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Dairy',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
          trxAnomaly: {
            anomalies: [7],
            anomalyScores: [0.82915619758885, 0, 0, 0, 0],
            stats: {
              mean: 4.8,
              variance: 1.7600000000000002,
              stdDev: 1.32664991614216,
            },
          },
          trxFlagged: [],
          amount: 1228.65,
          perc: 0.018,
          percAvg: 0.018,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 245.74,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15539',
              num: 'IV101-0027025183',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 81.58,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 30.22,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 475.14,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 395.97,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.018,
          percentAVG: 0.018,
          cellID: '841fc412_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 5,
          id: '841fc412_@_9',
          index: 1,
          cPercent: 0.018043386955129807,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Liquor',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          baseRef: 'Sales, Liquor',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
          trxAnomaly: {
            anomalies: [10],
            anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
            stats: {
              mean: 4.8,
              variance: 7.76,
              stdDev: 2.7856776554368237,
            },
          },
          trxFlagged: [],
          amount: 1597.33,
          amtAvg: 1597.33,
          perc: 0.0853,
          percAvg: 0.0853,
          dataRows: [
            {
              txnDate: '2025-07-16',
              type: 'Deposit',
              eventId: '15469',
              num: '',
              name: 'Allied Beverages',
              description: '653030 Dt.06.19.2025',
              amount: -215,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15512',
              num: '6502221',
              name: 'Fedway',
              description: 'POD CHECK',
              amount: 1000,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15549',
              num: '59469',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 812.33,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 1597.33,
          percent: 0.0853,
          percentAVG: 0.0853,
          cellID: '6eb26171_@_9_-x-_2',
          baseAmount: 18733.5,
          transactions: 3,
          id: '6eb26171_@_9',
          index: 1,
          cPercent: 0.08526596738463181,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Bar Groceries',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.9600000000000002,
              stdDev: 0.9797958971132713,
            },
          },
          trxFlagged: [],
          amount: 90.52,
          perc: 0.0013,
          percAvg: 0.0013,
          dataRows: [
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 90.52,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0013,
          percentAVG: 0.0013,
          cellID: '15101cdc_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '15101cdc_@_9',
          index: 1,
          cPercent: 0.001329334950700647,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          baseRef: 'Sales, Beer',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '90be8534_@_9_-x-_2',
          baseAmount: 5015,
          transactions: 0,
          id: '90be8534_@_9',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Draught Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 4.960000000000001,
              stdDev: 2.227105745132009,
            },
          },
          trxFlagged: [],
          amount: 3631.5,
          perc: 0.0533,
          percAvg: 0.0533,
          dataRows: [
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15493',
              num: '',
              name: 'Northern Eagle Beverage',
              description: 'NORTHERN EAGLE B INVOICES',
              amount: 870.5,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15554',
              num: '625995',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 640,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15555',
              num: '3733721',
              name: 'Peerless Beverage',
              description: '',
              amount: 447,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15556',
              num: '3733723',
              name: 'Peerless Beverage',
              description: '',
              amount: 485,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15498',
              num: '',
              name: 'Northern Eagle Beverage',
              description: 'NORTHERN EAGLE B INVOICES',
              amount: 640,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15508',
              num: '6502332',
              name: 'Hoboken Brewing',
              description: 'CHECK 6502332',
              amount: 549,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0533,
          percentAVG: 0.0533,
          cellID: '3395a498_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 6,
          id: '3395a498_@_9',
          index: 1,
          cPercent: 0.053330533290647374,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Bottled Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 522,
          perc: 0.0077,
          percAvg: 0.0077,
          dataRows: [
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15555',
              num: '3733721',
              name: 'Peerless Beverage',
              description: '',
              amount: 298,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15549',
              num: '59469',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 224,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0077,
          percentAVG: 0.0077,
          cellID: 'e2c4f57e_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: 'e2c4f57e_@_9',
          index: 1,
          cPercent: 0.007665851129758482,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Wine',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          baseRef: 'Sales, Wine',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2.4,
              variance: 1.8399999999999999,
              stdDev: 1.3564659966250536,
            },
          },
          trxFlagged: [],
          amount: 1032.5,
          amtAvg: 1032.5,
          perc: 0.6311,
          percAvg: 0.6311,
          dataRows: [
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15549',
              num: '59469',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 507.3,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15551',
              num: '714240',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 525.2,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 1032.5,
          percent: 0.6311,
          percentAVG: 0.6311,
          cellID: 'b29ce542_@_9_-x-_2',
          baseAmount: 1636,
          transactions: 2,
          id: 'b29ce542_@_9',
          index: 1,
          cPercent: 0.6311124694376528,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Non-Alcoholic',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0, 0.784464540552736, 0, 0],
            stats: {
              mean: 4.4,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 1730.15,
          amtAvg: 1730.15,
          perc: 0.0254,
          percAvg: 0.0254,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15437',
              num: '6502262',
              name: 'Peerless Beverage',
              description: 'CHECK 6502262',
              amount: 986,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 65.5,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15557',
              num: '3733722',
              name: 'Peerless Beverage',
              description: '',
              amount: 81.5,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15560',
              num: '13859010',
              name: 'Pepsi',
              description: '',
              amount: 597.15,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 1730.15,
          percent: 0.0254,
          percentAVG: 0.0254,
          cellID: '9f08e50d_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 4,
          id: '9f08e50d_@_9',
          index: 1,
          cPercent: 0.025408184544351797,
        },
        {
          date: '2025-07-14',
          title: 'COGS, Packaging',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
          trxAnomaly: {
            anomalies: [1, 3],
            anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
            stats: {
              mean: 2,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 410.12,
          perc: 0.006,
          percAvg: 0.006,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 102.98,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 307.14,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.006,
          percentAVG: 0.006,
          cellID: '027a424d_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: '027a424d_@_9',
          index: 1,
          cPercent: 0.006022833075357373,
        },
        {
          date: '2025-07-14',
          title: 'Shipping, Freight and Delivery',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: 'dfae81d5_@_9_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'dfae81d5_@_9',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'TOTAL COGS',
          path: ['TOTAL COGS'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 32352.92,
          amtAvg: 32352.92,
          perc: 0.4751,
          percAvg: 0.4751,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 32352.92,
          percent: 0.4751,
          percentAVG: 0.4751,
          cellID: '528a97f9_@_10_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '528a97f9_@_10',
          index: 1,
          cPercent: 0.4751200542777505,
        },
        {
          date: '2025-07-14',
          title: 'GROSS PROFIT',
          path: ['GROSS PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 35741.28,
          amtAvg: 35741.28,
          perc: 0.5249,
          percAvg: 0.5249,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 35741.28,
          percent: 0.5249,
          percentAVG: 0.5249,
          cellID: '7b400e74_@_12_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '7b400e74_@_12',
          index: 1,
          cPercent: 0.5248799457222495,
        },
        {
          date: '2025-07-14',
          title: 'OPERATING EXPENSES',
          path: ['OPERATING EXPENSES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 74613.1,
          amtAvg: 56783.54,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 56783.54,
          cellID: '39d9c4d4_@_13_-x-_2',
          baseAmount: 74613.1,
          transactions: 0,
          id: '39d9c4d4_@_13',
          index: 1,
        },
        {
          date: '2025-07-14',
          title: 'LABOR',
          path: ['LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '5b0fe671_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '5b0fe671_@_14',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Direct Labor',
          path: ['LABOR', 'Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: 'bb2363da_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'bb2363da_@_14',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Labor Other',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 30,
              variance: 456.4,
              stdDev: 21.36352030916253,
            },
          },
          trxFlagged: [],
          amount: 28890.19,
          perc: 0.4243,
          percAvg: 0.4243,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15430',
              num: '6502230',
              name: 'Cantillano Cardenas, Lila',
              description: 'CHECK 6502230 W.E. 06.29.2025',
              amount: 85.04,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15431',
              num: '6502244',
              name: 'Christopher Intriago',
              description: 'CHECK 6502244 W.E. 06.29.2025',
              amount: 141.3,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15432',
              num: '6502226',
              name: 'Reynaldo Cortes Sanchoz',
              description: 'CHECK 6502226 W.E. 06.29.2025',
              amount: 276.43,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15433',
              num: '6502278',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502278',
              amount: 370,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15434',
              num: '6502228',
              name: 'ASSADOURIAN, BERDJ G',
              description: 'CHECK 6502228 W.E. 06.29.2025',
              amount: 542.77,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15435',
              num: '6502260',
              name: 'Sanchez, Anthony',
              description: 'CHECK 6502260 W.E. 06.29.2025',
              amount: 666.9,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15451',
              num: '6502193',
              name: 'Dunn, Kaitlyn',
              description: 'CHECK 6502193 W.E. 06.22.2025',
              amount: 207.62,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15452',
              num: '6502253',
              name: 'Perdikos, Eleni',
              description: 'CHECK 6502253 W.E. 06.29.2025',
              amount: 391.66,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15453',
              num: '6502267',
              name: 'Manuel Ramirez',
              description: 'CHECK 6502267',
              amount: 400.63,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15458',
              num: '6502255',
              name: 'Arielle Pizarro',
              description: 'CHECK 6502255 W.E. 06.29.2025',
              amount: 142.25,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15459',
              num: '6502270',
              name: 'Ana Garzon',
              description: 'CHECK 6502270  W.E. 06.23.2025',
              amount: 208,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15460',
              num: '6502316',
              name: 'Jessica Polak',
              description: 'CHECK 6502316 W.E. 07.06.2025',
              amount: 267.75,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15461',
              num: '6502294',
              name: 'Carlos Dominguez',
              description: "CHECK 6502294 Brandon's Donuts",
              amount: 309.6,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15462',
              num: '6502303',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502303 W.E. 07.06.2025',
              amount: 497.4,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15463',
              num: '6502281',
              name: 'Omar Lopez',
              description: 'CHECK 6502281 W.E. 07.06.2025',
              amount: 508.73,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15464',
              num: '6502293',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502293 W.E. 07.06.2025',
              amount: 607.32,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15465',
              num: '6502291',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502291 W.E. 07.06.2025',
              amount: 621.17,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15466',
              num: '6502306',
              name: 'Luna, Nelson',
              description: 'CHECK 6502306 W.E. 07.06.2025',
              amount: 629.47,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15471',
              num: '6502254',
              name: 'Allanah Pizarro.',
              description: 'CHECK 6502254 W.E. 06.29.2025',
              amount: 78.51,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15472',
              num: '6502312',
              name: 'Marina Pasek',
              description: 'CHECK 6502312 W.E. 07.06.2025',
              amount: 157.94,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15473',
              num: '6502277',
              name: 'Junior Santiago',
              description: 'CHECK 6502277',
              amount: 170.39,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15474',
              num: '6502301',
              name: 'Lina Granados',
              description: 'CHECK 6502301 W.E. 07.06.2025',
              amount: 317.08,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15475',
              num: '6502302',
              name: 'Javier Hernandez',
              description: 'CHECK 6502302 W.E. 07.06.2025',
              amount: 345.45,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15476',
              num: '6502327',
              name: 'Carac, Israel',
              description: 'CHECK 6502327 W.E. 07.06.2025',
              amount: 371.36,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15477',
              num: '6502314',
              name: 'Allanah Pizarro.',
              description: 'CHECK 6502314 W.E. 07.06.2025',
              amount: 410.26,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15478',
              num: '6502233',
              name: 'Isabella Devine',
              description: 'CHECK 6502233 W.E. 07.06.2025',
              amount: 445.8,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15479',
              num: '6502307',
              name: 'Alexis Martinez',
              description: 'CHECK 6502307 W.E. 07.06.2025',
              amount: 478.68,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15480',
              num: '6502290',
              name: 'Reynaldo Cortes Sanchoz',
              description: 'CHECK 6502290 W.E. 07.06.2025',
              amount: 514.73,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15481',
              num: '6502284',
              name: 'Jason Canas',
              description: 'CHECK 6502284 W.E. 07.06.2025',
              amount: 518.12,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15482',
              num: '6502232',
              name: 'Conserve, Mercidieu',
              description: 'POD CHECK W.E. 06.29.2025',
              amount: 535.96,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15483',
              num: '6502283',
              name: 'ASSADOURIAN, BERDJ G',
              description: 'CHECK 6502283 W.E. 07.06.2025',
              amount: 576.38,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15484',
              num: '6502184',
              name: 'Conserve, Mercidieu',
              description: 'POD CHECK W.E..06.22.2025',
              amount: 616.17,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15485',
              num: '6502298',
              name: 'Franco Ramos, Luis David',
              description: 'CHECK 6502298 W.E. 07.06.2025',
              amount: 624.92,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15486',
              num: '6502259',
              name: 'Rosemarie Rosado',
              description: 'CHECK 6502259 W.E. 06.29.2025',
              amount: 684.15,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15487',
              num: '6502299',
              name: 'Juliana Garcia Escobar',
              description: 'CHECK 6502299 W.E. 07.06.2025',
              amount: 685.44,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15488',
              num: '6502300',
              name: 'Ana Maria Garzon',
              description: 'CHECK 6502300 W.E. 07.06.2025',
              amount: 748.35,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15489',
              num: '6502289',
              name: 'Efren Cortes Sanchez',
              description: 'CHECK 6502289 W.E. 07.06.2025',
              amount: 757.68,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15490',
              num: '6502297',
              name: 'Fonto, Laurynn',
              description: 'CHECK 6502297 W.E. 07.06.2025',
              amount: 823.27,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15491',
              num: '6502295',
              name: 'Hakim Eatman',
              description: 'CHECK 6502295 W.E. 07.06.2025',
              amount: 966.36,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15500',
              num: '6502310',
              name: 'Frida Monroy',
              description: 'CHECK 6502310 W.E. 07.06.2025',
              amount: 202.73,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15501',
              num: '6502318',
              name: 'Carlos Ramirez',
              description: 'CHECK 6502318',
              amount: 304.03,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15502',
              num: '6502309',
              name: 'Jephthah Michel',
              description: 'POD CHECK W.E. 07.06.2025',
              amount: 403.1,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15503',
              num: '6502292',
              name: 'Isabella Devine',
              description: 'CHECK 6502292 W.E. 07.06.2025',
              amount: 405.95,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15504',
              num: '6502313',
              name: 'Perdikos, Eleni',
              description: 'CHECK 6502313 W.E. 07.06.2025',
              amount: 406.59,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15505',
              num: '6502287',
              name: 'Geoconda Castro',
              description: 'CHECK 6502287 W.E. 07.06.2025',
              amount: 408.55,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15507',
              num: '6502276',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502276',
              amount: 545,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15509',
              num: '6502324',
              name: 'Junior Santiago',
              description: 'CHECK 6502324 W.E. 07.06.2025',
              amount: 571.25,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15510',
              num: '6502296',
              name: 'Smicker Figueroa',
              description: 'CHECK 6502296 W.E. 07.06.2025',
              amount: 844.04,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15511',
              num: '6502311',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502311 W.E. 07.06.2025',
              amount: 932.87,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15513',
              num: '6502317',
              name: 'Mikhailson Pollas',
              description: 'CHECK 6502317 W.E. 07.06.2025',
              amount: 1044.91,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15515',
              num: '6502325',
              name: 'Roberto Santiago.',
              description: 'CHECK 6502325 W.E. 07.06.2025',
              amount: 1120.13,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'Other',
              amount: 4000,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.4243,
          percentAVG: 0.4243,
          cellID: '687f4cd2_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 52,
          id: '687f4cd2_@_14',
          index: 1,
          cPercent: 0.42426799933033943,
        },
        {
          date: '2025-07-14',
          title: 'Labor, Management',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 6486.95,
          perc: 0.0953,
          percAvg: 0.0953,
          dataRows: [
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'Management',
              amount: 6486.95,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0953,
          percentAVG: 0.0953,
          cellID: '529343c4_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '529343c4_@_14',
          index: 1,
          cPercent: 0.09526435437966817,
        },
        {
          date: '2025-07-14',
          title: 'Labor, BOH',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 5121.55,
          perc: 0.0752,
          percAvg: 0.0752,
          dataRows: [
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'BOH',
              amount: 5121.55,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.0752,
          percentAVG: 0.0752,
          cellID: '3c61733f_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '3c61733f_@_14',
          index: 1,
          cPercent: 0.07521272002608152,
        },
        {
          date: '2025-07-14',
          title: 'Total Direct Labor',
          path: ['LABOR', 'Total Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 40498.69,
          amtAvg: 40498.69,
          perc: 0.5947,
          percAvg: 0.5947,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 40498.69,
          percent: 0.5947,
          percentAVG: 0.5947,
          cellID: '143a84db_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '143a84db_@_14',
          index: 1,
          cPercent: 0.5947450737360892,
        },
        {
          date: '2025-07-14',
          title: 'Labor Related Expenses',
          path: ['LABOR', 'Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: 'dacf6533_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'dacf6533_@_14',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Commission/Bonus/Incentives',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '7a82e4de_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '7a82e4de_@_14',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Payroll Taxes',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 2993.1,
          perc: 0.044,
          percAvg: 0.044,
          dataRows: [
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'PR Tax',
              amount: 2993.1,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0.044,
          percentAVG: 0.044,
          cellID: 'bbc14e9c_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: 'bbc14e9c_@_14',
          index: 1,
          cPercent: 0.04395528547218412,
        },
        {
          date: '2025-07-14',
          title: 'Employee Meals',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '416bc276_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '416bc276_@_14',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Recruiting',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: 'c12aec10_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'c12aec10_@_14',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total Labor Related Expenses',
          path: ['LABOR', 'Total Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2993.1,
          amtAvg: 2993.1,
          perc: 0.044,
          percAvg: 0.044,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 2993.1,
          percent: 0.044,
          percentAVG: 0.044,
          cellID: '1e9ad256_@_14_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '1e9ad256_@_14',
          index: 1,
          cPercent: 0.04395528547218412,
        },
        {
          date: '2025-07-14',
          title: 'TOTAL LABOR',
          path: ['TOTAL LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 43491.79,
          amtAvg: 43491.79,
          perc: 0.6387,
          percAvg: 0.6387,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 43491.79,
          percent: 0.6387,
          percentAVG: 0.6387,
          cellID: 'd0736ae7_@_15_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'd0736ae7_@_15',
          index: 1,
          cPercent: 0.6387003592082733,
        },
        {
          date: '2025-07-14',
          title: 'PRIME COST',
          path: ['PRIME COST'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 75844.70999999999,
          amtAvg: 75844.70999999999,
          perc: 1.1138,
          percAvg: 1.1138,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 75844.70999999999,
          percent: 1.1138,
          percentAVG: 1.1138,
          cellID: 'b7d061ce_@_16_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'b7d061ce_@_16',
          index: 1,
          cPercent: 1.1138204134860237,
        },
        {
          date: '2025-07-14',
          title: 'Contribution Margin',
          path: ['Contribution Margin'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -7750.509999999995,
          amtAvg: -7750.509999999995,
          perc: -0.1138,
          percAvg: -0.1138,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: -7750.509999999995,
          percent: -0.1138,
          percentAVG: -0.1138,
          cellID: '2f5a4d68_@_17_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '2f5a4d68_@_17',
          index: 1,
          cPercent: -0.1138204134860237,
        },
        {
          date: '2025-07-14',
          title: 'CONTROLLABLE EXPENSES',
          path: ['CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '2cd659af_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '2cd659af_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '3be3d09b_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '3be3d09b_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Equipment Lease Rental',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 35,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 35,
          percent: 0,
          percentAVG: 0.0005,
          cellID: '1a6a3f76_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '1a6a3f76_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Cleaning Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
            stats: {
              mean: 2.2,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 131.91,
          amtAvg: 114.23,
          perc: 0.0019,
          percAvg: 0.0017,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 20.12,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 111.79,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 114.23,
          percent: 0.0019,
          percentAVG: 0.0017,
          cellID: '514ec7ed_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: '514ec7ed_@_18',
          index: 1,
          cPercent: 0.001937169391813106,
        },
        {
          date: '2025-07-14',
          title: 'Cleaning Services',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 235.95,
          perc: 0,
          percAvg: 0.0035,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 235.95,
          percent: 0,
          percentAVG: 0.0035,
          cellID: '758ae475_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '758ae475_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Restaurant Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 376.87,
          amtAvg: 402.65,
          perc: 0.0055,
          percAvg: 0.0059,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 46.81,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 149.33,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 180.73,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 402.65,
          percent: 0.0055,
          percentAVG: 0.0059,
          cellID: '28a2ce1f_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 3,
          id: '28a2ce1f_@_18',
          index: 1,
          cPercent: 0.0055345389181457455,
        },
        {
          date: '2025-07-14',
          title: 'Laundry, Linens, & Uniforms',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16,
              stdDev: 0.4,
            },
          },
          trxFlagged: [],
          amount: 1058.12,
          amtAvg: 557.42,
          perc: 0.0155,
          percAvg: 0.0082,
          dataRows: [
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15492',
              num: '',
              name: 'White Plains Linen',
              description: 'WHITE PLAINS COA COLLECTION',
              amount: 1058.12,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 557.42,
          percent: 0.0155,
          percentAVG: 0.0082,
          cellID: 'ad6ac922_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: 'ad6ac922_@_18',
          index: 1,
          cPercent: 0.015539062064023073,
        },
        {
          date: '2025-07-14',
          title: 'Kitchen/ Bar Smallwares',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '9f991141_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '9f991141_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1566.8999999999999,
          amtAvg: 1345.25,
          perc: 0.023,
          percAvg: 0.0198,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 1345.25,
          percent: 0.023,
          percentAVG: 0.0198,
          cellID: 'b7f8c8b8_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'b7f8c8b8_@_18',
          index: 1,
          cPercent: 0.023010770373981925,
        },
        {
          date: '2025-07-14',
          title: 'Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '9d0fd7d1_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '9d0fd7d1_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: '3rd Party Commissions',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '47bbbb15_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '47bbbb15_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd484c66b_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'd484c66b_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: 'edd65db2_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'edd65db2_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Marketing & Public Relations',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 22.19,
          amtAvg: 388.88,
          perc: 0.0003,
          percAvg: 0.0057,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15441',
              num: '',
              name: 'GO DADDY.COM',
              description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0586      480 5058855   * AZ',
              amount: 22.19,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 388.88,
          percent: 0.0003,
          percentAVG: 0.0057,
          cellID: 'c61b398a_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: 'c61b398a_@_18',
          index: 1,
          cPercent: 0.0003258721007075493,
        },
        {
          date: '2025-07-14',
          title: 'Advertising & Promotions',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
            stats: {
              mean: 1.8,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 289,
          amtAvg: 466.08,
          perc: 0.0042,
          percAvg: 0.0068,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15226',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  8V9TBVCVK2          650 5434800   * CA',
              amount: 289,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 466.08,
          percent: 0.0042,
          percentAVG: 0.0068,
          cellID: '1dc3b3a3_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '1dc3b3a3_@_18',
          index: 1,
          cPercent: 0.004244120644636401,
        },
        {
          date: '2025-07-14',
          title: 'Total Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 311.19,
          amtAvg: 854.96,
          perc: 0.0046,
          percAvg: 0.0126,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 854.96,
          percent: 0.0046,
          percentAVG: 0.0126,
          cellID: '024ba9eb_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '024ba9eb_@_18',
          index: 1,
          cPercent: 0.00456999274534395,
        },
        {
          date: '2025-07-14',
          title: 'Music & DJ',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '0c83dbac_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '0c83dbac_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '6f7c6ca5_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '6f7c6ca5_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Accounting & Bookkeeping',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 338.48,
          perc: 0,
          percAvg: 0.005,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 338.48,
          percent: 0,
          percentAVG: 0.005,
          cellID: '5a0fedcf_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '5a0fedcf_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Consulting',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'b08821c2_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'b08821c2_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Legal',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 658.11,
          perc: 0,
          percAvg: 0.0097,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 658.11,
          percent: 0,
          percentAVG: 0.0097,
          cellID: 'a630ac37_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'a630ac37_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Payroll Processing Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 92.53,
          amtAvg: 38.96,
          perc: 0.0014,
          percAvg: 0.0006,
          dataRows: [
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15445',
              num: '',
              name: '7Shifts',
              description: 'VISA DDA PUR AP - 401134     7SHIFTS                     7SHIFTS COM   * DE',
              amount: 92.53,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 38.96,
          percent: 0.0014,
          percentAVG: 0.0006,
          cellID: '975961bc_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '975961bc_@_18',
          index: 1,
          cPercent: 0.001358852883211786,
        },
        {
          date: '2025-07-14',
          title: 'Computer Supplies, Software & IT',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1440.67,
          amtAvg: 350.15,
          perc: 0.0212,
          percAvg: 0.0051,
          dataRows: [
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15443',
              num: '',
              name: 'Tripleseat',
              description: 'VISA DDA PUR AP - 490641     PST TRIPLESEAT              978 2916436   * MA',
              amount: 406.67,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15494',
              num: '',
              name: 'Toast Inc',
              description: 'TOAST, INC       TOAST, INC',
              amount: 1034,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 350.15,
          percent: 0.0212,
          percentAVG: 0.0051,
          cellID: '9450bb96_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: '9450bb96_@_18',
          index: 1,
          cPercent: 0.021157014841205274,
        },
        {
          date: '2025-07-14',
          title: 'Dues and Subscriptions',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 28.71,
          perc: 0,
          percAvg: 0.0004,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 28.71,
          percent: 0,
          percentAVG: 0.0004,
          cellID: '236c5723_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '236c5723_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Bank Charges & Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.8400000000000003,
              stdDev: 1.3564659966250538,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 47.42,
          perc: 0,
          percAvg: 0.0007,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 47.42,
          percent: 0,
          percentAVG: 0.0007,
          cellID: 'c3c23383_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'c3c23383_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Office Supplies & Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
            stats: {
              mean: 8.2,
              variance: 15.36,
              stdDev: 3.919183588453085,
            },
          },
          trxFlagged: [],
          amount: 1286.21,
          amtAvg: 1390.72,
          perc: 0.0189,
          percAvg: 0.0204,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15225',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 122.46,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15230',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 26.02,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15231',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 271.88,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15234',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 400.34,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15237',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 41.56,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15220',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 7.45,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15318',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 55.98,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15315',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 63.96,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15316',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 181.16,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15317',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 49.38,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15323',
              num: '',
              name: 'The Home Depot',
              description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
              amount: 66.02,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 1390.72,
          percent: 0.0189,
          percentAVG: 0.0204,
          cellID: '058d9b25_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 11,
          id: '058d9b25_@_18',
          index: 1,
          cPercent: 0.018888686554802026,
        },
        {
          date: '2025-07-14',
          title: 'Phone and Internet',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 393.24,
          amtAvg: 88.8,
          perc: 0.0058,
          percAvg: 0.0013,
          dataRows: [
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15495',
              num: '',
              name: 'Optimum',
              description: 'OPTIMUM 7862     CABLE PMNT',
              amount: 393.24,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 88.8,
          percent: 0.0058,
          percentAVG: 0.0013,
          cellID: '0c2b505e_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '0c2b505e_@_18',
          index: 1,
          cPercent: 0.005774941184418057,
        },
        {
          date: '2025-07-14',
          title: 'Security',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '9dc533d9_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '9dc533d9_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 3212.6499999999996,
          amtAvg: 2941.35,
          perc: 0.0472,
          percAvg: 0.0432,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 2941.35,
          percent: 0.0472,
          percentAVG: 0.0432,
          cellID: 'f12db2ec_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'f12db2ec_@_18',
          index: 1,
          cPercent: 0.04717949546363714,
        },
        {
          date: '2025-07-14',
          title: 'Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '084f517c_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '084f517c_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Travel, Ground Transport & Airfare',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 105.95,
          amtAvg: 175.05,
          perc: 0.0016,
          percAvg: 0.0026,
          dataRows: [
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15219',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 50.7,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15264',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 55.25,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 175.05,
          percent: 0.0016,
          percentAVG: 0.0026,
          cellID: 'e4e1ab18_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: 'e4e1ab18_@_18',
          index: 1,
          cPercent: 0.0015559328107239679,
        },
        {
          date: '2025-07-14',
          title: 'Meals & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 871.17,
          amtAvg: 237.27,
          perc: 0.0128,
          percAvg: 0.0035,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15329',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 71.17,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15468',
              num: '6502282',
              name: 'Mamma Mia',
              description: 'POD CHECK',
              amount: 800,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 237.27,
          percent: 0.0128,
          percentAVG: 0.0035,
          cellID: 'f245aeff_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: 'f245aeff_@_18',
          index: 1,
          cPercent: 0.012793600629715893,
        },
        {
          date: '2025-07-14',
          title: 'Parking',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 279.55,
          perc: 0,
          percAvg: 0.0041,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 279.55,
          percent: 0,
          percentAVG: 0.0041,
          cellID: '3ae4b332_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '3ae4b332_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Fuel',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 36.01,
          amtAvg: 23.71,
          perc: 0.0005,
          percAvg: 0.0003,
          dataRows: [
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15260',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 36.01,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 23.71,
          percent: 0.0005,
          percentAVG: 0.0003,
          cellID: '4dbd49a9_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '4dbd49a9_@_18',
          index: 1,
          cPercent: 0.0005288262436448332,
        },
        {
          date: '2025-07-14',
          title: 'Total Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1013.13,
          amtAvg: 715.58,
          perc: 0.0149,
          percAvg: 0.0105,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 715.58,
          percent: 0.0149,
          percentAVG: 0.0105,
          cellID: 'ea7ffa49_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'ea7ffa49_@_18',
          index: 1,
          cPercent: 0.014878359684084696,
        },
        {
          date: '2025-07-14',
          title: 'Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '1675dbe8_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '1675dbe8_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Repair & Maintenance, Equipment',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2441.6,
          amtAvg: 551.33,
          perc: 0.0359,
          percAvg: 0.0081,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15436',
              num: '6502273',
              name: 'AZ Mechanical',
              description: 'CHECK 6502273',
              amount: 880,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15438',
              num: '6502272',
              name: 'AZ Mechanical',
              description: 'CHECK 6502272 HVAC',
              amount: 1150,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15506',
              num: '6502328',
              name: 'AIs Technical Incorporated',
              description: 'CHECK 6502328',
              amount: 411.6,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 551.33,
          percent: 0.0359,
          percentAVG: 0.0081,
          cellID: 'aa06968c_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 3,
          id: 'aa06968c_@_18',
          index: 1,
          cPercent: 0.035856210954824344,
        },
        {
          date: '2025-07-14',
          title: 'Repair & Maintenance, Facility',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
            stats: {
              mean: 1,
              variance: 1.2,
              stdDev: 1.0954451150103321,
            },
          },
          trxFlagged: [],
          amount: 1697.66,
          amtAvg: 1607.85,
          perc: 0.0249,
          percAvg: 0.0236,
          dataRows: [
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15455',
              num: '6502087',
              name: 'American Garage Door',
              description: 'CHECK 6502087 Garage Door',
              amount: 1697.66,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 1607.85,
          percent: 0.0249,
          percentAVG: 0.0236,
          cellID: '4d40af10_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '4d40af10_@_18',
          index: 1,
          cPercent: 0.024931051396447863,
        },
        {
          date: '2025-07-14',
          title: 'Pest Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 118.65,
          perc: 0,
          percAvg: 0.0017,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 118.65,
          percent: 0,
          percentAVG: 0.0017,
          cellID: 'a044faba_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'a044faba_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Fire Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd6450b86_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'd6450b86_@_18',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4139.26,
          amtAvg: 2277.83,
          perc: 0.0608,
          percAvg: 0.0335,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 2277.83,
          percent: 0.0608,
          percentAVG: 0.0335,
          cellID: '4da1092f_@_18_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '4da1092f_@_18',
          index: 1,
          cPercent: 0.060787262351272214,
        },
        {
          date: '2025-07-14',
          title: 'TOTAL CONTROLLABLE EXPENSES',
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 10243.130000000001,
          amtAvg: 8134.97,
          perc: 0.1504,
          percAvg: 0.1195,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 8134.97,
          percent: 0.1504,
          percentAVG: 0.1195,
          cellID: 'a624f257_@_19_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'a624f257_@_19',
          index: 1,
          cPercent: 0.15042588061831993,
        },
        {
          date: '2025-07-14',
          title: 'Controllable Profit',
          path: ['Controllable Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -17993.639999999996,
          amtAvg: -15885.479999999996,
          perc: -0.2642,
          percAvg: -0.2333,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: -15885.479999999996,
          percent: -0.2642,
          percentAVG: -0.2333,
          cellID: 'a973b710_@_20_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'a973b710_@_20',
          index: 1,
          cPercent: -0.26424629410434364,
        },
        {
          date: '2025-07-14',
          title: 'NON-CONTROLLABLE EXPENSES',
          path: ['NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '79208dfc_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '79208dfc_@_21',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '52e26b6b_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '52e26b6b_@_21',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Rent/Lease',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18437.33,
          amtAvg: 4163.27,
          perc: 0.2708,
          percAvg: 0.0611,
          dataRows: [
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15470',
              num: '',
              name: 'Ironstate Proper',
              description: 'IRONSTATE PROPER SIGONFILE',
              amount: 18437.33,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 4163.27,
          percent: 0.2708,
          percentAVG: 0.0611,
          cellID: '68876c4f_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 1,
          id: '68876c4f_@_21',
          index: 1,
          cPercent: 0.2707621207092528,
        },
        {
          date: '2025-07-14',
          title: 'Utility, Electricity',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: '208dfabc_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '208dfabc_@_21',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Utility, Gas',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'c9446d9c_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'c9446d9c_@_21',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18437.33,
          amtAvg: 4163.27,
          perc: 0.2708,
          percAvg: 0.0611,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 4163.27,
          percent: 0.2708,
          percentAVG: 0.0611,
          cellID: '20d5762f_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '20d5762f_@_21',
          index: 1,
          cPercent: 0.2707621207092528,
        },
        {
          date: '2025-07-14',
          title: 'Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          percent: 0,
          percentAVG: 0,
          cellID: '763b7c77_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '763b7c77_@_21',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Other Income/Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: -0.23,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: -0.23,
          percent: 0,
          percentAVG: 0,
          cellID: '91f38f9a_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '91f38f9a_@_21',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'To Be Classified P&L',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.56,
              stdDev: 0.7483314773547883,
            },
          },
          trxFlagged: [],
          amount: 2440.85,
          amtAvg: 993.74,
          perc: 0.0358,
          percAvg: 0.0146,
          dataRows: [
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15496',
              num: '',
              name: 'Unknown',
              description: 'BENEFITHEALTHPLA WEBPAYMENT',
              amount: 987.26,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15497',
              num: '',
              name: 'Unknown',
              description: 'BENEFITHEALTHPLA WEBPAYMENT',
              amount: 1453.59,
            },
          ],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 993.74,
          percent: 0.0358,
          percentAVG: 0.0146,
          cellID: '5ccef3e9_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 2,
          id: '5ccef3e9_@_21',
          index: 1,
          cPercent: 0.03584519680090228,
        },
        {
          date: '2025-07-14',
          title: 'Total Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2440.85,
          amtAvg: 993.51,
          perc: 0.0358,
          percAvg: 0.0146,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 993.51,
          percent: 0.0358,
          percentAVG: 0.0146,
          cellID: 'd4b5a9af_@_21_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'd4b5a9af_@_21',
          index: 1,
          cPercent: 0.03584519680090228,
        },
        {
          date: '2025-07-14',
          title: 'TOTAL NON-CONTROLLABLE EXPENSES',
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 20878.18,
          amtAvg: 5156.78,
          perc: 0.3066,
          percAvg: 0.0757,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: 5156.78,
          percent: 0.3066,
          percentAVG: 0.0757,
          cellID: '1851dc59_@_22_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '1851dc59_@_22',
          index: 1,
          cPercent: 0.3066073175101551,
        },
        {
          date: '2025-07-14',
          title: 'Operating Profit',
          path: ['Operating Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -38871.81999999999,
          amtAvg: -21042.259999999995,
          perc: -0.5709,
          percAvg: -0.309,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: -21042.259999999995,
          percent: -0.5709,
          percentAVG: -0.309,
          cellID: '251b8ac6_@_23_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '251b8ac6_@_23',
          index: 1,
          cPercent: -0.5708536116144987,
        },
        {
          date: '2025-07-14',
          title: 'Other Expenses',
          path: ['Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: '5e10c38d_@_24_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '5e10c38d_@_24',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Loan Interest',
          path: ['Other Expenses', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: '13e3a076_@_24_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '13e3a076_@_24',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total Other Expenses',
          path: ['Total Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: 'caeb87a7_@_25_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'caeb87a7_@_25',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'EBITDA',
          path: ['EBITDA'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -38871.81999999999,
          amtAvg: -21042.259999999995,
          perc: -0.5709,
          percAvg: -0.309,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: -21042.259999999995,
          percent: -0.5709,
          percentAVG: -0.309,
          cellID: 'e815a21e_@_26_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'e815a21e_@_26',
          index: 1,
          cPercent: -0.5708536116144987,
        },
        {
          date: '2025-07-14',
          title: 'Interest, Taxes, Depreciation and Amortization',
          path: ['Interest, Taxes, Depreciation and Amortization'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: '644555ee_@_27_-x-_2',
          baseAmount: 0,
          transactions: 0,
          id: '644555ee_@_27',
          index: 1,
        },
        {
          date: '2025-07-14',
          title: 'Loan Interest',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: 'dce93088_@_27_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'dce93088_@_27',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'Total Interest, Taxes, Depreciation and Amortization',
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          cellID: 'b4184eff_@_28_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: 'b4184eff_@_28',
          index: 1,
          cPercent: 0,
        },
        {
          date: '2025-07-14',
          title: 'NET PROFIT',
          path: ['NET PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -38871.81999999999,
          amtAvg: -21042.259999999995,
          perc: -0.5709,
          percAvg: -0.309,
          dataRows: [],
          reportId: 'aa70149a-0cb7-49c6-9380-56ac7b780de5',
          amountAVG: -21042.259999999995,
          percent: -0.5709,
          percentAVG: -0.309,
          cellID: '9b50fa7c_@_29_-x-_2',
          baseAmount: 68094.2,
          transactions: 0,
          id: '9b50fa7c_@_29',
          index: 1,
          cPercent: -0.5708536116144987,
        },
      ],
      total: false,
      compoundColumn: false,
      isLocation: false,
      liveReport: false,
      periodReporting: false,
      periodID: '',
      consolidated: false,
      originType: 'Data',
    },
    {
      name: '2025-07-07',
      reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
      date: {
        start: '2025-07-07',
        end: '2025-07-13',
      },
      type: [
        {
          type: 'Data',
          index: 2,
        },
      ],
      data: [
        {
          date: '2025-07-07',
          title: 'SALES',
          path: ['SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          cellID: '5bc89b03_@_2_-x-_3',
          baseAmount: 0,
          transactions: 0,
          id: '5bc89b03_@_2',
          index: 2,
        },
        {
          date: '2025-07-07',
          title: 'Sales, Food',
          path: ['SALES', 'Sales, Food'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
          trxAnomaly: {
            anomalies: [8],
            anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
            stats: {
              mean: 7.2,
              variance: 0.15999999999999998,
              stdDev: 0.39999999999999997,
            },
          },
          trxFlagged: [],
          amount: 39645,
          perc: 0.5565,
          percAvg: 0.5565,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 3404.5,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 2043.5,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 2980,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 3034,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 5745,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 11703,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 10735,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.5565,
          percentAVG: 0.5565,
          cellID: 'c5601bf4_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 7,
          id: 'c5601bf4_@_2',
          index: 2,
          cPercent: 0.5565361091493021,
        },
        {
          date: '2025-07-07',
          title: 'Sales, Liquor',
          path: ['SALES', 'Sales, Liquor'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18588.01,
          amtAvg: 18588.01,
          perc: 0.2609,
          percAvg: 0.2609,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 1151.01,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 449,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 1435,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 1164,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 2608,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 6630,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 5151,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 18588.01,
          percent: 0.2609,
          percentAVG: 0.2609,
          cellID: 'e1ca5621_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 7,
          id: 'e1ca5621_@_2',
          index: 2,
          cPercent: 0.2609382964365826,
        },
        {
          date: '2025-07-07',
          title: 'Sales, Beer',
          path: ['SALES', 'Sales, Beer'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 14,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4710,
          amtAvg: 4710,
          perc: 0.0661,
          percAvg: 0.0661,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 47,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 517,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 93,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 151,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 69,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 441,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 59,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 187,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 83,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 681,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 378,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 979,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 295,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 730,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 4710,
          percent: 0.0661,
          percentAVG: 0.0661,
          cellID: 'ba0b0910_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 14,
          id: 'ba0b0910_@_2',
          index: 2,
          cPercent: 0.06611893237717778,
        },
        {
          date: '2025-07-07',
          title: 'Sales, Wine',
          path: ['SALES', 'Sales, Wine'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1252,
          amtAvg: 1252,
          perc: 0.0176,
          percAvg: 0.0176,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 99,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 42,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 171,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 98,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 276,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 484,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 82,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 1252,
          percent: 0.0176,
          percentAVG: 0.0176,
          cellID: '2f14959f_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 7,
          id: '2f14959f_@_2',
          index: 2,
          cPercent: 0.01757556334102475,
        },
        {
          date: '2025-07-07',
          title: 'Sales, Non-Alcoholic Beverage',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2328,
          amtAvg: 2328,
          perc: 0.0327,
          percAvg: 0.0327,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 258,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 110,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 198,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 116,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 297,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 757,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 592,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 2328,
          percent: 0.0327,
          percentAVG: 0.0327,
          cellID: '7bb557b1_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 7,
          id: '7bb557b1_@_2',
          index: 2,
          cPercent: 0.032680440461585955,
        },
        {
          date: '2025-07-07',
          title: 'Sales, Miscellaneous',
          path: ['SALES', 'Sales, Miscellaneous'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
            stats: {
              mean: 3.8,
              variance: 1.3599999999999999,
              stdDev: 1.16619037896906,
            },
          },
          trxFlagged: [],
          amount: 3359.04,
          perc: 0.0472,
          percAvg: 0.0472,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 214,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 388,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 387,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 79.04,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 2291,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0472,
          percentAVG: 0.0472,
          cellID: 'cbede411_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 5,
          id: 'cbede411_@_2',
          index: 2,
          cPercent: 0.04715416955673784,
        },
        {
          date: '2025-07-07',
          title: 'Sales, Service Charges',
          path: ['SALES', 'Sales, Service Charges'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1353.22,
          perc: 0.019,
          percAvg: 0.019,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 120.99,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 51.45,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 86.37,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 64.5,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 196.33,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 441.93,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 391.65,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.019,
          percentAVG: 0.019,
          cellID: '4e12e939_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 7,
          id: '4e12e939_@_2',
          index: 2,
          cPercent: 0.018996488677589067,
        },
        {
          date: '2025-07-07',
          title: 'Sales - No category',
          path: ['SALES', 'Sales - No category'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          cellID: 'a1f04b4c_@_2_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 0,
          id: 'a1f04b4c_@_2',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'GROSS SALES',
          path: ['GROSS SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 71235.26999999999,
          amtAvg: 71235.26999999999,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 71235.26999999999,
          cellID: '74405d1a_@_3_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 0,
          id: '74405d1a_@_3',
          index: 2,
        },
        {
          date: '2025-07-07',
          title: 'Comps & Discounts',
          path: ['Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'ba9fcd64_@_6_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 0,
          id: 'ba9fcd64_@_6',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Discounts and Comps',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1208.5,
          perc: -0.017,
          percAvg: -0.017,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: -97.5,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: -146,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: -72,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: -93,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: -117.5,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: -275.75,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: -406.75,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: -0.017,
          percentAVG: -0.017,
          cellID: '4936addc_@_6_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 7,
          id: '4936addc_@_6',
          index: 2,
          cPercent: -0.016964910780853364,
        },
        {
          date: '2025-07-07',
          title: 'Total Comps & Discounts',
          path: ['Total Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1208.5,
          amtAvg: -1208.5,
          perc: -0.017,
          percAvg: -0.017,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -1208.5,
          percent: -0.017,
          percentAVG: -0.017,
          cellID: '8a448d4b_@_7_-x-_3',
          baseAmount: 71235.26999999999,
          transactions: 0,
          id: '8a448d4b_@_7',
          index: 2,
          cPercent: -0.016964910780853364,
        },
        {
          date: '2025-07-07',
          title: 'NET SALES',
          path: ['NET SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 70026.76999999999,
          amtAvg: 70026.76999999999,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 70026.76999999999,
          cellID: '3b5cefb1_@_8_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '3b5cefb1_@_8',
          index: 2,
        },
        {
          date: '2025-07-07',
          title: 'COST OF GOODS SOLD (COGS)',
          path: ['COST OF GOODS SOLD (COGS)'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          cellID: '753db221_@_9_-x-_3',
          baseAmount: 0,
          transactions: 0,
          id: '753db221_@_9',
          index: 2,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Food',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          baseRef: 'Sales, Food',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.4,
              variance: 1.4400000000000002,
              stdDev: 1.2000000000000002,
            },
          },
          trxFlagged: [],
          amount: 2621.67,
          perc: 0.0661,
          percAvg: 0.0661,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14756',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 319.92,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '15383',
              num: '',
              name: 'Ferro & Sons, Inc.',
              description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
              amount: 2301.75,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0661,
          percentAVG: 0.0661,
          cellID: '7a94d93b_@_9_-x-_3',
          baseAmount: 39645,
          transactions: 2,
          id: '7a94d93b_@_9',
          index: 2,
          cPercent: 0.06612864169504351,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Meat & Poultry',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
            stats: {
              mean: 3.8,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 3127.43,
          perc: 0.0447,
          percAvg: 0.0447,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 1139.64,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 195.76,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 1703.27,
            },
            {
              txnDate: '2025-07-11',
              type: 'Bill',
              eventId: '14897',
              num: '9253030',
              name: 'Performance Food Service',
              description: '',
              amount: 88.76,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0447,
          percentAVG: 0.0447,
          cellID: '3f46fcce_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 4,
          id: '3f46fcce_@_9',
          index: 2,
          cPercent: 0.044660491980424065,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Seafood',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 0.96,
              stdDev: 0.9797958971132712,
            },
          },
          trxFlagged: [],
          amount: 348.57,
          perc: 0.005,
          percAvg: 0.005,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 106.47,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 44.78,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 173.83,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15027',
              num: 'IV101-0026997137',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 23.49,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.005,
          percentAVG: 0.005,
          cellID: '2bdeb0ad_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 4,
          id: '2bdeb0ad_@_9',
          index: 2,
          cPercent: 0.004977667826175619,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Produce',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
            stats: {
              mean: 7.4,
              variance: 12.24,
              stdDev: 3.4985711369071804,
            },
          },
          trxFlagged: [],
          amount: 4014.31,
          perc: 0.0573,
          percAvg: 0.0573,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14721',
              num: '711317',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 588.95,
            },
            {
              txnDate: '2025-07-08',
              type: 'Expense',
              eventId: '14836',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 979.61,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 461.8,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 237.5,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15027',
              num: 'IV101-0026997137',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 169.75,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15426',
              num: '6502217',
              name: 'Avanti Produce',
              description: 'CHECK 6502217 INV 0710262',
              amount: 1061.45,
            },
            {
              txnDate: '2025-07-12',
              type: 'Bill',
              eventId: '15535',
              num: 'IV101-0027013901',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 26.75,
            },
            {
              txnDate: '2025-07-12',
              type: 'Bill',
              eventId: '15570',
              num: 'IV101-0027013935',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 488.5,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0573,
          percentAVG: 0.0573,
          cellID: '593c4b13_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 8,
          id: '593c4b13_@_9',
          index: 2,
          cPercent: 0.05732536285766144,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Grocery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
          trxAnomaly: {
            anomalies: [11],
            anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
            stats: {
              mean: 7.6,
              variance: 4.24,
              stdDev: 2.0591260281974,
            },
          },
          trxFlagged: [],
          amount: 11950.63,
          perc: 0.1707,
          percAvg: 0.1707,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 506.56,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14721',
              num: '711317',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 65.9,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '15258',
              num: '',
              name: 'ShopRite',
              description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
              amount: 53.12,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15347',
              num: '6502206',
              name: 'Performance Food Service',
              description: 'CHECK 6502206',
              amount: 3633.57,
            },
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15388',
              num: '6502219',
              name: 'Performance Food Service',
              description: 'CHECK 6502219',
              amount: 5884.26,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 210.65,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 26.37,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 1381.53,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15027',
              num: 'IV101-0026997137',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 28.05,
            },
            {
              txnDate: '2025-07-11',
              type: 'Bill',
              eventId: '14897',
              num: '9253030',
              name: 'Performance Food Service',
              description: '',
              amount: 103.21,
            },
            {
              txnDate: '2025-07-11',
              type: 'Expense',
              eventId: '15241',
              num: '',
              name: 'Instacart',
              description: 'VISA DDA PUR AP - 401134     IC  INSTACART               INSTACART COM * CA',
              amount: 57.41,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.1707,
          percentAVG: 0.1707,
          cellID: 'e0037727_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 11,
          id: 'e0037727_@_9',
          index: 2,
          cPercent: 0.17065802121103116,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Bakery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 769.45,
          perc: 0.011,
          percAvg: 0.011,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 37,
            },
            {
              txnDate: '2025-07-08',
              type: 'Expense',
              eventId: '14843',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 732.45,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.011,
          percentAVG: 0.011,
          cellID: '47294ea3_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 2,
          id: '47294ea3_@_9',
          index: 2,
          cPercent: 0.010987940754657114,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Dairy',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
          trxAnomaly: {
            anomalies: [7],
            anomalyScores: [0.82915619758885, 0, 0, 0, 0],
            stats: {
              mean: 4.8,
              variance: 1.7600000000000002,
              stdDev: 1.32664991614216,
            },
          },
          trxFlagged: [],
          amount: 963.42,
          perc: 0.0138,
          percAvg: 0.0138,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 311.38,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 71.8,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 64.51,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 493.79,
            },
            {
              txnDate: '2025-07-12',
              type: 'Bill',
              eventId: '15570',
              num: 'IV101-0027013935',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 21.94,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0138,
          percentAVG: 0.0138,
          cellID: '841fc412_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 5,
          id: '841fc412_@_9',
          index: 2,
          cPercent: 0.013757881450193977,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Liquor',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          baseRef: 'Sales, Liquor',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
          trxAnomaly: {
            anomalies: [10],
            anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
            stats: {
              mean: 4.8,
              variance: 7.76,
              stdDev: 2.7856776554368237,
            },
          },
          trxFlagged: [],
          amount: 3807.32,
          amtAvg: 3807.32,
          perc: 0.2048,
          percAvg: 0.2048,
          dataRows: [
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14900',
              num: '837929',
              name: 'Allied Beverages',
              description: '',
              amount: 1325.12,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14901',
              num: '3733648',
              name: 'Peerless Beverage',
              description: '',
              amount: 112,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14902',
              num: '42235',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 1370.2,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15406',
              num: '6502220',
              name: 'Fedway',
              description: 'CHECK 6502220',
              amount: 1000,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 3807.32,
          percent: 0.2048,
          percentAVG: 0.2048,
          cellID: '6eb26171_@_9_-x-_3',
          baseAmount: 18588.01,
          transactions: 4,
          id: '6eb26171_@_9',
          index: 2,
          cPercent: 0.20482665976616113,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Bar Groceries',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.9600000000000002,
              stdDev: 0.9797958971132713,
            },
          },
          trxFlagged: [],
          amount: 70.16,
          perc: 0.001,
          percAvg: 0.001,
          dataRows: [
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 70.16,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.001,
          percentAVG: 0.001,
          cellID: '15101cdc_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '15101cdc_@_9',
          index: 2,
          cPercent: 0.0010019025581217012,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          baseRef: 'Sales, Beer',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 435.87,
          amtAvg: 435.87,
          perc: 0.0925,
          percAvg: 0.0925,
          dataRows: [
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15390',
              num: '6502207',
              name: 'Eileen Kim',
              description: 'CHECK 6502207 Beer',
              amount: 435.87,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 435.87,
          percent: 0.0925,
          percentAVG: 0.0925,
          cellID: '90be8534_@_9_-x-_3',
          baseAmount: 4710,
          transactions: 1,
          id: '90be8534_@_9',
          index: 2,
          cPercent: 0.09254140127388535,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Draught Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 4.960000000000001,
              stdDev: 2.227105745132009,
            },
          },
          trxFlagged: [],
          amount: 295.5,
          perc: 0.0042,
          percAvg: 0.0042,
          dataRows: [
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14901',
              num: '3733648',
              name: 'Peerless Beverage',
              description: '',
              amount: 295.5,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0042,
          percentAVG: 0.0042,
          cellID: '3395a498_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '3395a498_@_9',
          index: 2,
          cPercent: 0.00421981479368533,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Bottled Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 416,
          perc: 0.0059,
          percAvg: 0.0059,
          dataRows: [
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14899',
              num: '3733647',
              name: 'Peerless Beverage',
              description: '',
              amount: 37,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14901',
              num: '3733648',
              name: 'Peerless Beverage',
              description: '',
              amount: 379,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0059,
          percentAVG: 0.0059,
          cellID: 'e2c4f57e_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 2,
          id: 'e2c4f57e_@_9',
          index: 2,
          cPercent: 0.0059405852933099735,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Wine',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          baseRef: 'Sales, Wine',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2.4,
              variance: 1.8399999999999999,
              stdDev: 1.3564659966250536,
            },
          },
          trxFlagged: [],
          amount: 1209.4,
          amtAvg: 1209.4,
          perc: 0.966,
          percAvg: 0.966,
          dataRows: [
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14900',
              num: '837929',
              name: 'Allied Beverages',
              description: '',
              amount: 218.16,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14902',
              num: '42235',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 181.24,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15206',
              num: '710320',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 810,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 1209.4,
          percent: 0.966,
          percentAVG: 0.966,
          cellID: 'b29ce542_@_9_-x-_3',
          baseAmount: 1252,
          transactions: 3,
          id: 'b29ce542_@_9',
          index: 2,
          cPercent: 0.9659744408945687,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Non-Alcoholic',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0, 0.784464540552736, 0, 0],
            stats: {
              mean: 4.4,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 661.57,
          amtAvg: 661.57,
          perc: 0.0094,
          percAvg: 0.0094,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 121.22,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 65.5,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14898',
              num: '3685855',
              name: 'Peerless Beverage',
              description: '',
              amount: 40.75,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14899',
              num: '3733647',
              name: 'Peerless Beverage',
              description: '',
              amount: 122.25,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 153.95,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14904',
              num: '116699',
              name: 'W.b. Law Coffee',
              description: '',
              amount: 157.9,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 661.57,
          percent: 0.0094,
          percentAVG: 0.0094,
          cellID: '9f08e50d_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 6,
          id: '9f08e50d_@_9',
          index: 2,
          cPercent: 0.009447387049267017,
        },
        {
          date: '2025-07-07',
          title: 'COGS, Packaging',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
          trxAnomaly: {
            anomalies: [1, 3],
            anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
            stats: {
              mean: 2,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 147.95,
          perc: 0.0021,
          percAvg: 0.0021,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 103.38,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 44.57,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0021,
          percentAVG: 0.0021,
          cellID: '027a424d_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 2,
          id: '027a424d_@_9',
          index: 2,
          cPercent: 0.0021127634474644484,
        },
        {
          date: '2025-07-07',
          title: 'Shipping, Freight and Delivery',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          cellID: 'dfae81d5_@_9_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'dfae81d5_@_9',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'TOTAL COGS',
          path: ['TOTAL COGS'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 30839.25,
          amtAvg: 30839.25,
          perc: 0.4404,
          percAvg: 0.4404,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 30839.25,
          percent: 0.4404,
          percentAVG: 0.4404,
          cellID: '528a97f9_@_10_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '528a97f9_@_10',
          index: 2,
          cPercent: 0.4403922956892058,
        },
        {
          date: '2025-07-07',
          title: 'GROSS PROFIT',
          path: ['GROSS PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 39187.51999999999,
          amtAvg: 39187.51999999999,
          perc: 0.5596,
          percAvg: 0.5596,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 39187.51999999999,
          percent: 0.5596,
          percentAVG: 0.5596,
          cellID: '7b400e74_@_12_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '7b400e74_@_12',
          index: 2,
          cPercent: 0.5596077043107942,
        },
        {
          date: '2025-07-07',
          title: 'OPERATING EXPENSES',
          path: ['OPERATING EXPENSES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 51508.119999999995,
          amtAvg: 51508.119999999995,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 51508.119999999995,
          cellID: '39d9c4d4_@_13_-x-_3',
          baseAmount: 51508.119999999995,
          transactions: 0,
          id: '39d9c4d4_@_13',
          index: 2,
        },
        {
          date: '2025-07-07',
          title: 'LABOR',
          path: ['LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '5b0fe671_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '5b0fe671_@_14',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Direct Labor',
          path: ['LABOR', 'Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'bb2363da_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'bb2363da_@_14',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Labor Other',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 30,
              variance: 456.4,
              stdDev: 21.36352030916253,
            },
          },
          trxFlagged: [],
          amount: 37586.56,
          perc: 0.5367,
          percAvg: 0.5367,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15350',
              num: '6502189',
              name: 'Rony Normil',
              description: 'CHECK 6502189 W.E. 6.22.25',
              amount: 1337.83,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15351',
              num: '6502160',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502160 W.E. 6.22.25',
              amount: 1054.65,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15352',
              num: '6502178',
              name: 'Mikhailson Pollas',
              description: 'CHECK 6502178 W.E. 6.22.25',
              amount: 1044.91,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15358',
              num: '6502152',
              name: 'Omar Lopez',
              description: 'CHECK 6502152 Brandons Donuts',
              amount: 590.89,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15359',
              num: '6502158',
              name: 'Isabella Devine',
              description: 'CHECK 6502158 W.E. 06.22.2025',
              amount: 146.5,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15360',
              num: '6502198',
              name: 'Jessica Polak',
              description: 'CHECK 6502198 W.E. 06.22.2025',
              amount: 252.85,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15361',
              num: '6502174',
              name: 'Lina Granados',
              description: 'CHECK 6502174 W.E. 06.22.2025',
              amount: 262.86,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15362',
              num: '6502153',
              name: 'Omar Lopez',
              description: 'CHECK 6502153',
              amount: 300,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15363',
              num: '6502196',
              name: 'Javier Hernandez',
              description: 'CHECK 6502196 W.E. 06.22.2025',
              amount: 313.15,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15364',
              num: '6502170',
              name: 'Christopher Intriago',
              description: 'CHECK 6502170 W.E. 06.22.2025',
              amount: 340.34,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15365',
              num: '6502191',
              name: 'Joseph, Fiona',
              description: 'CHECK 6502191 W.E. 06.22.2025',
              amount: 344.05,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15366',
              num: '6502154',
              name: 'Juliana Garcia Escobar',
              description: 'CHECK 6502154 W.E. 06.22.2025',
              amount: 352.55,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15367',
              num: '6502159',
              name: 'Geoconda Castro',
              description: 'CHECK 6502159 W.E. 06.22.2025',
              amount: 367.8,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15368',
              num: '6502186',
              name: 'Tocto, Domenica',
              description: 'CHECK 6502186 W.E. 06.22.2025',
              amount: 388.33,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15369',
              num: '6502194',
              name: 'Rosemarie Rosado',
              description: 'CHECK 6502194 W.E. 06.22.2025',
              amount: 401.65,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15370',
              num: '6502179',
              name: 'Marina Pasek',
              description: 'CHECK 6502179 W.E. 06.22.2025',
              amount: 423.02,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15371',
              num: '6502171',
              name: 'Fonto, Laurynn',
              description: 'CHECK 6502171',
              amount: 495.61,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15372',
              num: '6502211',
              name: 'Smicker Figueroa',
              description: 'CHECK 6502211 W.E. 06.22.2025',
              amount: 552.98,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15373',
              num: '6502156',
              name: 'Luis David Franco Ramos',
              description: 'CHECK 6502156 W.E. 06.22.2025',
              amount: 557.66,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15374',
              num: '6502187',
              name: 'ASSADOURIAN, BERDJ G',
              description: 'CHECK 6502187 W.E. 06.22.2025',
              amount: 564.07,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15375',
              num: '6502188',
              name: 'Samantha Lada',
              description: 'POD CHECK W.E. 06.22.2025',
              amount: 619.92,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15376',
              num: '6502197',
              name: 'Jephthah Michel',
              description: 'POD CHECK W.E. 06.22.2025',
              amount: 736.22,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15377',
              num: '6502199',
              name: 'Hakim Eatman',
              description: 'CHECK 6502199 W.E. 06.22.2025',
              amount: 778.89,
            },
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15391',
              num: '6502214',
              name: 'Manuel Ramirez',
              description: 'CHECK 6502214',
              amount: 423.19,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15392',
              num: '6502256',
              name: 'Polak, Jessica',
              description: 'CHECK 6502256 W.E. 06.29.2025',
              amount: 303.02,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15393',
              num: '6502252',
              name: 'Marina Pasek',
              description: 'CHECK 6502252',
              amount: 332.68,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15394',
              num: '6502243',
              name: 'Javier Hernandez',
              description: 'CHECK 6502243 W.E. 06.29.2025',
              amount: 349.53,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15395',
              num: '6502248',
              name: 'Olivia Mandez',
              description: 'CHECK 6502248 W.E. 06.29.2025',
              amount: 366.02,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15396',
              num: '6502218',
              name: 'Omar Lopez',
              description: 'CHECK 6502218 Brandons Donuts',
              amount: 369.33,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15397',
              num: '6502231',
              name: 'Carac, Israel',
              description: 'CHECK 6502231 W.E. 06.29.2025',
              amount: 390.55,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15398',
              num: '6502239',
              name: 'Franco Ramos, Luis David',
              description: 'CHECK 6502239 W.E. 06.29.2025',
              amount: 460.45,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15399',
              num: '6502247',
              name: 'Luna, Nelson',
              description: 'CHECK 6502247 W.E. 06.29.2025',
              amount: 479.84,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15400',
              num: '6502269',
              name: 'Alexis Martinez',
              description: 'CHECK 6502269 W.E. 06.29.2025',
              amount: 491.13,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15401',
              num: '6502229',
              name: 'Jason Canas',
              description: 'CHECK 6502229 W.E. 06.29.2025',
              amount: 499.29,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15402',
              num: '6502225',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502225 W.E. 06.29.2025',
              amount: 604.74,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15403',
              num: '6502223',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502223 W.E. 06.29.2025',
              amount: 611.68,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15404',
              num: '6502236',
              name: 'Hakim Eatman',
              description: 'CHECK 6502236 W.E. 06.29.2025',
              amount: 611.8,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15405',
              num: '6502222',
              name: 'Efren Cortes Sanchez',
              description: 'CHECK 6502222 W.E. 06.29.2025',
              amount: 750.35,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15407',
              num: '6502257',
              name: 'Mikhailson Pollas',
              description: 'CHECK 6502257 W.E. 06.29.2025',
              amount: 1044.91,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15408',
              num: '6502250',
              name: 'Rony Normil',
              description: 'CHECK 6502250 W.E. 06.29.2025',
              amount: 1337.83,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15411',
              num: '6502168',
              name: 'Manon, Carolina',
              description: 'CHECK 6502168 W.E. 06.22.2025',
              amount: 166.98,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15412',
              num: '6502265',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502265 W.E. 06.29.2025',
              amount: 314,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15413',
              num: '6502240',
              name: 'Juliana Garcia Escobar',
              description: 'CHECK 6502240 W.E. 06.29.2025',
              amount: 359.89,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15414',
              num: '6502234',
              name: 'Geoconda Castro',
              description: 'CHECK 6502234 W.E. 06.29.2025',
              amount: 399.03,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15415',
              num: '6502237',
              name: 'Smicker Figueroa',
              description: 'CHECK 6502237 W.E. 06.29.2025',
              amount: 527.82,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15416',
              num: '6502264',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502264 W.E. 06.29.2025',
              amount: 530,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15417',
              num: '6502275',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502275',
              amount: 540,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15418',
              num: '6502245',
              name: 'Joseph, Fiona',
              description: 'CHECK 6502245 W.E. 06.29.2025',
              amount: 559.92,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15419',
              num: '6502242',
              name: 'Lina Granados',
              description: 'CHECK 6502242 W.E. 06.29.2025',
              amount: 564.42,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15420',
              num: '6502140',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502140 W.E. 06.29.2025',
              amount: 580,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15421',
              num: '6502246',
              name: 'Samantha Lada',
              description: 'POD CHECK W.E. 06.29.2025',
              amount: 654.53,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15422',
              num: '6502238',
              name: 'Fonto, Laurynn',
              description: 'CHECK 6502238 W.E. 06.29.2025',
              amount: 707.24,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15423',
              num: '6502251',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502251 W.E. 06.29.2025',
              amount: 761.38,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15424',
              num: '6502227',
              name: 'Carlos Ramirez',
              description: 'CHECK 6502227 W.E. 06.29.2025',
              amount: 767.84,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15425',
              num: '6502249',
              name: 'Jephthah Michel',
              description: 'POD CHECK W.E. 06.29.2025',
              amount: 825.33,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15427',
              num: '6502268',
              name: 'Roberto Santiago.',
              description: 'CHECK 6502268 W.E. 06.29.2025',
              amount: 1120.13,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15429',
              num: '6502261',
              name: 'Ibrahim Sidibay',
              description: 'CHECK 6502261 W.E. 06.29.2025',
              amount: 54.98,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'Other',
              amount: 6500,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.5367,
          percentAVG: 0.5367,
          cellID: '687f4cd2_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 58,
          id: '687f4cd2_@_14',
          index: 2,
          cPercent: 0.5367455902935406,
        },
        {
          date: '2025-07-07',
          title: 'Labor, Management',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2244.1,
          perc: 0.032,
          percAvg: 0.032,
          dataRows: [
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'Management',
              amount: 2244.1,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.032,
          percentAVG: 0.032,
          cellID: '529343c4_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '529343c4_@_14',
          index: 2,
          cPercent: 0.03204631600172334,
        },
        {
          date: '2025-07-07',
          title: 'Labor, BOH',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1711.54,
          perc: 0.0244,
          percAvg: 0.0244,
          dataRows: [
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0244,
          percentAVG: 0.0244,
          cellID: '3c61733f_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '3c61733f_@_14',
          index: 2,
          cPercent: 0.024441224406037864,
        },
        {
          date: '2025-07-07',
          title: 'Total Direct Labor',
          path: ['LABOR', 'Total Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 41542.2,
          amtAvg: 41542.2,
          perc: 0.5932,
          percAvg: 0.5932,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 41542.2,
          percent: 0.5932,
          percentAVG: 0.5932,
          cellID: '143a84db_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '143a84db_@_14',
          index: 2,
          cPercent: 0.5932331307013019,
        },
        {
          date: '2025-07-07',
          title: 'Labor Related Expenses',
          path: ['LABOR', 'Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'dacf6533_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'dacf6533_@_14',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Commission/Bonus/Incentives',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 271,
          perc: 0.0039,
          percAvg: 0.0039,
          dataRows: [
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'Commission',
              amount: 271,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0039,
          percentAVG: 0.0039,
          cellID: '7a82e4de_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '7a82e4de_@_14',
          index: 2,
          cPercent: 0.003869948592516834,
        },
        {
          date: '2025-07-07',
          title: 'Payroll Taxes',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 480.77,
          perc: 0.0069,
          percAvg: 0.0069,
          dataRows: [
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'PR Tax',
              amount: 480.77,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0069,
          percentAVG: 0.0069,
          cellID: 'bbc14e9c_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: 'bbc14e9c_@_14',
          index: 2,
          cPercent: 0.006865517287174606,
        },
        {
          date: '2025-07-07',
          title: 'Employee Meals',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '416bc276_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '416bc276_@_14',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Recruiting',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'c12aec10_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'c12aec10_@_14',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Labor Related Expenses',
          path: ['LABOR', 'Total Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 751.77,
          amtAvg: 751.77,
          perc: 0.0107,
          percAvg: 0.0107,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 751.77,
          percent: 0.0107,
          percentAVG: 0.0107,
          cellID: '1e9ad256_@_14_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '1e9ad256_@_14',
          index: 2,
          cPercent: 0.010735465879691439,
        },
        {
          date: '2025-07-07',
          title: 'TOTAL LABOR',
          path: ['TOTAL LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 42293.969999999994,
          amtAvg: 42293.969999999994,
          perc: 0.604,
          percAvg: 0.604,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 42293.969999999994,
          percent: 0.604,
          percentAVG: 0.604,
          cellID: 'd0736ae7_@_15_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'd0736ae7_@_15',
          index: 2,
          cPercent: 0.6039685965809932,
        },
        {
          date: '2025-07-07',
          title: 'PRIME COST',
          path: ['PRIME COST'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 73133.22,
          amtAvg: 73133.22,
          perc: 1.0444,
          percAvg: 1.0444,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 73133.22,
          percent: 1.0444,
          percentAVG: 1.0444,
          cellID: 'b7d061ce_@_16_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'b7d061ce_@_16',
          index: 2,
          cPercent: 1.0443608922701992,
        },
        {
          date: '2025-07-07',
          title: 'Contribution Margin',
          path: ['Contribution Margin'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -3106.4500000000116,
          amtAvg: -3106.4500000000116,
          perc: -0.0444,
          percAvg: -0.0444,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -3106.4500000000116,
          percent: -0.0444,
          percentAVG: -0.0444,
          cellID: '2f5a4d68_@_17_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '2f5a4d68_@_17',
          index: 2,
          cPercent: -0.044360892270199126,
        },
        {
          date: '2025-07-07',
          title: 'CONTROLLABLE EXPENSES',
          path: ['CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '2cd659af_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '2cd659af_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '3be3d09b_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '3be3d09b_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Equipment Lease Rental',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 155,
          perc: 0.0022,
          percAvg: 0.0022,
          dataRows: [
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15533',
              num: 'MI1905ME',
              name: '',
              description: 'Vendor: Alpine Soda Systems Of New York LLC',
              amount: 155,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0022,
          percentAVG: 0.0022,
          cellID: '1a6a3f76_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '1a6a3f76_@_18',
          index: 2,
          cPercent: 0.0022134392318823217,
        },
        {
          date: '2025-07-07',
          title: 'Cleaning Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
            stats: {
              mean: 2.2,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 122.74,
          perc: 0.0018,
          percAvg: 0.0018,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 101.13,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 21.61,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0018,
          percentAVG: 0.0018,
          cellID: '514ec7ed_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 2,
          id: '514ec7ed_@_18',
          index: 2,
          cPercent: 0.0017527582665886204,
        },
        {
          date: '2025-07-07',
          title: 'Cleaning Services',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1044.92,
          perc: 0.0149,
          percAvg: 0.0149,
          dataRows: [
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15389',
              num: '6502115',
              name: 'Golden Cleaning',
              description: 'CHECK 6502115',
              amount: 1044.92,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0149,
          percentAVG: 0.0149,
          cellID: '758ae475_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '758ae475_@_18',
          index: 2,
          cPercent: 0.014921722078570813,
        },
        {
          date: '2025-07-07',
          title: 'Restaurant Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 411.98,
          perc: 0.0059,
          percAvg: 0.0059,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 87.54,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 59.9,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 264.54,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0059,
          percentAVG: 0.0059,
          cellID: '28a2ce1f_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 3,
          id: '28a2ce1f_@_18',
          index: 2,
          cPercent: 0.005883178675812123,
        },
        {
          date: '2025-07-07',
          title: 'Laundry, Linens, & Uniforms',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16,
              stdDev: 0.4,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'ad6ac922_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'ad6ac922_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Kitchen/ Bar Smallwares',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '9f991141_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '9f991141_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1734.64,
          amtAvg: 1734.64,
          perc: 0.0248,
          percAvg: 0.0248,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 1734.64,
          percent: 0.0248,
          percentAVG: 0.0248,
          cellID: 'b7f8c8b8_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'b7f8c8b8_@_18',
          index: 2,
          cPercent: 0.02477109825285388,
        },
        {
          date: '2025-07-07',
          title: 'Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '9d0fd7d1_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '9d0fd7d1_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: '3rd Party Commissions',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '47bbbb15_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '47bbbb15_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'd484c66b_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'd484c66b_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'edd65db2_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'edd65db2_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Marketing & Public Relations',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 1700,
          perc: 0.0243,
          percAvg: 0.0243,
          dataRows: [
            {
              txnDate: '2025-07-10',
              type: 'Expense',
              eventId: '15410',
              num: '',
              name: 'The Scene',
              description: 'VISA DDA PUR AP - 406466     WWW THESCENENY COM          WWW THESCENEN * NY',
              amount: 1700,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0243,
          percentAVG: 0.0243,
          cellID: 'c61b398a_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: 'c61b398a_@_18',
          index: 2,
          cPercent: 0.02427643028516095,
        },
        {
          date: '2025-07-07',
          title: 'Advertising & Promotions',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
            stats: {
              mean: 1.8,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '1dc3b3a3_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '1dc3b3a3_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1700,
          amtAvg: 1700,
          perc: 0.0243,
          percAvg: 0.0243,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 1700,
          percent: 0.0243,
          percentAVG: 0.0243,
          cellID: '024ba9eb_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '024ba9eb_@_18',
          index: 2,
          cPercent: 0.02427643028516095,
        },
        {
          date: '2025-07-07',
          title: 'Music & DJ',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '0c83dbac_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '0c83dbac_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '6f7c6ca5_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '6f7c6ca5_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Accounting & Bookkeeping',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '5a0fedcf_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '5a0fedcf_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Consulting',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'b08821c2_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'b08821c2_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Legal',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 1681,
          perc: 0.024,
          percAvg: 0.024,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '15384',
              num: '',
              name: 'At Law',
              description: 'WIRE TRANSFER OUTGOING - Collection At Law',
              amount: 1681,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.024,
          percentAVG: 0.024,
          cellID: 'a630ac37_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: 'a630ac37_@_18',
          index: 2,
          cPercent: 0.024005105476091505,
        },
        {
          date: '2025-07-07',
          title: 'Payroll Processing Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '975961bc_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '975961bc_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Computer Supplies, Software & IT',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 110,
          perc: 0.0016,
          percAvg: 0.0016,
          dataRows: [
            {
              txnDate: '2025-07-09',
              type: 'Expense',
              eventId: '15261',
              num: '',
              name: 'MarginEdge',
              description: 'MARGINEDGE       XXXXXX9612',
              amount: 110,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0016,
          percentAVG: 0.0016,
          cellID: '9450bb96_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '9450bb96_@_18',
          index: 2,
          cPercent: 0.0015708278419810026,
        },
        {
          date: '2025-07-07',
          title: 'Dues and Subscriptions',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '236c5723_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '236c5723_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Bank Charges & Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.8400000000000003,
              stdDev: 1.3564659966250538,
            },
          },
          trxFlagged: [],
          amount: 90,
          perc: 0.0013,
          percAvg: 0.0013,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14767',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14768',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14769',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0013,
          percentAVG: 0.0013,
          cellID: 'c3c23383_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 3,
          id: 'c3c23383_@_18',
          index: 2,
          cPercent: 0.0012852227798026386,
        },
        {
          date: '2025-07-07',
          title: 'Office Supplies & Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
            stats: {
              mean: 8.2,
              variance: 15.36,
              stdDev: 3.919183588453085,
            },
          },
          trxFlagged: [],
          amount: 19.18,
          perc: 0.0003,
          percAvg: 0.0003,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14730',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 19.18,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0003,
          percentAVG: 0.0003,
          cellID: '058d9b25_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '058d9b25_@_18',
          index: 2,
          cPercent: 0.0002738952546290512,
        },
        {
          date: '2025-07-07',
          title: 'Phone and Internet',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '0c2b505e_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '0c2b505e_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Security',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '9dc533d9_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '9dc533d9_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1900.18,
          amtAvg: 1900.18,
          perc: 0.0271,
          percAvg: 0.0271,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 1900.18,
          percent: 0.0271,
          percentAVG: 0.0271,
          cellID: 'f12db2ec_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'f12db2ec_@_18',
          index: 2,
          cPercent: 0.027135051352504196,
        },
        {
          date: '2025-07-07',
          title: 'Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '084f517c_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '084f517c_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Travel, Ground Transport & Airfare',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 235.02,
          perc: 0.0034,
          percAvg: 0.0034,
          dataRows: [
            {
              txnDate: '2025-07-10',
              type: 'Expense',
              eventId: '15243',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 74.9,
            },
            {
              txnDate: '2025-07-10',
              type: 'Expense',
              eventId: '15246',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 54.38,
            },
            {
              txnDate: '2025-07-11',
              type: 'Expense',
              eventId: '15239',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 56.72,
            },
            {
              txnDate: '2025-07-11',
              type: 'Expense',
              eventId: '15263',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 49.02,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0034,
          percentAVG: 0.0034,
          cellID: 'e4e1ab18_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 4,
          id: 'e4e1ab18_@_18',
          index: 2,
          cPercent: 0.003356145085657957,
        },
        {
          date: '2025-07-07',
          title: 'Meals & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'f245aeff_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'f245aeff_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Parking',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '3ae4b332_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '3ae4b332_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Fuel',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '4dbd49a9_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '4dbd49a9_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 235.02,
          amtAvg: 235.02,
          perc: 0.0034,
          percAvg: 0.0034,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 235.02,
          percent: 0.0034,
          percentAVG: 0.0034,
          cellID: 'ea7ffa49_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'ea7ffa49_@_18',
          index: 2,
          cPercent: 0.003356145085657957,
        },
        {
          date: '2025-07-07',
          title: 'Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '1675dbe8_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '1675dbe8_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Repair & Maintenance, Equipment',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'aa06968c_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'aa06968c_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Repair & Maintenance, Facility',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
            stats: {
              mean: 1,
              variance: 1.2,
              stdDev: 1.0954451150103321,
            },
          },
          trxFlagged: [],
          amount: 3645.32,
          perc: 0.0521,
          percAvg: 0.0521,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15349',
              num: '6502085',
              name: 'American Garage Door',
              description: 'CHECK 6502085',
              amount: 1697.66,
            },
            {
              txnDate: '2025-07-08',
              type: 'Check',
              eventId: '15387',
              num: '6502144',
              name: 'Tekno Electric',
              description: 'CHECK 6502144',
              amount: 250,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15409',
              num: '6502086',
              name: 'American Garage Door',
              description: 'CHECK 6502086 Garage door',
              amount: 1697.66,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0.0521,
          percentAVG: 0.0521,
          cellID: '4d40af10_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 3,
          id: '4d40af10_@_18',
          index: 2,
          cPercent: 0.052056092263001716,
        },
        {
          date: '2025-07-07',
          title: 'Pest Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'a044faba_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'a044faba_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Fire Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'd6450b86_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'd6450b86_@_18',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 3645.32,
          amtAvg: 3645.32,
          perc: 0.0521,
          percAvg: 0.0521,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 3645.32,
          percent: 0.0521,
          percentAVG: 0.0521,
          cellID: '4da1092f_@_18_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '4da1092f_@_18',
          index: 2,
          cPercent: 0.052056092263001716,
        },
        {
          date: '2025-07-07',
          title: 'TOTAL CONTROLLABLE EXPENSES',
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 9215.160000000002,
          amtAvg: 9215.160000000002,
          perc: 0.1316,
          percAvg: 0.1316,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 9215.160000000002,
          percent: 0.1316,
          percentAVG: 0.1316,
          cellID: 'a624f257_@_19_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'a624f257_@_19',
          index: 2,
          cPercent: 0.1315948172391787,
        },
        {
          date: '2025-07-07',
          title: 'Controllable Profit',
          path: ['Controllable Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -12321.610000000013,
          amtAvg: -12321.610000000013,
          perc: -0.176,
          percAvg: -0.176,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -12321.610000000013,
          percent: -0.176,
          percentAVG: -0.176,
          cellID: 'a973b710_@_20_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'a973b710_@_20',
          index: 2,
          cPercent: -0.17595570950937783,
        },
        {
          date: '2025-07-07',
          title: 'NON-CONTROLLABLE EXPENSES',
          path: ['NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '79208dfc_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '79208dfc_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '52e26b6b_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '52e26b6b_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Rent/Lease',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '68876c4f_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '68876c4f_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Utility, Electricity',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '208dfabc_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '208dfabc_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Utility, Gas',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'c9446d9c_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'c9446d9c_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '20d5762f_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '20d5762f_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '763b7c77_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '763b7c77_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Other Income/Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1.01,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Deposit',
              eventId: '15382',
              num: '',
              name: 'Toast Inc',
              description: 'TOAST            EOM JUN 30',
              amount: -1.01,
            },
          ],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '91f38f9a_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 1,
          id: '91f38f9a_@_21',
          index: 2,
          cPercent: -0.000014423055640007388,
        },
        {
          date: '2025-07-07',
          title: 'To Be Classified P&L',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.56,
              stdDev: 0.7483314773547883,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '5ccef3e9_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '5ccef3e9_@_21',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1.01,
          amtAvg: -1.01,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -1.01,
          percent: 0,
          percentAVG: 0,
          cellID: 'd4b5a9af_@_21_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'd4b5a9af_@_21',
          index: 2,
          cPercent: -0.000014423055640007388,
        },
        {
          date: '2025-07-07',
          title: 'TOTAL NON-CONTROLLABLE EXPENSES',
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1.01,
          amtAvg: -1.01,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -1.01,
          percent: 0,
          percentAVG: 0,
          cellID: '1851dc59_@_22_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '1851dc59_@_22',
          index: 2,
          cPercent: -0.000014423055640007388,
        },
        {
          date: '2025-07-07',
          title: 'Operating Profit',
          path: ['Operating Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -12320.600000000013,
          amtAvg: -12320.600000000013,
          perc: -0.1759,
          percAvg: -0.1759,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -12320.600000000013,
          percent: -0.1759,
          percentAVG: -0.1759,
          cellID: '251b8ac6_@_23_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '251b8ac6_@_23',
          index: 2,
          cPercent: -0.17594128645373783,
        },
        {
          date: '2025-07-07',
          title: 'Other Expenses',
          path: ['Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: '5e10c38d_@_24_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '5e10c38d_@_24',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Loan Interest',
          path: ['Other Expenses', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '13e3a076_@_24_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '13e3a076_@_24',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Other Expenses',
          path: ['Total Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'caeb87a7_@_25_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'caeb87a7_@_25',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'EBITDA',
          path: ['EBITDA'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -12320.600000000013,
          amtAvg: -12320.600000000013,
          perc: -0.1759,
          percAvg: -0.1759,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -12320.600000000013,
          percent: -0.1759,
          percentAVG: -0.1759,
          cellID: 'e815a21e_@_26_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'e815a21e_@_26',
          index: 2,
          cPercent: -0.17594128645373783,
        },
        {
          date: '2025-07-07',
          title: 'Interest, Taxes, Depreciation and Amortization',
          path: ['Interest, Taxes, Depreciation and Amortization'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          cellID: '644555ee_@_27_-x-_3',
          baseAmount: 0,
          transactions: 0,
          id: '644555ee_@_27',
          index: 2,
        },
        {
          date: '2025-07-07',
          title: 'Loan Interest',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'dce93088_@_27_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'dce93088_@_27',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'Total Interest, Taxes, Depreciation and Amortization',
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          percent: 0,
          percentAVG: 0,
          cellID: 'b4184eff_@_28_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: 'b4184eff_@_28',
          index: 2,
          cPercent: 0,
        },
        {
          date: '2025-07-07',
          title: 'NET PROFIT',
          path: ['NET PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -12320.600000000013,
          amtAvg: -12320.600000000013,
          perc: -0.1759,
          percAvg: -0.1759,
          dataRows: [],
          reportId: '18ffe0fc-88f6-44e1-9b29-13478b5578ca',
          amountAVG: -12320.600000000013,
          percent: -0.1759,
          percentAVG: -0.1759,
          cellID: '9b50fa7c_@_29_-x-_3',
          baseAmount: 70026.76999999999,
          transactions: 0,
          id: '9b50fa7c_@_29',
          index: 2,
          cPercent: -0.17594128645373783,
        },
      ],
      total: false,
      compoundColumn: false,
      isLocation: false,
      liveReport: false,
      periodReporting: false,
      periodID: '',
      consolidated: false,
      originType: 'Data',
    },
    {
      name: '2025-06-30',
      reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
      date: {
        start: '2025-06-30',
        end: '2025-07-06',
      },
      type: [
        {
          type: 'Data',
          index: 3,
        },
      ],
      data: [
        {
          date: '2025-06-30',
          title: 'SALES',
          path: ['SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          cellID: '5bc89b03_@_2_-x-_4',
          baseAmount: 0,
          transactions: 0,
          id: '5bc89b03_@_2',
          index: 3,
        },
        {
          date: '2025-06-30',
          title: 'Sales, Food',
          path: ['SALES', 'Sales, Food'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
          trxAnomaly: {
            anomalies: [8],
            anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
            stats: {
              mean: 7.2,
              variance: 0.15999999999999998,
              stdDev: 0.39999999999999997,
            },
          },
          trxFlagged: [],
          amount: 49465.17,
          perc: 0.5367,
          percAvg: 0.5367,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 3223,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '15308',
              num: 'Strip sale P6.25',
              name: '',
              description: '',
              amount: 5883.17,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 3494,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 2415.5,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 5198,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 9323.5,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 10915,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 9013,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.5367,
          percentAVG: 0.5367,
          cellID: 'c5601bf4_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 8,
          id: 'c5601bf4_@_2',
          index: 3,
          cPercent: 0.5367395406679853,
        },
        {
          date: '2025-06-30',
          title: 'Sales, Liquor',
          path: ['SALES', 'Sales, Liquor'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 26219.51,
          amtAvg: 26219.51,
          perc: 0.2845,
          percAvg: 0.2845,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 1367,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 1397.01,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 1793,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 6275,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 5281,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 5572.5,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 4534,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 26219.51,
          percent: 0.2845,
          percentAVG: 0.2845,
          cellID: 'e1ca5621_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 7,
          id: 'e1ca5621_@_2',
          index: 3,
          cPercent: 0.28450418251750975,
        },
        {
          date: '2025-06-30',
          title: 'Sales, Beer',
          path: ['SALES', 'Sales, Beer'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 14,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 6528,
          amtAvg: 6528,
          perc: 0.0708,
          percAvg: 0.0708,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 106,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 252,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 135,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 413,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 69,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 539,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 452,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 794,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 338,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 1243,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 272,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 1042,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 166,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 707,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 6528,
          percent: 0.0708,
          percentAVG: 0.0708,
          cellID: 'ba0b0910_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 14,
          id: 'ba0b0910_@_2',
          index: 3,
          cPercent: 0.0708344016907373,
        },
        {
          date: '2025-06-30',
          title: 'Sales, Wine',
          path: ['SALES', 'Sales, Wine'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1628,
          amtAvg: 1628,
          perc: 0.0177,
          percAvg: 0.0177,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 38,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 183,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 243,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 227,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 236,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 437,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 264,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 1628,
          percent: 0.0177,
          percentAVG: 0.0177,
          cellID: '2f14959f_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 7,
          id: '2f14959f_@_2',
          index: 3,
          cPercent: 0.017665196990275786,
        },
        {
          date: '2025-06-30',
          title: 'Sales, Non-Alcoholic Beverage',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2902,
          amtAvg: 2902,
          perc: 0.0315,
          percAvg: 0.0315,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 239,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 188,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 144,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 480,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 641,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 616,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 594,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 2902,
          percent: 0.0315,
          percentAVG: 0.0315,
          cellID: '7bb557b1_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 7,
          id: '7bb557b1_@_2',
          index: 3,
          cPercent: 0.03148919021239578,
        },
        {
          date: '2025-06-30',
          title: 'Sales, Miscellaneous',
          path: ['SALES', 'Sales, Miscellaneous'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
            stats: {
              mean: 3.8,
              variance: 1.3599999999999999,
              stdDev: 1.16619037896906,
            },
          },
          trxFlagged: [],
          amount: 4069.88,
          perc: 0.0442,
          percAvg: 0.0442,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 1084,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 1460.88,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 1247,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 20,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 258,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0442,
          percentAVG: 0.0442,
          cellID: 'cbede411_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 5,
          id: 'cbede411_@_2',
          index: 3,
          cPercent: 0.04416169037271721,
        },
        {
          date: '2025-06-30',
          title: 'Sales, Service Charges',
          path: ['SALES', 'Sales, Service Charges'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1346.05,
          perc: 0.0146,
          percAvg: 0.0146,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 82.19,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 91.61,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 175.96,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 178.33,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 283.66,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 327.27,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 207.03,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0146,
          percentAVG: 0.0146,
          cellID: '4e12e939_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 7,
          id: '4e12e939_@_2',
          index: 3,
          cPercent: 0.014605797548378822,
        },
        {
          date: '2025-06-30',
          title: 'Sales - No category',
          path: ['SALES', 'Sales - No category'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'a1f04b4c_@_2_-x-_4',
          baseAmount: 92158.61,
          transactions: 0,
          id: 'a1f04b4c_@_2',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'GROSS SALES',
          path: ['GROSS SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 92158.61,
          amtAvg: 92158.61,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 92158.61,
          cellID: '74405d1a_@_3_-x-_4',
          baseAmount: 92158.61,
          transactions: 0,
          id: '74405d1a_@_3',
          index: 3,
        },
        {
          date: '2025-06-30',
          title: 'Comps & Discounts',
          path: ['Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'ba9fcd64_@_6_-x-_4',
          baseAmount: 92158.61,
          transactions: 0,
          id: 'ba9fcd64_@_6',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Discounts and Comps',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -2053.88,
          perc: -0.0223,
          percAvg: -0.0223,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: -24,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: -569.25,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: -81,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: -461,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: -193,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: -213.25,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: -512.38,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: -0.0223,
          percentAVG: -0.0223,
          cellID: '4936addc_@_6_-x-_4',
          baseAmount: 92158.61,
          transactions: 7,
          id: '4936addc_@_6',
          index: 3,
          cPercent: -0.022286360438813043,
        },
        {
          date: '2025-06-30',
          title: 'Total Comps & Discounts',
          path: ['Total Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -2053.88,
          amtAvg: -2053.88,
          perc: -0.0223,
          percAvg: -0.0223,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: -2053.88,
          percent: -0.0223,
          percentAVG: -0.0223,
          cellID: '8a448d4b_@_7_-x-_4',
          baseAmount: 92158.61,
          transactions: 0,
          id: '8a448d4b_@_7',
          index: 3,
          cPercent: -0.022286360438813043,
        },
        {
          date: '2025-06-30',
          title: 'NET SALES',
          path: ['NET SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 90104.73,
          amtAvg: 90104.73,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 90104.73,
          cellID: '3b5cefb1_@_8_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '3b5cefb1_@_8',
          index: 3,
        },
        {
          date: '2025-06-30',
          title: 'COST OF GOODS SOLD (COGS)',
          path: ['COST OF GOODS SOLD (COGS)'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          cellID: '753db221_@_9_-x-_4',
          baseAmount: 0,
          transactions: 0,
          id: '753db221_@_9',
          index: 3,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Food',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          baseRef: 'Sales, Food',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.4,
              variance: 1.4400000000000002,
              stdDev: 1.2000000000000002,
            },
          },
          trxFlagged: [],
          amount: 592.08,
          perc: 0.012,
          percAvg: 0.012,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14754',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 244.6,
            },
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14755',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 347.48,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.012,
          percentAVG: 0.012,
          cellID: '7a94d93b_@_9_-x-_4',
          baseAmount: 49465.17,
          transactions: 2,
          id: '7a94d93b_@_9',
          index: 3,
          cPercent: 0.011969634391229224,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Meat & Poultry',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
            stats: {
              mean: 3.8,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 3461.52,
          perc: 0.0384,
          percAvg: 0.0384,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 1435.21,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 441.11,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 1585.2,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0384,
          percentAVG: 0.0384,
          cellID: '3f46fcce_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 3,
          id: '3f46fcce_@_9',
          index: 3,
          cPercent: 0.038416629182507954,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Seafood',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 0.96,
              stdDev: 0.9797958971132712,
            },
          },
          trxFlagged: [],
          amount: 347.73,
          perc: 0.0039,
          percAvg: 0.0039,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 173.84,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 173.89,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0039,
          percentAVG: 0.0039,
          cellID: '2bdeb0ad_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 2,
          id: '2bdeb0ad_@_9',
          index: 3,
          cPercent: 0.003859175872343217,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Produce',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
            stats: {
              mean: 7.4,
              variance: 12.24,
              stdDev: 3.4985711369071804,
            },
          },
          trxFlagged: [],
          amount: 4556.91,
          perc: 0.0506,
          percAvg: 0.0506,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Bill',
              eventId: '14821',
              num: '710926',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 914.6,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14835',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 1115.12,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 68.25,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14837',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 694.09,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14722',
              num: '711119',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 488.45,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15335',
              num: '6502145',
              name: 'Avanti Produce',
              description: 'CHECK 6502145 INV#0710602',
              amount: 676.65,
            },
            {
              txnDate: '2025-07-05',
              type: 'Bill',
              eventId: '14723',
              num: '711235',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 599.75,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0506,
          percentAVG: 0.0506,
          cellID: '593c4b13_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 7,
          id: '593c4b13_@_9',
          index: 3,
          cPercent: 0.050573482657347735,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Grocery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
          trxAnomaly: {
            anomalies: [11],
            anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
            stats: {
              mean: 7.6,
              variance: 4.24,
              stdDev: 2.0591260281974,
            },
          },
          trxFlagged: [],
          amount: 2309.13,
          perc: 0.0256,
          percAvg: 0.0256,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 973.13,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 109.71,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14722',
              num: '711119',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 49.8,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 1077.64,
            },
            {
              txnDate: '2025-07-05',
              type: 'Bill',
              eventId: '14723',
              num: '711235',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 98.85,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0256,
          percentAVG: 0.0256,
          cellID: 'e0037727_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 5,
          id: 'e0037727_@_9',
          index: 3,
          cPercent: 0.025627178506611142,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Bakery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 658.78,
          perc: 0.0073,
          percAvg: 0.0073,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14842',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 613.98,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 44.8,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0073,
          percentAVG: 0.0073,
          cellID: '47294ea3_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 2,
          id: '47294ea3_@_9',
          index: 3,
          cPercent: 0.007311269896707976,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Dairy',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
          trxAnomaly: {
            anomalies: [7],
            anomalyScores: [0.82915619758885, 0, 0, 0, 0],
            stats: {
              mean: 4.8,
              variance: 1.7600000000000002,
              stdDev: 1.32664991614216,
            },
          },
          trxFlagged: [],
          amount: 1091.88,
          perc: 0.0121,
          percAvg: 0.0121,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 518.45,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 30.22,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 354.61,
            },
            {
              txnDate: '2025-07-05',
              type: 'Bill',
              eventId: '14723',
              num: '711235',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 188.6,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0121,
          percentAVG: 0.0121,
          cellID: '841fc412_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 4,
          id: '841fc412_@_9',
          index: 3,
          cPercent: 0.012117898805090479,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Liquor',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          baseRef: 'Sales, Liquor',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
          trxAnomaly: {
            anomalies: [10],
            anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
            stats: {
              mean: 4.8,
              variance: 7.76,
              stdDev: 2.7856776554368237,
            },
          },
          trxFlagged: [],
          amount: 4449.61,
          amtAvg: 4449.61,
          perc: 0.1697,
          percAvg: 0.1697,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14820',
              num: 'MI1826ME',
              name: '',
              description: 'Vendor: Allied Beverage Group LLC',
              amount: 178.64,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '650411',
              name: '',
              description: '',
              amount: -237,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '773964',
              name: '',
              description: '',
              amount: -69,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '752749',
              name: '',
              description: '',
              amount: -48,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '644657',
              name: '',
              description: '',
              amount: -36,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '641925',
              name: '',
              description: '',
              amount: -12,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15287',
              num: '6502148',
              name: 'Allied Beverages',
              description: 'CHECK 6502148',
              amount: 178.64,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 1184.38,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14823',
              num: '824312',
              name: 'Allied Beverages',
              description: '',
              amount: 2309.95,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15333',
              num: '6502200',
              name: 'Fedway',
              description: 'POD CHECK #110620',
              amount: 1000,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 4449.61,
          percent: 0.1697,
          percentAVG: 0.1697,
          cellID: '6eb26171_@_9_-x-_4',
          baseAmount: 26219.51,
          transactions: 10,
          id: '6eb26171_@_9',
          index: 3,
          cPercent: 0.16970607002190352,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Bar Groceries',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.9600000000000002,
              stdDev: 0.9797958971132713,
            },
          },
          trxFlagged: [],
          amount: 61.53,
          perc: 0.0007,
          percAvg: 0.0007,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14719',
              num: '9247032',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0007,
          percentAVG: 0.0007,
          cellID: '15101cdc_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '15101cdc_@_9',
          index: 3,
          cPercent: 0.0006828720312463064,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          baseRef: 'Sales, Beer',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          cellID: '90be8534_@_9_-x-_4',
          baseAmount: 6528,
          transactions: 0,
          id: '90be8534_@_9',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Draught Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 4.960000000000001,
              stdDev: 2.227105745132009,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '3395a498_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '3395a498_@_9',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Bottled Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 232,
          perc: 0.0026,
          percAvg: 0.0026,
          dataRows: [
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 232,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0026,
          percentAVG: 0.0026,
          cellID: 'e2c4f57e_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: 'e2c4f57e_@_9',
          index: 3,
          cPercent: 0.002574781590267237,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Wine',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          baseRef: 'Sales, Wine',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2.4,
              variance: 1.8399999999999999,
              stdDev: 1.3564659966250536,
            },
          },
          trxFlagged: [],
          amount: 2138.98,
          amtAvg: 2138.98,
          perc: 1.3139,
          percAvg: 1.3139,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Check',
              eventId: '15277',
              num: '6502116',
              name: 'Gallo Wine Sales',
              description: 'CHECK 6502116 703442',
              amount: 720.12,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14717',
              num: '707058',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 462,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 631.06,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14823',
              num: '824312',
              name: 'Allied Beverages',
              description: '',
              amount: 325.8,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 2138.98,
          percent: 1.3139,
          percentAVG: 1.3139,
          cellID: 'b29ce542_@_9_-x-_4',
          baseAmount: 1628,
          transactions: 4,
          id: 'b29ce542_@_9',
          index: 3,
          cPercent: 1.3138697788697788,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Non-Alcoholic',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0, 0.784464540552736, 0, 0],
            stats: {
              mean: 4.4,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 2040.39,
          amtAvg: 2040.39,
          perc: 0.0226,
          percAvg: 0.0226,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14846',
              num: '',
              name: 'Peerless Beverage',
              description: 'PEERLESS BEVERAG PEERLESS B',
              amount: 1115,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 49.75,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14718',
              num: '27165007',
              name: 'Pepsi',
              description: '',
              amount: 812.37,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 63.27,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 2040.39,
          percent: 0.0226,
          percentAVG: 0.0226,
          cellID: '9f08e50d_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 4,
          id: '9f08e50d_@_9',
          index: 3,
          cPercent: 0.02264464917657486,
        },
        {
          date: '2025-06-30',
          title: 'COGS, Packaging',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
          trxAnomaly: {
            anomalies: [1, 3],
            anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
            stats: {
              mean: 2,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 188.73,
          perc: 0.0021,
          percAvg: 0.0021,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 188.73,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0021,
          percentAVG: 0.0021,
          cellID: '027a424d_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '027a424d_@_9',
          index: 3,
          cPercent: 0.0020945626272893775,
        },
        {
          date: '2025-06-30',
          title: 'Shipping, Freight and Delivery',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          cellID: 'dfae81d5_@_9_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'dfae81d5_@_9',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'TOTAL COGS',
          path: ['TOTAL COGS'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 22129.269999999997,
          amtAvg: 22129.269999999997,
          perc: 0.2456,
          percAvg: 0.2456,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 22129.269999999997,
          percent: 0.2456,
          percentAVG: 0.2456,
          cellID: '528a97f9_@_10_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '528a97f9_@_10',
          index: 3,
          cPercent: 0.24559498707781488,
        },
        {
          date: '2025-06-30',
          title: 'GROSS PROFIT',
          path: ['GROSS PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 67975.45999999999,
          amtAvg: 67975.45999999999,
          perc: 0.7544,
          percAvg: 0.7544,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 67975.45999999999,
          percent: 0.7544,
          percentAVG: 0.7544,
          cellID: '7b400e74_@_12_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '7b400e74_@_12',
          index: 3,
          cPercent: 0.7544050129221851,
        },
        {
          date: '2025-06-30',
          title: 'OPERATING EXPENSES',
          path: ['OPERATING EXPENSES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 31655.99,
          amtAvg: 37173.28,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 37173.28,
          cellID: '39d9c4d4_@_13_-x-_4',
          baseAmount: 31655.99,
          transactions: 0,
          id: '39d9c4d4_@_13',
          index: 3,
        },
        {
          date: '2025-06-30',
          title: 'LABOR',
          path: ['LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '5b0fe671_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '5b0fe671_@_14',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Direct Labor',
          path: ['LABOR', 'Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'bb2363da_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'bb2363da_@_14',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Labor Other',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 30,
              variance: 456.4,
              stdDev: 21.36352030916253,
            },
          },
          trxFlagged: [],
          amount: 17238.8,
          perc: 0.1913,
          percAvg: 0.1913,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14883',
              num: '6502139',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502139 Payroll 06.15.2025',
              amount: 580,
            },
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14884',
              num: '6502137',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502137',
              amount: 356.2,
            },
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14885',
              num: '6502136',
              name: 'Javier Hernandez',
              description: 'CHECK 6502136',
              amount: 301.48,
            },
            {
              txnDate: '2025-07-01',
              type: 'Check',
              eventId: '15275',
              num: '6502143',
              name: '',
              description: '',
              amount: 59.76,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15282',
              num: '6502162',
              name: 'Carlos Ramirez',
              description: 'CHECK 6502162',
              amount: 677.74,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15283',
              num: '6502155',
              name: 'Luna, Nelson',
              description: 'CHECK 6502155',
              amount: 583.78,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15284',
              num: '6502183',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502183 WE 6.22.25 not found in Report',
              amount: 542.58,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15285',
              num: '6502166',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502166 WE 6.22.25 not found in Report',
              amount: 511.02,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15330',
              num: '6502192',
              name: 'Alexandre, Wood Loudie',
              description: 'POD CHECK W.E. 6.22.25',
              amount: 703.44,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15331',
              num: '6502157',
              name: 'Efren Cortes Sanchez',
              description: 'CHECK 6502157 W.E. 6.22.25',
              amount: 755.76,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15332',
              num: '6502182',
              name: 'Roberto Santiago.',
              description: 'CHECK 6502182 W.E. 6.22.25',
              amount: 1120.13,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15336',
              num: '6502167',
              name: 'Olivia Mandez',
              description: 'CHECK 6502167 W.E. 6.22.25',
              amount: 658.11,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15337',
              num: '6502190',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502190 W.E. 6.22.25',
              amount: 626.79,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15338',
              num: '6502164',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502164 W.E. 6.22.25',
              amount: 588.3,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15339',
              num: '6502180',
              name: 'Alexis Martinez',
              description: 'CHECK 6502180 W.E. 6.22.25',
              amount: 506.92,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15340',
              num: '6502169',
              name: 'Perdikos, Eleni',
              description: 'CHECK 6502169 W.E. 6.22.25',
              amount: 486.53,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15341',
              num: '6502175',
              name: 'Sanchez, Anthony',
              description: 'CHECK 6502175 W.E. 6.22.25',
              amount: 377.91,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15342',
              num: '6502173',
              name: 'Jason Canas',
              description: 'CHECK 6502173 W.E. 6.22.25',
              amount: 362.53,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15343',
              num: '6502185',
              name: 'Reynaldo Cortes Sanchoz',
              description: 'CHECK 6502185 W.E. 6.22.25',
              amount: 305.7,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15344',
              num: '6502177',
              name: 'Ibrahim Sidibay',
              description: 'CHECK 6502177 W.E. 6.22.25',
              amount: 262.54,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15345',
              num: '6502163',
              name: 'Frida Monroy',
              description: 'CHECK 6502163 W.E. 6.22.25',
              amount: 196.84,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15346',
              num: '6502161',
              name: 'Carac, Israel',
              description: 'CHECK 6502161 W.E. 6.22.25',
              amount: 174.74,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'Other',
              amount: 6500,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.1913,
          percentAVG: 0.1913,
          cellID: '687f4cd2_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 23,
          id: '687f4cd2_@_14',
          index: 3,
          cPercent: 0.19131958999266743,
        },
        {
          date: '2025-06-30',
          title: 'Labor, Management',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 3455,
          perc: 0.0383,
          percAvg: 0.0383,
          dataRows: [
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'Management',
              amount: 3455,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0383,
          percentAVG: 0.0383,
          cellID: '529343c4_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '529343c4_@_14',
          index: 3,
          cPercent: 0.03834426894126424,
        },
        {
          date: '2025-06-30',
          title: 'Labor, BOH',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1711.54,
          perc: 0.019,
          percAvg: 0.019,
          dataRows: [
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.019,
          percentAVG: 0.019,
          cellID: '3c61733f_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '3c61733f_@_14',
          index: 3,
          cPercent: 0.01899500725433615,
        },
        {
          date: '2025-06-30',
          title: 'Total Direct Labor',
          path: ['LABOR', 'Total Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 22405.34,
          amtAvg: 22405.34,
          perc: 0.2487,
          percAvg: 0.2487,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 22405.34,
          percent: 0.2487,
          percentAVG: 0.2487,
          cellID: '143a84db_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '143a84db_@_14',
          index: 3,
          cPercent: 0.24865886618826782,
        },
        {
          date: '2025-06-30',
          title: 'Labor Related Expenses',
          path: ['LABOR', 'Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'dacf6533_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'dacf6533_@_14',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Commission/Bonus/Incentives',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '7a82e4de_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '7a82e4de_@_14',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Payroll Taxes',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 475,
          perc: 0.0053,
          percAvg: 0.0053,
          dataRows: [
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'PR Tax',
              amount: 475,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0.0053,
          percentAVG: 0.0053,
          cellID: 'bbc14e9c_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: 'bbc14e9c_@_14',
          index: 3,
          cPercent: 0.005271643342141972,
        },
        {
          date: '2025-06-30',
          title: 'Employee Meals',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '416bc276_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '416bc276_@_14',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Recruiting',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'c12aec10_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'c12aec10_@_14',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Labor Related Expenses',
          path: ['LABOR', 'Total Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 475,
          amtAvg: 475,
          perc: 0.0053,
          percAvg: 0.0053,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 475,
          percent: 0.0053,
          percentAVG: 0.0053,
          cellID: '1e9ad256_@_14_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '1e9ad256_@_14',
          index: 3,
          cPercent: 0.005271643342141972,
        },
        {
          date: '2025-06-30',
          title: 'TOTAL LABOR',
          path: ['TOTAL LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 22880.34,
          amtAvg: 22880.34,
          perc: 0.2539,
          percAvg: 0.2539,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 22880.34,
          percent: 0.2539,
          percentAVG: 0.2539,
          cellID: 'd0736ae7_@_15_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'd0736ae7_@_15',
          index: 3,
          cPercent: 0.2539305095304098,
        },
        {
          date: '2025-06-30',
          title: 'PRIME COST',
          path: ['PRIME COST'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 45009.61,
          amtAvg: 45009.61,
          perc: 0.4995,
          percAvg: 0.4995,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 45009.61,
          percent: 0.4995,
          percentAVG: 0.4995,
          cellID: 'b7d061ce_@_16_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'b7d061ce_@_16',
          index: 3,
          cPercent: 0.4995254966082247,
        },
        {
          date: '2025-06-30',
          title: 'Contribution Margin',
          path: ['Contribution Margin'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 45095.119999999995,
          amtAvg: 45095.119999999995,
          perc: 0.5005,
          percAvg: 0.5005,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 45095.119999999995,
          percent: 0.5005,
          percentAVG: 0.5005,
          cellID: '2f5a4d68_@_17_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '2f5a4d68_@_17',
          index: 3,
          cPercent: 0.5004745033917753,
        },
        {
          date: '2025-06-30',
          title: 'CONTROLLABLE EXPENSES',
          path: ['CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '2cd659af_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '2cd659af_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '3be3d09b_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '3be3d09b_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Equipment Lease Rental',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 45.65,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 45.65,
          percent: 0,
          percentAVG: 0.0005,
          cellID: '1a6a3f76_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '1a6a3f76_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Cleaning Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
            stats: {
              mean: 2.2,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 66.69,
          amtAvg: 123.8,
          perc: 0.0007,
          percAvg: 0.0014,
          dataRows: [
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 66.69,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 123.8,
          percent: 0.0007,
          percentAVG: 0.0014,
          cellID: '514ec7ed_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '514ec7ed_@_18',
          index: 3,
          cPercent: 0.0007401387252367329,
        },
        {
          date: '2025-06-30',
          title: 'Cleaning Services',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 213.91,
          perc: 0,
          percAvg: 0.0024,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 213.91,
          percent: 0,
          percentAVG: 0.0024,
          cellID: '758ae475_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '758ae475_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Restaurant Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 464.64,
          amtAvg: 406.84,
          perc: 0.0052,
          percAvg: 0.0045,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 232.93,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14722',
              num: '711119',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 119.8,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 111.91,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 406.84,
          percent: 0.0052,
          percentAVG: 0.0045,
          cellID: '28a2ce1f_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 3,
          id: '28a2ce1f_@_18',
          index: 3,
          cPercent: 0.005156666026300728,
        },
        {
          date: '2025-06-30',
          title: 'Laundry, Linens, & Uniforms',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16,
              stdDev: 0.4,
            },
          },
          trxFlagged: [],
          amount: 1141.57,
          amtAvg: 547.55,
          perc: 0.0127,
          percAvg: 0.0061,
          dataRows: [
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14839',
              num: '',
              name: 'White Plains Linen',
              description: 'WHITE PLAINS COA COLLECTION',
              amount: 1141.57,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 547.55,
          percent: 0.0127,
          percentAVG: 0.0061,
          cellID: 'ad6ac922_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: 'ad6ac922_@_18',
          index: 3,
          cPercent: 0.012669368189661075,
        },
        {
          date: '2025-06-30',
          title: 'Kitchen/ Bar Smallwares',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 243.44,
          perc: 0,
          percAvg: 0.0027,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 243.44,
          percent: 0,
          percentAVG: 0.0027,
          cellID: '9f991141_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '9f991141_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1672.8999999999999,
          amtAvg: 1581.19,
          perc: 0.0186,
          percAvg: 0.0175,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 1581.19,
          percent: 0.0186,
          percentAVG: 0.0175,
          cellID: 'b7f8c8b8_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'b7f8c8b8_@_18',
          index: 3,
          cPercent: 0.018566172941198535,
        },
        {
          date: '2025-06-30',
          title: 'Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '9d0fd7d1_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '9d0fd7d1_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: '3rd Party Commissions',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 50,
          perc: 0,
          percAvg: 0.0006,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 50,
          percent: 0,
          percentAVG: 0.0006,
          cellID: '47bbbb15_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '47bbbb15_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 50,
          perc: 0,
          percAvg: 0.0006,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 50,
          percent: 0,
          percentAVG: 0.0006,
          cellID: 'd484c66b_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'd484c66b_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'edd65db2_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'edd65db2_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Marketing & Public Relations',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 556.85,
          perc: 0,
          percAvg: 0.0062,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '15201',
              num: '',
              name: 'Adentro Inc',
              description: 'ADENTRO INC      ZENREACH',
              amount: 89,
            },
            {
              txnDate: '2025-07-02',
              type: 'Deposit',
              eventId: '15202',
              num: '',
              name: 'Adentro Inc',
              description: 'ADENTRO INC      ZENREACH',
              amount: -89,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 556.85,
          percent: 0,
          percentAVG: 0.0062,
          cellID: 'c61b398a_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 2,
          id: 'c61b398a_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Advertising & Promotions',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
            stats: {
              mean: 1.8,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 1227.09,
          amtAvg: 453.17,
          perc: 0.0136,
          percAvg: 0.005,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14749',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  4GXXCVYUK2          650 5434800   * CA',
              amount: 18.14,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14750',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  UDDR8UQUK2          650 5434800   * CA',
              amount: 98.26,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14847',
              num: '',
              name: 'Google',
              description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE THE AINSWO    650 2530000   * CA',
              amount: 237.79,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14848',
              num: '',
              name: 'Google',
              description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE PAIGECONCE    650 2530000   * CA',
              amount: 522.99,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14849',
              num: '',
              name: 'Google',
              description: 'VISA DDA PUR AP - 420429     GOOGLE ADSXXXXXX3399        650 2530000   * CA',
              amount: 349.91,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 453.17,
          percent: 0.0136,
          percentAVG: 0.005,
          cellID: '1dc3b3a3_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 5,
          id: '1dc3b3a3_@_18',
          index: 3,
          cPercent: 0.013618485955176826,
        },
        {
          date: '2025-06-30',
          title: 'Total Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1227.09,
          amtAvg: 1010.02,
          perc: 0.0136,
          percAvg: 0.0112,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 1010.02,
          percent: 0.0136,
          percentAVG: 0.0112,
          cellID: '024ba9eb_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '024ba9eb_@_18',
          index: 3,
          cPercent: 0.013618485955176826,
        },
        {
          date: '2025-06-30',
          title: 'Music & DJ',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 113.42,
          perc: 0,
          percAvg: 0.0013,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 113.42,
          percent: 0,
          percentAVG: 0.0013,
          cellID: '0c83dbac_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '0c83dbac_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '6f7c6ca5_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '6f7c6ca5_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Accounting & Bookkeeping',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1499,
          amtAvg: 340.1,
          perc: 0.0166,
          percAvg: 0.0038,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Bill',
              eventId: '14560',
              num: 'INV-12776-7690',
              name: 'KitchenSync LLC',
              description: '',
              amount: 1499,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 340.1,
          percent: 0.0166,
          percentAVG: 0.0038,
          cellID: '5a0fedcf_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '5a0fedcf_@_18',
          index: 3,
          cPercent: 0.016636196568149086,
        },
        {
          date: '2025-06-30',
          title: 'Consulting',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 41.67,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 41.67,
          percent: 0,
          percentAVG: 0.0005,
          cellID: 'b08821c2_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'b08821c2_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Legal',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 2500,
          amtAvg: 791.01,
          perc: 0.0277,
          percAvg: 0.0088,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14882',
              num: '2095',
              name: 'Matthew J Keating Attorney',
              description: 'CHECK 2095',
              amount: 2500,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 791.01,
          percent: 0.0277,
          percentAVG: 0.0088,
          cellID: 'a630ac37_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: 'a630ac37_@_18',
          index: 3,
          cPercent: 0.027745491274431433,
        },
        {
          date: '2025-06-30',
          title: 'Payroll Processing Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 80,
          amtAvg: 95.64,
          perc: 0.0009,
          percAvg: 0.0011,
          dataRows: [
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'Invoices: Ains hoboken - 7/16/2025 - Shipping Fee',
              amount: 80,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 95.64,
          percent: 0.0009,
          percentAVG: 0.0011,
          cellID: '975961bc_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '975961bc_@_18',
          index: 3,
          cPercent: 0.0008878557207818059,
        },
        {
          date: '2025-06-30',
          title: 'Computer Supplies, Software & IT',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 353.18,
          perc: 0,
          percAvg: 0.0039,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 353.18,
          percent: 0,
          percentAVG: 0.0039,
          cellID: '9450bb96_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '9450bb96_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Dues and Subscriptions',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 114.36,
          amtAvg: 73.06,
          perc: 0.0013,
          percAvg: 0.0008,
          dataRows: [
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14844',
              num: '',
              name: 'Resy',
              description: 'RESYNETWORKINC   RESYNETWOR',
              amount: 114.36,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 73.06,
          percent: 0.0013,
          percentAVG: 0.0008,
          cellID: '236c5723_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '236c5723_@_18',
          index: 3,
          cPercent: 0.0012691897528575914,
        },
        {
          date: '2025-06-30',
          title: 'Bank Charges & Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.8400000000000003,
              stdDev: 1.3564659966250538,
            },
          },
          trxFlagged: [],
          amount: 50,
          amtAvg: 47.31,
          perc: 0.0006,
          percAvg: 0.0005,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '15203',
              num: '',
              name: 'Bank Charges',
              description: 'MAINTENANCE FEE',
              amount: 20,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14766',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 47.31,
          percent: 0.0006,
          percentAVG: 0.0005,
          cellID: 'c3c23383_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 2,
          id: 'c3c23383_@_18',
          index: 3,
          cPercent: 0.0005549098254886286,
        },
        {
          date: '2025-06-30',
          title: 'Office Supplies & Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
            stats: {
              mean: 8.2,
              variance: 15.36,
              stdDev: 3.919183588453085,
            },
          },
          trxFlagged: [],
          amount: 900.05,
          amtAvg: 1318.4,
          perc: 0.01,
          percAvg: 0.0146,
          dataRows: [
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14727',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 13.53,
            },
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14731',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 1.75,
            },
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14736',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 4.99,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14728',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 38.65,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14729',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 85.3,
            },
            {
              txnDate: '2025-07-02',
              type: 'Deposit',
              eventId: '14845',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA REF - 469216     AMAZON MKTPLACE PMTS        AMZN COM BILL * WA',
              amount: -244.17,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15334',
              num: '6502210',
              name: 'Meow Hospitality LLC',
              description: 'POD CHECK',
              amount: 1000,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 1318.4,
          percent: 0.01,
          percentAVG: 0.0146,
          cellID: '058d9b25_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 7,
          id: '058d9b25_@_18',
          index: 3,
          cPercent: 0.009988931768620804,
        },
        {
          date: '2025-06-30',
          title: 'Phone and Internet',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 100.39,
          perc: 0,
          percAvg: 0.0011,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 100.39,
          percent: 0,
          percentAVG: 0.0011,
          cellID: '0c2b505e_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '0c2b505e_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Security',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 31.67,
          perc: 0,
          percAvg: 0.0004,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 31.67,
          percent: 0,
          percentAVG: 0.0004,
          cellID: '9dc533d9_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '9dc533d9_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 5143.41,
          amtAvg: 3192.43,
          perc: 0.0571,
          percAvg: 0.0354,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 3192.43,
          percent: 0.0571,
          percentAVG: 0.0354,
          cellID: 'f12db2ec_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'f12db2ec_@_18',
          index: 3,
          cPercent: 0.05708257491032935,
        },
        {
          date: '2025-06-30',
          title: 'Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '084f517c_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '084f517c_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Travel, Ground Transport & Airfare',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 79.12,
          amtAvg: 188.2,
          perc: 0.0009,
          percAvg: 0.0021,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14764',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 79.12,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 188.2,
          percent: 0.0009,
          percentAVG: 0.0021,
          cellID: 'e4e1ab18_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: 'e4e1ab18_@_18',
          index: 3,
          cPercent: 0.000878089307853206,
        },
        {
          date: '2025-06-30',
          title: 'Meals & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 92.67,
          amtAvg: 240.66,
          perc: 0.001,
          percAvg: 0.0027,
          dataRows: [
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14834',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 92.67,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 240.66,
          percent: 0.001,
          percentAVG: 0.0027,
          cellID: 'f245aeff_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: 'f245aeff_@_18',
          index: 3,
          cPercent: 0.0010284698705606244,
        },
        {
          date: '2025-06-30',
          title: 'Parking',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 280.88,
          perc: 0,
          percAvg: 0.0031,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 280.88,
          percent: 0,
          percentAVG: 0.0031,
          cellID: '3ae4b332_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '3ae4b332_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Fuel',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 35,
          amtAvg: 22.23,
          perc: 0.0004,
          percAvg: 0.0002,
          dataRows: [
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14832',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 35,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 22.23,
          percent: 0.0004,
          percentAVG: 0.0002,
          cellID: '4dbd49a9_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: '4dbd49a9_@_18',
          index: 3,
          cPercent: 0.00038843687784204003,
        },
        {
          date: '2025-06-30',
          title: 'Total Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 206.79000000000002,
          amtAvg: 731.97,
          perc: 0.0023,
          percAvg: 0.0081,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 731.97,
          percent: 0.0023,
          percentAVG: 0.0081,
          cellID: 'ea7ffa49_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'ea7ffa49_@_18',
          index: 3,
          cPercent: 0.0022949960562558707,
        },
        {
          date: '2025-06-30',
          title: 'Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '1675dbe8_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '1675dbe8_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Repair & Maintenance, Equipment',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 704.51,
          perc: 0,
          percAvg: 0.0078,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 704.51,
          percent: 0,
          percentAVG: 0.0078,
          cellID: 'aa06968c_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'aa06968c_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Repair & Maintenance, Facility',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
            stats: {
              mean: 1,
              variance: 1.2,
              stdDev: 1.0954451150103321,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 1378.16,
          perc: 0,
          percAvg: 0.0153,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 1378.16,
          percent: 0,
          percentAVG: 0.0153,
          cellID: '4d40af10_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '4d40af10_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Pest Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 525.46,
          amtAvg: 194.38,
          perc: 0.0058,
          percAvg: 0.0022,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '15290',
              num: '',
              name: 'Liberty Pest',
              description: 'VISA DDA PUR AP - 403982     LIBERTY PEST CONTROL        718 8379030   * NY',
              amount: 525.46,
            },
          ],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 194.38,
          percent: 0.0058,
          percentAVG: 0.0022,
          cellID: 'a044faba_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 1,
          id: 'a044faba_@_18',
          index: 3,
          cPercent: 0.005831658338025097,
        },
        {
          date: '2025-06-30',
          title: 'Fire Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 21.04,
          perc: 0,
          percAvg: 0.0002,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 21.04,
          percent: 0,
          percentAVG: 0.0002,
          cellID: 'd6450b86_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'd6450b86_@_18',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 525.46,
          amtAvg: 2298.09,
          perc: 0.0058,
          percAvg: 0.0255,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 2298.09,
          percent: 0.0058,
          percentAVG: 0.0255,
          cellID: '4da1092f_@_18_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '4da1092f_@_18',
          index: 3,
          cPercent: 0.005831658338025097,
        },
        {
          date: '2025-06-30',
          title: 'TOTAL CONTROLLABLE EXPENSES',
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 8775.650000000001,
          amtAvg: 8977.12,
          perc: 0.0974,
          percAvg: 0.0996,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 8977.12,
          percent: 0.0974,
          percentAVG: 0.0996,
          cellID: 'a624f257_@_19_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'a624f257_@_19',
          index: 3,
          cPercent: 0.0973938882009857,
        },
        {
          date: '2025-06-30',
          title: 'Controllable Profit',
          path: ['Controllable Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 36319.469999999994,
          amtAvg: 36117.99999999999,
          perc: 0.4031,
          percAvg: 0.4008,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 36117.99999999999,
          percent: 0.4031,
          percentAVG: 0.4008,
          cellID: 'a973b710_@_20_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'a973b710_@_20',
          index: 3,
          cPercent: 0.4030806151907896,
        },
        {
          date: '2025-06-30',
          title: 'NON-CONTROLLABLE EXPENSES',
          path: ['NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '79208dfc_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '79208dfc_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '52e26b6b_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '52e26b6b_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Rent/Lease',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 4358.03,
          perc: 0,
          percAvg: 0.0484,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 4358.03,
          percent: 0,
          percentAVG: 0.0484,
          cellID: '68876c4f_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '68876c4f_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Utility, Electricity',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '208dfabc_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '208dfabc_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Utility, Gas',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 14.37,
          perc: 0,
          percAvg: 0.0002,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 14.37,
          percent: 0,
          percentAVG: 0.0002,
          cellID: 'c9446d9c_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'c9446d9c_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 4372.4,
          perc: 0,
          percAvg: 0.0485,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 4372.4,
          percent: 0,
          percentAVG: 0.0485,
          cellID: '20d5762f_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '20d5762f_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '763b7c77_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '763b7c77_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Other Income/Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: -0.2,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: -0.2,
          percent: 0,
          percentAVG: 0,
          cellID: '91f38f9a_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '91f38f9a_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'To Be Classified P&L',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.56,
              stdDev: 0.7483314773547883,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 943.62,
          perc: 0,
          percAvg: 0.0105,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 943.62,
          percent: 0,
          percentAVG: 0.0105,
          cellID: '5ccef3e9_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '5ccef3e9_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 943.42,
          perc: 0,
          percAvg: 0.0105,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 943.42,
          percent: 0,
          percentAVG: 0.0105,
          cellID: 'd4b5a9af_@_21_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'd4b5a9af_@_21',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'TOTAL NON-CONTROLLABLE EXPENSES',
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 5315.82,
          perc: 0,
          percAvg: 0.059,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 5315.82,
          percent: 0,
          percentAVG: 0.059,
          cellID: '1851dc59_@_22_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '1851dc59_@_22',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Operating Profit',
          path: ['Operating Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 36319.469999999994,
          amtAvg: 30802.179999999993,
          perc: 0.4031,
          percAvg: 0.3418,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 30802.179999999993,
          percent: 0.4031,
          percentAVG: 0.3418,
          cellID: '251b8ac6_@_23_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '251b8ac6_@_23',
          index: 3,
          cPercent: 0.4030806151907896,
        },
        {
          date: '2025-06-30',
          title: 'Other Expenses',
          path: ['Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: '5e10c38d_@_24_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '5e10c38d_@_24',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Loan Interest',
          path: ['Other Expenses', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '13e3a076_@_24_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '13e3a076_@_24',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Other Expenses',
          path: ['Total Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'caeb87a7_@_25_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'caeb87a7_@_25',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'EBITDA',
          path: ['EBITDA'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 36319.469999999994,
          amtAvg: 30802.179999999993,
          perc: 0.4031,
          percAvg: 0.3418,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 30802.179999999993,
          percent: 0.4031,
          percentAVG: 0.3418,
          cellID: 'e815a21e_@_26_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'e815a21e_@_26',
          index: 3,
          cPercent: 0.4030806151907896,
        },
        {
          date: '2025-06-30',
          title: 'Interest, Taxes, Depreciation and Amortization',
          path: ['Interest, Taxes, Depreciation and Amortization'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          cellID: '644555ee_@_27_-x-_4',
          baseAmount: 0,
          transactions: 0,
          id: '644555ee_@_27',
          index: 3,
        },
        {
          date: '2025-06-30',
          title: 'Loan Interest',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'dce93088_@_27_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'dce93088_@_27',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'Total Interest, Taxes, Depreciation and Amortization',
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          percent: 0,
          percentAVG: 0,
          cellID: 'b4184eff_@_28_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: 'b4184eff_@_28',
          index: 3,
          cPercent: 0,
        },
        {
          date: '2025-06-30',
          title: 'NET PROFIT',
          path: ['NET PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 36319.469999999994,
          amtAvg: 30802.179999999993,
          perc: 0.4031,
          percAvg: 0.3418,
          dataRows: [],
          reportId: '0bf2f58d-c8a1-4ce2-af8d-051f75007089',
          amountAVG: 30802.179999999993,
          percent: 0.4031,
          percentAVG: 0.3418,
          cellID: '9b50fa7c_@_29_-x-_4',
          baseAmount: 90104.73,
          transactions: 0,
          id: '9b50fa7c_@_29',
          index: 3,
          cPercent: 0.4030806151907896,
        },
      ],
      total: false,
      compoundColumn: false,
      isLocation: false,
      liveReport: false,
      periodReporting: false,
      periodID: '',
      consolidated: false,
      originType: 'Data',
    },
    {
      name: '2025-06-23',
      reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
      date: {
        start: '2025-06-23',
        end: '2025-06-29',
      },
      type: [
        {
          type: 'Data',
          index: 4,
        },
      ],
      data: [
        {
          date: '2025-06-23',
          title: 'SALES',
          path: ['SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          cellID: '5bc89b03_@_2_-x-_5',
          baseAmount: 0,
          transactions: 0,
          id: '5bc89b03_@_2',
          index: 4,
        },
        {
          date: '2025-06-23',
          title: 'Sales, Food',
          path: ['SALES', 'Sales, Food'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
          trxAnomaly: {
            anomalies: [8],
            anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
            stats: {
              mean: 7.2,
              variance: 0.15999999999999998,
              stdDev: 0.39999999999999997,
            },
          },
          trxFlagged: [],
          amount: 36991,
          perc: 0.5462,
          percAvg: 0.5462,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 2749,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 5498,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 3139.5,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 1993.5,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 4984.5,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 10957,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 7669.5,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.5462,
          percentAVG: 0.5462,
          cellID: 'c5601bf4_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 7,
          id: 'c5601bf4_@_2',
          index: 4,
          cPercent: 0.546184893132121,
        },
        {
          date: '2025-06-23',
          title: 'Sales, Liquor',
          path: ['SALES', 'Sales, Liquor'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18898,
          amtAvg: 18898,
          perc: 0.279,
          percAvg: 0.279,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 1230,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 1562,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 1105,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 1473,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 2132,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 7591.5,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 3804.5,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 18898,
          percent: 0.279,
          percentAVG: 0.279,
          cellID: 'e1ca5621_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 7,
          id: 'e1ca5621_@_2',
          index: 4,
          cPercent: 0.2790354981052371,
        },
        {
          date: '2025-06-23',
          title: 'Sales, Beer',
          path: ['SALES', 'Sales, Beer'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 14,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 6146,
          amtAvg: 6146,
          perc: 0.0907,
          percAvg: 0.0907,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 36,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 190,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 170,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 424,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 289,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 713,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 46,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 374,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 172,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 760,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 584,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 1482,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 173,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 733,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 6146,
          percent: 0.0907,
          percentAVG: 0.0907,
          cellID: 'ba0b0910_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 14,
          id: 'ba0b0910_@_2',
          index: 4,
          cPercent: 0.09074781306777369,
        },
        {
          date: '2025-06-23',
          title: 'Sales, Wine',
          path: ['SALES', 'Sales, Wine'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1513,
          amtAvg: 1513,
          perc: 0.0223,
          percAvg: 0.0223,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 211,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 197,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 135,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 56,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 227,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 587,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 100,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 1513,
          percent: 0.0223,
          percentAVG: 0.0223,
          cellID: '2f14959f_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 7,
          id: '2f14959f_@_2',
          index: 4,
          cPercent: 0.022339967649128146,
        },
        {
          date: '2025-06-23',
          title: 'Sales, Non-Alcoholic Beverage',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2884,
          amtAvg: 2884,
          perc: 0.0426,
          percAvg: 0.0426,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 260,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 554,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 349,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 104,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 302,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 743,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 572,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 2884,
          percent: 0.0426,
          percentAVG: 0.0426,
          cellID: '7bb557b1_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 7,
          id: '7bb557b1_@_2',
          index: 4,
          cPercent: 0.04258325624592569,
        },
        {
          date: '2025-06-23',
          title: 'Sales, Miscellaneous',
          path: ['SALES', 'Sales, Miscellaneous'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
            stats: {
              mean: 3.8,
              variance: 1.3599999999999999,
              stdDev: 1.16619037896906,
            },
          },
          trxFlagged: [],
          amount: 95,
          perc: 0.0014,
          percAvg: 0.0014,
          dataRows: [
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 30,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 65,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0014,
          percentAVG: 0.0014,
          cellID: 'cbede411_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 2,
          id: 'cbede411_@_2',
          index: 4,
          cPercent: 0.0014027078167000487,
        },
        {
          date: '2025-06-23',
          title: 'Sales, Service Charges',
          path: ['SALES', 'Sales, Service Charges'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1199.15,
          perc: 0.0177,
          percAvg: 0.0177,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 70.38,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 158.55,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 128.45,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 82.3,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 152.85,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 417.11,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 189.51,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0177,
          percentAVG: 0.0177,
          cellID: '4e12e939_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 7,
          id: '4e12e939_@_2',
          index: 4,
          cPercent: 0.017705863983114353,
        },
        {
          date: '2025-06-23',
          title: 'Sales - No category',
          path: ['SALES', 'Sales - No category'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'a1f04b4c_@_2_-x-_5',
          baseAmount: 67726.15,
          transactions: 0,
          id: 'a1f04b4c_@_2',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'GROSS SALES',
          path: ['GROSS SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 67726.15,
          amtAvg: 67726.15,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 67726.15,
          cellID: '74405d1a_@_3_-x-_5',
          baseAmount: 67726.15,
          transactions: 0,
          id: '74405d1a_@_3',
          index: 4,
        },
        {
          date: '2025-06-23',
          title: 'Comps & Discounts',
          path: ['Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'ba9fcd64_@_6_-x-_5',
          baseAmount: 67726.15,
          transactions: 0,
          id: 'ba9fcd64_@_6',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Discounts and Comps',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1294,
          perc: -0.0191,
          percAvg: -0.0191,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: -177,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: -241.75,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: -145,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: -96.25,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: -183,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: -381,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: -70,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: -0.0191,
          percentAVG: -0.0191,
          cellID: '4936addc_@_6_-x-_5',
          baseAmount: 67726.15,
          transactions: 7,
          id: '4936addc_@_6',
          index: 4,
          cPercent: -0.01910635699799856,
        },
        {
          date: '2025-06-23',
          title: 'Total Comps & Discounts',
          path: ['Total Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1294,
          amtAvg: -1294,
          perc: -0.0191,
          percAvg: -0.0191,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: -1294,
          percent: -0.0191,
          percentAVG: -0.0191,
          cellID: '8a448d4b_@_7_-x-_5',
          baseAmount: 67726.15,
          transactions: 0,
          id: '8a448d4b_@_7',
          index: 4,
          cPercent: -0.01910635699799856,
        },
        {
          date: '2025-06-23',
          title: 'NET SALES',
          path: ['NET SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 66432.15,
          amtAvg: 66432.15,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 66432.15,
          cellID: '3b5cefb1_@_8_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '3b5cefb1_@_8',
          index: 4,
        },
        {
          date: '2025-06-23',
          title: 'COST OF GOODS SOLD (COGS)',
          path: ['COST OF GOODS SOLD (COGS)'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          cellID: '753db221_@_9_-x-_5',
          baseAmount: 0,
          transactions: 0,
          id: '753db221_@_9',
          index: 4,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Food',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          baseRef: 'Sales, Food',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.4,
              variance: 1.4400000000000002,
              stdDev: 1.2000000000000002,
            },
          },
          trxFlagged: [],
          amount: 754.18,
          perc: 0.0204,
          percAvg: 0.0204,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14556',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 271.63,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14557',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 135.12,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14753',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 331.44,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14879',
              num: 'Uber eats ADJ P6.25',
              name: '',
              description: 'Refund',
              amount: 15.99,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0204,
          percentAVG: 0.0204,
          cellID: '7a94d93b_@_9_-x-_5',
          baseAmount: 36991,
          transactions: 4,
          id: '7a94d93b_@_9',
          index: 4,
          cPercent: 0.020388202535751937,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Meat & Poultry',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
            stats: {
              mean: 3.8,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 3526.27,
          perc: 0.0531,
          percAvg: 0.0531,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 1083.72,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 1700.37,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 742.18,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0531,
          percentAVG: 0.0531,
          cellID: '3f46fcce_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: '3f46fcce_@_9',
          index: 4,
          cPercent: 0.05308077489589002,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Seafood',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 0.96,
              stdDev: 0.9797958971132712,
            },
          },
          trxFlagged: [],
          amount: 526.36,
          perc: 0.0079,
          percAvg: 0.0079,
          dataRows: [
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 174.66,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 351.7,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0079,
          percentAVG: 0.0079,
          cellID: '2bdeb0ad_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 2,
          id: '2bdeb0ad_@_9',
          index: 4,
          cPercent: 0.007923272090395991,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Produce',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
            stats: {
              mean: 7.4,
              variance: 12.24,
              stdDev: 3.4985711369071804,
            },
          },
          trxFlagged: [],
          amount: 530.45,
          perc: 0.008,
          percAvg: 0.008,
          dataRows: [
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14852',
              num: '6502071',
              name: 'Avanti Produce',
              description: 'CHECK 6502071',
              amount: 530.45,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.008,
          percentAVG: 0.008,
          cellID: '593c4b13_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '593c4b13_@_9',
          index: 4,
          cPercent: 0.00798483866621809,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Grocery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
          trxAnomaly: {
            anomalies: [11],
            anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
            stats: {
              mean: 7.6,
              variance: 4.24,
              stdDev: 2.0591260281974,
            },
          },
          trxFlagged: [],
          amount: 7899.17,
          perc: 0.1189,
          percAvg: 0.1189,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 639.73,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14604',
              num: '',
              name: 'The Webstaurant Store',
              description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
              amount: 875.95,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 481.65,
            },
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14860',
              num: '6502089',
              name: 'Performance Food Service',
              description: 'CHECK 6502089',
              amount: 5204.19,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 659.19,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14887',
              num: '',
              name: 'ShopRite',
              description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
              amount: 38.46,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.1189,
          percentAVG: 0.1189,
          cellID: 'e0037727_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 6,
          id: 'e0037727_@_9',
          index: 4,
          cPercent: 0.11890583098695437,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Bakery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 1630.48,
          perc: 0.0245,
          percAvg: 0.0245,
          dataRows: [
            {
              txnDate: '2025-06-24',
              type: 'Expense',
              eventId: '14598',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 260.58,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14830',
              num: '',
              name: 'David Rosen Bakery Supply Co',
              description: 'VISA DDA PUR AP - 445351     DAVID ROSEN                 718 381 0600  * NY',
              amount: 1369.9,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0245,
          percentAVG: 0.0245,
          cellID: '47294ea3_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 2,
          id: '47294ea3_@_9',
          index: 4,
          cPercent: 0.02454353803090823,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Dairy',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
          trxAnomaly: {
            anomalies: [7],
            anomalyScores: [0.82915619758885, 0, 0, 0, 0],
            stats: {
              mean: 4.8,
              variance: 1.7600000000000002,
              stdDev: 1.32664991614216,
            },
          },
          trxFlagged: [],
          amount: 927.54,
          perc: 0.014,
          percAvg: 0.014,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 185.11,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 197.79,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 544.64,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.014,
          percentAVG: 0.014,
          cellID: '841fc412_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: '841fc412_@_9',
          index: 4,
          cPercent: 0.01396221558387016,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Liquor',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          baseRef: 'Sales, Liquor',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
          trxAnomaly: {
            anomalies: [10],
            anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
            stats: {
              mean: 4.8,
              variance: 7.76,
              stdDev: 2.7856776554368237,
            },
          },
          trxFlagged: [],
          amount: 2208.19,
          amtAvg: 2208.19,
          perc: 0.1168,
          percAvg: 0.1168,
          dataRows: [
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14859',
              num: '6502093',
              name: 'Fedway',
              description: 'CHECK 6502093',
              amount: 1000,
            },
            {
              txnDate: '2025-06-26',
              type: 'Check',
              eventId: '14880',
              num: '6502094',
              name: 'Allied Beverages',
              description: 'CHECK 6502094',
              amount: 1208.19,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 2208.19,
          percent: 0.1168,
          percentAVG: 0.1168,
          cellID: '6eb26171_@_9_-x-_5',
          baseAmount: 18898,
          transactions: 2,
          id: '6eb26171_@_9',
          index: 4,
          cPercent: 0.11684781458355382,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Bar Groceries',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.9600000000000002,
              stdDev: 0.9797958971132713,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '15101cdc_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '15101cdc_@_9',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          baseRef: 'Sales, Beer',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          cellID: '90be8534_@_9_-x-_5',
          baseAmount: 6146,
          transactions: 0,
          id: '90be8534_@_9',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Draught Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 4.960000000000001,
              stdDev: 2.227105745132009,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '3395a498_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '3395a498_@_9',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Bottled Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'e2c4f57e_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'e2c4f57e_@_9',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Wine',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          baseRef: 'Sales, Wine',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2.4,
              variance: 1.8399999999999999,
              stdDev: 1.3564659966250536,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'b29ce542_@_9_-x-_5',
          baseAmount: 1513,
          transactions: 0,
          id: 'b29ce542_@_9',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Non-Alcoholic',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0, 0.784464540552736, 0, 0],
            stats: {
              mean: 4.4,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 78.71,
          amtAvg: 78.71,
          perc: 0.0012,
          percAvg: 0.0012,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 49.91,
            },
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '15211',
              num: '6502076',
              name: 'Peerless Beverage',
              description: '',
              amount: 3.75,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 25.05,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 78.71,
          percent: 0.0012,
          percentAVG: 0.0012,
          cellID: '9f08e50d_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: '9f08e50d_@_9',
          index: 4,
          cPercent: 0.0011848178931436058,
        },
        {
          date: '2025-06-23',
          title: 'COGS, Packaging',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
          trxAnomaly: {
            anomalies: [1, 3],
            anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
            stats: {
              mean: 2,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 362.11,
          perc: 0.0055,
          percAvg: 0.0055,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 94.73,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 128.73,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 138.65,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0055,
          percentAVG: 0.0055,
          cellID: '027a424d_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: '027a424d_@_9',
          index: 4,
          cPercent: 0.005450824638371632,
        },
        {
          date: '2025-06-23',
          title: 'Shipping, Freight and Delivery',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          cellID: 'dfae81d5_@_9_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'dfae81d5_@_9',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'TOTAL COGS',
          path: ['TOTAL COGS'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18443.46,
          amtAvg: 18443.46,
          perc: 0.2776,
          percAvg: 0.2776,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 18443.46,
          percent: 0.2776,
          percentAVG: 0.2776,
          cellID: '528a97f9_@_10_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '528a97f9_@_10',
          index: 4,
          cPercent: 0.2776285277535049,
        },
        {
          date: '2025-06-23',
          title: 'GROSS PROFIT',
          path: ['GROSS PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 47988.689999999995,
          amtAvg: 47988.689999999995,
          perc: 0.7224,
          percAvg: 0.7224,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 47988.689999999995,
          percent: 0.7224,
          percentAVG: 0.7224,
          cellID: '7b400e74_@_12_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '7b400e74_@_12',
          index: 4,
          cPercent: 0.7223714722464951,
        },
        {
          date: '2025-06-23',
          title: 'OPERATING EXPENSES',
          path: ['OPERATING EXPENSES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 28777.91,
          amtAvg: 28777.91,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 28777.91,
          cellID: '39d9c4d4_@_13_-x-_5',
          baseAmount: 28777.91,
          transactions: 0,
          id: '39d9c4d4_@_13',
          index: 4,
        },
        {
          date: '2025-06-23',
          title: 'LABOR',
          path: ['LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '5b0fe671_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '5b0fe671_@_14',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Direct Labor',
          path: ['LABOR', 'Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'bb2363da_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'bb2363da_@_14',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Labor Other',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 30,
              variance: 456.4,
              stdDev: 21.36352030916253,
            },
          },
          trxFlagged: [],
          amount: 5477.44,
          perc: 0.0825,
          percAvg: 0.0825,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14674',
              num: '6502081',
              name: 'Anthony Sanchez',
              description: 'CHECK 6502081',
              amount: 489.65,
            },
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14680',
              num: '6502083',
              name: 'Isabella Devine',
              description: 'CHECK 6502083 06/02 - 06/08',
              amount: 128.64,
            },
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14858',
              num: '6502091',
              name: 'Omar Lopez',
              description: 'CHECK 6502091',
              amount: 559.15,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'Other',
              amount: 4300,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0825,
          percentAVG: 0.0825,
          cellID: '687f4cd2_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 4,
          id: '687f4cd2_@_14',
          index: 4,
          cPercent: 0.08245164427163655,
        },
        {
          date: '2025-06-23',
          title: 'Labor, Management',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1620,
          perc: 0.0244,
          percAvg: 0.0244,
          dataRows: [
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'Management',
              amount: 1620,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0244,
          percentAVG: 0.0244,
          cellID: '529343c4_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '529343c4_@_14',
          index: 4,
          cPercent: 0.024385783088459432,
        },
        {
          date: '2025-06-23',
          title: 'Labor, BOH',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1711.54,
          perc: 0.0258,
          percAvg: 0.0258,
          dataRows: [
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0258,
          percentAVG: 0.0258,
          cellID: '3c61733f_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '3c61733f_@_14',
          index: 4,
          cPercent: 0.025763730362482626,
        },
        {
          date: '2025-06-23',
          title: 'Total Direct Labor',
          path: ['LABOR', 'Total Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 8808.98,
          amtAvg: 8808.98,
          perc: 0.1326,
          percAvg: 0.1326,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 8808.98,
          percent: 0.1326,
          percentAVG: 0.1326,
          cellID: '143a84db_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '143a84db_@_14',
          index: 4,
          cPercent: 0.1326011577225786,
        },
        {
          date: '2025-06-23',
          title: 'Labor Related Expenses',
          path: ['LABOR', 'Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'dacf6533_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'dacf6533_@_14',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Commission/Bonus/Incentives',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 268,
          perc: 0.004,
          percAvg: 0.004,
          dataRows: [
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'comission',
              amount: 268,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.004,
          percentAVG: 0.004,
          cellID: '7a82e4de_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '7a82e4de_@_14',
          index: 4,
          cPercent: 0.004034191276362425,
        },
        {
          date: '2025-06-23',
          title: 'Payroll Taxes',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 238.76,
          perc: 0.0036,
          percAvg: 0.0036,
          dataRows: [
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'PR Tax',
              amount: 238.76,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0036,
          percentAVG: 0.0036,
          cellID: 'bbc14e9c_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'bbc14e9c_@_14',
          index: 4,
          cPercent: 0.003594042944568255,
        },
        {
          date: '2025-06-23',
          title: 'Employee Meals',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 774,
          perc: 0.0117,
          percAvg: 0.0117,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14675',
              num: '650204',
              name: 'Eileen Kim',
              description: 'CHECK 650204 Reimbursement',
              amount: 774,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0117,
          percentAVG: 0.0117,
          cellID: '416bc276_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '416bc276_@_14',
          index: 4,
          cPercent: 0.011650985253375061,
        },
        {
          date: '2025-06-23',
          title: 'Recruiting',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'c12aec10_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'c12aec10_@_14',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Total Labor Related Expenses',
          path: ['LABOR', 'Total Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1280.76,
          amtAvg: 1280.76,
          perc: 0.0193,
          percAvg: 0.0193,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 1280.76,
          percent: 0.0193,
          percentAVG: 0.0193,
          cellID: '1e9ad256_@_14_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '1e9ad256_@_14',
          index: 4,
          cPercent: 0.01927921947430574,
        },
        {
          date: '2025-06-23',
          title: 'TOTAL LABOR',
          path: ['TOTAL LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 10089.74,
          amtAvg: 10089.74,
          perc: 0.1519,
          percAvg: 0.1519,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 10089.74,
          percent: 0.1519,
          percentAVG: 0.1519,
          cellID: 'd0736ae7_@_15_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'd0736ae7_@_15',
          index: 4,
          cPercent: 0.15188037719688435,
        },
        {
          date: '2025-06-23',
          title: 'PRIME COST',
          path: ['PRIME COST'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 28533.199999999997,
          amtAvg: 28533.199999999997,
          perc: 0.4295,
          percAvg: 0.4295,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 28533.199999999997,
          percent: 0.4295,
          percentAVG: 0.4295,
          cellID: 'b7d061ce_@_16_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'b7d061ce_@_16',
          index: 4,
          cPercent: 0.42950890495038924,
        },
        {
          date: '2025-06-23',
          title: 'Contribution Margin',
          path: ['Contribution Margin'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 37898.95,
          amtAvg: 37898.95,
          perc: 0.5705,
          percAvg: 0.5705,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 37898.95,
          percent: 0.5705,
          percentAVG: 0.5705,
          cellID: '2f5a4d68_@_17_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '2f5a4d68_@_17',
          index: 4,
          cPercent: 0.5704910950496108,
        },
        {
          date: '2025-06-23',
          title: 'CONTROLLABLE EXPENSES',
          path: ['CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '2cd659af_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '2cd659af_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '3be3d09b_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '3be3d09b_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Equipment Lease Rental',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '1a6a3f76_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '1a6a3f76_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Cleaning Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
            stats: {
              mean: 2.2,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 174.1,
          perc: 0.0026,
          percAvg: 0.0026,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 65.4,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 74,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 34.7,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0026,
          percentAVG: 0.0026,
          cellID: '514ec7ed_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: '514ec7ed_@_18',
          index: 4,
          cPercent: 0.0026207190343832017,
        },
        {
          date: '2025-06-23',
          title: 'Cleaning Services',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '758ae475_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '758ae475_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Restaurant Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 371.63,
          perc: 0.0056,
          percAvg: 0.0056,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 80.19,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 166.11,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 125.33,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0056,
          percentAVG: 0.0056,
          cellID: '28a2ce1f_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: '28a2ce1f_@_18',
          index: 4,
          cPercent: 0.005594128746397641,
        },
        {
          date: '2025-06-23',
          title: 'Laundry, Linens, & Uniforms',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16,
              stdDev: 0.4,
            },
          },
          trxFlagged: [],
          amount: 1954.31,
          perc: 0.0294,
          percAvg: 0.0294,
          dataRows: [
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14886',
              num: '',
              name: 'Sartor NYC',
              description: 'VISA DDA PUR AP - 469216     SQ  SARTOR INC              NEW YORK      * NY',
              amount: 1954.31,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0294,
          percentAVG: 0.0294,
          cellID: 'ad6ac922_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'ad6ac922_@_18',
          index: 4,
          cPercent: 0.02941813564667108,
        },
        {
          date: '2025-06-23',
          title: 'Kitchen/ Bar Smallwares',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1598.17,
          perc: 0.0241,
          percAvg: 0.0241,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14590',
              num: '',
              name: 'Crate & Barrel',
              description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
              amount: 631.25,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14591',
              num: '',
              name: 'Crate & Barrel',
              description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
              amount: 546.8,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14592',
              num: '',
              name: 'Crate & Barrel',
              description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
              amount: 420.12,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0241,
          percentAVG: 0.0241,
          cellID: '9f991141_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: '9f991141_@_18',
          index: 4,
          cPercent: 0.02405717713486618,
        },
        {
          date: '2025-06-23',
          title: 'Total Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4098.21,
          amtAvg: 4098.21,
          perc: 0.0617,
          percAvg: 0.0617,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 4098.21,
          percent: 0.0617,
          percentAVG: 0.0617,
          cellID: 'b7f8c8b8_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'b7f8c8b8_@_18',
          index: 4,
          cPercent: 0.0616901605623181,
        },
        {
          date: '2025-06-23',
          title: 'Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '9d0fd7d1_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '9d0fd7d1_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: '3rd Party Commissions',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '47bbbb15_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '47bbbb15_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Total Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'd484c66b_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'd484c66b_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'edd65db2_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'edd65db2_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Marketing & Public Relations',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 210.8,
          perc: 0.0032,
          percAvg: 0.0032,
          dataRows: [
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14850',
              num: '',
              name: 'GO DADDY.COM',
              description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0986      480 5058855   * AZ',
              amount: 210.8,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0032,
          percentAVG: 0.0032,
          cellID: 'c61b398a_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'c61b398a_@_18',
          index: 4,
          cPercent: 0.0031731623920044742,
        },
        {
          date: '2025-06-23',
          title: 'Advertising & Promotions',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
            stats: {
              mean: 1.8,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 370,
          perc: 0.0056,
          percAvg: 0.0056,
          dataRows: [
            {
              txnDate: '2025-06-24',
              type: 'Expense',
              eventId: '14558',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  KR7KAXUUK2          650 5434800   * CA',
              amount: 262,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14879',
              num: 'Uber eats ADJ P6.25',
              name: '',
              description: 'Sum of Merchant promotions applied to the order',
              amount: 108,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0056,
          percentAVG: 0.0056,
          cellID: '1dc3b3a3_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 2,
          id: '1dc3b3a3_@_18',
          index: 4,
          cPercent: 0.005569592433783944,
        },
        {
          date: '2025-06-23',
          title: 'Total Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 580.8,
          amtAvg: 580.8,
          perc: 0.0087,
          percAvg: 0.0087,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 580.8,
          percent: 0.0087,
          percentAVG: 0.0087,
          cellID: '024ba9eb_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '024ba9eb_@_18',
          index: 4,
          cPercent: 0.008742754825788417,
        },
        {
          date: '2025-06-23',
          title: 'Music & DJ',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 500,
          perc: 0.0075,
          percAvg: 0.0075,
          dataRows: [
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14857',
              num: '6502092',
              name: 'YNVS Media LLC',
              description: 'POD CHECK',
              amount: 500,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0075,
          percentAVG: 0.0075,
          cellID: '0c83dbac_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '0c83dbac_@_18',
          index: 4,
          cPercent: 0.007526476261870195,
        },
        {
          date: '2025-06-23',
          title: 'General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '6f7c6ca5_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '6f7c6ca5_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Accounting & Bookkeeping',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          cellID: '5a0fedcf_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '5a0fedcf_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Consulting',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1250,
          perc: 0.0188,
          percAvg: 0.0188,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14676',
              num: '6502084',
              name: 'Shaun Rose',
              description: 'CHECK 6502084',
              amount: 1250,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0188,
          percentAVG: 0.0188,
          cellID: 'b08821c2_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'b08821c2_@_18',
          index: 4,
          cPercent: 0.018816190654675487,
        },
        {
          date: '2025-06-23',
          title: 'Legal',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 1806.54,
          perc: 0.0272,
          percAvg: 0.0272,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14679',
              num: '6502064',
              name: 'Matthew J Keating Attorney',
              description: 'CHECK 6502064',
              amount: 1806.54,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0272,
          percentAVG: 0.0272,
          cellID: 'a630ac37_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'a630ac37_@_18',
          index: 4,
          cPercent: 0.02719376085223796,
        },
        {
          date: '2025-06-23',
          title: 'Payroll Processing Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '975961bc_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '975961bc_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Computer Supplies, Software & IT',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '9450bb96_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '9450bb96_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Dues and Subscriptions',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '236c5723_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '236c5723_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Bank Charges & Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.8400000000000003,
              stdDev: 1.3564659966250538,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'c3c23383_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'c3c23383_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Office Supplies & Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
            stats: {
              mean: 8.2,
              variance: 15.36,
              stdDev: 3.919183588453085,
            },
          },
          trxFlagged: [],
          amount: 1110.12,
          perc: 0.0167,
          percAvg: 0.0167,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14548',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 21.3,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14594',
              num: '',
              name: 'The Home Depot',
              description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
              amount: 127.91,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14596',
              num: '',
              name: 'CVS Pharmacy',
              description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
              amount: 771.5,
            },
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14565',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 46.04,
            },
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14566',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 15.98,
            },
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14567',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 6.39,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14732',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 23.35,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14733',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 42.64,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14726',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 7.85,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14734',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 19.18,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14735',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 27.98,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0167,
          percentAVG: 0.0167,
          cellID: '058d9b25_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 11,
          id: '058d9b25_@_18',
          index: 4,
          cPercent: 0.016710583655654677,
        },
        {
          date: '2025-06-23',
          title: 'Phone and Internet',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 334.99,
          perc: 0.005,
          percAvg: 0.005,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14595',
              num: '',
              name: 'DirecTV',
              description: 'VISA DDA PUR AP - 469216     SPI DIRECTV SERVICE         800 531 5000  * CA',
              amount: 334.99,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.005,
          percentAVG: 0.005,
          cellID: '0c2b505e_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '0c2b505e_@_18',
          index: 4,
          cPercent: 0.005042588565927793,
        },
        {
          date: '2025-06-23',
          title: 'Security',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 950,
          perc: 0.0143,
          percAvg: 0.0143,
          dataRows: [
            {
              txnDate: '2025-06-27',
              type: 'Check',
              eventId: '14881',
              num: '6502082',
              name: 'Herve Bertrand',
              description: 'CHECK 6502082 Security',
              amount: 950,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0143,
          percentAVG: 0.0143,
          cellID: '9dc533d9_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '9dc533d9_@_18',
          index: 4,
          cPercent: 0.01430030489755337,
        },
        {
          date: '2025-06-23',
          title: 'Total General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 5451.65,
          amtAvg: 5451.65,
          perc: 0.0821,
          percAvg: 0.0821,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 5451.65,
          percent: 0.0821,
          percentAVG: 0.0821,
          cellID: 'f12db2ec_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'f12db2ec_@_18',
          index: 4,
          cPercent: 0.08206342862604929,
        },
        {
          date: '2025-06-23',
          title: 'Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '084f517c_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '084f517c_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Travel, Ground Transport & Airfare',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 176.49,
          perc: 0.0027,
          percAvg: 0.0027,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14581',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 68.96,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14765',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 50.66,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14841',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 56.87,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0027,
          percentAVG: 0.0027,
          cellID: 'e4e1ab18_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 3,
          id: 'e4e1ab18_@_18',
          index: 4,
          cPercent: 0.0026566955909149413,
        },
        {
          date: '2025-06-23',
          title: 'Meals & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 89.97,
          perc: 0.0014,
          percAvg: 0.0014,
          dataRows: [
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14603',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 89.97,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0014,
          percentAVG: 0.0014,
          cellID: 'f245aeff_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'f245aeff_@_18',
          index: 4,
          cPercent: 0.0013543141385609228,
        },
        {
          date: '2025-06-23',
          title: 'Parking',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1238,
          perc: 0.0186,
          percAvg: 0.0186,
          dataRows: [
            {
              txnDate: '2025-06-24',
              type: 'Expense',
              eventId: '14579',
              num: '',
              name: 'Hoboken Parking',
              description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
              amount: 1238,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0186,
          percentAVG: 0.0186,
          cellID: '3ae4b332_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '3ae4b332_@_18',
          index: 4,
          cPercent: 0.0186355552243906,
        },
        {
          date: '2025-06-23',
          title: 'Fuel',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 57.11,
          perc: 0.0009,
          percAvg: 0.0009,
          dataRows: [
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14833',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 475542     FUEL 4 GAS AND DIESEL       SECAUCUS      * NJ',
              amount: 30.1,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14831',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 27.01,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0009,
          percentAVG: 0.0009,
          cellID: '4dbd49a9_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 2,
          id: '4dbd49a9_@_18',
          index: 4,
          cPercent: 0.0008596741186308137,
        },
        {
          date: '2025-06-23',
          title: 'Total Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1561.57,
          amtAvg: 1561.57,
          perc: 0.0235,
          percAvg: 0.0235,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 1561.57,
          percent: 0.0235,
          percentAVG: 0.0235,
          cellID: 'ea7ffa49_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'ea7ffa49_@_18',
          index: 4,
          cPercent: 0.023506239072497277,
        },
        {
          date: '2025-06-23',
          title: 'Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '1675dbe8_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '1675dbe8_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Repair & Maintenance, Equipment',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 3479,
          perc: 0.0524,
          percAvg: 0.0524,
          dataRows: [
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14854',
              num: '6502073',
              name: 'AZ Mechanical',
              description: 'CHECK 6502073 MS HVAC',
              amount: 3479,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0524,
          percentAVG: 0.0524,
          cellID: 'aa06968c_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'aa06968c_@_18',
          index: 4,
          cPercent: 0.052369221830092814,
        },
        {
          date: '2025-06-23',
          title: 'Repair & Maintenance, Facility',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
            stats: {
              mean: 1,
              variance: 1.2,
              stdDev: 1.0954451150103321,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          cellID: '4d40af10_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '4d40af10_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Pest Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1137.35,
          perc: 0.0171,
          percAvg: 0.0171,
          dataRows: [
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14851',
              num: '650103',
              name: 'Liberty Pest',
              description: 'CHECK 650103 1170053',
              amount: 505.49,
            },
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14855',
              num: '65014',
              name: 'Liberty Pest',
              description: 'CHECK 65014 1185730',
              amount: 631.86,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0171,
          percentAVG: 0.0171,
          cellID: 'a044faba_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 2,
          id: 'a044faba_@_18',
          index: 4,
          cPercent: 0.01712047555287613,
        },
        {
          date: '2025-06-23',
          title: 'Fire Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'd6450b86_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'd6450b86_@_18',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Total Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4616.35,
          amtAvg: 4616.35,
          perc: 0.0695,
          percAvg: 0.0695,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 4616.35,
          percent: 0.0695,
          percentAVG: 0.0695,
          cellID: '4da1092f_@_18_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '4da1092f_@_18',
          index: 4,
          cPercent: 0.06948969738296895,
        },
        {
          date: '2025-06-23',
          title: 'TOTAL CONTROLLABLE EXPENSES',
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 16808.58,
          amtAvg: 16808.58,
          perc: 0.253,
          percAvg: 0.253,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 16808.58,
          percent: 0.253,
          percentAVG: 0.253,
          cellID: 'a624f257_@_19_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'a624f257_@_19',
          index: 4,
          cPercent: 0.25301875673149227,
        },
        {
          date: '2025-06-23',
          title: 'Controllable Profit',
          path: ['Controllable Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 21090.369999999995,
          amtAvg: 21090.369999999995,
          perc: 0.3175,
          percAvg: 0.3175,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 21090.369999999995,
          percent: 0.3175,
          percentAVG: 0.3175,
          cellID: 'a973b710_@_20_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'a973b710_@_20',
          index: 4,
          cPercent: 0.3174723383181185,
        },
        {
          date: '2025-06-23',
          title: 'NON-CONTROLLABLE EXPENSES',
          path: ['NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '79208dfc_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '79208dfc_@_21',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '52e26b6b_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '52e26b6b_@_21',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Rent/Lease',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '68876c4f_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '68876c4f_@_21',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Utility, Electricity',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '208dfabc_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '208dfabc_@_21',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Utility, Gas',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 430.96,
          perc: 0.0065,
          percAvg: 0.0065,
          dataRows: [
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '15215',
              num: '80547688',
              name: 'NuCO2',
              description: '',
              amount: 430.96,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0065,
          percentAVG: 0.0065,
          cellID: 'c9446d9c_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: 'c9446d9c_@_21',
          index: 4,
          cPercent: 0.006487220419631158,
        },
        {
          date: '2025-06-23',
          title: 'Total Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 430.96,
          amtAvg: 430.96,
          perc: 0.0065,
          percAvg: 0.0065,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 430.96,
          percent: 0.0065,
          percentAVG: 0.0065,
          cellID: '20d5762f_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '20d5762f_@_21',
          index: 4,
          cPercent: 0.006487220419631158,
        },
        {
          date: '2025-06-23',
          title: 'Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '763b7c77_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '763b7c77_@_21',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Other Income/Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '91f38f9a_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '91f38f9a_@_21',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'To Be Classified P&L',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.56,
              stdDev: 0.7483314773547883,
            },
          },
          trxFlagged: [],
          amount: 1448.63,
          perc: 0.0218,
          percAvg: 0.0218,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14677',
              num: '6502078',
              name: 'David Conte',
              description: 'CHECK 6502078',
              amount: 1448.63,
            },
          ],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0.0218,
          percentAVG: 0.0218,
          cellID: '5ccef3e9_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 1,
          id: '5ccef3e9_@_21',
          index: 4,
          cPercent: 0.021806158614466043,
        },
        {
          date: '2025-06-23',
          title: 'Total Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1448.63,
          amtAvg: 1448.63,
          perc: 0.0218,
          percAvg: 0.0218,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 1448.63,
          percent: 0.0218,
          percentAVG: 0.0218,
          cellID: 'd4b5a9af_@_21_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'd4b5a9af_@_21',
          index: 4,
          cPercent: 0.021806158614466043,
        },
        {
          date: '2025-06-23',
          title: 'TOTAL NON-CONTROLLABLE EXPENSES',
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1879.5900000000001,
          amtAvg: 1879.5900000000001,
          perc: 0.0283,
          percAvg: 0.0283,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 1879.5900000000001,
          percent: 0.0283,
          percentAVG: 0.0283,
          cellID: '1851dc59_@_22_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '1851dc59_@_22',
          index: 4,
          cPercent: 0.0282933790340972,
        },
        {
          date: '2025-06-23',
          title: 'Operating Profit',
          path: ['Operating Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 19210.779999999995,
          amtAvg: 19210.779999999995,
          perc: 0.2892,
          percAvg: 0.2892,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 19210.779999999995,
          percent: 0.2892,
          percentAVG: 0.2892,
          cellID: '251b8ac6_@_23_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '251b8ac6_@_23',
          index: 4,
          cPercent: 0.2891789592840213,
        },
        {
          date: '2025-06-23',
          title: 'Other Expenses',
          path: ['Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: '5e10c38d_@_24_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '5e10c38d_@_24',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Loan Interest',
          path: ['Other Expenses', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '13e3a076_@_24_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '13e3a076_@_24',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Total Other Expenses',
          path: ['Total Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'caeb87a7_@_25_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'caeb87a7_@_25',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'EBITDA',
          path: ['EBITDA'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 19210.779999999995,
          amtAvg: 19210.779999999995,
          perc: 0.2892,
          percAvg: 0.2892,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 19210.779999999995,
          percent: 0.2892,
          percentAVG: 0.2892,
          cellID: 'e815a21e_@_26_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'e815a21e_@_26',
          index: 4,
          cPercent: 0.2891789592840213,
        },
        {
          date: '2025-06-23',
          title: 'Interest, Taxes, Depreciation and Amortization',
          path: ['Interest, Taxes, Depreciation and Amortization'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          cellID: '644555ee_@_27_-x-_5',
          baseAmount: 0,
          transactions: 0,
          id: '644555ee_@_27',
          index: 4,
        },
        {
          date: '2025-06-23',
          title: 'Loan Interest',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'dce93088_@_27_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'dce93088_@_27',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'Total Interest, Taxes, Depreciation and Amortization',
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          percent: 0,
          percentAVG: 0,
          cellID: 'b4184eff_@_28_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: 'b4184eff_@_28',
          index: 4,
          cPercent: 0,
        },
        {
          date: '2025-06-23',
          title: 'NET PROFIT',
          path: ['NET PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 19210.779999999995,
          amtAvg: 19210.779999999995,
          perc: 0.2892,
          percAvg: 0.2892,
          dataRows: [],
          reportId: '6a45af48-afaf-4614-99e3-aaf7218ac6e8',
          amountAVG: 19210.779999999995,
          percent: 0.2892,
          percentAVG: 0.2892,
          cellID: '9b50fa7c_@_29_-x-_5',
          baseAmount: 66432.15,
          transactions: 0,
          id: '9b50fa7c_@_29',
          index: 4,
          cPercent: 0.2891789592840213,
        },
      ],
      total: false,
      compoundColumn: false,
      isLocation: false,
      liveReport: false,
      periodReporting: false,
      periodID: '',
      consolidated: false,
      originType: 'Data',
    },
  ],
  renderableColumns: 5,
  locations: [
    {
      id: '5e433b2d-17d4-4d7f-b0b3-31513cbc4a75',
      name: 'Ainsworth Hoboken',
      reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
    },
  ],
  budgetAvailable: false,
  totalColumn: false,
  difference: false,
  liveReport: -1,
  multiLocation: false,
  consolidated: false,
  periodReporting: false,
  periodTitles: null,
  utilityData: {
    totalColumn: {
      name: 'Total',
      date: {
        start: '∑ Total',
        end: '',
      },
      type: [
        {
          type: 'Direct',
          index: 0,
        },
      ],
      data: [
        {
          date: '2025-07-21',
          title: 'SALES',
          path: ['SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '5bc89b03_@_2_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '5bc89b03_@_2',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Food',
          path: ['SALES', 'Sales, Food'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
          trxAnomaly: {
            anomalies: [8],
            anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
            stats: {
              mean: 7.2,
              variance: 0.15999999999999998,
              stdDev: 0.39999999999999997,
            },
          },
          trxFlagged: [],
          amount: 203897.68,
          perc: 0.5278,
          percAvg: 0.5278,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 4814.5,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 4276,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 4525,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 3727,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 3850,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 12032.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 6898,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 2311,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 3859,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 2662,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 2951,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 7307.5,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 11975.51,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 6607.5,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 3404.5,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 2043.5,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 2980,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 3034,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 5745,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 11703,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 10735,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 3223,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '15308',
              num: 'Strip sale P6.25',
              name: '',
              description: '',
              amount: 5883.17,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 3494,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 2415.5,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 5198,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 9323.5,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 10915,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 9013,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 2749,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 5498,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 3139.5,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 1993.5,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 4984.5,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 10957,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 7669.5,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.5419623006308921,
          percentAVG: 0.5278,
          cellID: 'c5601bf4_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 36,
          id: 'c5601bf4_@_2',
          index: 0,
          cPercent: 0.5277632430125925,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Liquor',
          path: ['SALES', 'Sales, Liquor'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [
            {
              id: 'f5f466b6-1069-4f73-b141-8e3c89f3fe16',
              index: 6,
              account: '4110 Revenue / Sales:Sales, Liquor',
              type: 'trx',
              status: 'inProgress',
              period: '2025-07-23',
              createdAt: '2025-07-29 16:09:56',
              amount: 1629,
              transaction: {
                id: 'e252f492-4b2a-4e34-a610-4f77c5f721e1',
                memo: '',
                name: '',
                trxType: 'Journal Entry',
              },
            },
          ],
          amount: 104478.51999999999,
          amtAvg: 22039.5,
          perc: 0.2899,
          percAvg: 0.2899,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 1294,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 1490,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 1629,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 1811,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 2589,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 8862.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 4364,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 362,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 1232,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 822,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 1973,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 3302,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 7901.5,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 3141,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 1151.01,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 449,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 1435,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 1164,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 2608,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 6630,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 5151,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 1367,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 1397.01,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 1793,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 6275,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 5281,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 5572.5,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 4534,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 1230,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 1562,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 1105,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 1473,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 2132,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 7591.5,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 3804.5,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 22039.5,
          percent: 0.27770506788361043,
          percentAVG: 0.2899,
          cellID: 'e1ca5621_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 35,
          id: 'e1ca5621_@_2',
          index: 0,
          cPercent: 0.2898995088696267,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Beer',
          path: ['SALES', 'Sales, Beer'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 14,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 27624,
          amtAvg: 5225,
          perc: 0.0687,
          percAvg: 0.0687,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 97,
            },
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 376,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 110,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 542,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 61,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 474,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 20,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 347,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 107,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 503,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 600,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 1413,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 151,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 424,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 56,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 173,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 102,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 583,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 85,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 178,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 77,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 467,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 96,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 623,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 417,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 1256,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 261,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 641,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 47,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 517,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 93,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 151,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 69,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 441,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 59,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 187,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 83,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 681,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 378,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 979,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 295,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 730,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 106,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 252,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 135,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 413,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 69,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 539,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 452,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 794,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 338,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 1243,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 272,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 1042,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 166,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 707,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 36,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 190,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 170,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 424,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 289,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 713,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 46,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 374,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 172,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 760,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 584,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 1482,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 173,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 733,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5225,
          percent: 0.07342489915838064,
          percentAVG: 0.0687,
          cellID: 'ba0b0910_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 70,
          id: 'ba0b0910_@_2',
          index: 0,
          cPercent: 0.06872773583084005,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Wine',
          path: ['SALES', 'Sales, Wine'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [
            {
              id: '1e4fc649-e738-40ac-af2f-98fa638ac3fe',
              index: 4,
              account: '4120 Revenue / Sales:Sales, Wine',
              type: 'trx',
              status: 'inProgress',
              period: '2025-07-24',
              createdAt: '2025-07-29 16:58:53',
              amount: 248,
              transaction: {
                id: '88c5af13-7511-4e18-a7a0-e4757e221dce',
                memo: '',
                name: '',
                trxType: 'Journal Entry',
              },
            },
          ],
          amount: 7890,
          amtAvg: 1861,
          perc: 0.0245,
          percAvg: 0.0245,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 156,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 205,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 342,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 248,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 267,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 489,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 154,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 52,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 373,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 144,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 195,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 419,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 324,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 129,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 99,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 42,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 171,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 98,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 276,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 484,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 82,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 38,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 183,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 243,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 227,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 236,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 437,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 264,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 211,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 197,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 135,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 56,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 227,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 587,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 100,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1861,
          percent: 0.02097170773094495,
          percentAVG: 0.0245,
          cellID: '2f14959f_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 35,
          id: '2f14959f_@_2',
          index: 0,
          cPercent: 0.02447891222606571,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Non-Alcoholic Beverage',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 13083,
          amtAvg: 2599,
          perc: 0.0342,
          percAvg: 0.0342,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 333,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 316,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 243,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 266,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 205,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 701,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 535,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 170,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 307,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 141,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 239,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 451,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 583,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 479,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 258,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 110,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 198,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 116,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 297,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 757,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 592,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 239,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 188,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 144,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 480,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 641,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 616,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 594,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 260,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 554,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 349,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 104,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 302,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 743,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 572,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2599,
          percent: 0.0347747594732513,
          percentAVG: 0.0342,
          cellID: '7bb557b1_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 35,
          id: '7bb557b1_@_2',
          index: 0,
          cPercent: 0.03418629386112025,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Miscellaneous',
          path: ['SALES', 'Sales, Miscellaneous'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
            stats: {
              mean: 3.8,
              variance: 1.3599999999999999,
              stdDev: 1.16619037896906,
            },
          },
          trxFlagged: [],
          amount: 12672.370000000003,
          perc: 0.0363,
          percAvg: 0.0363,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 2542.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 86,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 80,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 52,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 29.48,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 1140.57,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 1217.6,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 214,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 388,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 387,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 79.04,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 2291,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 1084,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 1460.88,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 1247,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 20,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 258,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 30,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 65,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.033683300367350434,
          percentAVG: 0.0363,
          cellID: 'cbede411_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 19,
          id: 'cbede411_@_2',
          index: 0,
          cPercent: 0.03631455178598722,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Service Charges',
          path: ['SALES', 'Sales, Service Charges'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 6575.58,
          perc: 0.0186,
          percAvg: 0.0186,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 106.75,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 177.13,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 227.71,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 127.6,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 117.39,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 470.49,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 189.25,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: 64.36,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: 139.39,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: 85.01,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: 109.8,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: 281.63,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: 382.51,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: 198.14,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: 120.99,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: 51.45,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: 86.37,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: 64.5,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: 196.33,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: 441.93,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: 391.65,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: 82.19,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: 91.61,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: 175.96,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: 178.33,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: 283.66,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: 327.27,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: 207.03,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: 70.38,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: 158.55,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: 128.45,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: 82.3,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: 152.85,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: 417.11,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: 189.51,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.01747796475556996,
          percentAVG: 0.0186,
          cellID: '4e12e939_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 35,
          id: '4e12e939_@_2',
          index: 0,
          cPercent: 0.018629754413767536,
        },
        {
          date: '2025-07-21',
          title: 'Sales - No category',
          path: ['SALES', 'Sales - No category'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'a1f04b4c_@_2_-x-_1',
          baseAmount: 376221.15,
          transactions: 0,
          id: 'a1f04b4c_@_2',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'GROSS SALES',
          path: ['GROSS SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 376221.15,
          amtAvg: 76024.62000000001,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 76024.62000000001,
          percent: 0,
          cellID: '74405d1a_@_3_-x-_1',
          baseAmount: 376221.15,
          transactions: 0,
          id: '74405d1a_@_3',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Comps & Discounts',
          path: ['Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'ba9fcd64_@_6_-x-_1',
          baseAmount: 376221.15,
          transactions: 0,
          id: 'ba9fcd64_@_6',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Discounts and Comps',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -6756.18,
          perc: -0.016,
          percAvg: -0.016,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: -177.25,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: -84.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: -59.5,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: -117.75,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: -144,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: -320.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: -314,
            },
            {
              txnDate: '2025-07-14',
              type: 'Journal Entry',
              eventId: '15217',
              num: 'MJ1863ME',
              name: '',
              description: '',
              amount: -56,
            },
            {
              txnDate: '2025-07-15',
              type: 'Journal Entry',
              eventId: '15309',
              num: 'MJ1864ME',
              name: '',
              description: '',
              amount: -169.8,
            },
            {
              txnDate: '2025-07-16',
              type: 'Journal Entry',
              eventId: '15310',
              num: 'MJ1867ME',
              name: '',
              description: '',
              amount: -54,
            },
            {
              txnDate: '2025-07-17',
              type: 'Journal Entry',
              eventId: '15311',
              num: 'MJ1869ME',
              name: '',
              description: '',
              amount: -64.5,
            },
            {
              txnDate: '2025-07-18',
              type: 'Journal Entry',
              eventId: '15312',
              num: 'MJ1871ME',
              name: '',
              description: '',
              amount: -142.75,
            },
            {
              txnDate: '2025-07-19',
              type: 'Journal Entry',
              eventId: '15353',
              num: 'MJ1873ME',
              name: '',
              description: '',
              amount: -453.25,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15354',
              num: 'MJ1876ME',
              name: '',
              description: '',
              amount: -42,
            },
            {
              txnDate: '2025-07-07',
              type: 'Journal Entry',
              eventId: '14888',
              num: 'MJ1832ME',
              name: '',
              description: '',
              amount: -97.5,
            },
            {
              txnDate: '2025-07-08',
              type: 'Journal Entry',
              eventId: '14905',
              num: 'MJ1834ME',
              name: '',
              description: '',
              amount: -146,
            },
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15025',
              num: 'MJ1835ME',
              name: '',
              description: '',
              amount: -72,
            },
            {
              txnDate: '2025-07-10',
              type: 'Journal Entry',
              eventId: '15026',
              num: 'MJ1851ME',
              name: '',
              description: '',
              amount: -93,
            },
            {
              txnDate: '2025-07-11',
              type: 'Journal Entry',
              eventId: '15028',
              num: 'MJ1853ME',
              name: '',
              description: '',
              amount: -117.5,
            },
            {
              txnDate: '2025-07-12',
              type: 'Journal Entry',
              eventId: '15209',
              num: 'MJ1855ME',
              name: '',
              description: '',
              amount: -275.75,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15208',
              num: 'MJ1858ME',
              name: '',
              description: '',
              amount: -406.75,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14704',
              num: 'MJ1780ME',
              name: '',
              description: '',
              amount: -24,
            },
            {
              txnDate: '2025-07-01',
              type: 'Journal Entry',
              eventId: '14710',
              num: 'MJ1788ME',
              name: '',
              description: '',
              amount: -569.25,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14711',
              num: 'MJ1795ME',
              name: '',
              description: '',
              amount: -81,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14712',
              num: 'MJ1797ME',
              name: '',
              description: '',
              amount: -461,
            },
            {
              txnDate: '2025-07-04',
              type: 'Journal Entry',
              eventId: '14713',
              num: 'MJ1799ME',
              name: '',
              description: '',
              amount: -193,
            },
            {
              txnDate: '2025-07-05',
              type: 'Journal Entry',
              eventId: '14715',
              num: 'MJ1801ME',
              name: '',
              description: '',
              amount: -213.25,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '14716',
              num: 'MJ1803ME',
              name: '',
              description: '',
              amount: -512.38,
            },
            {
              txnDate: '2025-06-23',
              type: 'Journal Entry',
              eventId: '14564',
              num: 'MJ1758ME',
              name: '',
              description: '',
              amount: -177,
            },
            {
              txnDate: '2025-06-24',
              type: 'Journal Entry',
              eventId: '14681',
              num: 'MJ1759ME',
              name: '',
              description: '',
              amount: -241.75,
            },
            {
              txnDate: '2025-06-25',
              type: 'Journal Entry',
              eventId: '14682',
              num: 'MJ1766ME',
              name: '',
              description: '',
              amount: -145,
            },
            {
              txnDate: '2025-06-26',
              type: 'Journal Entry',
              eventId: '14683',
              num: 'MJ1769ME',
              name: '',
              description: '',
              amount: -96.25,
            },
            {
              txnDate: '2025-06-27',
              type: 'Journal Entry',
              eventId: '14684',
              num: 'MJ1771ME',
              name: '',
              description: '',
              amount: -183,
            },
            {
              txnDate: '2025-06-28',
              type: 'Journal Entry',
              eventId: '14686',
              num: 'MJ1774ME',
              name: '',
              description: '',
              amount: -381,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14687',
              num: 'MJ1777ME',
              name: '',
              description: '',
              amount: -70,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.017958001563707943,
          percentAVG: -0.016,
          cellID: '4936addc_@_6_-x-_1',
          baseAmount: 376221.15,
          transactions: 35,
          id: '4936addc_@_6',
          index: 0,
          cPercent: -0.01601454897110962,
        },
        {
          date: '2025-07-21',
          title: 'Total Comps & Discounts',
          path: ['Total Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -6756.18,
          amtAvg: -1217.5,
          perc: -0.016,
          percAvg: -0.016,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -1217.5,
          percent: -0.017958001563707943,
          percentAVG: -0.016,
          cellID: '8a448d4b_@_7_-x-_1',
          baseAmount: 376221.15,
          transactions: 0,
          id: '8a448d4b_@_7',
          index: 0,
          cPercent: -0.01601454897110962,
        },
        {
          date: '2025-07-21',
          title: 'NET SALES',
          path: ['NET SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 369464.97,
          amtAvg: 74807.12000000001,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 74807.12000000001,
          percent: 0,
          cellID: '3b5cefb1_@_8_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '3b5cefb1_@_8',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'COST OF GOODS SOLD (COGS)',
          path: ['COST OF GOODS SOLD (COGS)'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '753db221_@_9_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '753db221_@_9',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Food',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          baseRef: 'Sales, Food',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.4,
              variance: 1.4400000000000002,
              stdDev: 1.2000000000000002,
            },
          },
          trxFlagged: [],
          amount: 7106.3,
          perc: 0.051,
          percAvg: 0.051,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15521',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 374.85,
            },
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15622',
              num: '',
              name: 'Ferro & Sons, Inc.',
              description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
              amount: 1089.11,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15594',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 117.28,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15595',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 464.78,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15227',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 210.91,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15229',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 200.5,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15235',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 184.53,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15236',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 89.76,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15324',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 406.65,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14756',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 319.92,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '15383',
              num: '',
              name: 'Ferro & Sons, Inc.',
              description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
              amount: 2301.75,
            },
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14754',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 244.6,
            },
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14755',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 347.48,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14556',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 271.63,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14557',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 135.12,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14753',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 331.44,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14879',
              num: 'Uber eats ADJ P6.25',
              name: '',
              description: 'Refund',
              amount: 15.99,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.034852284734186285,
          percentAVG: 0.051,
          cellID: '7a94d93b_@_9_-x-_1',
          baseAmount: 203897.68,
          transactions: 17,
          id: '7a94d93b_@_9',
          index: 0,
          cPercent: 0.050993694389751515,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Meat & Poultry',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
            stats: {
              mean: 3.8,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 17896.68,
          perc: 0.0506,
          percAvg: 0.0506,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 48.99,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 195.86,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 1591.81,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 1555.39,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 391.52,
            },
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 797.83,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 97.98,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 1822.14,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 1279.94,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 1139.64,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 195.76,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 1703.27,
            },
            {
              txnDate: '2025-07-11',
              type: 'Bill',
              eventId: '14897',
              num: '9253030',
              name: 'Performance Food Service',
              description: '',
              amount: 88.76,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 1435.21,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 441.11,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 1585.2,
            },
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 1083.72,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 1700.37,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 742.18,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.04843945015951039,
          percentAVG: 0.0506,
          cellID: '3f46fcce_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 19,
          id: '3f46fcce_@_9',
          index: 0,
          cPercent: 0.050577672285739644,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Seafood',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 0.96,
              stdDev: 0.9797958971132712,
            },
          },
          trxFlagged: [],
          amount: 2047.0900000000001,
          perc: 0.0045,
          percAvg: 0.0045,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 19.99,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 181.2,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 113.12,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 22.39,
            },
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 113.07,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 23.49,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 113.18,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 237.99,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 106.47,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 44.78,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 173.83,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15027',
              num: 'IV101-0026997137',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 23.49,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 173.84,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 173.89,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 174.66,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 351.7,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.005540687659780033,
          percentAVG: 0.0045,
          cellID: '2bdeb0ad_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 16,
          id: '2bdeb0ad_@_9',
          index: 0,
          cPercent: 0.004500908469675078,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Produce',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
            stats: {
              mean: 7.4,
              variance: 12.24,
              stdDev: 3.4985711369071804,
            },
          },
          trxFlagged: [],
          amount: 16339.01,
          perc: 0.0518,
          percAvg: 0.0518,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15525',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 674.46,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15526',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 35.75,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15527',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 576.26,
            },
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 433.25,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 180.25,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15544',
              num: '712755',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 150.68,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15615',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 986.9,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 187.5,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 451.8,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 198.75,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15440',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 487.94,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15442',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 26.75,
            },
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15444',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 438.75,
            },
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15446',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 81.58,
            },
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15447',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 16.5,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15538',
              num: 'IV101-0027025164',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 16.5,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 200.25,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15448',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 286.21,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15449',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 936.51,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15467',
              num: '6502274',
              name: 'Avanti Produce',
              description: 'CHECK 6502274',
              amount: 732.25,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 138.5,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14721',
              num: '711317',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 588.95,
            },
            {
              txnDate: '2025-07-08',
              type: 'Expense',
              eventId: '14836',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 979.61,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 461.8,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 237.5,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15027',
              num: 'IV101-0026997137',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 169.75,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15426',
              num: '6502217',
              name: 'Avanti Produce',
              description: 'CHECK 6502217 INV 0710262',
              amount: 1061.45,
            },
            {
              txnDate: '2025-07-12',
              type: 'Bill',
              eventId: '15535',
              num: 'IV101-0027013901',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 26.75,
            },
            {
              txnDate: '2025-07-12',
              type: 'Bill',
              eventId: '15570',
              num: 'IV101-0027013935',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 488.5,
            },
            {
              txnDate: '2025-07-01',
              type: 'Bill',
              eventId: '14821',
              num: '710926',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 914.6,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14835',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 1115.12,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 68.25,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14837',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 694.09,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14722',
              num: '711119',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 488.45,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15335',
              num: '6502145',
              name: 'Avanti Produce',
              description: 'CHECK 6502145 INV#0710602',
              amount: 676.65,
            },
            {
              txnDate: '2025-07-05',
              type: 'Bill',
              eventId: '14723',
              num: '711235',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 599.75,
            },
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14852',
              num: '6502071',
              name: 'Avanti Produce',
              description: 'CHECK 6502071',
              amount: 530.45,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.044223434768389545,
          percentAVG: 0.0518,
          cellID: '593c4b13_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 37,
          id: '593c4b13_@_9',
          index: 0,
          cPercent: 0.0518079027771688,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Grocery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
          trxAnomaly: {
            anomalies: [11],
            anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
            stats: {
              mean: 7.6,
              variance: 4.24,
              stdDev: 2.0591260281974,
            },
          },
          trxFlagged: [],
          amount: 37311.61,
          perc: 0.0361,
          percAvg: 0.0361,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 26.37,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 99,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 1225.26,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 1141.98,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 32.31,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 98.85,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15545',
              num: 'MI1904ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 31.92,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15546',
              num: 'MI1903ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 41.76,
            },
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 575.78,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15456',
              num: '6502279',
              name: 'Performance Food Service',
              description: 'CHECK 6502279',
              amount: 6401.55,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 33.7,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 581.93,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15319',
              num: '',
              name: 'The Webstaurant Store',
              description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
              amount: 594.29,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15514',
              num: '',
              name: 'ShopRite',
              description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
              amount: 41.27,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15516',
              num: '6502334',
              name: 'Performance Food Service',
              description: 'CHECK 6502334',
              amount: 3560.65,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 666.06,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 506.56,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14721',
              num: '711317',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 65.9,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '15258',
              num: '',
              name: 'ShopRite',
              description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
              amount: 53.12,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15347',
              num: '6502206',
              name: 'Performance Food Service',
              description: 'CHECK 6502206',
              amount: 3633.57,
            },
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15388',
              num: '6502219',
              name: 'Performance Food Service',
              description: 'CHECK 6502219',
              amount: 5884.26,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 210.65,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 26.37,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 1381.53,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15027',
              num: 'IV101-0026997137',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 28.05,
            },
            {
              txnDate: '2025-07-11',
              type: 'Bill',
              eventId: '14897',
              num: '9253030',
              name: 'Performance Food Service',
              description: '',
              amount: 103.21,
            },
            {
              txnDate: '2025-07-11',
              type: 'Expense',
              eventId: '15241',
              num: '',
              name: 'Instacart',
              description: 'VISA DDA PUR AP - 401134     IC  INSTACART               INSTACART COM * CA',
              amount: 57.41,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 973.13,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 109.71,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14722',
              num: '711119',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 49.8,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 1077.64,
            },
            {
              txnDate: '2025-07-05',
              type: 'Bill',
              eventId: '14723',
              num: '711235',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 98.85,
            },
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 639.73,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14604',
              num: '',
              name: 'The Webstaurant Store',
              description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
              amount: 875.95,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 481.65,
            },
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14860',
              num: '6502089',
              name: 'Performance Food Service',
              description: 'CHECK 6502089',
              amount: 5204.19,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 659.19,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14887',
              num: '',
              name: 'ShopRite',
              description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
              amount: 38.46,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.10098822088600173,
          percentAVG: 0.0361,
          cellID: 'e0037727_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 38,
          id: 'e0037727_@_9',
          index: 0,
          cPercent: 0.03605873344676282,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bakery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 3818.72,
          perc: 0.0006,
          percAvg: 0.0006,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 44.8,
            },
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15262',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 670.41,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 44.8,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 37,
            },
            {
              txnDate: '2025-07-08',
              type: 'Expense',
              eventId: '14843',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 732.45,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14842',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 613.98,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 44.8,
            },
            {
              txnDate: '2025-06-24',
              type: 'Expense',
              eventId: '14598',
              num: '',
              name: 'RM Bakery LLC',
              description: 'RM BAKERY LLC    SALE',
              amount: 260.58,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14830',
              num: '',
              name: 'David Rosen Bakery Supply Co',
              description: 'VISA DDA PUR AP - 445351     DAVID ROSEN                 718 381 0600  * NY',
              amount: 1369.9,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.010335810726521651,
          percentAVG: 0.0006,
          cellID: '47294ea3_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 9,
          id: '47294ea3_@_9',
          index: 0,
          cPercent: 0.0005988734762145634,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Dairy',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
          trxAnomaly: {
            anomalies: [7],
            anomalyScores: [0.82915619758885, 0, 0, 0, 0],
            stats: {
              mean: 4.8,
              variance: 1.7600000000000002,
              stdDev: 1.32664991614216,
            },
          },
          trxFlagged: [],
          amount: 5260.6,
          perc: 0.014,
          percAvg: 0.014,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 68.24,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 68.74,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 335.06,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15544',
              num: '712755',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 115,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 293.08,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 59.09,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 109.9,
            },
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 245.74,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15539',
              num: 'IV101-0027025183',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 81.58,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 30.22,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 475.14,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 395.97,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 311.38,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 71.8,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 64.51,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 493.79,
            },
            {
              txnDate: '2025-07-12',
              type: 'Bill',
              eventId: '15570',
              num: 'IV101-0027013935',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 21.94,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 518.45,
            },
            {
              txnDate: '2025-07-02',
              type: 'Journal Entry',
              eventId: '14824',
              num: 'MI1811ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 30.22,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 354.61,
            },
            {
              txnDate: '2025-07-05',
              type: 'Bill',
              eventId: '14723',
              num: '711235',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 188.6,
            },
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 185.11,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 197.79,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 544.64,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.014238426988084961,
          percentAVG: 0.014,
          cellID: '841fc412_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 24,
          id: '841fc412_@_9',
          index: 0,
          cPercent: 0.014024199835523674,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Liquor',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          baseRef: 'Sales, Liquor',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
          trxAnomaly: {
            anomalies: [10],
            anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
            stats: {
              mean: 4.8,
              variance: 7.76,
              stdDev: 2.7856776554368237,
            },
          },
          trxFlagged: [],
          amount: 17757.6,
          amtAvg: 5695.15,
          perc: 0.2584,
          percAvg: 0.2584,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 1216.77,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15569',
              num: '866618',
              name: 'Allied Beverages',
              description: '',
              amount: 68.38,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15653',
              num: '6502348',
              name: 'Allied Beverages',
              description: 'CHECK 6502348',
              amount: 1483.07,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15571',
              num: '870345',
              name: 'Allied Beverages',
              description: '',
              amount: 1992.45,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15620',
              num: '',
              name: 'Fedway',
              description: 'FEDWAY ASSOCIATE FEDWAY ASS',
              amount: 934.48,
            },
            {
              txnDate: '2025-07-16',
              type: 'Deposit',
              eventId: '15469',
              num: '',
              name: 'Allied Beverages',
              description: '653030 Dt.06.19.2025',
              amount: -215,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15512',
              num: '6502221',
              name: 'Fedway',
              description: 'POD CHECK',
              amount: 1000,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15549',
              num: '59469',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 812.33,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14900',
              num: '837929',
              name: 'Allied Beverages',
              description: '',
              amount: 1325.12,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14901',
              num: '3733648',
              name: 'Peerless Beverage',
              description: '',
              amount: 112,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14902',
              num: '42235',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 1370.2,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15406',
              num: '6502220',
              name: 'Fedway',
              description: 'CHECK 6502220',
              amount: 1000,
            },
            {
              txnDate: '2025-06-30',
              type: 'Journal Entry',
              eventId: '14820',
              num: 'MI1826ME',
              name: '',
              description: 'Vendor: Allied Beverage Group LLC',
              amount: 178.64,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '650411',
              name: '',
              description: '',
              amount: -237,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '773964',
              name: '',
              description: '',
              amount: -69,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '752749',
              name: '',
              description: '',
              amount: -48,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '644657',
              name: '',
              description: '',
              amount: -36,
            },
            {
              txnDate: '2025-07-01',
              type: 'Deposit',
              eventId: '15279',
              num: '641925',
              name: '',
              description: '',
              amount: -12,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15287',
              num: '6502148',
              name: 'Allied Beverages',
              description: 'CHECK 6502148',
              amount: 178.64,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 1184.38,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14823',
              num: '824312',
              name: 'Allied Beverages',
              description: '',
              amount: 2309.95,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15333',
              num: '6502200',
              name: 'Fedway',
              description: 'POD CHECK #110620',
              amount: 1000,
            },
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14859',
              num: '6502093',
              name: 'Fedway',
              description: 'CHECK 6502093',
              amount: 1000,
            },
            {
              txnDate: '2025-06-26',
              type: 'Check',
              eventId: '14880',
              num: '6502094',
              name: 'Allied Beverages',
              description: 'CHECK 6502094',
              amount: 1208.19,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5695.15,
          percent: 0.16996412276896725,
          percentAVG: 0.2584,
          cellID: '6eb26171_@_9_-x-_1',
          baseAmount: 104478.51999999999,
          transactions: 24,
          id: '6eb26171_@_9',
          index: 0,
          cPercent: 0.2584064974250777,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bar Groceries',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.9600000000000002,
              stdDev: 0.9797958971132713,
            },
          },
          trxFlagged: [],
          amount: 404.27,
          perc: 0.0024,
          percAvg: 0.0024,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 59,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15563',
              num: '9262982',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15562',
              num: '9265170',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15536',
              num: 'IV101-0027029234',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 90.52,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 70.16,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14719',
              num: '9247032',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0010942038699907058,
          percentAVG: 0.0024,
          cellID: '15101cdc_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 6,
          id: '15101cdc_@_9',
          index: 0,
          cPercent: 0.002433725559813023,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          baseRef: 'Sales, Beer',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 435.87,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15390',
              num: '6502207',
              name: 'Eileen Kim',
              description: 'CHECK 6502207 Beer',
              amount: 435.87,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0.015778670721112078,
          percentAVG: 0,
          cellID: '90be8534_@_9_-x-_1',
          baseAmount: 27624,
          transactions: 1,
          id: '90be8534_@_9',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Draught Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 4.960000000000001,
              stdDev: 2.227105745132009,
            },
          },
          trxFlagged: [],
          amount: 4435,
          perc: 0.0068,
          percAvg: 0.0068,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15553',
              num: '627286',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 413,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15558',
              num: '3733797',
              name: 'Peerless Beverage',
              description: '',
              amount: 95,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15493',
              num: '',
              name: 'Northern Eagle Beverage',
              description: 'NORTHERN EAGLE B INVOICES',
              amount: 870.5,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15554',
              num: '625995',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 640,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15555',
              num: '3733721',
              name: 'Peerless Beverage',
              description: '',
              amount: 447,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15556',
              num: '3733723',
              name: 'Peerless Beverage',
              description: '',
              amount: 485,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15498',
              num: '',
              name: 'Northern Eagle Beverage',
              description: 'NORTHERN EAGLE B INVOICES',
              amount: 640,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15508',
              num: '6502332',
              name: 'Hoboken Brewing',
              description: 'CHECK 6502332',
              amount: 549,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14901',
              num: '3733648',
              name: 'Peerless Beverage',
              description: '',
              amount: 295.5,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.012003844369873552,
          percentAVG: 0.0068,
          cellID: '3395a498_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 9,
          id: '3395a498_@_9',
          index: 0,
          cPercent: 0.006790797453504425,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bottled Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 1608.6,
          perc: 0.0059,
          percAvg: 0.0059,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15553',
              num: '627286',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 52.6,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15558',
              num: '3733797',
              name: 'Peerless Beverage',
              description: '',
              amount: 349,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15559',
              num: '3733798',
              name: 'Peerless Beverage',
              description: '',
              amount: 37,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15555',
              num: '3733721',
              name: 'Peerless Beverage',
              description: '',
              amount: 298,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15549',
              num: '59469',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 224,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14899',
              num: '3733647',
              name: 'Peerless Beverage',
              description: '',
              amount: 37,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14901',
              num: '3733648',
              name: 'Peerless Beverage',
              description: '',
              amount: 379,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 232,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.004353863371674992,
          percentAVG: 0.0059,
          cellID: 'e2c4f57e_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 8,
          id: 'e2c4f57e_@_9',
          index: 0,
          cPercent: 0.0058630782738327576,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Wine',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          baseRef: 'Sales, Wine',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2.4,
              variance: 1.8399999999999999,
              stdDev: 1.3564659966250536,
            },
          },
          trxFlagged: [],
          amount: 5661.76,
          amtAvg: 1280.88,
          perc: 0.6883,
          percAvg: 0.6883,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15569',
              num: '866618',
              name: 'Allied Beverages',
              description: '',
              amount: 145.08,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15571',
              num: '870345',
              name: 'Allied Beverages',
              description: '',
              amount: 325.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15550',
              num: '723293',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 810,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15549',
              num: '59469',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 507.3,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15551',
              num: '714240',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 525.2,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14900',
              num: '837929',
              name: 'Allied Beverages',
              description: '',
              amount: 218.16,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14902',
              num: '42235',
              name: 'Federal Wine & Spirits Co.',
              description: '',
              amount: 181.24,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '15206',
              num: '710320',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 810,
            },
            {
              txnDate: '2025-07-01',
              type: 'Check',
              eventId: '15277',
              num: '6502116',
              name: 'Gallo Wine Sales',
              description: 'CHECK 6502116 703442',
              amount: 720.12,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14717',
              num: '707058',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 462,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 631.06,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14823',
              num: '824312',
              name: 'Allied Beverages',
              description: '',
              amount: 325.8,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1280.88,
          percent: 0.7175868187579214,
          percentAVG: 0.6883,
          cellID: 'b29ce542_@_9_-x-_1',
          baseAmount: 7890,
          transactions: 12,
          id: 'b29ce542_@_9',
          index: 0,
          cPercent: 0.6882751209027406,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Non-Alcoholic',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0, 0.784464540552736, 0, 0],
            stats: {
              mean: 4.4,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: 6043.070000000001,
          amtAvg: 1532.25,
          perc: 0.0205,
          percAvg: 0.0205,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 77.62,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15637',
              num: '6502336',
              name: 'Peerless Beverage',
              description: 'CHECK 6502336',
              amount: 1311.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 19.26,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 75.37,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 48.5,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15437',
              num: '6502262',
              name: 'Peerless Beverage',
              description: 'CHECK 6502262',
              amount: 986,
            },
            {
              txnDate: '2025-07-15',
              type: 'Bill',
              eventId: '15540',
              num: 'IV101-0027025179',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 65.5,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15557',
              num: '3733722',
              name: 'Peerless Beverage',
              description: '',
              amount: 81.5,
            },
            {
              txnDate: '2025-07-17',
              type: 'Bill',
              eventId: '15560',
              num: '13859010',
              name: 'Pepsi',
              description: '',
              amount: 597.15,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 121.22,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14896',
              num: 'IV101-0026997147',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 65.5,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14898',
              num: '3685855',
              name: 'Peerless Beverage',
              description: '',
              amount: 40.75,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14899',
              num: '3733647',
              name: 'Peerless Beverage',
              description: '',
              amount: 122.25,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 153.95,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14904',
              num: '116699',
              name: 'W.b. Law Coffee',
              description: '',
              amount: 157.9,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14846',
              num: '',
              name: 'Peerless Beverage',
              description: 'PEERLESS BEVERAG PEERLESS B',
              amount: 1115,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 49.75,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14718',
              num: '27165007',
              name: 'Pepsi',
              description: '',
              amount: 812.37,
            },
            {
              txnDate: '2025-07-03',
              type: 'Journal Entry',
              eventId: '14822',
              num: 'MI1819ME',
              name: '',
              description: 'Vendor: Federal Wine & Spirits Co.',
              amount: 63.27,
            },
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 49.91,
            },
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '15211',
              num: '6502076',
              name: 'Peerless Beverage',
              description: '',
              amount: 3.75,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 25.05,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1532.25,
          percent: 0.016356273234780557,
          percentAVG: 0.0205,
          cellID: '9f08e50d_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 22,
          id: '9f08e50d_@_9',
          index: 0,
          cPercent: 0.02048267598057511,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Packaging',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
          trxAnomaly: {
            anomalies: [1, 3],
            anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
            stats: {
              mean: 2,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 1298.3600000000001,
          perc: 0.0025,
          percAvg: 0.0025,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 129.66,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 59.79,
            },
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 102.98,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 307.14,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 103.38,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 44.57,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 188.73,
            },
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 94.73,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 128.73,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 138.65,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0035141626552579537,
          percentAVG: 0.0025,
          cellID: '027a424d_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 10,
          id: '027a424d_@_9',
          index: 0,
          cPercent: 0.0025325129479653805,
        },
        {
          date: '2025-07-21',
          title: 'Shipping, Freight and Delivery',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 387.04,
          perc: 0.0052,
          percAvg: 0.0052,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Check',
              eventId: '15649',
              num: '6502338',
              name: 'Campos Delivery LLC',
              description: 'CHECK 6502338',
              amount: 387.04,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0010475688669483335,
          percentAVG: 0.0052,
          cellID: 'dfae81d5_@_9_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: 'dfae81d5_@_9',
          index: 0,
          cPercent: 0.005173839067725104,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL COGS',
          path: ['TOTAL COGS'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 127811.57999999999,
          amtAvg: 24046.680000000004,
          perc: 0.3214,
          percAvg: 0.3214,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 24046.680000000004,
          percent: 0.3459369368630536,
          percentAVG: 0.3214,
          cellID: '528a97f9_@_10_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '528a97f9_@_10',
          index: 0,
          cPercent: 0.3214490813173933,
        },
        {
          date: '2025-07-21',
          title: 'GROSS PROFIT',
          path: ['GROSS PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 241653.38999999998,
          amtAvg: 50760.44,
          perc: 0.6786,
          percAvg: 0.6786,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 50760.44,
          percent: 0.6540630631369464,
          percentAVG: 0.6786,
          cellID: '7b400e74_@_12_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '7b400e74_@_12',
          index: 0,
          cPercent: 0.6785509186826066,
        },
        {
          date: '2025-07-21',
          title: 'OPERATING EXPENSES',
          path: ['OPERATING EXPENSES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 215454.94,
          amtAvg: 30351.52,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 30351.52,
          percent: 0,
          cellID: '39d9c4d4_@_13_-x-_1',
          baseAmount: 215454.94,
          transactions: 0,
          id: '39d9c4d4_@_13',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'LABOR',
          path: ['LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '5b0fe671_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '5b0fe671_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Direct Labor',
          path: ['LABOR', 'Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'bb2363da_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'bb2363da_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Labor Other',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 30,
              variance: 456.4,
              stdDev: 21.36352030916253,
            },
          },
          trxFlagged: [],
          amount: 103085.94,
          perc: 0.1857,
          percAvg: 0.1857,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15639',
              num: '6502305',
              name: 'Samantha Lada',
              description: 'POD CHECK  Payroll W.E. 07.06.2025',
              amount: 769.89,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15640',
              num: '6502320',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502320 Payroll W.E. 07.06.2025',
              amount: 684.47,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15641',
              num: '6502308',
              name: 'Olivia Mandez',
              description: 'CHECK 6502308 Payroll W.E. 07.06.2025',
              amount: 678.27,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15642',
              num: '6502266',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502266 Payroll W.E. 06.29.2025',
              amount: 606.87,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15643',
              num: '6502323',
              name: 'Anthony Sanchez',
              description: 'CHECK 6502323 Payroll W.E. 07.06.2025',
              amount: 606.26,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15644',
              num: '6502285',
              name: 'Cantillano Cardenas, Lila',
              description: 'CHECK 6502285 Payroll W.E. 07.06.2025',
              amount: 329.53,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15645',
              num: '6502304',
              name: 'Christopher Intriago',
              description: 'CHECK 6502304 Payroll W.E. 07.06.2025',
              amount: 193,
            },
            {
              txnDate: '2025-07-22',
              type: 'Check',
              eventId: '15650',
              num: '6502321',
              name: 'Manuel Ramirez',
              description: 'CHECK 6502321 Payroll W.E. 07.06.2025',
              amount: 362.39,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15652',
              num: '6502358',
              name: 'Domingo Roman',
              description: 'POD CHECK Payroll W.E. 07.13.2025',
              amount: 1511,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15654',
              num: '6502349',
              name: 'Omar Lopez',
              description: 'CHECK 6502349 Payroll W.E. 07.13.2025',
              amount: 588.1,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15655',
              num: '6502355',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502355 Payroll W.E. 07.13.2025',
              amount: 569.02,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15656',
              num: '6502354',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502354 Payroll W.E. 07.13.2025',
              amount: 494.15,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'Other',
              amount: 6500,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15430',
              num: '6502230',
              name: 'Cantillano Cardenas, Lila',
              description: 'CHECK 6502230 W.E. 06.29.2025',
              amount: 85.04,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15431',
              num: '6502244',
              name: 'Christopher Intriago',
              description: 'CHECK 6502244 W.E. 06.29.2025',
              amount: 141.3,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15432',
              num: '6502226',
              name: 'Reynaldo Cortes Sanchoz',
              description: 'CHECK 6502226 W.E. 06.29.2025',
              amount: 276.43,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15433',
              num: '6502278',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502278',
              amount: 370,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15434',
              num: '6502228',
              name: 'ASSADOURIAN, BERDJ G',
              description: 'CHECK 6502228 W.E. 06.29.2025',
              amount: 542.77,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15435',
              num: '6502260',
              name: 'Sanchez, Anthony',
              description: 'CHECK 6502260 W.E. 06.29.2025',
              amount: 666.9,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15451',
              num: '6502193',
              name: 'Dunn, Kaitlyn',
              description: 'CHECK 6502193 W.E. 06.22.2025',
              amount: 207.62,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15452',
              num: '6502253',
              name: 'Perdikos, Eleni',
              description: 'CHECK 6502253 W.E. 06.29.2025',
              amount: 391.66,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15453',
              num: '6502267',
              name: 'Manuel Ramirez',
              description: 'CHECK 6502267',
              amount: 400.63,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15458',
              num: '6502255',
              name: 'Arielle Pizarro',
              description: 'CHECK 6502255 W.E. 06.29.2025',
              amount: 142.25,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15459',
              num: '6502270',
              name: 'Ana Garzon',
              description: 'CHECK 6502270  W.E. 06.23.2025',
              amount: 208,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15460',
              num: '6502316',
              name: 'Jessica Polak',
              description: 'CHECK 6502316 W.E. 07.06.2025',
              amount: 267.75,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15461',
              num: '6502294',
              name: 'Carlos Dominguez',
              description: "CHECK 6502294 Brandon's Donuts",
              amount: 309.6,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15462',
              num: '6502303',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502303 W.E. 07.06.2025',
              amount: 497.4,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15463',
              num: '6502281',
              name: 'Omar Lopez',
              description: 'CHECK 6502281 W.E. 07.06.2025',
              amount: 508.73,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15464',
              num: '6502293',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502293 W.E. 07.06.2025',
              amount: 607.32,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15465',
              num: '6502291',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502291 W.E. 07.06.2025',
              amount: 621.17,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15466',
              num: '6502306',
              name: 'Luna, Nelson',
              description: 'CHECK 6502306 W.E. 07.06.2025',
              amount: 629.47,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15471',
              num: '6502254',
              name: 'Allanah Pizarro.',
              description: 'CHECK 6502254 W.E. 06.29.2025',
              amount: 78.51,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15472',
              num: '6502312',
              name: 'Marina Pasek',
              description: 'CHECK 6502312 W.E. 07.06.2025',
              amount: 157.94,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15473',
              num: '6502277',
              name: 'Junior Santiago',
              description: 'CHECK 6502277',
              amount: 170.39,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15474',
              num: '6502301',
              name: 'Lina Granados',
              description: 'CHECK 6502301 W.E. 07.06.2025',
              amount: 317.08,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15475',
              num: '6502302',
              name: 'Javier Hernandez',
              description: 'CHECK 6502302 W.E. 07.06.2025',
              amount: 345.45,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15476',
              num: '6502327',
              name: 'Carac, Israel',
              description: 'CHECK 6502327 W.E. 07.06.2025',
              amount: 371.36,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15477',
              num: '6502314',
              name: 'Allanah Pizarro.',
              description: 'CHECK 6502314 W.E. 07.06.2025',
              amount: 410.26,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15478',
              num: '6502233',
              name: 'Isabella Devine',
              description: 'CHECK 6502233 W.E. 07.06.2025',
              amount: 445.8,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15479',
              num: '6502307',
              name: 'Alexis Martinez',
              description: 'CHECK 6502307 W.E. 07.06.2025',
              amount: 478.68,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15480',
              num: '6502290',
              name: 'Reynaldo Cortes Sanchoz',
              description: 'CHECK 6502290 W.E. 07.06.2025',
              amount: 514.73,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15481',
              num: '6502284',
              name: 'Jason Canas',
              description: 'CHECK 6502284 W.E. 07.06.2025',
              amount: 518.12,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15482',
              num: '6502232',
              name: 'Conserve, Mercidieu',
              description: 'POD CHECK W.E. 06.29.2025',
              amount: 535.96,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15483',
              num: '6502283',
              name: 'ASSADOURIAN, BERDJ G',
              description: 'CHECK 6502283 W.E. 07.06.2025',
              amount: 576.38,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15484',
              num: '6502184',
              name: 'Conserve, Mercidieu',
              description: 'POD CHECK W.E..06.22.2025',
              amount: 616.17,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15485',
              num: '6502298',
              name: 'Franco Ramos, Luis David',
              description: 'CHECK 6502298 W.E. 07.06.2025',
              amount: 624.92,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15486',
              num: '6502259',
              name: 'Rosemarie Rosado',
              description: 'CHECK 6502259 W.E. 06.29.2025',
              amount: 684.15,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15487',
              num: '6502299',
              name: 'Juliana Garcia Escobar',
              description: 'CHECK 6502299 W.E. 07.06.2025',
              amount: 685.44,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15488',
              num: '6502300',
              name: 'Ana Maria Garzon',
              description: 'CHECK 6502300 W.E. 07.06.2025',
              amount: 748.35,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15489',
              num: '6502289',
              name: 'Efren Cortes Sanchez',
              description: 'CHECK 6502289 W.E. 07.06.2025',
              amount: 757.68,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15490',
              num: '6502297',
              name: 'Fonto, Laurynn',
              description: 'CHECK 6502297 W.E. 07.06.2025',
              amount: 823.27,
            },
            {
              txnDate: '2025-07-17',
              type: 'Check',
              eventId: '15491',
              num: '6502295',
              name: 'Hakim Eatman',
              description: 'CHECK 6502295 W.E. 07.06.2025',
              amount: 966.36,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15500',
              num: '6502310',
              name: 'Frida Monroy',
              description: 'CHECK 6502310 W.E. 07.06.2025',
              amount: 202.73,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15501',
              num: '6502318',
              name: 'Carlos Ramirez',
              description: 'CHECK 6502318',
              amount: 304.03,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15502',
              num: '6502309',
              name: 'Jephthah Michel',
              description: 'POD CHECK W.E. 07.06.2025',
              amount: 403.1,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15503',
              num: '6502292',
              name: 'Isabella Devine',
              description: 'CHECK 6502292 W.E. 07.06.2025',
              amount: 405.95,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15504',
              num: '6502313',
              name: 'Perdikos, Eleni',
              description: 'CHECK 6502313 W.E. 07.06.2025',
              amount: 406.59,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15505',
              num: '6502287',
              name: 'Geoconda Castro',
              description: 'CHECK 6502287 W.E. 07.06.2025',
              amount: 408.55,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15507',
              num: '6502276',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502276',
              amount: 545,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15509',
              num: '6502324',
              name: 'Junior Santiago',
              description: 'CHECK 6502324 W.E. 07.06.2025',
              amount: 571.25,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15510',
              num: '6502296',
              name: 'Smicker Figueroa',
              description: 'CHECK 6502296 W.E. 07.06.2025',
              amount: 844.04,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15511',
              num: '6502311',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502311 W.E. 07.06.2025',
              amount: 932.87,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15513',
              num: '6502317',
              name: 'Mikhailson Pollas',
              description: 'CHECK 6502317 W.E. 07.06.2025',
              amount: 1044.91,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15515',
              num: '6502325',
              name: 'Roberto Santiago.',
              description: 'CHECK 6502325 W.E. 07.06.2025',
              amount: 1120.13,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'Other',
              amount: 4000,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15350',
              num: '6502189',
              name: 'Rony Normil',
              description: 'CHECK 6502189 W.E. 6.22.25',
              amount: 1337.83,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15351',
              num: '6502160',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502160 W.E. 6.22.25',
              amount: 1054.65,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15352',
              num: '6502178',
              name: 'Mikhailson Pollas',
              description: 'CHECK 6502178 W.E. 6.22.25',
              amount: 1044.91,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15358',
              num: '6502152',
              name: 'Omar Lopez',
              description: 'CHECK 6502152 Brandons Donuts',
              amount: 590.89,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15359',
              num: '6502158',
              name: 'Isabella Devine',
              description: 'CHECK 6502158 W.E. 06.22.2025',
              amount: 146.5,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15360',
              num: '6502198',
              name: 'Jessica Polak',
              description: 'CHECK 6502198 W.E. 06.22.2025',
              amount: 252.85,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15361',
              num: '6502174',
              name: 'Lina Granados',
              description: 'CHECK 6502174 W.E. 06.22.2025',
              amount: 262.86,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15362',
              num: '6502153',
              name: 'Omar Lopez',
              description: 'CHECK 6502153',
              amount: 300,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15363',
              num: '6502196',
              name: 'Javier Hernandez',
              description: 'CHECK 6502196 W.E. 06.22.2025',
              amount: 313.15,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15364',
              num: '6502170',
              name: 'Christopher Intriago',
              description: 'CHECK 6502170 W.E. 06.22.2025',
              amount: 340.34,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15365',
              num: '6502191',
              name: 'Joseph, Fiona',
              description: 'CHECK 6502191 W.E. 06.22.2025',
              amount: 344.05,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15366',
              num: '6502154',
              name: 'Juliana Garcia Escobar',
              description: 'CHECK 6502154 W.E. 06.22.2025',
              amount: 352.55,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15367',
              num: '6502159',
              name: 'Geoconda Castro',
              description: 'CHECK 6502159 W.E. 06.22.2025',
              amount: 367.8,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15368',
              num: '6502186',
              name: 'Tocto, Domenica',
              description: 'CHECK 6502186 W.E. 06.22.2025',
              amount: 388.33,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15369',
              num: '6502194',
              name: 'Rosemarie Rosado',
              description: 'CHECK 6502194 W.E. 06.22.2025',
              amount: 401.65,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15370',
              num: '6502179',
              name: 'Marina Pasek',
              description: 'CHECK 6502179 W.E. 06.22.2025',
              amount: 423.02,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15371',
              num: '6502171',
              name: 'Fonto, Laurynn',
              description: 'CHECK 6502171',
              amount: 495.61,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15372',
              num: '6502211',
              name: 'Smicker Figueroa',
              description: 'CHECK 6502211 W.E. 06.22.2025',
              amount: 552.98,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15373',
              num: '6502156',
              name: 'Luis David Franco Ramos',
              description: 'CHECK 6502156 W.E. 06.22.2025',
              amount: 557.66,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15374',
              num: '6502187',
              name: 'ASSADOURIAN, BERDJ G',
              description: 'CHECK 6502187 W.E. 06.22.2025',
              amount: 564.07,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15375',
              num: '6502188',
              name: 'Samantha Lada',
              description: 'POD CHECK W.E. 06.22.2025',
              amount: 619.92,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15376',
              num: '6502197',
              name: 'Jephthah Michel',
              description: 'POD CHECK W.E. 06.22.2025',
              amount: 736.22,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15377',
              num: '6502199',
              name: 'Hakim Eatman',
              description: 'CHECK 6502199 W.E. 06.22.2025',
              amount: 778.89,
            },
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15391',
              num: '6502214',
              name: 'Manuel Ramirez',
              description: 'CHECK 6502214',
              amount: 423.19,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15392',
              num: '6502256',
              name: 'Polak, Jessica',
              description: 'CHECK 6502256 W.E. 06.29.2025',
              amount: 303.02,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15393',
              num: '6502252',
              name: 'Marina Pasek',
              description: 'CHECK 6502252',
              amount: 332.68,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15394',
              num: '6502243',
              name: 'Javier Hernandez',
              description: 'CHECK 6502243 W.E. 06.29.2025',
              amount: 349.53,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15395',
              num: '6502248',
              name: 'Olivia Mandez',
              description: 'CHECK 6502248 W.E. 06.29.2025',
              amount: 366.02,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15396',
              num: '6502218',
              name: 'Omar Lopez',
              description: 'CHECK 6502218 Brandons Donuts',
              amount: 369.33,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15397',
              num: '6502231',
              name: 'Carac, Israel',
              description: 'CHECK 6502231 W.E. 06.29.2025',
              amount: 390.55,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15398',
              num: '6502239',
              name: 'Franco Ramos, Luis David',
              description: 'CHECK 6502239 W.E. 06.29.2025',
              amount: 460.45,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15399',
              num: '6502247',
              name: 'Luna, Nelson',
              description: 'CHECK 6502247 W.E. 06.29.2025',
              amount: 479.84,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15400',
              num: '6502269',
              name: 'Alexis Martinez',
              description: 'CHECK 6502269 W.E. 06.29.2025',
              amount: 491.13,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15401',
              num: '6502229',
              name: 'Jason Canas',
              description: 'CHECK 6502229 W.E. 06.29.2025',
              amount: 499.29,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15402',
              num: '6502225',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502225 W.E. 06.29.2025',
              amount: 604.74,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15403',
              num: '6502223',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502223 W.E. 06.29.2025',
              amount: 611.68,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15404',
              num: '6502236',
              name: 'Hakim Eatman',
              description: 'CHECK 6502236 W.E. 06.29.2025',
              amount: 611.8,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15405',
              num: '6502222',
              name: 'Efren Cortes Sanchez',
              description: 'CHECK 6502222 W.E. 06.29.2025',
              amount: 750.35,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15407',
              num: '6502257',
              name: 'Mikhailson Pollas',
              description: 'CHECK 6502257 W.E. 06.29.2025',
              amount: 1044.91,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15408',
              num: '6502250',
              name: 'Rony Normil',
              description: 'CHECK 6502250 W.E. 06.29.2025',
              amount: 1337.83,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15411',
              num: '6502168',
              name: 'Manon, Carolina',
              description: 'CHECK 6502168 W.E. 06.22.2025',
              amount: 166.98,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15412',
              num: '6502265',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502265 W.E. 06.29.2025',
              amount: 314,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15413',
              num: '6502240',
              name: 'Juliana Garcia Escobar',
              description: 'CHECK 6502240 W.E. 06.29.2025',
              amount: 359.89,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15414',
              num: '6502234',
              name: 'Geoconda Castro',
              description: 'CHECK 6502234 W.E. 06.29.2025',
              amount: 399.03,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15415',
              num: '6502237',
              name: 'Smicker Figueroa',
              description: 'CHECK 6502237 W.E. 06.29.2025',
              amount: 527.82,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15416',
              num: '6502264',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502264 W.E. 06.29.2025',
              amount: 530,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15417',
              num: '6502275',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502275',
              amount: 540,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15418',
              num: '6502245',
              name: 'Joseph, Fiona',
              description: 'CHECK 6502245 W.E. 06.29.2025',
              amount: 559.92,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15419',
              num: '6502242',
              name: 'Lina Granados',
              description: 'CHECK 6502242 W.E. 06.29.2025',
              amount: 564.42,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15420',
              num: '6502140',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502140 W.E. 06.29.2025',
              amount: 580,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15421',
              num: '6502246',
              name: 'Samantha Lada',
              description: 'POD CHECK W.E. 06.29.2025',
              amount: 654.53,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15422',
              num: '6502238',
              name: 'Fonto, Laurynn',
              description: 'CHECK 6502238 W.E. 06.29.2025',
              amount: 707.24,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15423',
              num: '6502251',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502251 W.E. 06.29.2025',
              amount: 761.38,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15424',
              num: '6502227',
              name: 'Carlos Ramirez',
              description: 'CHECK 6502227 W.E. 06.29.2025',
              amount: 767.84,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15425',
              num: '6502249',
              name: 'Jephthah Michel',
              description: 'POD CHECK W.E. 06.29.2025',
              amount: 825.33,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15427',
              num: '6502268',
              name: 'Roberto Santiago.',
              description: 'CHECK 6502268 W.E. 06.29.2025',
              amount: 1120.13,
            },
            {
              txnDate: '2025-07-11',
              type: 'Check',
              eventId: '15429',
              num: '6502261',
              name: 'Ibrahim Sidibay',
              description: 'CHECK 6502261 W.E. 06.29.2025',
              amount: 54.98,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'Other',
              amount: 6500,
            },
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14883',
              num: '6502139',
              name: 'Janetydy Huesca.',
              description: 'CHECK 6502139 Payroll 06.15.2025',
              amount: 580,
            },
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14884',
              num: '6502137',
              name: 'Ivonne Olarte',
              description: 'CHECK 6502137',
              amount: 356.2,
            },
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14885',
              num: '6502136',
              name: 'Javier Hernandez',
              description: 'CHECK 6502136',
              amount: 301.48,
            },
            {
              txnDate: '2025-07-01',
              type: 'Check',
              eventId: '15275',
              num: '6502143',
              name: '',
              description: '',
              amount: 59.76,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15282',
              num: '6502162',
              name: 'Carlos Ramirez',
              description: 'CHECK 6502162',
              amount: 677.74,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15283',
              num: '6502155',
              name: 'Luna, Nelson',
              description: 'CHECK 6502155',
              amount: 583.78,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15284',
              num: '6502183',
              name: 'Carlos Dominguez',
              description: 'CHECK 6502183 WE 6.22.25 not found in Report',
              amount: 542.58,
            },
            {
              txnDate: '2025-07-02',
              type: 'Check',
              eventId: '15285',
              num: '6502166',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502166 WE 6.22.25 not found in Report',
              amount: 511.02,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15330',
              num: '6502192',
              name: 'Alexandre, Wood Loudie',
              description: 'POD CHECK W.E. 6.22.25',
              amount: 703.44,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15331',
              num: '6502157',
              name: 'Efren Cortes Sanchez',
              description: 'CHECK 6502157 W.E. 6.22.25',
              amount: 755.76,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15332',
              num: '6502182',
              name: 'Roberto Santiago.',
              description: 'CHECK 6502182 W.E. 6.22.25',
              amount: 1120.13,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15336',
              num: '6502167',
              name: 'Olivia Mandez',
              description: 'CHECK 6502167 W.E. 6.22.25',
              amount: 658.11,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15337',
              num: '6502190',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502190 W.E. 6.22.25',
              amount: 626.79,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15338',
              num: '6502164',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502164 W.E. 6.22.25',
              amount: 588.3,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15339',
              num: '6502180',
              name: 'Alexis Martinez',
              description: 'CHECK 6502180 W.E. 6.22.25',
              amount: 506.92,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15340',
              num: '6502169',
              name: 'Perdikos, Eleni',
              description: 'CHECK 6502169 W.E. 6.22.25',
              amount: 486.53,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15341',
              num: '6502175',
              name: 'Sanchez, Anthony',
              description: 'CHECK 6502175 W.E. 6.22.25',
              amount: 377.91,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15342',
              num: '6502173',
              name: 'Jason Canas',
              description: 'CHECK 6502173 W.E. 6.22.25',
              amount: 362.53,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15343',
              num: '6502185',
              name: 'Reynaldo Cortes Sanchoz',
              description: 'CHECK 6502185 W.E. 6.22.25',
              amount: 305.7,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15344',
              num: '6502177',
              name: 'Ibrahim Sidibay',
              description: 'CHECK 6502177 W.E. 6.22.25',
              amount: 262.54,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15345',
              num: '6502163',
              name: 'Frida Monroy',
              description: 'CHECK 6502163 W.E. 6.22.25',
              amount: 196.84,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15346',
              num: '6502161',
              name: 'Carac, Israel',
              description: 'CHECK 6502161 W.E. 6.22.25',
              amount: 174.74,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'Other',
              amount: 6500,
            },
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14674',
              num: '6502081',
              name: 'Anthony Sanchez',
              description: 'CHECK 6502081',
              amount: 489.65,
            },
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14680',
              num: '6502083',
              name: 'Isabella Devine',
              description: 'CHECK 6502083 06/02 - 06/08',
              amount: 128.64,
            },
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14858',
              num: '6502091',
              name: 'Omar Lopez',
              description: 'CHECK 6502091',
              amount: 559.15,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'Other',
              amount: 4300,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.2790141105934888,
          percentAVG: 0.1857,
          cellID: '687f4cd2_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 150,
          id: '687f4cd2_@_14',
          index: 0,
          cPercent: 0.18571694779855177,
        },
        {
          date: '2025-07-21',
          title: 'Labor, Management',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 16050.15,
          perc: 0.03,
          percAvg: 0.03,
          dataRows: [
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'Management',
              amount: 2244.1,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'Management',
              amount: 6486.95,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'Management',
              amount: 2244.1,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'Management',
              amount: 3455,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'Management',
              amount: 1620,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.04344160151366989,
          percentAVG: 0.03,
          cellID: '529343c4_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 5,
          id: '529343c4_@_14',
          index: 0,
          cPercent: 0.029998481427971024,
        },
        {
          date: '2025-07-21',
          title: 'Labor, BOH',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 11967.710000000003,
          perc: 0.0229,
          percAvg: 0.0229,
          dataRows: [
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'BOH',
              amount: 5121.55,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.03239200187232907,
          percentAVG: 0.0229,
          cellID: '3c61733f_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 5,
          id: '3c61733f_@_14',
          index: 0,
          cPercent: 0.0228793729794704,
        },
        {
          date: '2025-07-21',
          title: 'Total Direct Labor',
          path: ['LABOR', 'Total Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 131103.8,
          amtAvg: 17848.59,
          perc: 0.2386,
          percAvg: 0.2386,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 17848.59,
          percent: 0.35484771397948767,
          percentAVG: 0.2386,
          cellID: '143a84db_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '143a84db_@_14',
          index: 0,
          cPercent: 0.2385948022059932,
        },
        {
          date: '2025-07-21',
          title: 'Labor Related Expenses',
          path: ['LABOR', 'Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'dacf6533_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'dacf6533_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Commission/Bonus/Incentives',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 539,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'Commission',
              amount: 271,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'comission',
              amount: 268,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0014588663168797844,
          percentAVG: 0,
          cellID: '7a82e4de_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 2,
          id: '7a82e4de_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Payroll Taxes',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 3398.8099999999995,
          perc: -0.0105,
          percAvg: -0.0105,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Deposit',
              eventId: '15624',
              num: '',
              name: 'Payroll Tax',
              description: 'STRATEGY EXECUTI TAX COL',
              amount: -1269.59,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'PR Tax',
              amount: 480.77,
            },
            {
              txnDate: '2025-07-20',
              type: 'Journal Entry',
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              name: '',
              description: 'PR Tax',
              amount: 2993.1,
            },
            {
              txnDate: '2025-07-13',
              type: 'Journal Entry',
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              name: '',
              description: 'PR Tax',
              amount: 480.77,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'PR Tax',
              amount: 475,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              name: '',
              description: 'PR Tax',
              amount: 238.76,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.00919927537379254,
          percentAVG: -0.0105,
          cellID: 'bbc14e9c_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 6,
          id: 'bbc14e9c_@_14',
          index: 0,
          cPercent: -0.010544718203294017,
        },
        {
          date: '2025-07-21',
          title: 'Employee Meals',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 774,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14675',
              num: '650204',
              name: 'Eileen Kim',
              description: 'CHECK 650204 Reimbursement',
              amount: 774,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.002094921204573197,
          cellID: '416bc276_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '416bc276_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Recruiting',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'c12aec10_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'c12aec10_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Labor Related Expenses',
          path: ['LABOR', 'Total Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4711.8099999999995,
          amtAvg: -788.82,
          perc: -0.0105,
          percAvg: -0.0105,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -788.82,
          percent: 0.012753062895245523,
          percentAVG: -0.0105,
          cellID: '1e9ad256_@_14_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '1e9ad256_@_14',
          index: 0,
          cPercent: -0.010544718203294017,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL LABOR',
          path: ['TOTAL LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 135815.61,
          amtAvg: 17059.77,
          perc: 0.2281,
          percAvg: 0.2281,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 17059.77,
          percent: 0.3676007768747332,
          percentAVG: 0.2281,
          cellID: 'd0736ae7_@_15_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'd0736ae7_@_15',
          index: 0,
          cPercent: 0.2280500840026992,
        },
        {
          date: '2025-07-21',
          title: 'PRIME COST',
          path: ['PRIME COST'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 263627.19,
          amtAvg: 41106.450000000004,
          perc: 0.5495,
          percAvg: 0.5495,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 41106.450000000004,
          percent: 0.7135377137377868,
          percentAVG: 0.5495,
          cellID: 'b7d061ce_@_16_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'b7d061ce_@_16',
          index: 0,
          cPercent: 0.5494991653200925,
        },
        {
          date: '2025-07-21',
          title: 'Contribution Margin',
          path: ['Contribution Margin'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 105837.77999999998,
          amtAvg: 33700.670000000006,
          perc: 0.4505,
          percAvg: 0.4505,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 33700.670000000006,
          percent: 0.28646228626221315,
          percentAVG: 0.4505,
          cellID: '2f5a4d68_@_17_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '2f5a4d68_@_17',
          index: 0,
          cPercent: 0.4505008346799075,
        },
        {
          date: '2025-07-21',
          title: 'CONTROLLABLE EXPENSES',
          path: ['CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '2cd659af_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '2cd659af_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '3be3d09b_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '3be3d09b_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Equipment Lease Rental',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 155,
          amtAvg: 35,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [
            {
              txnDate: '2025-07-09',
              type: 'Journal Entry',
              eventId: '15533',
              num: 'MI1905ME',
              name: '',
              description: 'Vendor: Alpine Soda Systems Of New York LLC',
              amount: 155,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 35,
          percent: 0.00041952556422331463,
          percentAVG: 0.0005,
          cellID: '1a6a3f76_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '1a6a3f76_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Cleaning Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
            stats: {
              mean: 2.2,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: 679.97,
          amtAvg: 114.23,
          perc: 0.0025,
          percAvg: 0.0015,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15534',
              num: '3590454',
              name: 'White Plains Linen',
              description: '',
              amount: 83.48,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 65.35,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 35.7,
            },
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 20.12,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 111.79,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 101.13,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 21.61,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 66.69,
            },
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 65.4,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 74,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 34.7,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 114.23,
          percent: 0.0018404180509995307,
          percentAVG: 0.0015,
          cellID: '514ec7ed_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 11,
          id: '514ec7ed_@_18',
          index: 0,
          cPercent: 0.00246674380727396,
        },
        {
          date: '2025-07-21',
          title: 'Cleaning Services',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1044.92,
          amtAvg: 235.95,
          perc: 0,
          percAvg: 0.0032,
          dataRows: [
            {
              txnDate: '2025-07-09',
              type: 'Check',
              eventId: '15389',
              num: '6502115',
              name: 'Golden Cleaning',
              description: 'CHECK 6502115',
              amount: 1044.92,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 235.95,
          percent: 0.0028281977585046837,
          percentAVG: 0.0032,
          cellID: '758ae475_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '758ae475_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Restaurant Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2154.8,
          amtAvg: 402.65,
          perc: 0.0071,
          percAvg: 0.0054,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 270.35,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 139.53,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 119.8,
            },
            {
              txnDate: '2025-07-14',
              type: 'Bill',
              eventId: '15207',
              num: '9255396',
              name: 'Performance Food Service',
              description: '',
              amount: 46.81,
            },
            {
              txnDate: '2025-07-16',
              type: 'Bill',
              eventId: '15537',
              num: '9257563',
              name: 'Performance Food Service',
              description: '',
              amount: 149.33,
            },
            {
              txnDate: '2025-07-18',
              type: 'Bill',
              eventId: '15566',
              num: '9259520',
              name: 'Performance Food Service',
              description: '',
              amount: 180.73,
            },
            {
              txnDate: '2025-07-07',
              type: 'Bill',
              eventId: '14720',
              num: '9249995',
              name: 'Performance Food Service',
              description: '',
              amount: 87.54,
            },
            {
              txnDate: '2025-07-09',
              type: 'Bill',
              eventId: '15542',
              num: '711503',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 59.9,
            },
            {
              txnDate: '2025-07-10',
              type: 'Bill',
              eventId: '14903',
              num: '9253029',
              name: 'Performance Food Service',
              description: '',
              amount: 264.54,
            },
            {
              txnDate: '2025-07-02',
              type: 'Bill',
              eventId: '14714',
              num: '9247031',
              name: 'Performance Food Service',
              description: '',
              amount: 232.93,
            },
            {
              txnDate: '2025-07-03',
              type: 'Bill',
              eventId: '14722',
              num: '711119',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 119.8,
            },
            {
              txnDate: '2025-07-04',
              type: 'Bill',
              eventId: '14724',
              num: '9249000',
              name: 'Performance Food Service',
              description: '',
              amount: 111.91,
            },
            {
              txnDate: '2025-06-23',
              type: 'Bill',
              eventId: '14561',
              num: '9239104',
              name: 'Performance Food Service',
              description: '',
              amount: 80.19,
            },
            {
              txnDate: '2025-06-25',
              type: 'Bill',
              eventId: '14685',
              num: '9240751',
              name: 'Performance Food Service',
              description: '',
              amount: 166.11,
            },
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '14703',
              num: '9243481',
              name: 'Performance Food Service',
              description: '',
              amount: 125.33,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 402.65,
          percent: 0.005832217327667087,
          percentAVG: 0.0054,
          cellID: '28a2ce1f_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 15,
          id: '28a2ce1f_@_18',
          index: 0,
          cPercent: 0.007080609439315401,
        },
        {
          date: '2025-07-21',
          title: 'Laundry, Linens, & Uniforms',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16,
              stdDev: 0.4,
            },
          },
          trxFlagged: [],
          amount: 4422.889999999999,
          amtAvg: 557.42,
          perc: 0.0036,
          percAvg: 0.0075,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15534',
              num: '3590454',
              name: 'White Plains Linen',
              description: '',
              amount: 268.89,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15492',
              num: '',
              name: 'White Plains Linen',
              description: 'WHITE PLAINS COA COLLECTION',
              amount: 1058.12,
            },
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14839',
              num: '',
              name: 'White Plains Linen',
              description: 'WHITE PLAINS COA COLLECTION',
              amount: 1141.57,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14886',
              num: '',
              name: 'Sartor NYC',
              description: 'VISA DDA PUR AP - 469216     SQ  SARTOR INC              NEW YORK      * NY',
              amount: 1954.31,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 557.42,
          percent: 0.011971067243533263,
          percentAVG: 0.0075,
          cellID: 'ad6ac922_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 4,
          id: 'ad6ac922_@_18',
          index: 0,
          cPercent: 0.0035944439513244187,
        },
        {
          date: '2025-07-21',
          title: 'Kitchen/ Bar Smallwares',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1598.17,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14590',
              num: '',
              name: 'Crate & Barrel',
              description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
              amount: 631.25,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14591',
              num: '',
              name: 'Crate & Barrel',
              description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
              amount: 546.8,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14592',
              num: '',
              name: 'Crate & Barrel',
              description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
              amount: 420.12,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0.004325633361127579,
          percentAVG: 0,
          cellID: '9f991141_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 3,
          id: '9f991141_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 10055.75,
          amtAvg: 1345.25,
          perc: 0.0131,
          percAvg: 0.018,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1345.25,
          percent: 0.027217059306055457,
          percentAVG: 0.018,
          cellID: 'b7f8c8b8_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'b7f8c8b8_@_18',
          index: 0,
          cPercent: 0.01314179719791378,
        },
        {
          date: '2025-07-21',
          title: 'Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '9d0fd7d1_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '9d0fd7d1_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: '3rd Party Commissions',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '47bbbb15_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '47bbbb15_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd484c66b_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'd484c66b_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'edd65db2_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'edd65db2_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Marketing & Public Relations',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 1932.99,
          amtAvg: 388.88,
          perc: 0,
          percAvg: 0.0052,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15441',
              num: '',
              name: 'GO DADDY.COM',
              description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0586      480 5058855   * AZ',
              amount: 22.19,
            },
            {
              txnDate: '2025-07-10',
              type: 'Expense',
              eventId: '15410',
              num: '',
              name: 'The Scene',
              description: 'VISA DDA PUR AP - 406466     WWW THESCENENY COM          WWW THESCENEN * NY',
              amount: 1700,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '15201',
              num: '',
              name: 'Adentro Inc',
              description: 'ADENTRO INC      ZENREACH',
              amount: 89,
            },
            {
              txnDate: '2025-07-02',
              type: 'Deposit',
              eventId: '15202',
              num: '',
              name: 'Adentro Inc',
              description: 'ADENTRO INC      ZENREACH',
              amount: -89,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14850',
              num: '',
              name: 'GO DADDY.COM',
              description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0986      480 5058855   * AZ',
              amount: 210.8,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 388.88,
          percent: 0.005231862712180806,
          percentAVG: 0.0052,
          cellID: 'c61b398a_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 5,
          id: 'c61b398a_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Advertising & Promotions',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
            stats: {
              mean: 1.8,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 2434.09,
          amtAvg: 466.08,
          perc: 0.0073,
          percAvg: 0.0062,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15524',
              num: '',
              name: 'Popmenu Inc.',
              description: 'VISA DDA PUR AP - 401134     POPMENU INC                 POPMENU COM   * GA',
              amount: 548,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15226',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  8V9TBVCVK2          650 5434800   * CA',
              amount: 289,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14749',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  4GXXCVYUK2          650 5434800   * CA',
              amount: 18.14,
            },
            {
              txnDate: '2025-07-01',
              type: 'Expense',
              eventId: '14750',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  UDDR8UQUK2          650 5434800   * CA',
              amount: 98.26,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14847',
              num: '',
              name: 'Google',
              description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE THE AINSWO    650 2530000   * CA',
              amount: 237.79,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14848',
              num: '',
              name: 'Google',
              description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE PAIGECONCE    650 2530000   * CA',
              amount: 522.99,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14849',
              num: '',
              name: 'Google',
              description: 'VISA DDA PUR AP - 420429     GOOGLE ADSXXXXXX3399        650 2530000   * CA',
              amount: 349.91,
            },
            {
              txnDate: '2025-06-24',
              type: 'Expense',
              eventId: '14558',
              num: '',
              name: 'Facebook',
              description: 'VISA DDA PUR AP - 420429     FACEBK  KR7KAXUUK2          650 5434800   * CA',
              amount: 262,
            },
            {
              txnDate: '2025-06-29',
              type: 'Journal Entry',
              eventId: '14879',
              num: 'Uber eats ADJ P6.25',
              name: '',
              description: 'Sum of Merchant promotions applied to the order',
              amount: 108,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 466.08,
          percent: 0.006588148262066632,
          percentAVG: 0.0062,
          cellID: '1dc3b3a3_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 9,
          id: '1dc3b3a3_@_18',
          index: 0,
          cPercent: 0.007325505914410285,
        },
        {
          date: '2025-07-21',
          title: 'Total Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4367.08,
          amtAvg: 854.96,
          perc: 0.0073,
          percAvg: 0.0114,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 854.96,
          percent: 0.011820010974247437,
          percentAVG: 0.0114,
          cellID: '024ba9eb_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '024ba9eb_@_18',
          index: 0,
          cPercent: 0.007325505914410285,
        },
        {
          date: '2025-07-21',
          title: 'Music & DJ',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 500,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-06-25',
              type: 'Check',
              eventId: '14857',
              num: '6502092',
              name: 'YNVS Media LLC',
              description: 'POD CHECK',
              amount: 500,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0.0013533082716881118,
          percentAVG: 0,
          cellID: '0c83dbac_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '0c83dbac_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '6f7c6ca5_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '6f7c6ca5_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Accounting & Bookkeeping',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1499,
          amtAvg: 338.48,
          perc: 0,
          percAvg: 0.0045,
          dataRows: [
            {
              txnDate: '2025-07-01',
              type: 'Bill',
              eventId: '14560',
              num: 'INV-12776-7690',
              name: 'KitchenSync LLC',
              description: '',
              amount: 1499,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 338.48,
          percent: 0.004057218198520959,
          percentAVG: 0.0045,
          cellID: '5a0fedcf_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '5a0fedcf_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Consulting',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1250,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14676',
              num: '6502084',
              name: 'Shaun Rose',
              description: 'CHECK 6502084',
              amount: 1250,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0.0033832706792202793,
          percentAVG: 0,
          cellID: 'b08821c2_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: 'b08821c2_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Legal',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: 7221.03,
          amtAvg: 658.11,
          perc: 0.0165,
          percAvg: 0.0088,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15623',
              num: '',
              name: 'At Law',
              description: 'WIRE TRANSFER OUTGOING - Collection At Law',
              amount: 1233.49,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '15384',
              num: '',
              name: 'At Law',
              description: 'WIRE TRANSFER OUTGOING - Collection At Law',
              amount: 1681,
            },
            {
              txnDate: '2025-06-30',
              type: 'Check',
              eventId: '14882',
              num: '2095',
              name: 'Matthew J Keating Attorney',
              description: 'CHECK 2095',
              amount: 2500,
            },
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14679',
              num: '6502064',
              name: 'Matthew J Keating Attorney',
              description: 'CHECK 6502064',
              amount: 1806.54,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 658.11,
          percent: 0.01954455925821601,
          percentAVG: 0.0088,
          cellID: 'a630ac37_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 4,
          id: 'a630ac37_@_18',
          index: 0,
          cPercent: 0.01648893848606924,
        },
        {
          date: '2025-07-21',
          title: 'Payroll Processing Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 172.53,
          amtAvg: 38.96,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15445',
              num: '',
              name: '7Shifts',
              description: 'VISA DDA PUR AP - 401134     7SHIFTS                     7SHIFTS COM   * DE',
              amount: 92.53,
            },
            {
              txnDate: '2025-07-06',
              type: 'Journal Entry',
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              name: '',
              description: 'Invoices: Ains hoboken - 7/16/2025 - Shipping Fee',
              amount: 80,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 38.96,
          percent: 0.00046697255222869985,
          percentAVG: 0.0005,
          cellID: '975961bc_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 2,
          id: '975961bc_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Computer Supplies, Software & IT',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1550.67,
          amtAvg: 350.15,
          perc: 0,
          percAvg: 0.0047,
          dataRows: [
            {
              txnDate: '2025-07-15',
              type: 'Expense',
              eventId: '15443',
              num: '',
              name: 'Tripleseat',
              description: 'VISA DDA PUR AP - 490641     PST TRIPLESEAT              978 2916436   * MA',
              amount: 406.67,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15494',
              num: '',
              name: 'Toast Inc',
              description: 'TOAST, INC       TOAST, INC',
              amount: 1034,
            },
            {
              txnDate: '2025-07-09',
              type: 'Expense',
              eventId: '15261',
              num: '',
              name: 'MarginEdge',
              description: 'MARGINEDGE       XXXXXX9612',
              amount: 110,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 350.15,
          percent: 0.0041970690753172085,
          percentAVG: 0.0047,
          cellID: '9450bb96_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 3,
          id: '9450bb96_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Dues and Subscriptions',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 127.14,
          amtAvg: 28.71,
          perc: 0.0002,
          percAvg: 0.0004,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15529',
              num: '',
              name: 'Spotify',
              description: 'VISA DDA PUR AP - 420429     SPOTIFY USA                 877 7781161   * NY',
              amount: 12.78,
            },
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14844',
              num: '',
              name: 'Resy',
              description: 'RESYNETWORKINC   RESYNETWOR',
              amount: 114.36,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 28.71,
          percent: 0.00034411922732485305,
          percentAVG: 0.0004,
          cellID: '236c5723_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 2,
          id: '236c5723_@_18',
          index: 0,
          cPercent: 0.00017083935325942233,
        },
        {
          date: '2025-07-21',
          title: 'Bank Charges & Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.8400000000000003,
              stdDev: 1.3564659966250538,
            },
          },
          trxFlagged: [],
          amount: 230,
          amtAvg: 47.42,
          perc: 0.0012,
          percAvg: 0.0006,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15609',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15610',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15611',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14767',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14768',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14769',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '15203',
              num: '',
              name: 'Bank Charges',
              description: 'MAINTENANCE FEE',
              amount: 20,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14766',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 47.42,
          percent: 0.0006225218049765314,
          percentAVG: 0.0006,
          cellID: 'c3c23383_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 8,
          id: 'c3c23383_@_18',
          index: 0,
          cPercent: 0.0012030940370381855,
        },
        {
          date: '2025-07-21',
          title: 'Office Supplies & Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
            stats: {
              mean: 8.2,
              variance: 15.36,
              stdDev: 3.919183588453085,
            },
          },
          trxFlagged: [],
          amount: 6836.68,
          amtAvg: 1390.72,
          perc: 0.0471,
          percAvg: 0.0186,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15517',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 1086.51,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15518',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 318.9,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15519',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 51.17,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15638',
              num: '6502345',
              name: 'Meow Hospitality LLC',
              description: 'POD CHECK',
              amount: 1063,
            },
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15625',
              num: '',
              name: 'CVS Pharmacy',
              description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
              amount: 802.22,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15575',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 62.37,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15576',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 44.77,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15577',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 56.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15579',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 14.49,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15578',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 14.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15581',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 6.39,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15225',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 122.46,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15230',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 26.02,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15231',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 271.88,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15234',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 400.34,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15237',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 41.56,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15220',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 7.45,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15318',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 55.98,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15315',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 63.96,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15316',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 181.16,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15317',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 49.38,
            },
            {
              txnDate: '2025-07-18',
              type: 'Expense',
              eventId: '15323',
              num: '',
              name: 'The Home Depot',
              description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
              amount: 66.02,
            },
            {
              txnDate: '2025-07-07',
              type: 'Expense',
              eventId: '14730',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 19.18,
            },
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14727',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 13.53,
            },
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14731',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 1.75,
            },
            {
              txnDate: '2025-06-30',
              type: 'Expense',
              eventId: '14736',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 4.99,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14728',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 38.65,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14729',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 85.3,
            },
            {
              txnDate: '2025-07-02',
              type: 'Deposit',
              eventId: '14845',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA REF - 469216     AMAZON MKTPLACE PMTS        AMZN COM BILL * WA',
              amount: -244.17,
            },
            {
              txnDate: '2025-07-03',
              type: 'Check',
              eventId: '15334',
              num: '6502210',
              name: 'Meow Hospitality LLC',
              description: 'POD CHECK',
              amount: 1000,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14548',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 21.3,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14594',
              num: '',
              name: 'The Home Depot',
              description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
              amount: 127.91,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14596',
              num: '',
              name: 'CVS Pharmacy',
              description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
              amount: 771.5,
            },
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14565',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 46.04,
            },
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14566',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 15.98,
            },
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14567',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 6.39,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14732',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 23.35,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14733',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 42.64,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14726',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 7.85,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14734',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 19.18,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14735',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 27.98,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1390.72,
          percent: 0.01850427118976936,
          percentAVG: 0.0186,
          cellID: '058d9b25_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 41,
          id: '058d9b25_@_18',
          index: 0,
          cPercent: 0.04706931639662106,
        },
        {
          date: '2025-07-21',
          title: 'Phone and Internet',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 728.23,
          amtAvg: 88.8,
          perc: 0,
          percAvg: 0.0012,
          dataRows: [
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15495',
              num: '',
              name: 'Optimum',
              description: 'OPTIMUM 7862     CABLE PMNT',
              amount: 393.24,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14595',
              num: '',
              name: 'DirecTV',
              description: 'VISA DDA PUR AP - 469216     SPI DIRECTV SERVICE         800 531 5000  * CA',
              amount: 334.99,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 88.8,
          percent: 0.001971039365382867,
          percentAVG: 0.0012,
          cellID: '0c2b505e_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 2,
          id: '0c2b505e_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Security',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 950,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-06-27',
              type: 'Check',
              eventId: '14881',
              num: '6502082',
              name: 'Herve Bertrand',
              description: 'CHECK 6502082 Security',
              amount: 950,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0.0025712857162074124,
          percentAVG: 0,
          cellID: '9dc533d9_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '9dc533d9_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 20565.28,
          amtAvg: 2941.35,
          perc: 0.0649,
          percAvg: 0.0393,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2941.35,
          percent: 0.055662327067164175,
          percentAVG: 0.0393,
          cellID: 'f12db2ec_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'f12db2ec_@_18',
          index: 0,
          cPercent: 0.0649321882729879,
        },
        {
          date: '2025-07-21',
          title: 'Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '084f517c_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '084f517c_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Travel, Ground Transport & Airfare',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: 951.7,
          amtAvg: 175.05,
          perc: 0.0047,
          percAvg: 0.0023,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15606',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 60.9,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15607',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 81.87,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15603',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 52.21,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15605',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 54.38,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15604',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 50.67,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15608',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 55.09,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15219',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 50.7,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15264',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 55.25,
            },
            {
              txnDate: '2025-07-10',
              type: 'Expense',
              eventId: '15243',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 74.9,
            },
            {
              txnDate: '2025-07-10',
              type: 'Expense',
              eventId: '15246',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 54.38,
            },
            {
              txnDate: '2025-07-11',
              type: 'Expense',
              eventId: '15239',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 56.72,
            },
            {
              txnDate: '2025-07-11',
              type: 'Expense',
              eventId: '15263',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 49.02,
            },
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '14764',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 79.12,
            },
            {
              txnDate: '2025-06-23',
              type: 'Expense',
              eventId: '14581',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 68.96,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14765',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 50.66,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14841',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 56.87,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 175.05,
          percent: 0.002575886964331152,
          percentAVG: 0.0023,
          cellID: 'e4e1ab18_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 16,
          id: 'e4e1ab18_@_18',
          index: 0,
          cPercent: 0.004747141715922227,
        },
        {
          date: '2025-07-21',
          title: 'Meals & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 1140.72,
          amtAvg: 237.27,
          perc: 0.0012,
          percAvg: 0.0032,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15528',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 86.91,
            },
            {
              txnDate: '2025-07-14',
              type: 'Expense',
              eventId: '15329',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 71.17,
            },
            {
              txnDate: '2025-07-16',
              type: 'Check',
              eventId: '15468',
              num: '6502282',
              name: 'Mamma Mia',
              description: 'POD CHECK',
              amount: 800,
            },
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14834',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 92.67,
            },
            {
              txnDate: '2025-06-25',
              type: 'Expense',
              eventId: '14603',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 89.97,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 237.27,
          percent: 0.0030874916233601256,
          percentAVG: 0.0032,
          cellID: 'f245aeff_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 5,
          id: 'f245aeff_@_18',
          index: 0,
          cPercent: 0.0011617878084332078,
        },
        {
          date: '2025-07-21',
          title: 'Parking',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 2476,
          amtAvg: 279.55,
          perc: 0.0165,
          percAvg: 0.0037,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15621',
              num: '',
              name: 'Hoboken Parking',
              description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
              amount: 1238,
            },
            {
              txnDate: '2025-06-24',
              type: 'Expense',
              eventId: '14579',
              num: '',
              name: 'Hoboken Parking',
              description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
              amount: 1238,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 279.55,
          percent: 0.0067015825613995295,
          percentAVG: 0.0037,
          cellID: '3ae4b332_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 2,
          id: '3ae4b332_@_18',
          index: 0,
          cPercent: 0.016549226865036373,
        },
        {
          date: '2025-07-21',
          title: 'Fuel',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: 162.13,
          amtAvg: 23.71,
          perc: 0.0005,
          percAvg: 0.0003,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15583',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 34.01,
            },
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15260',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 36.01,
            },
            {
              txnDate: '2025-07-03',
              type: 'Expense',
              eventId: '14832',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 35,
            },
            {
              txnDate: '2025-06-26',
              type: 'Expense',
              eventId: '14833',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 475542     FUEL 4 GAS AND DIESEL       SECAUCUS      * NJ',
              amount: 30.1,
            },
            {
              txnDate: '2025-06-27',
              type: 'Expense',
              eventId: '14831',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 27.01,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 23.71,
          percent: 0.0004388237401775871,
          percentAVG: 0.0003,
          cellID: '4dbd49a9_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 5,
          id: '4dbd49a9_@_18',
          index: 0,
          cPercent: 0.00045463586888520765,
        },
        {
          date: '2025-07-21',
          title: 'Total Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4730.55,
          amtAvg: 715.58,
          perc: 0.0229,
          percAvg: 0.0096,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 715.58,
          percent: 0.012803784889268394,
          percentAVG: 0.0096,
          cellID: 'ea7ffa49_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'ea7ffa49_@_18',
          index: 0,
          cPercent: 0.022912792258277016,
        },
        {
          date: '2025-07-21',
          title: 'Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '1675dbe8_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '1675dbe8_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Repair & Maintenance, Equipment',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 5920.6,
          amtAvg: 551.33,
          perc: 0,
          percAvg: 0.0074,
          dataRows: [
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15436',
              num: '6502273',
              name: 'AZ Mechanical',
              description: 'CHECK 6502273',
              amount: 880,
            },
            {
              txnDate: '2025-07-14',
              type: 'Check',
              eventId: '15438',
              num: '6502272',
              name: 'AZ Mechanical',
              description: 'CHECK 6502272 HVAC',
              amount: 1150,
            },
            {
              txnDate: '2025-07-18',
              type: 'Check',
              eventId: '15506',
              num: '6502328',
              name: 'AIs Technical Incorporated',
              description: 'CHECK 6502328',
              amount: 411.6,
            },
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14854',
              num: '6502073',
              name: 'AZ Mechanical',
              description: 'CHECK 6502073 MS HVAC',
              amount: 3479,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 551.33,
          percent: 0.01602479390671327,
          percentAVG: 0.0074,
          cellID: 'aa06968c_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 4,
          id: 'aa06968c_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Repair & Maintenance, Facility',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
            stats: {
              mean: 1,
              variance: 1.2,
              stdDev: 1.0954451150103321,
            },
          },
          trxFlagged: [],
          amount: 7120.5,
          amtAvg: 1607.85,
          perc: 0.0238,
          percAvg: 0.0215,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15636',
              num: '6502326',
              name: 'Eileen Kim',
              description: 'CHECK 6502326 Electrical & plumbing work',
              amount: 1777.52,
            },
            {
              txnDate: '2025-07-15',
              type: 'Check',
              eventId: '15455',
              num: '6502087',
              name: 'American Garage Door',
              description: 'CHECK 6502087 Garage Door',
              amount: 1697.66,
            },
            {
              txnDate: '2025-07-07',
              type: 'Check',
              eventId: '15349',
              num: '6502085',
              name: 'American Garage Door',
              description: 'CHECK 6502085',
              amount: 1697.66,
            },
            {
              txnDate: '2025-07-08',
              type: 'Check',
              eventId: '15387',
              num: '6502144',
              name: 'Tekno Electric',
              description: 'CHECK 6502144',
              amount: 250,
            },
            {
              txnDate: '2025-07-10',
              type: 'Check',
              eventId: '15409',
              num: '6502086',
              name: 'American Garage Door',
              description: 'CHECK 6502086 Garage door',
              amount: 1697.66,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1607.85,
          percent: 0.0192724630971104,
          percentAVG: 0.0215,
          cellID: '4d40af10_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 5,
          id: '4d40af10_@_18',
          index: 0,
          cPercent: 0.023761374585734615,
        },
        {
          date: '2025-07-21',
          title: 'Pest Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1662.81,
          amtAvg: 118.65,
          perc: 0,
          percAvg: 0.0016,
          dataRows: [
            {
              txnDate: '2025-07-02',
              type: 'Expense',
              eventId: '15290',
              num: '',
              name: 'Liberty Pest',
              description: 'VISA DDA PUR AP - 403982     LIBERTY PEST CONTROL        718 8379030   * NY',
              amount: 525.46,
            },
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14851',
              num: '650103',
              name: 'Liberty Pest',
              description: 'CHECK 650103 1170053',
              amount: 505.49,
            },
            {
              txnDate: '2025-06-24',
              type: 'Check',
              eventId: '14855',
              num: '65014',
              name: 'Liberty Pest',
              description: 'CHECK 65014 1185730',
              amount: 631.86,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 118.65,
          percent: 0.004500589054491418,
          percentAVG: 0.0016,
          cellID: 'a044faba_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 3,
          id: 'a044faba_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Fire Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd6450b86_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'd6450b86_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 14703.910000000002,
          amtAvg: 2277.83,
          perc: 0.0238,
          percAvg: 0.0304,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2277.83,
          percent: 0.03979784605831509,
          percentAVG: 0.0304,
          cellID: '4da1092f_@_18_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '4da1092f_@_18',
          index: 0,
          cPercent: 0.023761374585734615,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL CONTROLLABLE EXPENSES',
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 54922.57000000001,
          amtAvg: 8134.97,
          perc: 0.1321,
          percAvg: 0.1087,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 8134.97,
          percent: 0.14865433656673868,
          percentAVG: 0.1087,
          cellID: 'a624f257_@_19_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'a624f257_@_19',
          index: 0,
          cPercent: 0.1320736582293236,
        },
        {
          date: '2025-07-21',
          title: 'Controllable Profit',
          path: ['Controllable Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 50915.209999999985,
          amtAvg: 25565.700000000004,
          perc: 0.3184,
          percAvg: 0.3418,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 25565.700000000004,
          percent: 0.13780794969547447,
          percentAVG: 0.3418,
          cellID: 'a973b710_@_20_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'a973b710_@_20',
          index: 0,
          cPercent: 0.3184271764505839,
        },
        {
          date: '2025-07-21',
          title: 'NON-CONTROLLABLE EXPENSES',
          path: ['NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '79208dfc_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '79208dfc_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '52e26b6b_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '52e26b6b_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Rent/Lease',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18437.33,
          amtAvg: 4163.27,
          perc: 0,
          percAvg: 0.0557,
          dataRows: [
            {
              txnDate: '2025-07-16',
              type: 'Expense',
              eventId: '15470',
              num: '',
              name: 'Ironstate Proper',
              description: 'IRONSTATE PROPER SIGONFILE',
              amount: 18437.33,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 4163.27,
          percent: 0.04990278239368675,
          percentAVG: 0.0557,
          cellID: '68876c4f_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '68876c4f_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Utility, Electricity',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '208dfabc_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '208dfabc_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Utility, Gas',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 430.96,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-06-27',
              type: 'Bill',
              eventId: '15215',
              num: '80547688',
              name: 'NuCO2',
              description: '',
              amount: 430.96,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0.0011664434655334172,
          percentAVG: 0,
          cellID: 'c9446d9c_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: 'c9446d9c_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 18868.29,
          amtAvg: 4163.27,
          perc: 0,
          percAvg: 0.0557,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 4163.27,
          percent: 0.05106922585922016,
          percentAVG: 0.0557,
          cellID: '20d5762f_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '20d5762f_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '763b7c77_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '763b7c77_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Other Income/Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1.01,
          amtAvg: -0.23,
          perc: 0,
          percAvg: 0,
          dataRows: [
            {
              txnDate: '2025-07-07',
              type: 'Deposit',
              eventId: '15382',
              num: '',
              name: 'Toast Inc',
              description: 'TOAST            EOM JUN 30',
              amount: -1.01,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -0.23,
          percent: 0,
          percentAVG: 0,
          cellID: '91f38f9a_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 1,
          id: '91f38f9a_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'To Be Classified P&L',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.56,
              stdDev: 0.7483314773547883,
            },
          },
          trxFlagged: [],
          amount: 5849.4800000000005,
          amtAvg: 993.74,
          perc: 0.0262,
          percAvg: 0.0133,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15657',
              num: '6502339',
              name: 'Roberto Averos',
              description: 'CHECK 6502339',
              amount: 1960,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15496',
              num: '',
              name: 'Unknown',
              description: 'BENEFITHEALTHPLA WEBPAYMENT',
              amount: 987.26,
            },
            {
              txnDate: '2025-07-17',
              type: 'Expense',
              eventId: '15497',
              num: '',
              name: 'Unknown',
              description: 'BENEFITHEALTHPLA WEBPAYMENT',
              amount: 1453.59,
            },
            {
              txnDate: '2025-06-23',
              type: 'Check',
              eventId: '14677',
              num: '6502078',
              name: 'David Conte',
              description: 'CHECK 6502078',
              amount: 1448.63,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 993.74,
          percent: 0.015832299338148354,
          percentAVG: 0.0133,
          cellID: '5ccef3e9_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 4,
          id: '5ccef3e9_@_21',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'Total Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 5848.47,
          amtAvg: 993.51,
          perc: 0.0262,
          percAvg: 0.0133,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 993.51,
          percent: 0.015829565655439543,
          percentAVG: 0.0133,
          cellID: 'd4b5a9af_@_21_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'd4b5a9af_@_21',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL NON-CONTROLLABLE EXPENSES',
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 24716.760000000002,
          amtAvg: 5156.78,
          perc: 0.0262,
          percAvg: 0.0689,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5156.78,
          percent: 0.0668987915146597,
          percentAVG: 0.0689,
          cellID: '1851dc59_@_22_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '1851dc59_@_22',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'Operating Profit',
          path: ['Operating Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 26198.44999999999,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.0709091581808148,
          percentAVG: 0.2728,
          cellID: '251b8ac6_@_23_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '251b8ac6_@_23',
          index: 0,
          cPercent: 0.2922264618661967,
        },
        {
          date: '2025-07-21',
          title: 'Other Expenses',
          path: ['Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '5e10c38d_@_24_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '5e10c38d_@_24',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Loan Interest',
          path: ['Other Expenses', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '13e3a076_@_24_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '13e3a076_@_24',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Other Expenses',
          path: ['Total Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'caeb87a7_@_25_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'caeb87a7_@_25',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'EBITDA',
          path: ['EBITDA'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 26198.44999999999,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.0709091581808148,
          percentAVG: 0.2728,
          cellID: 'e815a21e_@_26_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'e815a21e_@_26',
          index: 0,
          cPercent: 0.2922264618661967,
        },
        {
          date: '2025-07-21',
          title: 'Interest, Taxes, Depreciation and Amortization',
          path: ['Interest, Taxes, Depreciation and Amortization'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '644555ee_@_27_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '644555ee_@_27',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Loan Interest',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'dce93088_@_27_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'dce93088_@_27',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Interest, Taxes, Depreciation and Amortization',
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'b4184eff_@_28_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: 'b4184eff_@_28',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'NET PROFIT',
          path: ['NET PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 26198.44999999999,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.0709091581808148,
          percentAVG: 0.2728,
          cellID: '9b50fa7c_@_29_-x-_1',
          baseAmount: 369464.97,
          transactions: 0,
          id: '9b50fa7c_@_29',
          index: 0,
          cPercent: 0.2922264618661967,
        },
      ],
      total: true,
      periodReporting: false,
      originType: 'Synthetic Total',
    },
    differenceColumn: {
      name: 'Difference',
      date: {
        start: 'Δ Difference',
        end: '',
      },
      type: [
        {
          type: 'Direct',
          index: 0,
        },
      ],
      data: [
        {
          date: '2025-07-21',
          title: 'SALES',
          path: ['SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '5bc89b03_@_2_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '5bc89b03_@_2',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Food',
          path: ['SALES', 'Sales, Food'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [49465.17],
            anomalyScores: [0, 0, 0, 0.9655051293968633, 0],
            stats: {
              mean: 40779.536,
              variance: 20231770.394503992,
              stdDev: 4497.974032217615,
            },
          },
          trxAnomaly: {
            anomalies: [8],
            anomalyScores: [0, 0, 0, 0.9999999999999999, 0],
            stats: {
              mean: 7.2,
              variance: 0.15999999999999998,
              stdDev: 0.39999999999999997,
            },
          },
          trxFlagged: [],
          amount: -123651.68,
          perc: 0.5278,
          percAvg: 0.5278,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 4814.5,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 4276,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 4525,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 3727,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 3850,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 12032.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 6898,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -1.6569999999999998,
          percentAVG: 0.5278,
          cellID: 'c5601bf4_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: 'c5601bf4_@_2',
          index: 0,
          cPercent: 0.5277632430125925,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Liquor',
          path: ['SALES', 'Sales, Liquor'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [26219.51],
            anomalyScores: [0, 0, 0, 0.9009942644979041, 0],
            stats: {
              mean: 20895.703999999998,
              variance: 8728515.724423997,
              stdDev: 2954.406154276016,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [
            {
              id: 'f5f466b6-1069-4f73-b141-8e3c89f3fe16',
              index: 6,
              account: '4110 Revenue / Sales:Sales, Liquor',
              type: 'trx',
              status: 'inProgress',
              period: '2025-07-23',
              createdAt: '2025-07-29 16:09:56',
              amount: 1629,
              transaction: {
                id: 'e252f492-4b2a-4e34-a610-4f77c5f721e1',
                memo: '',
                name: '',
                trxType: 'Journal Entry',
              },
            },
          ],
          amount: -60399.52,
          amtAvg: 22039.5,
          perc: 0.2899,
          percAvg: 0.2899,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 1294,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 1490,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 1629,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 1811,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 2589,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 8862.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 4364,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 22039.5,
          percent: -0.8057,
          percentAVG: 0.2899,
          cellID: 'e1ca5621_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: 'e1ca5621_@_2',
          index: 0,
          cPercent: 0.2898995088696267,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Beer',
          path: ['SALES', 'Sales, Beer'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 5524.8,
              variance: 481194.9600000001,
              stdDev: 693.6821750629031,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 14,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -17174,
          amtAvg: 5225,
          perc: 0.0687,
          percAvg: 0.0687,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 97,
            },
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 376,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 110,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 542,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 61,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 474,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 20,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 347,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 107,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 503,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 600,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 1413,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 151,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 424,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5225,
          percent: -0.2315,
          percentAVG: 0.0687,
          cellID: 'ba0b0910_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 14,
          id: 'ba0b0910_@_2',
          index: 0,
          cPercent: 0.06872773583084005,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Wine',
          path: ['SALES', 'Sales, Wine'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1252],
            anomalyScores: [0, 0, -0.8223224909788607, 0, 0],
            stats: {
              mean: 1578,
              variance: 39290.8,
              stdDev: 198.21907072731423,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [
            {
              id: '1e4fc649-e738-40ac-af2f-98fa638ac3fe',
              index: 4,
              account: '4120 Revenue / Sales:Sales, Wine',
              type: 'trx',
              status: 'inProgress',
              period: '2025-07-24',
              createdAt: '2025-07-29 16:58:53',
              amount: 248,
              transaction: {
                id: '88c5af13-7511-4e18-a7a0-e4757e221dce',
                memo: '',
                name: '',
                trxType: 'Journal Entry',
              },
            },
          ],
          amount: -4168,
          amtAvg: 1861,
          perc: 0.0245,
          percAvg: 0.0245,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 156,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 205,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 342,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 248,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 267,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 489,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 154,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1861,
          percent: -0.0568,
          percentAVG: 0.0245,
          cellID: '2f14959f_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '2f14959f_@_2',
          index: 0,
          cPercent: 0.02447891222606571,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Non-Alcoholic Beverage',
          path: ['SALES', 'Sales, Non-Alcoholic Beverage'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2616.6,
              variance: 59473.44,
              stdDev: 243.87176958393525,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -7885,
          amtAvg: 2599,
          perc: 0.0342,
          percAvg: 0.0342,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 333,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 316,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 243,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 266,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 205,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 701,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 535,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2599,
          percent: -0.1069,
          percentAVG: 0.0342,
          cellID: '7bb557b1_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '7bb557b1_@_2',
          index: 0,
          cPercent: 0.03418629386112025,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Miscellaneous',
          path: ['SALES', 'Sales, Miscellaneous'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [95],
            anomalyScores: [0, 0, 0, 0, -0.9060631469462755],
            stats: {
              mean: 2534.4740000000006,
              variance: 1812238.9630240002,
              stdDev: 1346.194251593729,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, -0.7717436331412898],
            stats: {
              mean: 3.8,
              variance: 1.3599999999999999,
              stdDev: 1.16619037896906,
            },
          },
          trxFlagged: [],
          amount: -7150.77,
          perc: 0.0363,
          percAvg: 0.0363,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 2542.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 86,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 80,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 52,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0911,
          percentAVG: 0.0363,
          cellID: 'cbede411_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 4,
          id: 'cbede411_@_2',
          index: 0,
          cPercent: 0.03631455178598722,
        },
        {
          date: '2025-07-21',
          title: 'Sales, Service Charges',
          path: ['SALES', 'Sales, Service Charges'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1199.15],
            anomalyScores: [0, 0, 0, 0, -0.7607630997669528],
            stats: {
              mean: 1315.116,
              variance: 5809.014823999995,
              stdDev: 76.21689329800839,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -3742.94,
          perc: 0.0186,
          percAvg: 0.0186,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: 106.75,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: 177.13,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: 227.71,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: 127.6,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: 117.39,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: 470.49,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: 189.25,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.051000000000000004,
          percentAVG: 0.0186,
          cellID: '4e12e939_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '4e12e939_@_2',
          index: 0,
          cPercent: 0.018629754413767536,
        },
        {
          date: '2025-07-21',
          title: 'Sales - No category',
          path: ['SALES', 'Sales - No category'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'a1f04b4c_@_2_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: 'a1f04b4c_@_2',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'GROSS SALES',
          path: ['GROSS SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [92158.61],
            anomalyScores: [0, 0, 0, 0.9487029524917497, 0],
            stats: {
              mean: 75244.23000000001,
              variance: 79467887.97148004,
              stdDev: 8914.476315043978,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -224171.90999999997,
          amtAvg: 76024.62000000001,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 76024.62000000001,
          percent: 0,
          cellID: '74405d1a_@_3_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: '74405d1a_@_3',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Comps & Discounts',
          path: ['Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'ba9fcd64_@_6_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: 'ba9fcd64_@_6',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Discounts and Comps',
          path: ['Comps & Discounts', 'Discounts and Comps'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4321.18,
          perc: -0.016,
          percAvg: -0.016,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Journal Entry',
              eventId: '15356',
              num: 'MJ1878ME',
              name: '',
              description: '',
              amount: -177.25,
            },
            {
              txnDate: '2025-07-22',
              type: 'Journal Entry',
              eventId: '15357',
              num: 'MJ1879ME',
              name: '',
              description: '',
              amount: -84.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Journal Entry',
              eventId: '15530',
              num: 'MJ1883ME',
              name: '',
              description: '',
              amount: -59.5,
            },
            {
              txnDate: '2025-07-24',
              type: 'Journal Entry',
              eventId: '15531',
              num: 'MJ1887ME',
              name: '',
              description: '',
              amount: -117.75,
            },
            {
              txnDate: '2025-07-25',
              type: 'Journal Entry',
              eventId: '15561',
              num: 'MJ1888ME',
              name: '',
              description: '',
              amount: -144,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15572',
              num: 'MJ1890ME',
              name: '',
              description: '',
              amount: -320.5,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15573',
              num: 'MJ1934ME',
              name: '',
              description: '',
              amount: -314,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.056600000000000004,
          percentAVG: -0.016,
          cellID: '4936addc_@_6_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 7,
          id: '4936addc_@_6',
          index: 0,
          cPercent: -0.01601454897110962,
        },
        {
          date: '2025-07-21',
          title: 'Total Comps & Discounts',
          path: ['Total Comps & Discounts'],
          baseRef: 'GROSS SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-2053.88],
            anomalyScores: [0, 0, 0, -0.9587679795170329, 0],
            stats: {
              mean: -1351.236,
              variance: 134271.44118400002,
              stdDev: 366.43067718737746,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 4321.18,
          amtAvg: -1217.5,
          perc: -0.016,
          percAvg: -0.016,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -1217.5,
          percent: 0.056600000000000004,
          percentAVG: -0.016,
          cellID: '8a448d4b_@_7_-x-_1',
          baseAmount: 76024.62000000001,
          transactions: 0,
          id: '8a448d4b_@_7',
          index: 0,
          cPercent: -0.01601454897110962,
        },
        {
          date: '2025-07-21',
          title: 'NET SALES',
          path: ['NET SALES'],
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [90104.73],
            anomalyScores: [0, 0, 0, 0.9449813421421022, 0],
            stats: {
              mean: 73892.99399999999,
              variance: 73578780.70850402,
              stdDev: 8577.807453452428,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -219850.72999999995,
          amtAvg: 74807.12000000001,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 74807.12000000001,
          percent: 0,
          cellID: '3b5cefb1_@_8_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '3b5cefb1_@_8',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'COST OF GOODS SOLD (COGS)',
          path: ['COST OF GOODS SOLD (COGS)'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '753db221_@_9_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '753db221_@_9',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Food',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Food'],
          baseRef: 'Sales, Food',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2621.67],
            anomalyScores: [0, 0, 0.7657238118238597, 0, 0],
            stats: {
              mean: 1421.26,
              variance: 614405.2425200001,
              stdDev: 783.8400618238392,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.4,
              variance: 1.4400000000000002,
              stdDev: 1.2000000000000002,
            },
          },
          trxFlagged: [],
          amount: -3014.2599999999998,
          perc: 0.051,
          percAvg: 0.051,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15521',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 374.85,
            },
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15622',
              num: '',
              name: 'Ferro & Sons, Inc.',
              description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
              amount: 1089.11,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15594',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 117.28,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15595',
              num: '',
              name: 'Restaurant Depot',
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              amount: 464.78,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.07650000000000001,
          percentAVG: 0.051,
          cellID: '7a94d93b_@_9_-x-_1',
          baseAmount: 40123,
          transactions: 4,
          id: '7a94d93b_@_9',
          index: 0,
          cPercent: 0.050993694389751515,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Meat & Poultry',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Meat & Poultry'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3127.43],
            anomalyScores: [0, 0, -0.763586046627646, 0, 0],
            stats: {
              mean: 3579.3360000000002,
              variance: 87562.92414400002,
              stdDev: 295.9103312559398,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0.8017837257372733, 0, 0, 0, 0],
            stats: {
              mean: 3.8,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: -10329.539999999999,
          perc: 0.0506,
          percAvg: 0.0506,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 48.99,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 195.86,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 1591.81,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 1555.39,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 391.52,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.1443,
          percentAVG: 0.0506,
          cellID: '3f46fcce_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 5,
          id: '3f46fcce_@_9',
          index: 0,
          cPercent: 0.050577672285739644,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Seafood',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Seafood'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 409.418,
              variance: 6520.799336000002,
              stdDev: 80.75146646346431,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 0.96,
              stdDev: 0.9797958971132712,
            },
          },
          trxFlagged: [],
          amount: -1373.69,
          perc: 0.0045,
          percAvg: 0.0045,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 19.99,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 181.2,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 113.12,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 22.39,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0195,
          percentAVG: 0.0045,
          cellID: '2bdeb0ad_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 4,
          id: '2bdeb0ad_@_9',
          index: 0,
          cPercent: 0.004500908469675078,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Produce',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Produce'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [530.45],
            anomalyScores: [0, 0, 0, 0, -0.9634544716211021],
            stats: {
              mean: 3267.802,
              variance: 2018082.4716559995,
              stdDev: 1420.5922960709029,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, 0, -0.9146591207600472],
            stats: {
              mean: 7.4,
              variance: 12.24,
              stdDev: 3.4985711369071804,
            },
          },
          trxFlagged: [],
          amount: -8587.81,
          perc: 0.0518,
          percAvg: 0.0518,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15525',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 674.46,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15526',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 35.75,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15527',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
              amount: 576.26,
            },
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 433.25,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 180.25,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15544',
              num: '712755',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 150.68,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15615',
              num: '',
              name: 'Baldor Specialty Foods Inc.',
              description: 'BALDOR SPECIALTY BALDOR SPE',
              amount: 986.9,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 187.5,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 451.8,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 198.75,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.11349999999999999,
          percentAVG: 0.0518,
          cellID: '593c4b13_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 10,
          id: '593c4b13_@_9',
          index: 0,
          cPercent: 0.0518079027771688,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Grocery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Grocery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 7462.322,
              variance: 18904853.627936,
              stdDev: 4347.971208268978,
            },
          },
          trxAnomaly: {
            anomalies: [11],
            anomalyScores: [0, 0, 0.8255929830036747, 0, 0],
            stats: {
              mean: 7.6,
              variance: 4.24,
              stdDev: 2.0591260281974,
            },
          },
          trxFlagged: [],
          amount: -31916.71,
          perc: 0.0361,
          percAvg: 0.0361,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 26.37,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 99,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 1225.26,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 1141.98,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 32.31,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 98.85,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15545',
              num: 'MI1904ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 31.92,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15546',
              num: 'MI1903ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 41.76,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.462,
          percentAVG: 0.0361,
          cellID: 'e0037727_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 8,
          id: 'e0037727_@_9',
          index: 0,
          cPercent: 0.03605873344676282,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bakery',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bakery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1630.48],
            anomalyScores: [0, 0, 0, 0, 0.8560115059802932],
            stats: {
              mean: 763.7439999999999,
              variance: 256303.46354400003,
              stdDev: 506.2642230535356,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [-0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: -3729.1200000000003,
          perc: 0.0006,
          percAvg: 0.0006,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 44.8,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.052700000000000004,
          percentAVG: 0.0006,
          cellID: '47294ea3_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '47294ea3_@_9',
          index: 0,
          cPercent: 0.0005988734762145634,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Dairy',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Dairy'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1228.65],
            anomalyScores: [0, 0.8329806368948148, 0, 0, 0],
            stats: {
              mean: 1052.1200000000001,
              variance: 11228.125000000011,
              stdDev: 105.96284726261375,
            },
          },
          trxAnomaly: {
            anomalies: [7],
            anomalyScores: [0.82915619758885, 0, 0, 0, 0],
            stats: {
              mean: 4.8,
              variance: 1.7600000000000002,
              stdDev: 1.32664991614216,
            },
          },
          trxFlagged: [],
          amount: -3162.38,
          perc: 0.014,
          percAvg: 0.014,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 68.24,
            },
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15548',
              num: 'IV101-0027063549',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 68.74,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 335.06,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15544',
              num: '712755',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 115,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 293.08,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 59.09,
            },
            {
              txnDate: '2025-07-26',
              type: 'Journal Entry',
              eventId: '15547',
              num: 'MI1900ME',
              name: '',
              description: 'Vendor: Baldor Specialty Foods Inc.',
              amount: 109.9,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.043899999999999995,
          percentAVG: 0.014,
          cellID: '841fc412_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 7,
          id: '841fc412_@_9',
          index: 0,
          cPercent: 0.014024199835523674,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Liquor',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Liquor'],
          baseRef: 'Sales, Liquor',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3551.5199999999995,
              variance: 2218108.5819999995,
              stdDev: 1489.331589002261,
            },
          },
          trxAnomaly: {
            anomalies: [10],
            anomalyScores: [0, 0, 0, 0.9333456062030596, 0],
            stats: {
              mean: 4.8,
              variance: 7.76,
              stdDev: 2.7856776554368237,
            },
          },
          trxFlagged: [],
          amount: -6367.300000000001,
          amtAvg: 5695.15,
          perc: 0.2584,
          percAvg: 0.2584,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 1216.77,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15569',
              num: '866618',
              name: 'Allied Beverages',
              description: '',
              amount: 68.38,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15653',
              num: '6502348',
              name: 'Allied Beverages',
              description: 'CHECK 6502348',
              amount: 1483.07,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15571',
              num: '870345',
              name: 'Allied Beverages',
              description: '',
              amount: 1992.45,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15620',
              num: '',
              name: 'Fedway',
              description: 'FEDWAY ASSOCIATE FEDWAY ASS',
              amount: 934.48,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5695.15,
          percent: -0.3182,
          percentAVG: 0.2584,
          cellID: '6eb26171_@_9_-x-_1',
          baseAmount: 22039.5,
          transactions: 5,
          id: '6eb26171_@_9',
          index: 0,
          cPercent: 0.2584064974250777,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bar Groceries',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bar Groceries'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [182.06],
            anomalyScores: [0.858758349427589, 0, 0, 0, 0],
            stats: {
              mean: 80.854,
              variance: 3472.246784,
              stdDev: 58.92577351210589,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0.9185586535436917, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.9600000000000002,
              stdDev: 0.9797958971132713,
            },
          },
          trxFlagged: [],
          amount: -40.14999999999999,
          perc: 0.0024,
          percAvg: 0.0024,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Bill',
              eventId: '15565',
              num: '862670',
              name: 'Allied Beverages',
              description: '',
              amount: 59,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15563',
              num: '9262982',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15562',
              num: '9265170',
              name: 'Performance Food Service',
              description: '',
              amount: 61.53,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0006000000000000002,
          percentAVG: 0.0024,
          cellID: '15101cdc_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: '15101cdc_@_9',
          index: 0,
          cPercent: 0.002433725559813023,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Beer'],
          baseRef: 'Sales, Beer',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -435.87,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: -0.0925,
          percentAVG: 0,
          cellID: '90be8534_@_9_-x-_1',
          baseAmount: 5225,
          transactions: 0,
          id: '90be8534_@_9',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Draught Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Draught Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3631.5],
            anomalyScores: [0, 0.990370616654923, 0, 0, 0],
            stats: {
              mean: 887,
              variance: 1919866.3,
              stdDev: 1385.5924003833163,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0.9429278356405683, 0, 0, 0],
            stats: {
              mean: 1.8,
              variance: 4.960000000000001,
              stdDev: 2.227105745132009,
            },
          },
          trxFlagged: [],
          amount: -3419,
          perc: 0.0068,
          percAvg: 0.0068,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15553',
              num: '627286',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 413,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15558',
              num: '3733797',
              name: 'Peerless Beverage',
              description: '',
              amount: 95,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0507,
          percentAVG: 0.0068,
          cellID: '3395a498_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 2,
          id: '3395a498_@_9',
          index: 0,
          cPercent: 0.006790797453504425,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Bottled Beer',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Bottled Beer'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 321.71999999999997,
              variance: 34843.0336,
              stdDev: 186.66288758079364,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: -731.4,
          perc: 0.0059,
          percAvg: 0.0059,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15553',
              num: '627286',
              name: 'Northern Eagle Beverage',
              description: '',
              amount: 52.6,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15558',
              num: '3733797',
              name: 'Peerless Beverage',
              description: '',
              amount: 349,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15559',
              num: '3733798',
              name: 'Peerless Beverage',
              description: '',
              amount: 37,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0103,
          percentAVG: 0.0059,
          cellID: 'e2c4f57e_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: 'e2c4f57e_@_9',
          index: 0,
          cPercent: 0.0058630782738327576,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Wine',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Wine'],
          baseRef: 'Sales, Wine',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1132.352,
              variance: 466697.673056,
              stdDev: 683.152745040229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 2.4,
              variance: 1.8399999999999999,
              stdDev: 1.3564659966250536,
            },
          },
          trxFlagged: [],
          amount: -3100,
          amtAvg: 1280.88,
          perc: 0.6883,
          percAvg: 0.6883,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15569',
              num: '866618',
              name: 'Allied Beverages',
              description: '',
              amount: 145.08,
            },
            {
              txnDate: '2025-07-24',
              type: 'Bill',
              eventId: '15571',
              num: '870345',
              name: 'Allied Beverages',
              description: '',
              amount: 325.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15550',
              num: '723293',
              name: 'Gallo Wine Sales',
              description: '',
              amount: 810,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1280.88,
          percent: -2.2227,
          percentAVG: 0.6883,
          cellID: 'b29ce542_@_9_-x-_1',
          baseAmount: 1861,
          transactions: 3,
          id: 'b29ce542_@_9',
          index: 0,
          cPercent: 0.6882751209027406,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Non-Alcoholic',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Non-Alcoholic'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [78.71],
            anomalyScores: [0, 0, 0, 0, -0.7768231784930022],
            stats: {
              mean: 1208.614,
              variance: 528906.312224,
              stdDev: 727.2594531692249,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0, 0, 0.784464540552736, 0, 0],
            stats: {
              mean: 4.4,
              variance: 1.04,
              stdDev: 1.019803902718557,
            },
          },
          trxFlagged: [],
          amount: -2978.57,
          amtAvg: 1532.25,
          perc: 0.0205,
          percAvg: 0.0205,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15568',
              num: 'IV101-0027056103',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 77.62,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15637',
              num: '6502336',
              name: 'Peerless Beverage',
              description: 'CHECK 6502336',
              amount: 1311.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 19.26,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 75.37,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15567',
              num: 'IV101-0027082856',
              name: 'Baldor Specialty Foods Inc.',
              description: '',
              amount: 48.5,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1532.25,
          percent: -0.038099999999999995,
          percentAVG: 0.0205,
          cellID: '9f08e50d_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 5,
          id: '9f08e50d_@_9',
          index: 0,
          cPercent: 0.02048267598057511,
        },
        {
          date: '2025-07-21',
          title: 'COGS, Packaging',
          path: ['COST OF GOODS SOLD (COGS)', 'COGS, Packaging'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 259.672,
              variance: 11114.769296000002,
              stdDev: 105.42660620545462,
            },
          },
          trxAnomaly: {
            anomalies: [1, 3],
            anomalyScores: [0, 0, 0, -0.7905694150420948, 0.7905694150420948],
            stats: {
              mean: 2,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: -919.46,
          perc: 0.0025,
          percAvg: 0.0025,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 129.66,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 59.79,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0132,
          percentAVG: 0.0025,
          cellID: '027a424d_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 2,
          id: '027a424d_@_9',
          index: 0,
          cPercent: 0.0025325129479653805,
        },
        {
          date: '2025-07-21',
          title: 'Shipping, Freight and Delivery',
          path: ['COST OF GOODS SOLD (COGS)', 'Shipping, Freight and Delivery'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 387.04,
          perc: 0.0052,
          percAvg: 0.0052,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Check',
              eventId: '15649',
              num: '6502338',
              name: 'Campos Delivery LLC',
              description: 'CHECK 6502338',
              amount: 387.04,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0.0052,
          percentAVG: 0.0052,
          cellID: 'dfae81d5_@_9_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'dfae81d5_@_9',
          index: 0,
          cPercent: 0.005173839067725104,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL COGS',
          path: ['TOTAL COGS'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 25562.316,
              variance: 27743880.639304,
              stdDev: 5267.246020389023,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -79718.21999999999,
          amtAvg: 24046.680000000004,
          perc: 0.3214,
          percAvg: 0.3214,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 24046.680000000004,
          percent: -1.1173000000000002,
          percentAVG: 0.3214,
          cellID: '528a97f9_@_10_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '528a97f9_@_10',
          index: 0,
          cPercent: 0.3214490813173933,
        },
        {
          date: '2025-07-21',
          title: 'GROSS PROFIT',
          path: ['GROSS PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [67975.45999999999],
            anomalyScores: [0, 0, 0, 0.872263803844029, 0],
            stats: {
              mean: 48330.678,
              variance: 126805687.84233598,
              stdDev: 11260.80316151277,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -140132.50999999998,
          amtAvg: 50760.44,
          perc: 0.6786,
          percAvg: 0.6786,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 50760.44,
          percent: -1.8826999999999998,
          percentAVG: 0.6786,
          cellID: '7b400e74_@_12_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '7b400e74_@_12',
          index: 0,
          cPercent: 0.6785509186826066,
        },
        {
          date: '2025-07-21',
          title: 'OPERATING EXPENSES',
          path: ['OPERATING EXPENSES'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [74613.1],
            anomalyScores: [0, 0.8806559255009395, 0, 0, 0],
            stats: {
              mean: 43090.988,
              variance: 320300857.26885605,
              stdDev: 17896.951060693442,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -157655.3,
          amtAvg: 30351.52,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 30351.52,
          percent: 0,
          cellID: '39d9c4d4_@_13_-x-_1',
          baseAmount: 28899.82,
          transactions: 0,
          id: '39d9c4d4_@_13',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'LABOR',
          path: ['LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '5b0fe671_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '5b0fe671_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Direct Labor',
          path: ['LABOR', 'Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'bb2363da_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'bb2363da_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Labor Other',
          path: ['LABOR', 'Direct Labor', 'Labor Other'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 20617.188000000002,
              variance: 128448599.96581598,
              stdDev: 11333.516663675753,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 30,
              variance: 456.4,
              stdDev: 21.36352030916253,
            },
          },
          trxFlagged: [],
          amount: -75300.04,
          perc: 0.1857,
          percAvg: 0.1857,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15639',
              num: '6502305',
              name: 'Samantha Lada',
              description: 'POD CHECK  Payroll W.E. 07.06.2025',
              amount: 769.89,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15640',
              num: '6502320',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502320 Payroll W.E. 07.06.2025',
              amount: 684.47,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15641',
              num: '6502308',
              name: 'Olivia Mandez',
              description: 'CHECK 6502308 Payroll W.E. 07.06.2025',
              amount: 678.27,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15642',
              num: '6502266',
              name: 'Ramirez, Jesus Sarmiento',
              description: 'CHECK 6502266 Payroll W.E. 06.29.2025',
              amount: 606.87,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15643',
              num: '6502323',
              name: 'Anthony Sanchez',
              description: 'CHECK 6502323 Payroll W.E. 07.06.2025',
              amount: 606.26,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15644',
              num: '6502285',
              name: 'Cantillano Cardenas, Lila',
              description: 'CHECK 6502285 Payroll W.E. 07.06.2025',
              amount: 329.53,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15645',
              num: '6502304',
              name: 'Christopher Intriago',
              description: 'CHECK 6502304 Payroll W.E. 07.06.2025',
              amount: 193,
            },
            {
              txnDate: '2025-07-22',
              type: 'Check',
              eventId: '15650',
              num: '6502321',
              name: 'Manuel Ramirez',
              description: 'CHECK 6502321 Payroll W.E. 07.06.2025',
              amount: 362.39,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15652',
              num: '6502358',
              name: 'Domingo Roman',
              description: 'POD CHECK Payroll W.E. 07.13.2025',
              amount: 1511,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15654',
              num: '6502349',
              name: 'Omar Lopez',
              description: 'CHECK 6502349 Payroll W.E. 07.13.2025',
              amount: 588.1,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15655',
              num: '6502355',
              name: 'Hernandez-Canel, Esteban',
              description: 'CHECK 6502355 Payroll W.E. 07.13.2025',
              amount: 569.02,
            },
            {
              txnDate: '2025-07-23',
              type: 'Check',
              eventId: '15656',
              num: '6502354',
              name: 'Cruz Hernandez, Pedro',
              description: 'CHECK 6502354 Payroll W.E. 07.13.2025',
              amount: 494.15,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'Other',
              amount: 6500,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -1.0491,
          percentAVG: 0.1857,
          cellID: '687f4cd2_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 13,
          id: '687f4cd2_@_14',
          index: 0,
          cPercent: 0.18571694779855177,
        },
        {
          date: '2025-07-21',
          title: 'Labor, Management',
          path: ['LABOR', 'Direct Labor', 'Labor, Management'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [6486.95],
            anomalyScores: [0, 0.939954670660601, 0, 0, 0],
            stats: {
              mean: 3210.0299999999997,
              variance: 3038490.3835999994,
              stdDev: 1743.1266114657303,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -11561.95,
          perc: 0.03,
          percAvg: 0.03,
          dataRows: [
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'Management',
              amount: 2244.1,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.16,
          percentAVG: 0.03,
          cellID: '529343c4_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '529343c4_@_14',
          index: 0,
          cPercent: 0.029998481427971024,
        },
        {
          date: '2025-07-21',
          title: 'Labor, BOH',
          path: ['LABOR', 'Direct Labor', 'Labor, BOH'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [5121.55],
            anomalyScores: [0, 0.9999999999999998, 0, 0, 0],
            stats: {
              mean: 2393.5420000000004,
              variance: 1860506.9120160001,
              stdDev: 1364.0040000000001,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -8544.630000000001,
          perc: 0.0229,
          percAvg: 0.0229,
          dataRows: [
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'BOH',
              amount: 1711.54,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.12150000000000001,
          percentAVG: 0.0229,
          cellID: '3c61733f_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '3c61733f_@_14',
          index: 0,
          cPercent: 0.0228793729794704,
        },
        {
          date: '2025-07-21',
          title: 'Total Direct Labor',
          path: ['LABOR', 'Total Direct Labor'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 26220.76,
              variance: 165285310.36244,
              stdDev: 12856.33347274564,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -95406.62,
          amtAvg: 17848.59,
          perc: 0.2386,
          percAvg: 0.2386,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 17848.59,
          percent: -1.3306,
          percentAVG: 0.2386,
          cellID: '143a84db_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '143a84db_@_14',
          index: 0,
          cPercent: 0.2385948022059932,
        },
        {
          date: '2025-07-21',
          title: 'Labor Related Expenses',
          path: ['LABOR', 'Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'dacf6533_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'dacf6533_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Commission/Bonus/Incentives',
          path: ['LABOR', 'Labor Related Expenses', 'Commission/Bonus/Incentives'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -539,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0079,
          percentAVG: 0,
          cellID: '7a82e4de_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '7a82e4de_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Payroll Taxes',
          path: ['LABOR', 'Labor Related Expenses', 'Payroll Taxes'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.9270113368443218, 0, 0, 0],
            stats: {
              mean: 679.762,
              variance: 1556854.7699359995,
              stdDev: 1247.7398646897516,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0.9999999999999999, 0, 0, 0, 0],
            stats: {
              mean: 1.2,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: -4976.450000000001,
          perc: -0.0105,
          percAvg: -0.0105,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Deposit',
              eventId: '15624',
              num: '',
              name: 'Payroll Tax',
              description: 'STRATEGY EXECUTI TAX COL',
              amount: -1269.59,
            },
            {
              txnDate: '2025-07-27',
              type: 'Journal Entry',
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              name: '',
              description: 'PR Tax',
              amount: 480.77,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0703,
          percentAVG: -0.0105,
          cellID: 'bbc14e9c_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 2,
          id: 'bbc14e9c_@_14',
          index: 0,
          cPercent: -0.010544718203294017,
        },
        {
          date: '2025-07-21',
          title: 'Employee Meals',
          path: ['LABOR', 'Labor Related Expenses', 'Employee Meals'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -774,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: -0.0117,
          cellID: '416bc276_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '416bc276_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Recruiting',
          path: ['LABOR', 'Labor Related Expenses', 'Recruiting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'c12aec10_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'c12aec10_@_14',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Labor Related Expenses',
          path: ['LABOR', 'Total Labor Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [2993.1],
            anomalyScores: [0, 0.8332323053590937, 0, 0, 0],
            stats: {
              mean: 942.3619999999999,
              variance: 1514356.643536,
              stdDev: 1230.5919890589244,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -6289.450000000001,
          amtAvg: -788.82,
          perc: -0.0105,
          percAvg: -0.0105,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -788.82,
          percent: -0.08979999999999999,
          percentAVG: -0.0105,
          cellID: '1e9ad256_@_14_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1e9ad256_@_14',
          index: 0,
          cPercent: -0.010544718203294017,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL LABOR',
          path: ['TOTAL LABOR'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 27163.121999999996,
              variance: 181497655.213336,
              stdDev: 13472.106561831226,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -101696.06999999999,
          amtAvg: 17059.77,
          perc: 0.2281,
          percAvg: 0.2281,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 17059.77,
          percent: -1.4204,
          percentAVG: 0.2281,
          cellID: 'd0736ae7_@_15_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd0736ae7_@_15',
          index: 0,
          cPercent: 0.2280500840026992,
        },
        {
          date: '2025-07-21',
          title: 'PRIME COST',
          path: ['PRIME COST'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 52725.438,
              variance: 346155513.457576,
              stdDev: 18605.254995768693,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -181414.28999999998,
          amtAvg: 41106.450000000004,
          perc: 0.5495,
          percAvg: 0.5495,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 41106.450000000004,
          percent: -2.5376999999999996,
          percentAVG: 0.5495,
          cellID: 'b7d061ce_@_16_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b7d061ce_@_16',
          index: 0,
          cPercent: 0.5494991653200925,
        },
        {
          date: '2025-07-21',
          title: 'Contribution Margin',
          path: ['Contribution Margin'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 21167.555999999997,
              variance: 487005743.832544,
              stdDev: 22068.206629278782,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -38436.43999999998,
          amtAvg: 33700.670000000006,
          perc: 0.4505,
          percAvg: 0.4505,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 33700.670000000006,
          percent: -0.46229999999999993,
          percentAVG: 0.4505,
          cellID: '2f5a4d68_@_17_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '2f5a4d68_@_17',
          index: 0,
          cPercent: 0.4505008346799075,
        },
        {
          date: '2025-07-21',
          title: 'CONTROLLABLE EXPENSES',
          path: ['CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '2cd659af_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '2cd659af_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '3be3d09b_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '3be3d09b_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Equipment Lease Rental',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Equipment Lease Rental'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -155,
          amtAvg: 35,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 35,
          percent: -0.0022,
          percentAVG: 0.0005,
          cellID: '1a6a3f76_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1a6a3f76_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Cleaning Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [66.69],
            anomalyScores: [0, 0, 0, -0.8258343847818393, 0],
            stats: {
              mean: 135.994,
              variance: 1760.6405040000002,
              stdDev: 41.95998693994077,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, 0, -0.8017837257372733, 0],
            stats: {
              mean: 2.2,
              variance: 0.5599999999999999,
              stdDev: 0.7483314773547882,
            },
          },
          trxFlagged: [],
          amount: -310.90999999999997,
          amtAvg: 114.23,
          perc: 0.0025,
          percAvg: 0.0015,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15534',
              num: '3590454',
              name: 'White Plains Linen',
              description: '',
              amount: 83.48,
            },
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 65.35,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 35.7,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 114.23,
          percent: -0.0045,
          percentAVG: 0.0015,
          cellID: '514ec7ed_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: '514ec7ed_@_18',
          index: 0,
          cPercent: 0.00246674380727396,
        },
        {
          date: '2025-07-21',
          title: 'Cleaning Services',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Cleaning Services'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1044.92,
          amtAvg: 235.95,
          perc: 0,
          percAvg: 0.0032,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 235.95,
          percent: -0.0149,
          percentAVG: 0.0032,
          cellID: '758ae475_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '758ae475_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Restaurant Supplies',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Restaurant Supplies'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [529.68],
            anomalyScores: [0.829937455486837, 0, 0, 0, 0],
            stats: {
              mean: 430.96000000000004,
              variance: 3537.1996399999975,
              stdDev: 59.4743611987552,
            },
          },
          trxAnomaly: {
            anomalies: [0, 0, 0, 0, 0],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 3,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1095.44,
          amtAvg: 402.65,
          perc: 0.0071,
          percAvg: 0.0054,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Bill',
              eventId: '15541',
              num: '9262981',
              name: 'Performance Food Service',
              description: '',
              amount: 270.35,
            },
            {
              txnDate: '2025-07-25',
              type: 'Bill',
              eventId: '15564',
              num: '9265169',
              name: 'Performance Food Service',
              description: '',
              amount: 139.53,
            },
            {
              txnDate: '2025-07-26',
              type: 'Bill',
              eventId: '15543',
              num: '713076',
              name: 'Avanti Enterprises,INC.',
              description: '',
              amount: 119.8,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 402.65,
          percent: -0.015099999999999999,
          percentAVG: 0.0054,
          cellID: '28a2ce1f_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: '28a2ce1f_@_18',
          index: 0,
          cPercent: 0.007080609439315401,
        },
        {
          date: '2025-07-21',
          title: 'Laundry, Linens, & Uniforms',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Laundry, Linens, & Uniforms'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1954.31],
            anomalyScores: [0, 0, 0, 0, 0.7716849627692227],
            stats: {
              mean: 884.5779999999999,
              variance: 480407.64341599995,
              stdDev: 693.114451887998,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16,
              stdDev: 0.4,
            },
          },
          trxFlagged: [],
          amount: -3885.1099999999997,
          amtAvg: 557.42,
          perc: 0.0036,
          percAvg: 0.0075,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Bill',
              eventId: '15534',
              num: '3590454',
              name: 'White Plains Linen',
              description: '',
              amount: 268.89,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 557.42,
          percent: -0.054,
          percentAVG: 0.0075,
          cellID: 'ad6ac922_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'ad6ac922_@_18',
          index: 0,
          cPercent: 0.0035944439513244187,
        },
        {
          date: '2025-07-21',
          title: 'Kitchen/ Bar Smallwares',
          path: ['CONTROLLABLE EXPENSES', 'Direct Operating Expenses', 'Kitchen/ Bar Smallwares'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1598.17,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: -0.0241,
          percentAVG: 0,
          cellID: '9f991141_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9f991141_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Direct Operating Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Direct Operating Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [4098.21],
            anomalyScores: [0, 0, 0, 0, 0.9688151819150049],
            stats: {
              mean: 2011.15,
              variance: 1160187.0302400002,
              stdDev: 1077.1197845365205,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -8089.55,
          amtAvg: 1345.25,
          perc: 0.0131,
          percAvg: 0.018,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1345.25,
          percent: -0.11499999999999999,
          percentAVG: 0.018,
          cellID: 'b7f8c8b8_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b7f8c8b8_@_18',
          index: 0,
          cPercent: 0.01314179719791378,
        },
        {
          date: '2025-07-21',
          title: 'Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '9d0fd7d1_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9d0fd7d1_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: '3rd Party Commissions',
          path: ['CONTROLLABLE EXPENSES', 'Transaction Related Expenses', '3rd Party Commissions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: '47bbbb15_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '47bbbb15_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Transaction Related Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total Transaction Related Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd484c66b_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd484c66b_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: 'edd65db2_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'edd65db2_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Marketing & Public Relations',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Marketing & Public Relations'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.9928070544044717, 0, 0],
            stats: {
              mean: 386.598,
              variance: 437527.793616,
              stdDev: 661.4588374313249,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0.7905694150420948, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: -1932.99,
          amtAvg: 388.88,
          perc: 0,
          percAvg: 0.0052,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 388.88,
          percent: -0.027800000000000002,
          percentAVG: 0.0052,
          cellID: 'c61b398a_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'c61b398a_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Advertising & Promotions',
          path: ['CONTROLLABLE EXPENSES', 'Marketing & Advertising', 'Advertising & Promotions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1227.09],
            anomalyScores: [0, 0, 0, 0.9022255665494788, 0],
            stats: {
              mean: 486.81800000000004,
              variance: 168303.20849599998,
              stdDev: 410.2477403910959,
            },
          },
          trxAnomaly: {
            anomalies: [5],
            anomalyScores: [0, 0, 0, 0.9299811099505544, 0],
            stats: {
              mean: 1.8,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: -1338.09,
          amtAvg: 466.08,
          perc: 0.0073,
          percAvg: 0.0062,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15524',
              num: '',
              name: 'Popmenu Inc.',
              description: 'VISA DDA PUR AP - 401134     POPMENU INC                 POPMENU COM   * GA',
              amount: 548,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 466.08,
          percent: -0.0161,
          percentAVG: 0.0062,
          cellID: '1dc3b3a3_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '1dc3b3a3_@_18',
          index: 0,
          cPercent: 0.007325505914410285,
        },
        {
          date: '2025-07-21',
          title: 'Total Marketing & Advertising',
          path: ['CONTROLLABLE EXPENSES', 'Total Marketing & Advertising'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1700],
            anomalyScores: [0, 0, 0.8056070670430966, 0, 0],
            stats: {
              mean: 873.4159999999999,
              variance: 263188.835784,
              stdDev: 513.0193327585229,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -3271.08,
          amtAvg: 854.96,
          perc: 0.0073,
          percAvg: 0.0114,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 854.96,
          percent: -0.043899999999999995,
          percentAVG: 0.0114,
          cellID: '024ba9eb_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '024ba9eb_@_18',
          index: 0,
          cPercent: 0.007325505914410285,
        },
        {
          date: '2025-07-21',
          title: 'Music & DJ',
          path: ['CONTROLLABLE EXPENSES', 'Music & DJ'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -500,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: -0.0075,
          percentAVG: 0,
          cellID: '0c83dbac_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '0c83dbac_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '6f7c6ca5_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '6f7c6ca5_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Accounting & Bookkeeping',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Accounting & Bookkeeping'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1499,
          amtAvg: 338.48,
          perc: 0,
          percAvg: 0.0045,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 338.48,
          percent: -0.0166,
          percentAVG: 0.0045,
          cellID: '5a0fedcf_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '5a0fedcf_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Consulting',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Consulting'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1250,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: -0.0188,
          percentAVG: 0,
          cellID: 'b08821c2_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b08821c2_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Legal',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Legal'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1444.206,
              variance: 686438.0999040001,
              stdDev: 828.5156002779912,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.16000000000000006,
              stdDev: 0.4000000000000001,
            },
          },
          trxFlagged: [],
          amount: -4754.05,
          amtAvg: 658.11,
          perc: 0.0165,
          percAvg: 0.0088,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15623',
              num: '',
              name: 'At Law',
              description: 'WIRE TRANSFER OUTGOING - Collection At Law',
              amount: 1233.49,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 658.11,
          percent: -0.0624,
          percentAVG: 0.0088,
          cellID: 'a630ac37_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'a630ac37_@_18',
          index: 0,
          cPercent: 0.01648893848606924,
        },
        {
          date: '2025-07-21',
          title: 'Payroll Processing Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Payroll Processing Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -172.53,
          amtAvg: 38.96,
          perc: 0,
          percAvg: 0.0005,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 38.96,
          percent: -0.0023,
          percentAVG: 0.0005,
          cellID: '975961bc_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '975961bc_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Computer Supplies, Software & IT',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Computer Supplies, Software & IT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1550.67,
          amtAvg: 350.15,
          perc: 0,
          percAvg: 0.0047,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 350.15,
          percent: -0.0228,
          percentAVG: 0.0047,
          cellID: '9450bb96_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9450bb96_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Dues and Subscriptions',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Dues and Subscriptions'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -101.58,
          amtAvg: 28.71,
          perc: 0.0002,
          percAvg: 0.0004,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15529',
              num: '',
              name: 'Spotify',
              description: 'VISA DDA PUR AP - 420429     SPOTIFY USA                 877 7781161   * NY',
              amount: 12.78,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 28.71,
          percent: -0.0010999999999999998,
          percentAVG: 0.0004,
          cellID: '236c5723_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '236c5723_@_18',
          index: 0,
          cPercent: 0.00017083935325942233,
        },
        {
          date: '2025-07-21',
          title: 'Bank Charges & Fees',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Bank Charges & Fees'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 46,
              variance: 1624,
              stdDev: 40.29888335921977,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1.6,
              variance: 1.8400000000000003,
              stdDev: 1.3564659966250538,
            },
          },
          trxFlagged: [],
          amount: -50,
          amtAvg: 47.42,
          perc: 0.0012,
          percAvg: 0.0006,
          dataRows: [
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15609',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15610',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15611',
              num: '',
              name: 'Bank Charges',
              description: 'WIRE TRANSFER FEE',
              amount: 30,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 47.42,
          percent: -0.0007,
          percentAVG: 0.0006,
          cellID: 'c3c23383_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 3,
          id: 'c3c23383_@_18',
          index: 0,
          cPercent: 0.0012030940370381855,
        },
        {
          date: '2025-07-21',
          title: 'Office Supplies & Expenses',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Office Supplies & Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3521.12],
            anomalyScores: [0.9270190794799632, 0, 0, 0, 0],
            stats: {
              mean: 1367.336,
              variance: 1349481.5646639995,
              stdDev: 1161.671883392208,
            },
          },
          trxAnomaly: {
            anomalies: [1],
            anomalyScores: [0, 0, -0.9185586535436917, 0, 0],
            stats: {
              mean: 8.2,
              variance: 15.36,
              stdDev: 3.919183588453085,
            },
          },
          trxFlagged: [],
          amount: 205.56000000000017,
          amtAvg: 1390.72,
          perc: 0.0471,
          percAvg: 0.0186,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15517',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 1086.51,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15518',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 318.9,
            },
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15519',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 51.17,
            },
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15638',
              num: '6502345',
              name: 'Meow Hospitality LLC',
              description: 'POD CHECK',
              amount: 1063,
            },
            {
              txnDate: '2025-07-22',
              type: 'Expense',
              eventId: '15625',
              num: '',
              name: 'CVS Pharmacy',
              description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
              amount: 802.22,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15575',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 62.37,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15576',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 44.77,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15577',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 56.5,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15579',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 14.49,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15578',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 14.8,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15581',
              num: '',
              name: 'Amazon',
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              amount: 6.39,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1390.72,
          percent: 0.0011999999999999997,
          percentAVG: 0.0186,
          cellID: '058d9b25_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 11,
          id: '058d9b25_@_18',
          index: 0,
          cPercent: 0.04706931639662106,
        },
        {
          date: '2025-07-21',
          title: 'Phone and Internet',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Phone and Internet'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -728.23,
          amtAvg: 88.8,
          perc: 0,
          percAvg: 0.0012,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 88.8,
          percent: -0.0108,
          percentAVG: 0.0012,
          cellID: '0c2b505e_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '0c2b505e_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Security',
          path: ['CONTROLLABLE EXPENSES', 'General & Administrative Expenses', 'Security'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -950,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: -0.0143,
          percentAVG: 0,
          cellID: '9dc533d9_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9dc533d9_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total General & Administrative Expenses',
          path: ['CONTROLLABLE EXPENSES', 'Total General & Administrative Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [1900.18],
            anomalyScores: [0, 0, -0.8194691648957217, 0, 0],
            stats: {
              mean: 4113.056,
              variance: 1823009.5043839994,
              stdDev: 1350.1886921404723,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -10850.5,
          amtAvg: 2941.35,
          perc: 0.0649,
          percAvg: 0.0393,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2941.35,
          percent: -0.1486,
          percentAVG: 0.0393,
          cellID: 'f12db2ec_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'f12db2ec_@_18',
          index: 0,
          cPercent: 0.0649321882729879,
        },
        {
          date: '2025-07-21',
          title: 'Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '084f517c_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '084f517c_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Travel, Ground Transport & Airfare',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Travel, Ground Transport & Airfare'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [355.12],
            anomalyScores: [0.8336939580201272, 0, 0, 0, 0],
            stats: {
              mean: 190.34,
              variance: 9766.42676,
              stdDev: 98.82523341738182,
            },
          },
          trxAnomaly: {
            anomalies: [6],
            anomalyScores: [0.8137334712067349, 0, 0, 0, 0],
            stats: {
              mean: 3.2,
              variance: 2.96,
              stdDev: 1.7204650534085253,
            },
          },
          trxFlagged: [],
          amount: -241.46,
          amtAvg: 175.05,
          perc: 0.0047,
          percAvg: 0.0023,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15606',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 60.9,
            },
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15607',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 81.87,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15603',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 52.21,
            },
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15605',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              amount: 54.38,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15604',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 50.67,
            },
            {
              txnDate: '2025-07-25',
              type: 'Expense',
              eventId: '15608',
              num: '',
              name: 'Uber Trips',
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              amount: 55.09,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 175.05,
          percent: -0.0039,
          percentAVG: 0.0023,
          cellID: 'e4e1ab18_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 6,
          id: 'e4e1ab18_@_18',
          index: 0,
          cPercent: 0.004747141715922227,
        },
        {
          date: '2025-07-21',
          title: 'Meals & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Meals & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [871.17],
            anomalyScores: [0, 0.994177836334134, 0, 0, 0],
            stats: {
              mean: 228.144,
              variance: 104584.884624,
              stdDev: 323.395863647017,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.7905694150420948, 0, 0, 0],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: -966.9,
          amtAvg: 237.27,
          perc: 0.0012,
          percAvg: 0.0032,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Expense',
              eventId: '15528',
              num: '',
              name: 'Plaza Mexico',
              description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
              amount: 86.91,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 237.27,
          percent: -0.014,
          percentAVG: 0.0032,
          cellID: 'f245aeff_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: 'f245aeff_@_18',
          index: 0,
          cPercent: 0.0011617878084332078,
        },
        {
          date: '2025-07-21',
          title: 'Parking',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Parking'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 279.55,
          perc: 0.0165,
          percAvg: 0.0037,
          dataRows: [
            {
              txnDate: '2025-07-24',
              type: 'Expense',
              eventId: '15621',
              num: '',
              name: 'Hoboken Parking',
              description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
              amount: 1238,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 279.55,
          percent: -0.0020999999999999977,
          percentAVG: 0.0037,
          cellID: '3ae4b332_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '3ae4b332_@_18',
          index: 0,
          cPercent: 0.016549226865036373,
        },
        {
          date: '2025-07-21',
          title: 'Fuel',
          path: ['CONTROLLABLE EXPENSES', 'Travel, Meals, & Entertainment', 'Fuel'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 32.426,
              variance: 336.544984,
              stdDev: 18.345162414107975,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0, 0, 0, 0.7905694150420948],
            stats: {
              mean: 1,
              variance: 0.4,
              stdDev: 0.6324555320336759,
            },
          },
          trxFlagged: [],
          amount: -94.11,
          amtAvg: 23.71,
          perc: 0.0005,
          percAvg: 0.0003,
          dataRows: [
            {
              txnDate: '2025-07-23',
              type: 'Expense',
              eventId: '15583',
              num: '',
              name: 'FUEL 4',
              description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
              amount: 34.01,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 23.71,
          percent: -0.0013,
          percentAVG: 0.0003,
          cellID: '4dbd49a9_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '4dbd49a9_@_18',
          index: 0,
          cPercent: 0.00045463586888520765,
        },
        {
          date: '2025-07-21',
          title: 'Total Travel, Meals, & Entertainment',
          path: ['CONTROLLABLE EXPENSES', 'Total Travel, Meals, & Entertainment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 946.11,
              variance: 405048.44547999994,
              stdDev: 636.4341642935268,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1302.47,
          amtAvg: 715.58,
          perc: 0.0229,
          percAvg: 0.0096,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 715.58,
          percent: -0.0212,
          percentAVG: 0.0096,
          cellID: 'ea7ffa49_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'ea7ffa49_@_18',
          index: 0,
          cPercent: 0.022912792258277016,
        },
        {
          date: '2025-07-21',
          title: 'Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '1675dbe8_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1675dbe8_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Repair & Maintenance, Equipment',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Equipment'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -5920.6,
          amtAvg: 551.33,
          perc: 0,
          percAvg: 0.0074,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 551.33,
          percent: -0.0883,
          percentAVG: 0.0074,
          cellID: 'aa06968c_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'aa06968c_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Repair & Maintenance, Facility',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Repair & Maintenance, Facility'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [3645.32],
            anomalyScores: [0, 0, 0.81921212447709, 0, 0],
            stats: {
              mean: 1424.1,
              variance: 1837936.13568,
              stdDev: 1355.7050326970098,
            },
          },
          trxAnomaly: {
            anomalies: [3],
            anomalyScores: [0, 0, 0.9128709291752769, 0, 0],
            stats: {
              mean: 1,
              variance: 1.2,
              stdDev: 1.0954451150103321,
            },
          },
          trxFlagged: [],
          amount: -3565.46,
          amtAvg: 1607.85,
          perc: 0.0238,
          percAvg: 0.0215,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15636',
              num: '6502326',
              name: 'Eileen Kim',
              description: 'CHECK 6502326 Electrical & plumbing work',
              amount: 1777.52,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 1607.85,
          percent: -0.0532,
          percentAVG: 0.0215,
          cellID: '4d40af10_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '4d40af10_@_18',
          index: 0,
          cPercent: 0.023761374585734615,
        },
        {
          date: '2025-07-21',
          title: 'Pest Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Pest Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1662.81,
          amtAvg: 118.65,
          perc: 0,
          percAvg: 0.0016,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 118.65,
          percent: -0.0229,
          percentAVG: 0.0016,
          cellID: 'a044faba_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'a044faba_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Fire Control',
          path: ['CONTROLLABLE EXPENSES', 'Repairs & Maintenance', 'Fire Control'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: 0,
          percentAVG: 0,
          cellID: 'd6450b86_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd6450b86_@_18',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Repairs & Maintenance',
          path: ['CONTROLLABLE EXPENSES', 'Total Repairs & Maintenance'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [525.46],
            anomalyScores: [0, 0, 0, -0.781916910471579, 0],
            stats: {
              mean: 2940.782,
              variance: 2385442.0553760002,
              stdDev: 1544.487635229237,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -11148.87,
          amtAvg: 2277.83,
          perc: 0.0238,
          percAvg: 0.0304,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 2277.83,
          percent: -0.1644,
          percentAVG: 0.0304,
          cellID: '4da1092f_@_18_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '4da1092f_@_18',
          index: 0,
          cPercent: 0.023761374585734615,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL CONTROLLABLE EXPENSES',
          path: ['TOTAL CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [16808.58],
            anomalyScores: [0, 0, 0, 0, 0.9850219207228548],
            stats: {
              mean: 10984.514000000001,
              variance: 8739785.896584,
              stdDev: 2956.312888816744,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -35162.47000000001,
          amtAvg: 8134.97,
          perc: 0.1321,
          percAvg: 0.1087,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 8134.97,
          percent: -0.5003,
          percentAVG: 0.1087,
          cellID: 'a624f257_@_19_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'a624f257_@_19',
          index: 0,
          cPercent: 0.1320736582293236,
        },
        {
          date: '2025-07-21',
          title: 'Controllable Profit',
          path: ['Controllable Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 10183.041999999998,
              variance: 457690195.3150161,
              stdDev: 21393.695223476847,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -3273.969999999972,
          amtAvg: 25565.700000000004,
          perc: 0.3184,
          percAvg: 0.3418,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 25565.700000000004,
          percent: 0.03799999999999992,
          percentAVG: 0.3418,
          cellID: 'a973b710_@_20_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'a973b710_@_20',
          index: 0,
          cPercent: 0.3184271764505839,
        },
        {
          date: '2025-07-21',
          title: 'NON-CONTROLLABLE EXPENSES',
          path: ['NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '79208dfc_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '79208dfc_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '52e26b6b_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '52e26b6b_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Rent/Lease',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Rent/Lease'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -18437.33,
          amtAvg: 4163.27,
          perc: 0,
          percAvg: 0.0557,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 4163.27,
          percent: -0.2708,
          percentAVG: 0.0557,
          cellID: '68876c4f_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '68876c4f_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Utility, Electricity',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Electricity'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '208dfabc_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '208dfabc_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Utility, Gas',
          path: ['NON-CONTROLLABLE EXPENSES', 'Property Expenses', 'Utility, Gas'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -430.96,
          amtAvg: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 0,
          percent: -0.0065,
          percentAVG: 0,
          cellID: 'c9446d9c_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'c9446d9c_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Property Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Property Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -18868.29,
          amtAvg: 4163.27,
          perc: 0,
          percAvg: 0.0557,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 4163.27,
          percent: -0.2773,
          percentAVG: 0.0557,
          cellID: '20d5762f_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '20d5762f_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          percentAVG: 0,
          cellID: '763b7c77_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '763b7c77_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Other Income/Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'Other Income/Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 1.01,
          amtAvg: -0.23,
          perc: 0,
          percAvg: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: -0.23,
          percent: 0,
          percentAVG: 0,
          cellID: '91f38f9a_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '91f38f9a_@_21',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'To Be Classified P&L',
          path: ['NON-CONTROLLABLE EXPENSES', 'Other Income and Expenses', 'To Be Classified P&L'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.8960000000002,
              variance: 1010918.8690640001,
              stdDev: 1005.444612628662,
            },
          },
          trxAnomaly: {
            anomalies: [2],
            anomalyScores: [0, 0.8017837257372731, 0, 0, 0],
            stats: {
              mean: 0.8,
              variance: 0.56,
              stdDev: 0.7483314773547883,
            },
          },
          trxFlagged: [],
          amount: -1929.48,
          amtAvg: 993.74,
          perc: 0.0262,
          percAvg: 0.0133,
          dataRows: [
            {
              txnDate: '2025-07-21',
              type: 'Check',
              eventId: '15657',
              num: '6502339',
              name: 'Roberto Averos',
              description: 'CHECK 6502339',
              amount: 1960,
            },
          ],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 993.74,
          percent: -0.0314,
          percentAVG: 0.0133,
          cellID: '5ccef3e9_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 1,
          id: '5ccef3e9_@_21',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'Total Other Income and Expenses',
          path: ['NON-CONTROLLABLE EXPENSES', 'Total Other Income and Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: true,
            isHeader: true,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [0, 0, 0, 0, 0],
            stats: {
              mean: 1169.694,
              variance: 1011391.6702639998,
              stdDev: 1005.6797056041252,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -1928.47,
          amtAvg: 993.51,
          perc: 0.0262,
          percAvg: 0.0133,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 993.51,
          percent: -0.0314,
          percentAVG: 0.0133,
          cellID: 'd4b5a9af_@_21_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'd4b5a9af_@_21',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'TOTAL NON-CONTROLLABLE EXPENSES',
          path: ['TOTAL NON-CONTROLLABLE EXPENSES'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [20878.18],
            anomalyScores: [0, 0.9942360990055261, 0, 0, 0],
            stats: {
              mean: 4943.352000000001,
              variance: 64217842.944216,
              stdDev: 8013.603617862316,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: -20796.760000000002,
          amtAvg: 5156.78,
          perc: 0.0262,
          percAvg: 0.0689,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 5156.78,
          percent: -0.3087,
          percentAVG: 0.0689,
          cellID: '1851dc59_@_22_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '1851dc59_@_22',
          index: 0,
          cPercent: 0.02620071458438715,
        },
        {
          date: '2025-07-21',
          title: 'Operating Profit',
          path: ['Operating Profit'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 17522.79000000002,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.3466999999999999,
          percentAVG: 0.2728,
          cellID: '251b8ac6_@_23_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '251b8ac6_@_23',
          index: 0,
          cPercent: 0.2922264618661967,
        },
        {
          date: '2025-07-21',
          title: 'Other Expenses',
          path: ['Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '5e10c38d_@_24_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '5e10c38d_@_24',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Loan Interest',
          path: ['Other Expenses', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '13e3a076_@_24_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '13e3a076_@_24',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Other Expenses',
          path: ['Total Other Expenses'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'caeb87a7_@_25_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'caeb87a7_@_25',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'EBITDA',
          path: ['EBITDA'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 17522.79000000002,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.3466999999999999,
          percentAVG: 0.2728,
          cellID: 'e815a21e_@_26_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'e815a21e_@_26',
          index: 0,
          cPercent: 0.2922264618661967,
        },
        {
          date: '2025-07-21',
          title: 'Interest, Taxes, Depreciation and Amortization',
          path: ['Interest, Taxes, Depreciation and Amortization'],
          vizHelpers: {
            lastItem: false,
            isTotal: false,
            isHeader: false,
            isBigHeader: true,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: true,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: '644555ee_@_27_-x-_1',
          baseAmount: 0,
          transactions: 0,
          id: '644555ee_@_27',
          index: 0,
        },
        {
          date: '2025-07-21',
          title: 'Loan Interest',
          path: ['Interest, Taxes, Depreciation and Amortization', 'Loan Interest'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: true,
            isTotal: false,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'dce93088_@_27_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'dce93088_@_27',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'Total Interest, Taxes, Depreciation and Amortization',
          path: ['Total Interest, Taxes, Depreciation and Amortization'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 0,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          percent: 0,
          cellID: 'b4184eff_@_28_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: 'b4184eff_@_28',
          index: 0,
          cPercent: 0,
        },
        {
          date: '2025-07-21',
          title: 'NET PROFIT',
          path: ['NET PROFIT'],
          baseRef: 'NET SALES',
          vizHelpers: {
            lastItem: false,
            isTotal: true,
            isHeader: false,
            isBigHeader: false,
            isExpanded: true,
            isSelected: false,
            noValuesToShow: false,
          },
          anomaly: {
            anomalies: [-38871.81999999999],
            anomalyScores: [0, -0.8117088651955878, 0, 0, 0],
            stats: {
              mean: 5239.689999999998,
              variance: 738317698.8131198,
              stdDev: 27172.002112710055,
            },
          },
          trxAnomaly: {
            anomalies: [],
            anomalyScores: [],
            stats: {
              mean: 0,
              variance: 0,
              stdDev: 0,
            },
          },
          trxFlagged: [],
          amount: 17522.79000000002,
          amtAvg: 20408.920000000006,
          perc: 0.2922,
          percAvg: 0.2728,
          dataRows: [],
          reportId: '91940c6d-cd4c-47b9-ae87-686532d81f9a',
          amountAVG: 20408.920000000006,
          percent: 0.3466999999999999,
          percentAVG: 0.2728,
          cellID: '9b50fa7c_@_29_-x-_1',
          baseAmount: 74807.12000000001,
          transactions: 0,
          id: '9b50fa7c_@_29',
          index: 0,
          cPercent: 0.2922264618661967,
        },
      ],
      total: true,
      periodReporting: false,
      originType: 'Synthetic Difference',
    },
    totalRow: [],
    chartData: {
      '5bc89b03_@_2': {
        id: '5bc89b03_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'SALES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 76024.62000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c5601bf4_@_2',
                glCode: 4105,
                title: 'Sales, Food',
                money: 40123,
                percent: 0.5278,
              },
              {
                id: 'e1ca5621_@_2',
                glCode: 4110,
                title: 'Sales, Liquor',
                money: 22039.5,
                percent: 0.2899,
              },
              {
                id: 'ba0b0910_@_2',
                glCode: 4115,
                title: 'Sales, Beer',
                money: 5225,
                percent: 0.0687,
              },
              {
                id: '2f14959f_@_2',
                glCode: 4120,
                title: 'Sales, Wine',
                money: 1861,
                percent: 0.0245,
              },
              {
                id: '7bb557b1_@_2',
                glCode: 4125,
                title: 'Sales, Non-Alcoholic Beverage',
                money: 2599,
                percent: 0.0342,
              },
              {
                id: 'cbede411_@_2',
                glCode: 4140,
                title: 'Sales, Miscellaneous',
                money: 2760.8,
                percent: 0.0363,
              },
              {
                id: '4e12e939_@_2',
                glCode: 4145,
                title: 'Sales, Service Charges',
                money: 1416.32,
                percent: 0.0186,
              },
              {
                id: 'a1f04b4c_@_2',
                glCode: 4199,
                title: 'Sales - No category',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 69076.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c5601bf4_@_2',
                glCode: 4105,
                title: 'Sales, Food',
                money: 37673.51,
                percent: 0.5454,
              },
              {
                id: 'e1ca5621_@_2',
                glCode: 4110,
                title: 'Sales, Liquor',
                money: 18733.5,
                percent: 0.2712,
              },
              {
                id: 'ba0b0910_@_2',
                glCode: 4115,
                title: 'Sales, Beer',
                money: 5015,
                percent: 0.0726,
              },
              {
                id: '2f14959f_@_2',
                glCode: 4120,
                title: 'Sales, Wine',
                money: 1636,
                percent: 0.0237,
              },
              {
                id: '7bb557b1_@_2',
                glCode: 4125,
                title: 'Sales, Non-Alcoholic Beverage',
                money: 2370,
                percent: 0.0343,
              },
              {
                id: 'cbede411_@_2',
                glCode: 4140,
                title: 'Sales, Miscellaneous',
                money: 2387.65,
                percent: 0.0346,
              },
              {
                id: '4e12e939_@_2',
                glCode: 4145,
                title: 'Sales, Service Charges',
                money: 1260.84,
                percent: 0.0183,
              },
              {
                id: 'a1f04b4c_@_2',
                glCode: 4199,
                title: 'Sales - No category',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 71235.26999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c5601bf4_@_2',
                glCode: 4105,
                title: 'Sales, Food',
                money: 39645,
                percent: 0.5565,
              },
              {
                id: 'e1ca5621_@_2',
                glCode: 4110,
                title: 'Sales, Liquor',
                money: 18588.01,
                percent: 0.2609,
              },
              {
                id: 'ba0b0910_@_2',
                glCode: 4115,
                title: 'Sales, Beer',
                money: 4710,
                percent: 0.0661,
              },
              {
                id: '2f14959f_@_2',
                glCode: 4120,
                title: 'Sales, Wine',
                money: 1252,
                percent: 0.0176,
              },
              {
                id: '7bb557b1_@_2',
                glCode: 4125,
                title: 'Sales, Non-Alcoholic Beverage',
                money: 2328,
                percent: 0.0327,
              },
              {
                id: 'cbede411_@_2',
                glCode: 4140,
                title: 'Sales, Miscellaneous',
                money: 3359.04,
                percent: 0.0472,
              },
              {
                id: '4e12e939_@_2',
                glCode: 4145,
                title: 'Sales, Service Charges',
                money: 1353.22,
                percent: 0.019,
              },
              {
                id: 'a1f04b4c_@_2',
                glCode: 4199,
                title: 'Sales - No category',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 92158.61,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c5601bf4_@_2',
                glCode: 4105,
                title: 'Sales, Food',
                money: 49465.17,
                percent: 0.5367,
              },
              {
                id: 'e1ca5621_@_2',
                glCode: 4110,
                title: 'Sales, Liquor',
                money: 26219.51,
                percent: 0.2845,
              },
              {
                id: 'ba0b0910_@_2',
                glCode: 4115,
                title: 'Sales, Beer',
                money: 6528,
                percent: 0.0708,
              },
              {
                id: '2f14959f_@_2',
                glCode: 4120,
                title: 'Sales, Wine',
                money: 1628,
                percent: 0.0177,
              },
              {
                id: '7bb557b1_@_2',
                glCode: 4125,
                title: 'Sales, Non-Alcoholic Beverage',
                money: 2902,
                percent: 0.0315,
              },
              {
                id: 'cbede411_@_2',
                glCode: 4140,
                title: 'Sales, Miscellaneous',
                money: 4069.88,
                percent: 0.0442,
              },
              {
                id: '4e12e939_@_2',
                glCode: 4145,
                title: 'Sales, Service Charges',
                money: 1346.05,
                percent: 0.0146,
              },
              {
                id: 'a1f04b4c_@_2',
                glCode: 4199,
                title: 'Sales - No category',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 67726.15,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c5601bf4_@_2',
                glCode: 4105,
                title: 'Sales, Food',
                money: 36991,
                percent: 0.5462,
              },
              {
                id: 'e1ca5621_@_2',
                glCode: 4110,
                title: 'Sales, Liquor',
                money: 18898,
                percent: 0.279,
              },
              {
                id: 'ba0b0910_@_2',
                glCode: 4115,
                title: 'Sales, Beer',
                money: 6146,
                percent: 0.0907,
              },
              {
                id: '2f14959f_@_2',
                glCode: 4120,
                title: 'Sales, Wine',
                money: 1513,
                percent: 0.0223,
              },
              {
                id: '7bb557b1_@_2',
                glCode: 4125,
                title: 'Sales, Non-Alcoholic Beverage',
                money: 2884,
                percent: 0.0426,
              },
              {
                id: 'cbede411_@_2',
                glCode: 4140,
                title: 'Sales, Miscellaneous',
                money: 95,
                percent: 0.0014,
              },
              {
                id: '4e12e939_@_2',
                glCode: 4145,
                title: 'Sales, Service Charges',
                money: 1199.15,
                percent: 0.0177,
              },
              {
                id: 'a1f04b4c_@_2',
                glCode: 4199,
                title: 'Sales - No category',
                money: 0,
                percent: 0,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
        ],
        glCode: 4000,
      },
      'c5601bf4_@_2': {
        id: 'c5601bf4_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales, Food',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 40123,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5278,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 37673.51,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5454,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 39645,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5565,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 49465.17,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5367,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 36991,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5462,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: 'c5601bf4_@_2',
            name: 'Sales, Food',
          },
        ],
        glCode: 4105,
      },
      'e1ca5621_@_2': {
        id: 'e1ca5621_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales, Liquor',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22039.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2899,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18733.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2712,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18588.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2609,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 26219.51,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2845,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18898,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.279,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: 'e1ca5621_@_2',
            name: 'Sales, Liquor',
          },
        ],
        glCode: 4110,
      },
      'ba0b0910_@_2': {
        id: 'ba0b0910_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales, Beer',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5225,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0687,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5015,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0726,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4710,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0661,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 6528,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0708,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 6146,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0907,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: 'ba0b0910_@_2',
            name: 'Sales, Beer',
          },
        ],
        glCode: 4115,
      },
      '2f14959f_@_2': {
        id: '2f14959f_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales, Wine',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1861,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0245,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1636,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0237,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1252,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0176,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1628,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0177,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1513,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0223,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: '2f14959f_@_2',
            name: 'Sales, Wine',
          },
        ],
        glCode: 4120,
      },
      '7bb557b1_@_2': {
        id: '7bb557b1_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales, Non-Alcoholic Beverage',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2599,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0342,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2370,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0343,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2328,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0327,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2902,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0315,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2884,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0426,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: '7bb557b1_@_2',
            name: 'Sales, Non-Alcoholic Beverage',
          },
        ],
        glCode: 4125,
      },
      'cbede411_@_2': {
        id: 'cbede411_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales, Miscellaneous',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2760.8,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0363,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2387.65,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0346,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3359.04,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0472,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4069.88,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0442,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 95,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0014,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: 'cbede411_@_2',
            name: 'Sales, Miscellaneous',
          },
        ],
        glCode: 4140,
      },
      '4e12e939_@_2': {
        id: '4e12e939_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales, Service Charges',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1416.32,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0186,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1260.84,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0183,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1353.22,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.019,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1346.05,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0146,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1199.15,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0177,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: '4e12e939_@_2',
            name: 'Sales, Service Charges',
          },
        ],
        glCode: 4145,
      },
      'a1f04b4c_@_2': {
        id: 'a1f04b4c_@_2',
        info: 'P&L Comparison (Weekly)',
        name: 'Sales - No category',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5bc89b03_@_2',
            name: 'SALES',
          },
          {
            id: 'a1f04b4c_@_2',
            name: 'Sales - No category',
          },
        ],
        glCode: 4199,
      },
      '74405d1a_@_3': {
        id: '74405d1a_@_3',
        info: 'P&L Comparison (Weekly)',
        name: 'GROSS SALES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 76024.62000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 69076.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 71235.26999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 92158.61,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 67726.15,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '74405d1a_@_3',
            name: 'GROSS SALES',
          },
        ],
        glCode: null,
      },
      'ba9fcd64_@_6': {
        id: 'ba9fcd64_@_6',
        info: 'P&L Comparison (Weekly)',
        name: 'Comps & Discounts',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1217.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '4936addc_@_6',
                glCode: 4500,
                title: 'Discounts and Comps',
                money: -1217.5,
                percent: -0.016,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 982.3,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '4936addc_@_6',
                glCode: 4500,
                title: 'Discounts and Comps',
                money: -982.3,
                percent: -0.0142,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1208.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '4936addc_@_6',
                glCode: 4500,
                title: 'Discounts and Comps',
                money: -1208.5,
                percent: -0.017,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2053.88,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '4936addc_@_6',
                glCode: 4500,
                title: 'Discounts and Comps',
                money: -2053.88,
                percent: -0.0223,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1294,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '4936addc_@_6',
                glCode: 4500,
                title: 'Discounts and Comps',
                money: -1294,
                percent: -0.0191,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: 'ba9fcd64_@_6',
            name: 'Comps & Discounts',
          },
        ],
        glCode: null,
      },
      '4936addc_@_6': {
        id: '4936addc_@_6',
        info: 'P&L Comparison (Weekly)',
        name: 'Discounts and Comps',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1217.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.016,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -982.3,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0142,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1208.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.017,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -2053.88,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0223,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1294,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0191,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'ba9fcd64_@_6',
            name: 'Comps & Discounts',
          },
          {
            id: '4936addc_@_6',
            name: 'Discounts and Comps',
          },
        ],
        glCode: 4500,
      },
      '8a448d4b_@_7': {
        id: '8a448d4b_@_7',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Comps & Discounts',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1217.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.016,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -982.3,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0142,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1208.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.017,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -2053.88,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0223,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1294,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0191,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '8a448d4b_@_7',
            name: 'Total Comps & Discounts',
          },
        ],
        glCode: null,
      },
      '3b5cefb1_@_8': {
        id: '3b5cefb1_@_8',
        info: 'P&L Comparison (Weekly)',
        name: 'NET SALES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 74807.12000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 68094.2,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 70026.76999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 90104.73,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 66432.15,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '3b5cefb1_@_8',
            name: 'NET SALES',
          },
        ],
        glCode: null,
      },
      '753db221_@_9': {
        id: '753db221_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COST OF GOODS SOLD (COGS)',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 24046.680000000004,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a94d93b_@_9',
                glCode: 5100,
                title: 'COGS, Food',
                money: 2046.02,
                percent: 0.051,
              },
              {
                id: '3f46fcce_@_9',
                glCode: 5101,
                title: 'COGS, Meat & Poultry',
                money: 3783.57,
                percent: 0.0506,
              },
              {
                id: '2bdeb0ad_@_9',
                glCode: 5102,
                title: 'COGS, Seafood',
                money: 336.7,
                percent: 0.0045,
              },
              {
                id: '593c4b13_@_9',
                glCode: 5103,
                title: 'COGS, Produce',
                money: 3875.6,
                percent: 0.0518,
              },
              {
                id: 'e0037727_@_9',
                glCode: 5104,
                title: 'COGS, Grocery',
                money: 2697.45,
                percent: 0.0361,
              },
              {
                id: '47294ea3_@_9',
                glCode: 5105,
                title: 'COGS, Bakery',
                money: 44.8,
                percent: 0.0006,
              },
              {
                id: '841fc412_@_9',
                glCode: 5106,
                title: 'COGS, Dairy',
                money: 1049.11,
                percent: 0.014,
              },
              {
                id: '6eb26171_@_9',
                glCode: 5110,
                title: 'COGS, Liquor',
                money: 5695.15,
                percent: 0.2584,
              },
              {
                id: '15101cdc_@_9',
                glCode: 5111,
                title: 'COGS, Bar Groceries',
                money: 182.06,
                percent: 0.0024,
              },
              {
                id: '90be8534_@_9',
                glCode: 5115,
                title: 'COGS, Beer',
                money: 0,
                percent: 0,
              },
              {
                id: '3395a498_@_9',
                glCode: 5116,
                title: 'COGS, Draught Beer',
                money: 508,
                percent: 0.0068,
              },
              {
                id: 'e2c4f57e_@_9',
                glCode: 5117,
                title: 'COGS, Bottled Beer',
                money: 438.6,
                percent: 0.0059,
              },
              {
                id: 'b29ce542_@_9',
                glCode: 5120,
                title: 'COGS, Wine',
                money: 1280.88,
                percent: 0.6883,
              },
              {
                id: '9f08e50d_@_9',
                glCode: 5125,
                title: 'COGS, Non-Alcoholic',
                money: 1532.25,
                percent: 0.0205,
              },
              {
                id: '027a424d_@_9',
                glCode: 5135,
                title: 'COGS, Packaging',
                money: 189.45,
                percent: 0.0025,
              },
              {
                id: 'dfae81d5_@_9',
                glCode: 5195,
                title: 'Shipping, Freight and Delivery',
                money: 387.04,
                percent: 0.0052,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 32352.92,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a94d93b_@_9',
                glCode: 5100,
                title: 'COGS, Food',
                money: 1092.35,
                percent: 0.029,
              },
              {
                id: '3f46fcce_@_9',
                glCode: 5101,
                title: 'COGS, Meat & Poultry',
                money: 3997.89,
                percent: 0.0587,
              },
              {
                id: '2bdeb0ad_@_9',
                glCode: 5102,
                title: 'COGS, Seafood',
                money: 487.73,
                percent: 0.0072,
              },
              {
                id: '593c4b13_@_9',
                glCode: 5103,
                title: 'COGS, Produce',
                money: 3361.74,
                percent: 0.0494,
              },
              {
                id: 'e0037727_@_9',
                glCode: 5104,
                title: 'COGS, Grocery',
                money: 12455.23,
                percent: 0.1829,
              },
              {
                id: '47294ea3_@_9',
                glCode: 5105,
                title: 'COGS, Bakery',
                money: 715.21,
                percent: 0.0105,
              },
              {
                id: '841fc412_@_9',
                glCode: 5106,
                title: 'COGS, Dairy',
                money: 1228.65,
                percent: 0.018,
              },
              {
                id: '6eb26171_@_9',
                glCode: 5110,
                title: 'COGS, Liquor',
                money: 1597.33,
                percent: 0.0853,
              },
              {
                id: '15101cdc_@_9',
                glCode: 5111,
                title: 'COGS, Bar Groceries',
                money: 90.52,
                percent: 0.0013,
              },
              {
                id: '90be8534_@_9',
                glCode: 5115,
                title: 'COGS, Beer',
                money: 0,
                percent: 0,
              },
              {
                id: '3395a498_@_9',
                glCode: 5116,
                title: 'COGS, Draught Beer',
                money: 3631.5,
                percent: 0.0533,
              },
              {
                id: 'e2c4f57e_@_9',
                glCode: 5117,
                title: 'COGS, Bottled Beer',
                money: 522,
                percent: 0.0077,
              },
              {
                id: 'b29ce542_@_9',
                glCode: 5120,
                title: 'COGS, Wine',
                money: 1032.5,
                percent: 0.6311,
              },
              {
                id: '9f08e50d_@_9',
                glCode: 5125,
                title: 'COGS, Non-Alcoholic',
                money: 1730.15,
                percent: 0.0254,
              },
              {
                id: '027a424d_@_9',
                glCode: 5135,
                title: 'COGS, Packaging',
                money: 410.12,
                percent: 0.006,
              },
              {
                id: 'dfae81d5_@_9',
                glCode: 5195,
                title: 'Shipping, Freight and Delivery',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 30839.25,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a94d93b_@_9',
                glCode: 5100,
                title: 'COGS, Food',
                money: 2621.67,
                percent: 0.0661,
              },
              {
                id: '3f46fcce_@_9',
                glCode: 5101,
                title: 'COGS, Meat & Poultry',
                money: 3127.43,
                percent: 0.0447,
              },
              {
                id: '2bdeb0ad_@_9',
                glCode: 5102,
                title: 'COGS, Seafood',
                money: 348.57,
                percent: 0.005,
              },
              {
                id: '593c4b13_@_9',
                glCode: 5103,
                title: 'COGS, Produce',
                money: 4014.31,
                percent: 0.0573,
              },
              {
                id: 'e0037727_@_9',
                glCode: 5104,
                title: 'COGS, Grocery',
                money: 11950.63,
                percent: 0.1707,
              },
              {
                id: '47294ea3_@_9',
                glCode: 5105,
                title: 'COGS, Bakery',
                money: 769.45,
                percent: 0.011,
              },
              {
                id: '841fc412_@_9',
                glCode: 5106,
                title: 'COGS, Dairy',
                money: 963.42,
                percent: 0.0138,
              },
              {
                id: '6eb26171_@_9',
                glCode: 5110,
                title: 'COGS, Liquor',
                money: 3807.32,
                percent: 0.2048,
              },
              {
                id: '15101cdc_@_9',
                glCode: 5111,
                title: 'COGS, Bar Groceries',
                money: 70.16,
                percent: 0.001,
              },
              {
                id: '90be8534_@_9',
                glCode: 5115,
                title: 'COGS, Beer',
                money: 435.87,
                percent: 0.0925,
              },
              {
                id: '3395a498_@_9',
                glCode: 5116,
                title: 'COGS, Draught Beer',
                money: 295.5,
                percent: 0.0042,
              },
              {
                id: 'e2c4f57e_@_9',
                glCode: 5117,
                title: 'COGS, Bottled Beer',
                money: 416,
                percent: 0.0059,
              },
              {
                id: 'b29ce542_@_9',
                glCode: 5120,
                title: 'COGS, Wine',
                money: 1209.4,
                percent: 0.966,
              },
              {
                id: '9f08e50d_@_9',
                glCode: 5125,
                title: 'COGS, Non-Alcoholic',
                money: 661.57,
                percent: 0.0094,
              },
              {
                id: '027a424d_@_9',
                glCode: 5135,
                title: 'COGS, Packaging',
                money: 147.95,
                percent: 0.0021,
              },
              {
                id: 'dfae81d5_@_9',
                glCode: 5195,
                title: 'Shipping, Freight and Delivery',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22129.269999999997,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a94d93b_@_9',
                glCode: 5100,
                title: 'COGS, Food',
                money: 592.08,
                percent: 0.012,
              },
              {
                id: '3f46fcce_@_9',
                glCode: 5101,
                title: 'COGS, Meat & Poultry',
                money: 3461.52,
                percent: 0.0384,
              },
              {
                id: '2bdeb0ad_@_9',
                glCode: 5102,
                title: 'COGS, Seafood',
                money: 347.73,
                percent: 0.0039,
              },
              {
                id: '593c4b13_@_9',
                glCode: 5103,
                title: 'COGS, Produce',
                money: 4556.91,
                percent: 0.0506,
              },
              {
                id: 'e0037727_@_9',
                glCode: 5104,
                title: 'COGS, Grocery',
                money: 2309.13,
                percent: 0.0256,
              },
              {
                id: '47294ea3_@_9',
                glCode: 5105,
                title: 'COGS, Bakery',
                money: 658.78,
                percent: 0.0073,
              },
              {
                id: '841fc412_@_9',
                glCode: 5106,
                title: 'COGS, Dairy',
                money: 1091.88,
                percent: 0.0121,
              },
              {
                id: '6eb26171_@_9',
                glCode: 5110,
                title: 'COGS, Liquor',
                money: 4449.61,
                percent: 0.1697,
              },
              {
                id: '15101cdc_@_9',
                glCode: 5111,
                title: 'COGS, Bar Groceries',
                money: 61.53,
                percent: 0.0007,
              },
              {
                id: '90be8534_@_9',
                glCode: 5115,
                title: 'COGS, Beer',
                money: 0,
                percent: 0,
              },
              {
                id: '3395a498_@_9',
                glCode: 5116,
                title: 'COGS, Draught Beer',
                money: 0,
                percent: 0,
              },
              {
                id: 'e2c4f57e_@_9',
                glCode: 5117,
                title: 'COGS, Bottled Beer',
                money: 232,
                percent: 0.0026,
              },
              {
                id: 'b29ce542_@_9',
                glCode: 5120,
                title: 'COGS, Wine',
                money: 2138.98,
                percent: 1.3139,
              },
              {
                id: '9f08e50d_@_9',
                glCode: 5125,
                title: 'COGS, Non-Alcoholic',
                money: 2040.39,
                percent: 0.0226,
              },
              {
                id: '027a424d_@_9',
                glCode: 5135,
                title: 'COGS, Packaging',
                money: 188.73,
                percent: 0.0021,
              },
              {
                id: 'dfae81d5_@_9',
                glCode: 5195,
                title: 'Shipping, Freight and Delivery',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18443.46,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a94d93b_@_9',
                glCode: 5100,
                title: 'COGS, Food',
                money: 754.18,
                percent: 0.0204,
              },
              {
                id: '3f46fcce_@_9',
                glCode: 5101,
                title: 'COGS, Meat & Poultry',
                money: 3526.27,
                percent: 0.0531,
              },
              {
                id: '2bdeb0ad_@_9',
                glCode: 5102,
                title: 'COGS, Seafood',
                money: 526.36,
                percent: 0.0079,
              },
              {
                id: '593c4b13_@_9',
                glCode: 5103,
                title: 'COGS, Produce',
                money: 530.45,
                percent: 0.008,
              },
              {
                id: 'e0037727_@_9',
                glCode: 5104,
                title: 'COGS, Grocery',
                money: 7899.17,
                percent: 0.1189,
              },
              {
                id: '47294ea3_@_9',
                glCode: 5105,
                title: 'COGS, Bakery',
                money: 1630.48,
                percent: 0.0245,
              },
              {
                id: '841fc412_@_9',
                glCode: 5106,
                title: 'COGS, Dairy',
                money: 927.54,
                percent: 0.014,
              },
              {
                id: '6eb26171_@_9',
                glCode: 5110,
                title: 'COGS, Liquor',
                money: 2208.19,
                percent: 0.1168,
              },
              {
                id: '15101cdc_@_9',
                glCode: 5111,
                title: 'COGS, Bar Groceries',
                money: 0,
                percent: 0,
              },
              {
                id: '90be8534_@_9',
                glCode: 5115,
                title: 'COGS, Beer',
                money: 0,
                percent: 0,
              },
              {
                id: '3395a498_@_9',
                glCode: 5116,
                title: 'COGS, Draught Beer',
                money: 0,
                percent: 0,
              },
              {
                id: 'e2c4f57e_@_9',
                glCode: 5117,
                title: 'COGS, Bottled Beer',
                money: 0,
                percent: 0,
              },
              {
                id: 'b29ce542_@_9',
                glCode: 5120,
                title: 'COGS, Wine',
                money: 0,
                percent: 0,
              },
              {
                id: '9f08e50d_@_9',
                glCode: 5125,
                title: 'COGS, Non-Alcoholic',
                money: 78.71,
                percent: 0.0012,
              },
              {
                id: '027a424d_@_9',
                glCode: 5135,
                title: 'COGS, Packaging',
                money: 362.11,
                percent: 0.0055,
              },
              {
                id: 'dfae81d5_@_9',
                glCode: 5195,
                title: 'Shipping, Freight and Delivery',
                money: 0,
                percent: 0,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
        ],
        glCode: 5000,
      },
      '7a94d93b_@_9': {
        id: '7a94d93b_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Food',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2046.02,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.051,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1092.35,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.029,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2621.67,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0661,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 592.08,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.012,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 754.18,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0204,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '7a94d93b_@_9',
            name: 'COGS, Food',
          },
        ],
        glCode: 5100,
      },
      '3f46fcce_@_9': {
        id: '3f46fcce_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Meat & Poultry',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3783.57,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0506,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3997.89,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0587,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3127.43,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0447,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3461.52,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0384,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3526.27,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0531,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '3f46fcce_@_9',
            name: 'COGS, Meat & Poultry',
          },
        ],
        glCode: 5101,
      },
      '2bdeb0ad_@_9': {
        id: '2bdeb0ad_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Seafood',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 336.7,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0045,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 487.73,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0072,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 348.57,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.005,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 347.73,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0039,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 526.36,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0079,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '2bdeb0ad_@_9',
            name: 'COGS, Seafood',
          },
        ],
        glCode: 5102,
      },
      '593c4b13_@_9': {
        id: '593c4b13_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Produce',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3875.6,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0518,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3361.74,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0494,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4014.31,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0573,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4556.91,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0506,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 530.45,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.008,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '593c4b13_@_9',
            name: 'COGS, Produce',
          },
        ],
        glCode: 5103,
      },
      'e0037727_@_9': {
        id: 'e0037727_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Grocery',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2697.45,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0361,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 12455.23,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1829,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 11950.63,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1707,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2309.13,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0256,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 7899.17,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1189,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: 'e0037727_@_9',
            name: 'COGS, Grocery',
          },
        ],
        glCode: 5104,
      },
      '47294ea3_@_9': {
        id: '47294ea3_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Bakery',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 44.8,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0006,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 715.21,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0105,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 769.45,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.011,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 658.78,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0073,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1630.48,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0245,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '47294ea3_@_9',
            name: 'COGS, Bakery',
          },
        ],
        glCode: 5105,
      },
      '841fc412_@_9': {
        id: '841fc412_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Dairy',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1049.11,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.014,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1228.65,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.018,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 963.42,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0138,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1091.88,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0121,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 927.54,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.014,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '841fc412_@_9',
            name: 'COGS, Dairy',
          },
        ],
        glCode: 5106,
      },
      '6eb26171_@_9': {
        id: '6eb26171_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Liquor',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5695.15,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2584,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1597.33,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0853,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3807.32,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2048,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4449.61,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1697,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2208.19,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1168,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '6eb26171_@_9',
            name: 'COGS, Liquor',
          },
        ],
        glCode: 5110,
      },
      '15101cdc_@_9': {
        id: '15101cdc_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Bar Groceries',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 182.06,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0024,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 90.52,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0013,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 70.16,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.001,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 61.53,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0007,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '15101cdc_@_9',
            name: 'COGS, Bar Groceries',
          },
        ],
        glCode: 5111,
      },
      '90be8534_@_9': {
        id: '90be8534_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Beer',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 435.87,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0925,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '90be8534_@_9',
            name: 'COGS, Beer',
          },
        ],
        glCode: 5115,
      },
      '3395a498_@_9': {
        id: '3395a498_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Draught Beer',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 508,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0068,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3631.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0533,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 295.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0042,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '3395a498_@_9',
            name: 'COGS, Draught Beer',
          },
        ],
        glCode: 5116,
      },
      'e2c4f57e_@_9': {
        id: 'e2c4f57e_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Bottled Beer',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 438.6,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0059,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 522,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0077,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 416,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0059,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 232,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0026,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: 'e2c4f57e_@_9',
            name: 'COGS, Bottled Beer',
          },
        ],
        glCode: 5117,
      },
      'b29ce542_@_9': {
        id: 'b29ce542_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Wine',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1280.88,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.6883,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1032.5,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.6311,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1209.4,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.966,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2138.98,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 1.3139,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: 'b29ce542_@_9',
            name: 'COGS, Wine',
          },
        ],
        glCode: 5120,
      },
      '9f08e50d_@_9': {
        id: '9f08e50d_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Non-Alcoholic',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1532.25,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0205,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1730.15,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0254,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 661.57,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0094,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2040.39,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0226,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 78.71,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0012,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '9f08e50d_@_9',
            name: 'COGS, Non-Alcoholic',
          },
        ],
        glCode: 5125,
      },
      '027a424d_@_9': {
        id: '027a424d_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'COGS, Packaging',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 189.45,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0025,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 410.12,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.006,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 147.95,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0021,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 188.73,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0021,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 362.11,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0055,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: '027a424d_@_9',
            name: 'COGS, Packaging',
          },
        ],
        glCode: 5135,
      },
      'dfae81d5_@_9': {
        id: 'dfae81d5_@_9',
        info: 'P&L Comparison (Weekly)',
        name: 'Shipping, Freight and Delivery',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 387.04,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0052,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '753db221_@_9',
            name: 'COST OF GOODS SOLD (COGS)',
          },
          {
            id: 'dfae81d5_@_9',
            name: 'Shipping, Freight and Delivery',
          },
        ],
        glCode: 5195,
      },
      '528a97f9_@_10': {
        id: '528a97f9_@_10',
        info: 'P&L Comparison (Weekly)',
        name: 'TOTAL COGS',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 24046.680000000004,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.3214,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 32352.92,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4751,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 30839.25,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4404,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22129.269999999997,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2456,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18443.46,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2776,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '528a97f9_@_10',
            name: 'TOTAL COGS',
          },
        ],
        glCode: null,
      },
      '7b400e74_@_12': {
        id: '7b400e74_@_12',
        info: 'P&L Comparison (Weekly)',
        name: 'GROSS PROFIT',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 50760.44,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.6786,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 35741.28,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5249,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 39187.51999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5596,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 67975.45999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.7544,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 47988.689999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.7224,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '7b400e74_@_12',
            name: 'GROSS PROFIT',
          },
        ],
        glCode: null,
      },
      '39d9c4d4_@_13': {
        id: '39d9c4d4_@_13',
        info: 'P&L Comparison (Weekly)',
        name: 'OPERATING EXPENSES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 28899.82,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 74613.1,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 51508.119999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 31655.99,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 28777.91,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '39d9c4d4_@_13',
            name: 'OPERATING EXPENSES',
          },
        ],
        glCode: null,
      },
      '5b0fe671_@_14': {
        id: '5b0fe671_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'LABOR',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18637.41,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'bb2363da_@_14',
                glCode: 5200,
                title: 'Direct Labor',
                money: 0,
                percent: 0,
              },
              {
                id: '143a84db_@_14',
                glCode: null,
                title: 'Total Direct Labor',
                money: 17848.59,
                percent: 0.2386,
              },
              {
                id: 'dacf6533_@_14',
                glCode: 5300,
                title: 'Labor Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '1e9ad256_@_14',
                glCode: null,
                title: 'Total Labor Related Expenses',
                money: -788.82,
                percent: -0.0105,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 43491.79,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'bb2363da_@_14',
                glCode: 5200,
                title: 'Direct Labor',
                money: 0,
                percent: 0,
              },
              {
                id: '143a84db_@_14',
                glCode: null,
                title: 'Total Direct Labor',
                money: 40498.69,
                percent: 0.5947,
              },
              {
                id: 'dacf6533_@_14',
                glCode: 5300,
                title: 'Labor Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '1e9ad256_@_14',
                glCode: null,
                title: 'Total Labor Related Expenses',
                money: 2993.1,
                percent: 0.044,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 42293.969999999994,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'bb2363da_@_14',
                glCode: 5200,
                title: 'Direct Labor',
                money: 0,
                percent: 0,
              },
              {
                id: '143a84db_@_14',
                glCode: null,
                title: 'Total Direct Labor',
                money: 41542.2,
                percent: 0.5932,
              },
              {
                id: 'dacf6533_@_14',
                glCode: 5300,
                title: 'Labor Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '1e9ad256_@_14',
                glCode: null,
                title: 'Total Labor Related Expenses',
                money: 751.77,
                percent: 0.0107,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22880.34,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'bb2363da_@_14',
                glCode: 5200,
                title: 'Direct Labor',
                money: 0,
                percent: 0,
              },
              {
                id: '143a84db_@_14',
                glCode: null,
                title: 'Total Direct Labor',
                money: 22405.34,
                percent: 0.2487,
              },
              {
                id: 'dacf6533_@_14',
                glCode: 5300,
                title: 'Labor Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '1e9ad256_@_14',
                glCode: null,
                title: 'Total Labor Related Expenses',
                money: 475,
                percent: 0.0053,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 10089.74,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'bb2363da_@_14',
                glCode: 5200,
                title: 'Direct Labor',
                money: 0,
                percent: 0,
              },
              {
                id: '143a84db_@_14',
                glCode: null,
                title: 'Total Direct Labor',
                money: 8808.98,
                percent: 0.1326,
              },
              {
                id: 'dacf6533_@_14',
                glCode: 5300,
                title: 'Labor Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '1e9ad256_@_14',
                glCode: null,
                title: 'Total Labor Related Expenses',
                money: 1280.76,
                percent: 0.0193,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
        ],
        glCode: 6000,
      },
      'bb2363da_@_14': {
        id: 'bb2363da_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Direct Labor',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 17848.59,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '687f4cd2_@_14',
                glCode: 5205,
                title: 'Labor Other',
                money: 13892.95,
                percent: 0.1857,
              },
              {
                id: '529343c4_@_14',
                glCode: 5210,
                title: 'Labor, Management',
                money: 2244.1,
                percent: 0.03,
              },
              {
                id: '3c61733f_@_14',
                glCode: 5215,
                title: 'Labor, BOH',
                money: 1711.54,
                percent: 0.0229,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 40498.69,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '687f4cd2_@_14',
                glCode: 5205,
                title: 'Labor Other',
                money: 28890.19,
                percent: 0.4243,
              },
              {
                id: '529343c4_@_14',
                glCode: 5210,
                title: 'Labor, Management',
                money: 6486.95,
                percent: 0.0953,
              },
              {
                id: '3c61733f_@_14',
                glCode: 5215,
                title: 'Labor, BOH',
                money: 5121.55,
                percent: 0.0752,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 41542.2,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '687f4cd2_@_14',
                glCode: 5205,
                title: 'Labor Other',
                money: 37586.56,
                percent: 0.5367,
              },
              {
                id: '529343c4_@_14',
                glCode: 5210,
                title: 'Labor, Management',
                money: 2244.1,
                percent: 0.032,
              },
              {
                id: '3c61733f_@_14',
                glCode: 5215,
                title: 'Labor, BOH',
                money: 1711.54,
                percent: 0.0244,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22405.34,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '687f4cd2_@_14',
                glCode: 5205,
                title: 'Labor Other',
                money: 17238.8,
                percent: 0.1913,
              },
              {
                id: '529343c4_@_14',
                glCode: 5210,
                title: 'Labor, Management',
                money: 3455,
                percent: 0.0383,
              },
              {
                id: '3c61733f_@_14',
                glCode: 5215,
                title: 'Labor, BOH',
                money: 1711.54,
                percent: 0.019,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 8808.98,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '687f4cd2_@_14',
                glCode: 5205,
                title: 'Labor Other',
                money: 5477.44,
                percent: 0.0825,
              },
              {
                id: '529343c4_@_14',
                glCode: 5210,
                title: 'Labor, Management',
                money: 1620,
                percent: 0.0244,
              },
              {
                id: '3c61733f_@_14',
                glCode: 5215,
                title: 'Labor, BOH',
                money: 1711.54,
                percent: 0.0258,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'bb2363da_@_14',
            name: 'Direct Labor',
          },
        ],
        glCode: 5200,
      },
      '687f4cd2_@_14': {
        id: '687f4cd2_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Labor Other',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 13892.95,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1857,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 28890.19,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4243,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 37586.56,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5367,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 17238.8,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1913,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5477.44,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0825,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'bb2363da_@_14',
            name: 'Direct Labor',
          },
          {
            id: '687f4cd2_@_14',
            name: 'Labor Other',
          },
        ],
        glCode: 5205,
      },
      '529343c4_@_14': {
        id: '529343c4_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Labor, Management',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2244.1,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.03,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 6486.95,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0953,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2244.1,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.032,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3455,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0383,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1620,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0244,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'bb2363da_@_14',
            name: 'Direct Labor',
          },
          {
            id: '529343c4_@_14',
            name: 'Labor, Management',
          },
        ],
        glCode: 5210,
      },
      '3c61733f_@_14': {
        id: '3c61733f_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Labor, BOH',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1711.54,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0229,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5121.55,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0752,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1711.54,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0244,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1711.54,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.019,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1711.54,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0258,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'bb2363da_@_14',
            name: 'Direct Labor',
          },
          {
            id: '3c61733f_@_14',
            name: 'Labor, BOH',
          },
        ],
        glCode: 5215,
      },
      '143a84db_@_14': {
        id: '143a84db_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Direct Labor',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 17848.59,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2386,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 40498.69,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5947,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 41542.2,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5932,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22405.34,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2487,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 8808.98,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1326,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: '143a84db_@_14',
            name: 'Total Direct Labor',
          },
        ],
        glCode: null,
      },
      'dacf6533_@_14': {
        id: 'dacf6533_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Labor Related Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 788.82,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a82e4de_@_14',
                glCode: 5310,
                title: 'Commission/Bonus/Incentives',
                money: 0,
                percent: 0,
              },
              {
                id: 'bbc14e9c_@_14',
                glCode: 5315,
                title: 'Payroll Taxes',
                money: -788.82,
                percent: -0.0105,
              },
              {
                id: '416bc276_@_14',
                glCode: 5340,
                title: 'Employee Meals',
                money: 0,
                percent: 0,
              },
              {
                id: 'c12aec10_@_14',
                glCode: 5345,
                title: 'Recruiting',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2993.1,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a82e4de_@_14',
                glCode: 5310,
                title: 'Commission/Bonus/Incentives',
                money: 0,
                percent: 0,
              },
              {
                id: 'bbc14e9c_@_14',
                glCode: 5315,
                title: 'Payroll Taxes',
                money: 2993.1,
                percent: 0.044,
              },
              {
                id: '416bc276_@_14',
                glCode: 5340,
                title: 'Employee Meals',
                money: 0,
                percent: 0,
              },
              {
                id: 'c12aec10_@_14',
                glCode: 5345,
                title: 'Recruiting',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 751.77,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a82e4de_@_14',
                glCode: 5310,
                title: 'Commission/Bonus/Incentives',
                money: 271,
                percent: 0.0039,
              },
              {
                id: 'bbc14e9c_@_14',
                glCode: 5315,
                title: 'Payroll Taxes',
                money: 480.77,
                percent: 0.0069,
              },
              {
                id: '416bc276_@_14',
                glCode: 5340,
                title: 'Employee Meals',
                money: 0,
                percent: 0,
              },
              {
                id: 'c12aec10_@_14',
                glCode: 5345,
                title: 'Recruiting',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 475,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a82e4de_@_14',
                glCode: 5310,
                title: 'Commission/Bonus/Incentives',
                money: 0,
                percent: 0,
              },
              {
                id: 'bbc14e9c_@_14',
                glCode: 5315,
                title: 'Payroll Taxes',
                money: 475,
                percent: 0.0053,
              },
              {
                id: '416bc276_@_14',
                glCode: 5340,
                title: 'Employee Meals',
                money: 0,
                percent: 0,
              },
              {
                id: 'c12aec10_@_14',
                glCode: 5345,
                title: 'Recruiting',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1280.76,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '7a82e4de_@_14',
                glCode: 5310,
                title: 'Commission/Bonus/Incentives',
                money: 268,
                percent: 0.004,
              },
              {
                id: 'bbc14e9c_@_14',
                glCode: 5315,
                title: 'Payroll Taxes',
                money: 238.76,
                percent: 0.0036,
              },
              {
                id: '416bc276_@_14',
                glCode: 5340,
                title: 'Employee Meals',
                money: 774,
                percent: 0.0117,
              },
              {
                id: 'c12aec10_@_14',
                glCode: 5345,
                title: 'Recruiting',
                money: 0,
                percent: 0,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'dacf6533_@_14',
            name: 'Labor Related Expenses',
          },
        ],
        glCode: 5300,
      },
      '7a82e4de_@_14': {
        id: '7a82e4de_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Commission/Bonus/Incentives',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 271,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0039,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 268,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.004,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'dacf6533_@_14',
            name: 'Labor Related Expenses',
          },
          {
            id: '7a82e4de_@_14',
            name: 'Commission/Bonus/Incentives',
          },
        ],
        glCode: 5310,
      },
      'bbc14e9c_@_14': {
        id: 'bbc14e9c_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Payroll Taxes',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -788.82,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0105,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2993.1,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.044,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 480.77,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0069,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 475,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0053,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 238.76,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0036,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'dacf6533_@_14',
            name: 'Labor Related Expenses',
          },
          {
            id: 'bbc14e9c_@_14',
            name: 'Payroll Taxes',
          },
        ],
        glCode: 5315,
      },
      '416bc276_@_14': {
        id: '416bc276_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Employee Meals',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 774,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0117,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'dacf6533_@_14',
            name: 'Labor Related Expenses',
          },
          {
            id: '416bc276_@_14',
            name: 'Employee Meals',
          },
        ],
        glCode: 5340,
      },
      'c12aec10_@_14': {
        id: 'c12aec10_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Recruiting',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: 'dacf6533_@_14',
            name: 'Labor Related Expenses',
          },
          {
            id: 'c12aec10_@_14',
            name: 'Recruiting',
          },
        ],
        glCode: 5345,
      },
      '1e9ad256_@_14': {
        id: '1e9ad256_@_14',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Labor Related Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -788.82,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0105,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2993.1,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.044,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 751.77,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0107,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 475,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0053,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1280.76,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0193,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5b0fe671_@_14',
            name: 'LABOR',
          },
          {
            id: '1e9ad256_@_14',
            name: 'Total Labor Related Expenses',
          },
        ],
        glCode: null,
      },
      'd0736ae7_@_15': {
        id: 'd0736ae7_@_15',
        info: 'P&L Comparison (Weekly)',
        name: 'TOTAL LABOR',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 17059.77,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2281,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 43491.79,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.6387,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 42293.969999999994,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.604,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22880.34,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2539,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 10089.74,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1519,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'd0736ae7_@_15',
            name: 'TOTAL LABOR',
          },
        ],
        glCode: null,
      },
      'b7d061ce_@_16': {
        id: 'b7d061ce_@_16',
        info: 'P&L Comparison (Weekly)',
        name: 'PRIME COST',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 41106.450000000004,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5495,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 75844.70999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 1.1138,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 73133.22,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 1.0444,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 45009.61,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4995,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 28533.199999999997,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4295,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'b7d061ce_@_16',
            name: 'PRIME COST',
          },
        ],
        glCode: null,
      },
      '2f5a4d68_@_17': {
        id: '2f5a4d68_@_17',
        info: 'P&L Comparison (Weekly)',
        name: 'Contribution Margin',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 33700.670000000006,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4505,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -7750.509999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.1138,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -3106.4500000000116,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.0444,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 45095.119999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5005,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 37898.95,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.5705,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2f5a4d68_@_17',
            name: 'Contribution Margin',
          },
        ],
        glCode: null,
      },
      '2cd659af_@_18': {
        id: '2cd659af_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'CONTROLLABLE EXPENSES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 9880.05,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '3be3d09b_@_18',
                glCode: 6100,
                title: 'Direct Operating Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'b7f8c8b8_@_18',
                glCode: null,
                title: 'Total Direct Operating Expenses',
                money: 983.0999999999999,
                percent: 0.0131,
              },
              {
                id: '9d0fd7d1_@_18',
                glCode: 6200,
                title: 'Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd484c66b_@_18',
                glCode: null,
                title: 'Total Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'edd65db2_@_18',
                glCode: 6250,
                title: 'Marketing & Advertising',
                money: 0,
                percent: 0,
              },
              {
                id: '024ba9eb_@_18',
                glCode: null,
                title: 'Total Marketing & Advertising',
                money: 548,
                percent: 0.0073,
              },
              {
                id: '0c83dbac_@_18',
                glCode: 6305,
                title: 'Music & DJ',
                money: 0,
                percent: 0,
              },
              {
                id: '6f7c6ca5_@_18',
                glCode: 6500,
                title: 'General & Administrative Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'f12db2ec_@_18',
                glCode: null,
                title: 'Total General & Administrative Expenses',
                money: 4857.389999999999,
                percent: 0.0649,
              },
              {
                id: '084f517c_@_18',
                glCode: 6700,
                title: 'Travel, Meals, & Entertainment',
                money: 0,
                percent: 0,
              },
              {
                id: 'ea7ffa49_@_18',
                glCode: null,
                title: 'Total Travel, Meals, & Entertainment',
                money: 1714.04,
                percent: 0.0229,
              },
              {
                id: '1675dbe8_@_18',
                glCode: 6800,
                title: 'Repairs & Maintenance',
                money: 0,
                percent: 0,
              },
              {
                id: '4da1092f_@_18',
                glCode: null,
                title: 'Total Repairs & Maintenance',
                money: 1777.52,
                percent: 0.0238,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 10243.130000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '3be3d09b_@_18',
                glCode: 6100,
                title: 'Direct Operating Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'b7f8c8b8_@_18',
                glCode: null,
                title: 'Total Direct Operating Expenses',
                money: 1566.8999999999999,
                percent: 0.023,
              },
              {
                id: '9d0fd7d1_@_18',
                glCode: 6200,
                title: 'Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd484c66b_@_18',
                glCode: null,
                title: 'Total Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'edd65db2_@_18',
                glCode: 6250,
                title: 'Marketing & Advertising',
                money: 0,
                percent: 0,
              },
              {
                id: '024ba9eb_@_18',
                glCode: null,
                title: 'Total Marketing & Advertising',
                money: 311.19,
                percent: 0.0046,
              },
              {
                id: '0c83dbac_@_18',
                glCode: 6305,
                title: 'Music & DJ',
                money: 0,
                percent: 0,
              },
              {
                id: '6f7c6ca5_@_18',
                glCode: 6500,
                title: 'General & Administrative Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'f12db2ec_@_18',
                glCode: null,
                title: 'Total General & Administrative Expenses',
                money: 3212.6499999999996,
                percent: 0.0472,
              },
              {
                id: '084f517c_@_18',
                glCode: 6700,
                title: 'Travel, Meals, & Entertainment',
                money: 0,
                percent: 0,
              },
              {
                id: 'ea7ffa49_@_18',
                glCode: null,
                title: 'Total Travel, Meals, & Entertainment',
                money: 1013.13,
                percent: 0.0149,
              },
              {
                id: '1675dbe8_@_18',
                glCode: 6800,
                title: 'Repairs & Maintenance',
                money: 0,
                percent: 0,
              },
              {
                id: '4da1092f_@_18',
                glCode: null,
                title: 'Total Repairs & Maintenance',
                money: 4139.26,
                percent: 0.0608,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 9215.160000000002,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '3be3d09b_@_18',
                glCode: 6100,
                title: 'Direct Operating Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'b7f8c8b8_@_18',
                glCode: null,
                title: 'Total Direct Operating Expenses',
                money: 1734.64,
                percent: 0.0248,
              },
              {
                id: '9d0fd7d1_@_18',
                glCode: 6200,
                title: 'Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd484c66b_@_18',
                glCode: null,
                title: 'Total Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'edd65db2_@_18',
                glCode: 6250,
                title: 'Marketing & Advertising',
                money: 0,
                percent: 0,
              },
              {
                id: '024ba9eb_@_18',
                glCode: null,
                title: 'Total Marketing & Advertising',
                money: 1700,
                percent: 0.0243,
              },
              {
                id: '0c83dbac_@_18',
                glCode: 6305,
                title: 'Music & DJ',
                money: 0,
                percent: 0,
              },
              {
                id: '6f7c6ca5_@_18',
                glCode: 6500,
                title: 'General & Administrative Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'f12db2ec_@_18',
                glCode: null,
                title: 'Total General & Administrative Expenses',
                money: 1900.18,
                percent: 0.0271,
              },
              {
                id: '084f517c_@_18',
                glCode: 6700,
                title: 'Travel, Meals, & Entertainment',
                money: 0,
                percent: 0,
              },
              {
                id: 'ea7ffa49_@_18',
                glCode: null,
                title: 'Total Travel, Meals, & Entertainment',
                money: 235.02,
                percent: 0.0034,
              },
              {
                id: '1675dbe8_@_18',
                glCode: 6800,
                title: 'Repairs & Maintenance',
                money: 0,
                percent: 0,
              },
              {
                id: '4da1092f_@_18',
                glCode: null,
                title: 'Total Repairs & Maintenance',
                money: 3645.32,
                percent: 0.0521,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 8775.650000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '3be3d09b_@_18',
                glCode: 6100,
                title: 'Direct Operating Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'b7f8c8b8_@_18',
                glCode: null,
                title: 'Total Direct Operating Expenses',
                money: 1672.8999999999999,
                percent: 0.0186,
              },
              {
                id: '9d0fd7d1_@_18',
                glCode: 6200,
                title: 'Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd484c66b_@_18',
                glCode: null,
                title: 'Total Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'edd65db2_@_18',
                glCode: 6250,
                title: 'Marketing & Advertising',
                money: 0,
                percent: 0,
              },
              {
                id: '024ba9eb_@_18',
                glCode: null,
                title: 'Total Marketing & Advertising',
                money: 1227.09,
                percent: 0.0136,
              },
              {
                id: '0c83dbac_@_18',
                glCode: 6305,
                title: 'Music & DJ',
                money: 0,
                percent: 0,
              },
              {
                id: '6f7c6ca5_@_18',
                glCode: 6500,
                title: 'General & Administrative Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'f12db2ec_@_18',
                glCode: null,
                title: 'Total General & Administrative Expenses',
                money: 5143.41,
                percent: 0.0571,
              },
              {
                id: '084f517c_@_18',
                glCode: 6700,
                title: 'Travel, Meals, & Entertainment',
                money: 0,
                percent: 0,
              },
              {
                id: 'ea7ffa49_@_18',
                glCode: null,
                title: 'Total Travel, Meals, & Entertainment',
                money: 206.79000000000002,
                percent: 0.0023,
              },
              {
                id: '1675dbe8_@_18',
                glCode: 6800,
                title: 'Repairs & Maintenance',
                money: 0,
                percent: 0,
              },
              {
                id: '4da1092f_@_18',
                glCode: null,
                title: 'Total Repairs & Maintenance',
                money: 525.46,
                percent: 0.0058,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 16808.58,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '3be3d09b_@_18',
                glCode: 6100,
                title: 'Direct Operating Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'b7f8c8b8_@_18',
                glCode: null,
                title: 'Total Direct Operating Expenses',
                money: 4098.21,
                percent: 0.0617,
              },
              {
                id: '9d0fd7d1_@_18',
                glCode: 6200,
                title: 'Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd484c66b_@_18',
                glCode: null,
                title: 'Total Transaction Related Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'edd65db2_@_18',
                glCode: 6250,
                title: 'Marketing & Advertising',
                money: 0,
                percent: 0,
              },
              {
                id: '024ba9eb_@_18',
                glCode: null,
                title: 'Total Marketing & Advertising',
                money: 580.8,
                percent: 0.0087,
              },
              {
                id: '0c83dbac_@_18',
                glCode: 6305,
                title: 'Music & DJ',
                money: 500,
                percent: 0.0075,
              },
              {
                id: '6f7c6ca5_@_18',
                glCode: 6500,
                title: 'General & Administrative Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'f12db2ec_@_18',
                glCode: null,
                title: 'Total General & Administrative Expenses',
                money: 5451.65,
                percent: 0.0821,
              },
              {
                id: '084f517c_@_18',
                glCode: 6700,
                title: 'Travel, Meals, & Entertainment',
                money: 0,
                percent: 0,
              },
              {
                id: 'ea7ffa49_@_18',
                glCode: null,
                title: 'Total Travel, Meals, & Entertainment',
                money: 1561.57,
                percent: 0.0235,
              },
              {
                id: '1675dbe8_@_18',
                glCode: 6800,
                title: 'Repairs & Maintenance',
                money: 0,
                percent: 0,
              },
              {
                id: '4da1092f_@_18',
                glCode: null,
                title: 'Total Repairs & Maintenance',
                money: 4616.35,
                percent: 0.0695,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
        ],
        glCode: 7000,
      },
      '3be3d09b_@_18': {
        id: '3be3d09b_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Direct Operating Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 983.0999999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '1a6a3f76_@_18',
                glCode: 6110,
                title: 'Equipment Lease Rental',
                money: 0,
                percent: 0,
              },
              {
                id: '514ec7ed_@_18',
                glCode: 6115,
                title: 'Cleaning Supplies',
                money: 184.53,
                percent: 0.0025,
              },
              {
                id: '758ae475_@_18',
                glCode: 6120,
                title: 'Cleaning Services',
                money: 0,
                percent: 0,
              },
              {
                id: '28a2ce1f_@_18',
                glCode: 6125,
                title: 'Restaurant Supplies',
                money: 529.68,
                percent: 0.0071,
              },
              {
                id: 'ad6ac922_@_18',
                glCode: 6135,
                title: 'Laundry, Linens, & Uniforms',
                money: 268.89,
                percent: 0.0036,
              },
              {
                id: '9f991141_@_18',
                glCode: 6155,
                title: 'Kitchen/ Bar Smallwares',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1566.8999999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '1a6a3f76_@_18',
                glCode: 6110,
                title: 'Equipment Lease Rental',
                money: 0,
                percent: 0,
              },
              {
                id: '514ec7ed_@_18',
                glCode: 6115,
                title: 'Cleaning Supplies',
                money: 131.91,
                percent: 0.0019,
              },
              {
                id: '758ae475_@_18',
                glCode: 6120,
                title: 'Cleaning Services',
                money: 0,
                percent: 0,
              },
              {
                id: '28a2ce1f_@_18',
                glCode: 6125,
                title: 'Restaurant Supplies',
                money: 376.87,
                percent: 0.0055,
              },
              {
                id: 'ad6ac922_@_18',
                glCode: 6135,
                title: 'Laundry, Linens, & Uniforms',
                money: 1058.12,
                percent: 0.0155,
              },
              {
                id: '9f991141_@_18',
                glCode: 6155,
                title: 'Kitchen/ Bar Smallwares',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1734.64,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '1a6a3f76_@_18',
                glCode: 6110,
                title: 'Equipment Lease Rental',
                money: 155,
                percent: 0.0022,
              },
              {
                id: '514ec7ed_@_18',
                glCode: 6115,
                title: 'Cleaning Supplies',
                money: 122.74,
                percent: 0.0018,
              },
              {
                id: '758ae475_@_18',
                glCode: 6120,
                title: 'Cleaning Services',
                money: 1044.92,
                percent: 0.0149,
              },
              {
                id: '28a2ce1f_@_18',
                glCode: 6125,
                title: 'Restaurant Supplies',
                money: 411.98,
                percent: 0.0059,
              },
              {
                id: 'ad6ac922_@_18',
                glCode: 6135,
                title: 'Laundry, Linens, & Uniforms',
                money: 0,
                percent: 0,
              },
              {
                id: '9f991141_@_18',
                glCode: 6155,
                title: 'Kitchen/ Bar Smallwares',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1672.8999999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '1a6a3f76_@_18',
                glCode: 6110,
                title: 'Equipment Lease Rental',
                money: 0,
                percent: 0,
              },
              {
                id: '514ec7ed_@_18',
                glCode: 6115,
                title: 'Cleaning Supplies',
                money: 66.69,
                percent: 0.0007,
              },
              {
                id: '758ae475_@_18',
                glCode: 6120,
                title: 'Cleaning Services',
                money: 0,
                percent: 0,
              },
              {
                id: '28a2ce1f_@_18',
                glCode: 6125,
                title: 'Restaurant Supplies',
                money: 464.64,
                percent: 0.0052,
              },
              {
                id: 'ad6ac922_@_18',
                glCode: 6135,
                title: 'Laundry, Linens, & Uniforms',
                money: 1141.57,
                percent: 0.0127,
              },
              {
                id: '9f991141_@_18',
                glCode: 6155,
                title: 'Kitchen/ Bar Smallwares',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4098.21,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '1a6a3f76_@_18',
                glCode: 6110,
                title: 'Equipment Lease Rental',
                money: 0,
                percent: 0,
              },
              {
                id: '514ec7ed_@_18',
                glCode: 6115,
                title: 'Cleaning Supplies',
                money: 174.1,
                percent: 0.0026,
              },
              {
                id: '758ae475_@_18',
                glCode: 6120,
                title: 'Cleaning Services',
                money: 0,
                percent: 0,
              },
              {
                id: '28a2ce1f_@_18',
                glCode: 6125,
                title: 'Restaurant Supplies',
                money: 371.63,
                percent: 0.0056,
              },
              {
                id: 'ad6ac922_@_18',
                glCode: 6135,
                title: 'Laundry, Linens, & Uniforms',
                money: 1954.31,
                percent: 0.0294,
              },
              {
                id: '9f991141_@_18',
                glCode: 6155,
                title: 'Kitchen/ Bar Smallwares',
                money: 1598.17,
                percent: 0.0241,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '3be3d09b_@_18',
            name: 'Direct Operating Expenses',
          },
        ],
        glCode: 6100,
      },
      '1a6a3f76_@_18': {
        id: '1a6a3f76_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Equipment Lease Rental',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 155,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0022,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '3be3d09b_@_18',
            name: 'Direct Operating Expenses',
          },
          {
            id: '1a6a3f76_@_18',
            name: 'Equipment Lease Rental',
          },
        ],
        glCode: 6110,
      },
      '514ec7ed_@_18': {
        id: '514ec7ed_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Cleaning Supplies',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 184.53,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0025,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 131.91,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0019,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 122.74,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0018,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 66.69,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0007,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 174.1,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0026,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '3be3d09b_@_18',
            name: 'Direct Operating Expenses',
          },
          {
            id: '514ec7ed_@_18',
            name: 'Cleaning Supplies',
          },
        ],
        glCode: 6115,
      },
      '758ae475_@_18': {
        id: '758ae475_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Cleaning Services',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1044.92,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0149,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '3be3d09b_@_18',
            name: 'Direct Operating Expenses',
          },
          {
            id: '758ae475_@_18',
            name: 'Cleaning Services',
          },
        ],
        glCode: 6120,
      },
      '28a2ce1f_@_18': {
        id: '28a2ce1f_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Restaurant Supplies',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 529.68,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0071,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 376.87,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0055,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 411.98,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0059,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 464.64,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0052,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 371.63,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0056,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '3be3d09b_@_18',
            name: 'Direct Operating Expenses',
          },
          {
            id: '28a2ce1f_@_18',
            name: 'Restaurant Supplies',
          },
        ],
        glCode: 6125,
      },
      'ad6ac922_@_18': {
        id: 'ad6ac922_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Laundry, Linens, & Uniforms',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 268.89,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0036,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1058.12,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0155,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1141.57,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0127,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1954.31,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0294,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '3be3d09b_@_18',
            name: 'Direct Operating Expenses',
          },
          {
            id: 'ad6ac922_@_18',
            name: 'Laundry, Linens, & Uniforms',
          },
        ],
        glCode: 6135,
      },
      '9f991141_@_18': {
        id: '9f991141_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Kitchen/ Bar Smallwares',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1598.17,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0241,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '3be3d09b_@_18',
            name: 'Direct Operating Expenses',
          },
          {
            id: '9f991141_@_18',
            name: 'Kitchen/ Bar Smallwares',
          },
        ],
        glCode: 6155,
      },
      'b7f8c8b8_@_18': {
        id: 'b7f8c8b8_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Direct Operating Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 983.0999999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0131,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1566.8999999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.023,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1734.64,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0248,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1672.8999999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0186,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4098.21,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0617,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: 'b7f8c8b8_@_18',
            name: 'Total Direct Operating Expenses',
          },
        ],
        glCode: null,
      },
      '9d0fd7d1_@_18': {
        id: '9d0fd7d1_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Transaction Related Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '47bbbb15_@_18',
                glCode: 6215,
                title: '3rd Party Commissions',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '47bbbb15_@_18',
                glCode: 6215,
                title: '3rd Party Commissions',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '47bbbb15_@_18',
                glCode: 6215,
                title: '3rd Party Commissions',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '47bbbb15_@_18',
                glCode: 6215,
                title: '3rd Party Commissions',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '47bbbb15_@_18',
                glCode: 6215,
                title: '3rd Party Commissions',
                money: 0,
                percent: 0,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '9d0fd7d1_@_18',
            name: 'Transaction Related Expenses',
          },
        ],
        glCode: 6200,
      },
      '47bbbb15_@_18': {
        id: '47bbbb15_@_18',
        info: 'P&L Comparison (Weekly)',
        name: '3rd Party Commissions',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '9d0fd7d1_@_18',
            name: 'Transaction Related Expenses',
          },
          {
            id: '47bbbb15_@_18',
            name: '3rd Party Commissions',
          },
        ],
        glCode: 6215,
      },
      'd484c66b_@_18': {
        id: 'd484c66b_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Transaction Related Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: 'd484c66b_@_18',
            name: 'Total Transaction Related Expenses',
          },
        ],
        glCode: null,
      },
      'edd65db2_@_18': {
        id: 'edd65db2_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Marketing & Advertising',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 548,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c61b398a_@_18',
                glCode: 6255,
                title: 'Marketing & Public Relations',
                money: 0,
                percent: 0,
              },
              {
                id: '1dc3b3a3_@_18',
                glCode: 6260,
                title: 'Advertising & Promotions',
                money: 548,
                percent: 0.0073,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 311.19,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c61b398a_@_18',
                glCode: 6255,
                title: 'Marketing & Public Relations',
                money: 22.19,
                percent: 0.0003,
              },
              {
                id: '1dc3b3a3_@_18',
                glCode: 6260,
                title: 'Advertising & Promotions',
                money: 289,
                percent: 0.0042,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1700,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c61b398a_@_18',
                glCode: 6255,
                title: 'Marketing & Public Relations',
                money: 1700,
                percent: 0.0243,
              },
              {
                id: '1dc3b3a3_@_18',
                glCode: 6260,
                title: 'Advertising & Promotions',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1227.09,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c61b398a_@_18',
                glCode: 6255,
                title: 'Marketing & Public Relations',
                money: 0,
                percent: 0,
              },
              {
                id: '1dc3b3a3_@_18',
                glCode: 6260,
                title: 'Advertising & Promotions',
                money: 1227.09,
                percent: 0.0136,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 580.8,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'c61b398a_@_18',
                glCode: 6255,
                title: 'Marketing & Public Relations',
                money: 210.8,
                percent: 0.0032,
              },
              {
                id: '1dc3b3a3_@_18',
                glCode: 6260,
                title: 'Advertising & Promotions',
                money: 370,
                percent: 0.0056,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: 'edd65db2_@_18',
            name: 'Marketing & Advertising',
          },
        ],
        glCode: 6250,
      },
      'c61b398a_@_18': {
        id: 'c61b398a_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Marketing & Public Relations',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 22.19,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0003,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1700,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0243,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 210.8,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0032,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: 'edd65db2_@_18',
            name: 'Marketing & Advertising',
          },
          {
            id: 'c61b398a_@_18',
            name: 'Marketing & Public Relations',
          },
        ],
        glCode: 6255,
      },
      '1dc3b3a3_@_18': {
        id: '1dc3b3a3_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Advertising & Promotions',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 548,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0073,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 289,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0042,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1227.09,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0136,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 370,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0056,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: 'edd65db2_@_18',
            name: 'Marketing & Advertising',
          },
          {
            id: '1dc3b3a3_@_18',
            name: 'Advertising & Promotions',
          },
        ],
        glCode: 6260,
      },
      '024ba9eb_@_18': {
        id: '024ba9eb_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Marketing & Advertising',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 548,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0073,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 311.19,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0046,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1700,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0243,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1227.09,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0136,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 580.8,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0087,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '024ba9eb_@_18',
            name: 'Total Marketing & Advertising',
          },
        ],
        glCode: null,
      },
      '0c83dbac_@_18': {
        id: '0c83dbac_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Music & DJ',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 500,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0075,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '0c83dbac_@_18',
            name: 'Music & DJ',
          },
        ],
        glCode: 6305,
      },
      '6f7c6ca5_@_18': {
        id: '6f7c6ca5_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'General & Administrative Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4857.389999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '5a0fedcf_@_18',
                glCode: 6505,
                title: 'Accounting & Bookkeeping',
                money: 0,
                percent: 0,
              },
              {
                id: 'b08821c2_@_18',
                glCode: 6510,
                title: 'Consulting',
                money: 0,
                percent: 0,
              },
              {
                id: 'a630ac37_@_18',
                glCode: 6520,
                title: 'Legal',
                money: 1233.49,
                percent: 0.0165,
              },
              {
                id: '975961bc_@_18',
                glCode: 6525,
                title: 'Payroll Processing Fees',
                money: 0,
                percent: 0,
              },
              {
                id: '9450bb96_@_18',
                glCode: 6535,
                title: 'Computer Supplies, Software & IT',
                money: 0,
                percent: 0,
              },
              {
                id: '236c5723_@_18',
                glCode: 6550,
                title: 'Dues and Subscriptions',
                money: 12.78,
                percent: 0.0002,
              },
              {
                id: 'c3c23383_@_18',
                glCode: 6560,
                title: 'Bank Charges & Fees',
                money: 90,
                percent: 0.0012,
              },
              {
                id: '058d9b25_@_18',
                glCode: 6575,
                title: 'Office Supplies & Expenses',
                money: 3521.12,
                percent: 0.0471,
              },
              {
                id: '0c2b505e_@_18',
                glCode: 6605,
                title: 'Phone and Internet',
                money: 0,
                percent: 0,
              },
              {
                id: '9dc533d9_@_18',
                glCode: 6610,
                title: 'Security',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3212.6499999999996,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '5a0fedcf_@_18',
                glCode: 6505,
                title: 'Accounting & Bookkeeping',
                money: 0,
                percent: 0,
              },
              {
                id: 'b08821c2_@_18',
                glCode: 6510,
                title: 'Consulting',
                money: 0,
                percent: 0,
              },
              {
                id: 'a630ac37_@_18',
                glCode: 6520,
                title: 'Legal',
                money: 0,
                percent: 0,
              },
              {
                id: '975961bc_@_18',
                glCode: 6525,
                title: 'Payroll Processing Fees',
                money: 92.53,
                percent: 0.0014,
              },
              {
                id: '9450bb96_@_18',
                glCode: 6535,
                title: 'Computer Supplies, Software & IT',
                money: 1440.67,
                percent: 0.0212,
              },
              {
                id: '236c5723_@_18',
                glCode: 6550,
                title: 'Dues and Subscriptions',
                money: 0,
                percent: 0,
              },
              {
                id: 'c3c23383_@_18',
                glCode: 6560,
                title: 'Bank Charges & Fees',
                money: 0,
                percent: 0,
              },
              {
                id: '058d9b25_@_18',
                glCode: 6575,
                title: 'Office Supplies & Expenses',
                money: 1286.21,
                percent: 0.0189,
              },
              {
                id: '0c2b505e_@_18',
                glCode: 6605,
                title: 'Phone and Internet',
                money: 393.24,
                percent: 0.0058,
              },
              {
                id: '9dc533d9_@_18',
                glCode: 6610,
                title: 'Security',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1900.18,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '5a0fedcf_@_18',
                glCode: 6505,
                title: 'Accounting & Bookkeeping',
                money: 0,
                percent: 0,
              },
              {
                id: 'b08821c2_@_18',
                glCode: 6510,
                title: 'Consulting',
                money: 0,
                percent: 0,
              },
              {
                id: 'a630ac37_@_18',
                glCode: 6520,
                title: 'Legal',
                money: 1681,
                percent: 0.024,
              },
              {
                id: '975961bc_@_18',
                glCode: 6525,
                title: 'Payroll Processing Fees',
                money: 0,
                percent: 0,
              },
              {
                id: '9450bb96_@_18',
                glCode: 6535,
                title: 'Computer Supplies, Software & IT',
                money: 110,
                percent: 0.0016,
              },
              {
                id: '236c5723_@_18',
                glCode: 6550,
                title: 'Dues and Subscriptions',
                money: 0,
                percent: 0,
              },
              {
                id: 'c3c23383_@_18',
                glCode: 6560,
                title: 'Bank Charges & Fees',
                money: 90,
                percent: 0.0013,
              },
              {
                id: '058d9b25_@_18',
                glCode: 6575,
                title: 'Office Supplies & Expenses',
                money: 19.18,
                percent: 0.0003,
              },
              {
                id: '0c2b505e_@_18',
                glCode: 6605,
                title: 'Phone and Internet',
                money: 0,
                percent: 0,
              },
              {
                id: '9dc533d9_@_18',
                glCode: 6610,
                title: 'Security',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5143.41,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '5a0fedcf_@_18',
                glCode: 6505,
                title: 'Accounting & Bookkeeping',
                money: 1499,
                percent: 0.0166,
              },
              {
                id: 'b08821c2_@_18',
                glCode: 6510,
                title: 'Consulting',
                money: 0,
                percent: 0,
              },
              {
                id: 'a630ac37_@_18',
                glCode: 6520,
                title: 'Legal',
                money: 2500,
                percent: 0.0277,
              },
              {
                id: '975961bc_@_18',
                glCode: 6525,
                title: 'Payroll Processing Fees',
                money: 80,
                percent: 0.0009,
              },
              {
                id: '9450bb96_@_18',
                glCode: 6535,
                title: 'Computer Supplies, Software & IT',
                money: 0,
                percent: 0,
              },
              {
                id: '236c5723_@_18',
                glCode: 6550,
                title: 'Dues and Subscriptions',
                money: 114.36,
                percent: 0.0013,
              },
              {
                id: 'c3c23383_@_18',
                glCode: 6560,
                title: 'Bank Charges & Fees',
                money: 50,
                percent: 0.0006,
              },
              {
                id: '058d9b25_@_18',
                glCode: 6575,
                title: 'Office Supplies & Expenses',
                money: 900.05,
                percent: 0.01,
              },
              {
                id: '0c2b505e_@_18',
                glCode: 6605,
                title: 'Phone and Internet',
                money: 0,
                percent: 0,
              },
              {
                id: '9dc533d9_@_18',
                glCode: 6610,
                title: 'Security',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5451.65,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '5a0fedcf_@_18',
                glCode: 6505,
                title: 'Accounting & Bookkeeping',
                money: 0,
                percent: 0,
              },
              {
                id: 'b08821c2_@_18',
                glCode: 6510,
                title: 'Consulting',
                money: 1250,
                percent: 0.0188,
              },
              {
                id: 'a630ac37_@_18',
                glCode: 6520,
                title: 'Legal',
                money: 1806.54,
                percent: 0.0272,
              },
              {
                id: '975961bc_@_18',
                glCode: 6525,
                title: 'Payroll Processing Fees',
                money: 0,
                percent: 0,
              },
              {
                id: '9450bb96_@_18',
                glCode: 6535,
                title: 'Computer Supplies, Software & IT',
                money: 0,
                percent: 0,
              },
              {
                id: '236c5723_@_18',
                glCode: 6550,
                title: 'Dues and Subscriptions',
                money: 0,
                percent: 0,
              },
              {
                id: 'c3c23383_@_18',
                glCode: 6560,
                title: 'Bank Charges & Fees',
                money: 0,
                percent: 0,
              },
              {
                id: '058d9b25_@_18',
                glCode: 6575,
                title: 'Office Supplies & Expenses',
                money: 1110.12,
                percent: 0.0167,
              },
              {
                id: '0c2b505e_@_18',
                glCode: 6605,
                title: 'Phone and Internet',
                money: 334.99,
                percent: 0.005,
              },
              {
                id: '9dc533d9_@_18',
                glCode: 6610,
                title: 'Security',
                money: 950,
                percent: 0.0143,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
        ],
        glCode: 6500,
      },
      '5a0fedcf_@_18': {
        id: '5a0fedcf_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Accounting & Bookkeeping',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1499,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0166,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: '5a0fedcf_@_18',
            name: 'Accounting & Bookkeeping',
          },
        ],
        glCode: 6505,
      },
      'b08821c2_@_18': {
        id: 'b08821c2_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Consulting',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1250,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0188,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: 'b08821c2_@_18',
            name: 'Consulting',
          },
        ],
        glCode: 6510,
      },
      'a630ac37_@_18': {
        id: 'a630ac37_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Legal',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1233.49,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0165,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1681,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.024,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2500,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0277,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1806.54,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0272,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: 'a630ac37_@_18',
            name: 'Legal',
          },
        ],
        glCode: 6520,
      },
      '975961bc_@_18': {
        id: '975961bc_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Payroll Processing Fees',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 92.53,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0014,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 80,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0009,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: '975961bc_@_18',
            name: 'Payroll Processing Fees',
          },
        ],
        glCode: 6525,
      },
      '9450bb96_@_18': {
        id: '9450bb96_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Computer Supplies, Software & IT',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1440.67,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0212,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 110,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0016,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: '9450bb96_@_18',
            name: 'Computer Supplies, Software & IT',
          },
        ],
        glCode: 6535,
      },
      '236c5723_@_18': {
        id: '236c5723_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Dues and Subscriptions',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 12.78,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0002,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 114.36,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0013,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: '236c5723_@_18',
            name: 'Dues and Subscriptions',
          },
        ],
        glCode: 6550,
      },
      'c3c23383_@_18': {
        id: 'c3c23383_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Bank Charges & Fees',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 90,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0012,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 90,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0013,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 50,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0006,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: 'c3c23383_@_18',
            name: 'Bank Charges & Fees',
          },
        ],
        glCode: 6560,
      },
      '058d9b25_@_18': {
        id: '058d9b25_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Office Supplies & Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3521.12,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0471,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1286.21,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0189,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 19.18,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0003,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 900.05,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.01,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1110.12,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0167,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: '058d9b25_@_18',
            name: 'Office Supplies & Expenses',
          },
        ],
        glCode: 6575,
      },
      '0c2b505e_@_18': {
        id: '0c2b505e_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Phone and Internet',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 393.24,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0058,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 334.99,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.005,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: '0c2b505e_@_18',
            name: 'Phone and Internet',
          },
        ],
        glCode: 6605,
      },
      '9dc533d9_@_18': {
        id: '9dc533d9_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Security',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 950,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0143,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '6f7c6ca5_@_18',
            name: 'General & Administrative Expenses',
          },
          {
            id: '9dc533d9_@_18',
            name: 'Security',
          },
        ],
        glCode: 6610,
      },
      'f12db2ec_@_18': {
        id: 'f12db2ec_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Total General & Administrative Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4857.389999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0649,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3212.6499999999996,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0472,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1900.18,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0271,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5143.41,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0571,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 5451.65,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0821,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: 'f12db2ec_@_18',
            name: 'Total General & Administrative Expenses',
          },
        ],
        glCode: null,
      },
      '084f517c_@_18': {
        id: '084f517c_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Travel, Meals, & Entertainment',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1714.04,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'e4e1ab18_@_18',
                glCode: 6705,
                title: 'Travel, Ground Transport & Airfare',
                money: 355.12,
                percent: 0.0047,
              },
              {
                id: 'f245aeff_@_18',
                glCode: 6710,
                title: 'Meals & Entertainment',
                money: 86.91,
                percent: 0.0012,
              },
              {
                id: '3ae4b332_@_18',
                glCode: 6720,
                title: 'Parking',
                money: 1238,
                percent: 0.0165,
              },
              {
                id: '4dbd49a9_@_18',
                glCode: 6725,
                title: 'Fuel',
                money: 34.01,
                percent: 0.0005,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1013.13,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'e4e1ab18_@_18',
                glCode: 6705,
                title: 'Travel, Ground Transport & Airfare',
                money: 105.95,
                percent: 0.0016,
              },
              {
                id: 'f245aeff_@_18',
                glCode: 6710,
                title: 'Meals & Entertainment',
                money: 871.17,
                percent: 0.0128,
              },
              {
                id: '3ae4b332_@_18',
                glCode: 6720,
                title: 'Parking',
                money: 0,
                percent: 0,
              },
              {
                id: '4dbd49a9_@_18',
                glCode: 6725,
                title: 'Fuel',
                money: 36.01,
                percent: 0.0005,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 235.02,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'e4e1ab18_@_18',
                glCode: 6705,
                title: 'Travel, Ground Transport & Airfare',
                money: 235.02,
                percent: 0.0034,
              },
              {
                id: 'f245aeff_@_18',
                glCode: 6710,
                title: 'Meals & Entertainment',
                money: 0,
                percent: 0,
              },
              {
                id: '3ae4b332_@_18',
                glCode: 6720,
                title: 'Parking',
                money: 0,
                percent: 0,
              },
              {
                id: '4dbd49a9_@_18',
                glCode: 6725,
                title: 'Fuel',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 206.79000000000002,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'e4e1ab18_@_18',
                glCode: 6705,
                title: 'Travel, Ground Transport & Airfare',
                money: 79.12,
                percent: 0.0009,
              },
              {
                id: 'f245aeff_@_18',
                glCode: 6710,
                title: 'Meals & Entertainment',
                money: 92.67,
                percent: 0.001,
              },
              {
                id: '3ae4b332_@_18',
                glCode: 6720,
                title: 'Parking',
                money: 0,
                percent: 0,
              },
              {
                id: '4dbd49a9_@_18',
                glCode: 6725,
                title: 'Fuel',
                money: 35,
                percent: 0.0004,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1561.57,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'e4e1ab18_@_18',
                glCode: 6705,
                title: 'Travel, Ground Transport & Airfare',
                money: 176.49,
                percent: 0.0027,
              },
              {
                id: 'f245aeff_@_18',
                glCode: 6710,
                title: 'Meals & Entertainment',
                money: 89.97,
                percent: 0.0014,
              },
              {
                id: '3ae4b332_@_18',
                glCode: 6720,
                title: 'Parking',
                money: 1238,
                percent: 0.0186,
              },
              {
                id: '4dbd49a9_@_18',
                glCode: 6725,
                title: 'Fuel',
                money: 57.11,
                percent: 0.0009,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '084f517c_@_18',
            name: 'Travel, Meals, & Entertainment',
          },
        ],
        glCode: 6700,
      },
      'e4e1ab18_@_18': {
        id: 'e4e1ab18_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Travel, Ground Transport & Airfare',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 355.12,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0047,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 105.95,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0016,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 235.02,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0034,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 79.12,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0009,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 176.49,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0027,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '084f517c_@_18',
            name: 'Travel, Meals, & Entertainment',
          },
          {
            id: 'e4e1ab18_@_18',
            name: 'Travel, Ground Transport & Airfare',
          },
        ],
        glCode: 6705,
      },
      'f245aeff_@_18': {
        id: 'f245aeff_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Meals & Entertainment',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 86.91,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0012,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 871.17,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0128,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 92.67,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.001,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 89.97,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0014,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '084f517c_@_18',
            name: 'Travel, Meals, & Entertainment',
          },
          {
            id: 'f245aeff_@_18',
            name: 'Meals & Entertainment',
          },
        ],
        glCode: 6710,
      },
      '3ae4b332_@_18': {
        id: '3ae4b332_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Parking',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1238,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0165,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1238,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0186,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '084f517c_@_18',
            name: 'Travel, Meals, & Entertainment',
          },
          {
            id: '3ae4b332_@_18',
            name: 'Parking',
          },
        ],
        glCode: 6720,
      },
      '4dbd49a9_@_18': {
        id: '4dbd49a9_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Fuel',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 34.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0005,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 36.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0005,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 35,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0004,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 57.11,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0009,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '084f517c_@_18',
            name: 'Travel, Meals, & Entertainment',
          },
          {
            id: '4dbd49a9_@_18',
            name: 'Fuel',
          },
        ],
        glCode: 6725,
      },
      'ea7ffa49_@_18': {
        id: 'ea7ffa49_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Travel, Meals, & Entertainment',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1714.04,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0229,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1013.13,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0149,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 235.02,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0034,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 206.79000000000002,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0023,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1561.57,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0235,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: 'ea7ffa49_@_18',
            name: 'Total Travel, Meals, & Entertainment',
          },
        ],
        glCode: null,
      },
      '1675dbe8_@_18': {
        id: '1675dbe8_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Repairs & Maintenance',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1777.52,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'aa06968c_@_18',
                glCode: 6810,
                title: 'Repair & Maintenance, Equipment',
                money: 0,
                percent: 0,
              },
              {
                id: '4d40af10_@_18',
                glCode: 6815,
                title: 'Repair & Maintenance, Facility',
                money: 1777.52,
                percent: 0.0238,
              },
              {
                id: 'a044faba_@_18',
                glCode: 6820,
                title: 'Pest Control',
                money: 0,
                percent: 0,
              },
              {
                id: 'd6450b86_@_18',
                glCode: 6825,
                title: 'Fire Control',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4139.26,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'aa06968c_@_18',
                glCode: 6810,
                title: 'Repair & Maintenance, Equipment',
                money: 2441.6,
                percent: 0.0359,
              },
              {
                id: '4d40af10_@_18',
                glCode: 6815,
                title: 'Repair & Maintenance, Facility',
                money: 1697.66,
                percent: 0.0249,
              },
              {
                id: 'a044faba_@_18',
                glCode: 6820,
                title: 'Pest Control',
                money: 0,
                percent: 0,
              },
              {
                id: 'd6450b86_@_18',
                glCode: 6825,
                title: 'Fire Control',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3645.32,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'aa06968c_@_18',
                glCode: 6810,
                title: 'Repair & Maintenance, Equipment',
                money: 0,
                percent: 0,
              },
              {
                id: '4d40af10_@_18',
                glCode: 6815,
                title: 'Repair & Maintenance, Facility',
                money: 3645.32,
                percent: 0.0521,
              },
              {
                id: 'a044faba_@_18',
                glCode: 6820,
                title: 'Pest Control',
                money: 0,
                percent: 0,
              },
              {
                id: 'd6450b86_@_18',
                glCode: 6825,
                title: 'Fire Control',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 525.46,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'aa06968c_@_18',
                glCode: 6810,
                title: 'Repair & Maintenance, Equipment',
                money: 0,
                percent: 0,
              },
              {
                id: '4d40af10_@_18',
                glCode: 6815,
                title: 'Repair & Maintenance, Facility',
                money: 0,
                percent: 0,
              },
              {
                id: 'a044faba_@_18',
                glCode: 6820,
                title: 'Pest Control',
                money: 525.46,
                percent: 0.0058,
              },
              {
                id: 'd6450b86_@_18',
                glCode: 6825,
                title: 'Fire Control',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4616.35,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'aa06968c_@_18',
                glCode: 6810,
                title: 'Repair & Maintenance, Equipment',
                money: 3479,
                percent: 0.0524,
              },
              {
                id: '4d40af10_@_18',
                glCode: 6815,
                title: 'Repair & Maintenance, Facility',
                money: 0,
                percent: 0,
              },
              {
                id: 'a044faba_@_18',
                glCode: 6820,
                title: 'Pest Control',
                money: 1137.35,
                percent: 0.0171,
              },
              {
                id: 'd6450b86_@_18',
                glCode: 6825,
                title: 'Fire Control',
                money: 0,
                percent: 0,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '1675dbe8_@_18',
            name: 'Repairs & Maintenance',
          },
        ],
        glCode: 6800,
      },
      'aa06968c_@_18': {
        id: 'aa06968c_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Repair & Maintenance, Equipment',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2441.6,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0359,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3479,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0524,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '1675dbe8_@_18',
            name: 'Repairs & Maintenance',
          },
          {
            id: 'aa06968c_@_18',
            name: 'Repair & Maintenance, Equipment',
          },
        ],
        glCode: 6810,
      },
      '4d40af10_@_18': {
        id: '4d40af10_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Repair & Maintenance, Facility',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1777.52,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0238,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1697.66,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0249,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3645.32,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0521,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '1675dbe8_@_18',
            name: 'Repairs & Maintenance',
          },
          {
            id: '4d40af10_@_18',
            name: 'Repair & Maintenance, Facility',
          },
        ],
        glCode: 6815,
      },
      'a044faba_@_18': {
        id: 'a044faba_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Pest Control',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 525.46,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0058,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1137.35,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0171,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '1675dbe8_@_18',
            name: 'Repairs & Maintenance',
          },
          {
            id: 'a044faba_@_18',
            name: 'Pest Control',
          },
        ],
        glCode: 6820,
      },
      'd6450b86_@_18': {
        id: 'd6450b86_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Fire Control',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '1675dbe8_@_18',
            name: 'Repairs & Maintenance',
          },
          {
            id: 'd6450b86_@_18',
            name: 'Fire Control',
          },
        ],
        glCode: 6825,
      },
      '4da1092f_@_18': {
        id: '4da1092f_@_18',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Repairs & Maintenance',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1777.52,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0238,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4139.26,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0608,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 3645.32,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0521,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 525.46,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0058,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 4616.35,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0695,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '2cd659af_@_18',
            name: 'CONTROLLABLE EXPENSES',
          },
          {
            id: '4da1092f_@_18',
            name: 'Total Repairs & Maintenance',
          },
        ],
        glCode: null,
      },
      'a624f257_@_19': {
        id: 'a624f257_@_19',
        info: 'P&L Comparison (Weekly)',
        name: 'TOTAL CONTROLLABLE EXPENSES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 9880.05,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1321,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 10243.130000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1504,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 9215.160000000002,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.1316,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 8775.650000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0974,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 16808.58,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.253,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'a624f257_@_19',
            name: 'TOTAL CONTROLLABLE EXPENSES',
          },
        ],
        glCode: null,
      },
      'a973b710_@_20': {
        id: 'a973b710_@_20',
        info: 'P&L Comparison (Weekly)',
        name: 'Controllable Profit',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 23820.620000000006,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.3184,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -17993.639999999996,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.2642,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -12321.610000000013,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.176,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 36319.469999999994,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4031,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 21090.369999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.3175,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'a973b710_@_20',
            name: 'Controllable Profit',
          },
        ],
        glCode: null,
      },
      '79208dfc_@_21': {
        id: '79208dfc_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'NON-CONTROLLABLE EXPENSES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1960,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '52e26b6b_@_21',
                glCode: 7100,
                title: 'Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '20d5762f_@_21',
                glCode: null,
                title: 'Total Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '763b7c77_@_21',
                glCode: 8100,
                title: 'Other Income and Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd4b5a9af_@_21',
                glCode: null,
                title: 'Total Other Income and Expenses',
                money: 1960,
                percent: 0.0262,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 20878.18,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '52e26b6b_@_21',
                glCode: 7100,
                title: 'Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '20d5762f_@_21',
                glCode: null,
                title: 'Total Property Expenses',
                money: 18437.33,
                percent: 0.2708,
              },
              {
                id: '763b7c77_@_21',
                glCode: 8100,
                title: 'Other Income and Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd4b5a9af_@_21',
                glCode: null,
                title: 'Total Other Income and Expenses',
                money: 2440.85,
                percent: 0.0358,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '52e26b6b_@_21',
                glCode: 7100,
                title: 'Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '20d5762f_@_21',
                glCode: null,
                title: 'Total Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '763b7c77_@_21',
                glCode: 8100,
                title: 'Other Income and Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd4b5a9af_@_21',
                glCode: null,
                title: 'Total Other Income and Expenses',
                money: -1.01,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '52e26b6b_@_21',
                glCode: 7100,
                title: 'Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '20d5762f_@_21',
                glCode: null,
                title: 'Total Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '763b7c77_@_21',
                glCode: 8100,
                title: 'Other Income and Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd4b5a9af_@_21',
                glCode: null,
                title: 'Total Other Income and Expenses',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1879.5900000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '52e26b6b_@_21',
                glCode: 7100,
                title: 'Property Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '20d5762f_@_21',
                glCode: null,
                title: 'Total Property Expenses',
                money: 430.96,
                percent: 0.0065,
              },
              {
                id: '763b7c77_@_21',
                glCode: 8100,
                title: 'Other Income and Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: 'd4b5a9af_@_21',
                glCode: null,
                title: 'Total Other Income and Expenses',
                money: 1448.63,
                percent: 0.0218,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
        ],
        glCode: 8000,
      },
      '52e26b6b_@_21': {
        id: '52e26b6b_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Property Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '68876c4f_@_21',
                glCode: 7105,
                title: 'Rent/Lease',
                money: 0,
                percent: 0,
              },
              {
                id: '208dfabc_@_21',
                glCode: 7125,
                title: 'Utility, Electricity',
                money: 0,
                percent: 0,
              },
              {
                id: 'c9446d9c_@_21',
                glCode: 7130,
                title: 'Utility, Gas',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18437.33,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '68876c4f_@_21',
                glCode: 7105,
                title: 'Rent/Lease',
                money: 18437.33,
                percent: 0.2708,
              },
              {
                id: '208dfabc_@_21',
                glCode: 7125,
                title: 'Utility, Electricity',
                money: 0,
                percent: 0,
              },
              {
                id: 'c9446d9c_@_21',
                glCode: 7130,
                title: 'Utility, Gas',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '68876c4f_@_21',
                glCode: 7105,
                title: 'Rent/Lease',
                money: 0,
                percent: 0,
              },
              {
                id: '208dfabc_@_21',
                glCode: 7125,
                title: 'Utility, Electricity',
                money: 0,
                percent: 0,
              },
              {
                id: 'c9446d9c_@_21',
                glCode: 7130,
                title: 'Utility, Gas',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '68876c4f_@_21',
                glCode: 7105,
                title: 'Rent/Lease',
                money: 0,
                percent: 0,
              },
              {
                id: '208dfabc_@_21',
                glCode: 7125,
                title: 'Utility, Electricity',
                money: 0,
                percent: 0,
              },
              {
                id: 'c9446d9c_@_21',
                glCode: 7130,
                title: 'Utility, Gas',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 430.96,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '68876c4f_@_21',
                glCode: 7105,
                title: 'Rent/Lease',
                money: 0,
                percent: 0,
              },
              {
                id: '208dfabc_@_21',
                glCode: 7125,
                title: 'Utility, Electricity',
                money: 0,
                percent: 0,
              },
              {
                id: 'c9446d9c_@_21',
                glCode: 7130,
                title: 'Utility, Gas',
                money: 430.96,
                percent: 0.0065,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '52e26b6b_@_21',
            name: 'Property Expenses',
          },
        ],
        glCode: 7100,
      },
      '68876c4f_@_21': {
        id: '68876c4f_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Rent/Lease',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18437.33,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2708,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '52e26b6b_@_21',
            name: 'Property Expenses',
          },
          {
            id: '68876c4f_@_21',
            name: 'Rent/Lease',
          },
        ],
        glCode: 7105,
      },
      '208dfabc_@_21': {
        id: '208dfabc_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Utility, Electricity',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '52e26b6b_@_21',
            name: 'Property Expenses',
          },
          {
            id: '208dfabc_@_21',
            name: 'Utility, Electricity',
          },
        ],
        glCode: 7125,
      },
      'c9446d9c_@_21': {
        id: 'c9446d9c_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Utility, Gas',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 430.96,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0065,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '52e26b6b_@_21',
            name: 'Property Expenses',
          },
          {
            id: 'c9446d9c_@_21',
            name: 'Utility, Gas',
          },
        ],
        glCode: 7130,
      },
      '20d5762f_@_21': {
        id: '20d5762f_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Property Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 18437.33,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2708,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 430.96,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0065,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '20d5762f_@_21',
            name: 'Total Property Expenses',
          },
        ],
        glCode: null,
      },
      '763b7c77_@_21': {
        id: '763b7c77_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Other Income and Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1960,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '91f38f9a_@_21',
                glCode: 8130,
                title: 'Other Income/Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '5ccef3e9_@_21',
                glCode: 9999,
                title: 'To Be Classified P&L',
                money: 1960,
                percent: 0.0262,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2440.85,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '91f38f9a_@_21',
                glCode: 8130,
                title: 'Other Income/Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '5ccef3e9_@_21',
                glCode: 9999,
                title: 'To Be Classified P&L',
                money: 2440.85,
                percent: 0.0358,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '91f38f9a_@_21',
                glCode: 8130,
                title: 'Other Income/Expenses',
                money: -1.01,
                percent: 0,
              },
              {
                id: '5ccef3e9_@_21',
                glCode: 9999,
                title: 'To Be Classified P&L',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '91f38f9a_@_21',
                glCode: 8130,
                title: 'Other Income/Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '5ccef3e9_@_21',
                glCode: 9999,
                title: 'To Be Classified P&L',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1448.63,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '91f38f9a_@_21',
                glCode: 8130,
                title: 'Other Income/Expenses',
                money: 0,
                percent: 0,
              },
              {
                id: '5ccef3e9_@_21',
                glCode: 9999,
                title: 'To Be Classified P&L',
                money: 1448.63,
                percent: 0.0218,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '763b7c77_@_21',
            name: 'Other Income and Expenses',
          },
        ],
        glCode: 8100,
      },
      '91f38f9a_@_21': {
        id: '91f38f9a_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Other Income/Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '763b7c77_@_21',
            name: 'Other Income and Expenses',
          },
          {
            id: '91f38f9a_@_21',
            name: 'Other Income/Expenses',
          },
        ],
        glCode: 8130,
      },
      '5ccef3e9_@_21': {
        id: '5ccef3e9_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'To Be Classified P&L',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1960,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0262,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2440.85,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0358,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1448.63,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0218,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: '763b7c77_@_21',
            name: 'Other Income and Expenses',
          },
          {
            id: '5ccef3e9_@_21',
            name: 'To Be Classified P&L',
          },
        ],
        glCode: 9999,
      },
      'd4b5a9af_@_21': {
        id: 'd4b5a9af_@_21',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Other Income and Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1960,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0262,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 2440.85,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0358,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1448.63,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0218,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '79208dfc_@_21',
            name: 'NON-CONTROLLABLE EXPENSES',
          },
          {
            id: 'd4b5a9af_@_21',
            name: 'Total Other Income and Expenses',
          },
        ],
        glCode: null,
      },
      '1851dc59_@_22': {
        id: '1851dc59_@_22',
        info: 'P&L Comparison (Weekly)',
        name: 'TOTAL NON-CONTROLLABLE EXPENSES',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1960,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0262,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 20878.18,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.3066,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -1.01,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 1879.5900000000001,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.0283,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '1851dc59_@_22',
            name: 'TOTAL NON-CONTROLLABLE EXPENSES',
          },
        ],
        glCode: null,
      },
      '251b8ac6_@_23': {
        id: '251b8ac6_@_23',
        info: 'P&L Comparison (Weekly)',
        name: 'Operating Profit',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 21860.620000000006,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2922,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -38871.81999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.5709,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -12320.600000000013,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.1759,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 36319.469999999994,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4031,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 19210.779999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2892,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '251b8ac6_@_23',
            name: 'Operating Profit',
          },
        ],
        glCode: null,
      },
      '5e10c38d_@_24': {
        id: '5e10c38d_@_24',
        info: 'P&L Comparison (Weekly)',
        name: 'Other Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '13e3a076_@_24',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '13e3a076_@_24',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '13e3a076_@_24',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '13e3a076_@_24',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: '13e3a076_@_24',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '5e10c38d_@_24',
            name: 'Other Expenses',
          },
        ],
        glCode: null,
      },
      '13e3a076_@_24': {
        id: '13e3a076_@_24',
        info: 'P&L Comparison (Weekly)',
        name: 'Loan Interest',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '5e10c38d_@_24',
            name: 'Other Expenses',
          },
          {
            id: '13e3a076_@_24',
            name: 'Loan Interest',
          },
        ],
        glCode: 8205,
      },
      'caeb87a7_@_25': {
        id: 'caeb87a7_@_25',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Other Expenses',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'caeb87a7_@_25',
            name: 'Total Other Expenses',
          },
        ],
        glCode: null,
      },
      'e815a21e_@_26': {
        id: 'e815a21e_@_26',
        info: 'P&L Comparison (Weekly)',
        name: 'EBITDA',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 21860.620000000006,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2922,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -38871.81999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.5709,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -12320.600000000013,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.1759,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 36319.469999999994,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4031,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 19210.779999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2892,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'e815a21e_@_26',
            name: 'EBITDA',
          },
        ],
        glCode: null,
      },
      '644555ee_@_27': {
        id: '644555ee_@_27',
        info: 'P&L Comparison (Weekly)',
        name: 'Interest, Taxes, Depreciation and Amortization',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'dce93088_@_27',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'dce93088_@_27',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'dce93088_@_27',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'dce93088_@_27',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
            childrenAccounts: [
              {
                id: 'dce93088_@_27',
                glCode: 8205,
                title: 'Loan Interest',
                money: 0,
                percent: 0,
              },
            ],
          },
        ],
        isParent: true,
        path: [
          {
            id: '644555ee_@_27',
            name: 'Interest, Taxes, Depreciation and Amortization',
          },
        ],
        glCode: null,
      },
      'dce93088_@_27': {
        id: 'dce93088_@_27',
        info: 'P&L Comparison (Weekly)',
        name: 'Loan Interest',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: false,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '644555ee_@_27',
            name: 'Interest, Taxes, Depreciation and Amortization',
          },
          {
            id: '13e3a076_@_24',
            name: 'Loan Interest',
          },
        ],
        glCode: 8205,
      },
      'b4184eff_@_28': {
        id: 'b4184eff_@_28',
        info: 'P&L Comparison (Weekly)',
        name: 'Total Interest, Taxes, Depreciation and Amortization',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: 'b4184eff_@_28',
            name: 'Total Interest, Taxes, Depreciation and Amortization',
          },
        ],
        glCode: null,
      },
      '9b50fa7c_@_29': {
        id: '9b50fa7c_@_29',
        info: 'P&L Comparison (Weekly)',
        name: 'NET PROFIT',
        timeFrame: 'Jul 21 - Jun 29, 2025',
        isLocation: false,
        total: true,
        consolidated: false,
        display: {
          money: true,
          percent: true,
        },
        budget: false,
        groups: ['Actual', 'Budget', 'Variance'],
        columns: [
          {
            name: 'Jul 21 - 27, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 21860.620000000006,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2922,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 14 - 20, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -38871.81999999999,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.5709,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jul 7 - 13, 2025',
            liveReport: false,
            data: {
              money: {
                actual: -12320.600000000013,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: -0.1759,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 30 - Jul 6, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 36319.469999999994,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.4031,
                budget: 0,
                variance: 0,
              },
            },
          },
          {
            name: 'Jun 23 - 29, 2025',
            liveReport: false,
            data: {
              money: {
                actual: 19210.779999999995,
                budget: 0,
                variance: 0,
              },
              percent: {
                actual: 0.2892,
                budget: 0,
                variance: 0,
              },
            },
          },
        ],
        isParent: false,
        path: [
          {
            id: '9b50fa7c_@_29',
            name: 'NET PROFIT',
          },
        ],
        glCode: null,
      },
    },
  },
  flaggedCells: [
    {
      id: 'eb89fd19-e2a6-4df6-8e97-6a0462be5e2f',
      index: 0,
      account: 'Sales, Beer',
      type: 'Flagged Cell',
      status: 'inProgress',
      period: '2025-07-14',
      createdAt: '2025-07-29 19:37:44',
      amount: 5015,
    },
    {
      id: '1e4fc649-e738-40ac-af2f-98fa638ac3fe',
      index: 4,
      account: '4120 Revenue / Sales:Sales, Wine',
      type: 'trx',
      status: 'inProgress',
      period: '2025-07-24',
      createdAt: '2025-07-29 16:58:53',
      amount: 248,
      transaction: {
        id: '88c5af13-7511-4e18-a7a0-e4757e221dce',
        memo: '',
        name: '',
        trxType: 'Journal Entry',
      },
    },
    {
      id: 'f53bb8ca-cc34-4ea6-bd43-eda4d5af03d8',
      index: 5,
      account: '4115 Revenue / Sales:Sales, Beer',
      type: 'trx',
      status: 'inProgress',
      period: '2025-07-15',
      createdAt: '2025-07-29 16:49:23',
      amount: 102,
      transaction: {
        id: 'b1888fa0-4e9b-4d9b-a1f2-2b02e6f3be52',
        memo: '',
        name: '',
        trxType: 'Journal Entry',
      },
    },
    {
      id: 'f5f466b6-1069-4f73-b141-8e3c89f3fe16',
      index: 6,
      account: '4110 Revenue / Sales:Sales, Liquor',
      type: 'trx',
      status: 'inProgress',
      period: '2025-07-23',
      createdAt: '2025-07-29 16:09:56',
      amount: 1629,
      transaction: {
        id: 'e252f492-4b2a-4e34-a610-4f77c5f721e1',
        memo: '',
        name: '',
        trxType: 'Journal Entry',
      },
    },
  ],
  transactionsAudit: {
    transactions: [
      {
        id: 0,
        amount: 4814.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 1,
        amount: 4276,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 2,
        amount: 4525,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 3,
        amount: 3727,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 4,
        amount: 3850,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 5,
        amount: 12032.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 6,
        amount: 6898,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 7,
        amount: 2311,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 8,
        amount: 3859,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 9,
        amount: 2662,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 10,
        amount: 2951,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 11,
        amount: 7307.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 12,
        amount: 11975.51,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 13,
        amount: 6607.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 14,
        amount: 3404.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 15,
        amount: 2043.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 16,
        amount: 2980,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 17,
        amount: 3034,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 18,
        amount: 5745,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 19,
        amount: 11703,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 20,
        amount: 10735,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 21,
        amount: 3223,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 22,
        amount: 5883.17,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15308',
        num: 'Strip sale P6.25',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 23,
        amount: 3494,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 24,
        amount: 2415.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 25,
        amount: 5198,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 26,
        amount: 9323.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 27,
        amount: 10915,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 28,
        amount: 9013,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 29,
        amount: 2749,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 30,
        amount: 5498,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 31,
        amount: 3139.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 32,
        amount: 1993.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 33,
        amount: 4984.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 34,
        amount: 10957,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 35,
        amount: 7669.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'c5601bf4_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 36,
        amount: 1294,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 37,
        amount: 1490,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 38,
        amount: 1629,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 39,
        amount: 1811,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 40,
        amount: 2589,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 41,
        amount: 8862.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 42,
        amount: 4364,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 43,
        amount: 362,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 44,
        amount: 1232,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 45,
        amount: 822,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 46,
        amount: 1973,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 47,
        amount: 3302,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 48,
        amount: 7901.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 49,
        amount: 3141,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 50,
        amount: 1151.01,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 51,
        amount: 449,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 52,
        amount: 1435,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 53,
        amount: 1164,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 54,
        amount: 2608,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 55,
        amount: 6630,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 56,
        amount: 5151,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 57,
        amount: 1367,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 58,
        amount: 1397.01,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 59,
        amount: 1793,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 60,
        amount: 6275,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 61,
        amount: 5281,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 62,
        amount: 5572.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 63,
        amount: 4534,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 64,
        amount: 1230,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 65,
        amount: 1562,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 66,
        amount: 1105,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 67,
        amount: 1473,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 68,
        amount: 2132,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 69,
        amount: 7591.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 70,
        amount: 3804.5,
        description: '',
        category: 'Journal Entry',
        accountId: 'e1ca5621_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 71,
        amount: 97,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 72,
        amount: 376,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 73,
        amount: 110,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 74,
        amount: 542,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 75,
        amount: 61,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 76,
        amount: 474,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 77,
        amount: 20,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 78,
        amount: 347,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 79,
        amount: 107,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 80,
        amount: 503,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 81,
        amount: 600,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 82,
        amount: 1413,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 83,
        amount: 151,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 84,
        amount: 424,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 85,
        amount: 56,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 86,
        amount: 173,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 87,
        amount: 102,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 88,
        amount: 583,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 89,
        amount: 85,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 90,
        amount: 178,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 91,
        amount: 77,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 92,
        amount: 467,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 93,
        amount: 96,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 94,
        amount: 623,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 95,
        amount: 417,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 96,
        amount: 1256,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 97,
        amount: 261,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 98,
        amount: 641,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 99,
        amount: 47,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 100,
        amount: 517,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 101,
        amount: 93,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 102,
        amount: 151,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 103,
        amount: 69,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 104,
        amount: 441,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 105,
        amount: 59,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 106,
        amount: 187,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 107,
        amount: 83,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 108,
        amount: 681,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 109,
        amount: 378,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 110,
        amount: 979,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 111,
        amount: 295,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 112,
        amount: 730,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 113,
        amount: 106,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 114,
        amount: 252,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 115,
        amount: 135,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 116,
        amount: 413,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 117,
        amount: 69,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 118,
        amount: 539,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 119,
        amount: 452,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 120,
        amount: 794,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 121,
        amount: 338,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 122,
        amount: 1243,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 123,
        amount: 272,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 124,
        amount: 1042,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 125,
        amount: 166,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 126,
        amount: 707,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 127,
        amount: 36,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 128,
        amount: 190,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 129,
        amount: 170,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 130,
        amount: 424,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 131,
        amount: 289,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 132,
        amount: 713,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 133,
        amount: 46,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 134,
        amount: 374,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 135,
        amount: 172,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 136,
        amount: 760,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 137,
        amount: 584,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 138,
        amount: 1482,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Outlier',
          amount: 1482,
          reason: 'Amount ($1,482.00) is outside the range of -629.94 to 1,419.19\n      ($394.63 +/- 3 * 341.52)',
          priority: 'low',
          confidence: 41.15435999844536,
        },
      },
      {
        id: 139,
        amount: 173,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 140,
        amount: 733,
        description: '',
        category: 'Journal Entry',
        accountId: 'ba0b0910_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 141,
        amount: 156,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 142,
        amount: 205,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 143,
        amount: 342,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 144,
        amount: 248,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 145,
        amount: 267,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 146,
        amount: 489,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 147,
        amount: 154,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 148,
        amount: 52,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 149,
        amount: 373,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 150,
        amount: 144,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 151,
        amount: 195,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 152,
        amount: 419,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 153,
        amount: 324,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 154,
        amount: 129,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 155,
        amount: 99,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 156,
        amount: 42,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 157,
        amount: 171,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 158,
        amount: 98,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 159,
        amount: 276,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 160,
        amount: 484,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 161,
        amount: 82,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 162,
        amount: 38,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 163,
        amount: 183,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 164,
        amount: 243,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 165,
        amount: 227,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 166,
        amount: 236,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 167,
        amount: 437,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 168,
        amount: 264,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 169,
        amount: 211,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 170,
        amount: 197,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 171,
        amount: 135,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 172,
        amount: 56,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 173,
        amount: 227,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 174,
        amount: 587,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 175,
        amount: 100,
        description: '',
        category: 'Journal Entry',
        accountId: '2f14959f_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 176,
        amount: 333,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 177,
        amount: 316,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 178,
        amount: 243,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 179,
        amount: 266,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 180,
        amount: 205,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 181,
        amount: 701,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 182,
        amount: 535,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 183,
        amount: 170,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 184,
        amount: 307,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 185,
        amount: 141,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 186,
        amount: 239,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 187,
        amount: 451,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 188,
        amount: 583,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 189,
        amount: 479,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 190,
        amount: 258,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 191,
        amount: 110,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 192,
        amount: 198,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 193,
        amount: 116,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 194,
        amount: 297,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 195,
        amount: 757,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 196,
        amount: 592,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 197,
        amount: 239,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 198,
        amount: 188,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 199,
        amount: 144,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 200,
        amount: 480,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 201,
        amount: 641,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 202,
        amount: 616,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 203,
        amount: 594,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 204,
        amount: 260,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 205,
        amount: 554,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 206,
        amount: 349,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 207,
        amount: 104,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 208,
        amount: 302,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 209,
        amount: 743,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 210,
        amount: 572,
        description: '',
        category: 'Journal Entry',
        accountId: '7bb557b1_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 211,
        amount: 2542.8,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 212,
        amount: 86,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 213,
        amount: 80,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 214,
        amount: 52,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 215,
        amount: 29.48,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 216,
        amount: 1140.57,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 217,
        amount: 1217.6,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 218,
        amount: 214,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 219,
        amount: 388,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 220,
        amount: 387,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 221,
        amount: 79.04,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 222,
        amount: 2291,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 223,
        amount: 1084,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 224,
        amount: 1460.88,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 225,
        amount: 1247,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 226,
        amount: 20,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 227,
        amount: 258,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 228,
        amount: 30,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 229,
        amount: 65,
        description: '',
        category: 'Journal Entry',
        accountId: 'cbede411_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 230,
        amount: 106.75,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 231,
        amount: 177.13,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 232,
        amount: 227.71,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 233,
        amount: 127.6,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 234,
        amount: 117.39,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 235,
        amount: 470.49,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 236,
        amount: 189.25,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 237,
        amount: 64.36,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 238,
        amount: 139.39,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 239,
        amount: 85.01,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 240,
        amount: 109.8,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 241,
        amount: 281.63,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 242,
        amount: 382.51,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 243,
        amount: 198.14,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 244,
        amount: 120.99,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 245,
        amount: 51.45,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 246,
        amount: 86.37,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 247,
        amount: 64.5,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 248,
        amount: 196.33,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 249,
        amount: 441.93,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 250,
        amount: 391.65,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 251,
        amount: 82.19,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 252,
        amount: 91.61,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 253,
        amount: 175.96,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 254,
        amount: 178.33,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 255,
        amount: 283.66,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 256,
        amount: 327.27,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 257,
        amount: 207.03,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 258,
        amount: 70.38,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 259,
        amount: 158.55,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 260,
        amount: 128.45,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 261,
        amount: 82.3,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 262,
        amount: 152.85,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 263,
        amount: 417.11,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 264,
        amount: 189.51,
        description: '',
        category: 'Journal Entry',
        accountId: '4e12e939_@_2',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 265,
        amount: -177.25,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15356',
        num: 'MJ1878ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 266,
        amount: -84.5,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15357',
        num: 'MJ1879ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 267,
        amount: -59.5,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15530',
        num: 'MJ1883ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 268,
        amount: -117.75,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15531',
        num: 'MJ1887ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 269,
        amount: -144,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15561',
        num: 'MJ1888ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 270,
        amount: -320.5,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15572',
        num: 'MJ1890ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 271,
        amount: -314,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15573',
        num: 'MJ1934ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 272,
        amount: -56,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15217',
        num: 'MJ1863ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 273,
        amount: -169.8,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15309',
        num: 'MJ1864ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 274,
        amount: -54,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15310',
        num: 'MJ1867ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 275,
        amount: -64.5,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15311',
        num: 'MJ1869ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 276,
        amount: -142.75,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15312',
        num: 'MJ1871ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 277,
        amount: -453.25,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-19',
        date: '2025-07-19T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15353',
        num: 'MJ1873ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 278,
        amount: -42,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15354',
        num: 'MJ1876ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 279,
        amount: -97.5,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14888',
        num: 'MJ1832ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 280,
        amount: -146,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14905',
        num: 'MJ1834ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 281,
        amount: -72,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15025',
        num: 'MJ1835ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 282,
        amount: -93,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15026',
        num: 'MJ1851ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 283,
        amount: -117.5,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15028',
        num: 'MJ1853ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 284,
        amount: -275.75,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15209',
        num: 'MJ1855ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 285,
        amount: -406.75,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15208',
        num: 'MJ1858ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 286,
        amount: -24,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14704',
        num: 'MJ1780ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 287,
        amount: -569.25,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14710',
        num: 'MJ1788ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 288,
        amount: -81,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14711',
        num: 'MJ1795ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 289,
        amount: -461,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14712',
        num: 'MJ1797ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 290,
        amount: -193,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14713',
        num: 'MJ1799ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 291,
        amount: -213.25,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14715',
        num: 'MJ1801ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 292,
        amount: -512.38,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14716',
        num: 'MJ1803ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 293,
        amount: -177,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14564',
        num: 'MJ1758ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 294,
        amount: -241.75,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14681',
        num: 'MJ1759ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 295,
        amount: -145,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14682',
        num: 'MJ1766ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 296,
        amount: -96.25,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14683',
        num: 'MJ1769ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 297,
        amount: -183,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14684',
        num: 'MJ1771ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 298,
        amount: -381,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-28',
        date: '2025-06-28T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14686',
        num: 'MJ1774ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 299,
        amount: -70,
        description: '',
        category: 'Journal Entry',
        accountId: '4936addc_@_6',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14687',
        num: 'MJ1777ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 300,
        amount: 374.85,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15521',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 301,
        amount: 1089.11,
        description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Ferro & Sons, Inc.',
        vendorId: 2,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15622',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 302,
        amount: 117.28,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15594',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 303,
        amount: 464.78,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15595',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 304,
        amount: 210.91,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15227',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 305,
        amount: 200.5,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15229',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 306,
        amount: 184.53,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15235',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 307,
        amount: 89.76,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15236',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 308,
        amount: 406.65,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15324',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 309,
        amount: 319.92,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14756',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 310,
        amount: 2301.75,
        description: 'WIRE TRANSFER OUTGOING - F Ferro and Sons',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Ferro & Sons, Inc.',
        vendorId: 2,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15383',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 311,
        amount: 244.6,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14754',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 312,
        amount: 347.48,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14755',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 313,
        amount: 271.63,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14556',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 314,
        amount: 135.12,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14557',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 315,
        amount: 331.44,
        description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '7a94d93b_@_9',
        name: 'Restaurant Depot',
        vendorId: 1,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14753',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 316,
        amount: 15.99,
        description: 'Refund',
        category: 'Journal Entry',
        accountId: '7a94d93b_@_9',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14879',
        num: 'Uber eats ADJ P6.25',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 317,
        amount: 48.99,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15568',
        num: 'IV101-0027056103',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 318,
        amount: 195.86,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15548',
        num: 'IV101-0027063549',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 319,
        amount: 1591.81,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 320,
        amount: 1555.39,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 321,
        amount: 391.52,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: '3f46fcce_@_9',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15547',
        num: 'MI1900ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 322,
        amount: 797.83,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15207',
        num: '9255396',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 323,
        amount: 97.98,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15540',
        num: 'IV101-0027025179',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 324,
        amount: 1822.14,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15537',
        num: '9257563',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 325,
        amount: 1279.94,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15566',
        num: '9259520',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 326,
        amount: 1139.64,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 327,
        amount: 195.76,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14896',
        num: 'IV101-0026997147',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 328,
        amount: 1703.27,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 329,
        amount: 88.76,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14897',
        num: '9253030',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 330,
        amount: 1435.21,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14714',
        num: '9247031',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 331,
        amount: 441.11,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: '3f46fcce_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14824',
        num: 'MI1811ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 332,
        amount: 1585.2,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14724',
        num: '9249000',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 333,
        amount: 1083.72,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14561',
        num: '9239104',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 334,
        amount: 1700.37,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 335,
        amount: 742.18,
        description: '',
        category: 'Bill',
        accountId: '3f46fcce_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14703',
        num: '9243481',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 336,
        amount: 19.99,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15568',
        num: 'IV101-0027056103',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 337,
        amount: 181.2,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 338,
        amount: 113.12,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 339,
        amount: 22.39,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15567',
        num: 'IV101-0027082856',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 340,
        amount: 113.07,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15207',
        num: '9255396',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 341,
        amount: 23.49,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15536',
        num: 'IV101-0027029234',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 342,
        amount: 113.18,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15537',
        num: '9257563',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 343,
        amount: 237.99,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15566',
        num: '9259520',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 344,
        amount: 106.47,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 345,
        amount: 44.78,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14896',
        num: 'IV101-0026997147',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 346,
        amount: 173.83,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 347,
        amount: 23.49,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15027',
        num: 'IV101-0026997137',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 348,
        amount: 173.84,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14714',
        num: '9247031',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 349,
        amount: 173.89,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14724',
        num: '9249000',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 350,
        amount: 174.66,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 351,
        amount: 351.7,
        description: '',
        category: 'Bill',
        accountId: '2bdeb0ad_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14703',
        num: '9243481',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 352,
        amount: 674.46,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15525',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 353,
        amount: 35.75,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15526',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 354,
        amount: 576.26,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15527',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 355,
        amount: 433.25,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15568',
        num: 'IV101-0027056103',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 356,
        amount: 180.25,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15548',
        num: 'IV101-0027063549',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 357,
        amount: 150.68,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15544',
        num: '712755',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 358,
        amount: 986.9,
        description: 'BALDOR SPECIALTY BALDOR SPE',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15615',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 359,
        amount: 187.5,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15567',
        num: 'IV101-0027082856',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 360,
        amount: 451.8,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15543',
        num: '713076',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 361,
        amount: 198.75,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: '593c4b13_@_9',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15547',
        num: 'MI1900ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 362,
        amount: 487.94,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15440',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 363,
        amount: 26.75,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15442',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 364,
        amount: 438.75,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15444',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 365,
        amount: 81.58,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15446',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 366,
        amount: 16.5,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15447',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 367,
        amount: 16.5,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15538',
        num: 'IV101-0027025164',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 368,
        amount: 200.25,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15540',
        num: 'IV101-0027025179',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 369,
        amount: 286.21,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15448',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 370,
        amount: 936.51,
        description: 'BALDOR SPECIALTY BALDOR SPE',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15449',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 371,
        amount: 732.25,
        description: 'CHECK 6502274',
        category: 'Check',
        accountId: '593c4b13_@_9',
        name: 'Avanti Produce',
        vendorId: 6,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15467',
        num: '6502274',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 372,
        amount: 138.5,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15536',
        num: 'IV101-0027029234',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 373,
        amount: 588.95,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14721',
        num: '711317',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 374,
        amount: 979.61,
        description: 'BALDOR SPECIALTY BALDOR SPE',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14836',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 375,
        amount: 461.8,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15542',
        num: '711503',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 376,
        amount: 237.5,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14896',
        num: 'IV101-0026997147',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 377,
        amount: 169.75,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15027',
        num: 'IV101-0026997137',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 378,
        amount: 1061.45,
        description: 'CHECK 6502217 INV 0710262',
        category: 'Check',
        accountId: '593c4b13_@_9',
        name: 'Avanti Produce',
        vendorId: 6,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15426',
        num: '6502217',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 379,
        amount: 26.75,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15535',
        num: 'IV101-0027013901',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 380,
        amount: 488.5,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15570',
        num: 'IV101-0027013935',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 381,
        amount: 914.6,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14821',
        num: '710926',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 382,
        amount: 1115.12,
        description: 'BALDOR SPECIALTY BALDOR SPE',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14835',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 383,
        amount: 68.25,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: '593c4b13_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14824',
        num: 'MI1811ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 384,
        amount: 694.09,
        description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
        category: 'Expense',
        accountId: '593c4b13_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14837',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 385,
        amount: 488.45,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14722',
        num: '711119',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 386,
        amount: 676.65,
        description: 'CHECK 6502145 INV#0710602',
        category: 'Check',
        accountId: '593c4b13_@_9',
        name: 'Avanti Produce',
        vendorId: 6,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15335',
        num: '6502145',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 387,
        amount: 599.75,
        description: '',
        category: 'Bill',
        accountId: '593c4b13_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14723',
        num: '711235',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 388,
        amount: 530.45,
        description: 'CHECK 6502071',
        category: 'Check',
        accountId: '593c4b13_@_9',
        name: 'Avanti Produce',
        vendorId: 6,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14852',
        num: '6502071',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 389,
        amount: 26.37,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15568',
        num: 'IV101-0027056103',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 390,
        amount: 99,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15565',
        num: '862670',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 391,
        amount: 1225.26,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 392,
        amount: 1141.98,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 393,
        amount: 32.31,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15567',
        num: 'IV101-0027082856',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 394,
        amount: 98.85,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15543',
        num: '713076',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 395,
        amount: 31.92,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: 'e0037727_@_9',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15545',
        num: 'MI1904ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 396,
        amount: 41.76,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: 'e0037727_@_9',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15546',
        num: 'MI1903ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 397,
        amount: 575.78,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15207',
        num: '9255396',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 398,
        amount: 6401.55,
        description: 'CHECK 6502279',
        category: 'Check',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15456',
        num: '6502279',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 399,
        amount: 33.7,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15536',
        num: 'IV101-0027029234',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 400,
        amount: 581.93,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15537',
        num: '9257563',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 401,
        amount: 594.29,
        description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
        category: 'Expense',
        accountId: 'e0037727_@_9',
        name: 'The Webstaurant Store',
        vendorId: 8,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15319',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 402,
        amount: 41.27,
        description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
        category: 'Expense',
        accountId: 'e0037727_@_9',
        name: 'ShopRite',
        vendorId: 9,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15514',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 403,
        amount: 3560.65,
        description: 'CHECK 6502334',
        category: 'Check',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15516',
        num: '6502334',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 404,
        amount: 666.06,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15566',
        num: '9259520',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 405,
        amount: 506.56,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 406,
        amount: 65.9,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14721',
        num: '711317',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 407,
        amount: 53.12,
        description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
        category: 'Expense',
        accountId: 'e0037727_@_9',
        name: 'ShopRite',
        vendorId: 9,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15258',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 408,
        amount: 3633.57,
        description: 'CHECK 6502206',
        category: 'Check',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15347',
        num: '6502206',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 409,
        amount: 5884.26,
        description: 'CHECK 6502219',
        category: 'Check',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15388',
        num: '6502219',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 410,
        amount: 210.65,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15542',
        num: '711503',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 411,
        amount: 26.37,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14896',
        num: 'IV101-0026997147',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 412,
        amount: 1381.53,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 413,
        amount: 28.05,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15027',
        num: 'IV101-0026997137',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 414,
        amount: 103.21,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14897',
        num: '9253030',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 415,
        amount: 57.41,
        description: 'VISA DDA PUR AP - 401134     IC  INSTACART               INSTACART COM * CA',
        category: 'Expense',
        accountId: 'e0037727_@_9',
        name: 'Instacart',
        vendorId: 10,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15241',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 416,
        amount: 973.13,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14714',
        num: '9247031',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 417,
        amount: 109.71,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: 'e0037727_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14824',
        num: 'MI1811ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 418,
        amount: 49.8,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14722',
        num: '711119',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 419,
        amount: 1077.64,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14724',
        num: '9249000',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 420,
        amount: 98.85,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14723',
        num: '711235',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 421,
        amount: 639.73,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14561',
        num: '9239104',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 422,
        amount: 875.95,
        description: 'VISA DDA PUR AP - 411343     THE WEBSTAURANT STORE IN    717 392 7472  * PA',
        category: 'Expense',
        accountId: 'e0037727_@_9',
        name: 'The Webstaurant Store',
        vendorId: 8,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14604',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 423,
        amount: 481.65,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 424,
        amount: 5204.19,
        description: 'CHECK 6502089',
        category: 'Check',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14860',
        num: '6502089',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 425,
        amount: 659.19,
        description: '',
        category: 'Bill',
        accountId: 'e0037727_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14703',
        num: '9243481',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 426,
        amount: 38.46,
        description: 'VISA DDA PUR AP - 469216     SHOPRITE HOBOKEN S1         HOBOKEN       * NJ',
        category: 'Expense',
        accountId: 'e0037727_@_9',
        name: 'ShopRite',
        vendorId: 9,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14887',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 427,
        amount: 44.8,
        description: '',
        category: 'Bill',
        accountId: '47294ea3_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15548',
        num: 'IV101-0027063549',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 428,
        amount: 670.41,
        description: 'RM BAKERY LLC    SALE',
        category: 'Expense',
        accountId: '47294ea3_@_9',
        name: 'RM Bakery LLC',
        vendorId: 11,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15262',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 429,
        amount: 44.8,
        description: '',
        category: 'Bill',
        accountId: '47294ea3_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15540',
        num: 'IV101-0027025179',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 430,
        amount: 37,
        description: '',
        category: 'Bill',
        accountId: '47294ea3_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 431,
        amount: 732.45,
        description: 'RM BAKERY LLC    SALE',
        category: 'Expense',
        accountId: '47294ea3_@_9',
        name: 'RM Bakery LLC',
        vendorId: 11,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14843',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 432,
        amount: 613.98,
        description: 'RM BAKERY LLC    SALE',
        category: 'Expense',
        accountId: '47294ea3_@_9',
        name: 'RM Bakery LLC',
        vendorId: 11,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14842',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 433,
        amount: 44.8,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: '47294ea3_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14824',
        num: 'MI1811ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 434,
        amount: 260.58,
        description: 'RM BAKERY LLC    SALE',
        category: 'Expense',
        accountId: '47294ea3_@_9',
        name: 'RM Bakery LLC',
        vendorId: 11,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14598',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 435,
        amount: 1369.9,
        description: 'VISA DDA PUR AP - 445351     DAVID ROSEN                 718 381 0600  * NY',
        category: 'Expense',
        accountId: '47294ea3_@_9',
        name: 'David Rosen Bakery Supply Co',
        vendorId: 12,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14830',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 436,
        amount: 68.24,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15568',
        num: 'IV101-0027056103',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 437,
        amount: 68.74,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15548',
        num: 'IV101-0027063549',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 438,
        amount: 335.06,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 439,
        amount: 115,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15544',
        num: '712755',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 440,
        amount: 293.08,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 441,
        amount: 59.09,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15567',
        num: 'IV101-0027082856',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 442,
        amount: 109.9,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: '841fc412_@_9',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15547',
        num: 'MI1900ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 443,
        amount: 245.74,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15207',
        num: '9255396',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 444,
        amount: 81.58,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15539',
        num: 'IV101-0027025183',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 445,
        amount: 30.22,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15540',
        num: 'IV101-0027025179',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 446,
        amount: 475.14,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15537',
        num: '9257563',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 447,
        amount: 395.97,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15566',
        num: '9259520',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 448,
        amount: 311.38,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 449,
        amount: 71.8,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15542',
        num: '711503',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 450,
        amount: 64.51,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14896',
        num: 'IV101-0026997147',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 451,
        amount: 493.79,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 452,
        amount: 21.94,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-12',
        date: '2025-07-12T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15570',
        num: 'IV101-0027013935',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 453,
        amount: 518.45,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14714',
        num: '9247031',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 454,
        amount: 30.22,
        description: 'Vendor: Baldor Specialty Foods Inc.',
        category: 'Journal Entry',
        accountId: '841fc412_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14824',
        num: 'MI1811ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 455,
        amount: 354.61,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14724',
        num: '9249000',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 456,
        amount: 188.6,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 3,
        txnDate: '2025-07-05',
        date: '2025-07-05T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14723',
        num: '711235',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 457,
        amount: 185.11,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14561',
        num: '9239104',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 458,
        amount: 197.79,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 459,
        amount: 544.64,
        description: '',
        category: 'Bill',
        accountId: '841fc412_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14703',
        num: '9243481',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 460,
        amount: 1216.77,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15565',
        num: '862670',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 461,
        amount: 68.38,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15569',
        num: '866618',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 462,
        amount: 1483.07,
        description: 'CHECK 6502348',
        category: 'Check',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15653',
        num: '6502348',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 463,
        amount: 1992.45,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15571',
        num: '870345',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 464,
        amount: 934.48,
        description: 'FEDWAY ASSOCIATE FEDWAY ASS',
        category: 'Expense',
        accountId: '6eb26171_@_9',
        name: 'Fedway',
        vendorId: 13,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15620',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 465,
        amount: -215,
        description: '653030 Dt.06.19.2025',
        category: 'Deposit',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15469',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 466,
        amount: 1000,
        description: 'POD CHECK',
        category: 'Check',
        accountId: '6eb26171_@_9',
        name: 'Fedway',
        vendorId: 13,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15512',
        num: '6502221',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 467,
        amount: 812.33,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Federal Wine & Spirits Co.',
        vendorId: 14,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15549',
        num: '59469',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 468,
        amount: 1325.12,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14900',
        num: '837929',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 469,
        amount: 112,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14901',
        num: '3733648',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 470,
        amount: 1370.2,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Federal Wine & Spirits Co.',
        vendorId: 14,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14902',
        num: '42235',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 471,
        amount: 1000,
        description: 'CHECK 6502220',
        category: 'Check',
        accountId: '6eb26171_@_9',
        name: 'Fedway',
        vendorId: 13,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15406',
        num: '6502220',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 472,
        amount: 178.64,
        description: 'Vendor: Allied Beverage Group LLC',
        category: 'Journal Entry',
        accountId: '6eb26171_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14820',
        num: 'MI1826ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 473,
        amount: -237,
        description: '',
        category: 'Deposit',
        accountId: '6eb26171_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15279',
        num: '650411',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 474,
        amount: -69,
        description: '',
        category: 'Deposit',
        accountId: '6eb26171_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15279',
        num: '773964',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 475,
        amount: -48,
        description: '',
        category: 'Deposit',
        accountId: '6eb26171_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15279',
        num: '752749',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 476,
        amount: -36,
        description: '',
        category: 'Deposit',
        accountId: '6eb26171_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15279',
        num: '644657',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 477,
        amount: -12,
        description: '',
        category: 'Deposit',
        accountId: '6eb26171_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15279',
        num: '641925',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 478,
        amount: 178.64,
        description: 'CHECK 6502148',
        category: 'Check',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15287',
        num: '6502148',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 479,
        amount: 1184.38,
        description: 'Vendor: Federal Wine & Spirits Co.',
        category: 'Journal Entry',
        accountId: '6eb26171_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14822',
        num: 'MI1819ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 480,
        amount: 2309.95,
        description: '',
        category: 'Bill',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14823',
        num: '824312',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 481,
        amount: 1000,
        description: 'POD CHECK #110620',
        category: 'Check',
        accountId: '6eb26171_@_9',
        name: 'Fedway',
        vendorId: 13,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15333',
        num: '6502200',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 482,
        amount: 1000,
        description: 'CHECK 6502093',
        category: 'Check',
        accountId: '6eb26171_@_9',
        name: 'Fedway',
        vendorId: 13,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14859',
        num: '6502093',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 483,
        amount: 1208.19,
        description: 'CHECK 6502094',
        category: 'Check',
        accountId: '6eb26171_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14880',
        num: '6502094',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 484,
        amount: 59,
        description: '',
        category: 'Bill',
        accountId: '15101cdc_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15565',
        num: '862670',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 485,
        amount: 61.53,
        description: '',
        category: 'Bill',
        accountId: '15101cdc_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15563',
        num: '9262982',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 486,
        amount: 61.53,
        description: '',
        category: 'Bill',
        accountId: '15101cdc_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15562',
        num: '9265170',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 487,
        amount: 90.52,
        description: '',
        category: 'Bill',
        accountId: '15101cdc_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15536',
        num: 'IV101-0027029234',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 488,
        amount: 70.16,
        description: '',
        category: 'Bill',
        accountId: '15101cdc_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 489,
        amount: 61.53,
        description: '',
        category: 'Bill',
        accountId: '15101cdc_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14719',
        num: '9247032',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 490,
        amount: 435.87,
        description: 'CHECK 6502207 Beer',
        category: 'Check',
        accountId: '90be8534_@_9',
        name: 'Eileen Kim',
        vendorId: 16,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15390',
        num: '6502207',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 491,
        amount: 413,
        description: '',
        category: 'Bill',
        accountId: '3395a498_@_9',
        name: 'Northern Eagle Beverage',
        vendorId: 17,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15553',
        num: '627286',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 492,
        amount: 95,
        description: '',
        category: 'Bill',
        accountId: '3395a498_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15558',
        num: '3733797',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 493,
        amount: 870.5,
        description: 'NORTHERN EAGLE B INVOICES',
        category: 'Expense',
        accountId: '3395a498_@_9',
        name: 'Northern Eagle Beverage',
        vendorId: 17,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15493',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 494,
        amount: 640,
        description: '',
        category: 'Bill',
        accountId: '3395a498_@_9',
        name: 'Northern Eagle Beverage',
        vendorId: 17,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15554',
        num: '625995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 495,
        amount: 447,
        description: '',
        category: 'Bill',
        accountId: '3395a498_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15555',
        num: '3733721',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 496,
        amount: 485,
        description: '',
        category: 'Bill',
        accountId: '3395a498_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15556',
        num: '3733723',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 497,
        amount: 640,
        description: 'NORTHERN EAGLE B INVOICES',
        category: 'Expense',
        accountId: '3395a498_@_9',
        name: 'Northern Eagle Beverage',
        vendorId: 17,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15498',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 498,
        amount: 549,
        description: 'CHECK 6502332',
        category: 'Check',
        accountId: '3395a498_@_9',
        name: 'Hoboken Brewing',
        vendorId: 18,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15508',
        num: '6502332',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 499,
        amount: 295.5,
        description: '',
        category: 'Bill',
        accountId: '3395a498_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14901',
        num: '3733648',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 500,
        amount: 52.6,
        description: '',
        category: 'Bill',
        accountId: 'e2c4f57e_@_9',
        name: 'Northern Eagle Beverage',
        vendorId: 17,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15553',
        num: '627286',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 501,
        amount: 349,
        description: '',
        category: 'Bill',
        accountId: 'e2c4f57e_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15558',
        num: '3733797',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 502,
        amount: 37,
        description: '',
        category: 'Bill',
        accountId: 'e2c4f57e_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15559',
        num: '3733798',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 503,
        amount: 298,
        description: '',
        category: 'Bill',
        accountId: 'e2c4f57e_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15555',
        num: '3733721',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 504,
        amount: 224,
        description: '',
        category: 'Bill',
        accountId: 'e2c4f57e_@_9',
        name: 'Federal Wine & Spirits Co.',
        vendorId: 14,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15549',
        num: '59469',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 505,
        amount: 37,
        description: '',
        category: 'Bill',
        accountId: 'e2c4f57e_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14899',
        num: '3733647',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 506,
        amount: 379,
        description: '',
        category: 'Bill',
        accountId: 'e2c4f57e_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14901',
        num: '3733648',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 507,
        amount: 232,
        description: 'Vendor: Federal Wine & Spirits Co.',
        category: 'Journal Entry',
        accountId: 'e2c4f57e_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14822',
        num: 'MI1819ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 508,
        amount: 145.08,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15569',
        num: '866618',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 509,
        amount: 325.8,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15571',
        num: '870345',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 510,
        amount: 810,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Gallo Wine Sales',
        vendorId: 19,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15550',
        num: '723293',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 511,
        amount: 507.3,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Federal Wine & Spirits Co.',
        vendorId: 14,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15549',
        num: '59469',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 512,
        amount: 525.2,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Gallo Wine Sales',
        vendorId: 19,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15551',
        num: '714240',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 513,
        amount: 218.16,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14900',
        num: '837929',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 514,
        amount: 181.24,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Federal Wine & Spirits Co.',
        vendorId: 14,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14902',
        num: '42235',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 515,
        amount: 810,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Gallo Wine Sales',
        vendorId: 19,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15206',
        num: '710320',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 516,
        amount: 720.12,
        description: 'CHECK 6502116 703442',
        category: 'Check',
        accountId: 'b29ce542_@_9',
        name: 'Gallo Wine Sales',
        vendorId: 19,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15277',
        num: '6502116',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 517,
        amount: 462,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Gallo Wine Sales',
        vendorId: 19,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14717',
        num: '707058',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 518,
        amount: 631.06,
        description: 'Vendor: Federal Wine & Spirits Co.',
        category: 'Journal Entry',
        accountId: 'b29ce542_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14822',
        num: 'MI1819ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 519,
        amount: 325.8,
        description: '',
        category: 'Bill',
        accountId: 'b29ce542_@_9',
        name: 'Allied Beverages',
        vendorId: 7,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14823',
        num: '824312',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 520,
        amount: 77.62,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15568',
        num: 'IV101-0027056103',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 521,
        amount: 1311.5,
        description: 'CHECK 6502336',
        category: 'Check',
        accountId: '9f08e50d_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15637',
        num: '6502336',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 522,
        amount: 19.26,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 523,
        amount: 75.37,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 524,
        amount: 48.5,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15567',
        num: 'IV101-0027082856',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 525,
        amount: 986,
        description: 'CHECK 6502262',
        category: 'Check',
        accountId: '9f08e50d_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15437',
        num: '6502262',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 526,
        amount: 65.5,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15540',
        num: 'IV101-0027025179',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 527,
        amount: 81.5,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15557',
        num: '3733722',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 528,
        amount: 597.15,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Pepsi',
        vendorId: 20,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15560',
        num: '13859010',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 529,
        amount: 121.22,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 530,
        amount: 65.5,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Baldor Specialty Foods Inc.',
        vendorId: 3,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14896',
        num: 'IV101-0026997147',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 531,
        amount: 40.75,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14898',
        num: '3685855',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 532,
        amount: 122.25,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14899',
        num: '3733647',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 533,
        amount: 153.95,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 534,
        amount: 157.9,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'W.b. Law Coffee',
        vendorId: 21,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14904',
        num: '116699',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 535,
        amount: 1115,
        description: 'PEERLESS BEVERAG PEERLESS B',
        category: 'Expense',
        accountId: '9f08e50d_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14846',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 536,
        amount: 49.75,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14714',
        num: '9247031',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 537,
        amount: 812.37,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Pepsi',
        vendorId: 20,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14718',
        num: '27165007',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 538,
        amount: 63.27,
        description: 'Vendor: Federal Wine & Spirits Co.',
        category: 'Journal Entry',
        accountId: '9f08e50d_@_9',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14822',
        num: 'MI1819ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 539,
        amount: 49.91,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14561',
        num: '9239104',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 540,
        amount: 3.75,
        description: '',
        category: 'Check',
        accountId: '9f08e50d_@_9',
        name: 'Peerless Beverage',
        vendorId: 15,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15211',
        num: '6502076',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 541,
        amount: 25.05,
        description: '',
        category: 'Bill',
        accountId: '9f08e50d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 542,
        amount: 129.66,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 543,
        amount: 59.79,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 544,
        amount: 102.98,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15207',
        num: '9255396',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 545,
        amount: 307.14,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15537',
        num: '9257563',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 546,
        amount: 103.38,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 547,
        amount: 44.57,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 548,
        amount: 188.73,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14714',
        num: '9247031',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 549,
        amount: 94.73,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14561',
        num: '9239104',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 550,
        amount: 128.73,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 551,
        amount: 138.65,
        description: '',
        category: 'Bill',
        accountId: '027a424d_@_9',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14703',
        num: '9243481',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 552,
        amount: 387.04,
        description: 'CHECK 6502338',
        category: 'Check',
        accountId: 'dfae81d5_@_9',
        name: 'Campos Delivery LLC',
        vendorId: 22,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15649',
        num: '6502338',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 553,
        amount: 769.89,
        description: 'POD CHECK  Payroll W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Samantha Lada',
        vendorId: 23,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15639',
        num: '6502305',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 554,
        amount: 684.47,
        description: 'CHECK 6502320 Payroll W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ramirez, Jesus Sarmiento',
        vendorId: 24,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15640',
        num: '6502320',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 555,
        amount: 678.27,
        description: 'CHECK 6502308 Payroll W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Olivia Mandez',
        vendorId: 25,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15641',
        num: '6502308',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 556,
        amount: 606.87,
        description: 'CHECK 6502266 Payroll W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ramirez, Jesus Sarmiento',
        vendorId: 24,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15642',
        num: '6502266',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 557,
        amount: 606.26,
        description: 'CHECK 6502323 Payroll W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Anthony Sanchez',
        vendorId: 26,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15643',
        num: '6502323',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 558,
        amount: 329.53,
        description: 'CHECK 6502285 Payroll W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Cantillano Cardenas, Lila',
        vendorId: 27,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15644',
        num: '6502285',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 559,
        amount: 193,
        description: 'CHECK 6502304 Payroll W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Christopher Intriago',
        vendorId: 28,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15645',
        num: '6502304',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 560,
        amount: 362.39,
        description: 'CHECK 6502321 Payroll W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Manuel Ramirez',
        vendorId: 29,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15650',
        num: '6502321',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 561,
        amount: 1511,
        description: 'POD CHECK Payroll W.E. 07.13.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Domingo Roman',
        vendorId: 30,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15652',
        num: '6502358',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 562,
        amount: 588.1,
        description: 'CHECK 6502349 Payroll W.E. 07.13.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Omar Lopez',
        vendorId: 31,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15654',
        num: '6502349',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 563,
        amount: 569.02,
        description: 'CHECK 6502355 Payroll W.E. 07.13.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Hernandez-Canel, Esteban',
        vendorId: 32,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15655',
        num: '6502355',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 564,
        amount: 494.15,
        description: 'CHECK 6502354 Payroll W.E. 07.13.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Cruz Hernandez, Pedro',
        vendorId: 33,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15656',
        num: '6502354',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 565,
        amount: 6500,
        description: 'Other',
        category: 'Journal Entry',
        accountId: '687f4cd2_@_14',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15635',
        num: 'Payroll Accrual 07.27',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 566,
        amount: 85.04,
        description: 'CHECK 6502230 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Cantillano Cardenas, Lila',
        vendorId: 27,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15430',
        num: '6502230',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 567,
        amount: 141.3,
        description: 'CHECK 6502244 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Christopher Intriago',
        vendorId: 28,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15431',
        num: '6502244',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 568,
        amount: 276.43,
        description: 'CHECK 6502226 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Reynaldo Cortes Sanchoz',
        vendorId: 34,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15432',
        num: '6502226',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 569,
        amount: 370,
        description: 'CHECK 6502278',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ivonne Olarte',
        vendorId: 35,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15433',
        num: '6502278',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 570,
        amount: 542.77,
        description: 'CHECK 6502228 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'ASSADOURIAN, BERDJ G',
        vendorId: 36,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15434',
        num: '6502228',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 571,
        amount: 666.9,
        description: 'CHECK 6502260 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Sanchez, Anthony',
        vendorId: 37,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15435',
        num: '6502260',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 572,
        amount: 207.62,
        description: 'CHECK 6502193 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Dunn, Kaitlyn',
        vendorId: 38,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15451',
        num: '6502193',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 573,
        amount: 391.66,
        description: 'CHECK 6502253 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Perdikos, Eleni',
        vendorId: 39,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15452',
        num: '6502253',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 574,
        amount: 400.63,
        description: 'CHECK 6502267',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Manuel Ramirez',
        vendorId: 29,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15453',
        num: '6502267',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 575,
        amount: 142.25,
        description: 'CHECK 6502255 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Arielle Pizarro',
        vendorId: 40,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15458',
        num: '6502255',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 576,
        amount: 208,
        description: 'CHECK 6502270  W.E. 06.23.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ana Garzon',
        vendorId: 41,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15459',
        num: '6502270',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 577,
        amount: 267.75,
        description: 'CHECK 6502316 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jessica Polak',
        vendorId: 42,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15460',
        num: '6502316',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 578,
        amount: 309.6,
        description: "CHECK 6502294 Brandon's Donuts",
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Dominguez',
        vendorId: 43,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15461',
        num: '6502294',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 579,
        amount: 497.4,
        description: 'CHECK 6502303 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Hernandez-Canel, Esteban',
        vendorId: 32,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15462',
        num: '6502303',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 580,
        amount: 508.73,
        description: 'CHECK 6502281 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Omar Lopez',
        vendorId: 31,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15463',
        num: '6502281',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 581,
        amount: 607.32,
        description: 'CHECK 6502293 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Dominguez',
        vendorId: 43,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15464',
        num: '6502293',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 582,
        amount: 621.17,
        description: 'CHECK 6502291 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Cruz Hernandez, Pedro',
        vendorId: 33,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15465',
        num: '6502291',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 583,
        amount: 629.47,
        description: 'CHECK 6502306 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Luna, Nelson',
        vendorId: 44,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15466',
        num: '6502306',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 584,
        amount: 78.51,
        description: 'CHECK 6502254 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Allanah Pizarro.',
        vendorId: 45,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15471',
        num: '6502254',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 585,
        amount: 157.94,
        description: 'CHECK 6502312 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Marina Pasek',
        vendorId: 46,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15472',
        num: '6502312',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 586,
        amount: 170.39,
        description: 'CHECK 6502277',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Junior Santiago',
        vendorId: 47,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15473',
        num: '6502277',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 587,
        amount: 317.08,
        description: 'CHECK 6502301 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Lina Granados',
        vendorId: 48,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15474',
        num: '6502301',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 588,
        amount: 345.45,
        description: 'CHECK 6502302 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Javier Hernandez',
        vendorId: 49,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15475',
        num: '6502302',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 589,
        amount: 371.36,
        description: 'CHECK 6502327 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carac, Israel',
        vendorId: 50,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15476',
        num: '6502327',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 590,
        amount: 410.26,
        description: 'CHECK 6502314 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Allanah Pizarro.',
        vendorId: 45,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15477',
        num: '6502314',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 591,
        amount: 445.8,
        description: 'CHECK 6502233 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Isabella Devine',
        vendorId: 51,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15478',
        num: '6502233',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 592,
        amount: 478.68,
        description: 'CHECK 6502307 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Alexis Martinez',
        vendorId: 52,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15479',
        num: '6502307',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 593,
        amount: 514.73,
        description: 'CHECK 6502290 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Reynaldo Cortes Sanchoz',
        vendorId: 34,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15480',
        num: '6502290',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 594,
        amount: 518.12,
        description: 'CHECK 6502284 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jason Canas',
        vendorId: 53,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15481',
        num: '6502284',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 595,
        amount: 535.96,
        description: 'POD CHECK W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Conserve, Mercidieu',
        vendorId: 54,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15482',
        num: '6502232',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 596,
        amount: 576.38,
        description: 'CHECK 6502283 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'ASSADOURIAN, BERDJ G',
        vendorId: 36,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15483',
        num: '6502283',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 597,
        amount: 616.17,
        description: 'POD CHECK W.E..06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Conserve, Mercidieu',
        vendorId: 54,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15484',
        num: '6502184',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 598,
        amount: 624.92,
        description: 'CHECK 6502298 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Franco Ramos, Luis David',
        vendorId: 55,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15485',
        num: '6502298',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 599,
        amount: 684.15,
        description: 'CHECK 6502259 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Rosemarie Rosado',
        vendorId: 56,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15486',
        num: '6502259',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 600,
        amount: 685.44,
        description: 'CHECK 6502299 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Juliana Garcia Escobar',
        vendorId: 57,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15487',
        num: '6502299',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 601,
        amount: 748.35,
        description: 'CHECK 6502300 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ana Maria Garzon',
        vendorId: 58,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15488',
        num: '6502300',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 602,
        amount: 757.68,
        description: 'CHECK 6502289 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Efren Cortes Sanchez',
        vendorId: 59,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15489',
        num: '6502289',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 603,
        amount: 823.27,
        description: 'CHECK 6502297 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Fonto, Laurynn',
        vendorId: 60,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15490',
        num: '6502297',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 604,
        amount: 966.36,
        description: 'CHECK 6502295 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Hakim Eatman',
        vendorId: 61,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15491',
        num: '6502295',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 605,
        amount: 202.73,
        description: 'CHECK 6502310 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Frida Monroy',
        vendorId: 62,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15500',
        num: '6502310',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 606,
        amount: 304.03,
        description: 'CHECK 6502318',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Ramirez',
        vendorId: 63,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15501',
        num: '6502318',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 607,
        amount: 403.1,
        description: 'POD CHECK W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jephthah Michel',
        vendorId: 64,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15502',
        num: '6502309',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 608,
        amount: 405.95,
        description: 'CHECK 6502292 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Isabella Devine',
        vendorId: 51,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15503',
        num: '6502292',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 609,
        amount: 406.59,
        description: 'CHECK 6502313 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Perdikos, Eleni',
        vendorId: 39,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15504',
        num: '6502313',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 610,
        amount: 408.55,
        description: 'CHECK 6502287 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Geoconda Castro',
        vendorId: 65,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15505',
        num: '6502287',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 611,
        amount: 545,
        description: 'CHECK 6502276',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Janetydy Huesca.',
        vendorId: 66,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15507',
        num: '6502276',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 612,
        amount: 571.25,
        description: 'CHECK 6502324 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Junior Santiago',
        vendorId: 47,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15509',
        num: '6502324',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 613,
        amount: 844.04,
        description: 'CHECK 6502296 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Smicker Figueroa',
        vendorId: 67,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15510',
        num: '6502296',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 614,
        amount: 932.87,
        description: 'CHECK 6502311 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ivonne Olarte',
        vendorId: 35,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15511',
        num: '6502311',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 615,
        amount: 1044.91,
        description: 'CHECK 6502317 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Mikhailson Pollas',
        vendorId: 68,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15513',
        num: '6502317',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 616,
        amount: 1120.13,
        description: 'CHECK 6502325 W.E. 07.06.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Roberto Santiago.',
        vendorId: 69,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15515',
        num: '6502325',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 617,
        amount: 4000,
        description: 'Other',
        category: 'Journal Entry',
        accountId: '687f4cd2_@_14',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15355',
        num: 'Payroll Accrual 07.20',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 618,
        amount: 1337.83,
        description: 'CHECK 6502189 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Rony Normil',
        vendorId: 70,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15350',
        num: '6502189',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 619,
        amount: 1054.65,
        description: 'CHECK 6502160 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ivonne Olarte',
        vendorId: 35,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15351',
        num: '6502160',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 620,
        amount: 1044.91,
        description: 'CHECK 6502178 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Mikhailson Pollas',
        vendorId: 68,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15352',
        num: '6502178',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 621,
        amount: 590.89,
        description: 'CHECK 6502152 Brandons Donuts',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Omar Lopez',
        vendorId: 31,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15358',
        num: '6502152',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 622,
        amount: 146.5,
        description: 'CHECK 6502158 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Isabella Devine',
        vendorId: 51,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15359',
        num: '6502158',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 623,
        amount: 252.85,
        description: 'CHECK 6502198 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jessica Polak',
        vendorId: 42,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15360',
        num: '6502198',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 624,
        amount: 262.86,
        description: 'CHECK 6502174 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Lina Granados',
        vendorId: 48,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15361',
        num: '6502174',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 625,
        amount: 300,
        description: 'CHECK 6502153',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Omar Lopez',
        vendorId: 31,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15362',
        num: '6502153',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 626,
        amount: 313.15,
        description: 'CHECK 6502196 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Javier Hernandez',
        vendorId: 49,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15363',
        num: '6502196',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 627,
        amount: 340.34,
        description: 'CHECK 6502170 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Christopher Intriago',
        vendorId: 28,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15364',
        num: '6502170',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 628,
        amount: 344.05,
        description: 'CHECK 6502191 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Joseph, Fiona',
        vendorId: 71,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15365',
        num: '6502191',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 629,
        amount: 352.55,
        description: 'CHECK 6502154 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Juliana Garcia Escobar',
        vendorId: 57,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15366',
        num: '6502154',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 630,
        amount: 367.8,
        description: 'CHECK 6502159 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Geoconda Castro',
        vendorId: 65,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15367',
        num: '6502159',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 631,
        amount: 388.33,
        description: 'CHECK 6502186 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Tocto, Domenica',
        vendorId: 72,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15368',
        num: '6502186',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 632,
        amount: 401.65,
        description: 'CHECK 6502194 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Rosemarie Rosado',
        vendorId: 56,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15369',
        num: '6502194',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 633,
        amount: 423.02,
        description: 'CHECK 6502179 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Marina Pasek',
        vendorId: 46,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15370',
        num: '6502179',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 634,
        amount: 495.61,
        description: 'CHECK 6502171',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Fonto, Laurynn',
        vendorId: 60,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15371',
        num: '6502171',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 635,
        amount: 552.98,
        description: 'CHECK 6502211 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Smicker Figueroa',
        vendorId: 67,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15372',
        num: '6502211',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 636,
        amount: 557.66,
        description: 'CHECK 6502156 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Luis David Franco Ramos',
        vendorId: 73,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15373',
        num: '6502156',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 637,
        amount: 564.07,
        description: 'CHECK 6502187 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'ASSADOURIAN, BERDJ G',
        vendorId: 36,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15374',
        num: '6502187',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 638,
        amount: 619.92,
        description: 'POD CHECK W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Samantha Lada',
        vendorId: 23,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15375',
        num: '6502188',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 639,
        amount: 736.22,
        description: 'POD CHECK W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jephthah Michel',
        vendorId: 64,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15376',
        num: '6502197',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 640,
        amount: 778.89,
        description: 'CHECK 6502199 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Hakim Eatman',
        vendorId: 61,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15377',
        num: '6502199',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 641,
        amount: 423.19,
        description: 'CHECK 6502214',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Manuel Ramirez',
        vendorId: 29,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15391',
        num: '6502214',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 642,
        amount: 303.02,
        description: 'CHECK 6502256 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Polak, Jessica',
        vendorId: 74,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15392',
        num: '6502256',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 643,
        amount: 332.68,
        description: 'CHECK 6502252',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Marina Pasek',
        vendorId: 46,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15393',
        num: '6502252',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 644,
        amount: 349.53,
        description: 'CHECK 6502243 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Javier Hernandez',
        vendorId: 49,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15394',
        num: '6502243',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 645,
        amount: 366.02,
        description: 'CHECK 6502248 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Olivia Mandez',
        vendorId: 25,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15395',
        num: '6502248',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 646,
        amount: 369.33,
        description: 'CHECK 6502218 Brandons Donuts',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Omar Lopez',
        vendorId: 31,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15396',
        num: '6502218',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 647,
        amount: 390.55,
        description: 'CHECK 6502231 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carac, Israel',
        vendorId: 50,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15397',
        num: '6502231',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 648,
        amount: 460.45,
        description: 'CHECK 6502239 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Franco Ramos, Luis David',
        vendorId: 55,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15398',
        num: '6502239',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 649,
        amount: 479.84,
        description: 'CHECK 6502247 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Luna, Nelson',
        vendorId: 44,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15399',
        num: '6502247',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 650,
        amount: 491.13,
        description: 'CHECK 6502269 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Alexis Martinez',
        vendorId: 52,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15400',
        num: '6502269',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 651,
        amount: 499.29,
        description: 'CHECK 6502229 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jason Canas',
        vendorId: 53,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15401',
        num: '6502229',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 652,
        amount: 604.74,
        description: 'CHECK 6502225 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Cruz Hernandez, Pedro',
        vendorId: 33,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15402',
        num: '6502225',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 653,
        amount: 611.68,
        description: 'CHECK 6502223 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Hernandez-Canel, Esteban',
        vendorId: 32,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15403',
        num: '6502223',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 654,
        amount: 611.8,
        description: 'CHECK 6502236 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Hakim Eatman',
        vendorId: 61,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15404',
        num: '6502236',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 655,
        amount: 750.35,
        description: 'CHECK 6502222 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Efren Cortes Sanchez',
        vendorId: 59,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15405',
        num: '6502222',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 656,
        amount: 1044.91,
        description: 'CHECK 6502257 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Mikhailson Pollas',
        vendorId: 68,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15407',
        num: '6502257',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 657,
        amount: 1337.83,
        description: 'CHECK 6502250 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Rony Normil',
        vendorId: 70,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15408',
        num: '6502250',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 658,
        amount: 166.98,
        description: 'CHECK 6502168 W.E. 06.22.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Manon, Carolina',
        vendorId: 75,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15411',
        num: '6502168',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 659,
        amount: 314,
        description: 'CHECK 6502265 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Dominguez',
        vendorId: 43,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15412',
        num: '6502265',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 660,
        amount: 359.89,
        description: 'CHECK 6502240 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Juliana Garcia Escobar',
        vendorId: 57,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15413',
        num: '6502240',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 661,
        amount: 399.03,
        description: 'CHECK 6502234 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Geoconda Castro',
        vendorId: 65,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15414',
        num: '6502234',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 662,
        amount: 527.82,
        description: 'CHECK 6502237 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Smicker Figueroa',
        vendorId: 67,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15415',
        num: '6502237',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 663,
        amount: 530,
        description: 'CHECK 6502264 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Dominguez',
        vendorId: 43,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15416',
        num: '6502264',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 664,
        amount: 540,
        description: 'CHECK 6502275',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Janetydy Huesca.',
        vendorId: 66,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15417',
        num: '6502275',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 665,
        amount: 559.92,
        description: 'CHECK 6502245 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Joseph, Fiona',
        vendorId: 71,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15418',
        num: '6502245',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 666,
        amount: 564.42,
        description: 'CHECK 6502242 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Lina Granados',
        vendorId: 48,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15419',
        num: '6502242',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 667,
        amount: 580,
        description: 'CHECK 6502140 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Janetydy Huesca.',
        vendorId: 66,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15420',
        num: '6502140',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 668,
        amount: 654.53,
        description: 'POD CHECK W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Samantha Lada',
        vendorId: 23,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15421',
        num: '6502246',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 669,
        amount: 707.24,
        description: 'CHECK 6502238 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Fonto, Laurynn',
        vendorId: 60,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15422',
        num: '6502238',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 670,
        amount: 761.38,
        description: 'CHECK 6502251 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ivonne Olarte',
        vendorId: 35,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15423',
        num: '6502251',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 671,
        amount: 767.84,
        description: 'CHECK 6502227 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Ramirez',
        vendorId: 63,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15424',
        num: '6502227',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 672,
        amount: 825.33,
        description: 'POD CHECK W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jephthah Michel',
        vendorId: 64,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15425',
        num: '6502249',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 673,
        amount: 1120.13,
        description: 'CHECK 6502268 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Roberto Santiago.',
        vendorId: 69,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15427',
        num: '6502268',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 674,
        amount: 54.98,
        description: 'CHECK 6502261 W.E. 06.29.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ibrahim Sidibay',
        vendorId: 76,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15429',
        num: '6502261',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 675,
        amount: 6500,
        description: 'Other',
        category: 'Journal Entry',
        accountId: '687f4cd2_@_14',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15628',
        num: 'PR 07.07. to 07.13',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 676,
        amount: 580,
        description: 'CHECK 6502139 Payroll 06.15.2025',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Janetydy Huesca.',
        vendorId: 66,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14883',
        num: '6502139',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 677,
        amount: 356.2,
        description: 'CHECK 6502137',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ivonne Olarte',
        vendorId: 35,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14884',
        num: '6502137',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 678,
        amount: 301.48,
        description: 'CHECK 6502136',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Javier Hernandez',
        vendorId: 49,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14885',
        num: '6502136',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 679,
        amount: 59.76,
        description: '',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15275',
        num: '6502143',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 680,
        amount: 677.74,
        description: 'CHECK 6502162',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Ramirez',
        vendorId: 63,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15282',
        num: '6502162',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 681,
        amount: 583.78,
        description: 'CHECK 6502155',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Luna, Nelson',
        vendorId: 44,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15283',
        num: '6502155',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 682,
        amount: 542.58,
        description: 'CHECK 6502183 WE 6.22.25 not found in Report',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carlos Dominguez',
        vendorId: 43,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15284',
        num: '6502183',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 683,
        amount: 511.02,
        description: 'CHECK 6502166 WE 6.22.25 not found in Report',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Hernandez-Canel, Esteban',
        vendorId: 32,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15285',
        num: '6502166',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 684,
        amount: 703.44,
        description: 'POD CHECK W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Alexandre, Wood Loudie',
        vendorId: 77,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15330',
        num: '6502192',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 685,
        amount: 755.76,
        description: 'CHECK 6502157 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Efren Cortes Sanchez',
        vendorId: 59,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15331',
        num: '6502157',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 686,
        amount: 1120.13,
        description: 'CHECK 6502182 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Roberto Santiago.',
        vendorId: 69,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15332',
        num: '6502182',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 687,
        amount: 658.11,
        description: 'CHECK 6502167 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Olivia Mandez',
        vendorId: 25,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15336',
        num: '6502167',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 688,
        amount: 626.79,
        description: 'CHECK 6502190 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ramirez, Jesus Sarmiento',
        vendorId: 24,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15337',
        num: '6502190',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 689,
        amount: 588.3,
        description: 'CHECK 6502164 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Cruz Hernandez, Pedro',
        vendorId: 33,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15338',
        num: '6502164',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 690,
        amount: 506.92,
        description: 'CHECK 6502180 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Alexis Martinez',
        vendorId: 52,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15339',
        num: '6502180',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 691,
        amount: 486.53,
        description: 'CHECK 6502169 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Perdikos, Eleni',
        vendorId: 39,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15340',
        num: '6502169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 692,
        amount: 377.91,
        description: 'CHECK 6502175 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Sanchez, Anthony',
        vendorId: 37,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15341',
        num: '6502175',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 693,
        amount: 362.53,
        description: 'CHECK 6502173 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Jason Canas',
        vendorId: 53,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15342',
        num: '6502173',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 694,
        amount: 305.7,
        description: 'CHECK 6502185 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Reynaldo Cortes Sanchoz',
        vendorId: 34,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15343',
        num: '6502185',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 695,
        amount: 262.54,
        description: 'CHECK 6502177 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Ibrahim Sidibay',
        vendorId: 76,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15344',
        num: '6502177',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 696,
        amount: 196.84,
        description: 'CHECK 6502163 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Frida Monroy',
        vendorId: 62,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15345',
        num: '6502163',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 697,
        amount: 174.74,
        description: 'CHECK 6502161 W.E. 6.22.25',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Carac, Israel',
        vendorId: 50,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15346',
        num: '6502161',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 698,
        amount: 6500,
        description: 'Other',
        category: 'Journal Entry',
        accountId: '687f4cd2_@_14',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15268',
        num: 'PR 06.30 to 07.06',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 699,
        amount: 489.65,
        description: 'CHECK 6502081',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Anthony Sanchez',
        vendorId: 26,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14674',
        num: '6502081',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 700,
        amount: 128.64,
        description: 'CHECK 6502083 06/02 - 06/08',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Isabella Devine',
        vendorId: 51,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14680',
        num: '6502083',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 701,
        amount: 559.15,
        description: 'CHECK 6502091',
        category: 'Check',
        accountId: '687f4cd2_@_14',
        name: 'Omar Lopez',
        vendorId: 31,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14858',
        num: '6502091',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 702,
        amount: 4300,
        description: 'Other',
        category: 'Journal Entry',
        accountId: '687f4cd2_@_14',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15265',
        num: 'PR 06.23 to 06.29',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 703,
        amount: 2244.1,
        description: 'Management',
        category: 'Journal Entry',
        accountId: '529343c4_@_14',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15635',
        num: 'Payroll Accrual 07.27',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 704,
        amount: 6486.95,
        description: 'Management',
        category: 'Journal Entry',
        accountId: '529343c4_@_14',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15355',
        num: 'Payroll Accrual 07.20',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 705,
        amount: 2244.1,
        description: 'Management',
        category: 'Journal Entry',
        accountId: '529343c4_@_14',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15628',
        num: 'PR 07.07. to 07.13',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 706,
        amount: 3455,
        description: 'Management',
        category: 'Journal Entry',
        accountId: '529343c4_@_14',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15268',
        num: 'PR 06.30 to 07.06',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 707,
        amount: 1620,
        description: 'Management',
        category: 'Journal Entry',
        accountId: '529343c4_@_14',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15265',
        num: 'PR 06.23 to 06.29',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 708,
        amount: 1711.54,
        description: 'BOH',
        category: 'Journal Entry',
        accountId: '3c61733f_@_14',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15635',
        num: 'Payroll Accrual 07.27',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 709,
        amount: 5121.55,
        description: 'BOH',
        category: 'Journal Entry',
        accountId: '3c61733f_@_14',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15355',
        num: 'Payroll Accrual 07.20',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 710,
        amount: 1711.54,
        description: 'BOH',
        category: 'Journal Entry',
        accountId: '3c61733f_@_14',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15628',
        num: 'PR 07.07. to 07.13',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 711,
        amount: 1711.54,
        description: 'BOH',
        category: 'Journal Entry',
        accountId: '3c61733f_@_14',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15268',
        num: 'PR 06.30 to 07.06',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 712,
        amount: 1711.54,
        description: 'BOH',
        category: 'Journal Entry',
        accountId: '3c61733f_@_14',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15265',
        num: 'PR 06.23 to 06.29',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 713,
        amount: 271,
        description: 'Commission',
        category: 'Journal Entry',
        accountId: '7a82e4de_@_14',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15628',
        num: 'PR 07.07. to 07.13',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 714,
        amount: 268,
        description: 'comission',
        category: 'Journal Entry',
        accountId: '7a82e4de_@_14',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15265',
        num: 'PR 06.23 to 06.29',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 715,
        amount: -1269.59,
        description: 'STRATEGY EXECUTI TAX COL',
        category: 'Deposit',
        accountId: 'bbc14e9c_@_14',
        name: 'Payroll Tax',
        vendorId: 78,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15624',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 716,
        amount: 480.77,
        description: 'PR Tax',
        category: 'Journal Entry',
        accountId: 'bbc14e9c_@_14',
        name: '',
        vendorId: 0,
        period: 0,
        txnDate: '2025-07-27',
        date: '2025-07-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15635',
        num: 'Payroll Accrual 07.27',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 717,
        amount: 2993.1,
        description: 'PR Tax',
        category: 'Journal Entry',
        accountId: 'bbc14e9c_@_14',
        name: '',
        vendorId: 0,
        period: 1,
        txnDate: '2025-07-20',
        date: '2025-07-20T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15355',
        num: 'Payroll Accrual 07.20',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 718,
        amount: 480.77,
        description: 'PR Tax',
        category: 'Journal Entry',
        accountId: 'bbc14e9c_@_14',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-13',
        date: '2025-07-13T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15628',
        num: 'PR 07.07. to 07.13',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 719,
        amount: 475,
        description: 'PR Tax',
        category: 'Journal Entry',
        accountId: 'bbc14e9c_@_14',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15268',
        num: 'PR 06.30 to 07.06',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 720,
        amount: 238.76,
        description: 'PR Tax',
        category: 'Journal Entry',
        accountId: 'bbc14e9c_@_14',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15265',
        num: 'PR 06.23 to 06.29',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 721,
        amount: 774,
        description: 'CHECK 650204 Reimbursement',
        category: 'Check',
        accountId: '416bc276_@_14',
        name: 'Eileen Kim',
        vendorId: 16,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14675',
        num: '650204',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 722,
        amount: 155,
        description: 'Vendor: Alpine Soda Systems Of New York LLC',
        category: 'Journal Entry',
        accountId: '1a6a3f76_@_18',
        name: '',
        vendorId: 0,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15533',
        num: 'MI1905ME',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 723,
        amount: 83.48,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'White Plains Linen',
        vendorId: 79,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15534',
        num: '3590454',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 724,
        amount: 65.35,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 725,
        amount: 35.7,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 726,
        amount: 20.12,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15207',
        num: '9255396',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 727,
        amount: 111.79,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15537',
        num: '9257563',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 728,
        amount: 101.13,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 729,
        amount: 21.61,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 730,
        amount: 66.69,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14724',
        num: '9249000',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 731,
        amount: 65.4,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14561',
        num: '9239104',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 732,
        amount: 74,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 733,
        amount: 34.7,
        description: '',
        category: 'Bill',
        accountId: '514ec7ed_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14703',
        num: '9243481',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 734,
        amount: 1044.92,
        description: 'CHECK 6502115',
        category: 'Check',
        accountId: '758ae475_@_18',
        name: 'Golden Cleaning',
        vendorId: 80,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15389',
        num: '6502115',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 735,
        amount: 270.35,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15541',
        num: '9262981',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 736,
        amount: 139.53,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15564',
        num: '9265169',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 737,
        amount: 119.8,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 0,
        txnDate: '2025-07-26',
        date: '2025-07-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15543',
        num: '713076',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 738,
        amount: 46.81,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15207',
        num: '9255396',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 739,
        amount: 149.33,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15537',
        num: '9257563',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 740,
        amount: 180.73,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15566',
        num: '9259520',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 741,
        amount: 87.54,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14720',
        num: '9249995',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 742,
        amount: 59.9,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15542',
        num: '711503',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 743,
        amount: 264.54,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14903',
        num: '9253029',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 744,
        amount: 232.93,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14714',
        num: '9247031',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 745,
        amount: 119.8,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Avanti Enterprises,INC.',
        vendorId: 5,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14722',
        num: '711119',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 746,
        amount: 111.91,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 3,
        txnDate: '2025-07-04',
        date: '2025-07-04T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14724',
        num: '9249000',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 747,
        amount: 80.19,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14561',
        num: '9239104',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 748,
        amount: 166.11,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14685',
        num: '9240751',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 749,
        amount: 125.33,
        description: '',
        category: 'Bill',
        accountId: '28a2ce1f_@_18',
        name: 'Performance Food Service',
        vendorId: 4,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14703',
        num: '9243481',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 750,
        amount: 268.89,
        description: '',
        category: 'Bill',
        accountId: 'ad6ac922_@_18',
        name: 'White Plains Linen',
        vendorId: 79,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15534',
        num: '3590454',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 751,
        amount: 1058.12,
        description: 'WHITE PLAINS COA COLLECTION',
        category: 'Expense',
        accountId: 'ad6ac922_@_18',
        name: 'White Plains Linen',
        vendorId: 79,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15492',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 752,
        amount: 1141.57,
        description: 'WHITE PLAINS COA COLLECTION',
        category: 'Expense',
        accountId: 'ad6ac922_@_18',
        name: 'White Plains Linen',
        vendorId: 79,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14839',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 753,
        amount: 1954.31,
        description: 'VISA DDA PUR AP - 469216     SQ  SARTOR INC              NEW YORK      * NY',
        category: 'Expense',
        accountId: 'ad6ac922_@_18',
        name: 'Sartor NYC',
        vendorId: 81,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14886',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 754,
        amount: 631.25,
        description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
        category: 'Expense',
        accountId: '9f991141_@_18',
        name: 'Crate & Barrel',
        vendorId: 82,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14590',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 755,
        amount: 546.8,
        description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
        category: 'Expense',
        accountId: '9f991141_@_18',
        name: 'Crate & Barrel',
        vendorId: 82,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14591',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 756,
        amount: 420.12,
        description: 'VISA DDA PUR AP - 469216     CRATE BARREL CB2 NOD        800 967 6696  * IL',
        category: 'Expense',
        accountId: '9f991141_@_18',
        name: 'Crate & Barrel',
        vendorId: 82,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14592',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 757,
        amount: 22.19,
        description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0586      480 5058855   * AZ',
        category: 'Expense',
        accountId: 'c61b398a_@_18',
        name: 'GO DADDY.COM',
        vendorId: 83,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15441',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 758,
        amount: 1700,
        description: 'VISA DDA PUR AP - 406466     WWW THESCENENY COM          WWW THESCENEN * NY',
        category: 'Expense',
        accountId: 'c61b398a_@_18',
        name: 'The Scene',
        vendorId: 84,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15410',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 759,
        amount: 89,
        description: 'ADENTRO INC      ZENREACH',
        category: 'Expense',
        accountId: 'c61b398a_@_18',
        name: 'Adentro Inc',
        vendorId: 85,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15201',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 760,
        amount: -89,
        description: 'ADENTRO INC      ZENREACH',
        category: 'Deposit',
        accountId: 'c61b398a_@_18',
        name: 'Adentro Inc',
        vendorId: 85,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15202',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 761,
        amount: 210.8,
        description: 'VISA DDA PUR AP - 490641     DNH GODADDY XXXXXX0986      480 5058855   * AZ',
        category: 'Expense',
        accountId: 'c61b398a_@_18',
        name: 'GO DADDY.COM',
        vendorId: 83,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14850',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 762,
        amount: 548,
        description: 'VISA DDA PUR AP - 401134     POPMENU INC                 POPMENU COM   * GA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Popmenu Inc.',
        vendorId: 86,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15524',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 763,
        amount: 289,
        description: 'VISA DDA PUR AP - 420429     FACEBK  8V9TBVCVK2          650 5434800   * CA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Facebook',
        vendorId: 87,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15226',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 764,
        amount: 18.14,
        description: 'VISA DDA PUR AP - 420429     FACEBK  4GXXCVYUK2          650 5434800   * CA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Facebook',
        vendorId: 87,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14749',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 765,
        amount: 98.26,
        description: 'VISA DDA PUR AP - 420429     FACEBK  UDDR8UQUK2          650 5434800   * CA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Facebook',
        vendorId: 87,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14750',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 766,
        amount: 237.79,
        description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE THE AINSWO    650 2530000   * CA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Google',
        vendorId: 88,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14847',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 767,
        amount: 522.99,
        description: 'VISA DDA PUR AP - 420429     GOOGLE GSUITE PAIGECONCE    650 2530000   * CA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Google',
        vendorId: 88,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14848',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 768,
        amount: 349.91,
        description: 'VISA DDA PUR AP - 420429     GOOGLE ADSXXXXXX3399        650 2530000   * CA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Google',
        vendorId: 88,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14849',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 769,
        amount: 262,
        description: 'VISA DDA PUR AP - 420429     FACEBK  KR7KAXUUK2          650 5434800   * CA',
        category: 'Expense',
        accountId: '1dc3b3a3_@_18',
        name: 'Facebook',
        vendorId: 87,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14558',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 770,
        amount: 108,
        description: 'Sum of Merchant promotions applied to the order',
        category: 'Journal Entry',
        accountId: '1dc3b3a3_@_18',
        name: '',
        vendorId: 0,
        period: 4,
        txnDate: '2025-06-29',
        date: '2025-06-29T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14879',
        num: 'Uber eats ADJ P6.25',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 771,
        amount: 500,
        description: 'POD CHECK',
        category: 'Check',
        accountId: '0c83dbac_@_18',
        name: 'YNVS Media LLC',
        vendorId: 89,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14857',
        num: '6502092',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 772,
        amount: 1499,
        description: '',
        category: 'Bill',
        accountId: '5a0fedcf_@_18',
        name: 'KitchenSync LLC',
        vendorId: 90,
        period: 3,
        txnDate: '2025-07-01',
        date: '2025-07-01T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14560',
        num: 'INV-12776-7690',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 773,
        amount: 1250,
        description: 'CHECK 6502084',
        category: 'Check',
        accountId: 'b08821c2_@_18',
        name: 'Shaun Rose',
        vendorId: 91,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14676',
        num: '6502084',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 774,
        amount: 1233.49,
        description: 'WIRE TRANSFER OUTGOING - Collection At Law',
        category: 'Expense',
        accountId: 'a630ac37_@_18',
        name: 'At Law',
        vendorId: 92,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15623',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 775,
        amount: 1681,
        description: 'WIRE TRANSFER OUTGOING - Collection At Law',
        category: 'Expense',
        accountId: 'a630ac37_@_18',
        name: 'At Law',
        vendorId: 92,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15384',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 776,
        amount: 2500,
        description: 'CHECK 2095',
        category: 'Check',
        accountId: 'a630ac37_@_18',
        name: 'Matthew J Keating Attorney',
        vendorId: 93,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14882',
        num: '2095',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 777,
        amount: 1806.54,
        description: 'CHECK 6502064',
        category: 'Check',
        accountId: 'a630ac37_@_18',
        name: 'Matthew J Keating Attorney',
        vendorId: 93,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14679',
        num: '6502064',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 778,
        amount: 92.53,
        description: 'VISA DDA PUR AP - 401134     7SHIFTS                     7SHIFTS COM   * DE',
        category: 'Expense',
        accountId: '975961bc_@_18',
        name: '7Shifts',
        vendorId: 94,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15445',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 779,
        amount: 80,
        description: 'Invoices: Ains hoboken - 7/16/2025 - Shipping Fee',
        category: 'Journal Entry',
        accountId: '975961bc_@_18',
        name: '',
        vendorId: 0,
        period: 3,
        txnDate: '2025-07-06',
        date: '2025-07-06T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15268',
        num: 'PR 06.30 to 07.06',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 780,
        amount: 406.67,
        description: 'VISA DDA PUR AP - 490641     PST TRIPLESEAT              978 2916436   * MA',
        category: 'Expense',
        accountId: '9450bb96_@_18',
        name: 'Tripleseat',
        vendorId: 95,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15443',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 781,
        amount: 1034,
        description: 'TOAST, INC       TOAST, INC',
        category: 'Expense',
        accountId: '9450bb96_@_18',
        name: 'Toast Inc',
        vendorId: 96,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15494',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 782,
        amount: 110,
        description: 'MARGINEDGE       XXXXXX9612',
        category: 'Expense',
        accountId: '9450bb96_@_18',
        name: 'MarginEdge',
        vendorId: 97,
        period: 2,
        txnDate: '2025-07-09',
        date: '2025-07-09T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15261',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 783,
        amount: 12.78,
        description: 'VISA DDA PUR AP - 420429     SPOTIFY USA                 877 7781161   * NY',
        category: 'Expense',
        accountId: '236c5723_@_18',
        name: 'Spotify',
        vendorId: 98,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15529',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 784,
        amount: 114.36,
        description: 'RESYNETWORKINC   RESYNETWOR',
        category: 'Expense',
        accountId: '236c5723_@_18',
        name: 'Resy',
        vendorId: 99,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14844',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 785,
        amount: 30,
        description: 'WIRE TRANSFER FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15609',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 786,
        amount: 30,
        description: 'WIRE TRANSFER FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15610',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 787,
        amount: 30,
        description: 'WIRE TRANSFER FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15611',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 788,
        amount: 30,
        description: 'WIRE TRANSFER FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14767',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 789,
        amount: 30,
        description: 'WIRE TRANSFER FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14768',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 790,
        amount: 30,
        description: 'WIRE TRANSFER FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14769',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 791,
        amount: 20,
        description: 'MAINTENANCE FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15203',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 792,
        amount: 30,
        description: 'WIRE TRANSFER FEE',
        category: 'Expense',
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges',
        vendorId: 100,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14766',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 793,
        amount: 1086.51,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15517',
        num: '',
        notes: '',
        audit: {
          status: 'Outlier',
          amount: 1086.51,
          reason: 'Amount ($1,086.51) is outside the range of -515.34 to 687.12\n      ($85.89 +/- 3 * 200.41)',
          priority: 'high',
          confidence: 70,
        },
      },
      {
        id: 794,
        amount: 318.9,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15518',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 795,
        amount: 51.17,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15519',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 796,
        amount: 1063,
        description: 'POD CHECK',
        category: 'Check',
        accountId: '058d9b25_@_18',
        name: 'Meow Hospitality LLC',
        vendorId: 102,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15638',
        num: '6502345',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 797,
        amount: 802.22,
        description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'CVS Pharmacy',
        vendorId: 103,
        period: 0,
        txnDate: '2025-07-22',
        date: '2025-07-22T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15625',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 798,
        amount: 62.37,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15575',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 799,
        amount: 44.77,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15576',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 800,
        amount: 56.5,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15577',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 801,
        amount: 14.49,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15579',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 802,
        amount: 14.8,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15578',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 803,
        amount: 6.39,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15581',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 804,
        amount: 122.46,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15225',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 805,
        amount: 26.02,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15230',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 806,
        amount: 271.88,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15231',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 807,
        amount: 400.34,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15234',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 808,
        amount: 41.56,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15237',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 809,
        amount: 7.45,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15220',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 810,
        amount: 55.98,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15318',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 811,
        amount: 63.96,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15315',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 812,
        amount: 181.16,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15316',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 813,
        amount: 49.38,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15317',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 814,
        amount: 66.02,
        description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'The Home Depot',
        vendorId: 104,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15323',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 815,
        amount: 19.18,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14730',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 816,
        amount: 13.53,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14727',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 817,
        amount: 1.75,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14731',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 818,
        amount: 4.99,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 3,
        txnDate: '2025-06-30',
        date: '2025-06-30T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14736',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 819,
        amount: 38.65,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14728',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 820,
        amount: 85.3,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14729',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 821,
        amount: -244.17,
        description: 'VISA DDA REF - 469216     AMAZON MKTPLACE PMTS        AMZN COM BILL * WA',
        category: 'Deposit',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14845',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 822,
        amount: 1000,
        description: 'POD CHECK',
        category: 'Check',
        accountId: '058d9b25_@_18',
        name: 'Meow Hospitality LLC',
        vendorId: 102,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15334',
        num: '6502210',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 823,
        amount: 21.3,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14548',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 824,
        amount: 127.91,
        description: 'VISA DDA PUR AP - 494301     THE HOME DEPOT  0908        CLIFTON       * NJ',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'The Home Depot',
        vendorId: 104,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14594',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 825,
        amount: 771.5,
        description: 'VISA DDA PUR AP - 413746     CVS PHARMACY  00845         800 746 7287  * NY',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'CVS Pharmacy',
        vendorId: 103,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14596',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 826,
        amount: 46.04,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14565',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 827,
        amount: 15.98,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14566',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 828,
        amount: 6.39,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14567',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 829,
        amount: 23.35,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14732',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 830,
        amount: 42.64,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14733',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 831,
        amount: 7.85,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14726',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 832,
        amount: 19.18,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14734',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 833,
        amount: 27.98,
        description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
        category: 'Expense',
        accountId: '058d9b25_@_18',
        name: 'Amazon',
        vendorId: 101,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14735',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 834,
        amount: 393.24,
        description: 'OPTIMUM 7862     CABLE PMNT',
        category: 'Expense',
        accountId: '0c2b505e_@_18',
        name: 'Optimum',
        vendorId: 105,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15495',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 835,
        amount: 334.99,
        description: 'VISA DDA PUR AP - 469216     SPI DIRECTV SERVICE         800 531 5000  * CA',
        category: 'Expense',
        accountId: '0c2b505e_@_18',
        name: 'DirecTV',
        vendorId: 106,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14595',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 836,
        amount: 950,
        description: 'CHECK 6502082 Security',
        category: 'Check',
        accountId: '9dc533d9_@_18',
        name: 'Herve Bertrand',
        vendorId: 107,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14881',
        num: '6502082',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 837,
        amount: 60.9,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15606',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 838,
        amount: 81.87,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15607',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 839,
        amount: 52.21,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15603',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 840,
        amount: 54.38,
        description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15605',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 841,
        amount: 50.67,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15604',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 842,
        amount: 55.09,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 0,
        txnDate: '2025-07-25',
        date: '2025-07-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15608',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 843,
        amount: 50.7,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15219',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 844,
        amount: 55.25,
        description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15264',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 845,
        amount: 74.9,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15243',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 846,
        amount: 54.38,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15246',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 847,
        amount: 56.72,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15239',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 848,
        amount: 49.02,
        description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 2,
        txnDate: '2025-07-11',
        date: '2025-07-11T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15263',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 849,
        amount: 79.12,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14764',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 850,
        amount: 68.96,
        description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14581',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 851,
        amount: 50.66,
        description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14765',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 852,
        amount: 56.87,
        description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
        category: 'Expense',
        accountId: 'e4e1ab18_@_18',
        name: 'Uber Trips',
        vendorId: 108,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14841',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 853,
        amount: 86.91,
        description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
        category: 'Expense',
        accountId: 'f245aeff_@_18',
        name: 'Plaza Mexico',
        vendorId: 109,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15528',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 854,
        amount: 71.17,
        description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
        category: 'Expense',
        accountId: 'f245aeff_@_18',
        name: 'Plaza Mexico',
        vendorId: 109,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15329',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 855,
        amount: 800,
        description: 'POD CHECK',
        category: 'Check',
        accountId: 'f245aeff_@_18',
        name: 'Mamma Mia',
        vendorId: 110,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15468',
        num: '6502282',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 856,
        amount: 92.67,
        description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
        category: 'Expense',
        accountId: 'f245aeff_@_18',
        name: 'Plaza Mexico',
        vendorId: 109,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14834',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 857,
        amount: 89.97,
        description: 'VISA DDA PUR AP - 476501     PLAZA MEXICO                PASSAIC       * NJ',
        category: 'Expense',
        accountId: 'f245aeff_@_18',
        name: 'Plaza Mexico',
        vendorId: 109,
        period: 4,
        txnDate: '2025-06-25',
        date: '2025-06-25T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14603',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 858,
        amount: 1238,
        description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
        category: 'Expense',
        accountId: '3ae4b332_@_18',
        name: 'Hoboken Parking',
        vendorId: 111,
        period: 0,
        txnDate: '2025-07-24',
        date: '2025-07-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15621',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 859,
        amount: 1238,
        description: 'VISA DDA PUR AP - 401339     HOBOKEN PARKING UTILITY     201 6531919   * NJ',
        category: 'Expense',
        accountId: '3ae4b332_@_18',
        name: 'Hoboken Parking',
        vendorId: 111,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14579',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 860,
        amount: 34.01,
        description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
        category: 'Expense',
        accountId: '4dbd49a9_@_18',
        name: 'FUEL 4',
        vendorId: 112,
        period: 0,
        txnDate: '2025-07-23',
        date: '2025-07-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15583',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 861,
        amount: 36.01,
        description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
        category: 'Expense',
        accountId: '4dbd49a9_@_18',
        name: 'FUEL 4',
        vendorId: 112,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15260',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 862,
        amount: 35,
        description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
        category: 'Expense',
        accountId: '4dbd49a9_@_18',
        name: 'FUEL 4',
        vendorId: 112,
        period: 3,
        txnDate: '2025-07-03',
        date: '2025-07-03T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14832',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 863,
        amount: 30.1,
        description: 'VISA DDA PUR AP - 475542     FUEL 4 GAS AND DIESEL       SECAUCUS      * NJ',
        category: 'Expense',
        accountId: '4dbd49a9_@_18',
        name: 'FUEL 4',
        vendorId: 112,
        period: 4,
        txnDate: '2025-06-26',
        date: '2025-06-26T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14833',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 864,
        amount: 27.01,
        description: 'VISA DDA PUR AP - 476501     FUEL 4 JERSEY CITY          JERSEY CITY   * NJ',
        category: 'Expense',
        accountId: '4dbd49a9_@_18',
        name: 'FUEL 4',
        vendorId: 112,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14831',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 865,
        amount: 880,
        description: 'CHECK 6502273',
        category: 'Check',
        accountId: 'aa06968c_@_18',
        name: 'AZ Mechanical',
        vendorId: 113,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15436',
        num: '6502273',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 866,
        amount: 1150,
        description: 'CHECK 6502272 HVAC',
        category: 'Check',
        accountId: 'aa06968c_@_18',
        name: 'AZ Mechanical',
        vendorId: 113,
        period: 1,
        txnDate: '2025-07-14',
        date: '2025-07-14T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15438',
        num: '6502272',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 867,
        amount: 411.6,
        description: 'CHECK 6502328',
        category: 'Check',
        accountId: 'aa06968c_@_18',
        name: 'AIs Technical Incorporated',
        vendorId: 114,
        period: 1,
        txnDate: '2025-07-18',
        date: '2025-07-18T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15506',
        num: '6502328',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 868,
        amount: 3479,
        description: 'CHECK 6502073 MS HVAC',
        category: 'Check',
        accountId: 'aa06968c_@_18',
        name: 'AZ Mechanical',
        vendorId: 113,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14854',
        num: '6502073',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 869,
        amount: 1777.52,
        description: 'CHECK 6502326 Electrical & plumbing work',
        category: 'Check',
        accountId: '4d40af10_@_18',
        name: 'Eileen Kim',
        vendorId: 16,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15636',
        num: '6502326',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 870,
        amount: 1697.66,
        description: 'CHECK 6502087 Garage Door',
        category: 'Check',
        accountId: '4d40af10_@_18',
        name: 'American Garage Door',
        vendorId: 115,
        period: 1,
        txnDate: '2025-07-15',
        date: '2025-07-15T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15455',
        num: '6502087',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 871,
        amount: 1697.66,
        description: 'CHECK 6502085',
        category: 'Check',
        accountId: '4d40af10_@_18',
        name: 'American Garage Door',
        vendorId: 115,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15349',
        num: '6502085',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 872,
        amount: 250,
        description: 'CHECK 6502144',
        category: 'Check',
        accountId: '4d40af10_@_18',
        name: 'Tekno Electric',
        vendorId: 116,
        period: 2,
        txnDate: '2025-07-08',
        date: '2025-07-08T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15387',
        num: '6502144',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 873,
        amount: 1697.66,
        description: 'CHECK 6502086 Garage door',
        category: 'Check',
        accountId: '4d40af10_@_18',
        name: 'American Garage Door',
        vendorId: 115,
        period: 2,
        txnDate: '2025-07-10',
        date: '2025-07-10T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15409',
        num: '6502086',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 874,
        amount: 525.46,
        description: 'VISA DDA PUR AP - 403982     LIBERTY PEST CONTROL        718 8379030   * NY',
        category: 'Expense',
        accountId: 'a044faba_@_18',
        name: 'Liberty Pest',
        vendorId: 117,
        period: 3,
        txnDate: '2025-07-02',
        date: '2025-07-02T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15290',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 875,
        amount: 505.49,
        description: 'CHECK 650103 1170053',
        category: 'Check',
        accountId: 'a044faba_@_18',
        name: 'Liberty Pest',
        vendorId: 117,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14851',
        num: '650103',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 876,
        amount: 631.86,
        description: 'CHECK 65014 1185730',
        category: 'Check',
        accountId: 'a044faba_@_18',
        name: 'Liberty Pest',
        vendorId: 117,
        period: 4,
        txnDate: '2025-06-24',
        date: '2025-06-24T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14855',
        num: '65014',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 877,
        amount: 18437.33,
        description: 'IRONSTATE PROPER SIGONFILE',
        category: 'Expense',
        accountId: '68876c4f_@_21',
        name: 'Ironstate Proper',
        vendorId: 118,
        period: 1,
        txnDate: '2025-07-16',
        date: '2025-07-16T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15470',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 878,
        amount: 430.96,
        description: '',
        category: 'Bill',
        accountId: 'c9446d9c_@_21',
        name: 'NuCO2',
        vendorId: 119,
        period: 4,
        txnDate: '2025-06-27',
        date: '2025-06-27T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15215',
        num: '80547688',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 879,
        amount: -1.01,
        description: 'TOAST            EOM JUN 30',
        category: 'Deposit',
        accountId: '91f38f9a_@_21',
        name: 'Toast Inc',
        vendorId: 96,
        period: 2,
        txnDate: '2025-07-07',
        date: '2025-07-07T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15382',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 880,
        amount: 1960,
        description: 'CHECK 6502339',
        category: 'Check',
        accountId: '5ccef3e9_@_21',
        name: 'Roberto Averos',
        vendorId: 120,
        period: 0,
        txnDate: '2025-07-21',
        date: '2025-07-21T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15657',
        num: '6502339',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 881,
        amount: 987.26,
        description: 'BENEFITHEALTHPLA WEBPAYMENT',
        category: 'Expense',
        accountId: '5ccef3e9_@_21',
        name: 'Unknown',
        vendorId: 121,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15496',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 882,
        amount: 1453.59,
        description: 'BENEFITHEALTHPLA WEBPAYMENT',
        category: 'Expense',
        accountId: '5ccef3e9_@_21',
        name: 'Unknown',
        vendorId: 121,
        period: 1,
        txnDate: '2025-07-17',
        date: '2025-07-17T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '15497',
        num: '',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
      {
        id: 883,
        amount: 1448.63,
        description: 'CHECK 6502078',
        category: 'Check',
        accountId: '5ccef3e9_@_21',
        name: 'David Conte',
        vendorId: 122,
        period: 4,
        txnDate: '2025-06-23',
        date: '2025-06-23T00:00:00.000Z',
        dueDate: '',
        pastDue: 0,
        eventId: '14677',
        num: '6502078',
        notes: '',
        audit: {
          status: 'Normal',
          amount: 0,
          reason: '',
        },
      },
    ],
    vendors: [
      {
        id: 0,
        name: '',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 1,
            stats: null,
          },
          {
            accountId: 2,
            stats: null,
          },
          {
            accountId: 3,
            stats: null,
          },
          {
            accountId: 4,
            stats: null,
          },
          {
            accountId: 5,
            stats: null,
          },
          {
            accountId: 6,
            stats: null,
          },
          {
            accountId: 7,
            stats: null,
          },
          {
            accountId: 11,
            stats: null,
          },
          {
            accountId: 15,
            stats: null,
          },
          {
            accountId: 16,
            stats: null,
          },
          {
            accountId: 18,
            stats: null,
          },
          {
            accountId: 19,
            stats: null,
          },
          {
            accountId: 20,
            stats: null,
          },
          {
            accountId: 21,
            stats: null,
          },
          {
            accountId: 22,
            stats: null,
          },
          {
            accountId: 26,
            stats: null,
          },
          {
            accountId: 27,
            stats: null,
          },
          {
            accountId: 28,
            stats: null,
          },
          {
            accountId: 36,
            stats: null,
          },
          {
            accountId: 37,
            stats: null,
          },
          {
            accountId: 38,
            stats: null,
          },
          {
            accountId: 41,
            stats: null,
          },
          {
            accountId: 42,
            stats: null,
          },
          {
            accountId: 51,
            stats: null,
          },
          {
            accountId: 63,
            stats: null,
          },
          {
            accountId: 70,
            stats: null,
          },
        ],
      },
      {
        id: 1,
        name: 'Restaurant Depot',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 15,
            stats: null,
          },
        ],
      },
      {
        id: 2,
        name: 'Ferro & Sons, Inc.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 15,
            stats: null,
          },
        ],
      },
      {
        id: 3,
        name: 'Baldor Specialty Foods Inc.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 16,
            stats: null,
          },
          {
            accountId: 17,
            stats: null,
          },
          {
            accountId: 18,
            stats: null,
          },
          {
            accountId: 19,
            stats: null,
          },
          {
            accountId: 20,
            stats: null,
          },
          {
            accountId: 21,
            stats: null,
          },
          {
            accountId: 23,
            stats: null,
          },
          {
            accountId: 28,
            stats: null,
          },
        ],
      },
      {
        id: 4,
        name: 'Performance Food Service',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 16,
            stats: null,
          },
          {
            accountId: 17,
            stats: null,
          },
          {
            accountId: 19,
            stats: null,
          },
          {
            accountId: 20,
            stats: null,
          },
          {
            accountId: 21,
            stats: null,
          },
          {
            accountId: 23,
            stats: null,
          },
          {
            accountId: 28,
            stats: null,
          },
          {
            accountId: 29,
            stats: null,
          },
          {
            accountId: 52,
            stats: null,
          },
          {
            accountId: 54,
            stats: null,
          },
        ],
      },
      {
        id: 5,
        name: 'Avanti Enterprises,INC.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 18,
            stats: null,
          },
          {
            accountId: 19,
            stats: null,
          },
          {
            accountId: 21,
            stats: null,
          },
          {
            accountId: 54,
            stats: null,
          },
        ],
      },
      {
        id: 6,
        name: 'Avanti Produce',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 18,
            stats: null,
          },
        ],
      },
      {
        id: 7,
        name: 'Allied Beverages',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 19,
            stats: null,
          },
          {
            accountId: 22,
            stats: null,
          },
          {
            accountId: 23,
            stats: null,
          },
          {
            accountId: 27,
            stats: null,
          },
        ],
      },
      {
        id: 8,
        name: 'The Webstaurant Store',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 19,
            stats: null,
          },
        ],
      },
      {
        id: 9,
        name: 'ShopRite',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 19,
            stats: null,
          },
        ],
      },
      {
        id: 10,
        name: 'Instacart',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 19,
            stats: null,
          },
        ],
      },
      {
        id: 11,
        name: 'RM Bakery LLC',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 20,
            stats: null,
          },
        ],
      },
      {
        id: 12,
        name: 'David Rosen Bakery Supply Co',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 20,
            stats: null,
          },
        ],
      },
      {
        id: 13,
        name: 'Fedway',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 22,
            stats: null,
          },
        ],
      },
      {
        id: 14,
        name: 'Federal Wine & Spirits Co.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 22,
            stats: null,
          },
          {
            accountId: 26,
            stats: null,
          },
          {
            accountId: 27,
            stats: null,
          },
        ],
      },
      {
        id: 15,
        name: 'Peerless Beverage',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 22,
            stats: null,
          },
          {
            accountId: 25,
            stats: null,
          },
          {
            accountId: 26,
            stats: null,
          },
          {
            accountId: 28,
            stats: null,
          },
        ],
      },
      {
        id: 16,
        name: 'Eileen Kim',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 24,
            stats: null,
          },
          {
            accountId: 43,
            stats: null,
          },
          {
            accountId: 86,
            stats: null,
          },
        ],
      },
      {
        id: 17,
        name: 'Northern Eagle Beverage',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 25,
            stats: null,
          },
          {
            accountId: 26,
            stats: null,
          },
        ],
      },
      {
        id: 18,
        name: 'Hoboken Brewing',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 25,
            stats: null,
          },
        ],
      },
      {
        id: 19,
        name: 'Gallo Wine Sales',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 27,
            stats: null,
          },
        ],
      },
      {
        id: 20,
        name: 'Pepsi',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 28,
            stats: null,
          },
        ],
      },
      {
        id: 21,
        name: 'W.b. Law Coffee',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 28,
            stats: null,
          },
        ],
      },
      {
        id: 22,
        name: 'Campos Delivery LLC',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 30,
            stats: null,
          },
        ],
      },
      {
        id: 23,
        name: 'Samantha Lada',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 24,
        name: 'Ramirez, Jesus Sarmiento',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 25,
        name: 'Olivia Mandez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 26,
        name: 'Anthony Sanchez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 27,
        name: 'Cantillano Cardenas, Lila',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 28,
        name: 'Christopher Intriago',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 29,
        name: 'Manuel Ramirez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 30,
        name: 'Domingo Roman',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 31,
        name: 'Omar Lopez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 32,
        name: 'Hernandez-Canel, Esteban',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 33,
        name: 'Cruz Hernandez, Pedro',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 34,
        name: 'Reynaldo Cortes Sanchoz',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 35,
        name: 'Ivonne Olarte',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 36,
        name: 'ASSADOURIAN, BERDJ G',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 37,
        name: 'Sanchez, Anthony',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 38,
        name: 'Dunn, Kaitlyn',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 39,
        name: 'Perdikos, Eleni',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 40,
        name: 'Arielle Pizarro',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 41,
        name: 'Ana Garzon',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 42,
        name: 'Jessica Polak',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 43,
        name: 'Carlos Dominguez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 44,
        name: 'Luna, Nelson',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 45,
        name: 'Allanah Pizarro.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 46,
        name: 'Marina Pasek',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 47,
        name: 'Junior Santiago',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 48,
        name: 'Lina Granados',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 49,
        name: 'Javier Hernandez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 50,
        name: 'Carac, Israel',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 51,
        name: 'Isabella Devine',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 52,
        name: 'Alexis Martinez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 53,
        name: 'Jason Canas',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 54,
        name: 'Conserve, Mercidieu',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 55,
        name: 'Franco Ramos, Luis David',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 56,
        name: 'Rosemarie Rosado',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 57,
        name: 'Juliana Garcia Escobar',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 58,
        name: 'Ana Maria Garzon',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 59,
        name: 'Efren Cortes Sanchez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 60,
        name: 'Fonto, Laurynn',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 61,
        name: 'Hakim Eatman',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 62,
        name: 'Frida Monroy',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 63,
        name: 'Carlos Ramirez',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 64,
        name: 'Jephthah Michel',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 65,
        name: 'Geoconda Castro',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 66,
        name: 'Janetydy Huesca.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 67,
        name: 'Smicker Figueroa',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 68,
        name: 'Mikhailson Pollas',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 69,
        name: 'Roberto Santiago.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 70,
        name: 'Rony Normil',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 71,
        name: 'Joseph, Fiona',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 72,
        name: 'Tocto, Domenica',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 73,
        name: 'Luis David Franco Ramos',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 74,
        name: 'Polak, Jessica',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 75,
        name: 'Manon, Carolina',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 76,
        name: 'Ibrahim Sidibay',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 77,
        name: 'Alexandre, Wood Loudie',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 36,
            stats: null,
          },
        ],
      },
      {
        id: 78,
        name: 'Payroll Tax',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 42,
            stats: null,
          },
        ],
      },
      {
        id: 79,
        name: 'White Plains Linen',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 52,
            stats: null,
          },
          {
            accountId: 55,
            stats: null,
          },
        ],
      },
      {
        id: 80,
        name: 'Golden Cleaning',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 53,
            stats: null,
          },
        ],
      },
      {
        id: 81,
        name: 'Sartor NYC',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 55,
            stats: null,
          },
        ],
      },
      {
        id: 82,
        name: 'Crate & Barrel',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 56,
            stats: null,
          },
        ],
      },
      {
        id: 83,
        name: 'GO DADDY.COM',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 62,
            stats: null,
          },
        ],
      },
      {
        id: 84,
        name: 'The Scene',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 62,
            stats: null,
          },
        ],
      },
      {
        id: 85,
        name: 'Adentro Inc',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 62,
            stats: null,
          },
        ],
      },
      {
        id: 86,
        name: 'Popmenu Inc.',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 63,
            stats: null,
          },
        ],
      },
      {
        id: 87,
        name: 'Facebook',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 63,
            stats: null,
          },
        ],
      },
      {
        id: 88,
        name: 'Google',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 63,
            stats: null,
          },
        ],
      },
      {
        id: 89,
        name: 'YNVS Media LLC',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 65,
            stats: null,
          },
        ],
      },
      {
        id: 90,
        name: 'KitchenSync LLC',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 67,
            stats: null,
          },
        ],
      },
      {
        id: 91,
        name: 'Shaun Rose',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 68,
            stats: null,
          },
        ],
      },
      {
        id: 92,
        name: 'At Law',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 69,
            stats: null,
          },
        ],
      },
      {
        id: 93,
        name: 'Matthew J Keating Attorney',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 69,
            stats: null,
          },
        ],
      },
      {
        id: 94,
        name: '7Shifts',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 70,
            stats: null,
          },
        ],
      },
      {
        id: 95,
        name: 'Tripleseat',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 71,
            stats: null,
          },
        ],
      },
      {
        id: 96,
        name: 'Toast Inc',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 71,
            stats: null,
          },
          {
            accountId: 99,
            stats: null,
          },
        ],
      },
      {
        id: 97,
        name: 'MarginEdge',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 71,
            stats: null,
          },
        ],
      },
      {
        id: 98,
        name: 'Spotify',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 72,
            stats: null,
          },
        ],
      },
      {
        id: 99,
        name: 'Resy',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 72,
            stats: null,
          },
        ],
      },
      {
        id: 100,
        name: 'Bank Charges',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 73,
            stats: null,
          },
        ],
      },
      {
        id: 101,
        name: 'Amazon',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 74,
            stats: null,
          },
        ],
      },
      {
        id: 102,
        name: 'Meow Hospitality LLC',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 74,
            stats: null,
          },
        ],
      },
      {
        id: 103,
        name: 'CVS Pharmacy',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 74,
            stats: null,
          },
        ],
      },
      {
        id: 104,
        name: 'The Home Depot',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 74,
            stats: null,
          },
        ],
      },
      {
        id: 105,
        name: 'Optimum',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 75,
            stats: null,
          },
        ],
      },
      {
        id: 106,
        name: 'DirecTV',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 75,
            stats: null,
          },
        ],
      },
      {
        id: 107,
        name: 'Herve Bertrand',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 76,
            stats: null,
          },
        ],
      },
      {
        id: 108,
        name: 'Uber Trips',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 79,
            stats: null,
          },
        ],
      },
      {
        id: 109,
        name: 'Plaza Mexico',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 80,
            stats: null,
          },
        ],
      },
      {
        id: 110,
        name: 'Mamma Mia',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 80,
            stats: null,
          },
        ],
      },
      {
        id: 111,
        name: 'Hoboken Parking',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 81,
            stats: null,
          },
        ],
      },
      {
        id: 112,
        name: 'FUEL 4',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 82,
            stats: null,
          },
        ],
      },
      {
        id: 113,
        name: 'AZ Mechanical',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 85,
            stats: null,
          },
        ],
      },
      {
        id: 114,
        name: 'AIs Technical Incorporated',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 85,
            stats: null,
          },
        ],
      },
      {
        id: 115,
        name: 'American Garage Door',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 86,
            stats: null,
          },
        ],
      },
      {
        id: 116,
        name: 'Tekno Electric',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 86,
            stats: null,
          },
        ],
      },
      {
        id: 117,
        name: 'Liberty Pest',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 87,
            stats: null,
          },
        ],
      },
      {
        id: 118,
        name: 'Ironstate Proper',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 94,
            stats: null,
          },
        ],
      },
      {
        id: 119,
        name: 'NuCO2',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 96,
            stats: null,
          },
        ],
      },
      {
        id: 120,
        name: 'Roberto Averos',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 100,
            stats: null,
          },
        ],
      },
      {
        id: 121,
        name: 'Unknown',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 100,
            stats: null,
          },
        ],
      },
      {
        id: 122,
        name: 'David Conte',
        categories: [],
        externalId: '',
        glAccounts: [
          {
            accountId: 100,
            stats: null,
          },
        ],
      },
    ],
    accounts: [
      {
        id: 0,
        glCode: 4000,
        accountId: '5bc89b03_@_2',
        name: 'SALES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 1,
        glCode: 4105,
        accountId: 'c5601bf4_@_2',
        name: 'Sales, Food',
        stats: {
          count: 36,
          min: 1993.5,
          max: 12032.5,
          stdDev: 3146.5564725562776,
          median: 4669.75,
          mean: 5663.824444444444,
          variance: 9900817.634985805,
          sum: 203897.68,
          boundaries: {
            threeStdDev: {
              lower: -3775.844973224388,
              upper: 15103.493862113277,
            },
            iqr: {
              q1: 3139.5,
              q3: 7669.5,
              lower: -3655.5,
              upper: 14464.5,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [22],
          anomalies: [
            {
              id: 22,
              amount: 5883.17,
              description: '',
              category: 'Journal Entry',
              accountId: 'c5601bf4_@_2',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-06-30',
              date: '2025-06-30T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15308',
              num: 'Strip sale P6.25',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 2,
        glCode: 4110,
        accountId: 'e1ca5621_@_2',
        name: 'Sales, Liquor',
        stats: {
          count: 35,
          min: 362,
          max: 8862.5,
          stdDev: 2291.5746205623304,
          median: 1811,
          mean: 2985.1005714285716,
          variance: 5251314.241605388,
          sum: 104478.52,
          boundaries: {
            threeStdDev: {
              lower: -3889.6232902584193,
              upper: 9859.824433115562,
            },
            iqr: {
              q1: 1294,
              q3: 4534,
              lower: -3566,
              upper: 9394,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 3,
        glCode: 4115,
        accountId: 'ba0b0910_@_2',
        name: 'Sales, Beer',
        stats: {
          count: 70,
          min: 20,
          max: 1482,
          stdDev: 341.5212677514105,
          median: 316.5,
          mean: 394.62857142857143,
          variance: 116636.77632653061,
          sum: 27624,
          boundaries: {
            threeStdDev: {
              lower: -629.9352318256601,
              upper: 1419.192374682803,
            },
            iqr: {
              q1: 107,
              q3: 583,
              lower: -607,
              upper: 1297,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [138],
          outliers: [
            {
              id: 138,
              amount: 1482,
              description: '',
              category: 'Journal Entry',
              accountId: 'ba0b0910_@_2',
              name: '',
              vendorId: 0,
              period: 4,
              txnDate: '2025-06-28',
              date: '2025-06-28T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14686',
              num: 'MJ1774ME',
              notes: '',
              audit: {
                status: 'Outlier',
                amount: 1482,
                reason:
                  'Amount ($1,482.00) is outside the range of -629.94 to 1,419.19\n      ($394.63 +/- 3 * 341.52)',
                priority: 'low',
                confidence: 41.15435999844536,
              },
            },
          ],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 4,
        glCode: 4120,
        accountId: '2f14959f_@_2',
        name: 'Sales, Wine',
        stats: {
          count: 35,
          min: 38,
          max: 587,
          stdDev: 135.0473537508308,
          median: 205,
          mean: 225.42857142857142,
          variance: 18237.78775510204,
          sum: 7890,
          boundaries: {
            threeStdDev: {
              lower: -179.71348982392104,
              upper: 630.5706326810639,
            },
            iqr: {
              q1: 129,
              q3: 276,
              lower: -91.5,
              upper: 496.5,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 5,
        glCode: 4125,
        accountId: '7bb557b1_@_2',
        name: 'Sales, Non-Alcoholic Beverage',
        stats: {
          count: 35,
          min: 104,
          max: 757,
          stdDev: 196.39956357239842,
          median: 307,
          mean: 373.8,
          variance: 38572.788571428566,
          sum: 13083,
          boundaries: {
            threeStdDev: {
              lower: -215.39869071719528,
              upper: 962.9986907171954,
            },
            iqr: {
              q1: 205,
              q3: 572,
              lower: -345.5,
              upper: 1122.5,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 6,
        glCode: 4140,
        accountId: 'cbede411_@_2',
        name: 'Sales, Miscellaneous',
        stats: {
          count: 19,
          min: 20,
          max: 2542.8,
          stdDev: 772.9629149683336,
          median: 258,
          mean: 666.9668421052633,
          variance: 597471.6679163434,
          sum: 12672.370000000003,
          boundaries: {
            threeStdDev: {
              lower: -1651.9219027997374,
              upper: 2985.855587010264,
            },
            iqr: {
              q1: 65,
              q3: 1217.6,
              lower: -1663.8999999999999,
              upper: 2946.5,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [
            211, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 224, 225, 226, 227, 223, 228, 229,
          ],
          anomalies: [
            {
              id: 211,
              amount: 2542.8,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15530',
              num: 'MJ1883ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 211,
              amount: 2542.8,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15530',
              num: 'MJ1883ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 212,
              amount: 86,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-25',
              date: '2025-07-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15561',
              num: 'MJ1888ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 213,
              amount: 80,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-26',
              date: '2025-07-26T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15572',
              num: 'MJ1890ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 214,
              amount: 52,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-27',
              date: '2025-07-27T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15573',
              num: 'MJ1934ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 215,
              amount: 29.48,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 1,
              txnDate: '2025-07-16',
              date: '2025-07-16T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15310',
              num: 'MJ1867ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 216,
              amount: 1140.57,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 1,
              txnDate: '2025-07-18',
              date: '2025-07-18T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15312',
              num: 'MJ1871ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 217,
              amount: 1217.6,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 1,
              txnDate: '2025-07-19',
              date: '2025-07-19T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15353',
              num: 'MJ1873ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 218,
              amount: 214,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-07',
              date: '2025-07-07T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14888',
              num: 'MJ1832ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 219,
              amount: 388,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-08',
              date: '2025-07-08T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14905',
              num: 'MJ1834ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 220,
              amount: 387,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15026',
              num: 'MJ1851ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 221,
              amount: 79.04,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-12',
              date: '2025-07-12T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15209',
              num: 'MJ1855ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 222,
              amount: 2291,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-13',
              date: '2025-07-13T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15208',
              num: 'MJ1858ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 224,
              amount: 1460.88,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-02',
              date: '2025-07-02T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14711',
              num: 'MJ1795ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 225,
              amount: 1247,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-03',
              date: '2025-07-03T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14712',
              num: 'MJ1797ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 226,
              amount: 20,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-05',
              date: '2025-07-05T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14715',
              num: 'MJ1801ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 227,
              amount: 258,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-06',
              date: '2025-07-06T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14716',
              num: 'MJ1803ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 223,
              amount: 1084,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-01',
              date: '2025-07-01T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14710',
              num: 'MJ1788ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 228,
              amount: 30,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 4,
              txnDate: '2025-06-27',
              date: '2025-06-27T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14684',
              num: 'MJ1771ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 229,
              amount: 65,
              description: '',
              category: 'Journal Entry',
              accountId: 'cbede411_@_2',
              name: '',
              vendorId: 0,
              period: 4,
              txnDate: '2025-06-28',
              date: '2025-06-28T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14686',
              num: 'MJ1774ME',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 7,
        glCode: 4145,
        accountId: '4e12e939_@_2',
        name: 'Sales, Service Charges',
        stats: {
          count: 35,
          min: 51.45,
          max: 470.49,
          stdDev: 115.30480926869353,
          median: 158.55,
          mean: 187.87371428571427,
          variance: 13295.199040489793,
          sum: 6575.58,
          boundaries: {
            threeStdDev: {
              lower: -158.04071352036632,
              upper: 533.7881420917948,
            },
            iqr: {
              q1: 91.61,
              q3: 227.71,
              lower: -112.54000000000003,
              upper: 431.86,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 8,
        glCode: 4199,
        accountId: 'a1f04b4c_@_2',
        name: 'Sales - No category',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 9,
        glCode: null,
        accountId: '74405d1a_@_3',
        name: 'GROSS SALES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 10,
        glCode: null,
        accountId: 'ba9fcd64_@_6',
        name: 'Comps & Discounts',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 11,
        glCode: 4500,
        accountId: '4936addc_@_6',
        name: 'Discounts and Comps',
        stats: {
          count: 35,
          min: -569.25,
          max: -24,
          stdDev: 144.71488319323845,
          median: -145,
          mean: -193.0337142857143,
          variance: 20942.39741763265,
          sum: -6756.18,
          boundaries: {
            threeStdDev: {
              lower: -627.1783638654297,
              upper: 241.11093529400105,
            },
            iqr: {
              q1: -275.75,
              q3: -81,
              lower: -567.875,
              upper: 211.125,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 12,
        glCode: null,
        accountId: '8a448d4b_@_7',
        name: 'Total Comps & Discounts',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 13,
        glCode: null,
        accountId: '3b5cefb1_@_8',
        name: 'NET SALES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 14,
        glCode: 5000,
        accountId: '753db221_@_9',
        name: 'COST OF GOODS SOLD (COGS)',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 15,
        glCode: 5100,
        accountId: '7a94d93b_@_9',
        name: 'COGS, Food',
        stats: {
          count: 2,
          min: 1089.11,
          max: 2301.75,
          stdDev: 606.32,
          median: 1695.4299999999998,
          mean: 1695.4299999999998,
          variance: 367623.94240000006,
          sum: 3390.8599999999997,
          boundaries: {
            threeStdDev: {
              lower: -123.5300000000002,
              upper: 3514.39,
            },
            iqr: {
              q1: 1089.11,
              q3: 2301.75,
              lower: -729.8500000000001,
              upper: 4120.71,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [304],
          anomalies: [
            {
              id: 304,
              amount: 210.91,
              description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
              category: 'Expense',
              accountId: '7a94d93b_@_9',
              name: 'Restaurant Depot',
              vendorId: 1,
              period: 1,
              txnDate: '2025-07-14',
              date: '2025-07-14T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15227',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 16,
        glCode: 5101,
        accountId: '3f46fcce_@_9',
        name: 'COGS, Meat & Poultry',
        stats: {
          count: 13,
          min: 88.76,
          max: 1822.14,
          stdDev: 475.4022674529522,
          median: 1435.21,
          mean: 1271.189230769231,
          variance: 226007.31589940828,
          sum: 16525.460000000003,
          boundaries: {
            threeStdDev: {
              lower: -155.0175715896255,
              upper: 2697.3960331280878,
            },
            iqr: {
              q1: 1083.72,
              q3: 1591.81,
              lower: 321.58500000000015,
              upper: 2353.9449999999997,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [319, 320, 322, 324, 325, 326, 328, 329, 330, 332, 333, 334, 335],
          anomalies: [
            {
              id: 319,
              amount: 1591.81,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15541',
              num: '9262981',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 320,
              amount: 1555.39,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 0,
              txnDate: '2025-07-25',
              date: '2025-07-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15564',
              num: '9265169',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 322,
              amount: 797.83,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 1,
              txnDate: '2025-07-14',
              date: '2025-07-14T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15207',
              num: '9255396',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 324,
              amount: 1822.14,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 1,
              txnDate: '2025-07-16',
              date: '2025-07-16T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15537',
              num: '9257563',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 325,
              amount: 1279.94,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 1,
              txnDate: '2025-07-18',
              date: '2025-07-18T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15566',
              num: '9259520',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 326,
              amount: 1139.64,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 2,
              txnDate: '2025-07-07',
              date: '2025-07-07T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14720',
              num: '9249995',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 328,
              amount: 1703.27,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14903',
              num: '9253029',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 329,
              amount: 88.76,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 2,
              txnDate: '2025-07-11',
              date: '2025-07-11T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14897',
              num: '9253030',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 330,
              amount: 1435.21,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 3,
              txnDate: '2025-07-02',
              date: '2025-07-02T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14714',
              num: '9247031',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 332,
              amount: 1585.2,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 3,
              txnDate: '2025-07-04',
              date: '2025-07-04T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14724',
              num: '9249000',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 333,
              amount: 1083.72,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 4,
              txnDate: '2025-06-23',
              date: '2025-06-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14561',
              num: '9239104',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 334,
              amount: 1700.37,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 4,
              txnDate: '2025-06-25',
              date: '2025-06-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14685',
              num: '9240751',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 335,
              amount: 742.18,
              description: '',
              category: 'Bill',
              accountId: '3f46fcce_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 4,
              txnDate: '2025-06-27',
              date: '2025-06-27T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14703',
              num: '9243481',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 17,
        glCode: 5102,
        accountId: '2bdeb0ad_@_9',
        name: 'COGS, Seafood',
        stats: {
          count: 11,
          min: 106.47,
          max: 351.7,
          stdDev: 68.3589886838907,
          median: 173.84,
          mean: 173.90454545454543,
          variance: 4672.951333884296,
          sum: 1912.9499999999998,
          boundaries: {
            threeStdDev: {
              lower: -31.17242059712669,
              upper: 378.98151150621754,
            },
            iqr: {
              q1: 113.12,
              q3: 181.2,
              lower: 11.000000000000028,
              upper: 283.31999999999994,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [337, 338, 340, 342, 343, 344, 346, 348, 349, 350, 351],
          anomalies: [
            {
              id: 337,
              amount: 181.2,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15541',
              num: '9262981',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 338,
              amount: 113.12,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 0,
              txnDate: '2025-07-25',
              date: '2025-07-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15564',
              num: '9265169',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 340,
              amount: 113.07,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 1,
              txnDate: '2025-07-14',
              date: '2025-07-14T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15207',
              num: '9255396',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 342,
              amount: 113.18,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 1,
              txnDate: '2025-07-16',
              date: '2025-07-16T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15537',
              num: '9257563',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 343,
              amount: 237.99,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 1,
              txnDate: '2025-07-18',
              date: '2025-07-18T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15566',
              num: '9259520',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 344,
              amount: 106.47,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 2,
              txnDate: '2025-07-07',
              date: '2025-07-07T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14720',
              num: '9249995',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 346,
              amount: 173.83,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14903',
              num: '9253029',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 348,
              amount: 173.84,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 3,
              txnDate: '2025-07-02',
              date: '2025-07-02T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14714',
              num: '9247031',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 349,
              amount: 173.89,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 3,
              txnDate: '2025-07-04',
              date: '2025-07-04T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14724',
              num: '9249000',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 350,
              amount: 174.66,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 4,
              txnDate: '2025-06-25',
              date: '2025-06-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14685',
              num: '9240751',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 351,
              amount: 351.7,
              description: '',
              category: 'Bill',
              accountId: '2bdeb0ad_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 4,
              txnDate: '2025-06-27',
              date: '2025-06-27T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14703',
              num: '9243481',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 18,
        glCode: 5103,
        accountId: '593c4b13_@_9',
        name: 'COGS, Produce',
        stats: {
          count: 4,
          min: 530.45,
          max: 1061.45,
          stdDev: 194.2282355889586,
          median: 704.45,
          mean: 750.2,
          variance: 37724.6075,
          sum: 3000.8,
          boundaries: {
            threeStdDev: {
              lower: 167.51529323312423,
              upper: 1332.8847067668758,
            },
            iqr: {
              q1: 676.65,
              q3: 1061.45,
              lower: 99.44999999999993,
              upper: 1638.65,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 19,
        glCode: 5104,
        accountId: 'e0037727_@_9',
        name: 'COGS, Grocery',
        stats: {
          count: 1,
          min: 57.41,
          max: 57.41,
          stdDev: 0,
          median: 57.41,
          mean: 57.41,
          variance: 0,
          sum: 57.41,
          boundaries: {
            threeStdDev: {
              lower: 57.41,
              upper: 57.41,
            },
            iqr: {
              q1: 57.41,
              q3: 57.41,
              lower: 57.41,
              upper: 57.41,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 20,
        glCode: 5105,
        accountId: '47294ea3_@_9',
        name: 'COGS, Bakery',
        stats: {
          count: 1,
          min: 1369.9,
          max: 1369.9,
          stdDev: 0,
          median: 1369.9,
          mean: 1369.9,
          variance: 0,
          sum: 1369.9,
          boundaries: {
            threeStdDev: {
              lower: 1369.9,
              upper: 1369.9,
            },
            iqr: {
              q1: 1369.9,
              q3: 1369.9,
              lower: 1369.9,
              upper: 1369.9,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 21,
        glCode: 5106,
        accountId: '841fc412_@_9',
        name: 'COGS, Dairy',
        stats: {
          count: 3,
          min: 71.8,
          max: 188.6,
          stdDev: 48.21876075646168,
          median: 115,
          mean: 125.13333333333333,
          variance: 2325.0488888888885,
          sum: 375.4,
          boundaries: {
            threeStdDev: {
              lower: -19.522948936051705,
              upper: 269.78961560271836,
            },
            iqr: {
              q1: 71.8,
              q3: 188.6,
              lower: -103.39999999999999,
              upper: 363.79999999999995,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 22,
        glCode: 5110,
        accountId: '6eb26171_@_9',
        name: 'COGS, Liquor',
        stats: {
          count: 1,
          min: 112,
          max: 112,
          stdDev: 0,
          median: 112,
          mean: 112,
          variance: 0,
          sum: 112,
          boundaries: {
            threeStdDev: {
              lower: 112,
              upper: 112,
            },
            iqr: {
              q1: 112,
              q3: 112,
              lower: 112,
              upper: 112,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [464, 466, 471, 481, 482],
          anomalies: [
            {
              id: 464,
              amount: 934.48,
              description: 'FEDWAY ASSOCIATE FEDWAY ASS',
              category: 'Expense',
              accountId: '6eb26171_@_9',
              name: 'Fedway',
              vendorId: 13,
              period: 0,
              txnDate: '2025-07-24',
              date: '2025-07-24T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15620',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 466,
              amount: 1000,
              description: 'POD CHECK',
              category: 'Check',
              accountId: '6eb26171_@_9',
              name: 'Fedway',
              vendorId: 13,
              period: 1,
              txnDate: '2025-07-18',
              date: '2025-07-18T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15512',
              num: '6502221',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 471,
              amount: 1000,
              description: 'CHECK 6502220',
              category: 'Check',
              accountId: '6eb26171_@_9',
              name: 'Fedway',
              vendorId: 13,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15406',
              num: '6502220',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 481,
              amount: 1000,
              description: 'POD CHECK #110620',
              category: 'Check',
              accountId: '6eb26171_@_9',
              name: 'Fedway',
              vendorId: 13,
              period: 3,
              txnDate: '2025-07-03',
              date: '2025-07-03T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15333',
              num: '6502200',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 482,
              amount: 1000,
              description: 'CHECK 6502093',
              category: 'Check',
              accountId: '6eb26171_@_9',
              name: 'Fedway',
              vendorId: 13,
              period: 4,
              txnDate: '2025-06-25',
              date: '2025-06-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14859',
              num: '6502093',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 23,
        glCode: 5111,
        accountId: '15101cdc_@_9',
        name: 'COGS, Bar Groceries',
        stats: {
          count: 1,
          min: 59,
          max: 59,
          stdDev: 0,
          median: 59,
          mean: 59,
          variance: 0,
          sum: 59,
          boundaries: {
            threeStdDev: {
              lower: 59,
              upper: 59,
            },
            iqr: {
              q1: 59,
              q3: 59,
              lower: 59,
              upper: 59,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 24,
        glCode: 5115,
        accountId: '90be8534_@_9',
        name: 'COGS, Beer',
        stats: {
          count: 1,
          min: 435.87,
          max: 435.87,
          stdDev: 0,
          median: 435.87,
          mean: 435.87,
          variance: 0,
          sum: 435.87,
          boundaries: {
            threeStdDev: {
              lower: 435.87,
              upper: 435.87,
            },
            iqr: {
              q1: 435.87,
              q3: 435.87,
              lower: 435.87,
              upper: 435.87,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 25,
        glCode: 5116,
        accountId: '3395a498_@_9',
        name: 'COGS, Draught Beer',
        stats: {
          count: 1,
          min: 549,
          max: 549,
          stdDev: 0,
          median: 549,
          mean: 549,
          variance: 0,
          sum: 549,
          boundaries: {
            threeStdDev: {
              lower: 549,
              upper: 549,
            },
            iqr: {
              q1: 549,
              q3: 549,
              lower: 549,
              upper: 549,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 26,
        glCode: 5117,
        accountId: 'e2c4f57e_@_9',
        name: 'COGS, Bottled Beer',
        stats: {
          count: 1,
          min: 52.6,
          max: 52.6,
          stdDev: 0,
          median: 52.6,
          mean: 52.6,
          variance: 0,
          sum: 52.6,
          boundaries: {
            threeStdDev: {
              lower: 52.6,
              upper: 52.6,
            },
            iqr: {
              q1: 52.6,
              q3: 52.6,
              lower: 52.6,
              upper: 52.6,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 27,
        glCode: 5120,
        accountId: 'b29ce542_@_9',
        name: 'COGS, Wine',
        stats: {
          count: 5,
          min: 462,
          max: 810,
          stdDev: 145.4923901240199,
          median: 720.12,
          mean: 665.4639999999999,
          variance: 21168.035583999997,
          sum: 3327.3199999999997,
          boundaries: {
            threeStdDev: {
              lower: 228.98682962794027,
              upper: 1101.9411703720596,
            },
            iqr: {
              q1: 525.2,
              q3: 810,
              lower: 98.00000000000011,
              upper: 1237.1999999999998,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [510, 512, 515, 517, 516],
          anomalies: [
            {
              id: 510,
              amount: 810,
              description: '',
              category: 'Bill',
              accountId: 'b29ce542_@_9',
              name: 'Gallo Wine Sales',
              vendorId: 19,
              period: 0,
              txnDate: '2025-07-25',
              date: '2025-07-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15550',
              num: '723293',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 512,
              amount: 525.2,
              description: '',
              category: 'Bill',
              accountId: 'b29ce542_@_9',
              name: 'Gallo Wine Sales',
              vendorId: 19,
              period: 1,
              txnDate: '2025-07-18',
              date: '2025-07-18T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15551',
              num: '714240',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 515,
              amount: 810,
              description: '',
              category: 'Bill',
              accountId: 'b29ce542_@_9',
              name: 'Gallo Wine Sales',
              vendorId: 19,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15206',
              num: '710320',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 517,
              amount: 462,
              description: '',
              category: 'Bill',
              accountId: 'b29ce542_@_9',
              name: 'Gallo Wine Sales',
              vendorId: 19,
              period: 3,
              txnDate: '2025-07-03',
              date: '2025-07-03T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14717',
              num: '707058',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 516,
              amount: 720.12,
              description: 'CHECK 6502116 703442',
              category: 'Check',
              accountId: 'b29ce542_@_9',
              name: 'Gallo Wine Sales',
              vendorId: 19,
              period: 3,
              txnDate: '2025-07-01',
              date: '2025-07-01T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15277',
              num: '6502116',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 28,
        glCode: 5125,
        accountId: '9f08e50d_@_9',
        name: 'COGS, Non-Alcoholic',
        stats: {
          count: 1,
          min: 157.9,
          max: 157.9,
          stdDev: 0,
          median: 157.9,
          mean: 157.9,
          variance: 0,
          sum: 157.9,
          boundaries: {
            threeStdDev: {
              lower: 157.9,
              upper: 157.9,
            },
            iqr: {
              q1: 157.9,
              q3: 157.9,
              lower: 157.9,
              upper: 157.9,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 29,
        glCode: 5135,
        accountId: '027a424d_@_9',
        name: 'COGS, Packaging',
        stats: {
          count: 10,
          min: 44.57,
          max: 307.14,
          stdDev: 70.57937463593737,
          median: 116.05499999999999,
          mean: 129.836,
          variance: 4981.448124,
          sum: 1298.3600000000001,
          boundaries: {
            threeStdDev: {
              lower: -81.9021239078121,
              upper: 341.5741239078121,
            },
            iqr: {
              q1: 94.73,
              q3: 138.65,
              lower: 28.85000000000001,
              upper: 204.53,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [542],
          anomalies: [
            {
              id: 542,
              amount: 129.66,
              description: '',
              category: 'Bill',
              accountId: '027a424d_@_9',
              name: 'Performance Food Service',
              vendorId: 4,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15541',
              num: '9262981',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 30,
        glCode: 5195,
        accountId: 'dfae81d5_@_9',
        name: 'Shipping, Freight and Delivery',
        stats: {
          count: 1,
          min: 387.04,
          max: 387.04,
          stdDev: 0,
          median: 387.04,
          mean: 387.04,
          variance: 0,
          sum: 387.04,
          boundaries: {
            threeStdDev: {
              lower: 387.04,
              upper: 387.04,
            },
            iqr: {
              q1: 387.04,
              q3: 387.04,
              lower: 387.04,
              upper: 387.04,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 31,
        glCode: null,
        accountId: '528a97f9_@_10',
        name: 'TOTAL COGS',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 32,
        glCode: null,
        accountId: '7b400e74_@_12',
        name: 'GROSS PROFIT',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 33,
        glCode: null,
        accountId: '39d9c4d4_@_13',
        name: 'OPERATING EXPENSES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 34,
        glCode: 6000,
        accountId: '5b0fe671_@_14',
        name: 'LABOR',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 35,
        glCode: 5200,
        accountId: 'bb2363da_@_14',
        name: 'Direct Labor',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 36,
        glCode: 5205,
        accountId: '687f4cd2_@_14',
        name: 'Labor Other',
        stats: {
          count: 1,
          min: 703.44,
          max: 703.44,
          stdDev: 0,
          median: 703.44,
          mean: 703.44,
          variance: 0,
          sum: 703.44,
          boundaries: {
            threeStdDev: {
              lower: 703.44,
              upper: 703.44,
            },
            iqr: {
              q1: 703.44,
              q3: 703.44,
              lower: 703.44,
              upper: 703.44,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 37,
        glCode: 5210,
        accountId: '529343c4_@_14',
        name: 'Labor, Management',
        stats: {
          count: 5,
          min: 1620,
          max: 6486.95,
          stdDev: 1743.1266114657303,
          median: 2244.1,
          mean: 3210.0299999999997,
          variance: 3038490.3835999994,
          sum: 16050.15,
          boundaries: {
            threeStdDev: {
              lower: -2019.3498343971914,
              upper: 8439.409834397191,
            },
            iqr: {
              q1: 2244.1,
              q3: 3455,
              lower: 427.7499999999998,
              upper: 5271.35,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [703, 704, 705, 706, 707],
          anomalies: [
            {
              id: 703,
              amount: 2244.1,
              description: 'Management',
              category: 'Journal Entry',
              accountId: '529343c4_@_14',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-27',
              date: '2025-07-27T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 704,
              amount: 6486.95,
              description: 'Management',
              category: 'Journal Entry',
              accountId: '529343c4_@_14',
              name: '',
              vendorId: 0,
              period: 1,
              txnDate: '2025-07-20',
              date: '2025-07-20T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 705,
              amount: 2244.1,
              description: 'Management',
              category: 'Journal Entry',
              accountId: '529343c4_@_14',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-13',
              date: '2025-07-13T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 706,
              amount: 3455,
              description: 'Management',
              category: 'Journal Entry',
              accountId: '529343c4_@_14',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-06',
              date: '2025-07-06T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 707,
              amount: 1620,
              description: 'Management',
              category: 'Journal Entry',
              accountId: '529343c4_@_14',
              name: '',
              vendorId: 0,
              period: 4,
              txnDate: '2025-06-29',
              date: '2025-06-29T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 38,
        glCode: 5215,
        accountId: '3c61733f_@_14',
        name: 'Labor, BOH',
        stats: {
          count: 5,
          min: 1711.54,
          max: 5121.55,
          stdDev: 1364.0040000000001,
          median: 1711.54,
          mean: 2393.5420000000004,
          variance: 1860506.9120160001,
          sum: 11967.710000000003,
          boundaries: {
            threeStdDev: {
              lower: -1698.4700000000003,
              upper: 6485.554000000001,
            },
            iqr: {
              q1: 1711.54,
              q3: 1711.54,
              lower: 1711.54,
              upper: 1711.54,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [708, 709, 710, 711, 712],
          anomalies: [
            {
              id: 708,
              amount: 1711.54,
              description: 'BOH',
              category: 'Journal Entry',
              accountId: '3c61733f_@_14',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-27',
              date: '2025-07-27T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 709,
              amount: 5121.55,
              description: 'BOH',
              category: 'Journal Entry',
              accountId: '3c61733f_@_14',
              name: '',
              vendorId: 0,
              period: 1,
              txnDate: '2025-07-20',
              date: '2025-07-20T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 710,
              amount: 1711.54,
              description: 'BOH',
              category: 'Journal Entry',
              accountId: '3c61733f_@_14',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-13',
              date: '2025-07-13T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 711,
              amount: 1711.54,
              description: 'BOH',
              category: 'Journal Entry',
              accountId: '3c61733f_@_14',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-06',
              date: '2025-07-06T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 712,
              amount: 1711.54,
              description: 'BOH',
              category: 'Journal Entry',
              accountId: '3c61733f_@_14',
              name: '',
              vendorId: 0,
              period: 4,
              txnDate: '2025-06-29',
              date: '2025-06-29T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 39,
        glCode: null,
        accountId: '143a84db_@_14',
        name: 'Total Direct Labor',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 40,
        glCode: 5300,
        accountId: 'dacf6533_@_14',
        name: 'Labor Related Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 41,
        glCode: 5310,
        accountId: '7a82e4de_@_14',
        name: 'Commission/Bonus/Incentives',
        stats: {
          count: 2,
          min: 268,
          max: 271,
          stdDev: 1.5,
          median: 269.5,
          mean: 269.5,
          variance: 2.25,
          sum: 539,
          boundaries: {
            threeStdDev: {
              lower: 265,
              upper: 274,
            },
            iqr: {
              q1: 268,
              q3: 271,
              lower: 263.5,
              upper: 275.5,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 42,
        glCode: 5315,
        accountId: 'bbc14e9c_@_14',
        name: 'Payroll Taxes',
        stats: {
          count: 1,
          min: -1269.59,
          max: -1269.59,
          stdDev: 0,
          median: -1269.59,
          mean: -1269.59,
          variance: 0,
          sum: -1269.59,
          boundaries: {
            threeStdDev: {
              lower: -1269.59,
              upper: -1269.59,
            },
            iqr: {
              q1: -1269.59,
              q3: -1269.59,
              lower: -1269.59,
              upper: -1269.59,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [716, 717, 718, 719, 720],
          anomalies: [
            {
              id: 716,
              amount: 480.77,
              description: 'PR Tax',
              category: 'Journal Entry',
              accountId: 'bbc14e9c_@_14',
              name: '',
              vendorId: 0,
              period: 0,
              txnDate: '2025-07-27',
              date: '2025-07-27T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15635',
              num: 'Payroll Accrual 07.27',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 717,
              amount: 2993.1,
              description: 'PR Tax',
              category: 'Journal Entry',
              accountId: 'bbc14e9c_@_14',
              name: '',
              vendorId: 0,
              period: 1,
              txnDate: '2025-07-20',
              date: '2025-07-20T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15355',
              num: 'Payroll Accrual 07.20',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 718,
              amount: 480.77,
              description: 'PR Tax',
              category: 'Journal Entry',
              accountId: 'bbc14e9c_@_14',
              name: '',
              vendorId: 0,
              period: 2,
              txnDate: '2025-07-13',
              date: '2025-07-13T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15628',
              num: 'PR 07.07. to 07.13',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 719,
              amount: 475,
              description: 'PR Tax',
              category: 'Journal Entry',
              accountId: 'bbc14e9c_@_14',
              name: '',
              vendorId: 0,
              period: 3,
              txnDate: '2025-07-06',
              date: '2025-07-06T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15268',
              num: 'PR 06.30 to 07.06',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 720,
              amount: 238.76,
              description: 'PR Tax',
              category: 'Journal Entry',
              accountId: 'bbc14e9c_@_14',
              name: '',
              vendorId: 0,
              period: 4,
              txnDate: '2025-06-29',
              date: '2025-06-29T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15265',
              num: 'PR 06.23 to 06.29',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 43,
        glCode: 5340,
        accountId: '416bc276_@_14',
        name: 'Employee Meals',
        stats: {
          count: 1,
          min: 774,
          max: 774,
          stdDev: 0,
          median: 774,
          mean: 774,
          variance: 0,
          sum: 774,
          boundaries: {
            threeStdDev: {
              lower: 774,
              upper: 774,
            },
            iqr: {
              q1: 774,
              q3: 774,
              lower: 774,
              upper: 774,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 44,
        glCode: 5345,
        accountId: 'c12aec10_@_14',
        name: 'Recruiting',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 45,
        glCode: null,
        accountId: '1e9ad256_@_14',
        name: 'Total Labor Related Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 46,
        glCode: null,
        accountId: 'd0736ae7_@_15',
        name: 'TOTAL LABOR',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 47,
        glCode: null,
        accountId: 'b7d061ce_@_16',
        name: 'PRIME COST',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 48,
        glCode: null,
        accountId: '2f5a4d68_@_17',
        name: 'Contribution Margin',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 49,
        glCode: 7000,
        accountId: '2cd659af_@_18',
        name: 'CONTROLLABLE EXPENSES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 50,
        glCode: 6100,
        accountId: '3be3d09b_@_18',
        name: 'Direct Operating Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 51,
        glCode: 6110,
        accountId: '1a6a3f76_@_18',
        name: 'Equipment Lease Rental',
        stats: {
          count: 1,
          min: 155,
          max: 155,
          stdDev: 0,
          median: 155,
          mean: 155,
          variance: 0,
          sum: 155,
          boundaries: {
            threeStdDev: {
              lower: 155,
              upper: 155,
            },
            iqr: {
              q1: 155,
              q3: 155,
              lower: 155,
              upper: 155,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 52,
        glCode: 6115,
        accountId: '514ec7ed_@_18',
        name: 'Cleaning Supplies',
        stats: {
          count: 1,
          min: 83.48,
          max: 83.48,
          stdDev: 0,
          median: 83.48,
          mean: 83.48,
          variance: 0,
          sum: 83.48,
          boundaries: {
            threeStdDev: {
              lower: 83.48,
              upper: 83.48,
            },
            iqr: {
              q1: 83.48,
              q3: 83.48,
              lower: 83.48,
              upper: 83.48,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 53,
        glCode: 6120,
        accountId: '758ae475_@_18',
        name: 'Cleaning Services',
        stats: {
          count: 1,
          min: 1044.92,
          max: 1044.92,
          stdDev: 0,
          median: 1044.92,
          mean: 1044.92,
          variance: 0,
          sum: 1044.92,
          boundaries: {
            threeStdDev: {
              lower: 1044.92,
              upper: 1044.92,
            },
            iqr: {
              q1: 1044.92,
              q3: 1044.92,
              lower: 1044.92,
              upper: 1044.92,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 54,
        glCode: 6125,
        accountId: '28a2ce1f_@_18',
        name: 'Restaurant Supplies',
        stats: {
          count: 3,
          min: 59.9,
          max: 119.8,
          stdDev: 28.237130795382797,
          median: 119.8,
          mean: 99.83333333333333,
          variance: 797.3355555555555,
          sum: 299.5,
          boundaries: {
            threeStdDev: {
              lower: 15.121940947184939,
              upper: 184.54472571948173,
            },
            iqr: {
              q1: 59.9,
              q3: 119.8,
              lower: -29.949999999999996,
              upper: 209.64999999999998,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 55,
        glCode: 6135,
        accountId: 'ad6ac922_@_18',
        name: 'Laundry, Linens, & Uniforms',
        stats: {
          count: 1,
          min: 1954.31,
          max: 1954.31,
          stdDev: 0,
          median: 1954.31,
          mean: 1954.31,
          variance: 0,
          sum: 1954.31,
          boundaries: {
            threeStdDev: {
              lower: 1954.31,
              upper: 1954.31,
            },
            iqr: {
              q1: 1954.31,
              q3: 1954.31,
              lower: 1954.31,
              upper: 1954.31,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 56,
        glCode: 6155,
        accountId: '9f991141_@_18',
        name: 'Kitchen/ Bar Smallwares',
        stats: {
          count: 3,
          min: 420.12,
          max: 631.25,
          stdDev: 86.766290049125,
          median: 546.8,
          mean: 532.7233333333334,
          variance: 7528.389088888888,
          sum: 1598.17,
          boundaries: {
            threeStdDev: {
              lower: 272.42446318595836,
              upper: 793.0222034807084,
            },
            iqr: {
              q1: 420.12,
              q3: 631.25,
              lower: 103.42500000000001,
              upper: 947.9449999999999,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 57,
        glCode: null,
        accountId: 'b7f8c8b8_@_18',
        name: 'Total Direct Operating Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 58,
        glCode: 6200,
        accountId: '9d0fd7d1_@_18',
        name: 'Transaction Related Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 59,
        glCode: 6215,
        accountId: '47bbbb15_@_18',
        name: '3rd Party Commissions',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 60,
        glCode: null,
        accountId: 'd484c66b_@_18',
        name: 'Total Transaction Related Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 61,
        glCode: 6250,
        accountId: 'edd65db2_@_18',
        name: 'Marketing & Advertising',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 62,
        glCode: 6255,
        accountId: 'c61b398a_@_18',
        name: 'Marketing & Public Relations',
        stats: {
          count: 2,
          min: -89,
          max: 89,
          stdDev: 89,
          median: 0,
          mean: 0,
          variance: 7921,
          sum: 0,
          boundaries: {
            threeStdDev: {
              lower: -267,
              upper: 267,
            },
            iqr: {
              q1: -89,
              q3: 89,
              lower: -356,
              upper: 356,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 63,
        glCode: 6260,
        accountId: '1dc3b3a3_@_18',
        name: 'Advertising & Promotions',
        stats: {
          count: 3,
          min: 237.79,
          max: 522.99,
          stdDev: 117.31563351346941,
          median: 349.91,
          mean: 370.23,
          variance: 13762.957866666666,
          sum: 1110.69,
          boundaries: {
            threeStdDev: {
              lower: 18.283099459591767,
              upper: 722.1769005404083,
            },
            iqr: {
              q1: 237.79,
              q3: 522.99,
              lower: -190.01000000000008,
              upper: 950.7900000000001,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 64,
        glCode: null,
        accountId: '024ba9eb_@_18',
        name: 'Total Marketing & Advertising',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 65,
        glCode: 6305,
        accountId: '0c83dbac_@_18',
        name: 'Music & DJ',
        stats: {
          count: 1,
          min: 500,
          max: 500,
          stdDev: 0,
          median: 500,
          mean: 500,
          variance: 0,
          sum: 500,
          boundaries: {
            threeStdDev: {
              lower: 500,
              upper: 500,
            },
            iqr: {
              q1: 500,
              q3: 500,
              lower: 500,
              upper: 500,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 66,
        glCode: 6500,
        accountId: '6f7c6ca5_@_18',
        name: 'General & Administrative Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 67,
        glCode: 6505,
        accountId: '5a0fedcf_@_18',
        name: 'Accounting & Bookkeeping',
        stats: {
          count: 1,
          min: 1499,
          max: 1499,
          stdDev: 0,
          median: 1499,
          mean: 1499,
          variance: 0,
          sum: 1499,
          boundaries: {
            threeStdDev: {
              lower: 1499,
              upper: 1499,
            },
            iqr: {
              q1: 1499,
              q3: 1499,
              lower: 1499,
              upper: 1499,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 68,
        glCode: 6510,
        accountId: 'b08821c2_@_18',
        name: 'Consulting',
        stats: {
          count: 1,
          min: 1250,
          max: 1250,
          stdDev: 0,
          median: 1250,
          mean: 1250,
          variance: 0,
          sum: 1250,
          boundaries: {
            threeStdDev: {
              lower: 1250,
              upper: 1250,
            },
            iqr: {
              q1: 1250,
              q3: 1250,
              lower: 1250,
              upper: 1250,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 69,
        glCode: 6520,
        accountId: 'a630ac37_@_18',
        name: 'Legal',
        stats: {
          count: 2,
          min: 1806.54,
          max: 2500,
          stdDev: 346.73,
          median: 2153.27,
          mean: 2153.27,
          variance: 120221.69290000001,
          sum: 4306.54,
          boundaries: {
            threeStdDev: {
              lower: 1113.08,
              upper: 3193.46,
            },
            iqr: {
              q1: 1806.54,
              q3: 2500,
              lower: 766.3499999999999,
              upper: 3540.19,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 70,
        glCode: 6525,
        accountId: '975961bc_@_18',
        name: 'Payroll Processing Fees',
        stats: {
          count: 1,
          min: 92.53,
          max: 92.53,
          stdDev: 0,
          median: 92.53,
          mean: 92.53,
          variance: 0,
          sum: 92.53,
          boundaries: {
            threeStdDev: {
              lower: 92.53,
              upper: 92.53,
            },
            iqr: {
              q1: 92.53,
              q3: 92.53,
              lower: 92.53,
              upper: 92.53,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 71,
        glCode: 6535,
        accountId: '9450bb96_@_18',
        name: 'Computer Supplies, Software & IT',
        stats: {
          count: 1,
          min: 110,
          max: 110,
          stdDev: 0,
          median: 110,
          mean: 110,
          variance: 0,
          sum: 110,
          boundaries: {
            threeStdDev: {
              lower: 110,
              upper: 110,
            },
            iqr: {
              q1: 110,
              q3: 110,
              lower: 110,
              upper: 110,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 72,
        glCode: 6550,
        accountId: '236c5723_@_18',
        name: 'Dues and Subscriptions',
        stats: {
          count: 1,
          min: 114.36,
          max: 114.36,
          stdDev: 0,
          median: 114.36,
          mean: 114.36,
          variance: 0,
          sum: 114.36,
          boundaries: {
            threeStdDev: {
              lower: 114.36,
              upper: 114.36,
            },
            iqr: {
              q1: 114.36,
              q3: 114.36,
              lower: 114.36,
              upper: 114.36,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 73,
        glCode: 6560,
        accountId: 'c3c23383_@_18',
        name: 'Bank Charges & Fees',
        stats: {
          count: 8,
          min: 20,
          max: 30,
          stdDev: 3.307189138830738,
          median: 30,
          mean: 28.75,
          variance: 10.9375,
          sum: 230,
          boundaries: {
            threeStdDev: {
              lower: 18.828432583507784,
              upper: 38.671567416492216,
            },
            iqr: {
              q1: 30,
              q3: 30,
              lower: 30,
              upper: 30,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [785, 785, 786, 787, 788, 789, 790, 792, 791],
          anomalies: [
            {
              id: 785,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 0,
              txnDate: '2025-07-22',
              date: '2025-07-22T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15609',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 785,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 0,
              txnDate: '2025-07-22',
              date: '2025-07-22T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15609',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 786,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15610',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 787,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15611',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 788,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 2,
              txnDate: '2025-07-07',
              date: '2025-07-07T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14767',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 789,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 2,
              txnDate: '2025-07-07',
              date: '2025-07-07T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14768',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 790,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 2,
              txnDate: '2025-07-07',
              date: '2025-07-07T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14769',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 792,
              amount: 30,
              description: 'WIRE TRANSFER FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 3,
              txnDate: '2025-07-02',
              date: '2025-07-02T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14766',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 791,
              amount: 20,
              description: 'MAINTENANCE FEE',
              category: 'Expense',
              accountId: 'c3c23383_@_18',
              name: 'Bank Charges',
              vendorId: 100,
              period: 3,
              txnDate: '2025-06-30',
              date: '2025-06-30T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15203',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 74,
        glCode: 6575,
        accountId: '058d9b25_@_18',
        name: 'Office Supplies & Expenses',
        stats: {
          count: 2,
          min: 66.02,
          max: 127.91,
          stdDev: 30.945,
          median: 96.965,
          mean: 96.965,
          variance: 957.593025,
          sum: 193.93,
          boundaries: {
            threeStdDev: {
              lower: 4.1299999999999955,
              upper: 189.8,
            },
            iqr: {
              q1: 66.02,
              q3: 127.91,
              lower: -26.815000000000012,
              upper: 220.745,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [815, 804],
          anomalies: [
            {
              id: 815,
              amount: 19.18,
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              category: 'Expense',
              accountId: '058d9b25_@_18',
              name: 'Amazon',
              vendorId: 101,
              period: 2,
              txnDate: '2025-07-07',
              date: '2025-07-07T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14730',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 804,
              amount: 122.46,
              description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
              category: 'Expense',
              accountId: '058d9b25_@_18',
              name: 'Amazon',
              vendorId: 101,
              period: 1,
              txnDate: '2025-07-14',
              date: '2025-07-14T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15225',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 75,
        glCode: 6605,
        accountId: '0c2b505e_@_18',
        name: 'Phone and Internet',
        stats: {
          count: 1,
          min: 334.99,
          max: 334.99,
          stdDev: 0,
          median: 334.99,
          mean: 334.99,
          variance: 0,
          sum: 334.99,
          boundaries: {
            threeStdDev: {
              lower: 334.99,
              upper: 334.99,
            },
            iqr: {
              q1: 334.99,
              q3: 334.99,
              lower: 334.99,
              upper: 334.99,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 76,
        glCode: 6610,
        accountId: '9dc533d9_@_18',
        name: 'Security',
        stats: {
          count: 1,
          min: 950,
          max: 950,
          stdDev: 0,
          median: 950,
          mean: 950,
          variance: 0,
          sum: 950,
          boundaries: {
            threeStdDev: {
              lower: 950,
              upper: 950,
            },
            iqr: {
              q1: 950,
              q3: 950,
              lower: 950,
              upper: 950,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 77,
        glCode: null,
        accountId: 'f12db2ec_@_18',
        name: 'Total General & Administrative Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 78,
        glCode: 6700,
        accountId: '084f517c_@_18',
        name: 'Travel, Meals, & Entertainment',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 79,
        glCode: 6705,
        accountId: 'e4e1ab18_@_18',
        name: 'Travel, Ground Transport & Airfare',
        stats: {
          count: 16,
          min: 49.02,
          max: 81.87,
          stdDev: 10.35338403313139,
          median: 55.17,
          mean: 59.48125,
          variance: 107.1925609375,
          sum: 951.7,
          boundaries: {
            threeStdDev: {
              lower: 28.421097900605837,
              upper: 90.54140209939416,
            },
            iqr: {
              q1: 52.21,
              q3: 68.96,
              lower: 27.08500000000001,
              upper: 94.08499999999998,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [845, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852],
          anomalies: [
            {
              id: 845,
              amount: 74.9,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15243',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 837,
              amount: 60.9,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15606',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 838,
              amount: 81.87,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 0,
              txnDate: '2025-07-23',
              date: '2025-07-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15607',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 839,
              amount: 52.21,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 0,
              txnDate: '2025-07-24',
              date: '2025-07-24T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15603',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 840,
              amount: 54.38,
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 0,
              txnDate: '2025-07-24',
              date: '2025-07-24T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15605',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 841,
              amount: 50.67,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 0,
              txnDate: '2025-07-25',
              date: '2025-07-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15604',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 842,
              amount: 55.09,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 0,
              txnDate: '2025-07-25',
              date: '2025-07-25T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15608',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 843,
              amount: 50.7,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 1,
              txnDate: '2025-07-16',
              date: '2025-07-16T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15219',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 844,
              amount: 55.25,
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 1,
              txnDate: '2025-07-16',
              date: '2025-07-16T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15264',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 845,
              amount: 74.9,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15243',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 846,
              amount: 54.38,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 2,
              txnDate: '2025-07-10',
              date: '2025-07-10T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15246',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 847,
              amount: 56.72,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 2,
              txnDate: '2025-07-11',
              date: '2025-07-11T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15239',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 848,
              amount: 49.02,
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 2,
              txnDate: '2025-07-11',
              date: '2025-07-11T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '15263',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 849,
              amount: 79.12,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 3,
              txnDate: '2025-07-02',
              date: '2025-07-02T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14764',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 850,
              amount: 68.96,
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 4,
              txnDate: '2025-06-23',
              date: '2025-06-23T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14581',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 851,
              amount: 50.66,
              description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 4,
              txnDate: '2025-06-26',
              date: '2025-06-26T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14765',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
            {
              id: 852,
              amount: 56.87,
              description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
              category: 'Expense',
              accountId: 'e4e1ab18_@_18',
              name: 'Uber Trips',
              vendorId: 108,
              period: 4,
              txnDate: '2025-06-26',
              date: '2025-06-26T00:00:00.000Z',
              dueDate: '',
              pastDue: 0,
              eventId: '14841',
              num: '',
              notes: '',
              audit: {
                status: 'Normal',
                amount: 0,
                reason: '',
              },
            },
          ],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 80,
        glCode: 6710,
        accountId: 'f245aeff_@_18',
        name: 'Meals & Entertainment',
        stats: {
          count: 1,
          min: 800,
          max: 800,
          stdDev: 0,
          median: 800,
          mean: 800,
          variance: 0,
          sum: 800,
          boundaries: {
            threeStdDev: {
              lower: 800,
              upper: 800,
            },
            iqr: {
              q1: 800,
              q3: 800,
              lower: 800,
              upper: 800,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 81,
        glCode: 6720,
        accountId: '3ae4b332_@_18',
        name: 'Parking',
        stats: {
          count: 2,
          min: 1238,
          max: 1238,
          stdDev: 0,
          median: 1238,
          mean: 1238,
          variance: 0,
          sum: 2476,
          boundaries: {
            threeStdDev: {
              lower: 1238,
              upper: 1238,
            },
            iqr: {
              q1: 1238,
              q3: 1238,
              lower: 1238,
              upper: 1238,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 82,
        glCode: 6725,
        accountId: '4dbd49a9_@_18',
        name: 'Fuel',
        stats: {
          count: 5,
          min: 27.01,
          max: 36.01,
          stdDev: 3.368172204623747,
          median: 34.01,
          mean: 32.426,
          variance: 11.344583999999992,
          sum: 162.13,
          boundaries: {
            threeStdDev: {
              lower: 22.32148338612876,
              upper: 42.53051661387124,
            },
            iqr: {
              q1: 30.1,
              q3: 35,
              lower: 22.750000000000004,
              upper: 42.349999999999994,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 83,
        glCode: null,
        accountId: 'ea7ffa49_@_18',
        name: 'Total Travel, Meals, & Entertainment',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 84,
        glCode: 6800,
        accountId: '1675dbe8_@_18',
        name: 'Repairs & Maintenance',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 85,
        glCode: 6810,
        accountId: 'aa06968c_@_18',
        name: 'Repair & Maintenance, Equipment',
        stats: {
          count: 1,
          min: 411.6,
          max: 411.6,
          stdDev: 0,
          median: 411.6,
          mean: 411.6,
          variance: 0,
          sum: 411.6,
          boundaries: {
            threeStdDev: {
              lower: 411.6,
              upper: 411.6,
            },
            iqr: {
              q1: 411.6,
              q3: 411.6,
              lower: 411.6,
              upper: 411.6,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 86,
        glCode: 6815,
        accountId: '4d40af10_@_18',
        name: 'Repair & Maintenance, Facility',
        stats: {
          count: 1,
          min: 250,
          max: 250,
          stdDev: 0,
          median: 250,
          mean: 250,
          variance: 0,
          sum: 250,
          boundaries: {
            threeStdDev: {
              lower: 250,
              upper: 250,
            },
            iqr: {
              q1: 250,
              q3: 250,
              lower: 250,
              upper: 250,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 87,
        glCode: 6820,
        accountId: 'a044faba_@_18',
        name: 'Pest Control',
        stats: {
          count: 3,
          min: 505.49,
          max: 631.86,
          stdDev: 55.46684475131668,
          median: 525.46,
          mean: 554.27,
          variance: 3076.5708666666665,
          sum: 1662.81,
          boundaries: {
            threeStdDev: {
              lower: 387.86946574604997,
              upper: 720.67053425395,
            },
            iqr: {
              q1: 505.49,
              q3: 631.86,
              lower: 315.935,
              upper: 821.415,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 88,
        glCode: 6825,
        accountId: 'd6450b86_@_18',
        name: 'Fire Control',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 89,
        glCode: null,
        accountId: '4da1092f_@_18',
        name: 'Total Repairs & Maintenance',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 90,
        glCode: null,
        accountId: 'a624f257_@_19',
        name: 'TOTAL CONTROLLABLE EXPENSES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 91,
        glCode: null,
        accountId: 'a973b710_@_20',
        name: 'Controllable Profit',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 92,
        glCode: 8000,
        accountId: '79208dfc_@_21',
        name: 'NON-CONTROLLABLE EXPENSES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 93,
        glCode: 7100,
        accountId: '52e26b6b_@_21',
        name: 'Property Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 94,
        glCode: 7105,
        accountId: '68876c4f_@_21',
        name: 'Rent/Lease',
        stats: {
          count: 1,
          min: 18437.33,
          max: 18437.33,
          stdDev: 0,
          median: 18437.33,
          mean: 18437.33,
          variance: 0,
          sum: 18437.33,
          boundaries: {
            threeStdDev: {
              lower: 18437.33,
              upper: 18437.33,
            },
            iqr: {
              q1: 18437.33,
              q3: 18437.33,
              lower: 18437.33,
              upper: 18437.33,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 95,
        glCode: 7125,
        accountId: '208dfabc_@_21',
        name: 'Utility, Electricity',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 96,
        glCode: 7130,
        accountId: 'c9446d9c_@_21',
        name: 'Utility, Gas',
        stats: {
          count: 1,
          min: 430.96,
          max: 430.96,
          stdDev: 0,
          median: 430.96,
          mean: 430.96,
          variance: 0,
          sum: 430.96,
          boundaries: {
            threeStdDev: {
              lower: 430.96,
              upper: 430.96,
            },
            iqr: {
              q1: 430.96,
              q3: 430.96,
              lower: 430.96,
              upper: 430.96,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 97,
        glCode: null,
        accountId: '20d5762f_@_21',
        name: 'Total Property Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 98,
        glCode: 8100,
        accountId: '763b7c77_@_21',
        name: 'Other Income and Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 99,
        glCode: 8130,
        accountId: '91f38f9a_@_21',
        name: 'Other Income/Expenses',
        stats: {
          count: 1,
          min: -1.01,
          max: -1.01,
          stdDev: 0,
          median: -1.01,
          mean: -1.01,
          variance: 0,
          sum: -1.01,
          boundaries: {
            threeStdDev: {
              lower: -1.01,
              upper: -1.01,
            },
            iqr: {
              q1: -1.01,
              q3: -1.01,
              lower: -1.01,
              upper: -1.01,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 100,
        glCode: 9999,
        accountId: '5ccef3e9_@_21',
        name: 'To Be Classified P&L',
        stats: {
          count: 1,
          min: 1448.63,
          max: 1448.63,
          stdDev: 0,
          median: 1448.63,
          mean: 1448.63,
          variance: 0,
          sum: 1448.63,
          boundaries: {
            threeStdDev: {
              lower: 1448.63,
              upper: 1448.63,
            },
            iqr: {
              q1: 1448.63,
              q3: 1448.63,
              lower: 1448.63,
              upper: 1448.63,
            },
          },
        },
        auditedTransactions: {
          outlierIds: [],
          outliers: [],
          anomalyIds: [],
          anomalies: [],
          flaggedTransactions: [],
          flaggedIds: [],
          periodicityPatterns: {},
        },
      },
      {
        id: 101,
        glCode: null,
        accountId: 'd4b5a9af_@_21',
        name: 'Total Other Income and Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 102,
        glCode: null,
        accountId: '1851dc59_@_22',
        name: 'TOTAL NON-CONTROLLABLE EXPENSES',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 103,
        glCode: null,
        accountId: '251b8ac6_@_23',
        name: 'Operating Profit',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 104,
        glCode: null,
        accountId: '5e10c38d_@_24',
        name: 'Other Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 105,
        glCode: 8205,
        accountId: '13e3a076_@_24',
        name: 'Loan Interest',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 106,
        glCode: null,
        accountId: 'caeb87a7_@_25',
        name: 'Total Other Expenses',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 107,
        glCode: null,
        accountId: 'e815a21e_@_26',
        name: 'EBITDA',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 108,
        glCode: null,
        accountId: '644555ee_@_27',
        name: 'Interest, Taxes, Depreciation and Amortization',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 109,
        glCode: 8205,
        accountId: 'dce93088_@_27',
        name: 'Loan Interest',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 110,
        glCode: null,
        accountId: 'b4184eff_@_28',
        name: 'Total Interest, Taxes, Depreciation and Amortization',
        stats: null,
        auditedTransactions: null,
      },
      {
        id: 111,
        glCode: null,
        accountId: '9b50fa7c_@_29',
        name: 'NET PROFIT',
        stats: null,
        auditedTransactions: null,
      },
    ],
    auditedTransactions: {
      outlierIds: [138, 793],
      outliers: [
        {
          id: 138,
          amount: 1482,
          description: '',
          category: 'Journal Entry',
          accountId: 'ba0b0910_@_2',
          name: '',
          vendorId: 0,
          period: 4,
          txnDate: '2025-06-28',
          date: '2025-06-28T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14686',
          num: 'MJ1774ME',
          notes: '',
          audit: {
            status: 'Outlier',
            amount: 1482,
            reason: 'Amount ($1,482.00) is outside the range of -629.94 to 1,419.19\n      ($394.63 +/- 3 * 341.52)',
            priority: 'low',
            confidence: 41.15435999844536,
          },
        },
        {
          id: 793,
          amount: 1086.51,
          description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
          category: 'Expense',
          accountId: '058d9b25_@_18',
          name: 'Amazon',
          vendorId: 101,
          period: 0,
          txnDate: '2025-07-21',
          date: '2025-07-21T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15517',
          num: '',
          notes: '',
          audit: {
            status: 'Outlier',
            amount: 1086.51,
            reason: 'Amount ($1,086.51) is outside the range of -515.34 to 687.12\n      ($85.89 +/- 3 * 200.41)',
            priority: 'high',
            confidence: 70,
          },
        },
      ],
      anomalyIds: [
        22, 211, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 224, 225, 226, 227, 223, 228, 229, 472,
        473, 474, 475, 476, 477, 479, 703, 704, 705, 706, 707, 708, 709, 710, 711, 712, 716, 717, 718, 719, 720, 304,
        374, 352, 352, 353, 354, 355, 356, 358, 359, 362, 363, 364, 365, 366, 367, 368, 369, 370, 372, 374, 376, 377,
        379, 380, 384, 382, 319, 320, 322, 324, 325, 326, 328, 329, 330, 332, 333, 334, 335, 337, 338, 340, 342, 343,
        344, 346, 348, 349, 350, 351, 416, 391, 391, 392, 397, 398, 400, 403, 404, 405, 408, 409, 412, 414, 416, 419,
        421, 423, 424, 425, 542, 357, 357, 360, 373, 375, 385, 387, 381, 460, 461, 462, 463, 465, 468, 478, 480, 483,
        464, 466, 471, 481, 482, 510, 512, 515, 517, 516, 562, 580, 621, 625, 646, 701, 569, 614, 619, 670, 677, 785,
        785, 786, 787, 788, 789, 790, 792, 791, 815, 804, 845, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847,
        848, 849, 850, 851, 852,
      ],
      anomalies: [
        {
          id: 22,
          amount: 5883.17,
          description: '',
          category: 'Journal Entry',
          accountId: 'c5601bf4_@_2',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-06-30',
          date: '2025-06-30T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15308',
          num: 'Strip sale P6.25',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 211,
          amount: 2542.8,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15530',
          num: 'MJ1883ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 211,
          amount: 2542.8,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15530',
          num: 'MJ1883ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 212,
          amount: 86,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15561',
          num: 'MJ1888ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 213,
          amount: 80,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-26',
          date: '2025-07-26T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15572',
          num: 'MJ1890ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 214,
          amount: 52,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-27',
          date: '2025-07-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15573',
          num: 'MJ1934ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 215,
          amount: 29.48,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15310',
          num: 'MJ1867ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 216,
          amount: 1140.57,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15312',
          num: 'MJ1871ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 217,
          amount: 1217.6,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 1,
          txnDate: '2025-07-19',
          date: '2025-07-19T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15353',
          num: 'MJ1873ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 218,
          amount: 214,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14888',
          num: 'MJ1832ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 219,
          amount: 388,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-08',
          date: '2025-07-08T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14905',
          num: 'MJ1834ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 220,
          amount: 387,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15026',
          num: 'MJ1851ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 221,
          amount: 79.04,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-12',
          date: '2025-07-12T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15209',
          num: 'MJ1855ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 222,
          amount: 2291,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-13',
          date: '2025-07-13T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15208',
          num: 'MJ1858ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 224,
          amount: 1460.88,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14711',
          num: 'MJ1795ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 225,
          amount: 1247,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-03',
          date: '2025-07-03T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14712',
          num: 'MJ1797ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 226,
          amount: 20,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-05',
          date: '2025-07-05T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14715',
          num: 'MJ1801ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 227,
          amount: 258,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-06',
          date: '2025-07-06T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14716',
          num: 'MJ1803ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 223,
          amount: 1084,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14710',
          num: 'MJ1788ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 228,
          amount: 30,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 4,
          txnDate: '2025-06-27',
          date: '2025-06-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14684',
          num: 'MJ1771ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 229,
          amount: 65,
          description: '',
          category: 'Journal Entry',
          accountId: 'cbede411_@_2',
          name: '',
          vendorId: 0,
          period: 4,
          txnDate: '2025-06-28',
          date: '2025-06-28T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14686',
          num: 'MJ1774ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 472,
          amount: 178.64,
          description: 'Vendor: Allied Beverage Group LLC',
          category: 'Journal Entry',
          accountId: '6eb26171_@_9',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-06-30',
          date: '2025-06-30T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14820',
          num: 'MI1826ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 473,
          amount: -237,
          description: '',
          category: 'Deposit',
          accountId: '6eb26171_@_9',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15279',
          num: '650411',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 474,
          amount: -69,
          description: '',
          category: 'Deposit',
          accountId: '6eb26171_@_9',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15279',
          num: '773964',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 475,
          amount: -48,
          description: '',
          category: 'Deposit',
          accountId: '6eb26171_@_9',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15279',
          num: '752749',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 476,
          amount: -36,
          description: '',
          category: 'Deposit',
          accountId: '6eb26171_@_9',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15279',
          num: '644657',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 477,
          amount: -12,
          description: '',
          category: 'Deposit',
          accountId: '6eb26171_@_9',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15279',
          num: '641925',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 479,
          amount: 1184.38,
          description: 'Vendor: Federal Wine & Spirits Co.',
          category: 'Journal Entry',
          accountId: '6eb26171_@_9',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-03',
          date: '2025-07-03T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14822',
          num: 'MI1819ME',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 703,
          amount: 2244.1,
          description: 'Management',
          category: 'Journal Entry',
          accountId: '529343c4_@_14',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-27',
          date: '2025-07-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15635',
          num: 'Payroll Accrual 07.27',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 704,
          amount: 6486.95,
          description: 'Management',
          category: 'Journal Entry',
          accountId: '529343c4_@_14',
          name: '',
          vendorId: 0,
          period: 1,
          txnDate: '2025-07-20',
          date: '2025-07-20T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15355',
          num: 'Payroll Accrual 07.20',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 705,
          amount: 2244.1,
          description: 'Management',
          category: 'Journal Entry',
          accountId: '529343c4_@_14',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-13',
          date: '2025-07-13T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15628',
          num: 'PR 07.07. to 07.13',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 706,
          amount: 3455,
          description: 'Management',
          category: 'Journal Entry',
          accountId: '529343c4_@_14',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-06',
          date: '2025-07-06T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15268',
          num: 'PR 06.30 to 07.06',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 707,
          amount: 1620,
          description: 'Management',
          category: 'Journal Entry',
          accountId: '529343c4_@_14',
          name: '',
          vendorId: 0,
          period: 4,
          txnDate: '2025-06-29',
          date: '2025-06-29T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15265',
          num: 'PR 06.23 to 06.29',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 708,
          amount: 1711.54,
          description: 'BOH',
          category: 'Journal Entry',
          accountId: '3c61733f_@_14',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-27',
          date: '2025-07-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15635',
          num: 'Payroll Accrual 07.27',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 709,
          amount: 5121.55,
          description: 'BOH',
          category: 'Journal Entry',
          accountId: '3c61733f_@_14',
          name: '',
          vendorId: 0,
          period: 1,
          txnDate: '2025-07-20',
          date: '2025-07-20T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15355',
          num: 'Payroll Accrual 07.20',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 710,
          amount: 1711.54,
          description: 'BOH',
          category: 'Journal Entry',
          accountId: '3c61733f_@_14',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-13',
          date: '2025-07-13T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15628',
          num: 'PR 07.07. to 07.13',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 711,
          amount: 1711.54,
          description: 'BOH',
          category: 'Journal Entry',
          accountId: '3c61733f_@_14',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-06',
          date: '2025-07-06T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15268',
          num: 'PR 06.30 to 07.06',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 712,
          amount: 1711.54,
          description: 'BOH',
          category: 'Journal Entry',
          accountId: '3c61733f_@_14',
          name: '',
          vendorId: 0,
          period: 4,
          txnDate: '2025-06-29',
          date: '2025-06-29T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15265',
          num: 'PR 06.23 to 06.29',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 716,
          amount: 480.77,
          description: 'PR Tax',
          category: 'Journal Entry',
          accountId: 'bbc14e9c_@_14',
          name: '',
          vendorId: 0,
          period: 0,
          txnDate: '2025-07-27',
          date: '2025-07-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15635',
          num: 'Payroll Accrual 07.27',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 717,
          amount: 2993.1,
          description: 'PR Tax',
          category: 'Journal Entry',
          accountId: 'bbc14e9c_@_14',
          name: '',
          vendorId: 0,
          period: 1,
          txnDate: '2025-07-20',
          date: '2025-07-20T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15355',
          num: 'Payroll Accrual 07.20',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 718,
          amount: 480.77,
          description: 'PR Tax',
          category: 'Journal Entry',
          accountId: 'bbc14e9c_@_14',
          name: '',
          vendorId: 0,
          period: 2,
          txnDate: '2025-07-13',
          date: '2025-07-13T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15628',
          num: 'PR 07.07. to 07.13',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 719,
          amount: 475,
          description: 'PR Tax',
          category: 'Journal Entry',
          accountId: 'bbc14e9c_@_14',
          name: '',
          vendorId: 0,
          period: 3,
          txnDate: '2025-07-06',
          date: '2025-07-06T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15268',
          num: 'PR 06.30 to 07.06',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 720,
          amount: 238.76,
          description: 'PR Tax',
          category: 'Journal Entry',
          accountId: 'bbc14e9c_@_14',
          name: '',
          vendorId: 0,
          period: 4,
          txnDate: '2025-06-29',
          date: '2025-06-29T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15265',
          num: 'PR 06.23 to 06.29',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 304,
          amount: 210.91,
          description: 'VISA DDA PUR AP - 443565     RESTAURANT DEPOT            SECAUCUS      * NJ',
          category: 'Expense',
          accountId: '7a94d93b_@_9',
          name: 'Restaurant Depot',
          vendorId: 1,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15227',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 374,
          amount: 979.61,
          description: 'BALDOR SPECIALTY BALDOR SPE',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 2,
          txnDate: '2025-07-08',
          date: '2025-07-08T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14836',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 352,
          amount: 674.46,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-21',
          date: '2025-07-21T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15525',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 352,
          amount: 674.46,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-21',
          date: '2025-07-21T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15525',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 353,
          amount: 35.75,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-21',
          date: '2025-07-21T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15526',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 354,
          amount: 576.26,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-21',
          date: '2025-07-21T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15527',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 355,
          amount: 433.25,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-21',
          date: '2025-07-21T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15568',
          num: 'IV101-0027056103',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 356,
          amount: 180.25,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-22',
          date: '2025-07-22T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15548',
          num: 'IV101-0027063549',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 358,
          amount: 986.9,
          description: 'BALDOR SPECIALTY BALDOR SPE',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15615',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 359,
          amount: 187.5,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15567',
          num: 'IV101-0027082856',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 362,
          amount: 487.94,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15440',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 363,
          amount: 26.75,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15442',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 364,
          amount: 438.75,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-15',
          date: '2025-07-15T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15444',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 365,
          amount: 81.58,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-15',
          date: '2025-07-15T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15446',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 366,
          amount: 16.5,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-15',
          date: '2025-07-15T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15447',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 367,
          amount: 16.5,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-15',
          date: '2025-07-15T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15538',
          num: 'IV101-0027025164',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 368,
          amount: 200.25,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-15',
          date: '2025-07-15T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15540',
          num: 'IV101-0027025179',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 369,
          amount: 286.21,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15448',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 370,
          amount: 936.51,
          description: 'BALDOR SPECIALTY BALDOR SPE',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15449',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 372,
          amount: 138.5,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15536',
          num: 'IV101-0027029234',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 374,
          amount: 979.61,
          description: 'BALDOR SPECIALTY BALDOR SPE',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 2,
          txnDate: '2025-07-08',
          date: '2025-07-08T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14836',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 376,
          amount: 237.5,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14896',
          num: 'IV101-0026997147',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 377,
          amount: 169.75,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15027',
          num: 'IV101-0026997137',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 379,
          amount: 26.75,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 2,
          txnDate: '2025-07-12',
          date: '2025-07-12T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15535',
          num: 'IV101-0027013901',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 380,
          amount: 488.5,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 2,
          txnDate: '2025-07-12',
          date: '2025-07-12T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15570',
          num: 'IV101-0027013935',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 384,
          amount: 694.09,
          description: 'VISA DDA PUR AP - 400077     BALDOR SPECIALTY FOODS      BALDORFOOD CO * NY',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14837',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 382,
          amount: 1115.12,
          description: 'BALDOR SPECIALTY BALDOR SPE',
          category: 'Expense',
          accountId: '593c4b13_@_9',
          name: 'Baldor Specialty Foods Inc.',
          vendorId: 3,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14835',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 319,
          amount: 1591.81,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15541',
          num: '9262981',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 320,
          amount: 1555.39,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15564',
          num: '9265169',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 322,
          amount: 797.83,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15207',
          num: '9255396',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 324,
          amount: 1822.14,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15537',
          num: '9257563',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 325,
          amount: 1279.94,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15566',
          num: '9259520',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 326,
          amount: 1139.64,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14720',
          num: '9249995',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 328,
          amount: 1703.27,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14903',
          num: '9253029',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 329,
          amount: 88.76,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-11',
          date: '2025-07-11T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14897',
          num: '9253030',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 330,
          amount: 1435.21,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14714',
          num: '9247031',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 332,
          amount: 1585.2,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 3,
          txnDate: '2025-07-04',
          date: '2025-07-04T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14724',
          num: '9249000',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 333,
          amount: 1083.72,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-23',
          date: '2025-06-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14561',
          num: '9239104',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 334,
          amount: 1700.37,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-25',
          date: '2025-06-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14685',
          num: '9240751',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 335,
          amount: 742.18,
          description: '',
          category: 'Bill',
          accountId: '3f46fcce_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-27',
          date: '2025-06-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14703',
          num: '9243481',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 337,
          amount: 181.2,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15541',
          num: '9262981',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 338,
          amount: 113.12,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15564',
          num: '9265169',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 340,
          amount: 113.07,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15207',
          num: '9255396',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 342,
          amount: 113.18,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15537',
          num: '9257563',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 343,
          amount: 237.99,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15566',
          num: '9259520',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 344,
          amount: 106.47,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14720',
          num: '9249995',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 346,
          amount: 173.83,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14903',
          num: '9253029',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 348,
          amount: 173.84,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14714',
          num: '9247031',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 349,
          amount: 173.89,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 3,
          txnDate: '2025-07-04',
          date: '2025-07-04T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14724',
          num: '9249000',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 350,
          amount: 174.66,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-25',
          date: '2025-06-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14685',
          num: '9240751',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 351,
          amount: 351.7,
          description: '',
          category: 'Bill',
          accountId: '2bdeb0ad_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-27',
          date: '2025-06-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14703',
          num: '9243481',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 416,
          amount: 973.13,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14714',
          num: '9247031',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 391,
          amount: 1225.26,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15541',
          num: '9262981',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 391,
          amount: 1225.26,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15541',
          num: '9262981',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 392,
          amount: 1141.98,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15564',
          num: '9265169',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 397,
          amount: 575.78,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15207',
          num: '9255396',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 398,
          amount: 6401.55,
          description: 'CHECK 6502279',
          category: 'Check',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-15',
          date: '2025-07-15T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15456',
          num: '6502279',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 400,
          amount: 581.93,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15537',
          num: '9257563',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 403,
          amount: 3560.65,
          description: 'CHECK 6502334',
          category: 'Check',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15516',
          num: '6502334',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 404,
          amount: 666.06,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15566',
          num: '9259520',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 405,
          amount: 506.56,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14720',
          num: '9249995',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 408,
          amount: 3633.57,
          description: 'CHECK 6502206',
          category: 'Check',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15347',
          num: '6502206',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 409,
          amount: 5884.26,
          description: 'CHECK 6502219',
          category: 'Check',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-09',
          date: '2025-07-09T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15388',
          num: '6502219',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 412,
          amount: 1381.53,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14903',
          num: '9253029',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 414,
          amount: 103.21,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 2,
          txnDate: '2025-07-11',
          date: '2025-07-11T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14897',
          num: '9253030',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 416,
          amount: 973.13,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14714',
          num: '9247031',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 419,
          amount: 1077.64,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 3,
          txnDate: '2025-07-04',
          date: '2025-07-04T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14724',
          num: '9249000',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 421,
          amount: 639.73,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-23',
          date: '2025-06-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14561',
          num: '9239104',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 423,
          amount: 481.65,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-25',
          date: '2025-06-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14685',
          num: '9240751',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 424,
          amount: 5204.19,
          description: 'CHECK 6502089',
          category: 'Check',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-25',
          date: '2025-06-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14860',
          num: '6502089',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 425,
          amount: 659.19,
          description: '',
          category: 'Bill',
          accountId: 'e0037727_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 4,
          txnDate: '2025-06-27',
          date: '2025-06-27T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14703',
          num: '9243481',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 542,
          amount: 129.66,
          description: '',
          category: 'Bill',
          accountId: '027a424d_@_9',
          name: 'Performance Food Service',
          vendorId: 4,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15541',
          num: '9262981',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 357,
          amount: 150.68,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15544',
          num: '712755',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 357,
          amount: 150.68,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15544',
          num: '712755',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 360,
          amount: 451.8,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 0,
          txnDate: '2025-07-26',
          date: '2025-07-26T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15543',
          num: '713076',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 373,
          amount: 588.95,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14721',
          num: '711317',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 375,
          amount: 461.8,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 2,
          txnDate: '2025-07-09',
          date: '2025-07-09T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15542',
          num: '711503',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 385,
          amount: 488.45,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 3,
          txnDate: '2025-07-03',
          date: '2025-07-03T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14722',
          num: '711119',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 387,
          amount: 599.75,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 3,
          txnDate: '2025-07-05',
          date: '2025-07-05T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14723',
          num: '711235',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 381,
          amount: 914.6,
          description: '',
          category: 'Bill',
          accountId: '593c4b13_@_9',
          name: 'Avanti Enterprises,INC.',
          vendorId: 5,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14821',
          num: '710926',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 460,
          amount: 1216.77,
          description: '',
          category: 'Bill',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 0,
          txnDate: '2025-07-22',
          date: '2025-07-22T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15565',
          num: '862670',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 461,
          amount: 68.38,
          description: '',
          category: 'Bill',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15569',
          num: '866618',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 462,
          amount: 1483.07,
          description: 'CHECK 6502348',
          category: 'Check',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15653',
          num: '6502348',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 463,
          amount: 1992.45,
          description: '',
          category: 'Bill',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 0,
          txnDate: '2025-07-24',
          date: '2025-07-24T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15571',
          num: '870345',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 465,
          amount: -215,
          description: '653030 Dt.06.19.2025',
          category: 'Deposit',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15469',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 468,
          amount: 1325.12,
          description: '',
          category: 'Bill',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14900',
          num: '837929',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 478,
          amount: 178.64,
          description: 'CHECK 6502148',
          category: 'Check',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15287',
          num: '6502148',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 480,
          amount: 2309.95,
          description: '',
          category: 'Bill',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 3,
          txnDate: '2025-07-03',
          date: '2025-07-03T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14823',
          num: '824312',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 483,
          amount: 1208.19,
          description: 'CHECK 6502094',
          category: 'Check',
          accountId: '6eb26171_@_9',
          name: 'Allied Beverages',
          vendorId: 7,
          period: 4,
          txnDate: '2025-06-26',
          date: '2025-06-26T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14880',
          num: '6502094',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 464,
          amount: 934.48,
          description: 'FEDWAY ASSOCIATE FEDWAY ASS',
          category: 'Expense',
          accountId: '6eb26171_@_9',
          name: 'Fedway',
          vendorId: 13,
          period: 0,
          txnDate: '2025-07-24',
          date: '2025-07-24T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15620',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 466,
          amount: 1000,
          description: 'POD CHECK',
          category: 'Check',
          accountId: '6eb26171_@_9',
          name: 'Fedway',
          vendorId: 13,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15512',
          num: '6502221',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 471,
          amount: 1000,
          description: 'CHECK 6502220',
          category: 'Check',
          accountId: '6eb26171_@_9',
          name: 'Fedway',
          vendorId: 13,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15406',
          num: '6502220',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 481,
          amount: 1000,
          description: 'POD CHECK #110620',
          category: 'Check',
          accountId: '6eb26171_@_9',
          name: 'Fedway',
          vendorId: 13,
          period: 3,
          txnDate: '2025-07-03',
          date: '2025-07-03T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15333',
          num: '6502200',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 482,
          amount: 1000,
          description: 'CHECK 6502093',
          category: 'Check',
          accountId: '6eb26171_@_9',
          name: 'Fedway',
          vendorId: 13,
          period: 4,
          txnDate: '2025-06-25',
          date: '2025-06-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14859',
          num: '6502093',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 510,
          amount: 810,
          description: '',
          category: 'Bill',
          accountId: 'b29ce542_@_9',
          name: 'Gallo Wine Sales',
          vendorId: 19,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15550',
          num: '723293',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 512,
          amount: 525.2,
          description: '',
          category: 'Bill',
          accountId: 'b29ce542_@_9',
          name: 'Gallo Wine Sales',
          vendorId: 19,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15551',
          num: '714240',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 515,
          amount: 810,
          description: '',
          category: 'Bill',
          accountId: 'b29ce542_@_9',
          name: 'Gallo Wine Sales',
          vendorId: 19,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15206',
          num: '710320',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 517,
          amount: 462,
          description: '',
          category: 'Bill',
          accountId: 'b29ce542_@_9',
          name: 'Gallo Wine Sales',
          vendorId: 19,
          period: 3,
          txnDate: '2025-07-03',
          date: '2025-07-03T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14717',
          num: '707058',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 516,
          amount: 720.12,
          description: 'CHECK 6502116 703442',
          category: 'Check',
          accountId: 'b29ce542_@_9',
          name: 'Gallo Wine Sales',
          vendorId: 19,
          period: 3,
          txnDate: '2025-07-01',
          date: '2025-07-01T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15277',
          num: '6502116',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 562,
          amount: 588.1,
          description: 'CHECK 6502349 Payroll W.E. 07.13.2025',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Omar Lopez',
          vendorId: 31,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15654',
          num: '6502349',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 580,
          amount: 508.73,
          description: 'CHECK 6502281 W.E. 07.06.2025',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Omar Lopez',
          vendorId: 31,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15463',
          num: '6502281',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 621,
          amount: 590.89,
          description: 'CHECK 6502152 Brandons Donuts',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Omar Lopez',
          vendorId: 31,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15358',
          num: '6502152',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 625,
          amount: 300,
          description: 'CHECK 6502153',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Omar Lopez',
          vendorId: 31,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15362',
          num: '6502153',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 646,
          amount: 369.33,
          description: 'CHECK 6502218 Brandons Donuts',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Omar Lopez',
          vendorId: 31,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15396',
          num: '6502218',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 701,
          amount: 559.15,
          description: 'CHECK 6502091',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Omar Lopez',
          vendorId: 31,
          period: 4,
          txnDate: '2025-06-25',
          date: '2025-06-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14858',
          num: '6502091',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 569,
          amount: 370,
          description: 'CHECK 6502278',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Ivonne Olarte',
          vendorId: 35,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15433',
          num: '6502278',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 614,
          amount: 932.87,
          description: 'CHECK 6502311 W.E. 07.06.2025',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Ivonne Olarte',
          vendorId: 35,
          period: 1,
          txnDate: '2025-07-18',
          date: '2025-07-18T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15511',
          num: '6502311',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 619,
          amount: 1054.65,
          description: 'CHECK 6502160 W.E. 6.22.25',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Ivonne Olarte',
          vendorId: 35,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15351',
          num: '6502160',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 670,
          amount: 761.38,
          description: 'CHECK 6502251 W.E. 06.29.2025',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Ivonne Olarte',
          vendorId: 35,
          period: 2,
          txnDate: '2025-07-11',
          date: '2025-07-11T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15423',
          num: '6502251',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 677,
          amount: 356.2,
          description: 'CHECK 6502137',
          category: 'Check',
          accountId: '687f4cd2_@_14',
          name: 'Ivonne Olarte',
          vendorId: 35,
          period: 3,
          txnDate: '2025-06-30',
          date: '2025-06-30T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14884',
          num: '6502137',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 785,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 0,
          txnDate: '2025-07-22',
          date: '2025-07-22T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15609',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 785,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 0,
          txnDate: '2025-07-22',
          date: '2025-07-22T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15609',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 786,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15610',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 787,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15611',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 788,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14767',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 789,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14768',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 790,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14769',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 792,
          amount: 30,
          description: 'WIRE TRANSFER FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14766',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 791,
          amount: 20,
          description: 'MAINTENANCE FEE',
          category: 'Expense',
          accountId: 'c3c23383_@_18',
          name: 'Bank Charges',
          vendorId: 100,
          period: 3,
          txnDate: '2025-06-30',
          date: '2025-06-30T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15203',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 815,
          amount: 19.18,
          description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
          category: 'Expense',
          accountId: '058d9b25_@_18',
          name: 'Amazon',
          vendorId: 101,
          period: 2,
          txnDate: '2025-07-07',
          date: '2025-07-07T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14730',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 804,
          amount: 122.46,
          description: 'VISA DDA PUR AP - 469216     AMAZON MKTPL NI05T1NS0      AMZN COM BILL * WA',
          category: 'Expense',
          accountId: '058d9b25_@_18',
          name: 'Amazon',
          vendorId: 101,
          period: 1,
          txnDate: '2025-07-14',
          date: '2025-07-14T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15225',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 845,
          amount: 74.9,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15243',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 837,
          amount: 60.9,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15606',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 838,
          amount: 81.87,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 0,
          txnDate: '2025-07-23',
          date: '2025-07-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15607',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 839,
          amount: 52.21,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 0,
          txnDate: '2025-07-24',
          date: '2025-07-24T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15603',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 840,
          amount: 54.38,
          description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 0,
          txnDate: '2025-07-24',
          date: '2025-07-24T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15605',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 841,
          amount: 50.67,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15604',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 842,
          amount: 55.09,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 0,
          txnDate: '2025-07-25',
          date: '2025-07-25T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15608',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 843,
          amount: 50.7,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15219',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 844,
          amount: 55.25,
          description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 1,
          txnDate: '2025-07-16',
          date: '2025-07-16T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15264',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 845,
          amount: 74.9,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15243',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 846,
          amount: 54.38,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 2,
          txnDate: '2025-07-10',
          date: '2025-07-10T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15246',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 847,
          amount: 56.72,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 2,
          txnDate: '2025-07-11',
          date: '2025-07-11T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15239',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 848,
          amount: 49.02,
          description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 2,
          txnDate: '2025-07-11',
          date: '2025-07-11T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '15263',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 849,
          amount: 79.12,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 3,
          txnDate: '2025-07-02',
          date: '2025-07-02T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14764',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 850,
          amount: 68.96,
          description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 4,
          txnDate: '2025-06-23',
          date: '2025-06-23T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14581',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 851,
          amount: 50.66,
          description: 'DDA PURCHASE AP - 52702100   UBER TECHNOLOGIES  INC      WILMINGTON    * DE',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 4,
          txnDate: '2025-06-26',
          date: '2025-06-26T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14765',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
        {
          id: 852,
          amount: 56.87,
          description: 'DDA PURCHASE AP - 05658446   UBR  PENDING UBER COM       SAN FRANCISCO * CA',
          category: 'Expense',
          accountId: 'e4e1ab18_@_18',
          name: 'Uber Trips',
          vendorId: 108,
          period: 4,
          txnDate: '2025-06-26',
          date: '2025-06-26T00:00:00.000Z',
          dueDate: '',
          pastDue: 0,
          eventId: '14841',
          num: '',
          notes: '',
          audit: {
            status: 'Normal',
            amount: 0,
            reason: '',
          },
        },
      ],
      flaggedTransactions: [],
      flaggedIds: [],
      periodicityPatterns: {
        '0-1': {
          periodicity: 'daily',
          confidence: 0.9,
          vendorName: '',
          accountName: 'Sales, Food',
        },
        '0-6': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: '',
          accountName: 'Sales, Miscellaneous',
        },
        '1-15': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Restaurant Depot',
          accountName: 'COGS, Food',
        },
        '3-18': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Baldor Specialty Foods Inc.',
          accountName: 'COGS, Produce',
        },
        '4-19': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Performance Food Service',
          accountName: 'COGS, Grocery',
        },
        '4-29': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Performance Food Service',
          accountName: 'COGS, Packaging',
        },
        '5-18': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Avanti Enterprises,INC.',
          accountName: 'COGS, Produce',
        },
        '100-73': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Bank Charges',
          accountName: 'Bank Charges & Fees',
        },
        '101-74': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Amazon',
          accountName: 'Office Supplies & Expenses',
        },
        '108-79': {
          periodicity: 'irregular',
          confidence: 0.9,
          vendorName: 'Uber Trips',
          accountName: 'Travel, Ground Transport & Airfare',
        },
      },
    },
  },
  aiAnalysis: {
    reportId: '',
    timeframe: 'Weekly',
    data: {
      metrics: [
        {
          period: 'W26',
          metrics: {
            totalSales: 66432.15,
            totalCogs: 18443.46,
            totalLabor: 10089.74,
            laborMargin: 15.188037719688435,
            cogsMargin: 27.76285277535049,
            primeCost: 28533.199999999997,
            primeCostMargin: 42.95089049503893,
          },
        },
        {
          period: 'W27',
          metrics: {
            totalSales: 90104.73,
            totalCogs: 22129.269999999997,
            totalLabor: 22880.34,
            laborMargin: 25.39305095304098,
            cogsMargin: 24.559498707781486,
            primeCost: 45009.61,
            primeCostMargin: 49.95254966082247,
          },
        },
        {
          period: 'W28',
          metrics: {
            totalSales: 70026.76999999999,
            totalCogs: 30839.25,
            totalLabor: 42293.969999999994,
            laborMargin: 60.396859658099324,
            cogsMargin: 44.03922956892058,
            primeCost: 73133.22,
            primeCostMargin: 104.43608922701992,
          },
        },
        {
          period: 'W29',
          metrics: {
            totalSales: 68094.2,
            totalCogs: 32352.92,
            totalLabor: 43491.79,
            laborMargin: 63.87003592082733,
            cogsMargin: 47.51200542777505,
            primeCost: 75844.70999999999,
            primeCostMargin: 111.38204134860237,
          },
        },
        {
          period: 'W30',
          metrics: {
            totalSales: 74807.12000000001,
            totalCogs: 24046.680000000004,
            totalLabor: 17059.77,
            laborMargin: 22.80500840026992,
            cogsMargin: 32.14490813173933,
            primeCost: 41106.450000000004,
            primeCostMargin: 54.94991653200925,
          },
        },
      ],
      hierarchicalData: [
        {
          periodId: 'W26',
          periodStart: '2025-06-23',
          periodEnd: '2025-06-29',
          periodType: 'Weekly',
          data: {
            sales: {
              total: 66432.15,
              accounts: {
                sales_food: 36991,
                sales_liquor: 18898,
                sales_beer: 6146,
                sales_wine: 1513,
                sales_non_alcoholic_beverage: 2884,
                sales_miscellaneous: 95,
                sales_service_charges: 1199.15,
                sales_no_category: 0,
              },
            },
            cogs: {
              total: 18443.46,
              accounts: {
                cogs_food: 754.18,
                cogs_meat_poultry: 3526.27,
                cogs_seafood: 526.36,
                cogs_produce: 530.45,
                cogs_grocery: 7899.17,
                cogs_bakery: 1630.48,
                cogs_dairy: 927.54,
                cogs_liquor: 2208.19,
                cogs_bar_groceries: 0,
                cogs_beer: 0,
                cogs_draught_beer: 0,
                cogs_bottled_beer: 0,
                cogs_wine: 0,
                cogs_non_alcoholic: 78.71,
                cogs_packaging: 362.11,
                shipping_freight_and_delivery: 0,
              },
            },
            labor: {
              total: 10089.74,
              accounts: {
                direct_labor: {
                  accounts: {
                    labor_other: 5477.44,
                    labor_management: 1620,
                    labor_boh: 1711.54,
                  },
                  total: 8808.98,
                },
                labor_related_expenses: {
                  accounts: {
                    commission_bonus_incentives: 268,
                    payroll_taxes: 238.76,
                    employee_meals: 774,
                    recruiting: 0,
                  },
                  total: 1280.76,
                },
              },
            },
            operatingExpenses: {
              total: 0,
              accounts: {},
              controllableExpenses: {
                total: 16808.58,
                accounts: {
                  direct_operating_expenses: {
                    accounts: {
                      equipment_lease_rental: 0,
                      cleaning_supplies: 174.1,
                      cleaning_services: 0,
                      restaurant_supplies: 371.63,
                      laundry_linens_uniforms: 1954.31,
                      kitchen_bar_smallwares: 1598.17,
                    },
                    total: 4098.21,
                  },
                  transaction_related_expenses: {
                    accounts: {
                      '3rd_party_commissions': 0,
                    },
                    total: 0,
                  },
                  marketing_advertising: {
                    accounts: {
                      marketing_public_relations: 210.8,
                      advertising_promotions: 370,
                    },
                    total: 580.8,
                  },
                  music_dj: 500,
                  general_administrative_expenses: {
                    accounts: {
                      accounting_bookkeeping: 0,
                      consulting: 1250,
                      legal: 1806.54,
                      payroll_processing_fees: 0,
                      computer_supplies_software_it: 0,
                      dues_and_subscriptions: 0,
                      bank_charges_fees: 0,
                      office_supplies_expenses: 1110.12,
                      phone_and_internet: 334.99,
                      security: 950,
                    },
                    total: 5451.65,
                  },
                  travel_meals_entertainment: {
                    accounts: {
                      travel_ground_transport_airfare: 176.49,
                      meals_entertainment: 89.97,
                      parking: 1238,
                      fuel: 57.11,
                    },
                    total: 1561.57,
                  },
                  repairs_maintenance: {
                    accounts: {
                      repair_maintenance_equipment: 3479,
                      repair_maintenance_facility: 0,
                      pest_control: 1137.35,
                      fire_control: 0,
                    },
                    total: 4616.35,
                  },
                },
              },
              nonControllableExpenses: {
                total: 1879.5900000000001,
                accounts: {
                  property_expenses: {
                    accounts: {
                      rent_lease: 0,
                      utility_electricity: 0,
                      utility_gas: 430.96,
                    },
                    total: 430.96,
                  },
                  other_income_and_expenses: {
                    accounts: {
                      other_income_expenses: 0,
                      to_be_classified_p_l: 1448.63,
                    },
                    total: 1448.63,
                  },
                },
              },
            },
          },
        },
        {
          periodId: 'W27',
          periodStart: '2025-06-30',
          periodEnd: '2025-07-06',
          periodType: 'Weekly',
          data: {
            sales: {
              total: 90104.73,
              accounts: {
                sales_food: 49465.17,
                sales_liquor: 26219.51,
                sales_beer: 6528,
                sales_wine: 1628,
                sales_non_alcoholic_beverage: 2902,
                sales_miscellaneous: 4069.88,
                sales_service_charges: 1346.05,
                sales_no_category: 0,
              },
            },
            cogs: {
              total: 22129.269999999997,
              accounts: {
                cogs_food: 592.08,
                cogs_meat_poultry: 3461.52,
                cogs_seafood: 347.73,
                cogs_produce: 4556.91,
                cogs_grocery: 2309.13,
                cogs_bakery: 658.78,
                cogs_dairy: 1091.88,
                cogs_liquor: 4449.61,
                cogs_bar_groceries: 61.53,
                cogs_beer: 0,
                cogs_draught_beer: 0,
                cogs_bottled_beer: 232,
                cogs_wine: 2138.98,
                cogs_non_alcoholic: 2040.39,
                cogs_packaging: 188.73,
                shipping_freight_and_delivery: 0,
              },
            },
            labor: {
              total: 22880.34,
              accounts: {
                direct_labor: {
                  accounts: {
                    labor_other: 17238.8,
                    labor_management: 3455,
                    labor_boh: 1711.54,
                  },
                  total: 22405.34,
                },
                labor_related_expenses: {
                  accounts: {
                    commission_bonus_incentives: 0,
                    payroll_taxes: 475,
                    employee_meals: 0,
                    recruiting: 0,
                  },
                  total: 475,
                },
              },
            },
            operatingExpenses: {
              total: 0,
              accounts: {},
              controllableExpenses: {
                total: 8775.650000000001,
                accounts: {
                  direct_operating_expenses: {
                    accounts: {
                      equipment_lease_rental: 0,
                      cleaning_supplies: 66.69,
                      cleaning_services: 0,
                      restaurant_supplies: 464.64,
                      laundry_linens_uniforms: 1141.57,
                      kitchen_bar_smallwares: 0,
                    },
                    total: 1672.8999999999999,
                  },
                  transaction_related_expenses: {
                    accounts: {
                      '3rd_party_commissions': 0,
                    },
                    total: 0,
                  },
                  marketing_advertising: {
                    accounts: {
                      marketing_public_relations: 0,
                      advertising_promotions: 1227.09,
                    },
                    total: 1227.09,
                  },
                  music_dj: 0,
                  general_administrative_expenses: {
                    accounts: {
                      accounting_bookkeeping: 1499,
                      consulting: 0,
                      legal: 2500,
                      payroll_processing_fees: 80,
                      computer_supplies_software_it: 0,
                      dues_and_subscriptions: 114.36,
                      bank_charges_fees: 50,
                      office_supplies_expenses: 900.05,
                      phone_and_internet: 0,
                      security: 0,
                    },
                    total: 5143.41,
                  },
                  travel_meals_entertainment: {
                    accounts: {
                      travel_ground_transport_airfare: 79.12,
                      meals_entertainment: 92.67,
                      parking: 0,
                      fuel: 35,
                    },
                    total: 206.79000000000002,
                  },
                  repairs_maintenance: {
                    accounts: {
                      repair_maintenance_equipment: 0,
                      repair_maintenance_facility: 0,
                      pest_control: 525.46,
                      fire_control: 0,
                    },
                    total: 525.46,
                  },
                },
              },
              nonControllableExpenses: {
                total: 0,
                accounts: {
                  property_expenses: {
                    accounts: {
                      rent_lease: 0,
                      utility_electricity: 0,
                      utility_gas: 0,
                    },
                    total: 0,
                  },
                  other_income_and_expenses: {
                    accounts: {
                      other_income_expenses: 0,
                      to_be_classified_p_l: 0,
                    },
                    total: 0,
                  },
                },
              },
            },
          },
        },
        {
          periodId: 'W28',
          periodStart: '2025-07-07',
          periodEnd: '2025-07-13',
          periodType: 'Weekly',
          data: {
            sales: {
              total: 70026.76999999999,
              accounts: {
                sales_food: 39645,
                sales_liquor: 18588.01,
                sales_beer: 4710,
                sales_wine: 1252,
                sales_non_alcoholic_beverage: 2328,
                sales_miscellaneous: 3359.04,
                sales_service_charges: 1353.22,
                sales_no_category: 0,
              },
            },
            cogs: {
              total: 30839.25,
              accounts: {
                cogs_food: 2621.67,
                cogs_meat_poultry: 3127.43,
                cogs_seafood: 348.57,
                cogs_produce: 4014.31,
                cogs_grocery: 11950.63,
                cogs_bakery: 769.45,
                cogs_dairy: 963.42,
                cogs_liquor: 3807.32,
                cogs_bar_groceries: 70.16,
                cogs_beer: 435.87,
                cogs_draught_beer: 295.5,
                cogs_bottled_beer: 416,
                cogs_wine: 1209.4,
                cogs_non_alcoholic: 661.57,
                cogs_packaging: 147.95,
                shipping_freight_and_delivery: 0,
              },
            },
            labor: {
              total: 42293.969999999994,
              accounts: {
                direct_labor: {
                  accounts: {
                    labor_other: 37586.56,
                    labor_management: 2244.1,
                    labor_boh: 1711.54,
                  },
                  total: 41542.2,
                },
                labor_related_expenses: {
                  accounts: {
                    commission_bonus_incentives: 271,
                    payroll_taxes: 480.77,
                    employee_meals: 0,
                    recruiting: 0,
                  },
                  total: 751.77,
                },
              },
            },
            operatingExpenses: {
              total: 0,
              accounts: {},
              controllableExpenses: {
                total: 9215.160000000002,
                accounts: {
                  direct_operating_expenses: {
                    accounts: {
                      equipment_lease_rental: 155,
                      cleaning_supplies: 122.74,
                      cleaning_services: 1044.92,
                      restaurant_supplies: 411.98,
                      laundry_linens_uniforms: 0,
                      kitchen_bar_smallwares: 0,
                    },
                    total: 1734.64,
                  },
                  transaction_related_expenses: {
                    accounts: {
                      '3rd_party_commissions': 0,
                    },
                    total: 0,
                  },
                  marketing_advertising: {
                    accounts: {
                      marketing_public_relations: 1700,
                      advertising_promotions: 0,
                    },
                    total: 1700,
                  },
                  music_dj: 0,
                  general_administrative_expenses: {
                    accounts: {
                      accounting_bookkeeping: 0,
                      consulting: 0,
                      legal: 1681,
                      payroll_processing_fees: 0,
                      computer_supplies_software_it: 110,
                      dues_and_subscriptions: 0,
                      bank_charges_fees: 90,
                      office_supplies_expenses: 19.18,
                      phone_and_internet: 0,
                      security: 0,
                    },
                    total: 1900.18,
                  },
                  travel_meals_entertainment: {
                    accounts: {
                      travel_ground_transport_airfare: 235.02,
                      meals_entertainment: 0,
                      parking: 0,
                      fuel: 0,
                    },
                    total: 235.02,
                  },
                  repairs_maintenance: {
                    accounts: {
                      repair_maintenance_equipment: 0,
                      repair_maintenance_facility: 3645.32,
                      pest_control: 0,
                      fire_control: 0,
                    },
                    total: 3645.32,
                  },
                },
              },
              nonControllableExpenses: {
                total: -1.01,
                accounts: {
                  property_expenses: {
                    accounts: {
                      rent_lease: 0,
                      utility_electricity: 0,
                      utility_gas: 0,
                    },
                    total: 0,
                  },
                  other_income_and_expenses: {
                    accounts: {
                      other_income_expenses: -1.01,
                      to_be_classified_p_l: 0,
                    },
                    total: -1.01,
                  },
                },
              },
            },
          },
        },
        {
          periodId: 'W29',
          periodStart: '2025-07-14',
          periodEnd: '2025-07-20',
          periodType: 'Weekly',
          data: {
            sales: {
              total: 68094.2,
              accounts: {
                sales_food: 37673.51,
                sales_liquor: 18733.5,
                sales_beer: 5015,
                sales_wine: 1636,
                sales_non_alcoholic_beverage: 2370,
                sales_miscellaneous: 2387.65,
                sales_service_charges: 1260.84,
                sales_no_category: 0,
              },
            },
            cogs: {
              total: 32352.92,
              accounts: {
                cogs_food: 1092.35,
                cogs_meat_poultry: 3997.89,
                cogs_seafood: 487.73,
                cogs_produce: 3361.74,
                cogs_grocery: 12455.23,
                cogs_bakery: 715.21,
                cogs_dairy: 1228.65,
                cogs_liquor: 1597.33,
                cogs_bar_groceries: 90.52,
                cogs_beer: 0,
                cogs_draught_beer: 3631.5,
                cogs_bottled_beer: 522,
                cogs_wine: 1032.5,
                cogs_non_alcoholic: 1730.15,
                cogs_packaging: 410.12,
                shipping_freight_and_delivery: 0,
              },
            },
            labor: {
              total: 43491.79,
              accounts: {
                direct_labor: {
                  accounts: {
                    labor_other: 28890.19,
                    labor_management: 6486.95,
                    labor_boh: 5121.55,
                  },
                  total: 40498.69,
                },
                labor_related_expenses: {
                  accounts: {
                    commission_bonus_incentives: 0,
                    payroll_taxes: 2993.1,
                    employee_meals: 0,
                    recruiting: 0,
                  },
                  total: 2993.1,
                },
              },
            },
            operatingExpenses: {
              total: 0,
              accounts: {},
              controllableExpenses: {
                total: 10243.130000000001,
                accounts: {
                  direct_operating_expenses: {
                    accounts: {
                      equipment_lease_rental: 0,
                      cleaning_supplies: 131.91,
                      cleaning_services: 0,
                      restaurant_supplies: 376.87,
                      laundry_linens_uniforms: 1058.12,
                      kitchen_bar_smallwares: 0,
                    },
                    total: 1566.8999999999999,
                  },
                  transaction_related_expenses: {
                    accounts: {
                      '3rd_party_commissions': 0,
                    },
                    total: 0,
                  },
                  marketing_advertising: {
                    accounts: {
                      marketing_public_relations: 22.19,
                      advertising_promotions: 289,
                    },
                    total: 311.19,
                  },
                  music_dj: 0,
                  general_administrative_expenses: {
                    accounts: {
                      accounting_bookkeeping: 0,
                      consulting: 0,
                      legal: 0,
                      payroll_processing_fees: 92.53,
                      computer_supplies_software_it: 1440.67,
                      dues_and_subscriptions: 0,
                      bank_charges_fees: 0,
                      office_supplies_expenses: 1286.21,
                      phone_and_internet: 393.24,
                      security: 0,
                    },
                    total: 3212.6499999999996,
                  },
                  travel_meals_entertainment: {
                    accounts: {
                      travel_ground_transport_airfare: 105.95,
                      meals_entertainment: 871.17,
                      parking: 0,
                      fuel: 36.01,
                    },
                    total: 1013.13,
                  },
                  repairs_maintenance: {
                    accounts: {
                      repair_maintenance_equipment: 2441.6,
                      repair_maintenance_facility: 1697.66,
                      pest_control: 0,
                      fire_control: 0,
                    },
                    total: 4139.26,
                  },
                },
              },
              nonControllableExpenses: {
                total: 20878.18,
                accounts: {
                  property_expenses: {
                    accounts: {
                      rent_lease: 18437.33,
                      utility_electricity: 0,
                      utility_gas: 0,
                    },
                    total: 18437.33,
                  },
                  other_income_and_expenses: {
                    accounts: {
                      other_income_expenses: 0,
                      to_be_classified_p_l: 2440.85,
                    },
                    total: 2440.85,
                  },
                },
              },
            },
          },
        },
        {
          periodId: 'W30',
          periodStart: '2025-07-21',
          periodEnd: '2025-07-27',
          periodType: 'Weekly',
          data: {
            sales: {
              total: 74807.12000000001,
              accounts: {
                sales_food: 40123,
                sales_liquor: 22039.5,
                sales_beer: 5225,
                sales_wine: 1861,
                sales_non_alcoholic_beverage: 2599,
                sales_miscellaneous: 2760.8,
                sales_service_charges: 1416.32,
                sales_no_category: 0,
              },
            },
            cogs: {
              total: 24046.680000000004,
              accounts: {
                cogs_food: 2046.02,
                cogs_meat_poultry: 3783.57,
                cogs_seafood: 336.7,
                cogs_produce: 3875.6,
                cogs_grocery: 2697.45,
                cogs_bakery: 44.8,
                cogs_dairy: 1049.11,
                cogs_liquor: 5695.15,
                cogs_bar_groceries: 182.06,
                cogs_beer: 0,
                cogs_draught_beer: 508,
                cogs_bottled_beer: 438.6,
                cogs_wine: 1280.88,
                cogs_non_alcoholic: 1532.25,
                cogs_packaging: 189.45,
                shipping_freight_and_delivery: 387.04,
              },
            },
            labor: {
              total: 17059.77,
              accounts: {
                direct_labor: {
                  accounts: {
                    labor_other: 13892.95,
                    labor_management: 2244.1,
                    labor_boh: 1711.54,
                  },
                  total: 17848.59,
                },
                labor_related_expenses: {
                  accounts: {
                    commission_bonus_incentives: 0,
                    payroll_taxes: -788.82,
                    employee_meals: 0,
                    recruiting: 0,
                  },
                  total: -788.82,
                },
              },
            },
            operatingExpenses: {
              total: 0,
              accounts: {},
              controllableExpenses: {
                total: 9880.05,
                accounts: {
                  direct_operating_expenses: {
                    accounts: {
                      equipment_lease_rental: 0,
                      cleaning_supplies: 184.53,
                      cleaning_services: 0,
                      restaurant_supplies: 529.68,
                      laundry_linens_uniforms: 268.89,
                      kitchen_bar_smallwares: 0,
                    },
                    total: 983.0999999999999,
                  },
                  transaction_related_expenses: {
                    accounts: {
                      '3rd_party_commissions': 0,
                    },
                    total: 0,
                  },
                  marketing_advertising: {
                    accounts: {
                      marketing_public_relations: 0,
                      advertising_promotions: 548,
                    },
                    total: 548,
                  },
                  music_dj: 0,
                  general_administrative_expenses: {
                    accounts: {
                      accounting_bookkeeping: 0,
                      consulting: 0,
                      legal: 1233.49,
                      payroll_processing_fees: 0,
                      computer_supplies_software_it: 0,
                      dues_and_subscriptions: 12.78,
                      bank_charges_fees: 90,
                      office_supplies_expenses: 3521.12,
                      phone_and_internet: 0,
                      security: 0,
                    },
                    total: 4857.389999999999,
                  },
                  travel_meals_entertainment: {
                    accounts: {
                      travel_ground_transport_airfare: 355.12,
                      meals_entertainment: 86.91,
                      parking: 1238,
                      fuel: 34.01,
                    },
                    total: 1714.04,
                  },
                  repairs_maintenance: {
                    accounts: {
                      repair_maintenance_equipment: 0,
                      repair_maintenance_facility: 1777.52,
                      pest_control: 0,
                      fire_control: 0,
                    },
                    total: 1777.52,
                  },
                },
              },
              nonControllableExpenses: {
                total: 1960,
                accounts: {
                  property_expenses: {
                    accounts: {
                      rent_lease: 0,
                      utility_electricity: 0,
                      utility_gas: 0,
                    },
                    total: 0,
                  },
                  other_income_and_expenses: {
                    accounts: {
                      other_income_expenses: 0,
                      to_be_classified_p_l: 1960,
                    },
                    total: 1960,
                  },
                },
              },
            },
          },
        },
      ],
    },
    statistics: {
      sales: {
        currentValue: 74807.12000000001,
        previousValue: 68094.2,
        changeAmount: 6712.920000000013,
        changePercent: 9.858284552869428,
        average: 73892.99399999999,
      },
      cogs: {
        currentValue: 24046.680000000004,
        previousValue: 32352.92,
        changeAmount: -8306.239999999994,
        changePercent: -25.673849531974223,
        average: 25562.316,
      },
      labor: {
        currentValue: 17059.77,
        previousValue: 43491.79,
        changeAmount: -26432.02,
        changePercent: -60.774734725795376,
        average: 27163.121999999996,
      },
      primeCost: {
        currentValue: 41106.450000000004,
        previousValue: 75844.70999999999,
        changeAmount: -34738.25999999999,
        changePercent: -45.801823225377206,
        average: 52725.438,
      },
      margins: {
        laborMargin: {
          currentValue: 22.80500840026992,
          previousValue: 63.87003592082733,
          changeAmount: -41.06502752055741,
          changePercent: -64.29466795894903,
          average: 37.5305985303852,
        },
        cogsMargin: {
          currentValue: 32.14490813173933,
          previousValue: 47.51200542777505,
          changeAmount: -15.367097296035723,
          changePercent: -32.34360906822988,
          average: 35.20369892231339,
        },
        primeCostMargin: {
          currentValue: 54.94991653200925,
          previousValue: 111.38204134860237,
          changeAmount: -56.432124816593124,
          changePercent: -50.66537130521108,
          average: 72.73429745269858,
        },
      },
    },
    significantChanges: [
      {
        period: 'W27',
        changes: [
          {
            metric: 'totalSales',
            change: 35.63422228544463,
            changeType: 'percent',
            from: 66432.15,
            to: 90104.73,
          },
          {
            metric: 'totalCogs',
            change: 19.984373864773737,
            changeType: 'percent',
            from: 18443.46,
            to: 22129.269999999997,
          },
          {
            metric: 'totalLabor',
            change: 126.76838055291813,
            changeType: 'percent',
            from: 10089.74,
            to: 22880.34,
          },
          {
            metric: 'laborMargin',
            change: 10.205013233352545,
            changeType: 'percentage_points',
            from: 15.188037719688435,
            to: 25.39305095304098,
          },
          {
            metric: 'primeCost',
            change: 57.74469740512808,
            changeType: 'percent',
            from: 28533.199999999997,
            to: 45009.61,
          },
          {
            metric: 'primeCostMargin',
            change: 7.001659165783543,
            changeType: 'percentage_points',
            from: 42.95089049503893,
            to: 49.95254966082247,
          },
        ],
      },
      {
        period: 'W28',
        changes: [
          {
            metric: 'totalSales',
            change: -22.282914559535342,
            changeType: 'percent',
            from: 90104.73,
            to: 70026.76999999999,
          },
          {
            metric: 'totalCogs',
            change: 39.359545073109075,
            changeType: 'percent',
            from: 22129.269999999997,
            to: 30839.25,
          },
          {
            metric: 'totalLabor',
            change: 84.84852060764828,
            changeType: 'percent',
            from: 22880.34,
            to: 42293.969999999994,
          },
          {
            metric: 'laborMargin',
            change: 35.00380870505835,
            changeType: 'percentage_points',
            from: 25.39305095304098,
            to: 60.396859658099324,
          },
          {
            metric: 'cogsMargin',
            change: 19.479730861139096,
            changeType: 'percentage_points',
            from: 24.559498707781486,
            to: 44.03922956892058,
          },
          {
            metric: 'primeCost',
            change: 62.4835673981623,
            changeType: 'percent',
            from: 45009.61,
            to: 73133.22,
          },
          {
            metric: 'primeCostMargin',
            change: 54.48353956619745,
            changeType: 'percentage_points',
            from: 49.95254966082247,
            to: 104.43608922701992,
          },
        ],
      },
      {
        period: 'W29',
        changes: [
          {
            metric: 'primeCostMargin',
            change: 6.945952121582451,
            changeType: 'percentage_points',
            from: 104.43608922701992,
            to: 111.38204134860237,
          },
        ],
      },
      {
        period: 'W30',
        changes: [
          {
            metric: 'totalSales',
            change: 9.858284552869428,
            changeType: 'percent',
            from: 68094.2,
            to: 74807.12000000001,
          },
          {
            metric: 'totalCogs',
            change: -25.673849531974223,
            changeType: 'percent',
            from: 32352.92,
            to: 24046.680000000004,
          },
          {
            metric: 'totalLabor',
            change: -60.774734725795376,
            changeType: 'percent',
            from: 43491.79,
            to: 17059.77,
          },
          {
            metric: 'laborMargin',
            change: -41.06502752055741,
            changeType: 'percentage_points',
            from: 63.87003592082733,
            to: 22.80500840026992,
          },
          {
            metric: 'cogsMargin',
            change: -15.367097296035723,
            changeType: 'percentage_points',
            from: 47.51200542777505,
            to: 32.14490813173933,
          },
          {
            metric: 'primeCost',
            change: -45.801823225377206,
            changeType: 'percent',
            from: 75844.70999999999,
            to: 41106.450000000004,
          },
          {
            metric: 'primeCostMargin',
            change: -56.432124816593124,
            changeType: 'percentage_points',
            from: 111.38204134860237,
            to: 54.94991653200925,
          },
        ],
      },
    ],
  },
};
